/*! jQuery Validation Plugin - v1.17.0 - 7/29/2017
 * https://jqueryvalidation.org/
 * Copyright (c) 2017 Jörn Zaefferer; Licensed MIT */
!function(t){"function"==typeof define&&define.amd?define(["jquery"],t):"object"==typeof module&&module.exports?module.exports=t(require("jquery")):t(jQuery)}(function(u){u.extend(u.fn,{validate:function(t){if(this.length){var s=u.data(this[0],"validator");return s||(this.attr("novalidate","novalidate"),s=new u.validator(t,this[0]),u.data(this[0],"validator",s),s.settings.onsubmit&&(this.on("click.validate",":submit",function(t){s.submitButton=t.currentTarget,u(this).hasClass("cancel")&&(s.cancelSubmit=!0),void 0!==u(this).attr("formnovalidate")&&(s.cancelSubmit=!0)}),this.on("submit.validate",function(i){function t(){var t,e;return s.submitButton&&(s.settings.submitHandler||s.formSubmitted)&&(t=u("<input type='hidden'/>").attr("name",s.submitButton.name).val(u(s.submitButton).val()).appendTo(s.currentForm)),!s.settings.submitHandler||(e=s.settings.submitHandler.call(s,s.currentForm,i),t&&t.remove(),void 0!==e&&e)}return s.settings.debug&&i.preventDefault(),s.cancelSubmit?(s.cancelSubmit=!1,t()):s.form()?s.pendingRequest?!(s.formSubmitted=!0):t():(s.focusInvalid(),!1)})),s)}t&&t.debug&&window.console&&console.warn("Nothing selected, can't validate, returning nothing.")},valid:function(){var t,e,i;return u(this[0]).is("form")?t=this.validate().form():(i=[],t=!0,e=u(this[0].form).validate(),this.each(function(){(t=e.element(this)&&t)||(i=i.concat(e.errorList))}),e.errorList=i),t},rules:function(t,e){var i,s,n,r,a,o,l=this[0];if(null!=l&&(!l.form&&l.hasAttribute("contenteditable")&&(l.form=this.closest("form")[0],l.name=this.attr("name")),null!=l.form)){if(t)switch(i=u.data(l.form,"validator").settings,s=i.rules,n=u.validator.staticRules(l),t){case"add":u.extend(n,u.validator.normalizeRule(e)),delete n.messages,s[l.name]=n,e.messages&&(i.messages[l.name]=u.extend(i.messages[l.name],e.messages));break;case"remove":return e?(o={},u.each(e.split(/\s/),function(t,e){o[e]=n[e],delete n[e]}),o):(delete s[l.name],n)}return(r=u.validator.normalizeRules(u.extend({},u.validator.classRules(l),u.validator.attributeRules(l),u.validator.dataRules(l),u.validator.staticRules(l)),l)).required&&(a=r.required,delete r.required,r=u.extend({required:a},r)),r.remote&&(a=r.remote,delete r.remote,r=u.extend(r,{remote:a})),r}}}),u.extend(u.expr.pseudos||u.expr[":"],{blank:function(t){return!u.trim(""+u(t).val())},filled:function(t){var e=u(t).val();return null!==e&&!!u.trim(""+e)},unchecked:function(t){return!u(t).prop("checked")}}),u.validator=function(t,e){this.settings=u.extend(!0,{},u.validator.defaults,t),this.currentForm=e,this.init()},u.validator.format=function(i,t){return 1===arguments.length?function(){var t=u.makeArray(arguments);return t.unshift(i),u.validator.format.apply(this,t)}:(void 0===t||(2<arguments.length&&t.constructor!==Array&&(t=u.makeArray(arguments).slice(1)),t.constructor!==Array&&(t=[t]),u.each(t,function(t,e){i=i.replace(new RegExp("\\{"+t+"\\}","g"),function(){return e})})),i)},u.extend(u.validator,{defaults:{messages:{},groups:{},rules:{},errorClass:"error",pendingClass:"pending",validClass:"valid",errorElement:"label",focusCleanup:!1,focusInvalid:!0,errorContainer:u([]),errorLabelContainer:u([]),onsubmit:!0,ignore:":hidden",ignoreTitle:!1,onfocusin:function(t){this.lastActive=t,this.settings.focusCleanup&&(this.settings.unhighlight&&this.settings.unhighlight.call(this,t,this.settings.errorClass,this.settings.validClass),this.hideThese(this.errorsFor(t)))},onfocusout:function(t){this.checkable(t)||!(t.name in this.submitted)&&this.optional(t)||this.element(t)},onkeyup:function(t,e){9===e.which&&""===this.elementValue(t)||-1!==u.inArray(e.keyCode,[16,17,18,20,35,36,37,38,39,40,45,144,225])||(t.name in this.submitted||t.name in this.invalid)&&this.element(t)},onclick:function(t){t.name in this.submitted?this.element(t):t.parentNode.name in this.submitted&&this.element(t.parentNode)},highlight:function(t,e,i){"radio"===t.type?this.findByName(t.name).addClass(e).removeClass(i):u(t).addClass(e).removeClass(i)},unhighlight:function(t,e,i){"radio"===t.type?this.findByName(t.name).removeClass(e).addClass(i):u(t).removeClass(e).addClass(i)}},setDefaults:function(t){u.extend(u.validator.defaults,t)},messages:{required:"This field is required.",remote:"Please fix this field.",email:"Please enter a valid email address.",url:"Please enter a valid URL.",date:"Please enter a valid date.",dateISO:"Please enter a valid date (ISO).",number:"Please enter a valid number.",digits:"Please enter only digits.",equalTo:"Please enter the same value again.",maxlength:u.validator.format("Please enter no more than {0} characters."),minlength:u.validator.format("Please enter at least {0} characters."),rangelength:u.validator.format("Please enter a value between {0} and {1} characters long."),range:u.validator.format("Please enter a value between {0} and {1}."),max:u.validator.format("Please enter a value less than or equal to {0}."),min:u.validator.format("Please enter a value greater than or equal to {0}."),step:u.validator.format("Please enter a multiple of {0}.")},autoCreateRanges:!1,prototype:{init:function(){function t(t){!this.form&&this.hasAttribute("contenteditable")&&(this.form=u(this).closest("form")[0],this.name=u(this).attr("name"));var e=u.data(this.form,"validator"),i="on"+t.type.replace(/^validate/,""),s=e.settings;s[i]&&!u(this).is(s.ignore)&&s[i].call(e,this,t)}this.labelContainer=u(this.settings.errorLabelContainer),this.errorContext=this.labelContainer.length&&this.labelContainer||u(this.currentForm),this.containers=u(this.settings.errorContainer).add(this.settings.errorLabelContainer),this.submitted={},this.valueCache={},this.pendingRequest=0,this.pending={},this.invalid={},this.reset();var i,s=this.groups={};u.each(this.settings.groups,function(i,t){"string"==typeof t&&(t=t.split(/\s/)),u.each(t,function(t,e){s[e]=i})}),i=this.settings.rules,u.each(i,function(t,e){i[t]=u.validator.normalizeRule(e)}),u(this.currentForm).on("focusin.validate focusout.validate keyup.validate",":text, [type='password'], [type='file'], select, textarea, [type='number'], [type='search'], [type='tel'], [type='url'], [type='email'], [type='datetime'], [type='date'], [type='month'], [type='week'], [type='time'], [type='datetime-local'], [type='range'], [type='color'], [type='radio'], [type='checkbox'], [contenteditable], [type='button']",t).on("click.validate","select, option, [type='radio'], [type='checkbox']",t),this.settings.invalidHandler&&u(this.currentForm).on("invalid-form.validate",this.settings.invalidHandler)},form:function(){return this.checkForm(),u.extend(this.submitted,this.errorMap),this.invalid=u.extend({},this.errorMap),this.valid()||u(this.currentForm).triggerHandler("invalid-form",[this]),this.showErrors(),this.valid()},checkForm:function(){this.prepareForm();for(var t=0,e=this.currentElements=this.elements();e[t];t++)this.check(e[t]);return this.valid()},element:function(t){var e,i,s=this.clean(t),n=this.validationTargetFor(s),r=this,a=!0;return void 0===n?delete this.invalid[s.name]:(this.prepareElement(n),this.currentElements=u(n),(i=this.groups[n.name])&&u.each(this.groups,function(t,e){e===i&&t!==n.name&&((s=r.validationTargetFor(r.clean(r.findByName(t))))&&s.name in r.invalid&&(r.currentElements.push(s),a=r.check(s)&&a))}),e=!1!==this.check(n),a=a&&e,this.invalid[n.name]=!e,this.numberOfInvalids()||(this.toHide=this.toHide.add(this.containers)),this.showErrors(),u(t).attr("aria-invalid",!e)),a},showErrors:function(e){if(e){var i=this;u.extend(this.errorMap,e),this.errorList=u.map(this.errorMap,function(t,e){return{message:t,element:i.findByName(e)[0]}}),this.successList=u.grep(this.successList,function(t){return!(t.name in e)})}this.settings.showErrors?this.settings.showErrors.call(this,this.errorMap,this.errorList):this.defaultShowErrors()},resetForm:function(){u.fn.resetForm&&u(this.currentForm).resetForm(),this.invalid={},this.submitted={},this.prepareForm(),this.hideErrors();var t=this.elements().removeData("previousValue").removeAttr("aria-invalid");this.resetElements(t)},resetElements:function(t){var e;if(this.settings.unhighlight)for(e=0;t[e];e++)this.settings.unhighlight.call(this,t[e],this.settings.errorClass,""),this.findByName(t[e].name).removeClass(this.settings.validClass);else t.removeClass(this.settings.errorClass).removeClass(this.settings.validClass)},numberOfInvalids:function(){return this.objectLength(this.invalid)},objectLength:function(t){var e,i=0;for(e in t)void 0!==t[e]&&null!==t[e]&&!1!==t[e]&&i++;return i},hideErrors:function(){this.hideThese(this.toHide)},hideThese:function(t){t.not(this.containers).text(""),this.addWrapper(t).hide()},valid:function(){return 0===this.size()},size:function(){return this.errorList.length},focusInvalid:function(){if(this.settings.focusInvalid)try{u(this.findLastActive()||this.errorList.length&&this.errorList[0].element||[]).filter(":visible").focus().trigger("focusin")}catch(t){}},findLastActive:function(){var e=this.lastActive;return e&&1===u.grep(this.errorList,function(t){return t.element.name===e.name}).length&&e},elements:function(){var e=this,i={};return u(this.currentForm).find("input, select, textarea, [contenteditable]").not(":submit, :reset, :image, :disabled").not(this.settings.ignore).filter(function(){var t=this.name||u(this).attr("name");return!t&&e.settings.debug&&window.console&&console.error("%o has no name assigned",this),this.hasAttribute("contenteditable")&&(this.form=u(this).closest("form")[0],this.name=t),!(t in i||!e.objectLength(u(this).rules())||(i[t]=!0,0))})},clean:function(t){return u(t)[0]},errors:function(){var t=this.settings.errorClass.split(" ").join(".");return u(this.settings.errorElement+"."+t,this.errorContext)},resetInternals:function(){this.successList=[],this.errorList=[],this.errorMap={},this.toShow=u([]),this.toHide=u([])},reset:function(){this.resetInternals(),this.currentElements=u([])},prepareForm:function(){this.reset(),this.toHide=this.errors().add(this.containers)},prepareElement:function(t){this.reset(),this.toHide=this.errorsFor(t)},elementValue:function(t){var e,i,s=u(t),n=t.type;return"radio"===n||"checkbox"===n?this.findByName(t.name).filter(":checked").val():"number"===n&&void 0!==t.validity?t.validity.badInput?"NaN":s.val():(e=t.hasAttribute("contenteditable")?s.text():s.val(),"file"===n?"C:\\fakepath\\"===e.substr(0,12)?e.substr(12):0<=(i=e.lastIndexOf("/"))?e.substr(i+1):0<=(i=e.lastIndexOf("\\"))?e.substr(i+1):e:"string"==typeof e?e.replace(/\r/g,""):e)},check:function(e){e=this.validationTargetFor(this.clean(e));var t,i,s,n,r=u(e).rules(),a=u.map(r,function(t,e){return e}).length,o=!1,l=this.elementValue(e);if("function"==typeof r.normalizer?n=r.normalizer:"function"==typeof this.settings.normalizer&&(n=this.settings.normalizer),n){if("string"!=typeof(l=n.call(e,l)))throw new TypeError("The normalizer should return a string value.");delete r.normalizer}for(i in r){s={method:i,parameters:r[i]};try{if("dependency-mismatch"===(t=u.validator.methods[i].call(this,l,e,s.parameters))&&1===a){o=!0;continue}if(o=!1,"pending"===t)return void(this.toHide=this.toHide.not(this.errorsFor(e)));if(!t)return this.formatAndAdd(e,s),!1}catch(t){throw this.settings.debug&&window.console&&console.log("Exception occurred when checking element "+e.id+", check the '"+s.method+"' method.",t),t instanceof TypeError&&(t.message+=".  Exception occurred when checking element "+e.id+", check the '"+s.method+"' method."),t}}if(!o)return this.objectLength(r)&&this.successList.push(e),!0},customDataMessage:function(t,e){return u(t).data("msg"+e.charAt(0).toUpperCase()+e.substring(1).toLowerCase())||u(t).data("msg")},customMessage:function(t,e){var i=this.settings.messages[t];return i&&(i.constructor===String?i:i[e])},findDefined:function(){for(var t=0;t<arguments.length;t++)if(void 0!==arguments[t])return arguments[t]},defaultMessage:function(t,e){"string"==typeof e&&(e={method:e});var i=this.findDefined(this.customMessage(t.name,e.method),this.customDataMessage(t,e.method),!this.settings.ignoreTitle&&t.title||void 0,u.validator.messages[e.method],"<strong>Warning: No message defined for "+t.name+"</strong>"),s=/\$?\{(\d+)\}/g;return"function"==typeof i?i=i.call(this,e.parameters,t):s.test(i)&&(i=u.validator.format(i.replace(s,"{$1}"),e.parameters)),i},formatAndAdd:function(t,e){var i=this.defaultMessage(t,e);this.errorList.push({message:i,element:t,method:e.method}),this.errorMap[t.name]=i,this.submitted[t.name]=i},addWrapper:function(t){return this.settings.wrapper&&(t=t.add(t.parent(this.settings.wrapper))),t},defaultShowErrors:function(){var t,e,i;for(t=0;this.errorList[t];t++)i=this.errorList[t],this.settings.highlight&&this.settings.highlight.call(this,i.element,this.settings.errorClass,this.settings.validClass),this.showLabel(i.element,i.message);if(this.errorList.length&&(this.toShow=this.toShow.add(this.containers)),this.settings.success)for(t=0;this.successList[t];t++)this.showLabel(this.successList[t]);if(this.settings.unhighlight)for(t=0,e=this.validElements();e[t];t++)this.settings.unhighlight.call(this,e[t],this.settings.errorClass,this.settings.validClass);this.toHide=this.toHide.not(this.toShow),this.hideErrors(),this.addWrapper(this.toShow).show()},validElements:function(){return this.currentElements.not(this.invalidElements())},invalidElements:function(){return u(this.errorList).map(function(){return this.element})},showLabel:function(t,e){var i,s,n,r,a=this.errorsFor(t),o=this.idOrName(t),l=u(t).attr("aria-describedby");a.length?(a.removeClass(this.settings.validClass).addClass(this.settings.errorClass),a.html(e)):(i=a=u("<"+this.settings.errorElement+">").attr("id",o+"-error").addClass(this.settings.errorClass).html(e||""),this.settings.wrapper&&(i=a.hide().show().wrap("<"+this.settings.wrapper+"/>").parent()),this.labelContainer.length?this.labelContainer.append(i):this.settings.errorPlacement?this.settings.errorPlacement.call(this,i,u(t)):i.insertAfter(t),a.is("label")?a.attr("for",o):0===a.parents("label[for='"+this.escapeCssMeta(o)+"']").length&&(n=a.attr("id"),l?l.match(new RegExp("\\b"+this.escapeCssMeta(n)+"\\b"))||(l+=" "+n):l=n,u(t).attr("aria-describedby",l),(s=this.groups[t.name])&&(r=this,u.each(r.groups,function(t,e){e===s&&u("[name='"+r.escapeCssMeta(t)+"']",r.currentForm).attr("aria-describedby",a.attr("id"))})))),!e&&this.settings.success&&(a.text(""),"string"==typeof this.settings.success?a.addClass(this.settings.success):this.settings.success(a,t)),this.toShow=this.toShow.add(a)},errorsFor:function(t){var e=this.escapeCssMeta(this.idOrName(t)),i=u(t).attr("aria-describedby"),s="label[for='"+e+"'], label[for='"+e+"'] *";return i&&(s=s+", #"+this.escapeCssMeta(i).replace(/\s+/g,", #")),this.errors().filter(s)},escapeCssMeta:function(t){return t.replace(/([\\!"#$%&'()*+,.\/:;<=>?@\[\]^`{|}~])/g,"\\$1")},idOrName:function(t){return this.groups[t.name]||(this.checkable(t)?t.name:t.id||t.name)},validationTargetFor:function(t){return this.checkable(t)&&(t=this.findByName(t.name)),u(t).not(this.settings.ignore)[0]},checkable:function(t){return/radio|checkbox/i.test(t.type)},findByName:function(t){return u(this.currentForm).find("[name='"+this.escapeCssMeta(t)+"']")},getLength:function(t,e){switch(e.nodeName.toLowerCase()){case"select":return u("option:selected",e).length;case"input":if(this.checkable(e))return this.findByName(e.name).filter(":checked").length}return t.length},depend:function(t,e){return!this.dependTypes[typeof t]||this.dependTypes[typeof t](t,e)},dependTypes:{boolean:function(t){return t},string:function(t,e){return!!u(t,e.form).length},function:function(t,e){return t(e)}},optional:function(t){var e=this.elementValue(t);return!u.validator.methods.required.call(this,e,t)&&"dependency-mismatch"},startRequest:function(t){this.pending[t.name]||(this.pendingRequest++,u(t).addClass(this.settings.pendingClass),this.pending[t.name]=!0)},stopRequest:function(t,e){this.pendingRequest--,this.pendingRequest<0&&(this.pendingRequest=0),delete this.pending[t.name],u(t).removeClass(this.settings.pendingClass),e&&0===this.pendingRequest&&this.formSubmitted&&this.form()?(u(this.currentForm).submit(),this.submitButton&&u("input:hidden[name='"+this.submitButton.name+"']",this.currentForm).remove(),this.formSubmitted=!1):!e&&0===this.pendingRequest&&this.formSubmitted&&(u(this.currentForm).triggerHandler("invalid-form",[this]),this.formSubmitted=!1)},previousValue:function(t,e){return e="string"==typeof e&&e||"remote",u.data(t,"previousValue")||u.data(t,"previousValue",{old:null,valid:!0,message:this.defaultMessage(t,{method:e})})},destroy:function(){this.resetForm(),u(this.currentForm).off(".validate").removeData("validator").find(".validate-equalTo-blur").off(".validate-equalTo").removeClass("validate-equalTo-blur")}},classRuleSettings:{required:{required:!0},email:{email:!0},url:{url:!0},date:{date:!0},dateISO:{dateISO:!0},number:{number:!0},digits:{digits:!0},creditcard:{creditcard:!0}},addClassRules:function(t,e){t.constructor===String?this.classRuleSettings[t]=e:u.extend(this.classRuleSettings,t)},classRules:function(t){var e={},i=u(t).attr("class");return i&&u.each(i.split(" "),function(){this in u.validator.classRuleSettings&&u.extend(e,u.validator.classRuleSettings[this])}),e},normalizeAttributeRule:function(t,e,i,s){/min|max|step/.test(i)&&(null===e||/number|range|text/.test(e))&&(s=Number(s),isNaN(s)&&(s=void 0)),s||0===s?t[i]=s:e===i&&"range"!==e&&(t[i]=!0)},attributeRules:function(t){var e,i,s={},n=u(t),r=t.getAttribute("type");for(e in u.validator.methods)"required"===e?(""===(i=t.getAttribute(e))&&(i=!0),i=!!i):i=n.attr(e),this.normalizeAttributeRule(s,r,e,i);return s.maxlength&&/-1|2147483647|524288/.test(s.maxlength)&&delete s.maxlength,s},dataRules:function(t){var e,i,s={},n=u(t),r=t.getAttribute("type");for(e in u.validator.methods)i=n.data("rule"+e.charAt(0).toUpperCase()+e.substring(1).toLowerCase()),this.normalizeAttributeRule(s,r,e,i);return s},staticRules:function(t){var e={},i=u.data(t.form,"validator");return i.settings.rules&&(e=u.validator.normalizeRule(i.settings.rules[t.name])||{}),e},normalizeRules:function(s,n){return u.each(s,function(t,e){if(!1!==e){if(e.param||e.depends){var i=!0;switch(typeof e.depends){case"string":i=!!u(e.depends,n.form).length;break;case"function":i=e.depends.call(n,n)}i?s[t]=void 0===e.param||e.param:(u.data(n.form,"validator").resetElements(u(n)),delete s[t])}}else delete s[t]}),u.each(s,function(t,e){s[t]=u.isFunction(e)&&"normalizer"!==t?e(n):e}),u.each(["minlength","maxlength"],function(){s[this]&&(s[this]=Number(s[this]))}),u.each(["rangelength","range"],function(){var t;s[this]&&(u.isArray(s[this])?s[this]=[Number(s[this][0]),Number(s[this][1])]:"string"==typeof s[this]&&(t=s[this].replace(/[\[\]]/g,"").split(/[\s,]+/),s[this]=[Number(t[0]),Number(t[1])]))}),u.validator.autoCreateRanges&&(null!=s.min&&null!=s.max&&(s.range=[s.min,s.max],delete s.min,delete s.max),null!=s.minlength&&null!=s.maxlength&&(s.rangelength=[s.minlength,s.maxlength],delete s.minlength,delete s.maxlength)),s},normalizeRule:function(t){if("string"==typeof t){var e={};u.each(t.split(/\s/),function(){e[this]=!0}),t=e}return t},addMethod:function(t,e,i){u.validator.methods[t]=e,u.validator.messages[t]=void 0!==i?i:u.validator.messages[t],e.length<3&&u.validator.addClassRules(t,u.validator.normalizeRule(t))},methods:{required:function(t,e,i){if(!this.depend(i,e))return"dependency-mismatch";if("select"===e.nodeName.toLowerCase()){var s=u(e).val();return s&&0<s.length}return this.checkable(e)?0<this.getLength(t,e):0<t.length},email:function(t,e){return this.optional(e)||/^[a-zA-Z0-9.!#$%&'*+\/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*$/.test(t)},url:function(t,e){return this.optional(e)||/^(?:(?:(?:https?|ftp):)?\/\/)(?:\S+(?::\S*)?@)?(?:(?!(?:10|127)(?:\.\d{1,3}){3})(?!(?:169\.254|192\.168)(?:\.\d{1,3}){2})(?!172\.(?:1[6-9]|2\d|3[0-1])(?:\.\d{1,3}){2})(?:[1-9]\d?|1\d\d|2[01]\d|22[0-3])(?:\.(?:1?\d{1,2}|2[0-4]\d|25[0-5])){2}(?:\.(?:[1-9]\d?|1\d\d|2[0-4]\d|25[0-4]))|(?:(?:[a-z\u00a1-\uffff0-9]-*)*[a-z\u00a1-\uffff0-9]+)(?:\.(?:[a-z\u00a1-\uffff0-9]-*)*[a-z\u00a1-\uffff0-9]+)*(?:\.(?:[a-z\u00a1-\uffff]{2,})).?)(?::\d{2,5})?(?:[\/?#]\S*)?$/i.test(t)},date:function(t,e){return this.optional(e)||!/Invalid|NaN/.test(new Date(t).toString())},dateISO:function(t,e){return this.optional(e)||/^\d{4}[\/\-](0?[1-9]|1[012])[\/\-](0?[1-9]|[12][0-9]|3[01])$/.test(t)},number:function(t,e){return this.optional(e)||/^(?:-?\d+|-?\d{1,3}(?:,\d{3})+)?(?:\.\d+)?$/.test(t)},digits:function(t,e){return this.optional(e)||/^\d+$/.test(t)},minlength:function(t,e,i){var s=u.isArray(t)?t.length:this.getLength(t,e);return this.optional(e)||i<=s},maxlength:function(t,e,i){var s=u.isArray(t)?t.length:this.getLength(t,e);return this.optional(e)||s<=i},rangelength:function(t,e,i){var s=u.isArray(t)?t.length:this.getLength(t,e);return this.optional(e)||s>=i[0]&&s<=i[1]},min:function(t,e,i){return this.optional(e)||i<=t},max:function(t,e,i){return this.optional(e)||t<=i},range:function(t,e,i){return this.optional(e)||t>=i[0]&&t<=i[1]},step:function(t,e,i){var s,n=u(e).attr("type"),r="Step attribute on input type "+n+" is not supported.",a=new RegExp("\\b"+n+"\\b"),o=function(t){var e=(""+t).match(/(?:\.(\d+))?$/);return e&&e[1]?e[1].length:0},l=function(t){return Math.round(t*Math.pow(10,s))},h=!0;if(n&&!a.test(["text","number","range"].join()))throw new Error(r);return s=o(i),(o(t)>s||l(t)%l(i)!=0)&&(h=!1),this.optional(e)||h},equalTo:function(t,e,i){var s=u(i);return this.settings.onfocusout&&s.not(".validate-equalTo-blur").length&&s.addClass("validate-equalTo-blur").on("blur.validate-equalTo",function(){u(e).valid()}),t===s.val()},remote:function(r,a,t,o){if(this.optional(a))return"dependency-mismatch";o="string"==typeof o&&o||"remote";var l,e,i,h=this.previousValue(a,o);return this.settings.messages[a.name]||(this.settings.messages[a.name]={}),h.originalMessage=h.originalMessage||this.settings.messages[a.name][o],this.settings.messages[a.name][o]=h.message,t="string"==typeof t&&{url:t}||t,i=u.param(u.extend({data:r},t.data)),h.old===i?h.valid:(h.old=i,(l=this).startRequest(a),(e={})[a.name]=r,u.ajax(u.extend(!0,{mode:"abort",port:"validate"+a.name,dataType:"json",data:e,context:l.currentForm,success:function(t){var e,i,s,n=!0===t||"true"===t;l.settings.messages[a.name][o]=h.originalMessage,n?(s=l.formSubmitted,l.resetInternals(),l.toHide=l.errorsFor(a),l.formSubmitted=s,l.successList.push(a),l.invalid[a.name]=!1,l.showErrors()):(e={},i=t||l.defaultMessage(a,{method:o,parameters:r}),e[a.name]=h.message=i,l.invalid[a.name]=!0,l.showErrors(e)),h.valid=n,l.stopRequest(a,n)}},t)),"pending")}}});var s,n={};return u.ajaxPrefilter?u.ajaxPrefilter(function(t,e,i){var s=t.port;"abort"===t.mode&&(n[s]&&n[s].abort(),n[s]=i)}):(s=u.ajax,u.ajax=function(t){var e=("mode"in t?t:u.ajaxSettings).mode,i=("port"in t?t:u.ajaxSettings).port;return"abort"===e?(n[i]&&n[i].abort(),n[i]=s.apply(this,arguments),n[i]):s.apply(this,arguments)}),u});
/*! modernizr 3.6.0 (Custom Build) | MIT *
 * https://modernizr.com/download/?-audio-backgroundsize-cssanimations-cssgradients-csstransforms-csstransforms3d-csstransitions-fontface-generatedcontent-hashchange-input-inputtypes-rgba-svg-video-domprefixes-hasevent-prefixes-setclasses-shiv-testallprops-testprop-teststyles !*/
!function(e,t,n){function r(e,t){return typeof e===t}function a(){var e,t,n,a,o,i,s;for(var l in T)if(T.hasOwnProperty(l)){if(e=[],t=T[l],t.name&&(e.push(t.name.toLowerCase()),t.options&&t.options.aliases&&t.options.aliases.length))for(n=0;n<t.options.aliases.length;n++)e.push(t.options.aliases[n].toLowerCase());for(a=r(t.fn,"function")?t.fn():t.fn,o=0;o<e.length;o++)i=e[o],s=i.split("."),1===s.length?Modernizr[s[0]]=a:(!Modernizr[s[0]]||Modernizr[s[0]]instanceof Boolean||(Modernizr[s[0]]=new Boolean(Modernizr[s[0]])),Modernizr[s[0]][s[1]]=a),b.push((a?"":"no-")+s.join("-"))}}function o(e){var t=C.className,n=Modernizr._config.classPrefix||"";if(E&&(t=t.baseVal),Modernizr._config.enableJSClass){var r=new RegExp("(^|\\s)"+n+"no-js(\\s|$)");t=t.replace(r,"$1"+n+"js$2")}Modernizr._config.enableClasses&&(t+=" "+n+e.join(" "+n),E?C.className.baseVal=t:C.className=t)}function i(){return"function"!=typeof t.createElement?t.createElement(arguments[0]):E?t.createElementNS.call(t,"http://www.w3.org/2000/svg",arguments[0]):t.createElement.apply(t,arguments)}function s(e,t){return!!~(""+e).indexOf(t)}function l(e){return e.replace(/([a-z])-([a-z])/g,function(e,t,n){return t+n.toUpperCase()}).replace(/^-/,"")}function c(){var e=t.body;return e||(e=i(E?"svg":"body"),e.fake=!0),e}function u(e,n,r,a){var o,s,l,u,d="modernizr",f=i("div"),p=c();if(parseInt(r,10))for(;r--;)l=i("div"),l.id=a?a[r]:d+(r+1),f.appendChild(l);return o=i("style"),o.type="text/css",o.id="s"+d,(p.fake?p:f).appendChild(o),p.appendChild(f),o.styleSheet?o.styleSheet.cssText=e:o.appendChild(t.createTextNode(e)),f.id=d,p.fake&&(p.style.background="",p.style.overflow="hidden",u=C.style.overflow,C.style.overflow="hidden",C.appendChild(p)),s=n(f,e),p.fake?(p.parentNode.removeChild(p),C.style.overflow=u,C.offsetHeight):f.parentNode.removeChild(f),!!s}function d(e){return e.replace(/([A-Z])/g,function(e,t){return"-"+t.toLowerCase()}).replace(/^ms-/,"-ms-")}function f(e,t){return function(){return e.apply(t,arguments)}}function p(e,t,n){var a;for(var o in e)if(e[o]in t)return n===!1?e[o]:(a=t[e[o]],r(a,"function")?f(a,n||t):a);return!1}function m(t,n,r){var a;if("getComputedStyle"in e){a=getComputedStyle.call(e,t,n);var o=e.console;if(null!==a)r&&(a=a.getPropertyValue(r));else if(o){var i=o.error?"error":"log";o[i].call(o,"getComputedStyle returning null, its possible modernizr test results are inaccurate")}}else a=!n&&t.currentStyle&&t.currentStyle[r];return a}function g(t,r){var a=t.length;if("CSS"in e&&"supports"in e.CSS){for(;a--;)if(e.CSS.supports(d(t[a]),r))return!0;return!1}if("CSSSupportsRule"in e){for(var o=[];a--;)o.push("("+d(t[a])+":"+r+")");return o=o.join(" or "),u("@supports ("+o+") { #modernizr { position: absolute; } }",function(e){return"absolute"==m(e,null,"position")})}return n}function h(e,t,a,o){function c(){d&&(delete O.style,delete O.modElem)}if(o=r(o,"undefined")?!1:o,!r(a,"undefined")){var u=g(e,a);if(!r(u,"undefined"))return u}for(var d,f,p,m,h,v=["modernizr","tspan","samp"];!O.style&&v.length;)d=!0,O.modElem=i(v.shift()),O.style=O.modElem.style;for(p=e.length,f=0;p>f;f++)if(m=e[f],h=O.style[m],s(m,"-")&&(m=l(m)),O.style[m]!==n){if(o||r(a,"undefined"))return c(),"pfx"==t?m:!0;try{O.style[m]=a}catch(y){}if(O.style[m]!=h)return c(),"pfx"==t?m:!0}return c(),!1}function v(e,t,n,a,o){var i=e.charAt(0).toUpperCase()+e.slice(1),s=(e+" "+M.join(i+" ")+i).split(" ");return r(t,"string")||r(t,"undefined")?h(s,t,a,o):(s=(e+" "+P.join(i+" ")+i).split(" "),p(s,t,n))}function y(e,t,r){return v(e,n,n,t,r)}var b=[],T=[],S={_version:"3.6.0",_config:{classPrefix:"",enableClasses:!0,enableJSClass:!0,usePrefixes:!0},_q:[],on:function(e,t){var n=this;setTimeout(function(){t(n[e])},0)},addTest:function(e,t,n){T.push({name:e,fn:t,options:n})},addAsyncTest:function(e){T.push({name:null,fn:e})}},Modernizr=function(){};Modernizr.prototype=S,Modernizr=new Modernizr,Modernizr.addTest("svg",!!t.createElementNS&&!!t.createElementNS("http://www.w3.org/2000/svg","svg").createSVGRect);var w=S._config.usePrefixes?" -webkit- -moz- -o- -ms- ".split(" "):["",""];S._prefixes=w;var C=t.documentElement,E="svg"===C.nodeName.toLowerCase();E||!function(e,t){function n(e,t){var n=e.createElement("p"),r=e.getElementsByTagName("head")[0]||e.documentElement;return n.innerHTML="x<style>"+t+"</style>",r.insertBefore(n.lastChild,r.firstChild)}function r(){var e=b.elements;return"string"==typeof e?e.split(" "):e}function a(e,t){var n=b.elements;"string"!=typeof n&&(n=n.join(" ")),"string"!=typeof e&&(e=e.join(" ")),b.elements=n+" "+e,c(t)}function o(e){var t=y[e[h]];return t||(t={},v++,e[h]=v,y[v]=t),t}function i(e,n,r){if(n||(n=t),d)return n.createElement(e);r||(r=o(n));var a;return a=r.cache[e]?r.cache[e].cloneNode():g.test(e)?(r.cache[e]=r.createElem(e)).cloneNode():r.createElem(e),!a.canHaveChildren||m.test(e)||a.tagUrn?a:r.frag.appendChild(a)}function s(e,n){if(e||(e=t),d)return e.createDocumentFragment();n=n||o(e);for(var a=n.frag.cloneNode(),i=0,s=r(),l=s.length;l>i;i++)a.createElement(s[i]);return a}function l(e,t){t.cache||(t.cache={},t.createElem=e.createElement,t.createFrag=e.createDocumentFragment,t.frag=t.createFrag()),e.createElement=function(n){return b.shivMethods?i(n,e,t):t.createElem(n)},e.createDocumentFragment=Function("h,f","return function(){var n=f.cloneNode(),c=n.createElement;h.shivMethods&&("+r().join().replace(/[\w\-:]+/g,function(e){return t.createElem(e),t.frag.createElement(e),'c("'+e+'")'})+");return n}")(b,t.frag)}function c(e){e||(e=t);var r=o(e);return!b.shivCSS||u||r.hasCSS||(r.hasCSS=!!n(e,"article,aside,dialog,figcaption,figure,footer,header,hgroup,main,nav,section{display:block}mark{background:#FF0;color:#000}template{display:none}")),d||l(e,r),e}var u,d,f="3.7.3",p=e.html5||{},m=/^<|^(?:button|map|select|textarea|object|iframe|option|optgroup)$/i,g=/^(?:a|b|code|div|fieldset|h1|h2|h3|h4|h5|h6|i|label|li|ol|p|q|span|strong|style|table|tbody|td|th|tr|ul)$/i,h="_html5shiv",v=0,y={};!function(){try{var e=t.createElement("a");e.innerHTML="<xyz></xyz>",u="hidden"in e,d=1==e.childNodes.length||function(){t.createElement("a");var e=t.createDocumentFragment();return"undefined"==typeof e.cloneNode||"undefined"==typeof e.createDocumentFragment||"undefined"==typeof e.createElement}()}catch(n){u=!0,d=!0}}();var b={elements:p.elements||"abbr article aside audio bdi canvas data datalist details dialog figcaption figure footer header hgroup main mark meter nav output picture progress section summary template time video",version:f,shivCSS:p.shivCSS!==!1,supportsUnknownElements:d,shivMethods:p.shivMethods!==!1,type:"default",shivDocument:c,createElement:i,createDocumentFragment:s,addElements:a};e.html5=b,c(t),"object"==typeof module&&module.exports&&(module.exports=b)}("undefined"!=typeof e?e:this,t);var x="Moz O ms Webkit",P=S._config.usePrefixes?x.toLowerCase().split(" "):[];S._domPrefixes=P;var k=function(){function e(e,t){var a;return e?(t&&"string"!=typeof t||(t=i(t||"div")),e="on"+e,a=e in t,!a&&r&&(t.setAttribute||(t=i("div")),t.setAttribute(e,""),a="function"==typeof t[e],t[e]!==n&&(t[e]=n),t.removeAttribute(e)),a):!1}var r=!("onblur"in t.documentElement);return e}();S.hasEvent=k,Modernizr.addTest("hashchange",function(){return k("hashchange",e)===!1?!1:t.documentMode===n||t.documentMode>7}),Modernizr.addTest("audio",function(){var e=i("audio"),t=!1;try{t=!!e.canPlayType,t&&(t=new Boolean(t),t.ogg=e.canPlayType('audio/ogg; codecs="vorbis"').replace(/^no$/,""),t.mp3=e.canPlayType('audio/mpeg; codecs="mp3"').replace(/^no$/,""),t.opus=e.canPlayType('audio/ogg; codecs="opus"')||e.canPlayType('audio/webm; codecs="opus"').replace(/^no$/,""),t.wav=e.canPlayType('audio/wav; codecs="1"').replace(/^no$/,""),t.m4a=(e.canPlayType("audio/x-m4a;")||e.canPlayType("audio/aac;")).replace(/^no$/,""))}catch(n){}return t}),Modernizr.addTest("video",function(){var e=i("video"),t=!1;try{t=!!e.canPlayType,t&&(t=new Boolean(t),t.ogg=e.canPlayType('video/ogg; codecs="theora"').replace(/^no$/,""),t.h264=e.canPlayType('video/mp4; codecs="avc1.42E01E"').replace(/^no$/,""),t.webm=e.canPlayType('video/webm; codecs="vp8, vorbis"').replace(/^no$/,""),t.vp9=e.canPlayType('video/webm; codecs="vp9"').replace(/^no$/,""),t.hls=e.canPlayType('application/x-mpegURL; codecs="avc1.42E01E"').replace(/^no$/,""))}catch(n){}return t}),Modernizr.addTest("cssgradients",function(){for(var e,t="background-image:",n="gradient(linear,left top,right bottom,from(#9f9),to(white));",r="",a=0,o=w.length-1;o>a;a++)e=0===a?"to ":"",r+=t+w[a]+"linear-gradient("+e+"left top, #9f9, white);";Modernizr._config.usePrefixes&&(r+=t+"-webkit-"+n);var s=i("a"),l=s.style;return l.cssText=r,(""+l.backgroundImage).indexOf("gradient")>-1}),Modernizr.addTest("rgba",function(){var e=i("a").style;return e.cssText="background-color:rgba(150,255,150,.5)",(""+e.backgroundColor).indexOf("rgba")>-1});var _=i("input"),N="autocomplete autofocus list placeholder max min multiple pattern required step".split(" "),$={};Modernizr.input=function(t){for(var n=0,r=t.length;r>n;n++)$[t[n]]=!!(t[n]in _);return $.list&&($.list=!(!i("datalist")||!e.HTMLDataListElement)),$}(N);var z="search tel url email datetime date month week time datetime-local number range color".split(" "),A={};Modernizr.inputtypes=function(e){for(var r,a,o,i=e.length,s="1)",l=0;i>l;l++)_.setAttribute("type",r=e[l]),o="text"!==_.type&&"style"in _,o&&(_.value=s,_.style.cssText="position:absolute;visibility:hidden;",/^range$/.test(r)&&_.style.WebkitAppearance!==n?(C.appendChild(_),a=t.defaultView,o=a.getComputedStyle&&"textfield"!==a.getComputedStyle(_,null).WebkitAppearance&&0!==_.offsetHeight,C.removeChild(_)):/^(search|tel)$/.test(r)||(o=/^(url|email)$/.test(r)?_.checkValidity&&_.checkValidity()===!1:_.value!=s)),A[e[l]]=!!o;return A}(z);var j="CSS"in e&&"supports"in e.CSS,F="supportsCSS"in e;Modernizr.addTest("supports",j||F);var M=S._config.usePrefixes?x.split(" "):[];S._cssomPrefixes=M;var L=S.testStyles=u,R=function(){var e=navigator.userAgent,t=e.match(/w(eb)?osbrowser/gi),n=e.match(/windows phone/gi)&&e.match(/iemobile\/([0-9])+/gi)&&parseFloat(RegExp.$1)>=9;return t||n}();R?Modernizr.addTest("fontface",!1):L('@font-face {font-family:"font";src:url("https://")}',function(e,n){var r=t.getElementById("smodernizr"),a=r.sheet||r.styleSheet,o=a?a.cssRules&&a.cssRules[0]?a.cssRules[0].cssText:a.cssText||"":"",i=/src/i.test(o)&&0===o.indexOf(n.split(" ")[0]);Modernizr.addTest("fontface",i)}),L('#modernizr{font:0/0 a}#modernizr:after{content:":)";visibility:hidden;font:7px/1 a}',function(e){Modernizr.addTest("generatedcontent",e.offsetHeight>=6)});var D={elem:i("modernizr")};Modernizr._q.push(function(){delete D.elem});var O={style:D.elem.style};Modernizr._q.unshift(function(){delete O.style});S.testProp=function(e,t,r){return h([e],n,t,r)};S.testAllProps=v,S.testAllProps=y,Modernizr.addTest("cssanimations",y("animationName","a",!0)),Modernizr.addTest("backgroundsize",y("backgroundSize","100%",!0)),Modernizr.addTest("csstransforms",function(){return-1===navigator.userAgent.indexOf("Android 2.")&&y("transform","scale(1)",!0)}),Modernizr.addTest("csstransforms3d",function(){return!!y("perspective","1px",!0)}),Modernizr.addTest("csstransitions",y("transition","all",!0)),a(),o(b),delete S.addTest,delete S.addAsyncTest;for(var V=0;V<Modernizr._q.length;V++)Modernizr._q[V]();e.Modernizr=Modernizr}(window,document);
/*!
 * ScrewDefaultButtons v2.0.6
 * http://screwdefaultbuttons.com/
 *
 * Licensed under the MIT license.
 * Copyright 2013 Matt Solano http://mattsolano.com
 *
 * Date: Mon February 25 2013
 */
/*
!function(u,e,i,t){var n={init:function(e){var d=u.extend({image:null,width:50,height:50,disabled:!1},e);return this.each(function(){var e=u(this),i=d.image,t=e.data("sdb-image");t&&(i=t),i||u.error("There is no image assigned for ScrewDefaultButtons"),e.wrap("<div >").css({display:"none"});var n=e.attr("class"),c=e.attr("onclick"),o=e.parent("div");o.addClass(n),o.attr("onclick",c),o.css({"background-image":i,width:d.width,height:d.height,cursor:"pointer"});var r=0,s=-d.height;if(e.is(":disabled")&&(r=-2*d.height,s=-3*d.height),e.on("disableBtn",function(){e.attr("disabled","disabled"),r=-2*d.height,s=-3*d.height,e.trigger("resetBackground")}),e.on("enableBtn",function(){e.removeAttr("disabled"),r=0,s=-d.height,e.trigger("resetBackground")}),e.on("resetBackground",function(){e.is(":checked")?o.css({backgroundPosition:"0 "+s+"px"}):o.css({backgroundPosition:"0 "+r+"px"})}),e.trigger("resetBackground"),e.is(":checkbox"))o.on("click",function(){e.is(":disabled")||e.change()}),o.addClass("styledCheckbox"),e.on("change",function(){e.prop("checked")?(e.prop("checked",!1),o.css({backgroundPosition:"0 "+r+"px"})):(e.prop("checked",!0),o.css({backgroundPosition:"0 "+s+"px"}))});else if(e.is(":radio")){o.addClass("styledRadio");var a=e.attr("name");o.on("click",function(){!e.prop("checked")&&!e.is(":disabled")&&e.change()}),e.on("change",function(){e.prop("checked")?(e.prop("checked",!1),o.css({backgroundPosition:"0 "+r+"px"})):(e.prop("checked",!0),o.css({backgroundPosition:"0 "+s+"px"}),u('input[name="'+a+'"]').not(e).trigger("radioSwitch"))}),e.on("radioSwitch",function(){o.css({backgroundPosition:"0 "+r+"px"})});var h=u(this).attr("id");u('label[for="'+h+'"]').on("click",function(){o.trigger("click")})}if(!u.support.leadingWhitespace){h=u(this).attr("id");u('label[for="'+h+'"]').on("click",function(){o.trigger("click")})}})},check:function(){return this.each(function(){var e=u(this);n.isChecked(e)||e.change()})},uncheck:function(){return this.each(function(){var e=u(this);n.isChecked(e)&&e.change()})},toggle:function(){return this.each(function(){u(this).change()})},disable:function(){return this.each(function(){u(this).trigger("disableBtn")})},enable:function(){return this.each(function(){u(this).trigger("enableBtn")})},isChecked:function(e){return!!e.prop("checked")}};u.fn.screwDefaultButtons=function(e,i){return n[e]?n[e].apply(this,Array.prototype.slice.call(arguments,1)):"object"!=typeof e&&e?void u.error("Method "+e+" does not exist on jQuery.screwDefaultButtons"):n.init.apply(this,arguments)}}(jQuery);
*/
/*!
 * hoverIntent v1.9.0 // 2017.09.01 // jQuery v1.7.0+
 * http://briancherne.github.io/jquery-hoverIntent/
 *
 * You may use hoverIntent under the terms of the MIT license. Basically that
 * means you are free to use hoverIntent as long as this header is left intact.
 * Copyright 2007-2017 Brian Cherne
 */
/*
!function(e){"use strict";"function"==typeof define&&define.amd?define(["jquery"],e):jQuery&&!jQuery.fn.hoverIntent&&e(jQuery)}(function(a){"use strict";var o,r,u={interval:100,sensitivity:6,timeout:0},s=0,f=function(e){o=e.pageX,r=e.pageY},d=function(e,t,n,i){if(Math.sqrt((n.pX-o)*(n.pX-o)+(n.pY-r)*(n.pY-r))<i.sensitivity)return t.off(n.event,f),delete n.timeoutId,n.isActive=!0,e.pageX=o,e.pageY=r,delete n.pX,delete n.pY,i.over.apply(t[0],[e]);n.pX=o,n.pY=r,n.timeoutId=setTimeout(function(){d(e,t,n,i)},i.interval)};a.fn.hoverIntent=function(e,t,n){var i=s++,v=a.extend({},u);a.isPlainObject(e)?(v=a.extend(v,e),a.isFunction(v.out)||(v.out=v.over)):v=a.isFunction(t)?a.extend(v,{over:e,out:t,selector:n}):a.extend(v,{over:e,out:e,selector:t});var o=function(e){var o=a.extend({},e),r=a(this),t=r.data("hoverIntent");t||r.data("hoverIntent",t={});var u=t[i];u||(t[i]=u={id:i}),u.timeoutId&&(u.timeoutId=clearTimeout(u.timeoutId));var n=u.event="mousemove.hoverIntent.hoverIntent"+i;if("mouseenter"===e.type){if(u.isActive)return;u.pX=o.pageX,u.pY=o.pageY,r.off(n,f).on(n,f),u.timeoutId=setTimeout(function(){d(o,r,u,v)},v.interval)}else{if(!u.isActive)return;r.off(n,f),u.timeoutId=setTimeout(function(){var e,t,n,i;e=o,t=r,n=u,i=v.out,delete t.data("hoverIntent")[n.id],i.apply(t[0],[e])},v.timeout)}};return this.on({"mouseenter.hoverIntent":o,"mouseleave.hoverIntent":o},v.selector)}});
*/
/*!
 * LazyLoad
 * https://github.com/verlok/lazyload
 */
function _extends(){return(_extends=Object.assign||function(t){for(var e=1;e<arguments.length;e++){var n=arguments[e];for(var o in n)Object.prototype.hasOwnProperty.call(n,o)&&(t[o]=n[o])}return t}).apply(this,arguments)}function _typeof(t){return(_typeof="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(t){return typeof t}:function(t){return t&&"function"==typeof Symbol&&t.constructor===Symbol&&t!==Symbol.prototype?"symbol":typeof t})(t)}!function(t,e){"object"===("undefined"==typeof exports?"undefined":_typeof(exports))&&"undefined"!=typeof module?module.exports=e():"function"==typeof define&&define.amd?define(e):t.LazyLoad=e()}(this,function(){"use strict";var t="undefined"!=typeof window,e=t&&!("onscroll"in window)||"undefined"!=typeof navigator&&/(gle|ing|ro)bot|crawl|spider/i.test(navigator.userAgent),n=t&&"IntersectionObserver"in window,o=t&&"classList"in document.createElement("p"),r={elements_selector:"img",container:e||t?document:null,threshold:300,thresholds:null,data_src:"src",data_srcset:"srcset",data_sizes:"sizes",data_bg:"bg",class_loading:"loading",class_loaded:"loaded",class_error:"error",load_delay:0,auto_unobserve:!0,callback_enter:null,callback_exit:null,callback_reveal:null,callback_loaded:null,callback_error:null,callback_finish:null},a=function(t,e){return t.getAttribute("data-"+e)},s=function(t,e,n){var o="data-"+e;null!==n?t.setAttribute(o,n):t.removeAttribute(o)},i=function(t){return"true"===a(t,"was-processed")},c=function(t,e){return s(t,"ll-timeout",e)},l=function(t){return a(t,"ll-timeout")},u=function(t,e){var n,o=new t(e);try{n=new CustomEvent("LazyLoad::Initialized",{detail:{instance:o}})}catch(t){(n=document.createEvent("CustomEvent")).initCustomEvent("LazyLoad::Initialized",!1,!1,{instance:o})}window.dispatchEvent(n)};var d=function(t,e){t&&t(e)},f=function(t,e){t._loadingCount+=e,0===t._elements.length&&0===t._loadingCount&&d(t._settings.callback_finish)},_=function(t){for(var e,n=[],o=0;e=t.children[o];o+=1)"SOURCE"===e.tagName&&n.push(e);return n},v=function(t,e,n){n&&t.setAttribute(e,n)},b=function(t,e){v(t,"sizes",a(t,e.data_sizes)),v(t,"srcset",a(t,e.data_srcset)),v(t,"src",a(t,e.data_src))},g={IMG:function(t,e){var n=t.parentNode;n&&"PICTURE"===n.tagName&&_(n).forEach(function(t){b(t,e)});b(t,e)},IFRAME:function(t,e){v(t,"src",a(t,e.data_src))},VIDEO:function(t,e){_(t).forEach(function(t){v(t,"src",a(t,e.data_src))}),v(t,"src",a(t,e.data_src)),t.load()}},m=function(t,e){var n,o,r=e._settings,s=t.tagName,i=g[s];if(i)return i(t,r),f(e,1),void(e._elements=(n=e._elements,o=t,n.filter(function(t){return t!==o})));!function(t,e){var n=a(t,e.data_src),o=a(t,e.data_bg);n&&(t.style.backgroundImage='url("'.concat(n,'")')),o&&(t.style.backgroundImage=o)}(t,r)},h=function(t,e){o?t.classList.add(e):t.className+=(t.className?" ":"")+e},p=function(t,e,n){t.addEventListener(e,n)},y=function(t,e,n){t.removeEventListener(e,n)},E=function(t,e,n){y(t,"load",e),y(t,"loadeddata",e),y(t,"error",n)},w=function(t,e,n){var r=n._settings,a=e?r.class_loaded:r.class_error,s=e?r.callback_loaded:r.callback_error,i=t.target;!function(t,e){o?t.classList.remove(e):t.className=t.className.replace(new RegExp("(^|\\s+)"+e+"(\\s+|$)")," ").replace(/^\s+/,"").replace(/\s+$/,"")}(i,r.class_loading),h(i,a),d(s,i),f(n,-1)},k=function(t,e){var n=function n(r){w(r,!0,e),E(t,n,o)},o=function o(r){w(r,!1,e),E(t,n,o)};!function(t,e,n){p(t,"load",e),p(t,"loadeddata",e),p(t,"error",n)}(t,n,o)},I=["IMG","IFRAME","VIDEO"],L=function(t,e){var n=e._observer;z(t,e),n&&e._settings.auto_unobserve&&n.unobserve(t)},x=function(t){var e=l(t);e&&(clearTimeout(e),c(t,null))},A=function(t,e){var n=e._settings.load_delay,o=l(t);o||(o=setTimeout(function(){L(t,e),x(t)},n),c(t,o))},z=function(t,e,n){var o=e._settings;!n&&i(t)||(I.indexOf(t.tagName)>-1&&(k(t,e),h(t,o.class_loading)),m(t,e),function(t){s(t,"was-processed","true")}(t),d(o.callback_reveal,t),d(o.callback_set,t))},O=function(t){return!!n&&(t._observer=new IntersectionObserver(function(e){e.forEach(function(e){return function(t){return t.isIntersecting||t.intersectionRatio>0}(e)?function(t,e){var n=e._settings;d(n.callback_enter,t),n.load_delay?A(t,e):L(t,e)}(e.target,t):function(t,e){var n=e._settings;d(n.callback_exit,t),n.load_delay&&x(t)}(e.target,t)})},{root:(e=t._settings).container===document?null:e.container,rootMargin:e.thresholds||e.threshold+"px"}),!0);var e},N=function(t,e){this._settings=function(t){return _extends({},r,t)}(t),this._loadingCount=0,O(this),this.update(e)};return N.prototype={update:function(t){var n=this,o=this._settings,r=t||o.container.querySelectorAll(o.elements_selector);this._elements=function(t){return t.filter(function(t){return!i(t)})}(Array.prototype.slice.call(r)),!e&&this._observer?this._elements.forEach(function(t){n._observer.observe(t)}):this.loadAll()},destroy:function(){var t=this;this._observer&&(this._elements.forEach(function(e){t._observer.unobserve(e)}),this._observer=null),this._elements=null,this._settings=null},load:function(t,e){z(t,this,e)},loadAll:function(){var t=this;this._elements.forEach(function(e){L(e,t)})}},t&&function(t,e){if(e)if(e.length)for(var n,o=0;n=e[o];o+=1)u(t,n);else u(t,e)}(N,window.lazyLoadOptions),N});
/**
 * Owl Carousel v2.3.4
 * Copyright 2013-2018 David Deutsch
 * Licensed under: SEE LICENSE IN https://github.com/OwlCarousel2/OwlCarousel2/blob/master/LICENSE
 */
!function(h,i,n,a){function l(t,e){this.settings=null,this.options=h.extend({},l.Defaults,e),this.$element=h(t),this._handlers={},this._plugins={},this._supress={},this._current=null,this._speed=null,this._coordinates=[],this._breakpoint=null,this._width=null,this._items=[],this._clones=[],this._mergers=[],this._widths=[],this._invalidated={},this._pipe=[],this._drag={time:null,target:null,pointer:null,stage:{start:null,current:null},direction:null},this._states={current:{},tags:{initializing:["busy"],animating:["busy"],dragging:["interacting"]}},h.each(["onResize","onThrottledResize"],h.proxy(function(t,e){this._handlers[e]=h.proxy(this[e],this)},this)),h.each(l.Plugins,h.proxy(function(t,e){this._plugins[t.charAt(0).toLowerCase()+t.slice(1)]=new e(this)},this)),h.each(l.Workers,h.proxy(function(t,e){this._pipe.push({filter:e.filter,run:h.proxy(e.run,this)})},this)),this.setup(),this.initialize()}l.Defaults={items:3,loop:!1,center:!1,rewind:!1,checkVisibility:!0,mouseDrag:!0,touchDrag:!0,pullDrag:!0,freeDrag:!1,margin:0,stagePadding:0,merge:!1,mergeFit:!0,autoWidth:!1,startPosition:0,rtl:!1,smartSpeed:250,fluidSpeed:!1,dragEndSpeed:!1,responsive:{},responsiveRefreshRate:200,responsiveBaseElement:i,fallbackEasing:"swing",slideTransition:"",info:!1,nestedItemSelector:!1,itemElement:"div",stageElement:"div",refreshClass:"owl-refresh",loadedClass:"owl-loaded",loadingClass:"owl-loading",rtlClass:"owl-rtl",responsiveClass:"owl-responsive",dragClass:"owl-drag",itemClass:"owl-item",stageClass:"owl-stage",stageOuterClass:"owl-stage-outer",grabClass:"owl-grab"},l.Width={Default:"default",Inner:"inner",Outer:"outer"},l.Type={Event:"event",State:"state"},l.Plugins={},l.Workers=[{filter:["width","settings"],run:function(){this._width=this.$element.width()}},{filter:["width","items","settings"],run:function(t){t.current=this._items&&this._items[this.relative(this._current)]}},{filter:["items","settings"],run:function(){this.$stage.children(".cloned").remove()}},{filter:["width","items","settings"],run:function(t){var e=this.settings.margin||"",i=!this.settings.autoWidth,s=this.settings.rtl,n={width:"auto","margin-left":s?e:"","margin-right":s?"":e};!i&&this.$stage.children().css(n),t.css=n}},{filter:["width","items","settings"],run:function(t){var e=(this.width()/this.settings.items).toFixed(3)-this.settings.margin,i=null,s=this._items.length,n=!this.settings.autoWidth,o=[];for(t.items={merge:!1,width:e};s--;)i=this._mergers[s],i=this.settings.mergeFit&&Math.min(i,this.settings.items)||i,t.items.merge=1<i||t.items.merge,o[s]=n?e*i:this._items[s].width();this._widths=o}},{filter:["items","settings"],run:function(){var t=[],e=this._items,i=this.settings,s=Math.max(2*i.items,4),n=2*Math.ceil(e.length/2),o=i.loop&&e.length?i.rewind?s:Math.max(s,n):0,r="",a="";for(o/=2;0<o;)t.push(this.normalize(t.length/2,!0)),r+=e[t[t.length-1]][0].outerHTML,t.push(this.normalize(e.length-1-(t.length-1)/2,!0)),a=e[t[t.length-1]][0].outerHTML+a,o-=1;this._clones=t,h(r).addClass("cloned").appendTo(this.$stage),h(a).addClass("cloned").prependTo(this.$stage)}},{filter:["width","items","settings"],run:function(){for(var t=this.settings.rtl?1:-1,e=this._clones.length+this._items.length,i=-1,s=0,n=0,o=[];++i<e;)s=o[i-1]||0,n=this._widths[this.relative(i)]+this.settings.margin,o.push(s+n*t);this._coordinates=o}},{filter:["width","items","settings"],run:function(){var t=this.settings.stagePadding,e=this._coordinates,i={width:Math.ceil(Math.abs(e[e.length-1]))+2*t,"padding-left":t||"","padding-right":t||""};this.$stage.css(i)}},{filter:["width","items","settings"],run:function(t){var e=this._coordinates.length,i=!this.settings.autoWidth,s=this.$stage.children();if(i&&t.items.merge)for(;e--;)t.css.width=this._widths[this.relative(e)],s.eq(e).css(t.css);else i&&(t.css.width=t.items.width,s.css(t.css))}},{filter:["items"],run:function(){this._coordinates.length<1&&this.$stage.removeAttr("style")}},{filter:["width","items","settings"],run:function(t){t.current=t.current?this.$stage.children().index(t.current):0,t.current=Math.max(this.minimum(),Math.min(this.maximum(),t.current)),this.reset(t.current)}},{filter:["position"],run:function(){this.animate(this.coordinates(this._current))}},{filter:["width","position","items","settings"],run:function(){var t,e,i,s,n=this.settings.rtl?1:-1,o=2*this.settings.stagePadding,r=this.coordinates(this.current())+o,a=r+this.width()*n,h=[];for(i=0,s=this._coordinates.length;i<s;i++)t=this._coordinates[i-1]||0,e=Math.abs(this._coordinates[i])+o*n,(this.op(t,"<=",r)&&this.op(t,">",a)||this.op(e,"<",r)&&this.op(e,">",a))&&h.push(i);this.$stage.children(".active").removeClass("active"),this.$stage.children(":eq("+h.join("), :eq(")+")").addClass("active"),this.$stage.children(".center").removeClass("center"),this.settings.center&&this.$stage.children().eq(this.current()).addClass("center")}}],l.prototype.initializeStage=function(){this.$stage=this.$element.find("."+this.settings.stageClass),this.$stage.length||(this.$element.addClass(this.options.loadingClass),this.$stage=h("<"+this.settings.stageElement+">",{class:this.settings.stageClass}).wrap(h("<div/>",{class:this.settings.stageOuterClass})),this.$element.append(this.$stage.parent()))},l.prototype.initializeItems=function(){var t=this.$element.find(".owl-item");if(t.length)return this._items=t.get().map(function(t){return h(t)}),this._mergers=this._items.map(function(){return 1}),void this.refresh();this.replace(this.$element.children().not(this.$stage.parent())),this.isVisible()?this.refresh():this.invalidate("width"),this.$element.removeClass(this.options.loadingClass).addClass(this.options.loadedClass)},l.prototype.initialize=function(){var t,e,i;(this.enter("initializing"),this.trigger("initialize"),this.$element.toggleClass(this.settings.rtlClass,this.settings.rtl),this.settings.autoWidth&&!this.is("pre-loading"))&&(t=this.$element.find("img"),e=this.settings.nestedItemSelector?"."+this.settings.nestedItemSelector:a,i=this.$element.children(e).width(),t.length&&i<=0&&this.preloadAutoWidthImages(t));this.initializeStage(),this.initializeItems(),this.registerEventHandlers(),this.leave("initializing"),this.trigger("initialized")},l.prototype.isVisible=function(){return!this.settings.checkVisibility||this.$element.is(":visible")},l.prototype.setup=function(){var e=this.viewport(),t=this.options.responsive,i=-1,s=null;t?(h.each(t,function(t){t<=e&&i<t&&(i=Number(t))}),"function"==typeof(s=h.extend({},this.options,t[i])).stagePadding&&(s.stagePadding=s.stagePadding()),delete s.responsive,s.responsiveClass&&this.$element.attr("class",this.$element.attr("class").replace(new RegExp("("+this.options.responsiveClass+"-)\\S+\\s","g"),"$1"+i))):s=h.extend({},this.options),this.trigger("change",{property:{name:"settings",value:s}}),this._breakpoint=i,this.settings=s,this.invalidate("settings"),this.trigger("changed",{property:{name:"settings",value:this.settings}})},l.prototype.optionsLogic=function(){this.settings.autoWidth&&(this.settings.stagePadding=!1,this.settings.merge=!1)},l.prototype.prepare=function(t){var e=this.trigger("prepare",{content:t});return e.data||(e.data=h("<"+this.settings.itemElement+"/>").addClass(this.options.itemClass).append(t)),this.trigger("prepared",{content:e.data}),e.data},l.prototype.update=function(){for(var t=0,e=this._pipe.length,i=h.proxy(function(t){return this[t]},this._invalidated),s={};t<e;)(this._invalidated.all||0<h.grep(this._pipe[t].filter,i).length)&&this._pipe[t].run(s),t++;this._invalidated={},!this.is("valid")&&this.enter("valid")},l.prototype.width=function(t){switch(t=t||l.Width.Default){case l.Width.Inner:case l.Width.Outer:return this._width;default:return this._width-2*this.settings.stagePadding+this.settings.margin}},l.prototype.refresh=function(){this.enter("refreshing"),this.trigger("refresh"),this.setup(),this.optionsLogic(),this.$element.addClass(this.options.refreshClass),this.update(),this.$element.removeClass(this.options.refreshClass),this.leave("refreshing"),this.trigger("refreshed")},l.prototype.onThrottledResize=function(){i.clearTimeout(this.resizeTimer),this.resizeTimer=i.setTimeout(this._handlers.onResize,this.settings.responsiveRefreshRate)},l.prototype.onResize=function(){return!!this._items.length&&this._width!==this.$element.width()&&!!this.isVisible()&&(this.enter("resizing"),this.trigger("resize").isDefaultPrevented()?(this.leave("resizing"),!1):(this.invalidate("width"),this.refresh(),this.leave("resizing"),void this.trigger("resized")))},l.prototype.registerEventHandlers=function(){h.support.transition&&this.$stage.on(h.support.transition.end+".owl.core",h.proxy(this.onTransitionEnd,this)),!1!==this.settings.responsive&&this.on(i,"resize",this._handlers.onThrottledResize),this.settings.mouseDrag&&(this.$element.addClass(this.options.dragClass),this.$stage.on("mousedown.owl.core",h.proxy(this.onDragStart,this)),this.$stage.on("dragstart.owl.core selectstart.owl.core",function(){return!1})),this.settings.touchDrag&&(this.$stage.on("touchstart.owl.core",h.proxy(this.onDragStart,this)),this.$stage.on("touchcancel.owl.core",h.proxy(this.onDragEnd,this)))},l.prototype.onDragStart=function(t){var e=null;3!==t.which&&(h.support.transform?e={x:(e=this.$stage.css("transform").replace(/.*\(|\)| /g,"").split(","))[16===e.length?12:4],y:e[16===e.length?13:5]}:(e=this.$stage.position(),e={x:this.settings.rtl?e.left+this.$stage.width()-this.width()+this.settings.margin:e.left,y:e.top}),this.is("animating")&&(h.support.transform?this.animate(e.x):this.$stage.stop(),this.invalidate("position")),this.$element.toggleClass(this.options.grabClass,"mousedown"===t.type),this.speed(0),this._drag.time=(new Date).getTime(),this._drag.target=h(t.target),this._drag.stage.start=e,this._drag.stage.current=e,this._drag.pointer=this.pointer(t),h(n).on("mouseup.owl.core touchend.owl.core",h.proxy(this.onDragEnd,this)),h(n).one("mousemove.owl.core touchmove.owl.core",h.proxy(function(t){var e=this.difference(this._drag.pointer,this.pointer(t));h(n).on("mousemove.owl.core touchmove.owl.core",h.proxy(this.onDragMove,this)),Math.abs(e.x)<Math.abs(e.y)&&this.is("valid")||(t.preventDefault(),this.enter("dragging"),this.trigger("drag"))},this)))},l.prototype.onDragMove=function(t){var e=null,i=null,s=null,n=this.difference(this._drag.pointer,this.pointer(t)),o=this.difference(this._drag.stage.start,n);this.is("dragging")&&(t.preventDefault(),this.settings.loop?(e=this.coordinates(this.minimum()),i=this.coordinates(this.maximum()+1)-e,o.x=((o.x-e)%i+i)%i+e):(e=this.settings.rtl?this.coordinates(this.maximum()):this.coordinates(this.minimum()),i=this.settings.rtl?this.coordinates(this.minimum()):this.coordinates(this.maximum()),s=this.settings.pullDrag?-1*n.x/5:0,o.x=Math.max(Math.min(o.x,e+s),i+s)),this._drag.stage.current=o,this.animate(o.x))},l.prototype.onDragEnd=function(t){var e=this.difference(this._drag.pointer,this.pointer(t)),i=this._drag.stage.current,s=0<e.x^this.settings.rtl?"left":"right";h(n).off(".owl.core"),this.$element.removeClass(this.options.grabClass),(0!==e.x&&this.is("dragging")||!this.is("valid"))&&(this.speed(this.settings.dragEndSpeed||this.settings.smartSpeed),this.current(this.closest(i.x,0!==e.x?s:this._drag.direction)),this.invalidate("position"),this.update(),this._drag.direction=s,(3<Math.abs(e.x)||300<(new Date).getTime()-this._drag.time)&&this._drag.target.one("click.owl.core",function(){return!1})),this.is("dragging")&&(this.leave("dragging"),this.trigger("dragged"))},l.prototype.closest=function(i,s){var n=-1,o=this.width(),r=this.coordinates();return this.settings.freeDrag||h.each(r,h.proxy(function(t,e){return"left"===s&&e-30<i&&i<e+30?n=t:"right"===s&&e-o-30<i&&i<e-o+30?n=t+1:this.op(i,"<",e)&&this.op(i,">",r[t+1]!==a?r[t+1]:e-o)&&(n="left"===s?t+1:t),-1===n},this)),this.settings.loop||(this.op(i,">",r[this.minimum()])?n=i=this.minimum():this.op(i,"<",r[this.maximum()])&&(n=i=this.maximum())),n},l.prototype.animate=function(t){var e=0<this.speed();this.is("animating")&&this.onTransitionEnd(),e&&(this.enter("animating"),this.trigger("translate")),h.support.transform3d&&h.support.transition?this.$stage.css({transform:"translate3d("+t+"px,0px,0px)",transition:this.speed()/1e3+"s"+(this.settings.slideTransition?" "+this.settings.slideTransition:"")}):e?this.$stage.animate({left:t+"px"},this.speed(),this.settings.fallbackEasing,h.proxy(this.onTransitionEnd,this)):this.$stage.css({left:t+"px"})},l.prototype.is=function(t){return this._states.current[t]&&0<this._states.current[t]},l.prototype.current=function(t){if(t===a)return this._current;if(0===this._items.length)return a;if(t=this.normalize(t),this._current!==t){var e=this.trigger("change",{property:{name:"position",value:t}});e.data!==a&&(t=this.normalize(e.data)),this._current=t,this.invalidate("position"),this.trigger("changed",{property:{name:"position",value:this._current}})}return this._current},l.prototype.invalidate=function(t){return"string"===h.type(t)&&(this._invalidated[t]=!0,this.is("valid")&&this.leave("valid")),h.map(this._invalidated,function(t,e){return e})},l.prototype.reset=function(t){(t=this.normalize(t))!==a&&(this._speed=0,this._current=t,this.suppress(["translate","translated"]),this.animate(this.coordinates(t)),this.release(["translate","translated"]))},l.prototype.normalize=function(t,e){var i=this._items.length,s=e?0:this._clones.length;return!this.isNumeric(t)||i<1?t=a:(t<0||i+s<=t)&&(t=((t-s/2)%i+i)%i+s/2),t},l.prototype.relative=function(t){return t-=this._clones.length/2,this.normalize(t,!0)},l.prototype.maximum=function(t){var e,i,s,n=this.settings,o=this._coordinates.length;if(n.loop)o=this._clones.length/2+this._items.length-1;else if(n.autoWidth||n.merge){if(e=this._items.length)for(i=this._items[--e].width(),s=this.$element.width();e--&&!((i+=this._items[e].width()+this.settings.margin)>s););o=e+1}else o=n.center?this._items.length-1:this._items.length-n.items;return t&&(o-=this._clones.length/2),Math.max(o,0)},l.prototype.minimum=function(t){return t?0:this._clones.length/2},l.prototype.items=function(t){return t===a?this._items.slice():(t=this.normalize(t,!0),this._items[t])},l.prototype.mergers=function(t){return t===a?this._mergers.slice():(t=this.normalize(t,!0),this._mergers[t])},l.prototype.clones=function(i){var e=this._clones.length/2,s=e+this._items.length,n=function(t){return t%2==0?s+t/2:e-(t+1)/2};return i===a?h.map(this._clones,function(t,e){return n(e)}):h.map(this._clones,function(t,e){return t===i?n(e):null})},l.prototype.speed=function(t){return t!==a&&(this._speed=t),this._speed},l.prototype.coordinates=function(t){var e,i=1,s=t-1;return t===a?h.map(this._coordinates,h.proxy(function(t,e){return this.coordinates(e)},this)):(this.settings.center?(this.settings.rtl&&(i=-1,s=t+1),e=this._coordinates[t],e+=(this.width()-e+(this._coordinates[s]||0))/2*i):e=this._coordinates[s]||0,e=Math.ceil(e))},l.prototype.duration=function(t,e,i){return 0===i?0:Math.min(Math.max(Math.abs(e-t),1),6)*Math.abs(i||this.settings.smartSpeed)},l.prototype.to=function(t,e){var i=this.current(),s=null,n=t-this.relative(i),o=(0<n)-(n<0),r=this._items.length,a=this.minimum(),h=this.maximum();this.settings.loop?(!this.settings.rewind&&Math.abs(n)>r/2&&(n+=-1*o*r),(s=(((t=i+n)-a)%r+r)%r+a)!==t&&s-n<=h&&0<s-n&&(i=s-n,t=s,this.reset(i))):this.settings.rewind?t=(t%(h+=1)+h)%h:t=Math.max(a,Math.min(h,t)),this.speed(this.duration(i,t,e)),this.current(t),this.isVisible()&&this.update()},l.prototype.next=function(t){t=t||!1,this.to(this.relative(this.current())+1,t)},l.prototype.prev=function(t){t=t||!1,this.to(this.relative(this.current())-1,t)},l.prototype.onTransitionEnd=function(t){if(t!==a&&(t.stopPropagation(),(t.target||t.srcElement||t.originalTarget)!==this.$stage.get(0)))return!1;this.leave("animating"),this.trigger("translated")},l.prototype.viewport=function(){var t;return this.options.responsiveBaseElement!==i?t=h(this.options.responsiveBaseElement).width():i.innerWidth?t=i.innerWidth:n.documentElement&&n.documentElement.clientWidth?t=n.documentElement.clientWidth:console.warn("Can not detect viewport width."),t},l.prototype.replace=function(t){this.$stage.empty(),this._items=[],t&&(t=t instanceof jQuery?t:h(t)),this.settings.nestedItemSelector&&(t=t.find("."+this.settings.nestedItemSelector)),t.filter(function(){return 1===this.nodeType}).each(h.proxy(function(t,e){e=this.prepare(e),this.$stage.append(e),this._items.push(e),this._mergers.push(1*e.find("[data-merge]").addBack("[data-merge]").attr("data-merge")||1)},this)),this.reset(this.isNumeric(this.settings.startPosition)?this.settings.startPosition:0),this.invalidate("items")},l.prototype.add=function(t,e){var i=this.relative(this._current);e=e===a?this._items.length:this.normalize(e,!0),t=t instanceof jQuery?t:h(t),this.trigger("add",{content:t,position:e}),t=this.prepare(t),0===this._items.length||e===this._items.length?(0===this._items.length&&this.$stage.append(t),0!==this._items.length&&this._items[e-1].after(t),this._items.push(t),this._mergers.push(1*t.find("[data-merge]").addBack("[data-merge]").attr("data-merge")||1)):(this._items[e].before(t),this._items.splice(e,0,t),this._mergers.splice(e,0,1*t.find("[data-merge]").addBack("[data-merge]").attr("data-merge")||1)),this._items[i]&&this.reset(this._items[i].index()),this.invalidate("items"),this.trigger("added",{content:t,position:e})},l.prototype.remove=function(t){(t=this.normalize(t,!0))!==a&&(this.trigger("remove",{content:this._items[t],position:t}),this._items[t].remove(),this._items.splice(t,1),this._mergers.splice(t,1),this.invalidate("items"),this.trigger("removed",{content:null,position:t}))},l.prototype.preloadAutoWidthImages=function(t){t.each(h.proxy(function(t,e){this.enter("pre-loading"),e=h(e),h(new Image).one("load",h.proxy(function(t){e.attr("src",t.target.src),e.css("opacity",1),this.leave("pre-loading"),!this.is("pre-loading")&&!this.is("initializing")&&this.refresh()},this)).attr("src",e.attr("src")||e.attr("data-src")||e.attr("data-src-retina"))},this))},l.prototype.destroy=function(){for(var t in this.$element.off(".owl.core"),this.$stage.off(".owl.core"),h(n).off(".owl.core"),!1!==this.settings.responsive&&(i.clearTimeout(this.resizeTimer),this.off(i,"resize",this._handlers.onThrottledResize)),this._plugins)this._plugins[t].destroy();this.$stage.children(".cloned").remove(),this.$stage.unwrap(),this.$stage.children().contents().unwrap(),this.$stage.children().unwrap(),this.$stage.remove(),this.$element.removeClass(this.options.refreshClass).removeClass(this.options.loadingClass).removeClass(this.options.loadedClass).removeClass(this.options.rtlClass).removeClass(this.options.dragClass).removeClass(this.options.grabClass).attr("class",this.$element.attr("class").replace(new RegExp(this.options.responsiveClass+"-\\S+\\s","g"),"")).removeData("owl.carousel")},l.prototype.op=function(t,e,i){var s=this.settings.rtl;switch(e){case"<":return s?i<t:t<i;case">":return s?t<i:i<t;case">=":return s?t<=i:i<=t;case"<=":return s?i<=t:t<=i}},l.prototype.on=function(t,e,i,s){t.addEventListener?t.addEventListener(e,i,s):t.attachEvent&&t.attachEvent("on"+e,i)},l.prototype.off=function(t,e,i,s){t.removeEventListener?t.removeEventListener(e,i,s):t.detachEvent&&t.detachEvent("on"+e,i)},l.prototype.trigger=function(t,e,i,s,n){var o={item:{count:this._items.length,index:this.current()}},r=h.camelCase(h.grep(["on",t,i],function(t){return t}).join("-").toLowerCase()),a=h.Event([t,"owl",i||"carousel"].join(".").toLowerCase(),h.extend({relatedTarget:this},o,e));return this._supress[t]||(h.each(this._plugins,function(t,e){e.onTrigger&&e.onTrigger(a)}),this.register({type:l.Type.Event,name:t}),this.$element.trigger(a),this.settings&&"function"==typeof this.settings[r]&&this.settings[r].call(this,a)),a},l.prototype.enter=function(t){h.each([t].concat(this._states.tags[t]||[]),h.proxy(function(t,e){this._states.current[e]===a&&(this._states.current[e]=0),this._states.current[e]++},this))},l.prototype.leave=function(t){h.each([t].concat(this._states.tags[t]||[]),h.proxy(function(t,e){this._states.current[e]--},this))},l.prototype.register=function(i){if(i.type===l.Type.Event){if(h.event.special[i.name]||(h.event.special[i.name]={}),!h.event.special[i.name].owl){var e=h.event.special[i.name]._default;h.event.special[i.name]._default=function(t){return!e||!e.apply||t.namespace&&-1!==t.namespace.indexOf("owl")?t.namespace&&-1<t.namespace.indexOf("owl"):e.apply(this,arguments)},h.event.special[i.name].owl=!0}}else i.type===l.Type.State&&(this._states.tags[i.name]?this._states.tags[i.name]=this._states.tags[i.name].concat(i.tags):this._states.tags[i.name]=i.tags,this._states.tags[i.name]=h.grep(this._states.tags[i.name],h.proxy(function(t,e){return h.inArray(t,this._states.tags[i.name])===e},this)))},l.prototype.suppress=function(t){h.each(t,h.proxy(function(t,e){this._supress[e]=!0},this))},l.prototype.release=function(t){h.each(t,h.proxy(function(t,e){delete this._supress[e]},this))},l.prototype.pointer=function(t){var e={x:null,y:null};return(t=(t=t.originalEvent||t||i.event).touches&&t.touches.length?t.touches[0]:t.changedTouches&&t.changedTouches.length?t.changedTouches[0]:t).pageX?(e.x=t.pageX,e.y=t.pageY):(e.x=t.clientX,e.y=t.clientY),e},l.prototype.isNumeric=function(t){return!isNaN(parseFloat(t))},l.prototype.difference=function(t,e){return{x:t.x-e.x,y:t.y-e.y}},h.fn.owlCarousel=function(e){var s=Array.prototype.slice.call(arguments,1);return this.each(function(){var t=h(this),i=t.data("owl.carousel");i||(i=new l(this,"object"==typeof e&&e),t.data("owl.carousel",i),h.each(["next","prev","to","destroy","refresh","replace","add","remove"],function(t,e){i.register({type:l.Type.Event,name:e}),i.$element.on(e+".owl.carousel.core",h.proxy(function(t){t.namespace&&t.relatedTarget!==this&&(this.suppress([e]),i[e].apply(this,[].slice.call(arguments,1)),this.release([e]))},i))})),"string"==typeof e&&"_"!==e.charAt(0)&&i[e].apply(i,s)})},h.fn.owlCarousel.Constructor=l}(window.Zepto||window.jQuery,window,document),function(e,i,t,s){var n=function(t){this._core=t,this._interval=null,this._visible=null,this._handlers={"initialized.owl.carousel":e.proxy(function(t){t.namespace&&this._core.settings.autoRefresh&&this.watch()},this)},this._core.options=e.extend({},n.Defaults,this._core.options),this._core.$element.on(this._handlers)};n.Defaults={autoRefresh:!0,autoRefreshInterval:500},n.prototype.watch=function(){this._interval||(this._visible=this._core.isVisible(),this._interval=i.setInterval(e.proxy(this.refresh,this),this._core.settings.autoRefreshInterval))},n.prototype.refresh=function(){this._core.isVisible()!==this._visible&&(this._visible=!this._visible,this._core.$element.toggleClass("owl-hidden",!this._visible),this._visible&&this._core.invalidate("width")&&this._core.refresh())},n.prototype.destroy=function(){var t,e;for(t in i.clearInterval(this._interval),this._handlers)this._core.$element.off(t,this._handlers[t]);for(e in Object.getOwnPropertyNames(this))"function"!=typeof this[e]&&(this[e]=null)},e.fn.owlCarousel.Constructor.Plugins.AutoRefresh=n}(window.Zepto||window.jQuery,window,document),function(a,o,t,e){var i=function(t){this._core=t,this._loaded=[],this._handlers={"initialized.owl.carousel change.owl.carousel resized.owl.carousel":a.proxy(function(t){if(t.namespace&&this._core.settings&&this._core.settings.lazyLoad&&(t.property&&"position"==t.property.name||"initialized"==t.type)){var e=this._core.settings,i=e.center&&Math.ceil(e.items/2)||e.items,s=e.center&&-1*i||0,n=(t.property&&void 0!==t.property.value?t.property.value:this._core.current())+s,o=this._core.clones().length,r=a.proxy(function(t,e){this.load(e)},this);for(0<e.lazyLoadEager&&(i+=e.lazyLoadEager,e.loop&&(n-=e.lazyLoadEager,i++));s++<i;)this.load(o/2+this._core.relative(n)),o&&a.each(this._core.clones(this._core.relative(n)),r),n++}},this)},this._core.options=a.extend({},i.Defaults,this._core.options),this._core.$element.on(this._handlers)};i.Defaults={lazyLoad:!1,lazyLoadEager:0},i.prototype.load=function(t){var e=this._core.$stage.children().eq(t),i=e&&e.find(".owl-lazy");!i||-1<a.inArray(e.get(0),this._loaded)||(i.each(a.proxy(function(t,e){var i,s=a(e),n=1<o.devicePixelRatio&&s.attr("data-src-retina")||s.attr("data-src")||s.attr("data-srcset");this._core.trigger("load",{element:s,url:n},"lazy"),s.is("img")?s.one("load.owl.lazy",a.proxy(function(){s.css("opacity",1),this._core.trigger("loaded",{element:s,url:n},"lazy")},this)).attr("src",n):s.is("source")?s.one("load.owl.lazy",a.proxy(function(){this._core.trigger("loaded",{element:s,url:n},"lazy")},this)).attr("srcset",n):((i=new Image).onload=a.proxy(function(){s.css({"background-image":'url("'+n+'")',opacity:"1"}),this._core.trigger("loaded",{element:s,url:n},"lazy")},this),i.src=n)},this)),this._loaded.push(e.get(0)))},i.prototype.destroy=function(){var t,e;for(t in this.handlers)this._core.$element.off(t,this.handlers[t]);for(e in Object.getOwnPropertyNames(this))"function"!=typeof this[e]&&(this[e]=null)},a.fn.owlCarousel.Constructor.Plugins.Lazy=i}(window.Zepto||window.jQuery,window,document),function(r,i,t,e){var s=function(t){this._core=t,this._previousHeight=null,this._handlers={"initialized.owl.carousel refreshed.owl.carousel":r.proxy(function(t){t.namespace&&this._core.settings.autoHeight&&this.update()},this),"changed.owl.carousel":r.proxy(function(t){t.namespace&&this._core.settings.autoHeight&&"position"===t.property.name&&this.update()},this),"loaded.owl.lazy":r.proxy(function(t){t.namespace&&this._core.settings.autoHeight&&t.element.closest("."+this._core.settings.itemClass).index()===this._core.current()&&this.update()},this)},this._core.options=r.extend({},s.Defaults,this._core.options),this._core.$element.on(this._handlers),this._intervalId=null;var e=this;r(i).on("load",function(){e._core.settings.autoHeight&&e.update()}),r(i).resize(function(){e._core.settings.autoHeight&&(null!=e._intervalId&&clearTimeout(e._intervalId),e._intervalId=setTimeout(function(){e.update()},250))})};s.Defaults={autoHeight:!1,autoHeightClass:"owl-height"},s.prototype.update=function(){var t=this._core._current,e=t+this._core.settings.items,i=this._core.settings.lazyLoad,s=this._core.$stage.children().toArray().slice(t,e),n=[],o=0;r.each(s,function(t,e){n.push(r(e).height())}),(o=Math.max.apply(null,n))<=1&&i&&this._previousHeight&&(o=this._previousHeight),this._previousHeight=o,this._core.$stage.parent().height(o).addClass(this._core.settings.autoHeightClass)},s.prototype.destroy=function(){var t,e;for(t in this._handlers)this._core.$element.off(t,this._handlers[t]);for(e in Object.getOwnPropertyNames(this))"function"!=typeof this[e]&&(this[e]=null)},r.fn.owlCarousel.Constructor.Plugins.AutoHeight=s}(window.Zepto||window.jQuery,window,document),function(c,t,e,i){var s=function(t){this._core=t,this._videos={},this._playing=null,this._handlers={"initialized.owl.carousel":c.proxy(function(t){t.namespace&&this._core.register({type:"state",name:"playing",tags:["interacting"]})},this),"resize.owl.carousel":c.proxy(function(t){t.namespace&&this._core.settings.video&&this.isInFullScreen()&&t.preventDefault()},this),"refreshed.owl.carousel":c.proxy(function(t){t.namespace&&this._core.is("resizing")&&this._core.$stage.find(".cloned .owl-video-frame").remove()},this),"changed.owl.carousel":c.proxy(function(t){t.namespace&&"position"===t.property.name&&this._playing&&this.stop()},this),"prepared.owl.carousel":c.proxy(function(t){if(t.namespace){var e=c(t.content).find(".owl-video");e.length&&(e.css("display","none"),this.fetch(e,c(t.content)))}},this)},this._core.options=c.extend({},s.Defaults,this._core.options),this._core.$element.on(this._handlers),this._core.$element.on("click.owl.video",".owl-video-play-icon",c.proxy(function(t){this.play(t)},this))};s.Defaults={video:!1,videoHeight:!1,videoWidth:!1},s.prototype.fetch=function(t,e){var i=t.attr("data-vimeo-id")?"vimeo":t.attr("data-vzaar-id")?"vzaar":"youtube",s=t.attr("data-vimeo-id")||t.attr("data-youtube-id")||t.attr("data-vzaar-id"),n=t.attr("data-width")||this._core.settings.videoWidth,o=t.attr("data-height")||this._core.settings.videoHeight,r=t.attr("href");if(!r)throw new Error("Missing video URL.");if(-1<(s=r.match(/(http:|https:|)\/\/(player.|www.|app.)?(vimeo\.com|youtu(be\.com|\.be|be\.googleapis\.com|be\-nocookie\.com)|vzaar\.com)\/(video\/|videos\/|embed\/|channels\/.+\/|groups\/.+\/|watch\?v=|v\/)?([A-Za-z0-9._%-]*)(\&\S+)?/))[3].indexOf("youtu"))i="youtube";else if(-1<s[3].indexOf("vimeo"))i="vimeo";else{if(!(-1<s[3].indexOf("vzaar")))throw new Error("Video URL not supported.");i="vzaar"}s=s[6],this._videos[r]={type:i,id:s,width:n,height:o},e.attr("data-video",r),this.thumbnail(t,this._videos[r])},s.prototype.thumbnail=function(e,t){var i,s,n=t.width&&t.height?"width:"+t.width+"px;height:"+t.height+"px;":"",o=e.find("img"),r="src",a="",h=this._core.settings,l=function(t){'<div class="owl-video-play-icon"></div>',i=h.lazyLoad?c("<div/>",{class:"owl-video-tn "+a,srcType:t}):c("<div/>",{class:"owl-video-tn",style:"opacity:1;background-image:url("+t+")"}),e.after(i),e.after('<div class="owl-video-play-icon"></div>')};if(e.wrap(c("<div/>",{class:"owl-video-wrapper",style:n})),this._core.settings.lazyLoad&&(r="data-src",a="owl-lazy"),o.length)return l(o.attr(r)),o.remove(),!1;"youtube"===t.type?(s="//img.youtube.com/vi/"+t.id+"/hqdefault.jpg",l(s)):"vimeo"===t.type?c.ajax({type:"GET",url:"//vimeo.com/api/v2/video/"+t.id+".json",jsonp:"callback",dataType:"jsonp",success:function(t){s=t[0].thumbnail_large,l(s)}}):"vzaar"===t.type&&c.ajax({type:"GET",url:"//vzaar.com/api/videos/"+t.id+".json",jsonp:"callback",dataType:"jsonp",success:function(t){s=t.framegrab_url,l(s)}})},s.prototype.stop=function(){this._core.trigger("stop",null,"video"),this._playing.find(".owl-video-frame").remove(),this._playing.removeClass("owl-video-playing"),this._playing=null,this._core.leave("playing"),this._core.trigger("stopped",null,"video")},s.prototype.play=function(t){var e,i=c(t.target).closest("."+this._core.settings.itemClass),s=this._videos[i.attr("data-video")],n=s.width||"100%",o=s.height||this._core.$stage.height();this._playing||(this._core.enter("playing"),this._core.trigger("play",null,"video"),i=this._core.items(this._core.relative(i.index())),this._core.reset(i.index()),(e=c('<iframe frameborder="0" allowfullscreen mozallowfullscreen webkitAllowFullScreen ></iframe>')).attr("height",o),e.attr("width",n),"youtube"===s.type?e.attr("src","//www.youtube.com/embed/"+s.id+"?autoplay=1&rel=0&v="+s.id):"vimeo"===s.type?e.attr("src","//player.vimeo.com/video/"+s.id+"?autoplay=1"):"vzaar"===s.type&&e.attr("src","//view.vzaar.com/"+s.id+"/player?autoplay=true"),c(e).wrap('<div class="owl-video-frame" />').insertAfter(i.find(".owl-video")),this._playing=i.addClass("owl-video-playing"))},s.prototype.isInFullScreen=function(){var t=e.fullscreenElement||e.mozFullScreenElement||e.webkitFullscreenElement;return t&&c(t).parent().hasClass("owl-video-frame")},s.prototype.destroy=function(){var t,e;for(t in this._core.$element.off("click.owl.video"),this._handlers)this._core.$element.off(t,this._handlers[t]);for(e in Object.getOwnPropertyNames(this))"function"!=typeof this[e]&&(this[e]=null)},c.fn.owlCarousel.Constructor.Plugins.Video=s}(window.Zepto||window.jQuery,window,document),function(r,t,e,i){var s=function(t){this.core=t,this.core.options=r.extend({},s.Defaults,this.core.options),this.swapping=!0,this.previous=void 0,this.next=void 0,this.handlers={"change.owl.carousel":r.proxy(function(t){t.namespace&&"position"==t.property.name&&(this.previous=this.core.current(),this.next=t.property.value)},this),"drag.owl.carousel dragged.owl.carousel translated.owl.carousel":r.proxy(function(t){t.namespace&&(this.swapping="translated"==t.type)},this),"translate.owl.carousel":r.proxy(function(t){t.namespace&&this.swapping&&(this.core.options.animateOut||this.core.options.animateIn)&&this.swap()},this)},this.core.$element.on(this.handlers)};s.Defaults={animateOut:!1,animateIn:!1},s.prototype.swap=function(){if(1===this.core.settings.items&&r.support.animation&&r.support.transition){this.core.speed(0);var t,e=r.proxy(this.clear,this),i=this.core.$stage.children().eq(this.previous),s=this.core.$stage.children().eq(this.next),n=this.core.settings.animateIn,o=this.core.settings.animateOut;this.core.current()!==this.previous&&(o&&(t=this.core.coordinates(this.previous)-this.core.coordinates(this.next),i.one(r.support.animation.end,e).css({left:t+"px"}).addClass("animated owl-animated-out").addClass(o)),n&&s.one(r.support.animation.end,e).addClass("animated owl-animated-in").addClass(n))}},s.prototype.clear=function(t){r(t.target).css({left:""}).removeClass("animated owl-animated-out owl-animated-in").removeClass(this.core.settings.animateIn).removeClass(this.core.settings.animateOut),this.core.onTransitionEnd()},s.prototype.destroy=function(){var t,e;for(t in this.handlers)this.core.$element.off(t,this.handlers[t]);for(e in Object.getOwnPropertyNames(this))"function"!=typeof this[e]&&(this[e]=null)},r.fn.owlCarousel.Constructor.Plugins.Animate=s}(window.Zepto||window.jQuery,window,document),function(s,n,e,t){var i=function(t){this._core=t,this._call=null,this._time=0,this._timeout=0,this._paused=!0,this._handlers={"changed.owl.carousel":s.proxy(function(t){t.namespace&&"settings"===t.property.name?this._core.settings.autoplay?this.play():this.stop():t.namespace&&"position"===t.property.name&&this._paused&&(this._time=0)},this),"initialized.owl.carousel":s.proxy(function(t){t.namespace&&this._core.settings.autoplay&&this.play()},this),"play.owl.autoplay":s.proxy(function(t,e,i){t.namespace&&this.play(e,i)},this),"stop.owl.autoplay":s.proxy(function(t){t.namespace&&this.stop()},this),"mouseover.owl.autoplay":s.proxy(function(){this._core.settings.autoplayHoverPause&&this._core.is("rotating")&&this.pause()},this),"mouseleave.owl.autoplay":s.proxy(function(){this._core.settings.autoplayHoverPause&&this._core.is("rotating")&&this.play()},this),"touchstart.owl.core":s.proxy(function(){this._core.settings.autoplayHoverPause&&this._core.is("rotating")&&this.pause()},this),"touchend.owl.core":s.proxy(function(){this._core.settings.autoplayHoverPause&&this.play()},this)},this._core.$element.on(this._handlers),this._core.options=s.extend({},i.Defaults,this._core.options)};i.Defaults={autoplay:!1,autoplayTimeout:5e3,autoplayHoverPause:!1,autoplaySpeed:!1},i.prototype._next=function(t){this._call=n.setTimeout(s.proxy(this._next,this,t),this._timeout*(Math.round(this.read()/this._timeout)+1)-this.read()),this._core.is("interacting")||e.hidden||this._core.next(t||this._core.settings.autoplaySpeed)},i.prototype.read=function(){return(new Date).getTime()-this._time},i.prototype.play=function(t,e){var i;this._core.is("rotating")||this._core.enter("rotating"),t=t||this._core.settings.autoplayTimeout,i=Math.min(this._time%(this._timeout||t),t),this._paused?(this._time=this.read(),this._paused=!1):n.clearTimeout(this._call),this._time+=this.read()%t-i,this._timeout=t,this._call=n.setTimeout(s.proxy(this._next,this,e),t-i)},i.prototype.stop=function(){this._core.is("rotating")&&(this._time=0,this._paused=!0,n.clearTimeout(this._call),this._core.leave("rotating"))},i.prototype.pause=function(){this._core.is("rotating")&&!this._paused&&(this._time=this.read(),this._paused=!0,n.clearTimeout(this._call))},i.prototype.destroy=function(){var t,e;for(t in this.stop(),this._handlers)this._core.$element.off(t,this._handlers[t]);for(e in Object.getOwnPropertyNames(this))"function"!=typeof this[e]&&(this[e]=null)},s.fn.owlCarousel.Constructor.Plugins.autoplay=i}(window.Zepto||window.jQuery,window,document),function(o,t,e,i){"use strict";var s=function(t){this._core=t,this._initialized=!1,this._pages=[],this._controls={},this._templates=[],this.$element=this._core.$element,this._overrides={next:this._core.next,prev:this._core.prev,to:this._core.to},this._handlers={"prepared.owl.carousel":o.proxy(function(t){t.namespace&&this._core.settings.dotsData&&this._templates.push('<div class="'+this._core.settings.dotClass+'">'+o(t.content).find("[data-dot]").addBack("[data-dot]").attr("data-dot")+"</div>")},this),"added.owl.carousel":o.proxy(function(t){t.namespace&&this._core.settings.dotsData&&this._templates.splice(t.position,0,this._templates.pop())},this),"remove.owl.carousel":o.proxy(function(t){t.namespace&&this._core.settings.dotsData&&this._templates.splice(t.position,1)},this),"changed.owl.carousel":o.proxy(function(t){t.namespace&&"position"==t.property.name&&this.draw()},this),"initialized.owl.carousel":o.proxy(function(t){t.namespace&&!this._initialized&&(this._core.trigger("initialize",null,"navigation"),this.initialize(),this.update(),this.draw(),this._initialized=!0,this._core.trigger("initialized",null,"navigation"))},this),"refreshed.owl.carousel":o.proxy(function(t){t.namespace&&this._initialized&&(this._core.trigger("refresh",null,"navigation"),this.update(),this.draw(),this._core.trigger("refreshed",null,"navigation"))},this)},this._core.options=o.extend({},s.Defaults,this._core.options),this.$element.on(this._handlers)};s.Defaults={nav:!1,navText:['<span aria-label="Previous">&#x2039;</span>','<span aria-label="Next">&#x203a;</span>'],navSpeed:!1,navElement:'button type="button" role="presentation"',navContainer:!1,navContainerClass:"owl-nav",navClass:["owl-prev","owl-next"],slideBy:1,dotClass:"owl-dot",dotsClass:"owl-dots",dots:!0,dotsEach:!1,dotsData:!1,dotsSpeed:!1,dotsContainer:!1},s.prototype.initialize=function(){var t,i=this._core.settings;for(t in this._controls.$relative=(i.navContainer?o(i.navContainer):o("<div>").addClass(i.navContainerClass).appendTo(this.$element)).addClass("disabled"),this._controls.$previous=o("<"+i.navElement+">").addClass(i.navClass[0]).html(i.navText[0]).prependTo(this._controls.$relative).on("click",o.proxy(function(t){this.prev(i.navSpeed)},this)),this._controls.$next=o("<"+i.navElement+">").addClass(i.navClass[1]).html(i.navText[1]).appendTo(this._controls.$relative).on("click",o.proxy(function(t){this.next(i.navSpeed)},this)),i.dotsData||(this._templates=[o('<button role="button">').addClass(i.dotClass).append(o("<span>")).prop("outerHTML")]),this._controls.$absolute=(i.dotsContainer?o(i.dotsContainer):o("<div>").addClass(i.dotsClass).appendTo(this.$element)).addClass("disabled"),this._controls.$absolute.on("click","button",o.proxy(function(t){var e=o(t.target).parent().is(this._controls.$absolute)?o(t.target).index():o(t.target).parent().index();t.preventDefault(),this.to(e,i.dotsSpeed)},this)),this._overrides)this._core[t]=o.proxy(this[t],this)},s.prototype.destroy=function(){var t,e,i,s,n;for(t in n=this._core.settings,this._handlers)this.$element.off(t,this._handlers[t]);for(e in this._controls)"$relative"===e&&n.navContainer?this._controls[e].html(""):this._controls[e].remove();for(s in this.overides)this._core[s]=this._overrides[s];for(i in Object.getOwnPropertyNames(this))"function"!=typeof this[i]&&(this[i]=null)},s.prototype.update=function(){var t,e,i=this._core.clones().length/2,s=i+this._core.items().length,n=this._core.maximum(!0),o=this._core.settings,r=o.center||o.autoWidth||o.dotsData?1:o.dotsEach||o.items;if("page"!==o.slideBy&&(o.slideBy=Math.min(o.slideBy,o.items)),o.dots||"page"==o.slideBy)for(this._pages=[],t=i,e=0;t<s;t++){if(r<=e||0===e){if(this._pages.push({start:Math.min(n,t-i),end:t-i+r-1}),Math.min(n,t-i)===n)break;e=0,0}e+=this._core.mergers(this._core.relative(t))}},s.prototype.draw=function(){var t,e=this._core.settings,i=this._core.items().length<=e.items,s=this._core.relative(this._core.current()),n=e.loop||e.rewind;this._controls.$relative.toggleClass("disabled",!e.nav||i),e.nav&&(this._controls.$previous.toggleClass("disabled",!n&&s<=this._core.minimum(!0)),this._controls.$next.toggleClass("disabled",!n&&s>=this._core.maximum(!0))),this._controls.$absolute.toggleClass("disabled",!e.dots||i),e.dots&&(t=this._pages.length-this._controls.$absolute.children().length,e.dotsData&&0!==t?this._controls.$absolute.html(this._templates.join("")):0<t?this._controls.$absolute.append(new Array(t+1).join(this._templates[0])):t<0&&this._controls.$absolute.children().slice(t).remove(),this._controls.$absolute.find(".active").removeClass("active"),this._controls.$absolute.children().eq(o.inArray(this.current(),this._pages)).addClass("active"))},s.prototype.onTrigger=function(t){var e=this._core.settings;t.page={index:o.inArray(this.current(),this._pages),count:this._pages.length,size:e&&(e.center||e.autoWidth||e.dotsData?1:e.dotsEach||e.items)}},s.prototype.current=function(){var i=this._core.relative(this._core.current());return o.grep(this._pages,o.proxy(function(t,e){return t.start<=i&&t.end>=i},this)).pop()},s.prototype.getPosition=function(t){var e,i,s=this._core.settings;return"page"==s.slideBy?(e=o.inArray(this.current(),this._pages),i=this._pages.length,t?++e:--e,e=this._pages[(e%i+i)%i].start):(e=this._core.relative(this._core.current()),i=this._core.items().length,t?e+=s.slideBy:e-=s.slideBy),e},s.prototype.next=function(t){o.proxy(this._overrides.to,this._core)(this.getPosition(!0),t)},s.prototype.prev=function(t){o.proxy(this._overrides.to,this._core)(this.getPosition(!1),t)},s.prototype.to=function(t,e,i){var s;!i&&this._pages.length?(s=this._pages.length,o.proxy(this._overrides.to,this._core)(this._pages[(t%s+s)%s].start,e)):o.proxy(this._overrides.to,this._core)(t,e)},o.fn.owlCarousel.Constructor.Plugins.Navigation=s}(window.Zepto||window.jQuery,window,document),function(s,n,t,e){"use strict";var i=function(t){this._core=t,this._hashes={},this.$element=this._core.$element,this._handlers={"initialized.owl.carousel":s.proxy(function(t){t.namespace&&"URLHash"===this._core.settings.startPosition&&s(n).trigger("hashchange.owl.navigation")},this),"prepared.owl.carousel":s.proxy(function(t){if(t.namespace){var e=s(t.content).find("[data-hash]").addBack("[data-hash]").attr("data-hash");if(!e)return;this._hashes[e]=t.content}},this),"changed.owl.carousel":s.proxy(function(t){if(t.namespace&&"position"===t.property.name){var i=this._core.items(this._core.relative(this._core.current())),e=s.map(this._hashes,function(t,e){return t===i?e:null}).join();if(!e||n.location.hash.slice(1)===e)return;n.location.hash=e}},this)},this._core.options=s.extend({},i.Defaults,this._core.options),this.$element.on(this._handlers),s(n).on("hashchange.owl.navigation",s.proxy(function(t){var e=n.location.hash.substring(1),i=this._core.$stage.children(),s=this._hashes[e]&&i.index(this._hashes[e]);void 0!==s&&s!==this._core.current()&&this._core.to(this._core.relative(s),!1,!0)},this))};i.Defaults={URLhashListener:!1},i.prototype.destroy=function(){var t,e;for(t in s(n).off("hashchange.owl.navigation"),this._handlers)this._core.$element.off(t,this._handlers[t]);for(e in Object.getOwnPropertyNames(this))"function"!=typeof this[e]&&(this[e]=null)},s.fn.owlCarousel.Constructor.Plugins.Hash=i}(window.Zepto||window.jQuery,window,document),function(n,t,e,o){function i(t,i){var s=!1,e=t.charAt(0).toUpperCase()+t.slice(1);return n.each((t+" "+a.join(e+" ")+e).split(" "),function(t,e){if(r[e]!==o)return s=!i||e,!1}),s}function s(t){return i(t,!0)}var r=n("<support>").get(0).style,a="Webkit Moz O ms".split(" "),h={transition:{end:{WebkitTransition:"webkitTransitionEnd",MozTransition:"transitionend",OTransition:"oTransitionEnd",transition:"transitionend"}},animation:{end:{WebkitAnimation:"webkitAnimationEnd",MozAnimation:"animationend",OAnimation:"oAnimationEnd",animation:"animationend"}}},l=function(){return!!i("transform")},c=function(){return!!i("perspective")},p=function(){return!!i("animation")};(function(){return!!i("transition")})()&&(n.support.transition=new String(s("transition")),n.support.transition.end=h.transition.end[n.support.transition]),p()&&(n.support.animation=new String(s("animation")),n.support.animation.end=h.animation.end[n.support.animation]),l()&&(n.support.transform=new String(s("transform")),n.support.transform3d=c())}(window.Zepto||window.jQuery,window,document);
/*! matchMedia() polyfill - Test a CSS media type/query in JS. Authors & copyright (c) 2012: Scott Jehl, Paul Irish, Nicholas Zakas, David Knight. MIT license */
window.matchMedia||(window.matchMedia=function(){"use strict";var t=window.styleMedia||window.media;if(!t){var d,i=document.createElement("style"),e=document.getElementsByTagName("script")[0];i.type="text/css",i.id="matchmediajs-test",e?e.parentNode.insertBefore(i,e):document.head.appendChild(i),d="getComputedStyle"in window&&window.getComputedStyle(i,null)||i.currentStyle,t={matchMedium:function(e){var t="@media "+e+"{ #matchmediajs-test { width: 1px; } }";return i.styleSheet?i.styleSheet.cssText=t:i.textContent=t,"1px"===d.width}}}return function(e){return{matches:t.matchMedium(e||"all"),media:e||"all"}}}());
/*! owl.carousel2.thumbs - v0.1.8 | (c) 2016 @gijsroge | MIT license | https://github.com/gijsroge/OwlCarousel2-Thumbs */
!function(a,b,c,d){"use strict";var e=function(b){this.owl=b,this._thumbcontent=[],this._identifier=0,this.owl_currentitem=this.owl.options.startPosition,this.$element=this.owl.$element,this._handlers={"prepared.owl.carousel":a.proxy(function(b){if(!b.namespace||!this.owl.options.thumbs||this.owl.options.thumbImage||this.owl.options.thumbsPrerendered||this.owl.options.thumbImage){if(b.namespace&&this.owl.options.thumbs&&this.owl.options.thumbImage){var c=a(b.content).find("img");this._thumbcontent.push(c)}}else a(b.content).find("[data-thumb]").attr("data-thumb")!==d&&this._thumbcontent.push(a(b.content).find("[data-thumb]").attr("data-thumb"))},this),"initialized.owl.carousel":a.proxy(function(a){a.namespace&&this.owl.options.thumbs&&(this.render(),this.listen(),this._identifier=this.owl.$element.data("slider-id"),this.setActive())},this),"changed.owl.carousel":a.proxy(function(a){a.namespace&&"position"===a.property.name&&this.owl.options.thumbs&&(this._identifier=this.owl.$element.data("slider-id"),this.setActive())},this)},this.owl.options=a.extend({},e.Defaults,this.owl.options),this.owl.$element.on(this._handlers)};e.Defaults={thumbs:!0,thumbImage:!1,thumbContainerClass:"owl-thumbs",thumbItemClass:"owl-thumb-item",moveThumbsInside:!1},e.prototype.listen=function(){var b=this.owl.options;b.thumbsPrerendered&&(this._thumbcontent._thumbcontainer=a("."+b.thumbContainerClass)),a(this._thumbcontent._thumbcontainer).on("click",this._thumbcontent._thumbcontainer.children(),a.proxy(function(c){this._identifier=a(c.target).closest("."+b.thumbContainerClass).data("slider-id");var d=a(c.target).parent().is(this._thumbcontent._thumbcontainer)?a(c.target).index():a(c.target).closest("."+b.thumbItemClass).index();b.thumbsPrerendered?a("[data-slider-id="+this._identifier+"]").trigger("to.owl.carousel",[d,b.dotsSpeed,!0]):this.owl.to(d,b.dotsSpeed),c.preventDefault()},this))},e.prototype.render=function(){var b=this.owl.options;b.thumbsPrerendered?(this._thumbcontent._thumbcontainer=a("."+b.thumbContainerClass),b.moveThumbsInside&&this._thumbcontent._thumbcontainer.appendTo(this.$element)):this._thumbcontent._thumbcontainer=a("<div>").addClass(b.thumbContainerClass).appendTo(this.$element);var c;if(b.thumbImage)for(c=0;c<this._thumbcontent.length;++c)this._thumbcontent._thumbcontainer.append("<button class="+b.thumbItemClass+'><img src="'+this._thumbcontent[c].attr("src")+'" alt="'+this._thumbcontent[c].attr("alt")+'" /></button>');else for(c=0;c<this._thumbcontent.length;++c)this._thumbcontent._thumbcontainer.append("<button class="+b.thumbItemClass+">"+this._thumbcontent[c]+"</button>")},e.prototype.setActive=function(){this.owl_currentitem=this.owl._current-this.owl._clones.length/2,this.owl_currentitem===this.owl._items.length&&(this.owl_currentitem=0);var b=this.owl.options,c=b.thumbsPrerendered?a("."+b.thumbContainerClass+'[data-slider-id="'+this._identifier+'"]'):this._thumbcontent._thumbcontainer;c.children().filter(".active").removeClass("active"),c.children().eq(this.owl_currentitem).addClass("active")},e.prototype.destroy=function(){var a,b;for(a in this._handlers)this.owl.$element.off(a,this._handlers[a]);for(b in Object.getOwnPropertyNames(this))"function"!=typeof this[b]&&(this[b]=null)},a.fn.owlCarousel.Constructor.Plugins.Thumbs=e}(window.Zepto||window.jQuery,window,document);
/**
 * Macy.js - Masonry layout v2.3.0
 * https://github.com/bigbitecreative/macy.js/
 */
!function(t,n){"object"==typeof exports&&"undefined"!=typeof module?module.exports=n():"function"==typeof define&&define.amd?define(n):t.Macy=n()}(this,function(){"use strict";function t(t,n){var e=void 0;return function(){e&&clearTimeout(e),e=setTimeout(t,n)}}function n(t,n){for(var e=t.length,o=e,r=[];e--;)r.push(n(t[o-e-1]));return r}function e(t,n){A(t,n,arguments.length>2&&void 0!==arguments[2]&&arguments[2])}function o(t){for(var n=t.options,e=t.responsiveOptions,o=t.keys,r=t.docWidth,i=void 0,s=0;s<o.length;s++){var a=parseInt(o[s],10);r>=a&&(i=n.breakAt[a],O(i,e))}return e}function r(t){for(var n=t.options,e=t.responsiveOptions,o=t.keys,r=t.docWidth,i=void 0,s=o.length-1;s>=0;s--){var a=parseInt(o[s],10);r<=a&&(i=n.breakAt[a],O(i,e))}return e}function i(t){var n=document.body.clientWidth,e={columns:t.columns};L(t.margin)?e.margin={x:t.margin.x,y:t.margin.y}:e.margin={x:t.margin,y:t.margin};var i=Object.keys(t.breakAt);return t.mobileFirst?o({options:t,responsiveOptions:e,keys:i,docWidth:n}):r({options:t,responsiveOptions:e,keys:i,docWidth:n})}function s(t){return i(t).columns}function a(t){return i(t).margin}function c(t){var n=!(arguments.length>1&&void 0!==arguments[1])||arguments[1],e=s(t),o=a(t).x,r=100/e;return n?1===e?"100%":(o=(e-1)*o/e,"calc("+r+"% - "+o+"px)"):r}function u(t,n){var e=s(t.options),o=0,r=void 0,i=void 0;return 1===++n?0:(i=a(t.options).x,r=(i-(e-1)*i/e)*(n-1),o+=c(t.options,!1)*(n-1),"calc("+o+"% + "+r+"px)")}function l(t){var n=0,e=t.container;m(t.rows,function(t){n=t>n?t:n}),e.style.height=n+"px"}function p(t,n){var e=arguments.length>2&&void 0!==arguments[2]&&arguments[2],o=!(arguments.length>3&&void 0!==arguments[3])||arguments[3],r=s(t.options),i=a(t.options).y;C(t,r,e),m(n,function(n){var e=0,r=parseInt(n.offsetHeight,10);isNaN(r)||(t.rows.forEach(function(n,o){n<t.rows[e]&&(e=o)}),n.style.position="absolute",n.style.top=t.rows[e]+"px",n.style.left=""+t.cols[e],t.rows[e]+=isNaN(r)?0:r+i,o&&(n.dataset.macyComplete=1))}),o&&(t.tmpRows=null),l(t)}function h(t,n){var e=arguments.length>2&&void 0!==arguments[2]&&arguments[2],o=!(arguments.length>3&&void 0!==arguments[3])||arguments[3],r=s(t.options),i=a(t.options).y;C(t,r,e),m(n,function(n){t.lastcol===r&&(t.lastcol=0);var e=M(n,"height");e=parseInt(n.offsetHeight,10),isNaN(e)||(n.style.position="absolute",n.style.top=t.rows[t.lastcol]+"px",n.style.left=""+t.cols[t.lastcol],t.rows[t.lastcol]+=isNaN(e)?0:e+i,t.lastcol+=1,o&&(n.dataset.macyComplete=1))}),o&&(t.tmpRows=null),l(t)}var f=function t(n,e){if(!(this instanceof t))return new t(n,e);if(n=n.replace(/^\s*/,"").replace(/\s*$/,""),e)return this.byCss(n,e);for(var o in this.selectors)if(e=o.split("/"),new RegExp(e[1],e[2]).test(n))return this.selectors[o](n);return this.byCss(n)};f.prototype.byCss=function(t,n){return(n||document).querySelectorAll(t)},f.prototype.selectors={},f.prototype.selectors[/^\.[\w\-]+$/]=function(t){return document.getElementsByClassName(t.substring(1))},f.prototype.selectors[/^\w+$/]=function(t){return document.getElementsByTagName(t)},f.prototype.selectors[/^\#[\w\-]+$/]=function(t){return document.getElementById(t.substring(1))};var m=function(t,n){for(var e=t.length,o=e;e--;)n(t[o-e-1])},v=function(){var t=arguments.length>0&&void 0!==arguments[0]&&arguments[0];this.running=!1,this.events=[],this.add(t)};v.prototype.run=function(){if(!this.running&&this.events.length>0){var t=this.events.shift();this.running=!0,t(),this.running=!1,this.run()}},v.prototype.add=function(){var t=this,n=arguments.length>0&&void 0!==arguments[0]&&arguments[0];return!!n&&(Array.isArray(n)?m(n,function(n){return t.add(n)}):(this.events.push(n),void this.run()))},v.prototype.clear=function(){this.events=[]};var d=function(t){var n=arguments.length>1&&void 0!==arguments[1]?arguments[1]:{};return this.instance=t,this.data=n,this},g=function(){var t=arguments.length>0&&void 0!==arguments[0]&&arguments[0];this.events={},this.instance=t};g.prototype.on=function(){var t=arguments.length>0&&void 0!==arguments[0]&&arguments[0],n=arguments.length>1&&void 0!==arguments[1]&&arguments[1];return!(!t||!n)&&(Array.isArray(this.events[t])||(this.events[t]=[]),this.events[t].push(n))},g.prototype.emit=function(){var t=arguments.length>0&&void 0!==arguments[0]&&arguments[0],n=arguments.length>1&&void 0!==arguments[1]?arguments[1]:{};if(!t||!Array.isArray(this.events[t]))return!1;var e=new d(this.instance,n);m(this.events[t],function(t){return t(e)})};var y=function(t){return!("naturalHeight"in t&&t.naturalHeight+t.naturalWidth===0)||t.width+t.height!==0},E=function(t,n){var e=arguments.length>2&&void 0!==arguments[2]&&arguments[2];return new Promise(function(t,e){if(n.complete)return y(n)?t(n):e(n);n.addEventListener("load",function(){return y(n)?t(n):e(n)}),n.addEventListener("error",function(){return e(n)})}).then(function(n){e&&t.emit(t.constants.EVENT_IMAGE_LOAD,{img:n})}).catch(function(n){return t.emit(t.constants.EVENT_IMAGE_ERROR,{img:n})})},w=function(t,e){var o=arguments.length>2&&void 0!==arguments[2]&&arguments[2];return n(e,function(n){return E(t,n,o)})},A=function(t,n){var e=arguments.length>2&&void 0!==arguments[2]&&arguments[2];return Promise.all(w(t,n,e)).then(function(){t.emit(t.constants.EVENT_IMAGE_COMPLETE)})},I=function(n){return t(function(){n.emit(n.constants.EVENT_RESIZE),n.queue.add(function(){return n.recalculate(!0,!0)})},100)},N=function(t){if(t.container=f(t.options.container),t.container instanceof f||!t.container)return!!t.options.debug&&console.error("Error: Container not found");delete t.options.container,t.container.length&&(t.container=t.container[0]),t.container.style.position="relative"},T=function(t){t.queue=new v,t.events=new g(t),t.rows=[],t.resizer=I(t)},b=function(t){var n=f("img",t.container);window.addEventListener("resize",t.resizer),t.on(t.constants.EVENT_IMAGE_LOAD,function(){return t.recalculate(!1,!1)}),t.on(t.constants.EVENT_IMAGE_COMPLETE,function(){return t.recalculate(!0,!0)}),t.options.useOwnImageLoader||e(t,n,!t.options.waitForImages),t.emit(t.constants.EVENT_INITIALIZED)},_=function(t){N(t),T(t),b(t)},L=function(t){return t===Object(t)&&"[object Array]"!==Object.prototype.toString.call(t)},O=function(t,n){L(t)||(n.columns=t),L(t)&&t.columns&&(n.columns=t.columns),L(t)&&t.margin&&!L(t.margin)&&(n.margin={x:t.margin,y:t.margin}),L(t)&&t.margin&&L(t.margin)&&t.margin.x&&(n.margin.x=t.margin.x),L(t)&&t.margin&&L(t.margin)&&t.margin.y&&(n.margin.y=t.margin.y)},M=function(t,n){return window.getComputedStyle(t,null).getPropertyValue(n)},C=function(t,n){var e=arguments.length>2&&void 0!==arguments[2]&&arguments[2];if(t.lastcol||(t.lastcol=0),t.rows.length<1&&(e=!0),e){t.rows=[],t.cols=[],t.lastcol=0;for(var o=n-1;o>=0;o--)t.rows[o]=0,t.cols[o]=u(t,o)}else if(t.tmpRows){t.rows=[];for(var o=n-1;o>=0;o--)t.rows[o]=t.tmpRows[o]}else{t.tmpRows=[];for(var o=n-1;o>=0;o--)t.tmpRows[o]=t.rows[o]}},V=function(t){var n=arguments.length>1&&void 0!==arguments[1]&&arguments[1],e=!(arguments.length>2&&void 0!==arguments[2])||arguments[2],o=n?t.container.children:f(':scope > *:not([data-macy-complete="1"])',t.container),r=c(t.options);return m(o,function(t){n&&(t.dataset.macyComplete=0),t.style.width=r}),t.options.trueOrder?(h(t,o,n,e),t.emit(t.constants.EVENT_RECALCULATED)):(p(t,o,n,e),t.emit(t.constants.EVENT_RECALCULATED))},R=Object.assign||function(t){for(var n=1;n<arguments.length;n++){var e=arguments[n];for(var o in e)Object.prototype.hasOwnProperty.call(e,o)&&(t[o]=e[o])}return t},x={columns:4,margin:2,trueOrder:!1,waitForImages:!1,useImageLoader:!0,breakAt:{},useOwnImageLoader:!1,onInit:!1};!function(){try{document.createElement("a").querySelector(":scope *")}catch(t){!function(){function t(t){return function(e){if(e&&n.test(e)){var o=this.getAttribute("id");o||(this.id="q"+Math.floor(9e6*Math.random())+1e6),arguments[0]=e.replace(n,"#"+this.id);var r=t.apply(this,arguments);return null===o?this.removeAttribute("id"):o||(this.id=o),r}return t.apply(this,arguments)}}var n=/:scope\b/gi,e=t(Element.prototype.querySelector);Element.prototype.querySelector=function(t){return e.apply(this,arguments)};var o=t(Element.prototype.querySelectorAll);Element.prototype.querySelectorAll=function(t){return o.apply(this,arguments)}}()}}();var q=function t(){var n=arguments.length>0&&void 0!==arguments[0]?arguments[0]:x;if(!(this instanceof t))return new t(n);this.options={},R(this.options,x,n),_(this)};return q.init=function(t){return console.warn("Depreciated: Macy.init will be removed in v3.0.0 opt to use Macy directly like so Macy({ /*options here*/ }) "),new q(t)},q.prototype.recalculateOnImageLoad=function(){var t=arguments.length>0&&void 0!==arguments[0]&&arguments[0];return e(this,f("img",this.container),!t)},q.prototype.runOnImageLoad=function(t){var n=arguments.length>1&&void 0!==arguments[1]&&arguments[1],o=f("img",this.container);return this.on(this.constants.EVENT_IMAGE_COMPLETE,t),n&&this.on(this.constants.EVENT_IMAGE_LOAD,t),e(this,o,n)},q.prototype.recalculate=function(){var t=this,n=arguments.length>0&&void 0!==arguments[0]&&arguments[0],e=!(arguments.length>1&&void 0!==arguments[1])||arguments[1];return e&&this.queue.clear(),this.queue.add(function(){return V(t,n,e)})},q.prototype.remove=function(){window.removeEventListener("resize",this.resizer),m(this.container.children,function(t){t.removeAttribute("data-macy-complete"),t.removeAttribute("style")}),this.container.removeAttribute("style")},q.prototype.reInit=function(){this.recalculate(!0,!0),this.emit(this.constants.EVENT_INITIALIZED),window.addEventListener("resize",this.resizer),this.container.style.position="relative"},q.prototype.on=function(t,n){this.events.on(t,n)},q.prototype.emit=function(t,n){this.events.emit(t,n)},q.constants={EVENT_INITIALIZED:"macy.initialized",EVENT_RECALCULATED:"macy.recalculated",EVENT_IMAGE_LOAD:"macy.image.load",EVENT_IMAGE_ERROR:"macy.image.error",EVENT_IMAGE_COMPLETE:"macy.images.complete",EVENT_RESIZE:"macy.resize"},q.prototype.constants=q.constants,q});
/*!
	Zoom 1.7.21
	license: MIT
	http://www.jacklmoore.com/zoom
*/
(function(o){var t={url:!1,callback:!1,target:!1,duration:120,on:"mouseover",touch:!0,onZoomIn:!1,onZoomOut:!1,magnify:1};o.zoom=function(t,n,e,i){var u,c,a,r,m,l,s,f=o(t),h=f.css("position"),d=o(n);return t.style.position=/(absolute|fixed)/.test(h)?h:"relative",t.style.overflow="hidden",e.style.width=e.style.height="",o(e).addClass("zoomImg").css({position:"absolute",top:0,left:0,opacity:0,width:e.width*i,height:e.height*i,border:"none",maxWidth:"none",maxHeight:"none"}).appendTo(t),{init:function(){c=f.outerWidth(),u=f.outerHeight(),n===t?(r=c,a=u):(r=d.outerWidth(),a=d.outerHeight()),m=(e.width-c)/r,l=(e.height-u)/a,s=d.offset()},move:function(o){var t=o.pageX-s.left,n=o.pageY-s.top;n=Math.max(Math.min(n,a),0),t=Math.max(Math.min(t,r),0),e.style.left=t*-m+"px",e.style.top=n*-l+"px"}}},o.fn.zoom=function(n){return this.each(function(){var e=o.extend({},t,n||{}),i=e.target&&o(e.target)[0]||this,u=this,c=o(u),a=document.createElement("img"),r=o(a),m="mousemove.zoom",l=!1,s=!1;if(!e.url){var f=u.querySelector("img");if(f&&(e.url=f.getAttribute("data-src")||f.currentSrc||f.src),!e.url)return}c.one("zoom.destroy",function(o,t){c.off(".zoom"),i.style.position=o,i.style.overflow=t,a.onload=null,r.remove()}.bind(this,i.style.position,i.style.overflow)),a.onload=function(){function t(t){f.init(),f.move(t),r.stop().fadeTo(o.support.opacity?e.duration:0,1,o.isFunction(e.onZoomIn)?e.onZoomIn.call(a):!1)}function n(){r.stop().fadeTo(e.duration,0,o.isFunction(e.onZoomOut)?e.onZoomOut.call(a):!1)}var f=o.zoom(i,u,a,e.magnify);"grab"===e.on?c.on("mousedown.zoom",function(e){1===e.which&&(o(document).one("mouseup.zoom",function(){n(),o(document).off(m,f.move)}),t(e),o(document).on(m,f.move),e.preventDefault())}):"click"===e.on?c.on("click.zoom",function(e){return l?void 0:(l=!0,t(e),o(document).on(m,f.move),o(document).one("click.zoom",function(){n(),l=!1,o(document).off(m,f.move)}),!1)}):"toggle"===e.on?c.on("click.zoom",function(o){l?n():t(o),l=!l}):"mouseover"===e.on&&(f.init(),c.on("mouseenter.zoom",t).on("mouseleave.zoom",n).on(m,f.move)),e.touch&&c.on("touchstart.zoom",function(o){o.preventDefault(),s?(s=!1,n()):(s=!0,t(o.originalEvent.touches[0]||o.originalEvent.changedTouches[0]))}).on("touchmove.zoom",function(o){o.preventDefault(),f.move(o.originalEvent.touches[0]||o.originalEvent.changedTouches[0])}).on("touchend.zoom",function(o){o.preventDefault(),s&&(s=!1,n())}),o.isFunction(e.callback)&&e.callback.call(a)},a.setAttribute("role","presentation"),a.alt="",a.src=e.url})},o.fn.zoom.defaults=t})(window.jQuery);
/*!
	Zoom 1.7.21
	license: MIT
	http://www.jacklmoore.com/zoom
*/
(function(o){var t={url:!1,callback:!1,target:!1,duration:120,on:"mouseover",touch:!0,onZoomIn:!1,onZoomOut:!1,magnify:1};o.zoom=function(t,n,e,i){var u,c,a,r,m,l,s,f=o(t),h=f.css("position"),d=o(n);return t.style.position=/(absolute|fixed)/.test(h)?h:"relative",t.style.overflow="hidden",e.style.width=e.style.height="",o(e).addClass("zoomImg").css({position:"absolute",top:0,left:0,opacity:0,width:e.width*i,height:e.height*i,border:"none",maxWidth:"none",maxHeight:"none"}).appendTo(t),{init:function(){c=f.outerWidth(),u=f.outerHeight(),n===t?(r=c,a=u):(r=d.outerWidth(),a=d.outerHeight()),m=(e.width-c)/r,l=(e.height-u)/a,s=d.offset()},move:function(o){var t=o.pageX-s.left,n=o.pageY-s.top;n=Math.max(Math.min(n,a),0),t=Math.max(Math.min(t,r),0),e.style.left=t*-m+"px",e.style.top=n*-l+"px"}}},o.fn.zoom=function(n){return this.each(function(){var e=o.extend({},t,n||{}),i=e.target&&o(e.target)[0]||this,u=this,c=o(u),a=document.createElement("img"),r=o(a),m="mousemove.zoom",l=!1,s=!1;if(!e.url){var f=u.querySelector("img");if(f&&(e.url=f.getAttribute("data-src")||f.currentSrc||f.src),!e.url)return}c.one("zoom.destroy",function(o,t){c.off(".zoom"),i.style.position=o,i.style.overflow=t,a.onload=null,r.remove()}.bind(this,i.style.position,i.style.overflow)),a.onload=function(){function t(t){f.init(),f.move(t),r.stop().fadeTo(o.support.opacity?e.duration:0,1,o.isFunction(e.onZoomIn)?e.onZoomIn.call(a):!1)}function n(){r.stop().fadeTo(e.duration,0,o.isFunction(e.onZoomOut)?e.onZoomOut.call(a):!1)}var f=o.zoom(i,u,a,e.magnify);"grab"===e.on?c.on("mousedown.zoom",function(e){1===e.which&&(o(document).one("mouseup.zoom",function(){n(),o(document).off(m,f.move)}),t(e),o(document).on(m,f.move),e.preventDefault())}):"click"===e.on?c.on("click.zoom",function(e){return l?void 0:(l=!0,t(e),o(document).on(m,f.move),o(document).one("click.zoom",function(){n(),l=!1,o(document).off(m,f.move)}),!1)}):"toggle"===e.on?c.on("click.zoom",function(o){l?n():t(o),l=!l}):"mouseover"===e.on&&(f.init(),c.on("mouseenter.zoom",t).on("mouseleave.zoom",n).on(m,f.move)),e.touch&&c.on("touchstart.zoom",function(o){o.preventDefault(),s?(s=!1,n()):(s=!0,t(o.originalEvent.touches[0]||o.originalEvent.changedTouches[0]))}).on("touchmove.zoom",function(o){o.preventDefault(),f.move(o.originalEvent.touches[0]||o.originalEvent.changedTouches[0])}).on("touchend.zoom",function(o){o.preventDefault(),s&&(s=!1,n())}),o.isFunction(e.callback)&&e.callback.call(a)},a.setAttribute("role","presentation"),a.alt="",a.src=e.url})},o.fn.zoom.defaults=t})(window.jQuery);
/*!
 * GSAP 3.12.5
 * https://gsap.com
 *
 * @license Copyright 2024, GreenSock. All rights reserved.
 * Subject to the terms at https://gsap.com/standard-license or for Club GSAP members, the agreement issued with that membership.
 * @author: Jack Doyle, jack@greensock.com
 */

!function(t,e){"object"==typeof exports&&"undefined"!=typeof module?e(exports):"function"==typeof define&&define.amd?define(["exports"],e):e((t=t||self).window=t.window||{})}(this,function(e){"use strict";function _inheritsLoose(t,e){t.prototype=Object.create(e.prototype),(t.prototype.constructor=t).__proto__=e}function _assertThisInitialized(t){if(void 0===t)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return t}function r(t){return"string"==typeof t}function s(t){return"function"==typeof t}function t(t){return"number"==typeof t}function u(t){return void 0===t}function v(t){return"object"==typeof t}function w(t){return!1!==t}function x(){return"undefined"!=typeof window}function y(t){return s(t)||r(t)}function P(t){return(i=yt(t,ot))&&ze}function Q(t,e){return console.warn("Invalid property",t,"set to",e,"Missing plugin? gsap.registerPlugin()")}function R(t,e){return!e&&console.warn(t)}function S(t,e){return t&&(ot[t]=e)&&i&&(i[t]=e)||ot}function T(){return 0}function ea(t){var e,r,i=t[0];if(v(i)||s(i)||(t=[t]),!(e=(i._gsap||{}).harness)){for(r=gt.length;r--&&!gt[r].targetTest(i););e=gt[r]}for(r=t.length;r--;)t[r]&&(t[r]._gsap||(t[r]._gsap=new Vt(t[r],e)))||t.splice(r,1);return t}function fa(t){return t._gsap||ea(Mt(t))[0]._gsap}function ga(t,e,r){return(r=t[e])&&s(r)?t[e]():u(r)&&t.getAttribute&&t.getAttribute(e)||r}function ha(t,e){return(t=t.split(",")).forEach(e)||t}function ia(t){return Math.round(1e5*t)/1e5||0}function ja(t){return Math.round(1e7*t)/1e7||0}function ka(t,e){var r=e.charAt(0),i=parseFloat(e.substr(2));return t=parseFloat(t),"+"===r?t+i:"-"===r?t-i:"*"===r?t*i:t/i}function la(t,e){for(var r=e.length,i=0;t.indexOf(e[i])<0&&++i<r;);return i<r}function ma(){var t,e,r=dt.length,i=dt.slice(0);for(ct={},t=dt.length=0;t<r;t++)(e=i[t])&&e._lazy&&(e.render(e._lazy[0],e._lazy[1],!0)._lazy=0)}function na(t,e,r,i){dt.length&&!L&&ma(),t.render(e,r,i||L&&e<0&&(t._initted||t._startAt)),dt.length&&!L&&ma()}function oa(t){var e=parseFloat(t);return(e||0===e)&&(t+"").match(at).length<2?e:r(t)?t.trim():t}function pa(t){return t}function qa(t,e){for(var r in e)r in t||(t[r]=e[r]);return t}function ta(t,e){for(var r in e)"__proto__"!==r&&"constructor"!==r&&"prototype"!==r&&(t[r]=v(e[r])?ta(t[r]||(t[r]={}),e[r]):e[r]);return t}function ua(t,e){var r,i={};for(r in t)r in e||(i[r]=t[r]);return i}function va(t){var e=t.parent||I,r=t.keyframes?function _setKeyframeDefaults(i){return function(t,e){for(var r in e)r in t||"duration"===r&&i||"ease"===r||(t[r]=e[r])}}(Z(t.keyframes)):qa;if(w(t.inherit))for(;e;)r(t,e.vars.defaults),e=e.parent||e._dp;return t}function xa(t,e,r,i,n){void 0===r&&(r="_first"),void 0===i&&(i="_last");var a,s=t[i];if(n)for(a=e[n];s&&s[n]>a;)s=s._prev;return s?(e._next=s._next,s._next=e):(e._next=t[r],t[r]=e),e._next?e._next._prev=e:t[i]=e,e._prev=s,e.parent=e._dp=t,e}function ya(t,e,r,i){void 0===r&&(r="_first"),void 0===i&&(i="_last");var n=e._prev,a=e._next;n?n._next=a:t[r]===e&&(t[r]=a),a?a._prev=n:t[i]===e&&(t[i]=n),e._next=e._prev=e.parent=null}function za(t,e){t.parent&&(!e||t.parent.autoRemoveChildren)&&t.parent.remove&&t.parent.remove(t),t._act=0}function Aa(t,e){if(t&&(!e||e._end>t._dur||e._start<0))for(var r=t;r;)r._dirty=1,r=r.parent;return t}function Ca(t,e,r,i){return t._startAt&&(L?t._startAt.revert(ht):t.vars.immediateRender&&!t.vars.autoRevert||t._startAt.render(e,!0,i))}function Ea(t){return t._repeat?Tt(t._tTime,t=t.duration()+t._rDelay)*t:0}function Ga(t,e){return(t-e._start)*e._ts+(0<=e._ts?0:e._dirty?e.totalDuration():e._tDur)}function Ha(t){return t._end=ja(t._start+(t._tDur/Math.abs(t._ts||t._rts||X)||0))}function Ia(t,e){var r=t._dp;return r&&r.smoothChildTiming&&t._ts&&(t._start=ja(r._time-(0<t._ts?e/t._ts:((t._dirty?t.totalDuration():t._tDur)-e)/-t._ts)),Ha(t),r._dirty||Aa(r,t)),t}function Ja(t,e){var r;if((e._time||!e._dur&&e._initted||e._start<t._time&&(e._dur||!e.add))&&(r=Ga(t.rawTime(),e),(!e._dur||Ot(0,e.totalDuration(),r)-e._tTime>X)&&e.render(r,!0)),Aa(t,e)._dp&&t._initted&&t._time>=t._dur&&t._ts){if(t._dur<t.duration())for(r=t;r._dp;)0<=r.rawTime()&&r.totalTime(r._tTime),r=r._dp;t._zTime=-X}}function Ka(e,r,i,n){return r.parent&&za(r),r._start=ja((t(i)?i:i||e!==I?xt(e,i,r):e._time)+r._delay),r._end=ja(r._start+(r.totalDuration()/Math.abs(r.timeScale())||0)),xa(e,r,"_first","_last",e._sort?"_start":0),bt(r)||(e._recent=r),n||Ja(e,r),e._ts<0&&Ia(e,e._tTime),e}function La(t,e){return(ot.ScrollTrigger||Q("scrollTrigger",e))&&ot.ScrollTrigger.create(e,t)}function Ma(t,e,r,i,n){return Qt(t,e,n),t._initted?!r&&t._pt&&!L&&(t._dur&&!1!==t.vars.lazy||!t._dur&&t.vars.lazy)&&f!==Rt.frame?(dt.push(t),t._lazy=[n,i],1):void 0:1}function Ra(t,e,r,i){var n=t._repeat,a=ja(e)||0,s=t._tTime/t._tDur;return s&&!i&&(t._time*=a/t._dur),t._dur=a,t._tDur=n?n<0?1e10:ja(a*(n+1)+t._rDelay*n):a,0<s&&!i&&Ia(t,t._tTime=t._tDur*s),t.parent&&Ha(t),r||Aa(t.parent,t),t}function Sa(t){return t instanceof Xt?Aa(t):Ra(t,t._dur)}function Va(e,r,i){var n,a,s=t(r[1]),o=(s?2:1)+(e<2?0:1),u=r[o];if(s&&(u.duration=r[1]),u.parent=i,e){for(n=u,a=i;a&&!("immediateRender"in n);)n=a.vars.defaults||{},a=w(a.vars.inherit)&&a.parent;u.immediateRender=w(n.immediateRender),e<2?u.runBackwards=1:u.startAt=r[o-1]}return new $t(r[0],u,r[1+o])}function Wa(t,e){return t||0===t?e(t):e}function Ya(t,e){return r(t)&&(e=st.exec(t))?e[1]:""}function _a(t,e){return t&&v(t)&&"length"in t&&(!e&&!t.length||t.length-1 in t&&v(t[0]))&&!t.nodeType&&t!==h}function cb(r){return r=Mt(r)[0]||R("Invalid scope")||{},function(t){var e=r.current||r.nativeElement||r;return Mt(t,e.querySelectorAll?e:e===r?R("Invalid scope")||a.createElement("div"):r)}}function db(t){return t.sort(function(){return.5-Math.random()})}function eb(t){if(s(t))return t;var p=v(t)?t:{each:t},_=jt(p.ease),m=p.from||0,g=parseFloat(p.base)||0,y={},e=0<m&&m<1,T=isNaN(m)||e,b=p.axis,w=m,x=m;return r(m)?w=x={center:.5,edges:.5,end:1}[m]||0:!e&&T&&(w=m[0],x=m[1]),function(t,e,r){var i,n,a,s,o,u,h,l,f,d=(r||p).length,c=y[d];if(!c){if(!(f="auto"===p.grid?0:(p.grid||[1,U])[1])){for(h=-U;h<(h=r[f++].getBoundingClientRect().left)&&f<d;);f<d&&f--}for(c=y[d]=[],i=T?Math.min(f,d)*w-.5:m%f,n=f===U?0:T?d*x/f-.5:m/f|0,l=U,u=h=0;u<d;u++)a=u%f-i,s=n-(u/f|0),c[u]=o=b?Math.abs("y"===b?s:a):K(a*a+s*s),h<o&&(h=o),o<l&&(l=o);"random"===m&&db(c),c.max=h-l,c.min=l,c.v=d=(parseFloat(p.amount)||parseFloat(p.each)*(d<f?d-1:b?"y"===b?d/f:f:Math.max(f,d/f))||0)*("edges"===m?-1:1),c.b=d<0?g-d:g,c.u=Ya(p.amount||p.each)||0,_=_&&d<0?Yt(_):_}return d=(c[t]-c.min)/c.max||0,ja(c.b+(_?_(d):d)*c.v)+c.u}}function fb(i){var n=Math.pow(10,((i+"").split(".")[1]||"").length);return function(e){var r=ja(Math.round(parseFloat(e)/i)*i*n);return(r-r%1)/n+(t(e)?0:Ya(e))}}function gb(h,e){var l,f,r=Z(h);return!r&&v(h)&&(l=r=h.radius||U,h.values?(h=Mt(h.values),(f=!t(h[0]))&&(l*=l)):h=fb(h.increment)),Wa(e,r?s(h)?function(t){return f=h(t),Math.abs(f-t)<=l?f:t}:function(e){for(var r,i,n=parseFloat(f?e.x:e),a=parseFloat(f?e.y:0),s=U,o=0,u=h.length;u--;)(r=f?(r=h[u].x-n)*r+(i=h[u].y-a)*i:Math.abs(h[u]-n))<s&&(s=r,o=u);return o=!l||s<=l?h[o]:e,f||o===e||t(e)?o:o+Ya(e)}:fb(h))}function hb(t,e,r,i){return Wa(Z(t)?!e:!0===r?!!(r=0):!i,function(){return Z(t)?t[~~(Math.random()*t.length)]:(r=r||1e-5)&&(i=r<1?Math.pow(10,(r+"").length-2):1)&&Math.floor(Math.round((t-r/2+Math.random()*(e-t+.99*r))/r)*r*i)/i})}function lb(e,r,t){return Wa(t,function(t){return e[~~r(t)]})}function ob(t){for(var e,r,i,n,a=0,s="";~(e=t.indexOf("random(",a));)i=t.indexOf(")",e),n="["===t.charAt(e+7),r=t.substr(e+7,i-e-7).match(n?at:tt),s+=t.substr(a,e-a)+hb(n?r:+r[0],n?0:+r[1],+r[2]||1e-5),a=i+1;return s+t.substr(a,t.length-a)}function rb(t,e,r){var i,n,a,s=t.labels,o=U;for(i in s)(n=s[i]-e)<0==!!r&&n&&o>(n=Math.abs(n))&&(a=i,o=n);return a}function tb(t){return za(t),t.scrollTrigger&&t.scrollTrigger.kill(!!L),t.progress()<1&&Ct(t,"onInterrupt"),t}function wb(t){if(t)if(t=!t.name&&t.default||t,x()||t.headless){var e=t.name,r=s(t),i=e&&!r&&t.init?function(){this._props=[]}:t,n={init:T,render:he,add:Wt,kill:ce,modifier:fe,rawVars:0},a={targetTest:0,get:0,getSetter:ne,aliases:{},register:0};if(Ft(),t!==i){if(pt[e])return;qa(i,qa(ua(t,n),a)),yt(i.prototype,yt(n,ua(t,a))),pt[i.prop=e]=i,t.targetTest&&(gt.push(i),ft[e]=1),e=("css"===e?"CSS":e.charAt(0).toUpperCase()+e.substr(1))+"Plugin"}S(e,i),t.register&&t.register(ze,i,_e)}else At.push(t)}function zb(t,e,r){return(6*(t+=t<0?1:1<t?-1:0)<1?e+(r-e)*t*6:t<.5?r:3*t<2?e+(r-e)*(2/3-t)*6:e)*St+.5|0}function Ab(e,r,i){var n,a,s,o,u,h,l,f,d,c,p=e?t(e)?[e>>16,e>>8&St,e&St]:0:zt.black;if(!p){if(","===e.substr(-1)&&(e=e.substr(0,e.length-1)),zt[e])p=zt[e];else if("#"===e.charAt(0)){if(e.length<6&&(e="#"+(n=e.charAt(1))+n+(a=e.charAt(2))+a+(s=e.charAt(3))+s+(5===e.length?e.charAt(4)+e.charAt(4):"")),9===e.length)return[(p=parseInt(e.substr(1,6),16))>>16,p>>8&St,p&St,parseInt(e.substr(7),16)/255];p=[(e=parseInt(e.substr(1),16))>>16,e>>8&St,e&St]}else if("hsl"===e.substr(0,3))if(p=c=e.match(tt),r){if(~e.indexOf("="))return p=e.match(et),i&&p.length<4&&(p[3]=1),p}else o=+p[0]%360/360,u=p[1]/100,n=2*(h=p[2]/100)-(a=h<=.5?h*(u+1):h+u-h*u),3<p.length&&(p[3]*=1),p[0]=zb(o+1/3,n,a),p[1]=zb(o,n,a),p[2]=zb(o-1/3,n,a);else p=e.match(tt)||zt.transparent;p=p.map(Number)}return r&&!c&&(n=p[0]/St,a=p[1]/St,s=p[2]/St,h=((l=Math.max(n,a,s))+(f=Math.min(n,a,s)))/2,l===f?o=u=0:(d=l-f,u=.5<h?d/(2-l-f):d/(l+f),o=l===n?(a-s)/d+(a<s?6:0):l===a?(s-n)/d+2:(n-a)/d+4,o*=60),p[0]=~~(o+.5),p[1]=~~(100*u+.5),p[2]=~~(100*h+.5)),i&&p.length<4&&(p[3]=1),p}function Bb(t){var r=[],i=[],n=-1;return t.split(Et).forEach(function(t){var e=t.match(rt)||[];r.push.apply(r,e),i.push(n+=e.length+1)}),r.c=i,r}function Cb(t,e,r){var i,n,a,s,o="",u=(t+o).match(Et),h=e?"hsla(":"rgba(",l=0;if(!u)return t;if(u=u.map(function(t){return(t=Ab(t,e,1))&&h+(e?t[0]+","+t[1]+"%,"+t[2]+"%,"+t[3]:t.join(","))+")"}),r&&(a=Bb(t),(i=r.c).join(o)!==a.c.join(o)))for(s=(n=t.replace(Et,"1").split(rt)).length-1;l<s;l++)o+=n[l]+(~i.indexOf(l)?u.shift()||h+"0,0,0,0)":(a.length?a:u.length?u:r).shift());if(!n)for(s=(n=t.split(Et)).length-1;l<s;l++)o+=n[l]+u[l];return o+n[s]}function Fb(t){var e,r=t.join(" ");if(Et.lastIndex=0,Et.test(r))return e=Dt.test(r),t[1]=Cb(t[1],e),t[0]=Cb(t[0],e,Bb(t[1])),!0}function Ob(t){var e=(t+"").split("("),r=Lt[e[0]];return r&&1<e.length&&r.config?r.config.apply(null,~t.indexOf("{")?[function _parseObjectInString(t){for(var e,r,i,n={},a=t.substr(1,t.length-3).split(":"),s=a[0],o=1,u=a.length;o<u;o++)r=a[o],e=o!==u-1?r.lastIndexOf(","):r.length,i=r.substr(0,e),n[s]=isNaN(i)?i.replace(Bt,"").trim():+i,s=r.substr(e+1).trim();return n}(e[1])]:function _valueInParentheses(t){var e=t.indexOf("(")+1,r=t.indexOf(")"),i=t.indexOf("(",e);return t.substring(e,~i&&i<r?t.indexOf(")",r+1):r)}(t).split(",").map(oa)):Lt._CE&&It.test(t)?Lt._CE("",t):r}function Qb(t,e){for(var r,i=t._first;i;)i instanceof Xt?Qb(i,e):!i.vars.yoyoEase||i._yoyo&&i._repeat||i._yoyo===e||(i.timeline?Qb(i.timeline,e):(r=i._ease,i._ease=i._yEase,i._yEase=r,i._yoyo=e)),i=i._next}function Sb(t,e,r,i){void 0===r&&(r=function easeOut(t){return 1-e(1-t)}),void 0===i&&(i=function easeInOut(t){return t<.5?e(2*t)/2:1-e(2*(1-t))/2});var n,a={easeIn:e,easeOut:r,easeInOut:i};return ha(t,function(t){for(var e in Lt[t]=ot[t]=a,Lt[n=t.toLowerCase()]=r,a)Lt[n+("easeIn"===e?".in":"easeOut"===e?".out":".inOut")]=Lt[t+"."+e]=a[e]}),a}function Tb(e){return function(t){return t<.5?(1-e(1-2*t))/2:.5+e(2*(t-.5))/2}}function Ub(r,t,e){function Jm(t){return 1===t?1:i*Math.pow(2,-10*t)*H((t-a)*n)+1}var i=1<=t?t:1,n=(e||(r?.3:.45))/(t<1?t:1),a=n/N*(Math.asin(1/i)||0),s="out"===r?Jm:"in"===r?function(t){return 1-Jm(1-t)}:Tb(Jm);return n=N/n,s.config=function(t,e){return Ub(r,t,e)},s}function Vb(e,r){function Rm(t){return t?--t*t*((r+1)*t+r)+1:0}void 0===r&&(r=1.70158);var t="out"===e?Rm:"in"===e?function(t){return 1-Rm(1-t)}:Tb(Rm);return t.config=function(t){return Vb(e,t)},t}var F,L,l,I,h,n,a,i,o,f,d,c,p,_,m,g,b,O,k,M,C,A,z,E,D,B,Y,j,q={autoSleep:120,force3D:"auto",nullTargetWarn:1,units:{lineHeight:""}},V={duration:.5,overwrite:!1,delay:0},U=1e8,X=1/U,N=2*Math.PI,G=N/4,W=0,K=Math.sqrt,J=Math.cos,H=Math.sin,$="function"==typeof ArrayBuffer&&ArrayBuffer.isView||function(){},Z=Array.isArray,tt=/(?:-?\.?\d|\.)+/gi,et=/[-+=.]*\d+[.e\-+]*\d*[e\-+]*\d*/g,rt=/[-+=.]*\d+[.e-]*\d*[a-z%]*/g,it=/[-+=.]*\d+\.?\d*(?:e-|e\+)?\d*/gi,nt=/[+-]=-?[.\d]+/,at=/[^,'"\[\]\s]+/gi,st=/^[+\-=e\s\d]*\d+[.\d]*([a-z]*|%)\s*$/i,ot={},ut={suppressEvents:!0,isStart:!0,kill:!1},ht={suppressEvents:!0,kill:!1},lt={suppressEvents:!0},ft={},dt=[],ct={},pt={},_t={},mt=30,gt=[],vt="",yt=function _merge(t,e){for(var r in e)t[r]=e[r];return t},Tt=function _animationCycle(t,e){var r=Math.floor(t/=e);return t&&r===t?r-1:r},bt=function _isFromOrFromStart(t){var e=t.data;return"isFromStart"===e||"isStart"===e},wt={_start:0,endTime:T,totalDuration:T},xt=function _parsePosition(t,e,i){var n,a,s,o=t.labels,u=t._recent||wt,h=t.duration()>=U?u.endTime(!1):t._dur;return r(e)&&(isNaN(e)||e in o)?(a=e.charAt(0),s="%"===e.substr(-1),n=e.indexOf("="),"<"===a||">"===a?(0<=n&&(e=e.replace(/=/,"")),("<"===a?u._start:u.endTime(0<=u._repeat))+(parseFloat(e.substr(1))||0)*(s?(n<0?u:i).totalDuration()/100:1)):n<0?(e in o||(o[e]=h),o[e]):(a=parseFloat(e.charAt(n-1)+e.substr(n+1)),s&&i&&(a=a/100*(Z(i)?i[0]:i).totalDuration()),1<n?_parsePosition(t,e.substr(0,n-1),i)+a:h+a)):null==e?h:+e},Ot=function _clamp(t,e,r){return r<t?t:e<r?e:r},kt=[].slice,Mt=function toArray(t,e,i){return l&&!e&&l.selector?l.selector(t):!r(t)||i||!n&&Ft()?Z(t)?function _flatten(t,e,i){return void 0===i&&(i=[]),t.forEach(function(t){return r(t)&&!e||_a(t,1)?i.push.apply(i,Mt(t)):i.push(t)})||i}(t,i):_a(t)?kt.call(t,0):t?[t]:[]:kt.call((e||a).querySelectorAll(t),0)},Pt=function mapRange(e,t,r,i,n){var a=t-e,s=i-r;return Wa(n,function(t){return r+((t-e)/a*s||0)})},Ct=function _callback(t,e,r){var i,n,a,s=t.vars,o=s[e],u=l,h=t._ctx;if(o)return i=s[e+"Params"],n=s.callbackScope||t,r&&dt.length&&ma(),h&&(l=h),a=i?o.apply(n,i):o.call(n),l=u,a},At=[],St=255,zt={aqua:[0,St,St],lime:[0,St,0],silver:[192,192,192],black:[0,0,0],maroon:[128,0,0],teal:[0,128,128],blue:[0,0,St],navy:[0,0,128],white:[St,St,St],olive:[128,128,0],yellow:[St,St,0],orange:[St,165,0],gray:[128,128,128],purple:[128,0,128],green:[0,128,0],red:[St,0,0],pink:[St,192,203],cyan:[0,St,St],transparent:[St,St,St,0]},Et=function(){var t,e="(?:\\b(?:(?:rgb|rgba|hsl|hsla)\\(.+?\\))|\\B#(?:[0-9a-f]{3,4}){1,2}\\b";for(t in zt)e+="|"+t+"\\b";return new RegExp(e+")","gi")}(),Dt=/hsl[a]?\(/,Rt=(k=Date.now,M=500,C=33,A=k(),z=A,D=E=1e3/240,g={time:0,frame:0,tick:function tick(){yl(!0)},deltaRatio:function deltaRatio(t){return b/(1e3/(t||60))},wake:function wake(){o&&(!n&&x()&&(h=n=window,a=h.document||{},ot.gsap=ze,(h.gsapVersions||(h.gsapVersions=[])).push(ze.version),P(i||h.GreenSockGlobals||!h.gsap&&h||{}),At.forEach(wb)),m="undefined"!=typeof requestAnimationFrame&&requestAnimationFrame,p&&g.sleep(),_=m||function(t){return setTimeout(t,D-1e3*g.time+1|0)},c=1,yl(2))},sleep:function sleep(){(m?cancelAnimationFrame:clearTimeout)(p),c=0,_=T},lagSmoothing:function lagSmoothing(t,e){M=t||1/0,C=Math.min(e||33,M)},fps:function fps(t){E=1e3/(t||240),D=1e3*g.time+E},add:function add(n,t,e){var a=t?function(t,e,r,i){n(t,e,r,i),g.remove(a)}:n;return g.remove(n),B[e?"unshift":"push"](a),Ft(),a},remove:function remove(t,e){~(e=B.indexOf(t))&&B.splice(e,1)&&e<=O&&O--},_listeners:B=[]}),Ft=function _wake(){return!c&&Rt.wake()},Lt={},It=/^[\d.\-M][\d.\-,\s]/,Bt=/["']/g,Yt=function _invertEase(e){return function(t){return 1-e(1-t)}},jt=function _parseEase(t,e){return t&&(s(t)?t:Lt[t]||Ob(t))||e};function yl(t){var e,r,i,n,a=k()-z,s=!0===t;if((M<a||a<0)&&(A+=a-C),(0<(e=(i=(z+=a)-A)-D)||s)&&(n=++g.frame,b=i-1e3*g.time,g.time=i/=1e3,D+=e+(E<=e?4:E-e),r=1),s||(p=_(yl)),r)for(O=0;O<B.length;O++)B[O](i,b,n,t)}function gn(t){return t<j?Y*t*t:t<.7272727272727273?Y*Math.pow(t-1.5/2.75,2)+.75:t<.9090909090909092?Y*(t-=2.25/2.75)*t+.9375:Y*Math.pow(t-2.625/2.75,2)+.984375}ha("Linear,Quad,Cubic,Quart,Quint,Strong",function(t,e){var r=e<5?e+1:e;Sb(t+",Power"+(r-1),e?function(t){return Math.pow(t,r)}:function(t){return t},function(t){return 1-Math.pow(1-t,r)},function(t){return t<.5?Math.pow(2*t,r)/2:1-Math.pow(2*(1-t),r)/2})}),Lt.Linear.easeNone=Lt.none=Lt.Linear.easeIn,Sb("Elastic",Ub("in"),Ub("out"),Ub()),Y=7.5625,j=1/2.75,Sb("Bounce",function(t){return 1-gn(1-t)},gn),Sb("Expo",function(t){return t?Math.pow(2,10*(t-1)):0}),Sb("Circ",function(t){return-(K(1-t*t)-1)}),Sb("Sine",function(t){return 1===t?1:1-J(t*G)}),Sb("Back",Vb("in"),Vb("out"),Vb()),Lt.SteppedEase=Lt.steps=ot.SteppedEase={config:function config(t,e){void 0===t&&(t=1);var r=1/t,i=t+(e?0:1),n=e?1:0;return function(t){return((i*Ot(0,.99999999,t)|0)+n)*r}}},V.ease=Lt["quad.out"],ha("onComplete,onUpdate,onStart,onRepeat,onReverseComplete,onInterrupt",function(t){return vt+=t+","+t+"Params,"});var qt,Vt=function GSCache(t,e){this.id=W++,(t._gsap=this).target=t,this.harness=e,this.get=e?e.get:ga,this.set=e?e.getSetter:ne},Ut=((qt=Animation.prototype).delay=function delay(t){return t||0===t?(this.parent&&this.parent.smoothChildTiming&&this.startTime(this._start+t-this._delay),this._delay=t,this):this._delay},qt.duration=function duration(t){return arguments.length?this.totalDuration(0<this._repeat?t+(t+this._rDelay)*this._repeat:t):this.totalDuration()&&this._dur},qt.totalDuration=function totalDuration(t){return arguments.length?(this._dirty=0,Ra(this,this._repeat<0?t:(t-this._repeat*this._rDelay)/(this._repeat+1))):this._tDur},qt.totalTime=function totalTime(t,e){if(Ft(),!arguments.length)return this._tTime;var r=this._dp;if(r&&r.smoothChildTiming&&this._ts){for(Ia(this,t),!r._dp||r.parent||Ja(r,this);r&&r.parent;)r.parent._time!==r._start+(0<=r._ts?r._tTime/r._ts:(r.totalDuration()-r._tTime)/-r._ts)&&r.totalTime(r._tTime,!0),r=r.parent;!this.parent&&this._dp.autoRemoveChildren&&(0<this._ts&&t<this._tDur||this._ts<0&&0<t||!this._tDur&&!t)&&Ka(this._dp,this,this._start-this._delay)}return(this._tTime!==t||!this._dur&&!e||this._initted&&Math.abs(this._zTime)===X||!t&&!this._initted&&(this.add||this._ptLookup))&&(this._ts||(this._pTime=t),na(this,t,e)),this},qt.time=function time(t,e){return arguments.length?this.totalTime(Math.min(this.totalDuration(),t+Ea(this))%(this._dur+this._rDelay)||(t?this._dur:0),e):this._time},qt.totalProgress=function totalProgress(t,e){return arguments.length?this.totalTime(this.totalDuration()*t,e):this.totalDuration()?Math.min(1,this._tTime/this._tDur):0<this.rawTime()?1:0},qt.progress=function progress(t,e){return arguments.length?this.totalTime(this.duration()*(!this._yoyo||1&this.iteration()?t:1-t)+Ea(this),e):this.duration()?Math.min(1,this._time/this._dur):0<this.rawTime()?1:0},qt.iteration=function iteration(t,e){var r=this.duration()+this._rDelay;return arguments.length?this.totalTime(this._time+(t-1)*r,e):this._repeat?Tt(this._tTime,r)+1:1},qt.timeScale=function timeScale(t,e){if(!arguments.length)return this._rts===-X?0:this._rts;if(this._rts===t)return this;var r=this.parent&&this._ts?Ga(this.parent._time,this):this._tTime;return this._rts=+t||0,this._ts=this._ps||t===-X?0:this._rts,this.totalTime(Ot(-Math.abs(this._delay),this._tDur,r),!1!==e),Ha(this),function _recacheAncestors(t){for(var e=t.parent;e&&e.parent;)e._dirty=1,e.totalDuration(),e=e.parent;return t}(this)},qt.paused=function paused(t){return arguments.length?(this._ps!==t&&((this._ps=t)?(this._pTime=this._tTime||Math.max(-this._delay,this.rawTime()),this._ts=this._act=0):(Ft(),this._ts=this._rts,this.totalTime(this.parent&&!this.parent.smoothChildTiming?this.rawTime():this._tTime||this._pTime,1===this.progress()&&Math.abs(this._zTime)!==X&&(this._tTime-=X)))),this):this._ps},qt.startTime=function startTime(t){if(arguments.length){this._start=t;var e=this.parent||this._dp;return!e||!e._sort&&this.parent||Ka(e,this,t-this._delay),this}return this._start},qt.endTime=function endTime(t){return this._start+(w(t)?this.totalDuration():this.duration())/Math.abs(this._ts||1)},qt.rawTime=function rawTime(t){var e=this.parent||this._dp;return e?t&&(!this._ts||this._repeat&&this._time&&this.totalProgress()<1)?this._tTime%(this._dur+this._rDelay):this._ts?Ga(e.rawTime(t),this):this._tTime:this._tTime},qt.revert=function revert(t){void 0===t&&(t=lt);var e=L;return L=t,(this._initted||this._startAt)&&(this.timeline&&this.timeline.revert(t),this.totalTime(-.01,t.suppressEvents)),"nested"!==this.data&&!1!==t.kill&&this.kill(),L=e,this},qt.globalTime=function globalTime(t){for(var e=this,r=arguments.length?t:e.rawTime();e;)r=e._start+r/(Math.abs(e._ts)||1),e=e._dp;return!this.parent&&this._sat?this._sat.globalTime(t):r},qt.repeat=function repeat(t){return arguments.length?(this._repeat=t===1/0?-2:t,Sa(this)):-2===this._repeat?1/0:this._repeat},qt.repeatDelay=function repeatDelay(t){if(arguments.length){var e=this._time;return this._rDelay=t,Sa(this),e?this.time(e):this}return this._rDelay},qt.yoyo=function yoyo(t){return arguments.length?(this._yoyo=t,this):this._yoyo},qt.seek=function seek(t,e){return this.totalTime(xt(this,t),w(e))},qt.restart=function restart(t,e){return this.play().totalTime(t?-this._delay:0,w(e))},qt.play=function play(t,e){return null!=t&&this.seek(t,e),this.reversed(!1).paused(!1)},qt.reverse=function reverse(t,e){return null!=t&&this.seek(t||this.totalDuration(),e),this.reversed(!0).paused(!1)},qt.pause=function pause(t,e){return null!=t&&this.seek(t,e),this.paused(!0)},qt.resume=function resume(){return this.paused(!1)},qt.reversed=function reversed(t){return arguments.length?(!!t!==this.reversed()&&this.timeScale(-this._rts||(t?-X:0)),this):this._rts<0},qt.invalidate=function invalidate(){return this._initted=this._act=0,this._zTime=-X,this},qt.isActive=function isActive(){var t,e=this.parent||this._dp,r=this._start;return!(e&&!(this._ts&&this._initted&&e.isActive()&&(t=e.rawTime(!0))>=r&&t<this.endTime(!0)-X))},qt.eventCallback=function eventCallback(t,e,r){var i=this.vars;return 1<arguments.length?(e?(i[t]=e,r&&(i[t+"Params"]=r),"onUpdate"===t&&(this._onUpdate=e)):delete i[t],this):i[t]},qt.then=function then(t){var i=this;return new Promise(function(e){function Co(){var t=i.then;i.then=null,s(r)&&(r=r(i))&&(r.then||r===i)&&(i.then=t),e(r),i.then=t}var r=s(t)?t:pa;i._initted&&1===i.totalProgress()&&0<=i._ts||!i._tTime&&i._ts<0?Co():i._prom=Co})},qt.kill=function kill(){tb(this)},Animation);function Animation(t){this.vars=t,this._delay=+t.delay||0,(this._repeat=t.repeat===1/0?-2:t.repeat||0)&&(this._rDelay=t.repeatDelay||0,this._yoyo=!!t.yoyo||!!t.yoyoEase),this._ts=1,Ra(this,+t.duration,1,1),this.data=t.data,l&&(this._ctx=l).data.push(this),c||Rt.wake()}qa(Ut.prototype,{_time:0,_start:0,_end:0,_tTime:0,_tDur:0,_dirty:0,_repeat:0,_yoyo:!1,parent:null,_initted:!1,_rDelay:0,_ts:1,_dp:0,ratio:0,_zTime:-X,_prom:0,_ps:!1,_rts:1});var Xt=function(i){function Timeline(t,e){var r;return void 0===t&&(t={}),(r=i.call(this,t)||this).labels={},r.smoothChildTiming=!!t.smoothChildTiming,r.autoRemoveChildren=!!t.autoRemoveChildren,r._sort=w(t.sortChildren),I&&Ka(t.parent||I,_assertThisInitialized(r),e),t.reversed&&r.reverse(),t.paused&&r.paused(!0),t.scrollTrigger&&La(_assertThisInitialized(r),t.scrollTrigger),r}_inheritsLoose(Timeline,i);var e=Timeline.prototype;return e.to=function to(t,e,r){return Va(0,arguments,this),this},e.from=function from(t,e,r){return Va(1,arguments,this),this},e.fromTo=function fromTo(t,e,r,i){return Va(2,arguments,this),this},e.set=function set(t,e,r){return e.duration=0,e.parent=this,va(e).repeatDelay||(e.repeat=0),e.immediateRender=!!e.immediateRender,new $t(t,e,xt(this,r),1),this},e.call=function call(t,e,r){return Ka(this,$t.delayedCall(0,t,e),r)},e.staggerTo=function staggerTo(t,e,r,i,n,a,s){return r.duration=e,r.stagger=r.stagger||i,r.onComplete=a,r.onCompleteParams=s,r.parent=this,new $t(t,r,xt(this,n)),this},e.staggerFrom=function staggerFrom(t,e,r,i,n,a,s){return r.runBackwards=1,va(r).immediateRender=w(r.immediateRender),this.staggerTo(t,e,r,i,n,a,s)},e.staggerFromTo=function staggerFromTo(t,e,r,i,n,a,s,o){return i.startAt=r,va(i).immediateRender=w(i.immediateRender),this.staggerTo(t,e,i,n,a,s,o)},e.render=function render(t,e,r){var i,n,a,s,o,u,h,l,f,d,c,p,_=this._time,m=this._dirty?this.totalDuration():this._tDur,g=this._dur,v=t<=0?0:ja(t),y=this._zTime<0!=t<0&&(this._initted||!g);if(this!==I&&m<v&&0<=t&&(v=m),v!==this._tTime||r||y){if(_!==this._time&&g&&(v+=this._time-_,t+=this._time-_),i=v,f=this._start,u=!(l=this._ts),y&&(g||(_=this._zTime),!t&&e||(this._zTime=t)),this._repeat){if(c=this._yoyo,o=g+this._rDelay,this._repeat<-1&&t<0)return this.totalTime(100*o+t,e,r);if(i=ja(v%o),v===m?(s=this._repeat,i=g):((s=~~(v/o))&&s===v/o&&(i=g,s--),g<i&&(i=g)),d=Tt(this._tTime,o),!_&&this._tTime&&d!==s&&this._tTime-d*o-this._dur<=0&&(d=s),c&&1&s&&(i=g-i,p=1),s!==d&&!this._lock){var T=c&&1&d,b=T===(c&&1&s);if(s<d&&(T=!T),_=T?0:v%g?g:v,this._lock=1,this.render(_||(p?0:ja(s*o)),e,!g)._lock=0,this._tTime=v,!e&&this.parent&&Ct(this,"onRepeat"),this.vars.repeatRefresh&&!p&&(this.invalidate()._lock=1),_&&_!==this._time||u!=!this._ts||this.vars.onRepeat&&!this.parent&&!this._act)return this;if(g=this._dur,m=this._tDur,b&&(this._lock=2,_=T?g:-1e-4,this.render(_,!0),this.vars.repeatRefresh&&!p&&this.invalidate()),this._lock=0,!this._ts&&!u)return this;Qb(this,p)}}if(this._hasPause&&!this._forcing&&this._lock<2&&(h=function _findNextPauseTween(t,e,r){var i;if(e<r)for(i=t._first;i&&i._start<=r;){if("isPause"===i.data&&i._start>e)return i;i=i._next}else for(i=t._last;i&&i._start>=r;){if("isPause"===i.data&&i._start<e)return i;i=i._prev}}(this,ja(_),ja(i)))&&(v-=i-(i=h._start)),this._tTime=v,this._time=i,this._act=!l,this._initted||(this._onUpdate=this.vars.onUpdate,this._initted=1,this._zTime=t,_=0),!_&&i&&!e&&!s&&(Ct(this,"onStart"),this._tTime!==v))return this;if(_<=i&&0<=t)for(n=this._first;n;){if(a=n._next,(n._act||i>=n._start)&&n._ts&&h!==n){if(n.parent!==this)return this.render(t,e,r);if(n.render(0<n._ts?(i-n._start)*n._ts:(n._dirty?n.totalDuration():n._tDur)+(i-n._start)*n._ts,e,r),i!==this._time||!this._ts&&!u){h=0,a&&(v+=this._zTime=-X);break}}n=a}else{n=this._last;for(var w=t<0?t:i;n;){if(a=n._prev,(n._act||w<=n._end)&&n._ts&&h!==n){if(n.parent!==this)return this.render(t,e,r);if(n.render(0<n._ts?(w-n._start)*n._ts:(n._dirty?n.totalDuration():n._tDur)+(w-n._start)*n._ts,e,r||L&&(n._initted||n._startAt)),i!==this._time||!this._ts&&!u){h=0,a&&(v+=this._zTime=w?-X:X);break}}n=a}}if(h&&!e&&(this.pause(),h.render(_<=i?0:-X)._zTime=_<=i?1:-1,this._ts))return this._start=f,Ha(this),this.render(t,e,r);this._onUpdate&&!e&&Ct(this,"onUpdate",!0),(v===m&&this._tTime>=this.totalDuration()||!v&&_)&&(f!==this._start&&Math.abs(l)===Math.abs(this._ts)||this._lock||(!t&&g||!(v===m&&0<this._ts||!v&&this._ts<0)||za(this,1),e||t<0&&!_||!v&&!_&&m||(Ct(this,v===m&&0<=t?"onComplete":"onReverseComplete",!0),!this._prom||v<m&&0<this.timeScale()||this._prom())))}return this},e.add=function add(e,i){var n=this;if(t(i)||(i=xt(this,i,e)),!(e instanceof Ut)){if(Z(e))return e.forEach(function(t){return n.add(t,i)}),this;if(r(e))return this.addLabel(e,i);if(!s(e))return this;e=$t.delayedCall(0,e)}return this!==e?Ka(this,e,i):this},e.getChildren=function getChildren(t,e,r,i){void 0===t&&(t=!0),void 0===e&&(e=!0),void 0===r&&(r=!0),void 0===i&&(i=-U);for(var n=[],a=this._first;a;)a._start>=i&&(a instanceof $t?e&&n.push(a):(r&&n.push(a),t&&n.push.apply(n,a.getChildren(!0,e,r)))),a=a._next;return n},e.getById=function getById(t){for(var e=this.getChildren(1,1,1),r=e.length;r--;)if(e[r].vars.id===t)return e[r]},e.remove=function remove(t){return r(t)?this.removeLabel(t):s(t)?this.killTweensOf(t):(ya(this,t),t===this._recent&&(this._recent=this._last),Aa(this))},e.totalTime=function totalTime(t,e){return arguments.length?(this._forcing=1,!this._dp&&this._ts&&(this._start=ja(Rt.time-(0<this._ts?t/this._ts:(this.totalDuration()-t)/-this._ts))),i.prototype.totalTime.call(this,t,e),this._forcing=0,this):this._tTime},e.addLabel=function addLabel(t,e){return this.labels[t]=xt(this,e),this},e.removeLabel=function removeLabel(t){return delete this.labels[t],this},e.addPause=function addPause(t,e,r){var i=$t.delayedCall(0,e||T,r);return i.data="isPause",this._hasPause=1,Ka(this,i,xt(this,t))},e.removePause=function removePause(t){var e=this._first;for(t=xt(this,t);e;)e._start===t&&"isPause"===e.data&&za(e),e=e._next},e.killTweensOf=function killTweensOf(t,e,r){for(var i=this.getTweensOf(t,r),n=i.length;n--;)Nt!==i[n]&&i[n].kill(t,e);return this},e.getTweensOf=function getTweensOf(e,r){for(var i,n=[],a=Mt(e),s=this._first,o=t(r);s;)s instanceof $t?la(s._targets,a)&&(o?(!Nt||s._initted&&s._ts)&&s.globalTime(0)<=r&&s.globalTime(s.totalDuration())>r:!r||s.isActive())&&n.push(s):(i=s.getTweensOf(a,r)).length&&n.push.apply(n,i),s=s._next;return n},e.tweenTo=function tweenTo(t,e){e=e||{};var r,i=this,n=xt(i,t),a=e.startAt,s=e.onStart,o=e.onStartParams,u=e.immediateRender,h=$t.to(i,qa({ease:e.ease||"none",lazy:!1,immediateRender:!1,time:n,overwrite:"auto",duration:e.duration||Math.abs((n-(a&&"time"in a?a.time:i._time))/i.timeScale())||X,onStart:function onStart(){if(i.pause(),!r){var t=e.duration||Math.abs((n-(a&&"time"in a?a.time:i._time))/i.timeScale());h._dur!==t&&Ra(h,t,0,1).render(h._time,!0,!0),r=1}s&&s.apply(h,o||[])}},e));return u?h.render(0):h},e.tweenFromTo=function tweenFromTo(t,e,r){return this.tweenTo(e,qa({startAt:{time:xt(this,t)}},r))},e.recent=function recent(){return this._recent},e.nextLabel=function nextLabel(t){return void 0===t&&(t=this._time),rb(this,xt(this,t))},e.previousLabel=function previousLabel(t){return void 0===t&&(t=this._time),rb(this,xt(this,t),1)},e.currentLabel=function currentLabel(t){return arguments.length?this.seek(t,!0):this.previousLabel(this._time+X)},e.shiftChildren=function shiftChildren(t,e,r){void 0===r&&(r=0);for(var i,n=this._first,a=this.labels;n;)n._start>=r&&(n._start+=t,n._end+=t),n=n._next;if(e)for(i in a)a[i]>=r&&(a[i]+=t);return Aa(this)},e.invalidate=function invalidate(t){var e=this._first;for(this._lock=0;e;)e.invalidate(t),e=e._next;return i.prototype.invalidate.call(this,t)},e.clear=function clear(t){void 0===t&&(t=!0);for(var e,r=this._first;r;)e=r._next,this.remove(r),r=e;return this._dp&&(this._time=this._tTime=this._pTime=0),t&&(this.labels={}),Aa(this)},e.totalDuration=function totalDuration(t){var e,r,i,n=0,a=this,s=a._last,o=U;if(arguments.length)return a.timeScale((a._repeat<0?a.duration():a.totalDuration())/(a.reversed()?-t:t));if(a._dirty){for(i=a.parent;s;)e=s._prev,s._dirty&&s.totalDuration(),o<(r=s._start)&&a._sort&&s._ts&&!a._lock?(a._lock=1,Ka(a,s,r-s._delay,1)._lock=0):o=r,r<0&&s._ts&&(n-=r,(!i&&!a._dp||i&&i.smoothChildTiming)&&(a._start+=r/a._ts,a._time-=r,a._tTime-=r),a.shiftChildren(-r,!1,-Infinity),o=0),s._end>n&&s._ts&&(n=s._end),s=e;Ra(a,a===I&&a._time>n?a._time:n,1,1),a._dirty=0}return a._tDur},Timeline.updateRoot=function updateRoot(t){if(I._ts&&(na(I,Ga(t,I)),f=Rt.frame),Rt.frame>=mt){mt+=q.autoSleep||120;var e=I._first;if((!e||!e._ts)&&q.autoSleep&&Rt._listeners.length<2){for(;e&&!e._ts;)e=e._next;e||Rt.sleep()}}},Timeline}(Ut);qa(Xt.prototype,{_lock:0,_hasPause:0,_forcing:0});function ac(t,e,i,n,a,o){var u,h,l,f;if(pt[t]&&!1!==(u=new pt[t]).init(a,u.rawVars?e[t]:function _processVars(t,e,i,n,a){if(s(t)&&(t=Kt(t,a,e,i,n)),!v(t)||t.style&&t.nodeType||Z(t)||$(t))return r(t)?Kt(t,a,e,i,n):t;var o,u={};for(o in t)u[o]=Kt(t[o],a,e,i,n);return u}(e[t],n,a,o,i),i,n,o)&&(i._pt=h=new _e(i._pt,a,t,0,1,u.render,u,0,u.priority),i!==d))for(l=i._ptLookup[i._targets.indexOf(a)],f=u._props.length;f--;)l[u._props[f]]=h;return u}function gc(t,r,e,i){var n,a,s=r.ease||i||"power1.inOut";if(Z(r))a=e[t]||(e[t]=[]),r.forEach(function(t,e){return a.push({t:e/(r.length-1)*100,v:t,e:s})});else for(n in r)a=e[n]||(e[n]=[]),"ease"===n||a.push({t:parseFloat(t),v:r[n],e:s})}var Nt,Gt,Wt=function _addPropTween(t,e,i,n,a,o,u,h,l,f){s(n)&&(n=n(a||0,t,o));var d,c=t[e],p="get"!==i?i:s(c)?l?t[e.indexOf("set")||!s(t["get"+e.substr(3)])?e:"get"+e.substr(3)](l):t[e]():c,_=s(c)?l?re:te:Zt;if(r(n)&&(~n.indexOf("random(")&&(n=ob(n)),"="===n.charAt(1)&&(!(d=ka(p,n)+(Ya(p)||0))&&0!==d||(n=d))),!f||p!==n||Gt)return isNaN(p*n)||""===n?(c||e in t||Q(e,n),function _addComplexStringPropTween(t,e,r,i,n,a,s){var o,u,h,l,f,d,c,p,_=new _e(this._pt,t,e,0,1,ue,null,n),m=0,g=0;for(_.b=r,_.e=i,r+="",(c=~(i+="").indexOf("random("))&&(i=ob(i)),a&&(a(p=[r,i],t,e),r=p[0],i=p[1]),u=r.match(it)||[];o=it.exec(i);)l=o[0],f=i.substring(m,o.index),h?h=(h+1)%5:"rgba("===f.substr(-5)&&(h=1),l!==u[g++]&&(d=parseFloat(u[g-1])||0,_._pt={_next:_._pt,p:f||1===g?f:",",s:d,c:"="===l.charAt(1)?ka(d,l)-d:parseFloat(l)-d,m:h&&h<4?Math.round:0},m=it.lastIndex);return _.c=m<i.length?i.substring(m,i.length):"",_.fp=s,(nt.test(i)||c)&&(_.e=0),this._pt=_}.call(this,t,e,p,n,_,h||q.stringFilter,l)):(d=new _e(this._pt,t,e,+p||0,n-(p||0),"boolean"==typeof c?se:ae,0,_),l&&(d.fp=l),u&&d.modifier(u,this,t),this._pt=d)},Qt=function _initTween(t,e,r){var i,n,a,s,o,u,h,l,f,d,c,p,_,m=t.vars,g=m.ease,v=m.startAt,y=m.immediateRender,T=m.lazy,b=m.onUpdate,x=m.runBackwards,O=m.yoyoEase,k=m.keyframes,M=m.autoRevert,P=t._dur,C=t._startAt,A=t._targets,S=t.parent,z=S&&"nested"===S.data?S.vars.targets:A,E="auto"===t._overwrite&&!F,D=t.timeline;if(!D||k&&g||(g="none"),t._ease=jt(g,V.ease),t._yEase=O?Yt(jt(!0===O?g:O,V.ease)):0,O&&t._yoyo&&!t._repeat&&(O=t._yEase,t._yEase=t._ease,t._ease=O),t._from=!D&&!!m.runBackwards,!D||k&&!m.stagger){if(p=(l=A[0]?fa(A[0]).harness:0)&&m[l.prop],i=ua(m,ft),C&&(C._zTime<0&&C.progress(1),e<0&&x&&y&&!M?C.render(-1,!0):C.revert(x&&P?ht:ut),C._lazy=0),v){if(za(t._startAt=$t.set(A,qa({data:"isStart",overwrite:!1,parent:S,immediateRender:!0,lazy:!C&&w(T),startAt:null,delay:0,onUpdate:b&&function(){return Ct(t,"onUpdate")},stagger:0},v))),t._startAt._dp=0,t._startAt._sat=t,e<0&&(L||!y&&!M)&&t._startAt.revert(ht),y&&P&&e<=0&&r<=0)return void(e&&(t._zTime=e))}else if(x&&P&&!C)if(e&&(y=!1),a=qa({overwrite:!1,data:"isFromStart",lazy:y&&!C&&w(T),immediateRender:y,stagger:0,parent:S},i),p&&(a[l.prop]=p),za(t._startAt=$t.set(A,a)),t._startAt._dp=0,t._startAt._sat=t,e<0&&(L?t._startAt.revert(ht):t._startAt.render(-1,!0)),t._zTime=e,y){if(!e)return}else _initTween(t._startAt,X,X);for(t._pt=t._ptCache=0,T=P&&w(T)||T&&!P,n=0;n<A.length;n++){if(h=(o=A[n])._gsap||ea(A)[n]._gsap,t._ptLookup[n]=d={},ct[h.id]&&dt.length&&ma(),c=z===A?n:z.indexOf(o),l&&!1!==(f=new l).init(o,p||i,t,c,z)&&(t._pt=s=new _e(t._pt,o,f.name,0,1,f.render,f,0,f.priority),f._props.forEach(function(t){d[t]=s}),f.priority&&(u=1)),!l||p)for(a in i)pt[a]&&(f=ac(a,i,t,c,o,z))?f.priority&&(u=1):d[a]=s=Wt.call(t,o,a,"get",i[a],c,z,0,m.stringFilter);t._op&&t._op[n]&&t.kill(o,t._op[n]),E&&t._pt&&(Nt=t,I.killTweensOf(o,d,t.globalTime(e)),_=!t.parent,Nt=0),t._pt&&T&&(ct[h.id]=1)}u&&pe(t),t._onInit&&t._onInit(t)}t._onUpdate=b,t._initted=(!t._op||t._pt)&&!_,k&&e<=0&&D.render(U,!0,!0)},Kt=function _parseFuncOrString(t,e,i,n,a){return s(t)?t.call(e,i,n,a):r(t)&&~t.indexOf("random(")?ob(t):t},Jt=vt+"repeat,repeatDelay,yoyo,repeatRefresh,yoyoEase,autoRevert",Ht={};ha(Jt+",id,stagger,delay,duration,paused,scrollTrigger",function(t){return Ht[t]=1});var $t=function(D){function Tween(e,r,i,n){var a;"number"==typeof r&&(i.duration=r,r=i,i=null);var s,o,u,h,l,f,d,c,p=(a=D.call(this,n?r:va(r))||this).vars,_=p.duration,m=p.delay,g=p.immediateRender,T=p.stagger,b=p.overwrite,x=p.keyframes,O=p.defaults,k=p.scrollTrigger,M=p.yoyoEase,P=r.parent||I,C=(Z(e)||$(e)?t(e[0]):"length"in r)?[e]:Mt(e);if(a._targets=C.length?ea(C):R("GSAP target "+e+" not found. https://gsap.com",!q.nullTargetWarn)||[],a._ptLookup=[],a._overwrite=b,x||T||y(_)||y(m)){if(r=a.vars,(s=a.timeline=new Xt({data:"nested",defaults:O||{},targets:P&&"nested"===P.data?P.vars.targets:C})).kill(),s.parent=s._dp=_assertThisInitialized(a),s._start=0,T||y(_)||y(m)){if(h=C.length,d=T&&eb(T),v(T))for(l in T)~Jt.indexOf(l)&&((c=c||{})[l]=T[l]);for(o=0;o<h;o++)(u=ua(r,Ht)).stagger=0,M&&(u.yoyoEase=M),c&&yt(u,c),f=C[o],u.duration=+Kt(_,_assertThisInitialized(a),o,f,C),u.delay=(+Kt(m,_assertThisInitialized(a),o,f,C)||0)-a._delay,!T&&1===h&&u.delay&&(a._delay=m=u.delay,a._start+=m,u.delay=0),s.to(f,u,d?d(o,f,C):0),s._ease=Lt.none;s.duration()?_=m=0:a.timeline=0}else if(x){va(qa(s.vars.defaults,{ease:"none"})),s._ease=jt(x.ease||r.ease||"none");var A,S,z,E=0;if(Z(x))x.forEach(function(t){return s.to(C,t,">")}),s.duration();else{for(l in u={},x)"ease"===l||"easeEach"===l||gc(l,x[l],u,x.easeEach);for(l in u)for(A=u[l].sort(function(t,e){return t.t-e.t}),o=E=0;o<A.length;o++)(z={ease:(S=A[o]).e,duration:(S.t-(o?A[o-1].t:0))/100*_})[l]=S.v,s.to(C,z,E),E+=z.duration;s.duration()<_&&s.to({},{duration:_-s.duration()})}}_||a.duration(_=s.duration())}else a.timeline=0;return!0!==b||F||(Nt=_assertThisInitialized(a),I.killTweensOf(C),Nt=0),Ka(P,_assertThisInitialized(a),i),r.reversed&&a.reverse(),r.paused&&a.paused(!0),(g||!_&&!x&&a._start===ja(P._time)&&w(g)&&function _hasNoPausedAncestors(t){return!t||t._ts&&_hasNoPausedAncestors(t.parent)}(_assertThisInitialized(a))&&"nested"!==P.data)&&(a._tTime=-X,a.render(Math.max(0,-m)||0)),k&&La(_assertThisInitialized(a),k),a}_inheritsLoose(Tween,D);var e=Tween.prototype;return e.render=function render(t,e,r){var i,n,a,s,o,u,h,l,f,d=this._time,c=this._tDur,p=this._dur,_=t<0,m=c-X<t&&!_?c:t<X?0:t;if(p){if(m!==this._tTime||!t||r||!this._initted&&this._tTime||this._startAt&&this._zTime<0!=_){if(i=m,l=this.timeline,this._repeat){if(s=p+this._rDelay,this._repeat<-1&&_)return this.totalTime(100*s+t,e,r);if(i=ja(m%s),m===c?(a=this._repeat,i=p):((a=~~(m/s))&&a===ja(m/s)&&(i=p,a--),p<i&&(i=p)),(u=this._yoyo&&1&a)&&(f=this._yEase,i=p-i),o=Tt(this._tTime,s),i===d&&!r&&this._initted&&a===o)return this._tTime=m,this;a!==o&&(l&&this._yEase&&Qb(l,u),this.vars.repeatRefresh&&!u&&!this._lock&&this._time!==s&&this._initted&&(this._lock=r=1,this.render(ja(s*a),!0).invalidate()._lock=0))}if(!this._initted){if(Ma(this,_?t:i,r,e,m))return this._tTime=0,this;if(!(d===this._time||r&&this.vars.repeatRefresh&&a!==o))return this;if(p!==this._dur)return this.render(t,e,r)}if(this._tTime=m,this._time=i,!this._act&&this._ts&&(this._act=1,this._lazy=0),this.ratio=h=(f||this._ease)(i/p),this._from&&(this.ratio=h=1-h),i&&!d&&!e&&!a&&(Ct(this,"onStart"),this._tTime!==m))return this;for(n=this._pt;n;)n.r(h,n.d),n=n._next;l&&l.render(t<0?t:l._dur*l._ease(i/this._dur),e,r)||this._startAt&&(this._zTime=t),this._onUpdate&&!e&&(_&&Ca(this,t,0,r),Ct(this,"onUpdate")),this._repeat&&a!==o&&this.vars.onRepeat&&!e&&this.parent&&Ct(this,"onRepeat"),m!==this._tDur&&m||this._tTime!==m||(_&&!this._onUpdate&&Ca(this,t,0,!0),!t&&p||!(m===this._tDur&&0<this._ts||!m&&this._ts<0)||za(this,1),e||_&&!d||!(m||d||u)||(Ct(this,m===c?"onComplete":"onReverseComplete",!0),!this._prom||m<c&&0<this.timeScale()||this._prom()))}}else!function _renderZeroDurationTween(t,e,r,i){var n,a,s,o=t.ratio,u=e<0||!e&&(!t._start&&function _parentPlayheadIsBeforeStart(t){var e=t.parent;return e&&e._ts&&e._initted&&!e._lock&&(e.rawTime()<0||_parentPlayheadIsBeforeStart(e))}(t)&&(t._initted||!bt(t))||(t._ts<0||t._dp._ts<0)&&!bt(t))?0:1,h=t._rDelay,l=0;if(h&&t._repeat&&(l=Ot(0,t._tDur,e),a=Tt(l,h),t._yoyo&&1&a&&(u=1-u),a!==Tt(t._tTime,h)&&(o=1-u,t.vars.repeatRefresh&&t._initted&&t.invalidate())),u!==o||L||i||t._zTime===X||!e&&t._zTime){if(!t._initted&&Ma(t,e,i,r,l))return;for(s=t._zTime,t._zTime=e||(r?X:0),r=r||e&&!s,t.ratio=u,t._from&&(u=1-u),t._time=0,t._tTime=l,n=t._pt;n;)n.r(u,n.d),n=n._next;e<0&&Ca(t,e,0,!0),t._onUpdate&&!r&&Ct(t,"onUpdate"),l&&t._repeat&&!r&&t.parent&&Ct(t,"onRepeat"),(e>=t._tDur||e<0)&&t.ratio===u&&(u&&za(t,1),r||L||(Ct(t,u?"onComplete":"onReverseComplete",!0),t._prom&&t._prom()))}else t._zTime||(t._zTime=e)}(this,t,e,r);return this},e.targets=function targets(){return this._targets},e.invalidate=function invalidate(t){return t&&this.vars.runBackwards||(this._startAt=0),this._pt=this._op=this._onUpdate=this._lazy=this.ratio=0,this._ptLookup=[],this.timeline&&this.timeline.invalidate(t),D.prototype.invalidate.call(this,t)},e.resetTo=function resetTo(t,e,r,i,n){c||Rt.wake(),this._ts||this.play();var a,s=Math.min(this._dur,(this._dp._time-this._start)*this._ts);return this._initted||Qt(this,s),a=this._ease(s/this._dur),function _updatePropTweens(t,e,r,i,n,a,s,o){var u,h,l,f,d=(t._pt&&t._ptCache||(t._ptCache={}))[e];if(!d)for(d=t._ptCache[e]=[],l=t._ptLookup,f=t._targets.length;f--;){if((u=l[f][e])&&u.d&&u.d._pt)for(u=u.d._pt;u&&u.p!==e&&u.fp!==e;)u=u._next;if(!u)return Gt=1,t.vars[e]="+=0",Qt(t,s),Gt=0,o?R(e+" not eligible for reset"):1;d.push(u)}for(f=d.length;f--;)(u=(h=d[f])._pt||h).s=!i&&0!==i||n?u.s+(i||0)+a*u.c:i,u.c=r-u.s,h.e&&(h.e=ia(r)+Ya(h.e)),h.b&&(h.b=u.s+Ya(h.b))}(this,t,e,r,i,a,s,n)?this.resetTo(t,e,r,i,1):(Ia(this,0),this.parent||xa(this._dp,this,"_first","_last",this._dp._sort?"_start":0),this.render(0))},e.kill=function kill(t,e){if(void 0===e&&(e="all"),!(t||e&&"all"!==e))return this._lazy=this._pt=0,this.parent?tb(this):this;if(this.timeline){var i=this.timeline.totalDuration();return this.timeline.killTweensOf(t,e,Nt&&!0!==Nt.vars.overwrite)._first||tb(this),this.parent&&i!==this.timeline.totalDuration()&&Ra(this,this._dur*this.timeline._tDur/i,0,1),this}var n,a,s,o,u,h,l,f=this._targets,d=t?Mt(t):f,c=this._ptLookup,p=this._pt;if((!e||"all"===e)&&function _arraysMatch(t,e){for(var r=t.length,i=r===e.length;i&&r--&&t[r]===e[r];);return r<0}(f,d))return"all"===e&&(this._pt=0),tb(this);for(n=this._op=this._op||[],"all"!==e&&(r(e)&&(u={},ha(e,function(t){return u[t]=1}),e=u),e=function _addAliasesToVars(t,e){var r,i,n,a,s=t[0]?fa(t[0]).harness:0,o=s&&s.aliases;if(!o)return e;for(i in r=yt({},e),o)if(i in r)for(n=(a=o[i].split(",")).length;n--;)r[a[n]]=r[i];return r}(f,e)),l=f.length;l--;)if(~d.indexOf(f[l]))for(u in a=c[l],"all"===e?(n[l]=e,o=a,s={}):(s=n[l]=n[l]||{},o=e),o)(h=a&&a[u])&&("kill"in h.d&&!0!==h.d.kill(u)||ya(this,h,"_pt"),delete a[u]),"all"!==s&&(s[u]=1);return this._initted&&!this._pt&&p&&tb(this),this},Tween.to=function to(t,e,r){return new Tween(t,e,r)},Tween.from=function from(t,e){return Va(1,arguments)},Tween.delayedCall=function delayedCall(t,e,r,i){return new Tween(e,0,{immediateRender:!1,lazy:!1,overwrite:!1,delay:t,onComplete:e,onReverseComplete:e,onCompleteParams:r,onReverseCompleteParams:r,callbackScope:i})},Tween.fromTo=function fromTo(t,e,r){return Va(2,arguments)},Tween.set=function set(t,e){return e.duration=0,e.repeatDelay||(e.repeat=0),new Tween(t,e)},Tween.killTweensOf=function killTweensOf(t,e,r){return I.killTweensOf(t,e,r)},Tween}(Ut);qa($t.prototype,{_targets:[],_lazy:0,_startAt:0,_op:0,_onInit:0}),ha("staggerTo,staggerFrom,staggerFromTo",function(r){$t[r]=function(){var t=new Xt,e=kt.call(arguments,0);return e.splice("staggerFromTo"===r?5:4,0,0),t[r].apply(t,e)}});function oc(t,e,r){return t.setAttribute(e,r)}function wc(t,e,r,i){i.mSet(t,e,i.m.call(i.tween,r,i.mt),i)}var Zt=function _setterPlain(t,e,r){return t[e]=r},te=function _setterFunc(t,e,r){return t[e](r)},re=function _setterFuncWithParam(t,e,r,i){return t[e](i.fp,r)},ne=function _getSetter(t,e){return s(t[e])?te:u(t[e])&&t.setAttribute?oc:Zt},ae=function _renderPlain(t,e){return e.set(e.t,e.p,Math.round(1e6*(e.s+e.c*t))/1e6,e)},se=function _renderBoolean(t,e){return e.set(e.t,e.p,!!(e.s+e.c*t),e)},ue=function _renderComplexString(t,e){var r=e._pt,i="";if(!t&&e.b)i=e.b;else if(1===t&&e.e)i=e.e;else{for(;r;)i=r.p+(r.m?r.m(r.s+r.c*t):Math.round(1e4*(r.s+r.c*t))/1e4)+i,r=r._next;i+=e.c}e.set(e.t,e.p,i,e)},he=function _renderPropTweens(t,e){for(var r=e._pt;r;)r.r(t,r.d),r=r._next},fe=function _addPluginModifier(t,e,r,i){for(var n,a=this._pt;a;)n=a._next,a.p===i&&a.modifier(t,e,r),a=n},ce=function _killPropTweensOf(t){for(var e,r,i=this._pt;i;)r=i._next,i.p===t&&!i.op||i.op===t?ya(this,i,"_pt"):i.dep||(e=1),i=r;return!e},pe=function _sortPropTweensByPriority(t){for(var e,r,i,n,a=t._pt;a;){for(e=a._next,r=i;r&&r.pr>a.pr;)r=r._next;(a._prev=r?r._prev:n)?a._prev._next=a:i=a,(a._next=r)?r._prev=a:n=a,a=e}t._pt=i},_e=(PropTween.prototype.modifier=function modifier(t,e,r){this.mSet=this.mSet||this.set,this.set=wc,this.m=t,this.mt=r,this.tween=e},PropTween);function PropTween(t,e,r,i,n,a,s,o,u){this.t=e,this.s=i,this.c=n,this.p=r,this.r=a||ae,this.d=s||this,this.set=o||Zt,this.pr=u||0,(this._next=t)&&(t._prev=this)}ha(vt+"parent,duration,ease,delay,overwrite,runBackwards,startAt,yoyo,immediateRender,repeat,repeatDelay,data,paused,reversed,lazy,callbackScope,stringFilter,id,yoyoEase,stagger,inherit,repeatRefresh,keyframes,autoRevert,scrollTrigger",function(t){return ft[t]=1}),ot.TweenMax=ot.TweenLite=$t,ot.TimelineLite=ot.TimelineMax=Xt,I=new Xt({sortChildren:!1,defaults:V,autoRemoveChildren:!0,id:"root",smoothChildTiming:!0}),q.stringFilter=Fb;function Ec(t){return(ye[t]||Te).map(function(t){return t()})}function Fc(){var t=Date.now(),o=[];2<t-Oe&&(Ec("matchMediaInit"),ge.forEach(function(t){var e,r,i,n,a=t.queries,s=t.conditions;for(r in a)(e=h.matchMedia(a[r]).matches)&&(i=1),e!==s[r]&&(s[r]=e,n=1);n&&(t.revert(),i&&o.push(t))}),Ec("matchMediaRevert"),o.forEach(function(e){return e.onMatch(e,function(t){return e.add(null,t)})}),Oe=t,Ec("matchMedia"))}var me,ge=[],ye={},Te=[],Oe=0,Me=0,Pe=((me=Context.prototype).add=function add(t,i,n){function Gw(){var t,e=l,r=a.selector;return e&&e!==a&&e.data.push(a),n&&(a.selector=cb(n)),l=a,t=i.apply(a,arguments),s(t)&&a._r.push(t),l=e,a.selector=r,a.isReverted=!1,t}s(t)&&(n=i,i=t,t=s);var a=this;return a.last=Gw,t===s?Gw(a,function(t){return a.add(null,t)}):t?a[t]=Gw:Gw},me.ignore=function ignore(t){var e=l;l=null,t(this),l=e},me.getTweens=function getTweens(){var e=[];return this.data.forEach(function(t){return t instanceof Context?e.push.apply(e,t.getTweens()):t instanceof $t&&!(t.parent&&"nested"===t.parent.data)&&e.push(t)}),e},me.clear=function clear(){this._r.length=this.data.length=0},me.kill=function kill(i,t){var n=this;if(i?function(){for(var t,e=n.getTweens(),r=n.data.length;r--;)"isFlip"===(t=n.data[r]).data&&(t.revert(),t.getChildren(!0,!0,!1).forEach(function(t){return e.splice(e.indexOf(t),1)}));for(e.map(function(t){return{g:t._dur||t._delay||t._sat&&!t._sat.vars.immediateRender?t.globalTime(0):-1/0,t:t}}).sort(function(t,e){return e.g-t.g||-1/0}).forEach(function(t){return t.t.revert(i)}),r=n.data.length;r--;)(t=n.data[r])instanceof Xt?"nested"!==t.data&&(t.scrollTrigger&&t.scrollTrigger.revert(),t.kill()):t instanceof $t||!t.revert||t.revert(i);n._r.forEach(function(t){return t(i,n)}),n.isReverted=!0}():this.data.forEach(function(t){return t.kill&&t.kill()}),this.clear(),t)for(var e=ge.length;e--;)ge[e].id===this.id&&ge.splice(e,1)},me.revert=function revert(t){this.kill(t||{})},Context);function Context(t,e){this.selector=e&&cb(e),this.data=[],this._r=[],this.isReverted=!1,this.id=Me++,t&&this.add(t)}var Ce,Ae=((Ce=MatchMedia.prototype).add=function add(t,e,r){v(t)||(t={matches:t});var i,n,a,s=new Pe(0,r||this.scope),o=s.conditions={};for(n in l&&!s.selector&&(s.selector=l.selector),this.contexts.push(s),e=s.add("onMatch",e),s.queries=t)"all"===n?a=1:(i=h.matchMedia(t[n]))&&(ge.indexOf(s)<0&&ge.push(s),(o[n]=i.matches)&&(a=1),i.addListener?i.addListener(Fc):i.addEventListener("change",Fc));return a&&e(s,function(t){return s.add(null,t)}),this},Ce.revert=function revert(t){this.kill(t||{})},Ce.kill=function kill(e){this.contexts.forEach(function(t){return t.kill(e,!0)})},MatchMedia);function MatchMedia(t){this.contexts=[],this.scope=t,l&&l.data.push(this)}var Se={registerPlugin:function registerPlugin(){for(var t=arguments.length,e=new Array(t),r=0;r<t;r++)e[r]=arguments[r];e.forEach(function(t){return wb(t)})},timeline:function timeline(t){return new Xt(t)},getTweensOf:function getTweensOf(t,e){return I.getTweensOf(t,e)},getProperty:function getProperty(i,t,e,n){r(i)&&(i=Mt(i)[0]);var a=fa(i||{}).get,s=e?pa:oa;return"native"===e&&(e=""),i?t?s((pt[t]&&pt[t].get||a)(i,t,e,n)):function(t,e,r){return s((pt[t]&&pt[t].get||a)(i,t,e,r))}:i},quickSetter:function quickSetter(r,e,i){if(1<(r=Mt(r)).length){var n=r.map(function(t){return ze.quickSetter(t,e,i)}),a=n.length;return function(t){for(var e=a;e--;)n[e](t)}}r=r[0]||{};var s=pt[e],o=fa(r),u=o.harness&&(o.harness.aliases||{})[e]||e,h=s?function(t){var e=new s;d._pt=0,e.init(r,i?t+i:t,d,0,[r]),e.render(1,e),d._pt&&he(1,d)}:o.set(r,u);return s?h:function(t){return h(r,u,i?t+i:t,o,1)}},quickTo:function quickTo(t,i,e){function $x(t,e,r){return n.resetTo(i,t,e,r)}var r,n=ze.to(t,yt(((r={})[i]="+=0.1",r.paused=!0,r),e||{}));return $x.tween=n,$x},isTweening:function isTweening(t){return 0<I.getTweensOf(t,!0).length},defaults:function defaults(t){return t&&t.ease&&(t.ease=jt(t.ease,V.ease)),ta(V,t||{})},config:function config(t){return ta(q,t||{})},registerEffect:function registerEffect(t){var i=t.name,n=t.effect,e=t.plugins,a=t.defaults,r=t.extendTimeline;(e||"").split(",").forEach(function(t){return t&&!pt[t]&&!ot[t]&&R(i+" effect requires "+t+" plugin.")}),_t[i]=function(t,e,r){return n(Mt(t),qa(e||{},a),r)},r&&(Xt.prototype[i]=function(t,e,r){return this.add(_t[i](t,v(e)?e:(r=e)&&{},this),r)})},registerEase:function registerEase(t,e){Lt[t]=jt(e)},parseEase:function parseEase(t,e){return arguments.length?jt(t,e):Lt},getById:function getById(t){return I.getById(t)},exportRoot:function exportRoot(t,e){void 0===t&&(t={});var r,i,n=new Xt(t);for(n.smoothChildTiming=w(t.smoothChildTiming),I.remove(n),n._dp=0,n._time=n._tTime=I._time,r=I._first;r;)i=r._next,!e&&!r._dur&&r instanceof $t&&r.vars.onComplete===r._targets[0]||Ka(n,r,r._start-r._delay),r=i;return Ka(I,n,0),n},context:function context(t,e){return t?new Pe(t,e):l},matchMedia:function matchMedia(t){return new Ae(t)},matchMediaRefresh:function matchMediaRefresh(){return ge.forEach(function(t){var e,r,i=t.conditions;for(r in i)i[r]&&(i[r]=!1,e=1);e&&t.revert()})||Fc()},addEventListener:function addEventListener(t,e){var r=ye[t]||(ye[t]=[]);~r.indexOf(e)||r.push(e)},removeEventListener:function removeEventListener(t,e){var r=ye[t],i=r&&r.indexOf(e);0<=i&&r.splice(i,1)},utils:{wrap:function wrap(e,t,r){var i=t-e;return Z(e)?lb(e,wrap(0,e.length),t):Wa(r,function(t){return(i+(t-e)%i)%i+e})},wrapYoyo:function wrapYoyo(e,t,r){var i=t-e,n=2*i;return Z(e)?lb(e,wrapYoyo(0,e.length-1),t):Wa(r,function(t){return e+(i<(t=(n+(t-e)%n)%n||0)?n-t:t)})},distribute:eb,random:hb,snap:gb,normalize:function normalize(t,e,r){return Pt(t,e,0,1,r)},getUnit:Ya,clamp:function clamp(e,r,t){return Wa(t,function(t){return Ot(e,r,t)})},splitColor:Ab,toArray:Mt,selector:cb,mapRange:Pt,pipe:function pipe(){for(var t=arguments.length,e=new Array(t),r=0;r<t;r++)e[r]=arguments[r];return function(t){return e.reduce(function(t,e){return e(t)},t)}},unitize:function unitize(e,r){return function(t){return e(parseFloat(t))+(r||Ya(t))}},interpolate:function interpolate(e,i,t,n){var a=isNaN(e+i)?0:function(t){return(1-t)*e+t*i};if(!a){var s,o,u,h,l,f=r(e),d={};if(!0===t&&(n=1)&&(t=null),f)e={p:e},i={p:i};else if(Z(e)&&!Z(i)){for(u=[],h=e.length,l=h-2,o=1;o<h;o++)u.push(interpolate(e[o-1],e[o]));h--,a=function func(t){t*=h;var e=Math.min(l,~~t);return u[e](t-e)},t=i}else n||(e=yt(Z(e)?[]:{},e));if(!u){for(s in i)Wt.call(d,e,s,"get",i[s]);a=function func(t){return he(t,d)||(f?e.p:e)}}}return Wa(t,a)},shuffle:db},install:P,effects:_t,ticker:Rt,updateRoot:Xt.updateRoot,plugins:pt,globalTimeline:I,core:{PropTween:_e,globals:S,Tween:$t,Timeline:Xt,Animation:Ut,getCache:fa,_removeLinkedListItem:ya,reverting:function reverting(){return L},context:function context(t){return t&&l&&(l.data.push(t),t._ctx=l),l},suppressOverwrites:function suppressOverwrites(t){return F=t}}};ha("to,from,fromTo,delayedCall,set,killTweensOf",function(t){return Se[t]=$t[t]}),Rt.add(Xt.updateRoot),d=Se.to({},{duration:0});function Jc(t,e){for(var r=t._pt;r&&r.p!==e&&r.op!==e&&r.fp!==e;)r=r._next;return r}function Lc(t,a){return{name:t,rawVars:1,init:function init(t,n,e){e._onInit=function(t){var e,i;if(r(n)&&(e={},ha(n,function(t){return e[t]=1}),n=e),a){for(i in e={},n)e[i]=a(n[i]);n=e}!function _addModifiers(t,e){var r,i,n,a=t._targets;for(r in e)for(i=a.length;i--;)(n=(n=t._ptLookup[i][r])&&n.d)&&(n._pt&&(n=Jc(n,r)),n&&n.modifier&&n.modifier(e[r],t,a[i],r))}(t,n)}}}}var ze=Se.registerPlugin({name:"attr",init:function init(t,e,r,i,n){var a,s,o;for(a in this.tween=r,e)o=t.getAttribute(a)||"",(s=this.add(t,"setAttribute",(o||0)+"",e[a],i,n,0,0,a)).op=a,s.b=o,this._props.push(a)},render:function render(t,e){for(var r=e._pt;r;)L?r.set(r.t,r.p,r.b,r):r.r(t,r.d),r=r._next}},{name:"endArray",init:function init(t,e){for(var r=e.length;r--;)this.add(t,r,t[r]||0,e[r],0,0,0,0,0,1)}},Lc("roundProps",fb),Lc("modifiers"),Lc("snap",gb))||Se;$t.version=Xt.version=ze.version="3.12.5",o=1,x()&&Ft();function vd(t,e){return e.set(e.t,e.p,Math.round(1e4*(e.s+e.c*t))/1e4+e.u,e)}function wd(t,e){return e.set(e.t,e.p,1===t?e.e:Math.round(1e4*(e.s+e.c*t))/1e4+e.u,e)}function xd(t,e){return e.set(e.t,e.p,t?Math.round(1e4*(e.s+e.c*t))/1e4+e.u:e.b,e)}function yd(t,e){var r=e.s+e.c*t;e.set(e.t,e.p,~~(r+(r<0?-.5:.5))+e.u,e)}function zd(t,e){return e.set(e.t,e.p,t?e.e:e.b,e)}function Ad(t,e){return e.set(e.t,e.p,1!==t?e.b:e.e,e)}function Bd(t,e,r){return t.style[e]=r}function Cd(t,e,r){return t.style.setProperty(e,r)}function Dd(t,e,r){return t._gsap[e]=r}function Ed(t,e,r){return t._gsap.scaleX=t._gsap.scaleY=r}function Fd(t,e,r,i,n){var a=t._gsap;a.scaleX=a.scaleY=r,a.renderTransform(n,a)}function Gd(t,e,r,i,n){var a=t._gsap;a[e]=r,a.renderTransform(n,a)}function Jd(t,e){var r=this,i=this.target,n=i.style,a=i._gsap;if(t in ar&&n){if(this.tfm=this.tfm||{},"transform"===t)return dr.transform.split(",").forEach(function(t){return Jd.call(r,t,e)});if(~(t=dr[t]||t).indexOf(",")?t.split(",").forEach(function(t){return r.tfm[t]=yr(i,t)}):this.tfm[t]=a.x?a[t]:yr(i,t),t===pr&&(this.tfm.zOrigin=a.zOrigin),0<=this.props.indexOf(cr))return;a.svg&&(this.svgo=i.getAttribute("data-svg-origin"),this.props.push(pr,e,"")),t=cr}(n||e)&&this.props.push(t,e,n[t])}function Kd(t){t.translate&&(t.removeProperty("translate"),t.removeProperty("scale"),t.removeProperty("rotate"))}function Ld(){var t,e,r=this.props,i=this.target,n=i.style,a=i._gsap;for(t=0;t<r.length;t+=3)r[t+1]?i[r[t]]=r[t+2]:r[t+2]?n[r[t]]=r[t+2]:n.removeProperty("--"===r[t].substr(0,2)?r[t]:r[t].replace(hr,"-$1").toLowerCase());if(this.tfm){for(e in this.tfm)a[e]=this.tfm[e];a.svg&&(a.renderTransform(),i.setAttribute("data-svg-origin",this.svgo||"")),(t=Be())&&t.isStart||n[cr]||(Kd(n),a.zOrigin&&n[pr]&&(n[pr]+=" "+a.zOrigin+"px",a.zOrigin=0,a.renderTransform()),a.uncache=1)}}function Md(t,e){var r={target:t,props:[],revert:Ld,save:Jd};return t._gsap||ze.core.getCache(t),e&&e.split(",").forEach(function(t){return r.save(t)}),r}function Od(t,e){var r=De.createElementNS?De.createElementNS((e||"http://www.w3.org/1999/xhtml").replace(/^https/,"http"),t):De.createElement(t);return r&&r.style?r:De.createElement(t)}function Pd(t,e,r){var i=getComputedStyle(t);return i[e]||i.getPropertyValue(e.replace(hr,"-$1").toLowerCase())||i.getPropertyValue(e)||!r&&Pd(t,mr(e)||e,1)||""}function Sd(){(function _windowExists(){return"undefined"!=typeof window})()&&window.document&&(Ee=window,De=Ee.document,Re=De.documentElement,Le=Od("div")||{style:{}},Od("div"),cr=mr(cr),pr=cr+"Origin",Le.style.cssText="border-width:0;line-height:0;position:absolute;padding:0",Ye=!!mr("perspective"),Be=ze.core.reverting,Fe=1)}function Td(t){var e,r=Od("svg",this.ownerSVGElement&&this.ownerSVGElement.getAttribute("xmlns")||"http://www.w3.org/2000/svg"),i=this.parentNode,n=this.nextSibling,a=this.style.cssText;if(Re.appendChild(r),r.appendChild(this),this.style.display="block",t)try{e=this.getBBox(),this._gsapBBox=this.getBBox,this.getBBox=Td}catch(t){}else this._gsapBBox&&(e=this._gsapBBox());return i&&(n?i.insertBefore(this,n):i.appendChild(this)),Re.removeChild(r),this.style.cssText=a,e}function Ud(t,e){for(var r=e.length;r--;)if(t.hasAttribute(e[r]))return t.getAttribute(e[r])}function Vd(e){var r;try{r=e.getBBox()}catch(t){r=Td.call(e,!0)}return r&&(r.width||r.height)||e.getBBox===Td||(r=Td.call(e,!0)),!r||r.width||r.x||r.y?r:{x:+Ud(e,["x","cx","x1"])||0,y:+Ud(e,["y","cy","y1"])||0,width:0,height:0}}function Wd(t){return!(!t.getCTM||t.parentNode&&!t.ownerSVGElement||!Vd(t))}function Xd(t,e){if(e){var r,i=t.style;e in ar&&e!==pr&&(e=cr),i.removeProperty?("ms"!==(r=e.substr(0,2))&&"webkit"!==e.substr(0,6)||(e="-"+e),i.removeProperty("--"===r?e:e.replace(hr,"-$1").toLowerCase())):i.removeAttribute(e)}}function Yd(t,e,r,i,n,a){var s=new _e(t._pt,e,r,0,1,a?Ad:zd);return(t._pt=s).b=i,s.e=n,t._props.push(r),s}function _d(t,e,r,i){var n,a,s,o,u=parseFloat(r)||0,h=(r+"").trim().substr((u+"").length)||"px",l=Le.style,f=lr.test(e),d="svg"===t.tagName.toLowerCase(),c=(d?"client":"offset")+(f?"Width":"Height"),p="px"===i,_="%"===i;if(i===h||!u||gr[i]||gr[h])return u;if("px"===h||p||(u=_d(t,e,r,"px")),o=t.getCTM&&Wd(t),(_||"%"===h)&&(ar[e]||~e.indexOf("adius")))return n=o?t.getBBox()[f?"width":"height"]:t[c],ia(_?u/n*100:u/100*n);if(l[f?"width":"height"]=100+(p?h:i),a=~e.indexOf("adius")||"em"===i&&t.appendChild&&!d?t:t.parentNode,o&&(a=(t.ownerSVGElement||{}).parentNode),a&&a!==De&&a.appendChild||(a=De.body),(s=a._gsap)&&_&&s.width&&f&&s.time===Rt.time&&!s.uncache)return ia(u/s.width*100);if(!_||"height"!==e&&"width"!==e)!_&&"%"!==h||vr[Pd(a,"display")]||(l.position=Pd(t,"position")),a===t&&(l.position="static"),a.appendChild(Le),n=Le[c],a.removeChild(Le),l.position="absolute";else{var m=t.style[e];t.style[e]=100+i,n=t[c],m?t.style[e]=m:Xd(t,e)}return f&&_&&((s=fa(a)).time=Rt.time,s.width=a[c]),ia(p?n*u/100:n&&u?100/n*u:0)}function be(t,e,r,i){if(!r||"none"===r){var n=mr(e,t,1),a=n&&Pd(t,n,1);a&&a!==r?(e=n,r=a):"borderColor"===e&&(r=Pd(t,"borderTopColor"))}var s,o,u,h,l,f,d,c,p,_,m,g=new _e(this._pt,t.style,e,0,1,ue),v=0,y=0;if(g.b=r,g.e=i,r+="","auto"===(i+="")&&(f=t.style[e],t.style[e]=i,i=Pd(t,e)||i,f?t.style[e]=f:Xd(t,e)),Fb(s=[r,i]),i=s[1],u=(r=s[0]).match(rt)||[],(i.match(rt)||[]).length){for(;o=rt.exec(i);)d=o[0],p=i.substring(v,o.index),l?l=(l+1)%5:"rgba("!==p.substr(-5)&&"hsla("!==p.substr(-5)||(l=1),d!==(f=u[y++]||"")&&(h=parseFloat(f)||0,m=f.substr((h+"").length),"="===d.charAt(1)&&(d=ka(h,d)+m),c=parseFloat(d),_=d.substr((c+"").length),v=rt.lastIndex-_.length,_||(_=_||q.units[e]||m,v===i.length&&(i+=_,g.e+=_)),m!==_&&(h=_d(t,e,f,_)||0),g._pt={_next:g._pt,p:p||1===y?p:",",s:h,c:c-h,m:l&&l<4||"zIndex"===e?Math.round:0});g.c=v<i.length?i.substring(v,i.length):""}else g.r="display"===e&&"none"===i?Ad:zd;return nt.test(i)&&(g.e=0),this._pt=g}function de(t){var e=t.split(" "),r=e[0],i=e[1]||"50%";return"top"!==r&&"bottom"!==r&&"left"!==i&&"right"!==i||(t=r,r=i,i=t),e[0]=Tr[r]||r,e[1]=Tr[i]||i,e.join(" ")}function ee(t,e){if(e.tween&&e.tween._time===e.tween._dur){var r,i,n,a=e.t,s=a.style,o=e.u,u=a._gsap;if("all"===o||!0===o)s.cssText="",i=1;else for(n=(o=o.split(",")).length;-1<--n;)r=o[n],ar[r]&&(i=1,r="transformOrigin"===r?pr:cr),Xd(a,r);i&&(Xd(a,cr),u&&(u.svg&&a.removeAttribute("transform"),Or(a,1),u.uncache=1,Kd(s)))}}function ie(t){return"matrix(1, 0, 0, 1, 0, 0)"===t||"none"===t||!t}function je(t){var e=Pd(t,cr);return ie(e)?wr:e.substr(7).match(et).map(ia)}function ke(t,e){var r,i,n,a,s=t._gsap||fa(t),o=t.style,u=je(t);return s.svg&&t.getAttribute("transform")?"1,0,0,1,0,0"===(u=[(n=t.transform.baseVal.consolidate().matrix).a,n.b,n.c,n.d,n.e,n.f]).join(",")?wr:u:(u!==wr||t.offsetParent||t===Re||s.svg||(n=o.display,o.display="block",(r=t.parentNode)&&t.offsetParent||(a=1,i=t.nextElementSibling,Re.appendChild(t)),u=je(t),n?o.display=n:Xd(t,"display"),a&&(i?r.insertBefore(t,i):r?r.appendChild(t):Re.removeChild(t))),e&&6<u.length?[u[0],u[1],u[4],u[5],u[12],u[13]]:u)}function le(t,e,r,i,n,a){var s,o,u,h=t._gsap,l=n||ke(t,!0),f=h.xOrigin||0,d=h.yOrigin||0,c=h.xOffset||0,p=h.yOffset||0,_=l[0],m=l[1],g=l[2],v=l[3],y=l[4],T=l[5],b=e.split(" "),w=parseFloat(b[0])||0,x=parseFloat(b[1])||0;r?l!==wr&&(o=_*v-m*g)&&(u=w*(-m/o)+x*(_/o)-(_*T-m*y)/o,w=w*(v/o)+x*(-g/o)+(g*T-v*y)/o,x=u):(w=(s=Vd(t)).x+(~b[0].indexOf("%")?w/100*s.width:w),x=s.y+(~(b[1]||b[0]).indexOf("%")?x/100*s.height:x)),i||!1!==i&&h.smooth?(y=w-f,T=x-d,h.xOffset=c+(y*_+T*g)-y,h.yOffset=p+(y*m+T*v)-T):h.xOffset=h.yOffset=0,h.xOrigin=w,h.yOrigin=x,h.smooth=!!i,h.origin=e,h.originIsAbsolute=!!r,t.style[pr]="0px 0px",a&&(Yd(a,h,"xOrigin",f,w),Yd(a,h,"yOrigin",d,x),Yd(a,h,"xOffset",c,h.xOffset),Yd(a,h,"yOffset",p,h.yOffset)),t.setAttribute("data-svg-origin",w+" "+x)}function oe(t,e,r){var i=Ya(e);return ia(parseFloat(e)+parseFloat(_d(t,"x",r+"px",i)))+i}function ve(t,e,i,n,a){var s,o,u=360,h=r(a),l=parseFloat(a)*(h&&~a.indexOf("rad")?sr:1)-n,f=n+l+"deg";return h&&("short"===(s=a.split("_")[1])&&(l%=u)!==l%180&&(l+=l<0?u:-u),"cw"===s&&l<0?l=(l+36e9)%u-~~(l/u)*u:"ccw"===s&&0<l&&(l=(l-36e9)%u-~~(l/u)*u)),t._pt=o=new _e(t._pt,e,i,n,l,wd),o.e=f,o.u="deg",t._props.push(i),o}function we(t,e){for(var r in e)t[r]=e[r];return t}function xe(t,e,r){var i,n,a,s,o,u,h,l=we({},r._gsap),f=r.style;for(n in l.svg?(a=r.getAttribute("transform"),r.setAttribute("transform",""),f[cr]=e,i=Or(r,1),Xd(r,cr),r.setAttribute("transform",a)):(a=getComputedStyle(r)[cr],f[cr]=e,i=Or(r,1),f[cr]=a),ar)(a=l[n])!==(s=i[n])&&"perspective,force3D,transformOrigin,svgOrigin".indexOf(n)<0&&(o=Ya(a)!==(h=Ya(s))?_d(r,n,a,h):parseFloat(a),u=parseFloat(s),t._pt=new _e(t._pt,i,n,o,u-o,vd),t._pt.u=h||0,t._props.push(n));we(i,l)}var Ee,De,Re,Fe,Le,Ie,Be,Ye,qe=Lt.Power0,Ve=Lt.Power1,Ue=Lt.Power2,Xe=Lt.Power3,Ne=Lt.Power4,Ge=Lt.Linear,We=Lt.Quad,Qe=Lt.Cubic,Ke=Lt.Quart,Je=Lt.Quint,He=Lt.Strong,$e=Lt.Elastic,Ze=Lt.Back,tr=Lt.SteppedEase,er=Lt.Bounce,rr=Lt.Sine,ir=Lt.Expo,nr=Lt.Circ,ar={},sr=180/Math.PI,or=Math.PI/180,ur=Math.atan2,hr=/([A-Z])/g,lr=/(left|right|width|margin|padding|x)/i,fr=/[\s,\(]\S/,dr={autoAlpha:"opacity,visibility",scale:"scaleX,scaleY",alpha:"opacity"},cr="transform",pr=cr+"Origin",_r="O,Moz,ms,Ms,Webkit".split(","),mr=function _checkPropPrefix(t,e,r){var i=(e||Le).style,n=5;if(t in i&&!r)return t;for(t=t.charAt(0).toUpperCase()+t.substr(1);n--&&!(_r[n]+t in i););return n<0?null:(3===n?"ms":0<=n?_r[n]:"")+t},gr={deg:1,rad:1,turn:1},vr={grid:1,flex:1},yr=function _get(t,e,r,i){var n;return Fe||Sd(),e in dr&&"transform"!==e&&~(e=dr[e]).indexOf(",")&&(e=e.split(",")[0]),ar[e]&&"transform"!==e?(n=Or(t,i),n="transformOrigin"!==e?n[e]:n.svg?n.origin:kr(Pd(t,pr))+" "+n.zOrigin+"px"):(n=t.style[e])&&"auto"!==n&&!i&&!~(n+"").indexOf("calc(")||(n=br[e]&&br[e](t,e,r)||Pd(t,e)||ga(t,e)||("opacity"===e?1:0)),r&&!~(n+"").trim().indexOf(" ")?_d(t,e,n,r)+r:n},Tr={top:"0%",bottom:"100%",left:"0%",right:"100%",center:"50%"},br={clearProps:function clearProps(t,e,r,i,n){if("isFromStart"!==n.data){var a=t._pt=new _e(t._pt,e,r,0,0,ee);return a.u=i,a.pr=-10,a.tween=n,t._props.push(r),1}}},wr=[1,0,0,1,0,0],xr={},Or=function _parseTransform(t,e){var r=t._gsap||new Vt(t);if("x"in r&&!e&&!r.uncache)return r;var i,n,a,s,o,u,h,l,f,d,c,p,_,m,g,v,y,T,b,w,x,O,k,M,P,C,A,S,z,E,D,R,F=t.style,L=r.scaleX<0,I="deg",B=getComputedStyle(t),Y=Pd(t,pr)||"0";return i=n=a=u=h=l=f=d=c=0,s=o=1,r.svg=!(!t.getCTM||!Wd(t)),B.translate&&("none"===B.translate&&"none"===B.scale&&"none"===B.rotate||(F[cr]=("none"!==B.translate?"translate3d("+(B.translate+" 0 0").split(" ").slice(0,3).join(", ")+") ":"")+("none"!==B.rotate?"rotate("+B.rotate+") ":"")+("none"!==B.scale?"scale("+B.scale.split(" ").join(",")+") ":"")+("none"!==B[cr]?B[cr]:"")),F.scale=F.rotate=F.translate="none"),m=ke(t,r.svg),r.svg&&(M=r.uncache?(P=t.getBBox(),Y=r.xOrigin-P.x+"px "+(r.yOrigin-P.y)+"px",""):!e&&t.getAttribute("data-svg-origin"),le(t,M||Y,!!M||r.originIsAbsolute,!1!==r.smooth,m)),p=r.xOrigin||0,_=r.yOrigin||0,m!==wr&&(T=m[0],b=m[1],w=m[2],x=m[3],i=O=m[4],n=k=m[5],6===m.length?(s=Math.sqrt(T*T+b*b),o=Math.sqrt(x*x+w*w),u=T||b?ur(b,T)*sr:0,(f=w||x?ur(w,x)*sr+u:0)&&(o*=Math.abs(Math.cos(f*or))),r.svg&&(i-=p-(p*T+_*w),n-=_-(p*b+_*x))):(R=m[6],E=m[7],A=m[8],S=m[9],z=m[10],D=m[11],i=m[12],n=m[13],a=m[14],h=(g=ur(R,z))*sr,g&&(M=O*(v=Math.cos(-g))+A*(y=Math.sin(-g)),P=k*v+S*y,C=R*v+z*y,A=O*-y+A*v,S=k*-y+S*v,z=R*-y+z*v,D=E*-y+D*v,O=M,k=P,R=C),l=(g=ur(-w,z))*sr,g&&(v=Math.cos(-g),D=x*(y=Math.sin(-g))+D*v,T=M=T*v-A*y,b=P=b*v-S*y,w=C=w*v-z*y),u=(g=ur(b,T))*sr,g&&(M=T*(v=Math.cos(g))+b*(y=Math.sin(g)),P=O*v+k*y,b=b*v-T*y,k=k*v-O*y,T=M,O=P),h&&359.9<Math.abs(h)+Math.abs(u)&&(h=u=0,l=180-l),s=ia(Math.sqrt(T*T+b*b+w*w)),o=ia(Math.sqrt(k*k+R*R)),g=ur(O,k),f=2e-4<Math.abs(g)?g*sr:0,c=D?1/(D<0?-D:D):0),r.svg&&(M=t.getAttribute("transform"),r.forceCSS=t.setAttribute("transform","")||!ie(Pd(t,cr)),M&&t.setAttribute("transform",M))),90<Math.abs(f)&&Math.abs(f)<270&&(L?(s*=-1,f+=u<=0?180:-180,u+=u<=0?180:-180):(o*=-1,f+=f<=0?180:-180)),e=e||r.uncache,r.x=i-((r.xPercent=i&&(!e&&r.xPercent||(Math.round(t.offsetWidth/2)===Math.round(-i)?-50:0)))?t.offsetWidth*r.xPercent/100:0)+"px",r.y=n-((r.yPercent=n&&(!e&&r.yPercent||(Math.round(t.offsetHeight/2)===Math.round(-n)?-50:0)))?t.offsetHeight*r.yPercent/100:0)+"px",r.z=a+"px",r.scaleX=ia(s),r.scaleY=ia(o),r.rotation=ia(u)+I,r.rotationX=ia(h)+I,r.rotationY=ia(l)+I,r.skewX=f+I,r.skewY=d+I,r.transformPerspective=c+"px",(r.zOrigin=parseFloat(Y.split(" ")[2])||!e&&r.zOrigin||0)&&(F[pr]=kr(Y)),r.xOffset=r.yOffset=0,r.force3D=q.force3D,r.renderTransform=r.svg?zr:Ye?Sr:Mr,r.uncache=0,r},kr=function _firstTwoOnly(t){return(t=t.split(" "))[0]+" "+t[1]},Mr=function _renderNon3DTransforms(t,e){e.z="0px",e.rotationY=e.rotationX="0deg",e.force3D=0,Sr(t,e)},Pr="0deg",Cr="0px",Ar=") ",Sr=function _renderCSSTransforms(t,e){var r=e||this,i=r.xPercent,n=r.yPercent,a=r.x,s=r.y,o=r.z,u=r.rotation,h=r.rotationY,l=r.rotationX,f=r.skewX,d=r.skewY,c=r.scaleX,p=r.scaleY,_=r.transformPerspective,m=r.force3D,g=r.target,v=r.zOrigin,y="",T="auto"===m&&t&&1!==t||!0===m;if(v&&(l!==Pr||h!==Pr)){var b,w=parseFloat(h)*or,x=Math.sin(w),O=Math.cos(w);w=parseFloat(l)*or,b=Math.cos(w),a=oe(g,a,x*b*-v),s=oe(g,s,-Math.sin(w)*-v),o=oe(g,o,O*b*-v+v)}_!==Cr&&(y+="perspective("+_+Ar),(i||n)&&(y+="translate("+i+"%, "+n+"%) "),!T&&a===Cr&&s===Cr&&o===Cr||(y+=o!==Cr||T?"translate3d("+a+", "+s+", "+o+") ":"translate("+a+", "+s+Ar),u!==Pr&&(y+="rotate("+u+Ar),h!==Pr&&(y+="rotateY("+h+Ar),l!==Pr&&(y+="rotateX("+l+Ar),f===Pr&&d===Pr||(y+="skew("+f+", "+d+Ar),1===c&&1===p||(y+="scale("+c+", "+p+Ar),g.style[cr]=y||"translate(0, 0)"},zr=function _renderSVGTransforms(t,e){var r,i,n,a,s,o=e||this,u=o.xPercent,h=o.yPercent,l=o.x,f=o.y,d=o.rotation,c=o.skewX,p=o.skewY,_=o.scaleX,m=o.scaleY,g=o.target,v=o.xOrigin,y=o.yOrigin,T=o.xOffset,b=o.yOffset,w=o.forceCSS,x=parseFloat(l),O=parseFloat(f);d=parseFloat(d),c=parseFloat(c),(p=parseFloat(p))&&(c+=p=parseFloat(p),d+=p),d||c?(d*=or,c*=or,r=Math.cos(d)*_,i=Math.sin(d)*_,n=Math.sin(d-c)*-m,a=Math.cos(d-c)*m,c&&(p*=or,s=Math.tan(c-p),n*=s=Math.sqrt(1+s*s),a*=s,p&&(s=Math.tan(p),r*=s=Math.sqrt(1+s*s),i*=s)),r=ia(r),i=ia(i),n=ia(n),a=ia(a)):(r=_,a=m,i=n=0),(x&&!~(l+"").indexOf("px")||O&&!~(f+"").indexOf("px"))&&(x=_d(g,"x",l,"px"),O=_d(g,"y",f,"px")),(v||y||T||b)&&(x=ia(x+v-(v*r+y*n)+T),O=ia(O+y-(v*i+y*a)+b)),(u||h)&&(s=g.getBBox(),x=ia(x+u/100*s.width),O=ia(O+h/100*s.height)),s="matrix("+r+","+i+","+n+","+a+","+x+","+O+")",g.setAttribute("transform",s),w&&(g.style[cr]=s)};ha("padding,margin,Width,Radius",function(e,r){var t="Right",i="Bottom",n="Left",o=(r<3?["Top",t,i,n]:["Top"+n,"Top"+t,i+t,i+n]).map(function(t){return r<2?e+t:"border"+t+e});br[1<r?"border"+e:e]=function(e,t,r,i,n){var a,s;if(arguments.length<4)return a=o.map(function(t){return yr(e,t,r)}),5===(s=a.join(" ")).split(a[0]).length?a[0]:s;a=(i+"").split(" "),s={},o.forEach(function(t,e){return s[t]=a[e]=a[e]||a[(e-1)/2|0]}),e.init(t,s,n)}});var Er,Dr,Rr,Fr={name:"css",register:Sd,targetTest:function targetTest(t){return t.style&&t.nodeType},init:function init(t,e,i,n,a){var s,o,u,h,l,f,d,c,p,_,m,g,v,y,T,b,w=this._props,x=t.style,O=i.vars.startAt;for(d in Fe||Sd(),this.styles=this.styles||Md(t),b=this.styles.props,this.tween=i,e)if("autoRound"!==d&&(o=e[d],!pt[d]||!ac(d,e,i,n,t,a)))if(l=typeof o,f=br[d],"function"===l&&(l=typeof(o=o.call(i,n,t,a))),"string"===l&&~o.indexOf("random(")&&(o=ob(o)),f)f(this,t,d,o,i)&&(T=1);else if("--"===d.substr(0,2))s=(getComputedStyle(t).getPropertyValue(d)+"").trim(),o+="",Et.lastIndex=0,Et.test(s)||(c=Ya(s),p=Ya(o)),p?c!==p&&(s=_d(t,d,s,p)+p):c&&(o+=c),this.add(x,"setProperty",s,o,n,a,0,0,d),w.push(d),b.push(d,0,x[d]);else if("undefined"!==l){if(O&&d in O?(s="function"==typeof O[d]?O[d].call(i,n,t,a):O[d],r(s)&&~s.indexOf("random(")&&(s=ob(s)),Ya(s+"")||"auto"===s||(s+=q.units[d]||Ya(yr(t,d))||""),"="===(s+"").charAt(1)&&(s=yr(t,d))):s=yr(t,d),h=parseFloat(s),(_="string"===l&&"="===o.charAt(1)&&o.substr(0,2))&&(o=o.substr(2)),u=parseFloat(o),d in dr&&("autoAlpha"===d&&(1===h&&"hidden"===yr(t,"visibility")&&u&&(h=0),b.push("visibility",0,x.visibility),Yd(this,x,"visibility",h?"inherit":"hidden",u?"inherit":"hidden",!u)),"scale"!==d&&"transform"!==d&&~(d=dr[d]).indexOf(",")&&(d=d.split(",")[0])),m=d in ar)if(this.styles.save(d),g||((v=t._gsap).renderTransform&&!e.parseTransform||Or(t,e.parseTransform),y=!1!==e.smoothOrigin&&v.smooth,(g=this._pt=new _e(this._pt,x,cr,0,1,v.renderTransform,v,0,-1)).dep=1),"scale"===d)this._pt=new _e(this._pt,v,"scaleY",v.scaleY,(_?ka(v.scaleY,_+u):u)-v.scaleY||0,vd),this._pt.u=0,w.push("scaleY",d),d+="X";else{if("transformOrigin"===d){b.push(pr,0,x[pr]),o=de(o),v.svg?le(t,o,0,y,0,this):((p=parseFloat(o.split(" ")[2])||0)!==v.zOrigin&&Yd(this,v,"zOrigin",v.zOrigin,p),Yd(this,x,d,kr(s),kr(o)));continue}if("svgOrigin"===d){le(t,o,1,y,0,this);continue}if(d in xr){ve(this,v,d,h,_?ka(h,_+o):o);continue}if("smoothOrigin"===d){Yd(this,v,"smooth",v.smooth,o);continue}if("force3D"===d){v[d]=o;continue}if("transform"===d){xe(this,o,t);continue}}else d in x||(d=mr(d)||d);if(m||(u||0===u)&&(h||0===h)&&!fr.test(o)&&d in x)u=u||0,(c=(s+"").substr((h+"").length))!==(p=Ya(o)||(d in q.units?q.units[d]:c))&&(h=_d(t,d,s,p)),this._pt=new _e(this._pt,m?v:x,d,h,(_?ka(h,_+u):u)-h,m||"px"!==p&&"zIndex"!==d||!1===e.autoRound?vd:yd),this._pt.u=p||0,c!==p&&"%"!==p&&(this._pt.b=s,this._pt.r=xd);else if(d in x)be.call(this,t,d,s,_?_+o:o);else if(d in t)this.add(t,d,s||t[d],_?_+o:o,n,a);else if("parseTransform"!==d){Q(d,o);continue}m||(d in x?b.push(d,0,x[d]):b.push(d,1,s||t[d])),w.push(d)}T&&pe(this)},render:function render(t,e){if(e.tween._time||!Be())for(var r=e._pt;r;)r.r(t,r.d),r=r._next;else e.styles.revert()},get:yr,aliases:dr,getSetter:function getSetter(t,e,r){var i=dr[e];return i&&i.indexOf(",")<0&&(e=i),e in ar&&e!==pr&&(t._gsap.x||yr(t,"x"))?r&&Ie===r?"scale"===e?Ed:Dd:(Ie=r||{})&&("scale"===e?Fd:Gd):t.style&&!u(t.style[e])?Bd:~e.indexOf("-")?Cd:ne(t,e)},core:{_removeProperty:Xd,_getMatrix:ke}};ze.utils.checkPrefix=mr,ze.core.getStyleSaver=Md,Rr=ha((Er="x,y,z,scale,scaleX,scaleY,xPercent,yPercent")+","+(Dr="rotation,rotationX,rotationY,skewX,skewY")+",transform,transformOrigin,svgOrigin,force3D,smoothOrigin,transformPerspective",function(t){ar[t]=1}),ha(Dr,function(t){q.units[t]="deg",xr[t]=1}),dr[Rr[13]]=Er+","+Dr,ha("0:translateX,1:translateY,2:translateZ,8:rotate,8:rotationZ,8:rotateZ,9:rotateX,10:rotateY",function(t){var e=t.split(":");dr[e[1]]=Rr[e[0]]}),ha("x,y,z,top,right,bottom,left,width,height,fontSize,padding,margin,perspective",function(t){q.units[t]="px"}),ze.registerPlugin(Fr);var Lr=ze.registerPlugin(Fr)||ze,Ir=Lr.core.Tween;e.Back=Ze,e.Bounce=er,e.CSSPlugin=Fr,e.Circ=nr,e.Cubic=Qe,e.Elastic=$e,e.Expo=ir,e.Linear=Ge,e.Power0=qe,e.Power1=Ve,e.Power2=Ue,e.Power3=Xe,e.Power4=Ne,e.Quad=We,e.Quart=Ke,e.Quint=Je,e.Sine=rr,e.SteppedEase=tr,e.Strong=He,e.TimelineLite=Xt,e.TimelineMax=Xt,e.TweenLite=$t,e.TweenMax=Ir,e.default=Lr,e.gsap=Lr;if (typeof(window)==="undefined"||window!==e){Object.defineProperty(e,"__esModule",{value:!0})} else {delete e.default}});
/**
 * PLUGINS
 * jQuery UI 1.8.17
 * http://bassistance.de/jquery-plugins/jquery-plugin-tooltip/
 * http://benalman.com/projects/jquery-hashchange-plugin/
 * http://bassistance.de/jquery-plugins/jquery-plugin-validation/
 * http://modernizr.com/download/#-fontface-backgroundsize-rgba-cssanimations-generatedcontent-cssgradients-csstransforms-csstransforms3d-csstransitions-hashchange-audio-video-input-inputtypes-svg-touch-shiv-cssclasses-teststyles-testprop-testallprops-hasevent-prefixes-domprefixes-load
 * http://cherne.net/brian/resources/jquery.hoverIntent.html
 * http://gsgd.co.uk/sandbox/jquery/easing/
 * http://hammerjs.github.io/
 */

/**
 * MINIFY Only works (ES6) with
 * https://skalman.github.io/UglifyJS-online/
 */

/*!
 * app.js
 */
var app = (function (app, $) {
  document.cookie = "rv=1";
  let $cache = {};

  /******** private functions & vars **********/

  // cache dom elements accessed multiple times
  // app.ui holds globally available elements
  function initUiCache() {
    app.ui = {
      searchContainer: $("#nav-menu-search"),
      searchInput: $("input#r-search-text"),
      searchResults: $('#nav-menu-search #hits'),
      searchAutocomplete: $('#search_autocomplete'),
      searchSuggestions: $('#search_suggestions'),
      searchToggle: $("li.menu-search"),


      main: $("#wrap"),
      content: $('#rove'),
      header: $("#header"),
      headerNav: $("#r-nav-container"),
      primaryMenu: $("#nav-menu-primary"),
      secondaryMenu: $("#nav-menu-secondary"),
      shopMenu: $(".menu-shop"),
      contentContainer: $("#content-wrap"),
      footer: $("footer.footer"),


      menuTriggers: $('.menu-trigger'),
      menuTriggersAr: $('.menu-trigger-ar'),

      blackout: '<div class="blackout"></div>',
      loadClick: '<div class="ajax-progress ajax-progress-throbber"><i class="icon-load"></i></div>',
      mobileSearchToggle: $("#mobile-navbar .mobile-search"),

      printPage: $("a.print-page"),

      // TODO: Necessary?
      reviewsContainer: $("#pwrwritediv"),
      primary: $("#primary"),
      secondary: $("#secondary"),
      faq: $('.pdp-help'),
      chat: $('.chat-container'),
      chatlink: $('.chat-link-container')
    };

    app.ua = navigator.userAgent || navigator.vendor || window.opera;
    app.isiPadAndSmallerInit = (window.innerWidth <= 768 || document.body.clientWidth <= 768);
    app.isMobileInit = (window.innerWidth < 768 || document.body.clientWidth < 768);
    app.isMobileDevice = (/iPhone|iPod|iPad|Android|BlackBerry|Opera Mini|IEMobile/).test(app.ua);
    app.isTablet = (window.innerWidth >= 768 && document.body.clientWidth <= 1024);
    app.isIpad = /ipad/i.test(app.ua.toLowerCase());
    app.isIOS = (/iPhone|iPod|iPad/).test(app.ua);

    app.isCountryMembershipOnly = $('body').hasClass('memberonly');
    app.isLockedComparePrice = $('body').hasClass('compareprices');

    app.resources = {
      COOKIES_DISABLED: "Your browser currently is not set to accept Cookies. Please turn it on or check if you have another program set to block cookies.",
      CLEAR_RECENT_SEARCHES: "Clear recent searches",
      WISHLIST_FINDER: "Wishlist",
      BACK_TO_TOP: "Back to top"
    };

    app.search_activated = 0;

    app.urls = {
      wishlist: '/i-love'
    };

    app.liveInfoIterate = 0;

    app.eventListenersScroll = [];
    app.eventListenersResize = [];
    app.eventListenersClick = [];
    app.eventListenersAjax = []; // When dom changes, we want to update..

    app.eventQueue = []; // If events occur unloaded, they will be queued
  }

  function initializeEvents() {
    // print handler
    app.ui.printPage.on("click", function () {
      window.print();
      return false;
    });

    $(window).on("resize", function () {
      let listeners = app.getEventListeners('resize');
      for (let x in listeners) {
        if (listeners.hasOwnProperty(x)) {
          app.executeFunctionByName(listeners[x], window);
        }
      }

      // Send an event when device changes from mobile to desktop and visa versa
      if (app.isiPadAndSmallerInit !== app.isiPadAndSmaller()) {
        app.isiPadAndSmallerInit = !app.isiPadAndSmallerInit;
        $(document).trigger('deviceChange');
      }
    });

    $(window).on("scroll", function () {
      let listeners = app.getEventListeners('scroll');
      for (let x in listeners) {
        if (listeners.hasOwnProperty(x)) {
          app.executeFunctionByName(listeners[x], window);
        }
      }

      app.components.stick($('#main'), $('.checkout-progress-indicator-stuck').first(), 0);

      // check if footer is in the viewport
      /*
      if (app.util.isInViewPortPartial($footerglobal)) {
        //alert('shift chat');
      } else {
        //alert('shift chat2');
      }
      */
    });

    $(document).on('click', function (event) {
      let $element = $(event.target);
      let listeners = app.getEventListeners('click');
      for (let x in listeners) {
        if (listeners.hasOwnProperty(x)) {
          app.executeFunctionByName(listeners[x], window, $element);
        }
      }

      // Close button (alerts)
      if ($element.hasClass('close')) {
        event.preventDefault();
        $element.parent().remove();
      }
    });

    // Listen to Drupal ajax events starting
    $(document).ajaxSend(function (event, jqxhr, sett) {
      if (sett.url === window.location.pathname) {
        $cache.ajaxRunning = true;
        //$('.checkout_summary').css('opacity',0.5);
        $('body').addClass('pane-loading').addClass('ajax-loading');
        // In some cases we changed the value via javascript
        //$cache.lastAjaxTrigger = $('[name="'+sett.extraData._triggering_element_name+'"][value="'+sett.extraData._triggering_element_value+'"],[name="'+sett.extraData._triggering_element_name+'"][data-actual="'+sett.extraData._triggering_element_value+'"]').not('.linkLoading');
        $cache.lastAjaxTrigger = $('[name="'+sett.extraData._triggering_element_name+'"][value="'+sett.extraData._triggering_element_value+'"],[name="'+sett.extraData._triggering_element_name+'"][data-actual]').not('.linkLoading');
        $cache.lastAjaxTrigger.parent().addClass('load-trigger');
        $cache.lastAjaxTrigger.trigger('ajaxStarted');

        $(document).trigger('ajaxBegin');
      }
    });

    // Listen to Drupal ajax events ending
    $(document).ajaxStop(function () {
      $cache.ajaxRunning = false;
      //$('.checkout_summary').css('opacity',1);
      $('body').removeClass('pane-loading').removeClass('ajax-loading');

      if (typeof $cache.lastAjaxTrigger !== 'undefined') {
        $cache.lastAjaxTrigger.parent().removeClass('load-trigger');
        $cache.lastAjaxTrigger.trigger('ajaxEnded');
      }

      $(document).trigger('ajaxEnding');
    });
  }

  function initializeDom() {
    // cookie check
    if (document.cookie.length === 0) {
      $("<div/>").addClass("messages error").append($("<p/>").addClass("browser-error").html(app.resources.COOKIES_DISABLED)).appendTo("#browser-check");
    }

    // write a class to html tag of browser version
    var browser = app.ua.match(/(opera|chrome|safari|firefox|msie|trident)\/?\s*(\.?\d+(\.\d+)*)/i);
    if (browser && browser.length >= 2) {
      $('html').addClass(browser[1].toLowerCase());
    }

    // mobile device detection
    var device = app.ua.match(/android|webos|iphone|ipad|ipod|blackberry|iemobile|opera mini/i);
    if (device && device.length >= 1) {
      $('html').addClass(device[0].toLowerCase());
    } else {
      $('html').removeClass('touch').addClass('no-touch');
    }

    // remove top when sticky is not supported
    var $stickies = $('.rove-sticky');
    if ($stickies.length > 0) {
      if (!window.getComputedStyle(document.querySelector('.rove-sticky')).position.match('sticky')) {
        $stickies.css("top", "auto");
      }
    }

    //Move bubble chat up in case of countdown
    let observer = new MutationObserver(function() {
      if ($("#countdown").length) {
        $("body").get(0).style.setProperty("--bottom", $("#countdown").height() + "px");
      } else {
        $("body").get(0).style.setProperty("--bottom", "0px");
      }
    });

    let uri = window.location.pathname;
    let is_ar = (uri.indexOf('/ar/') >= 0 || uri == '/ar') ? 1 : 0; //check if it's AR page

    if(is_ar === 0) {
      observer.observe(document, {attributes: false, childList: true, characterData: false, subtree: true});

      let observer1 = new MutationObserver(function () {
        if (document.querySelector("#klaviyo_form_msgs .alert")) {
          document.querySelector("#klaviyo_form_msgs .alert").setAttribute("role", "alert")
          document.querySelector("#klaviyo_form_msgs .alert").focus();
        }
      });
      let kfm = document.querySelector("#klaviyo_form_msgs");
      if (kfm !== null) {
        observer1.observe(kfm, {childList: true, subtree: true});
      }
    }

    // Canada we want to force member registration -- ($cache.country === "ca" || $cache.country === "canada")
    if (app.isCountryMembershipOnly) {
      app.checkout.lockMembershipOnly();
    }

  }

  // _app object
  // "inherits" app object via $.extend() at the end of this seaf (Self-Executing Anonymous Function
  var _app = {
    containerId: "content",
    ProductCache: null,
    // app.Product object ref to the current/main product
    ProductDetail: null,
    isMobileDevice: null,
    body: $('body'),
    init: function () {

      // init global cache
      initUiCache();

      // init global dom elements
      initializeDom();

      // init global events
      initializeEvents();

      // init tracking
      //app.tracking.init(); # Now done after live_info.js

      // init specific global components
      app.searchbar.init();
      app.nav.init();
      app.components.init();
      app.klaviyo.init();
      app.justuno.init();

      // TODO: This should be initiated with app.page.ns = 'category'
      //app.category.init();

      //app.tooltips.init();
      //app.minicart.init();
      //app.validator.init();
      //app.ordereturn.init();
      //app.footer.init();

      //gaa.trackitems();
      // tracks products and promotions

      // execute page specific initializations
      if (typeof app.page === 'undefined') {
        app.page = {
          ns: ''
        };
      }
      if (typeof roveApp !== 'undefined') {
        app.page.setContext(roveApp);
      }

      var ns = app.page.ns;
      if (ns && app[ns] && app[ns].init) {
        app[ns].init();
      }

      app.abtest.init();

      // if (window.location.pathname.indexOf("/ar/") > -1){
      //   // app.page.ARTutorial();
      //   setTimeout(() => {
      //       if ($(".ar-product").length > 0) {
      //         app.page.ARTutorial();
      //         //app.page.ARTutToast();
      //         app.page.ARHelpBtn();
      //       }
      //   }, 500);
      //
      // }

      // Mulberry init
      app.components.mulberry();

      app.continuous_liveinfo();

      app.preventRightClick('#colorbox img, #product-photos img, #product-photos img');

      // $("input").off("blur change keydown keyup keypress focus")
    },
    preventRightClick: function(elements) {
      // Disable right clicking of images
      $(document).on('contextmenu',elements,function() {
        return false;
      });
      /*
      app.ui.contentContainer.on('contextmenu', element, function(e){
        return false;
      });
      */
    },
    isAjaxRunning: function() {
      return $cache.ajaxRunning;
    },
    runLiveInfo: function (id, eventname) {
      // Only run on roveconcepts.com domains
      if (window.location.hostname.match(/rove/ig) !== null) {
        var base = id;
        var pagequery = location.search.length > 1 ? decodeURIComponent(location.search.substr(1)) : '';
        var pathquery = 'pathname='+(pagequery.length > 0 ? window.location.pathname + '&' + pagequery : window.location.pathname);
        if (!app.liveInfoIterate) {
          pathquery += '&init=1';
        }

        var element_settings = {
          url: window.location.protocol + '//' + window.location.hostname + Drupal.settings.basePath + Drupal.settings.pathPrefix + 'ajax/live_info.json?' + pathquery,
          event: eventname,
          progress: {
            type: 'throbber'
          }
        };
        Drupal.ajax[base] = new Drupal.ajax(base, jQuery('#' + id)[0], element_settings);
        app.liveInfoIterate++;
      }
    },
    getCountryLangCode: function(country) {
      switch(country.toUpperCase()) {
        case 'CA':
          return 'en_CA';
        case 'AU':
          return 'en_AU';
        case 'KR':
          return 'ko_KR';
        case 'UK':
          return 'en_UK';
        case 'HK':
          return 'ch_HK';
        case 'US':
        default:
          return 'en_US';
      }
    },
    getCurrency: function() {
      return $.cookie('uc_warehouse_location') === 'CA' ? 'CAD' : ($.cookie('uc_warehouse_location') === 'AU' ? 'AUD': ($.cookie('uc_warehouse_location') === 'KR' ? 'KRW': ($.cookie('uc_warehouse_location') === 'UK' ? 'GBP': $.cookie('uc_warehouse_location') === 'HK' ? 'HKD' : 'USD')));
    },
    continuous_liveinfo: function () {
      function refreshLiveInfo() {
        app.runLiveInfo('content-wrap', 'reload.data');
        $('#content-wrap').trigger('reload.data');
        $('#content-wrap').unbind('reload.data');
      }

      refreshLiveInfo();
      setInterval(refreshLiveInfo, 300 * 1000); //every 5 minutes
    },
    // List of function names to execute
    addEventListener: function (f, type) {
      switch (type) {
        case 'scroll':
          app.eventListenersScroll.push(f);
          break;
        case 'resize':
          app.eventListenersResize.push(f);
          break;
        case 'click':
          app.eventListenersClick.push(f);
          break;
        case 'ajax':
          app.eventListenersAjax.push(f);
          break;
        default:
          console.log('Invalid event listener passed.');
          break;
      }
    },
    // Remove event listener
    removeEventListener: function(f, type) {
      switch (type) {
        case 'scroll':
          app.eventListenersScroll.splice(f,1);
          break;
        case 'resize':
          app.eventListenersResize.splice(f,1);
          break;
        case 'click':
          app.eventListenersClick.splice(f,1);
          break;
        case 'ajax':
          app.eventListenersAjax.splice(f,1);
          break;
        default:
          console.log('Invalid event listener passed.');
          break;
      }
    },
    // Get event listeners
    getEventListeners: function (type) {
      switch (type) {
        case 'scroll':
          return app.eventListenersScroll;
          break;
        case 'resize':
          return app.eventListenersResize;
          break;
        case 'click':
          return app.eventListenersClick;
          break;
        case 'ajax':
          return app.eventListenersAjax;
          break;
        default:
          console.log('Invalid event listener requested.');
          break;
      }
    },
    // Check if event listener is set
    checkEventListener: function(f, type) {
      switch (type) {
        case 'scroll':
          return $.inArray(f,app.eventListenersScroll) !== -1;
          break;
        case 'resize':
          return $.inArray(f,app.eventListenersResize) !== -1;
          break;
        case 'click':
          return $.inArray(f,app.eventListenersClick) !== -1;
          break;
        case 'ajax':
          return $.inArray(f,app.eventListenersAjax) !== -1;
          break;
        default:
          console.log('Invalid event listener requested.');
          break;
      }
    },
    // Execute a function by string
    executeFunctionByName: function (functionName, context) {
      let args = Array.prototype.slice.call(arguments, 2);
      let namespaces = functionName.split(".");
      let func = namespaces.pop();
      for (let i = 0; i < namespaces.length; i++) {
        context = context[namespaces[i]];
      }
      return context[func].apply(context, args);
    },
    getCountry: function () {
      let country = $.cookie('uc_warehouse_location');
      if (country === null && typeof Drupal.settings.uc_warehouse_location !== 'undefined' && typeof Drupal.settings.uc_warehouse_location.initialLocale !== 'undefined') {
        country = Drupal.settings.uc_warehouse_location.initialLocale;

        // set the cookie
        $.cookie('uc_warehouse_location',country,{expires:365,path:'/',secure: true,domain:app.util.getUri(window.location.href).host});
      }
      //console.log('country: ' + country);
      return country;
    },
    // Determine if current state is mobile size
    isMobile: function () {
      app.isMobileInit = (window.innerWidth < 768 || document.body.clientWidth < 768 || /(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|ipad|iris|kindle|Android|Silk|lge |maemo|midp|mmp|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows (ce|phone)|xda|xiino/i.test(navigator.userAgent)
        || /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(navigator.userAgent.substr(0,4)));
      return app.isMobileInit;
      //return $(window).width() <= 768;
    },
    isExtraSmallAndSmaller: function () {
      return window.matchMedia("(max-width: 319px)").matches
    },
    isExtraSmallAndGreater: function () {
      return window.matchMedia("(min-width: 320px)").matches
    },
    isSmallAndSmaller: function () {
      return window.matchMedia("(max-width: 424px)").matches
    },
    isSmallAndGreater: function () {
      return window.matchMedia("(min-width: 425px)").matches
    },
    isMobileAndSmaller: function () {
      return window.matchMedia("(max-width: 767px)").matches
    },
    isMobileAndGreater: function () {
      return window.matchMedia("(min-width: 768px)").matches
    },
    isiPadAndSmaller: function () {
      return window.matchMedia("(max-width: 768px)").matches
    },
    isGreaterThaniPad: function () {
      return window.matchMedia("(min-width: 769px)").matches
    },
    isTabletAndSmaller: function () {
      return window.matchMedia("(max-width: 969px)").matches
    },
    isTabletAndGreater: function () {
      return window.matchMedia("(min-width: 970px)").matches
    },
    isDesktopAndSmaller: function () {
      return window.matchMedia("(max-width: 1366px)").matches
    },
    isDesktopAndGreater: function () {
      return window.matchMedia("(min-width: 1367px)").matches
    },
    isLargeDesktopAndSmaller: function () {
      return window.matchMedia("(max-width: 1599px)").matches
    },
    isLargeDesktopAndGreater: function () {
      return window.matchMedia("(min-width: 1600px)").matches
    },
    isMouseDevice: function () {
      return "onclick" in document.documentElement
    },
    isTouchDevice: function () {
      return "ontouchstart" in document.documentElement
    },
    isTabletDevice: function () {
      return window.matchMedia("(min-width: 768px)").matches && /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(app.ua)
    },
    isMobilePhone: function () {
      return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(app.ua)
    },
    isiPhone: function () {
      return /iPhone/i.test(app.ua)
    },
    isiPad: function () {
      app.isMobileInit = (window.innerWidth === 768 || document.body.clientWidth === 768);
      return app.isMobileInit;
      return /iPad/i.test(app.ua)
    },
    isiOS: function () {
      return this.isiPhone || this.isiPad
    },
    isAndroid: function () {
      return /Android/i.test(app.ua)
    },
    isProductPage: function() {
      return app.body.hasClass('node-type-product');
    },
    isCategoryPage: function() {
      return app.body.hasClass('page-taxonomy-term');
    },
    isCartPage: function() {
      return app.body.hasClass('page-cart') && !app.body.hasClass('page-cart-checkout');
    },
    isCheckoutPage: function() {
      return app.body.hasClass('page-cart-checkout');
    },
    isFrontPage: function() {
      return app.body.hasClass('front');
    }

  };

  return $.extend(app, _app);

}(window.app = window.app || {}, jQuery));


// init print
(function ($) {

  //initialize app
  Drupal.behaviors.roveApp = {
    attach: function (context, settings) {
      $('html').once('roveApp', function () {
        app.init();
      });
    }
  };
  $(document).ajaxStop(function () {
    let listeners = app.getEventListeners('ajax');
    for (let x in listeners) {
      if (listeners.hasOwnProperty(x)) {
        app.executeFunctionByName(listeners[x], window);
      }
    }
    app.components.getLazy().update();
    app.components.hoverProduct();

  });
  /*
  $(document).ready(function() {
    app.init();
  });
  */

  var beforePrint = function () {
    var $lazy = $('img');
    $.each($lazy, function (index, value) {
      var $img = $(this);
      var src = $img.attr('data-original');
      if (src) {
        $img.attr('src', src);
      }
    });
  };
  var afterPrint = function () {//console.log('Functionality to run after printing');
  };

  if (window.matchMedia) {
    var mediaQueryList = window.matchMedia('print');
    if (mediaQueryList.addEventListener) {
      mediaQueryList.addListener(function (mql) {
        if (mql.matches) {
          beforePrint();
        } else {
          afterPrint();
        }
      });
    }
  }

  window.onbeforeprint = beforePrint;
  window.onafterprint = afterPrint;

  $.fn.imageloaded = function (callback) {
    var $img = this;
    var $image = $img.get(0);
    // if image is loaded
    if($image){
      if ($image.complete) {
        // meaning less timeout, just used for cached images so that they wont return 0 for width and height
        setTimeout(function () {
          if (typeof callback === "function") {
            callback.call(this, $image);
          }
        }, 0);

      }// wait for image to load
    }
    else {
      $img.on("load", function () {
        if (typeof callback === "function") {
          callback.call(this, $image);
        }
      });
    }
  };
}(jQuery));

/*
This is a callalble function within Drupal.
ajax_command_invoke('document', 'appCall',[['callback'=>'app.namespace.function','x'=>1,'etc'=>'2']]);
 */
(function ($) {
  $.fn.appCall = function (data) {
    let callback = data.callback.split('.');
    delete data.callback;

    if (callback.length === 3) {
      window[callback[0]][callback[1]][callback[2]](data);
    } else if (callback.length === 2) {
      window[callback[0]][callback[1]](data);
    } else if (callback.length === 1) {
      window[callback[0]](data);
    }

  };
}(jQuery));



jQuery(document).ready(function($) {
  if($(".open-vr").length > 0) {
      var isMac = navigator.platform.toUpperCase().indexOf('MAC') >= 0;
      if (isMac) {
          $('body').addClass('is_mac');
      }

      $(".open-vr").click(function (e) {
          e.preventDefault();
          var y = $(window).height();
          var x = $(window).width();

          $.colorbox({
              href: $(this).attr('href'), width: x, height: y, top: 0, onComplete: function () {
                  $('body, html').css('overflow', 'hidden');
                  $('#admin-menu, #skulookup, .adminhud').hide();
                  $('body').addClass('colorbox_opened');
              }, onClosed: function () {
                  $('body, html').css('overflow', 'auto');
                  $('#admin-menu, #skulookup, .adminhud').show();
                  $('body').removeClass('colorbox_opened');
              }
          });
      });


      var show_video = function () {
          var isMobile = false;
          if (((/Android|webOS|iPhone|iPad|iPod|BlackBerry/i.test(navigator.userAgent) ||
              (/Android|webOS|iPhone|iPad|iPod|BlackBerry/i.test(navigator.platform)))) || (((/Linux/i.test(navigator.platform)) || (/Linux/i.test(navigator.userAgent))) || jQuery(window).width() < 1024)) {
              isMobile = true;
          }
          if (isMobile == true) {
              $('#image_wrapper, .open-vr-desktop').hide();
              $('#for_mobile, .open-vr-mobile').show();
          } else {
              $('#image_wrapper, .open-vr-desktop').show();
              $('#for_mobile, .open-vr-mobile').hide();
          }
      }
      show_video();

      $(window).on('resize', function () {
          show_video();
      })
  }

});
/*!
 * app.ui.util.js
 */
(function (app, $) {
	// sub namespace app.util.* contains utility functions
	app.util = {
		/* Capitalize a string */
		capitalizeFirstLetter: function (string) {
			return string.charAt(0).toUpperCase() + string.slice(1);
		},

		/* Simulate php's number_format function */
		number_format: function (number, decimals, dec_point, thousands_sep) {
			// Strip all characters but numerical ones.
			number = (number + '').replace(/[^0-9+\-Ee.]/g, '');
			var n = !isFinite(+number) ? 0 : +number,
				prec = !isFinite(+decimals) ? 0 : Math.abs(decimals),
				sep = (typeof thousands_sep === 'undefined') ? ',' : thousands_sep,
				dec = (typeof dec_point === 'undefined') ? '.' : dec_point,
				s = '',
				toFixedFix = function (n, prec) {
					var k = Math.pow(10, prec);
					return '' + Math.round(n * k) / k;
				};
			// Fix for IE parseFloat(0.55).toFixed(0) = 0;
			s = (prec ? toFixedFix(n, prec) : '' + Math.round(n)).split('.');
			if (s[0].length > 3) {
				s[0] = s[0].replace(/\B(?=(?:\d{3})+(?!\d))/g, sep);
			}
			if ((s[1] || '').length < prec) {
				s[1] = s[1] || '';
				s[1] += new Array(prec - s[1].length + 1).join('0');
			}
			return s.join(dec);
		},

		truncateString: function(str, num) {
			// If the length of str is less than or equal to num
			// just return str--don't truncate it.
			if (str.length <= num) {
				return str
			}
			// Return str truncated with '...' concatenated to the end of str.
			return str.slice(0, num) + '...'
		},

		// If we have Management Chair - High back - transform to parts[0] = Management Chair, parts[1] = High Back
		splitString: function(string, splitter) {
			let parts = [];
			let i = string.indexOf(splitter);
			if (i !== -1) {
				parts.push(string.slice(0,i));
				parts.push(string.slice(i+splitter.length));
			} else {
				parts.push(string);
			}
			return parts;
		},

		removeLazy: function ($container) {
			var $lazy = $container.find('img.lazy');
			$.each($lazy, function (index, value) {
				var $img = $(this);
				var src = $img.attr('data-original');
				if (src) {
					$img.attr('src', src);
				}
			});
		},
		// appends the parameter with the given name and
		// value to the given url and returns the changed url
		appendParamToURL: function (url, name, value) {
			var c = "?";
			if (url.indexOf(c) !== -1) {
				c = "&";
			}
			return url + c + name + "=" + encodeURIComponent(value);
		},
		appendParamsToUrl: function (url, params) {
			var uri = app.util.getUri(url)
				, includeHash = arguments.length < 3 ? false : arguments[2];

			var qsParams = $.extend(true, uri.queryParams, params);
			Object.keys(qsParams)
				.sort(function(a, b) { return qsParams[a] - qsParams[b]; })
				.reduce(function(obj,key) {
					obj[key] = qsParams[key];
					return obj;
				},{});
				/*
				.reduce((obj, key) => ({
					...obj,
					[key]: qsParams[key]
				}), {});
				*/
			var result = uri.path + "?" + $.param(qsParams);
			if (includeHash) {
				result += uri.hash;
			}
			return result;
		},
		removeParamFromURL: function (url, parameter) {
			var urlparts = url.split('?');

			if (urlparts.length >= 2) {
				var urlBase = urlparts.shift();
				var queryString = urlparts.join("?");

				//var prefix = encodeURIComponent(parameter) + '=';
				var prefix = parameter + '=';
				var pars = queryString.split(/[&;]/g);
				var i = pars.length;
				while (0 < i--) {
					if (pars[i].lastIndexOf(prefix, 0) !== -1) {
						pars.splice(i, 1);
					}
				}
				url = urlBase + '?' + pars.join('&');
			}
			return url;
		},
		replaceUrlState: function (url,title) {
			//window.history.pushState({key:value},"", url);
			window.history.replaceState(null, title?title:null, url);
		},
		staticUrl: function (path) {
			if (!path || $.trim(path).length === 0) {
				return app.urls.staticPath;
			}
			return app.urls.staticPath + (path.charAt(0) === "/" ? path.substr(1) : path);
		},
		ajaxUrl: function (path) {
			return app.util.appendParamToURL(path, "format", "ajax");
		},
		toAbsoluteUrl: function (url) {
			if (url && url.indexOf("http") !== 0 && url.charAt(0) !== "/") {
				url = "/" + url;
			}
			return url;
		},
    replaceText: function(className,textToFind,textToUse) {
      let eles = document.getElementsByClassName(className);
      for(let ele in eles) {
        if (eles.hasOwnProperty(ele)) {
          app.util.replaceTextElement(eles[ele],textToFind,textToUse);
        }
      }
    },
    replaceTextElement: function(element,textToFind,textToUse) {
      if (typeof element.innerHTML !== 'undefined' && element.innerHTML.length > 0) {
        element.innerHTML = element.innerHTML.replace(textToFind,textToUse);
      } else if (typeof element.innerHTML === 'undefined' && typeof element.html === 'function') {
        element.html(element.html().replace(textToFind,textToUse))
      }
    },

		loadJScript: function(url,async) {
			let tag = document.createElement('script');
			tag.src = url;
			if (async) {
				tag.setAttribute('async', '');
			}
			let firstScriptTag = document.getElementsByTagName('script')[0];
			firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);
		},
		loadDynamicCss: function (urls) {
			var i, len = urls.length;
			for (i = 0; i < len; i++) {
				app.util.loadedCssFiles.push(app.util.loadCssFile(urls[i]));
			}
		},
		// dynamically loads a CSS file
		loadCssFile: function (url) {
			if (/MSIE\s(5\.5|6\.)/.test(navigator.userAgent)) {
				return $('head').append('<link rel="stylesheet" href="' + url + '" type="text/css" />');
				//					return $("<link/>").appendTo($("head")).attr({
				//					type : "text/css",
				//					rel : "stylesheet"
				//					}).attr("href", url); // for i.e. <9, href must be added after link has been appended to head
			} else {
				return $("<link/>").appendTo($("head")).attr({
					type: "text/css",
					rel: "stylesheet",
					href: url
				});
			}

		},
		// array to keep track of the dynamically loaded CSS files
		loadedCssFiles: [],

		// removes all dynamically loaded CSS files
		clearDynamicCss: function () {
			let i = app.util.loadedCssFiles.length;
			while (0 > i--) {
				$(app.util.loadedCssFiles[i]).remove();
			}
			app.util.loadedCssFiles = [];
		},

		isCssLoaded: function (url) {
			let i = app.util.loadedCssFiles.length;
			while (0 > i--) {
				if (app.util.loadedCssFiles[i] === url) {
					return true;
				}
			}
			return false;
		},

		getQueryStringParams: function (qs) {
			if (!qs || qs.length === 0) {
				return {};
			}
			var params = {};
			// Use the String::replace method to iterate over each
			// name-value pair in the string.
			qs.replace(new RegExp("([^?=&]+)(=([^&]*))?", "g"), function ($0, $1, $2, $3) {
				switch (typeof params[$1]) {
					case 'object':
						//params[$1].push($3).sort();
						params[$1][$3] = $3;
						params[$1] = Object.keys(params[$1])
							.sort(function(a, b) { return params[$1][a] - params[$1][b]; })
							.reduce(function(obj,key) {
								obj[key] = params[$1][key];
								return obj;
							});
							/*
							.reduce((obj, key) => ({
								...obj,
								[key]: params[$1][key]
							}), {});
							*/
						break;
					case 'undefined':
						params[$1] = $3;
						break;
					default:
						let par = params[$1];
						params[$1] = {};
						params[$1][par] = par;
						params[$1][$3] = $3;
						params[$1] = Object.keys(params[$1])
							.sort(function(a, b) { return params[$1][a] - params[$1][b]; })
							.reduce(function(obj,key) {
								obj[key] = params[$1][key];
								return obj;
							});
							/*
							.reduce((obj, key) => ({
								...obj,
								[key]: params[$1][key]
							}), {});
							*/
						break;
				}
				if (typeof params[$1] === 'object') {
					params[$1] = Object.values(params[$1]);
				}
			});
			return params;
		},

		getUri: function (o) {
			if (typeof o === "undefined") {
				return;
			}

			var a;
			if (o.tagName && o.hasAttribute("href")) {
				a = o;
			} else if (typeof o === "string") {
				a = document.createElement("a");
				a.href = o;
			} else {
				return null;
			}

			var path = a.pathname;
			if (path.indexOf('/') !== 0) {
				path = "/" + a.pathname;
				// fix for root-relative urls for IE. See http://stackoverflow.com/questions/956233/javascript-pathname-ie-quirk
			}

			return {
				protocol: a.protocol,
				//http:
				host: a.host,
				//www.myexample.com
				hostname: a.hostname,
				//www.myexample.com'
				port: a.port,
				//:80
				path: path,
				// /sub1/sub2
				query: a.search,
				// ?param1=val1&param2=val2
				queryParams: a.search.length > 1 ? app.util.getQueryStringParams(a.search.substr(1)) : {},
				hash: a.hash,
				// #OU812,5150
				url: a.protocol + "//" + a.host + a.pathname,
				urlWithQuery: a.protocol + "//" + a.host + a.port + a.pathname + a.search
			};
		},

    delay: function(time) {
      return new Promise(resolve => setTimeout(resolve, time));
    },

		postForm: function (args) {
			var form = $("<form>").attr({
				action: args.url,
				method: "post"
			}).appendTo("body");
			var p;
			for (p in args.fields) {
				$("<input>").attr({
					name: p,
					value: args.fields[p]
				}).appendTo(form);
			}
			form.submit();
		},
		// Change the palceholder text to an input field
		toggleFormElm: function (elm, defaultText) {
			if (typeof elm === 'string') {
				elm = $(elm);
			}

			if ($.support.placeholder) {
				elm.attr('placeholder', defaultText);
			} else {

				if (elm.val() == '') {
					elm.val(defaultText);
				}

				elm.css("color", "#999");

				elm.on('focus', function () {
					if ($(this).val() == defaultText) {
						$(this).css("color", "#000").val("");
					} else {
						$(this).css("color", "#000");
					}
				}).on('blur', function (event, ui) {
					if ($(this).val() == "" || $(this).val() == defaultText) {
						$(this).css("color", "#999").val(defaultText);
					} else {
						$(this).css("color", "#000");
					}
				});
			}
		},
		// Credit card validation #
		Mod10: function (number) {
			// make sure it is number
			if (isNaN(number)) {
				return false;
			}
			var doubled = [];
			var i;
			for (i = number.length - 2; i >= 0; i = i - 2) {
				doubled.push(2 * number[i]);
			}
			var total = 0;
			for (i = ((number.length % 2) == 0 ? 1 : 0); i < number.length; i = i + 2) {
				total += parseInt(number[i]);
			}
			for (i = 0; i < doubled.length; i++) {
				var num = doubled[i];
				var digit;
				while (num != 0) {
					digit = num % 10;
					num = parseInt(num / 10);
					total += digit;
				}
			}
			if (total % 10 == 0) {
				return (true);
			} else {
				return (false);
			}
		},

		/**
		 * Determines if an element is ALL in the view port
		 */
		isInViewPort: function (el) {
			if (typeof jQuery === "function" && el instanceof jQuery) {
				el = el[0];
			}
			var rect = el.getBoundingClientRect();
			return (rect.top >= 0 && rect.left >= 0 && rect.bottom <= (window.innerHeight || document.documentElement.clientHeight) && /*or $(window).height() */
				rect.right <= (window.innerWidth || document.documentElement.clientWidth)/*or $(window).width() */
			);

		},
		/**
		 * Determines if ANY part of element is in the view port
		 */
		isInViewPortPartial: function (el) {
			console.log(el);
			if (typeof jQuery === "function" && el instanceof jQuery) {
				el = el[0];
			}
			var rect = el.getBoundingClientRect();
			return (rect.top <= $(window).height() && rect.bottom >= 0 && rect.left <= $(window).width() && rect.right >= 0);
		},

		/**
		 * Prioritize an event .on event to run first
		 * @param $ele
		 * @param name
		 * @param fn
		 */
		bindFirst: function($ele, name, fn) {
			// bind as you normally would
			// don't want to miss out on any jQuery magic
			$ele.on(name, fn);

			// Thanks to a comment by @Martin, adding support for
			// namespaced events too.
			$ele.each(function(e,i) {
				let handlers = $._data(i, 'events')[name.split('.')[0]];
				// take out the handler we just inserted from the end
				let handler = handlers.pop();
				// move it at the beginning
				handlers.splice(0, 0, handler);
			});
		},

		differenceOf2Arrays: function(array1, array2) {
			let temp = [];
			array1 = Object.values(array1).toString().split(',').map(Number);
			array2 = Object.values(array2).toString().split(',').map(Number);

			for (let i in array1) {
				if(array2.indexOf(array1[i]) === -1) temp.push(array1[i]);
			}
			for(let i in array2) {
				if(array1.indexOf(array2[i]) === -1) temp.push(array2[i]);
			}
			return temp.sort((a,b) => a-b);
		},

    replaceMembersOnlyText: function(element,string,replacementString) {
      if (app.isCountryMembershipOnly) {
        app.util.replaceTextElement(element,string,replacementString);
      }
      return string;
    },

    skuToNumeric: function(sku) {
      let result = '';

      if (typeof sku === 'undefined') {
        return "";
      }
      for (let i = 0; i < sku.length; i++) {
        const char = sku[i];

        if (/[0-9]/.test(char)) {
          result += char;
        } else if (/[a-zA-Z]/.test(char)) {
          const code = char.toUpperCase().charCodeAt(0) - 'A'.charCodeAt(0);
          const numStr = code.toString().padStart(2, '0');
          result += numStr;
        } else {
          // Non-alphanumeric character fallback
          result += '00';
        }
      }

      // Trim or pad to match original SKU length
      if (result.length > sku.length) {
        result = result.substring(0, sku.length);
      } else if (result.length < sku.length) {
        result = result.padEnd(sku.length, '0');
      }

      return result;
    }

	};
}(window.app = window.app || {}, jQuery));
/*!
 * app.ui.nav.js
 */
(function(app, $) {

  var $cache = {};

  function initializeCache() {
    $cache = {
      header: $('header.r-header'),
      isOpen: false,
      isInit: false,
      mobileCountryMenu: $('.mobile_country_selection ul'),
      mobileChangeCountry: $('#changeCountry')
    };
  }

  function initializeDom() {
    // Swap country selections with active selection
    $cache.mobileCountryMenu.hide();

    app.nav.changeCountry(app.getCountry());

    if (app.isiPadAndSmaller()) {

      app.ui.primaryMenu.find('.r-menu.primary>li>a').each(function() {
        if($(this).parent().find('ul').length) {
          $(this).addClass('icon-plus');
        }
      });

      app.ui.primaryMenu.find('.r-menu-1>li>a').each(function() {
        if($(this).parent().find('ul').length) {
          $(this).addClass('icon-plus');
        }
      });
    }
  }

  function hideSecondaryMenu() {
    app.ui.secondaryMenu.find('>ul>li').removeClass('activated');
    app.ui.headerNav.find('ul.fadeout').removeClass('fadeout');
    app.ui.headerNav.find('.r-menu-info.open,#r-menu-cart').removeClass('open');
    app.ui.header.removeClass('cart-open');
    $('div.blackout').remove();
  }

  function initializeEvents() {
    // Mobile
    $cache.mobileChangeCountry.on('click',function(e) {
      e.preventDefault();
      $cache.mobileChangeCountry.removeClass('active');
      $cache.mobileCountryMenu.show();
    });

    $cache.mobileCountryMenu.find('a').on('click',function(e) {
      e.preventDefault();
      if (!$(this).hasClass('active')) {
        var locale = app.util.getQueryStringParams($(this).attr('href')).locale;
        // trigger country change
        app.nav.changeCountry((locale === 'en_CA' || locale === 'fr_CA') ? 'CA' : (locale === 'en_AU' ? 'AU' : (locale === 'ko_KR' ? 'KR' : (locale === 'en_UK' ? 'UK' : (locale === 'ch_HK' ? 'HK' : 'US')))),true);
      }
      $cache.mobileCountryMenu.hide();
      $cache.mobileChangeCountry.addClass('active');
    });

    app.ui.menuTriggers.on('click',function(e) {
      e.preventDefault();
      if ($(this).hasClass('menu-primary')) {
        //app.nav.closeCart();
        hideSecondaryMenu();
        app.nav.togglePrimaryMobile();
      }
      if ($(this).hasClass('menu-mobile-cart')) {
        app.nav.closePrimaryMobile();
        if (app.isiPadAndSmaller() && !$(this).parent().hasClass('activated')) {
          // Open
          app.nav.lock();
        } else {
          // Close
        }
      }
    });


    // Main menu hover (Desktop)
    app.ui.primaryMenu.find('ul.primary > li > a').on('click touchstart',function(e){
      let $parent = $(this).parent();
      if (!app.isiPadAndSmaller() && $(this).siblings('.r-menu-html').find('.r-menu-1').length > 0) {
        e.preventDefault();
        app.nav.togglePrimary($parent);
      } else {
        // app.nav.togglePrimaryMobile();
      }
    });

    app.ui.primaryMenu.find('.r-menu.primary>li>a').on('click',function(e) {
      if (app.isiPadAndSmaller() && $(this).parent().find('li').length > 0) {
        e.preventDefault();
        let $parent = $(this).parent();
        let hasClass = $parent.hasClass('primary-selected');

        app.ui.primaryMenu.find('.primary-selected').removeClass('primary-selected');

        app.ui.primaryMenu.find('.icon-negative').removeClass('icon-negative').addClass('icon-plus');
        if (!hasClass) {
          app.ui.primaryMenu.addClass('expando');
          $parent.addClass('primary-selected');
          $(this).addClass('icon-negative');
        } else {
          app.ui.primaryMenu.removeClass('expando');
        }
      }
    });

    app.ui.primaryMenu.find('.r-menu-1>li>a').on('click',function(e) {
      if (app.isiPadAndSmaller() && $(this).parent().find('li').length > 0) {
        e.preventDefault();
        let $parent = $(this).parent();
        let hasClass = $parent.hasClass('selected');

        app.ui.primaryMenu.find('.selected').removeClass('selected');
        app.ui.primaryMenu.find('.r-menu-1 .icon-negative').removeClass('icon-negative').addClass('icon-plus');
        if (!hasClass) {
          app.ui.primaryMenu.addClass('expando');
          $parent.addClass('selected');
          $(this).addClass('icon-negative');
        } else {
          app.ui.primaryMenu.removeClass('expando');
        }
      }
    });

    /* Hovering over hidden menu content (desktop) */
    //var menuHoverIntent, menuHoverIntentOut;
    app.ui.secondaryMenu.find('>ul>li>span, >ul>li.menu-cart>button').on('click',function(e) {
      let $el = $(this).parent('li');
      let isMenu = $el.hasClass('menu-cart');
      let $menu = isMenu ? $('#r-menu-cart') : $el.find('.r-menu-info');

      if ($menu.length && !$el.hasClass('activated')) {
        // allow for menu change
        hideSecondaryMenu();

        // activate new hover
        app.ui.header.toggleClass('cart-open');
        $menu.toggleClass('open');
        $el.parents('ul').addClass('fadeout');
        $el.addClass('activated').addClass('lockmenu');
        app.ui.header.after(app.ui.blackout);
        $('.blackout').on('click',function() {});
        setTimeout(function () {
          $el.removeClass('lockmenu');
        }, 500);
      }
      else if ($el.hasClass('activated')) {
        if (isMenu) {
          app.nav.unlock();
        }
        hideSecondaryMenu();
      }
    });

    // Hide menu if click anywhere else
    $(document).on('click',function(event) {
      let $target = $(event.target);
      if (!app.isiPadAndSmaller()) {
        // Primary menu
        if ($target.hasClass('r-menu-html') || !$target.parent().hasClass('focused')) {
          app.ui.primaryMenu.find('ul.primary > li').removeClass('focused');
        }

        // Secondary menu
        if(app.ui.secondaryMenu.find('>ul>li.activated').length) {
          if(!$target.closest('.r-menu.secondary').length && !app.ui.secondaryMenu.find('>ul>li.activated').hasClass('lockmenu')) {
            hideSecondaryMenu();
          }
        }
      } else {
        // Close whatever is open if blackout is clicked.
        if ($target.hasClass('blackout')) {
          app.nav.closePrimaryMobile();
          app.nav.closeCart();
          app.nav.unlock();
        }
      }
    });

    $(".cart-close").on('click',function(event) {
      app.nav.closePrimaryMobile();
      app.nav.closeCart();
      app.nav.unlock();
    })

    $("#option-reset-form .form-submit").on('click',function(event) {
      event.preventDefault();
      $('.reset-msg').remove();
      if (!$(this).data('original')) {
        $(this).data('original',$(this).text());
      }
      $(this).text('Please wait');
      if (app.klaviyo.isValidEmail($('#user-pass-form .form-text').val())) {
        $('#user-pass-form').submit();
      } else {
        $(this).text($(this).data('original'));
        $(this).after($('<div>',{class: 'reset-msg'}).html('<small style="font-size:80%;padding:5px;background:#e9caca;display:block;text-align:center;">Enter a valid e-mail address</small>'));
      }
      return false;
    })

    // link local
    $('[data-linklocal]').on('click',function(e) {
      e.preventDefault();
      $($(this).data('linklocal')).addClass('open');
      $($(this).data('parent')).removeClass('open');
    });

    // close trigger
    $('.close_trigger').on('click',function(e) {
      e.preventDefault();
      $($(this).data('target')).removeClass('open');
      $($(this).data('parent')).addClass('open');
    });

  };

  app.nav = {
    init: function() {
      //double init on checkout hack
      if (typeof $cache.isInit === 'undefined' || !$cache.isInit) {

        initializeCache();
        initializeDom();
        initializeEvents();

        // Make nav sticky
        app.nav.sticky();
        app.nav.addAriaLabel();
        app.nav.openLookBookNewTab();
      }

    },
    changeCountry: function(country,redirect) {
      let is_fr = app.util.getQueryStringParams(window.location.href).locale === 'fr_CA' ? true : false;
      let locale = (country === 'CA' && is_fr) ? 'fr_CA' : ((country === 'CA' && !is_fr) ? 'en_CA':  (country === 'AU' ? 'en_AU' : (country === 'KR' ? 'ko_KR' : (country === 'UK' ? 'en_UK' : (country === 'HK' ? 'ch_HK' : 'en_US')))));
      let locale_from_module  = (country === 'CA' && is_fr) ? 'fr_CA' : ((country === 'CA' && !is_fr) ? 'en':  (country === 'AU' || country === 'UK' ? 'en' : (country === 'KR' ? 'ko_KR' : (country === 'HK' ? 'ch_HK' : 'en'))));
      let href = '';
      if(jQuery('.language-change ul li:not(.active) a[href*="locale=' + locale_from_module +'"]').length > 0) {
        href = jQuery('.language-change ul li:not(.active) a[href*="locale=' + locale_from_module +'"]').attr('href');
        href = href.substring(0, href.indexOf('?locale'));
      } else {
        href =$cache.mobileChangeCountry.attr('href');
      }

      let url = app.util.getUri(app.util.appendParamsToUrl(href,{locale:locale})).urlWithQuery;

      const now = Math.floor(Date.now() / 1000);
      if (country === 'CA' && now > 1768896000){
        url = 'https://ca.roveconcepts.com';
      }

      $cache.mobileChangeCountry.attr('href',url);
      $cache.mobileChangeCountry.attr('class','');
      $cache.mobileChangeCountry.text(country);
      $cache.mobileChangeCountry.addClass('active').addClass('sw_'+country.toLowerCase());
      $cache.mobileCountryMenu.find('a.sw_'+country.toLowerCase()).addClass('active');

      // console.log(country);
      $.cookie('uc_warehouse_location', country, {
        expires: 14,
        path: '/',
        domain: '.'+app.util.getUri(window.location.href).host.replace('www','')
      });


      if (redirect) {
        // Fire event
        $(document).trigger('changeCountry',[country]);

        window.location = url;
      }

    },
    openCart: function() {

    },
    closeCart: function() {
      let $el = $('#r-menu-cart');
      $el.removeClass('open');
      app.ui.secondaryMenu.find('.fadeout').removeClass('fadeout');
      app.ui.secondaryMenu.find('.activated').removeClass('activated');
      app.ui.header.removeClass('cart-open');
      $('div.blackout').remove();
    },
    toggleCart: function() {
      let $el = $('#r-menu-cart');
      if ($el.hasClass('open')) {
        //app.nav.unlock();
      } else {
        //app.nav.lock();
      }
      app.ui.header.toggleClass('cart-open');
      $el.toggleClass('open');
    },
    openPrimaryMobile: function() {
      app.ui.header.addClass('opening');
      app.ui.primaryMenu.one('transitionend webkitTransitionEnd oTransitionEnd', function () {
        app.ui.header.removeClass('opening');
      });
      app.nav.lock();
      app.ui.header.addClass('open').removeClass('show');
    },
    closePrimaryMobile: function() {
      if (app.ui.header.hasClass('open')) {
        app.ui.header.addClass('closing');
        app.ui.primaryMenu.one('transitionend webkitTransitionEnd oTransitionEnd', function () {
          app.ui.header.removeClass('closing');
        });
        app.nav.unlock();
        app.ui.header.removeClass('open');
      }
    },
    togglePrimaryMobile: function() {
      if (app.isiPadAndSmaller()) {
        app.ui.header.removeClass('search'); // Always remove this
        if (app.ui.header.hasClass('open')) {
          app.nav.closePrimaryMobile();
        } else {
          app.nav.openPrimaryMobile();
        }
      }
    },
    togglePrimary: function($clicked_parent) {
      app.ui.primaryMenu.find('.focused').not($clicked_parent).removeClass('focused');
      if ($clicked_parent) {
        $clicked_parent.toggleClass('focused');}
      app.ui.headerNav.scrollTop = 0;
    },
    closePrimary: function() {
      app.ui.primaryMenu.find('.focused').removeClass('focused');
    },
    openPrimary: function() {
      app.ui.primaryMenu.find('li>a:visible').first().trigger('click');
    },
    lock: function() {
      let $meta = $('meta[name=viewport]');
      $('html').addClass('overflow-hidden').toggleClass('overflow-hidden-long',document.body.scrollHeight > document.documentElement.clientWidth);
      $meta.attr('content', $meta.attr('content')+', maximum-scale=1, user-scalable=0');
    },
    unlock: function() {
      let $meta = $('meta[name=viewport]');
      $('html').removeClass('overflow-hidden').removeClass('overflow-hidden-long');
      $meta.attr('content', $meta.attr('content').replace(', maximum-scale=1, user-scalable=0',''));
    },
    sticky: function() {
      // only load sticky nav on desktop (not checkout)
      if ($('.pt_minheader').length === 0) {
        var stickyNavTop = app.isGreaterThaniPad() ? 0 : app.ui.header.offset().top;

        var stickyNav = function() {
          var scrollTop = $(window).scrollTop();
          var shouldBeSticky = scrollTop > stickyNavTop;
          app.ui.header.toggleClass('sticky', shouldBeSticky);
        };

        // Initial execution
        stickyNav();

        // Optimized event listeners
        $(window).on('scroll resize', function(e) {
          if (e.type === 'resize') {
            app.ui.header.removeClass('sticky');
          }
          stickyNav();
        });
      }

    },

    unStickRefinementBar: function() {
      $cache.sidebar = $cache.primary = $cache.sidebarContainer = false;
    },

    addAriaLabel: function(){
      $(".r-menu.primary>li, .r-menu.secondary>li").each(function(ind, val){
        if (val.children.length > 1){
          val.setAttribute("aria-expanded", "false");
        }
      });

      let menuObserver = new MutationObserver(function(mutations) {
          $("#r-nav-container li[aria-expanded]").each(function(ind, val) {
            if (val.classList.contains('focused') || val.classList.contains('activated')) {
              val.setAttribute("aria-expanded", "true");
            } else {
              val.setAttribute("aria-expanded", "false");
            }
          });
      });

      let target = document.querySelector("#r-nav-container");

      menuObserver.observe(target, {
        childList: true,
        subtree: true,
        attributes : true,
        attributeFilter : ['class']
      });

    },

    stickRefinementBar: function() {
      if (app.isGreaterThaniPad()) {
        var lastScrollTop = 0;
        var direction = '';
        var $window = $(window);
        $window.on("scroll", function() {
          var scrollTop = $window.scrollTop();
          // scrolling down
          if (scrollTop > lastScrollTop) {
            direction = 'down';
          }// scrolling up
          else {
            direction = 'up';
          }
          app.nav.resetRefinementBar(lastScrollTop, direction);
          lastScrollTop = scrollTop;
        });

        var windowWidth = $window.width();

        $window.on("resize", function() {

          if ($window.width() != windowWidth) {
            // weird iOS resize bug

            // Update the window width for next time
            windowWidth = $window.width();

            if ($cache.primary && $cache.sidebarContainer) {
              app.components.restick($cache.primary, $cache.sidebarContainer);
            }
          }
        });
      }
    },

    resetRefinementBar: function(lastScrollTop, direction) {
      $cache.sidebar = (!$cache.sidebar) ? $('#uc-display-term-form>div') : $cache.sidebar;

      if ($cache.sidebar.length > 0) {
        $cache.primary = (!$cache.primary) ? $('#rove_products') : $cache.primary;
        $cache.searchHeader = $('.rove-filtering-top');
        // can't cache as it changes height dynamically

        // if we do not have a primary, use main
        if ($cache.primary.length === 0) {
          $cache.primary = app.ui.main;
        }

        if ($cache.searchHeader.length > 0) {
          $cache.sidebarOffset = $cache.searchHeader.height() + 50;
        } else {
          $cache.sidebarOffset = (!$cache.sidebarOffset) ? false : $cache.sidebarOffset;
        }

        $cache.sidebarContainer = (!$cache.sidebarContainer) ? $('.rove-filtering-top>.limit>.row') : $cache.sidebarContainer;
        app.components.stick($cache.primary, $cache.sidebarContainer, $cache.sidebarOffset, lastScrollTop, direction);
      }
    },

    openLookBookNewTab: function (){
      $('li.menu-lookbook a').attr('target', '_blank');
    }
  };
}(window.app = window.app || {}, jQuery));
/*!
 * app.ui.progress.js
 */
(function(app, $) {
	var loader;
	app.progress = {
		show: function(container) {
			var target = (!container || $(container).length === 0) ? $("body") : $(container);
			loader = loader || $(".loader");

			if (loader.length === 0) {
				loader = $("<div/>").addClass("loader").append($("<div/>").addClass("loader-indicator"), $("<div/>").addClass("loader-bg"));

				if ($('html').hasClass('cssanimations') && $('html').hasClass('svg')) {

					var svg = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
					svg.setAttribute("class", "ar-spinner");
					svg.setAttribute("width", "64px");
					svg.setAttribute("height", "64px");
					svg.setAttribute("viewBox", "0 0 66 66");

					var circle = document.createElementNS('http://www.w3.org/2000/svg', 'circle');
					circle.setAttribute("class", "ar-path");
					circle.setAttribute("fill", "none");
					circle.setAttribute("stroke-width", "2");
					circle.setAttribute("stroke-linecap", "round");
					circle.setAttribute("cx", "33");
					circle.setAttribute("cy", "33");
					circle.setAttribute("r", "30");

					svg.appendChild(circle);

					var $indicator = loader.find(".loader-indicator");
					$indicator.css("background-image", "none");
					$indicator[0].appendChild(svg);

				}

			}

			loader.height($(document).height());
			loader.find(".loader-indicator").css("top", ($(window).scrollTop() + $(window).height()) / 2 - 32);
			// 32 for half the height of spinner

			return loader.appendTo(target).show();
		},
		hide: function() {
			if (loader) {
				loader.hide();
			}
		}
	};
}(window.app = window.app || {}, jQuery));/*!
 * app.searchbar.js
 */
(function (app, $) {
  let $cache = {
    searchMobileToolbar: true,   // true = show search icon in toolbar | false =
    // show search in menu
    searchMobileFixed: false     // true = search is fixed to the top of the site
  };

  function initializeCache() {
    let uri = window.location.pathname;
    let is_ar = (uri.indexOf('/ar/') >= 0 || uri == '/ar') ? 1 : 0; //check if it's AR page
    $cache = {
      searchMobileToolbar: typeof $cache.searchMobileToolbar !== 'undefined' ? $cache.searchMobileToolbar : false,
      searchMobileFixed: (is_ar !== 1)?Drupal.settings.search.mobile_fixed:false,
      initTime: Date.now(),
      query: '',
      delay: 400,
      maxSearchHistory: 100,
      queryTimeout: null,
      lastRequestQuery: null,
      latestRequestId: 0,
      searchReset: $('.r-search-reset'),
      searchButton: $('.r-search-submit'),
      searchClose: $('.r-search-close'),
      quickLinks: $('#search_suggestions'),
      type: {
        STL: 'In Shop the Look (:results)',
        pages: 'In Pages (:results)',
        reviews: 'In Reviews (:results)',
        customer_photos: 'In Customer Photos (:results)',
        products: 'In Products (:results)'
      }
    };
  }

  function initializeDom() {
    // disable browser auto complete
    app.ui.searchInput.attr("autocomplete", "off");
  }

  function initializeEvents() {
    $("#view_more_results").on('click', function (e) {
      e.preventDefault();
      $cache.query = app.ui.searchInput.val();
      location.href = "/search/products/" + q + "/";
    });

    // initialize search events
    app.ui.searchContainer.on("click", function (e) {
      // Prevent clicking within the search box bubbling up to the html level
      // and closing itself
      let checkLink = $(e.target).parents('a[data-pnid]');
      if (checkLink.length) {
        let $ele = checkLink[0];
        app.tracking.clickProduct(Drupal.settings.track.pageItems[$($ele).data('pnid')], $($ele));
      }
      e.stopPropagation();
    });

    // hide/show search box
    app.ui.searchToggle.on('click', function (e) {
      e.preventDefault();
      var $this = $(this);
      if (!app.isMobile() && !app.isiPad()) {
        if (!app.ui.searchContainer.is(':visible')) {
          app.searchbar.showSearch($this, e);
        }
        else {
          app.searchbar.hideSearch($this, e);
        }
      }
      else if ($cache.searchMobileToolbar) {
        app.ui.header.addClass('show');
        app.ui.searchInput.trigger('focus')
      }
      return false;
    });

    app.ui.searchInput.on('keydown', function (e) {
      let keyCode = e.keyCode || e.which || window.event.keyCode;

      // up arrow key down press
      if (keyCode === 38) {
        e.preventDefault();
        // disable default behaviour on up arrow key press (sets cursor to
        // begining of input)
      }
    });

    app.ui.searchInput.on('keyup', function (e) {
      // Note: There is some logic in app.ui.nav.js
      let keyCode = e.keyCode || e.which || window.event.keyCode;
      app.ui.searchAutocomplete.show();
      $cache.query = $(this).val();

      // check and treat up and down arrow keys
      if (keyCode === 38 || keyCode === 40) {
        if ($cache.handleUpDownKeys) {
          let activeclass = 'active';
          let $results = app.ui.searchResults.find('.hit');
          let $active = app.ui.searchResults.find('div.hit.' + activeclass);
          let next;
          if ($active.length === 0) {
            next = 0;
          }
          else {
            $results.removeClass(activeclass);
            let idx = $active.index();

            // down
            if (keyCode === 40) {
              next = (idx < $results.length - 1) ? idx + 1 : 0;
            }// up
            else if (keyCode === 38) {
              next = (idx > 0) ? idx - 1 : $results.length - 1;
            }

          }

          $active = $results.eq(next);
          $active.addClass(activeclass);

          if ($active.find('.clearsearch').length < 1) {
            app.ui.searchInput.val($active.find('.hit-name').text());
          }
          else {
            app.ui.searchInput.val('');
          }
        }
        return;
      }

      /* If enter key is pressed */
      if (keyCode === 13) {
        if (app.ui.searchResults.find('.clearsearch').length > 0) {
          app.searchbar.clearSearchHistory();
          app.searchbar.search($cache.query);
          return false;
        }

        app.searchbar.clearResults();
        app.searchbar.hideSearch(app.ui.searchToggle, e);

        return app.searchbar.searchResultGo($cache.query);
      }
      else {
        /* Any key except Enter was pressed */
        app.searchbar.search($cache.query);
      }

      // esc key press
      if (keyCode === 27) {
        if (app.ui.searchResults.is(':empty')) {
          app.searchbar.hideSearch(app.ui.searchToggle, e);
        }
        else {
          app.searchbar.clearResults();
        }
        // Exit
      }

      if (app.ui.searchInput.val() === '') {
        app.searchbar.hideHits();
      }
      else {
        app.searchbar.textInput();
      }
    });

    // retrigger focus on click
    app.ui.searchInput.on('click', function () {
      if (!app.isMobile() && !app.isiPad()) {
        app.ui.searchInput.trigger('focus');
      }
    });

    // Reset search input
    $cache.searchReset.on('click', function () {
      app.searchbar.resetInput();
      app.ui.searchInput.trigger('focus');
    });

    // Close button on search was clicked
    $cache.searchClose.on('click', function () {
      app.searchbar.resetInput();
      app.ui.header.removeClass('search').addClass('searchhide');
      $('.r-search-field').one('transitionend webkitTransitionEnd oTransitionEnd', function () {
        app.ui.header.removeClass('searchhide');
      });

      if ($cache.searchMobileToolbar) {
        app.ui.header.removeClass('show');
      }
    });

    // Search icon clicked (refresh results)
    $cache.searchButton.on('click', function () {
      app.searchbar.searchResultGo($cache.query);
    });

    // on focus listener (clear default value)
    app.ui.searchInput.on('focus', function () {
      if (app.isMobile() || app.isiPad()) {
        if (!$cache.searchMobileToolbar) {
          // show classes while css transitions run
          app.ui.header.addClass('searchshow');
          app.ui.searchContainer.one('transitionend webkitTransitionEnd oTransitionEnd', function () {
            app.ui.header.removeClass('searchshow');
            app.ui.header.addClass('search');
          });
        }
        else {
          app.ui.header.addClass('search');
        }

        if (!$cache.searchMobileFixed) {
          app.ui.searchAutocomplete.show();
          if (!app.ui.searchResults.find('>div').length) {
            app.searchbar.quickShow();
          }
          else {
            app.searchbar.quickHide();
          }
        }
      }

      // disable tabing in iOS
      if (app.isMobile() && app.isIOS) {
        $('input:enabled, select:enabled, textarea:enabled').not(app.ui.searchInput).prop('disabled', true).addClass('iOS-disabled');
      }

      let postAutoFocus = $cache.initTime + 1000 < Date.now();
      if (postAutoFocus) {
        app.searchbar.search($cache.query);
      }
    });

    // on blur listener
    app.ui.searchInput.on('blur', function () {
      $cache.lastRequestQuery = null;

      /*
      if (!app.isMobile()) {
        // Desktop only?
        setTimeout(function () {
          app.searchbar.clearResults();
        }, 200);
      }
      */

      // enable tabing in iOS
      if (app.isMobile() && app.isIOS) {
        $('input.iOS-disabled, select.iOS-disabled, textarea.iOS-disabled').removeAttr('disabled').removeClass('iOS-disabled');
      }
    });

    // Linked click in navigation (mobile) - but not autoComplete link
    app.ui.header.on('click', 'a', function (e) {
      let $this = $(this);
      if (app.isMobile() || app.isiPad()) {
        if (app.ui.header.hasClass('search')
          && !$this.parents(app.ui.searchAutocomplete.selector).length
          && !$this.parents('.r-brand').length) {
          e.stopPropagation();
          app.searchbar.resetInput();
        }
        if (!$this.parents('.mobile_country_selection').length) {
          app.nav.togglePrimary();
        }
      }

      // Are we changing country
      if ($this.parents('.menu-ship-to').length) {
        e.preventDefault();
        let locale = app.util.getQueryStringParams($this.attr('href')).locale;
        if (typeof locale !== 'undefined') {
          app.nav.changeCountry((locale === 'en_CA' || locale === 'fr_CA') ? 'CA' : (locale === 'en_AU' ? 'AU' : (locale === 'ko_KR' ? 'KR' : (locale === 'en_UK' ? 'UK': (locale === 'ch_HK' ? 'HK' : 'US')))), true);
        }
      }
    });

    app.ui.searchAutocomplete.on('click', function (e) {
      app.ui.searchResults.each(function () {
        if (!$(this).is(e.target) && $(this).has(e.target).length === 0 && $(e.target).is('a')) {
          e.stopPropagation();
          if (app.isMobile() || app.isiPad()) {
            app.searchbar.resetInput();
            app.nav.togglePrimary();
          }
          else {
            app.ui.searchContainer.slideUp(400);
            app.ui.searchAutocomplete.hide();
            app.ui.searchInput.val('');
          }
          app.search_activated = 0;
        }
      });
    });
  }

  app.searchbar = {
    client: algoliasearch('6COW5PRN5I', 'bc1bbe633e133311653923461e0d151c'),
    categoryResults: 5,
    productResults: 5,
    pageResults: 3,
    customerPhotoResults: 0,
    reviewResults: 0,
    stlResults: 2,
    handleUpDownKeys: false,
    searchPath: '/search/products/',
    //country: Drupal.settings.uc_warehouse_location.initialLocale,
    country: null,

    // configuration parameters and required object instances
    init: function () {
      app.searchbar.country = app.getCountry();

      initializeCache();
      initializeDom();
      initializeEvents();
    },

    // Get phrase and redirect to search page
    searchResultGo: function (result) {
      if (result.length === 0) {
        return false;
      }

      let url = app.searchbar.searchPath + encodeURI(result);
      app.searchbar.updateSearchHistory(result, url);
      window.location = url;
    },

    // Append search result
    searchResultAdd: function (result) {
      if ((app.isMobile() || app.isiPad()) && !app.ui.searchResults.html().length) {
        if ($cache.searchMobileFixed) {}
        app.ui.searchResults.append($('<label/>').text($cache.searchMobileFixed?'Suggestions':'Search Result(s)'));
      }
      app.ui.searchResults.append(result);
    },

    // Clear the search results div
    clearResults: function () {
      app.ui.searchResults.empty();
    },

    // Text entered, show reset icon
    textInput: function () {
      app.ui.searchContainer.addClass('with-reset');
      if ($cache.searchMobileFixed) {
        app.ui.header.addClass('show');
      }
    },

    // Hide quicklinks in search
    quickHide: function () {
      app.ui.header.addClass('no-quicklinks');
    },
    // Show quicklinks in search
    quickShow: function () {
      app.ui.header.removeClass('no-quicklinks');
    },

    // Input emptied
    resetInput: function () {
      if ($cache.searchMobileFixed) {
        app.ui.header.removeClass('show');
      }
      app.searchbar.clearResults();
      app.ui.searchInput.val('');
      $cache.query = '';
      app.ui.searchContainer.removeClass('with-reset');
      if (app.isMobile() || app.isiPad()) {
        app.searchbar.quickShow();
      }
      else {
        app.ui.searchAutocomplete.hide();
        app.searchbar.hideSearch();
      }
    },

    // Mobile search callback for generating content
    searchAutocompleteMobileCallback: function (err, content) {
      if (err) {
        console.log(err);
      }

      // Clear the contents before appending new results
      app.searchbar.clearResults();

      let products = content.results[0];
      let categories = content.results[1];
      let $result = $('<div/>', {id: 'search-results'});

      // Show/Hide quick results (fixed)
      if (products.hits.length === 0 && (!$cache.searchMobileFixed || categories.hits.length === 0)) {
        app.searchbar.quickShow();
      } else if (!$cache.searchMobileFixed) {
        app.searchbar.quickHide();
      }

      /* ============ PRODUCTS - Start ============ */

      if (products.hits.length > 0) {
        let $product_result = $('<ul/>', {class: 'mobile_product_hits'});
        $product_result.append($('<label/>').text(products.nbHits + ' Products - ')
          .append($('<a/>', {href: '/search/products/' + encodeURI($cache.query)}).text('View All')));
        for (let i = 0; i < products.hits.length; ++i) {
          if (!$cache.searchMobileFixed) {
            app.searchbar.searchResultAdd(app.searchbar.templateHitPage(products, i, true));
          } else {
            $product_result.append(app.searchbar.templateHitPage(products, i, true));
          }
        }
        $result.append($product_result);
      }
      /* ============ PRODUCTS - End ============ */

      // Track search event
      //app.tracking.search(app.ui.searchInput.val().trim(), productHits);
      if (typeof app.tracking !== 'undefined') {
        app.tracking.track('search', {term: app.ui.searchInput.val().trim()});
        app.tracking.track('searchViewResults', {term: app.ui.searchInput.val().trim(), items: products});
      }

      /* ============ CATEGORIES - Start ============ */
      let category_cnt = 0;
      if (categories.hits.length > 0 && $cache.searchMobileFixed) {
        let $category_result = $('<ul/>', {class: 'mobile_categories_hits'});
        for (let i = 0; i < categories.hits.length; ++i) {
          if (category_cnt >= app.searchbar.categoryResults) {
            break;
          }
          category_cnt++;
          $category_result.append(app.searchbar.templateHitCategory(categories, i));
        }
        $result.prepend($category_result);
      }
      /* ============ CATEGORIES - End ============ */

      // Do results
      if ($cache.searchMobileFixed) {
        // Default messages
        let $default_result = $('<div/>', {id: 'no-results-message'});
        if (products.hits.length === 0 && categories.hits.length === 0) {
          $default_result.append($('<p/>', {class: 'oh_no'}).text("Oh no, sorry we couldn't find that"));
        }
        $result.append($default_result);

        app.searchbar.clearResults();
        app.searchbar.searchResultAdd($result.html());
      } else if (products.hits.length !== 0) {
        // Add All Results links
        app.searchbar.searchResultAdd($('<div/>', {class: 'hit all-results'})
          .append($('<a/>', {href: '/search/products/' + encodeURI($cache.query)})
            .append($('<div/>', {class: 'hit-content'})
              .append($('<h2/>', {class: 'hit-name'}).text('All Results')))));
      }
    },

    // Desktop search callback for generating content
    searchAutocompleteCallback: function (err, content) {
      if (err) {
        console.log(err);
      }

      let i;
      let $h3;
      let $ul;
      let $result = $('<div/>', {id: 'search-results'});

      /* ============ PRODUCTS - Start ============ */
      let products = content.results[0];
      let products_exist = false;
      if (products.hits.length > 0) {


        $(".search-off-left").text(products.hits.length + " matched product(s) found");
        let $product_result = $('<div/>', {class: 'product_hits'});
        $h3 = $('<h2/>').text('Products');
        $ul = $('<ul/>');
        $product_result.append($h3);
        for (i = 0; i < products.hits.length; ++i) {
          products_exist = true;
          $ul.append(app.searchbar.templateHitPage(products, i, true));
        }
        $product_result.append($ul);
        let $more = $('<a/>', {
          id: 'view_more_results',
          href: '/search/',
          class: 'view_more_results'
        }).text('VIEW MORE RESULTS');
        let $span = $('<span/>', {class: 'icon-plus'});
        $more.append($span);
        $product_result.append($more);

        $result.append($product_result);
      } else {
        $(".search-off-left").text("0 matched product found")
        app.searchbar.search("sideboard");
      }
      /* ============ PRODUCTS - End ============ */

      // Track search event
      //app.tracking.search(app.ui.searchInput.val().trim(), productHits);
      if (typeof app.tracking !== 'undefined') {
        app.tracking.track('search', {term: app.ui.searchInput.val().trim()});
        app.tracking.track('searchViewResults', {term: app.ui.searchInput.val().trim(), items: products});
      }

      /* ============ STL PAGES - Start =========== */
      let static_pages = content.results[1];
      let stl_pages_exist = false;
      let stl_pages = content.results[6];
      let country = app.searchbar.country;
      let cur_language = (country == 'KR')?'ko_KR':(country == 'HK'?'ch_HK':'en');
      // Always show this so it looks consistent
      // Only if there are others
      if ((static_pages.hits.length > 0 && products.hits.length > 0) || stl_pages.hits.length > 0) {
        let $stl_pages_result = $('<div/>', {class: 'pages_hits'});
        $h3 = $('<h2/>').text('Shop the Look');
        $ul = $('<ul/>');
        $stl_pages_result.append($h3);
        if (stl_pages.hits.length > 0) {
          for (i = 0; i < stl_pages.hits.length; ++i) {
            let show_in_result = 0;
            if(typeof stl_pages.hits[i].language === 'undefined') {
              show_in_result = 1;
            } else if(typeof stl_pages.hits[i].language !== 'undefined' && (stl_pages.hits[i].language == 'und' || stl_pages.hits[i].language == 'en' || stl_pages.hits[i].language == cur_language)) {
              show_in_result = 1;
            }

            stl_pages_exist = true;
            if(show_in_result == 1) {
              $ul.append(app.searchbar.templateHitPage(stl_pages, i, true));
              $stl_pages_result.append($ul);
            }
          }
        } else {
          $stl_pages_result.append('<p>(0) Shop the Look results.</p>');
        }
        $result.append($stl_pages_result);
      }
      /* ============ STL PAGES - End ============= */

      /* ============ STATIC PAGES - Start ============ */
      let static_pages_exist = false;

      if (static_pages.hits.length > 0) {
        let $static_pages_result = $('');
        if (!stl_pages_exist) {
          $static_pages_result = $('<div/>', {class: 'page_hits'});
        }
        $h3 = $('<h2/>').text('');
        $ul = $('<ul/>');
        $static_pages_result.append($h3);
        for (i = 0; i < static_pages.hits.length; ++i) {
          static_pages_exist = true;
          let show_in_result = 0;
          if(typeof static_pages.hits[i].language === 'undefined') {
            show_in_result = 1;
          } else if(typeof static_pages.hits[i].language !== 'undefined' && (static_pages.hits[i].language == 'und' || static_pages.hits[i].language == 'en' || static_pages.hits[i].language == cur_language)) {
            show_in_result = 1;
          }
          if(show_in_result == 1) {
            $ul.append(app.searchbar.templateHitPage(static_pages, i, true));
            $static_pages_result.append($ul);
          }
        }
        $result.append($static_pages_result);
      }
      /* ============ STATIC PAGES - End ============ */

      /* ============ CATEGORIES - Start ============ */
      // rooms also here
      let $other_result = $('<div/>', {class: 'other_hits'});

      let rooms = content.results[5];
      let categories = content.results[2];
      let category_cnt = 0;
      if (rooms.hits.length > 0 || categories.hits.length > 0) {
        let $category_result = $('<div/>', {class: 'categories_hits'});
        $h3 = $('<h2/>').text('Categories');
        $ul = $('<ul/>');
        $category_result.append($h3);
        if (rooms.hits.length > 0) {
          for (i = 0; i < rooms.hits.length; ++i) {
            if (category_cnt === app.searchbar.categoryResults) {
              break;
            }
            category_cnt++;
            $ul.append(app.searchbar.templateHitCategory(rooms, i));
            $category_result.append($ul);
          }
        }
        if (categories.hits.length > 0) {
          for (i = 0; i < categories.hits.length; ++i) {
            if (category_cnt >= app.searchbar.categoryResults) {
              break;
            }
            category_cnt++;
           $ul.append(app.searchbar.templateHitCategory(categories, i));
            $category_result.append($ul);
          }
        }
        $other_result.append($category_result);
      }
      /* ============ CATEGORIES - End ============ */

      /* ============ ALL RESULTS LINKS - Start ============ */
      let customer_photos = content.results[3];
      let reviews = content.results[4];

      if (products_exist || customer_photos.nbHits > 0 || reviews.nbHits > 0 || static_pages_exist) {
        let $linkResults = $('<ul/>', {class: 'all_hits'});
        $h3 = $('<h2/>').text('View Results By');
        $ul = $('<li/>');
        $linkResults.append($h3);

        if (products_exist) {
          $ul = $('<li/>');
          $ul.append(app.searchbar.templateHitLink('products', products));
          $linkResults.append($ul);
        }

        if (customer_photos.nbHits > 0) {
          $ul = $('<li/>');
          $ul.append(app.searchbar.templateHitLink('customer_photos', customer_photos));
          $linkResults.append($ul);
        }

        if (reviews.nbHits > 0) {
          $ul = $('<li/>');
          $ul.append(app.searchbar.templateHitLink('reviews', reviews));
          $linkResults.append($ul);
        }

        if (static_pages_exist) {
          $ul = $('<li/>');
          $ul.append(app.searchbar.templateHitLink('pages', static_pages));
          $linkResults.append($ul);
        }

        if (stl_pages_exist) {
          $ul = $('<li/>');
          $ul.append(app.searchbar.templateHitLink('STL', stl_pages));
          $linkResults.append($ul);
        }

        $other_result.append($linkResults);
      }

      $result.append($other_result);
      /* ============ ALL RESULTS LINKS - Start ============ */

      let $default_result = $('<div/>', {id: 'no-results-message'});
      if (!products_exist && !static_pages_exist && !categories && !stl_pages_exist) {
        let $p = $('<p/>', {class: 'oh_no'}).text("Oh no, sorry we couldn't find that");
        $default_result.append($p);
      }
      $result.append($default_result);

      app.searchbar.clearResults();
      app.searchbar.searchResultAdd($result.html());
      //app.ui.searchResults.append($result);
    },

    // Template for products & pages
    templateHitPage: function (result, i, highlight) {
      // If this is a mobile result, let treat it as such.
      if (app.isMobile() || app.isiPad()) {
        return app.searchbar.templateHitPageMobile(result, i, highlight);
      }
      if(result.hits.length > 0) {
        let title = (typeof result.hits[i] !== 'undefined') ? ((highlight) ? result.hits[i]._highlightResult.title.value : result.hits[i].title) : '';
        let pageSrc = (typeof result.hits[i] !== 'undefined') ? (result.hits[i].image_category ? result.hits[i].image_category : (result.hits[i].image ? result.hits[i].image : '/sites/default/files/styles/algolia_search/public/placeholder.jpg')) : '';
        let $li = $('<li/>', {class: 'hit'});
        let list = typeof result.hits[i].nid !== 'undefined' ?
          {
            href: result.hits[i].url,
            title: result.hits[i].title,
            'data-pnid': result.hits[i].nid,
            'data-catpath':"/taxonomy/term/510",
            'data-sku': result.hits[i].objectID.substring(0,result.hits[i].objectID.indexOf('-')),
            'data-gsku': result.hits[i].google_tag_id,
            'data-fsku': result.hits[i].objectID,
            'data-category': "",
            'data-price': result.hits[i].prices.final[app.getCurrency().toLowerCase()].toString()
          } :
          {
            href: result.hits[i].url
          } ;
        let $a = $('<a/>', list);
        let $div2 = $('<div/>', {class: 'hit-image'});
        let $img = $('<img/>', {
          src: pageSrc,
          alt: '',
          class: 'img-responsive'
        });
        let $div3 = $('<div/>', {class: 'hit-content'});
        let $h2 = $('<p/>', {class: 'hit-name'}).html(title);
        $div3.append($h2);
        $div2.append($img);
        $a.append($div2).append($div3);

        // append also to page display items
        app.tracking.addProductFromPNID($a);
        app.tracking.setProductPageItems();

        $li.append($a);
        return $li;
      }

    },

    templateHitPageMobile: function (result, i, highlight) {
      if ($cache.searchMobileFixed) {
        return app.searchbar.templateHitPageMobileFixed(result, i, highlight);
      }
      let title = (typeof result.hits[i] !== 'undefined')?((highlight) ? result.hits[i]._highlightResult.title.value: result.hits[i].title):'';
      let $div = $('<div/>', {class: 'hit'});
      let list = typeof result.hits[i].nid !== 'undefined' ?
        {
          href: result.hits[i].url,
          title: result.hits[i].title,
          'data-pnid': result.hits[i].nid,
          'data-catpath':"/taxonomy/term/510",
          'data-sku': result.hits[i].objectID.substring(0,result.hits[i].objectID.indexOf('-')),
          'data-gsku': result.hits[i].google_tag_id,
          'data-fsku': result.hits[i].objectID,
          'data-category': "",
          'data-price': result.hits[i].prices.final[app.getCurrency().toLowerCase()].toString()
        } :
        {
          href: result.hits[i].url
        } ;
      let $a = $('<a/>', list);
      let $div2 = $('<div/>', {class: 'hit-content'});
      let $h2 = $('<h2/>', {class: 'hit-name'}).html(title);
      $div2.append($h2);
      $a.append($div2);
      $div.append($a);
      return $div;
    },

    templateHitPageMobileFixed: function(result, i, highlight) {
      let title = app.util.splitString((highlight && result.hits[i] !== 'undefined') ? result.hits[i]._highlightResult.title.value : result.hits[i].title,' - ');
      let pageSrc = (result.hits[i].image) ? result.hits[i].image : '/sites/default/files/styles/algolia_search/public/placeholder.jpg';
      let $div = $('<div/>', {class: 'hit'});
      let $a = $('<a/>', {href: result.hits[i].url});
      let $div2 = $('<div/>', {class: 'hit-image'});
      let $img = $('<img/>', {
        src: pageSrc.replace('algolia_search','picture_320_320_1x'),
        alt: title,
        class: 'img-responsive'
      });
      let $div3 = $('<div/>', {class: 'hit-content'});
      let $h2 = $('<h2/>', {class: 'hit-name'}).html(title.length > 1 ? (title.join('<small>') + '</small>') : title.join(''));
      //$div3.append($h2).append($('<div/>',{class:'product_price'}).append(price.$sale_strike));
      $div3.append($h2);
      $div2.append($img);
      $a.append($div2).append($div3);
      $div.append($a);
      return $div;
    },

    // Template for category results
    templateHitCategory: function (result, i) {
      if ((app.isMobile() || app.isiPad()) && $cache.searchMobileFixed) {
        return app.searchbar.templateHitCategoryMobile(result, i);
      }
      let $div = $('<li/>', {class: 'category'});
      let $a = $('<a/>', {href: result.hits[i].url});
      let $span = $('<span/>').html((result.hits[i] !== 'undefined')?result.hits[i]._highlightResult.title.value:result.hits[i].title);
      $a.append($span);
      $div.append($a);
      return $div;
    },

    templateHitCategoryMobile: function(result, i) {
      let $div = $('<div/>', {class: 'hit'});
      let $a = $('<a/>', {href: result.hits[i].url});
      let $span = $('<span/>').html((result.hits[i] !== 'undefined')?result.hits[i]._highlightResult.title.value:result.hits[i].title);
      $a.append($span);
      $div.append($a);
      return $div;
    },

    // Template for other results
    templateHitLink: function (type, result) {
      let $div = $('<div/>', {class: 'all'});
      let $a = $('<a/>', {href: 'search/' + type + '/' + $cache.query});
      let country = app.searchbar.country;
      let cur_language = (country == 'KR')?'ko_KR':(country == 'HK'?'ch_HK':'en');
      if (result.hits.length > 0) {
        for (i = 0; i < result.hits.length; ++i) {
          let show_in_result = 0;
          if(typeof result.hits[i].language === 'undefined') {
            show_in_result = 1;
          } else if(typeof result.hits[i].language !== 'undefined' && (result.hits[i].language == 'und' || result.hits[i].language == 'en' || result.hits[i].language == cur_language)) {
            show_in_result = 1;
          }
          if(show_in_result == 0) {
            result.hits.splice(i, 1);
          }
        }
      }
      let $span = $('<span/>').html(String($cache.type[type]).replace(':results', result.hits.length));
      let $em = $('<em/>').html($cache.query + " ");
      $span.prepend($em);
      $a.append($span);
      $div.append($a);
      return $div;
    },

    // Execute search
    search: function (searchTerm) {
      let searchRequestTerm = searchTerm;
      $cache.query = searchRequestTerm;

      // If the search request is empty show the history
      if (searchRequestTerm.length < 1) {
        app.searchbar.clearResults();
        app.searchbar.showSearchHistory();

        if ($(window).width <= 968 && JSON.parse(localStorage['searchHistory'] || '[]').length < 1) {
          app.ui.searchResults.show();

          // add wishlist search
          if ($('a.mobile-search-wishlist').length === 0) {
            $('<a/>', {
              "class": "mobile-search-wishlist mobile-search-item",
              "href": app.urls.wishlist,
              "html": app.resources.WISHLIST_FINDER + '<span class="ar-icon ar-icon-arrow-right-sm ar-icon-white"></span>'
            }).appendTo(app.ui.searchResults);
          }
        }

        $cache.lastRequestQuery = searchRequestTerm;
        return false;
      }

      // if the search request hasn't changed do nothing
      if (searchRequestTerm === $cache.lastRequestQuery) {
        return false;
      }

      // Set set the current request as the last request, generate a request id
      let requestId = Date.now();
      $cache.lastRequestQuery = searchRequestTerm;


      clearTimeout($cache.queryTimeout);
      $cache.queryTimeout = setTimeout(function () {

        if ($cache.latestRequestId > requestId) {
          return false;
        }

        let queries = [];
        let country_filter = '';
        switch (app.searchbar.country){
          case 'US':
            country_filter = '["usa_hide=0"]';
            break;
          case 'CA':
            country_filter = '["canada_hide=0"]';
            break;
          default:
            country_filter = '["' + app.searchbar.country.toLowerCase() + '_hide=0"]';
            break;
        }
        // let country_filter = app.searchbar.country === 'US' ? '["usa_hide=0"]' : '["canada_hide=0"]';
        let product_filter = '["num_products>0"]';
        if (app.isMobile() || app.isiPad()) {
          queries = [{
            indexName: 'products',
            query: searchRequestTerm,
            params: {
              hitsPerPage: app.searchbar.productResults,
              numericFilters: country_filter
            }
          }];
          if ($cache.searchMobileFixed) {
            queries.push({
              indexName: 'category',
              query: searchRequestTerm,
              params: {
                hitsPerPage: app.searchbar.categoryResults,
                numericFilters: product_filter
              }
            });
          }
        }
        else {
          queries = [{
            indexName: 'products',
            query: searchRequestTerm,
            params: {
              hitsPerPage: app.searchbar.productResults,
              numericFilters: country_filter
            }
          }, {
            indexName: 'pages',
            query: searchRequestTerm,
            params: {hitsPerPage: app.searchbar.pageResults}
          }, {
            indexName: 'category',
            query: searchRequestTerm,
            params: {
              hitsPerPage: app.searchbar.categoryResults,
              numericFilters: product_filter
            }
          }, {
            indexName: 'customer_photos',
            query: searchRequestTerm,
            params: {hitsPerPage: app.searchbar.customerPhotoResults}
          }, {
            indexName: 'reviews',
            query: searchRequestTerm,
            params: {hitsPerPage: app.searchbar.reviewResults}
          }, {
            indexName: 'rooms',
            query: searchRequestTerm,
            params: {
              hitsPerPage: app.searchbar.categoryResults,
              numericFilters: product_filter
            }
          }, {
            indexName: 'STL',
            query: searchRequestTerm,
            params: {hitsPerPage: app.searchbar.stlResults}
          }];
        }

        if (app.isMobile() || app.isiPad()) {
          if ($cache.query !== '') {
            app.ui.searchResults.show();
            app.searchbar.client.search(queries, app.searchbar.searchAutocompleteMobileCallback);
          }
          else {
            //app.ui.searchResults.hide();
            app.searchbar.resetInput();
            app.searchbar.clearResults();
          }
        }
        else {
          if ($cache.query !== '') {
            app.ui.searchAutocomplete.show();
            app.searchbar.client.search(queries, app.searchbar.searchAutocompleteCallback);
          }
          else {
            app.searchbar.clearResults();
            app.searchbar.resetInput();
            //app.ui.searchAutocomplete.hide();
          }
        }
      }, $cache.delay);
    },

    // Update the search history
    updateSearchHistory: function (search, href) {
      let searchHistory = JSON.parse(localStorage['searchHistory'] || '[]');
      let searchObject = {
        search: search,
        href: href
      };

      if ($(searchHistory).filter(function (i, value) {
        return value.search === searchObject.search
      }).length < 1) {
        searchHistory.unshift(searchObject);

        if (searchHistory.length > $cache.maxSearchHistory) {
          searchHistory.pop();
        }

        // Update the localStorage
        localStorage['searchHistory'] = JSON.stringify(searchHistory);
      }
    },

    // Show the search history
    showSearchHistory: function () {
      let searchHistory = JSON.parse(localStorage['searchHistory'] || '[]');
      if (searchHistory.length < 1) {
        return false
      }
      searchHistory = searchHistory.slice(0, 6);

      let html = '';
      $.each(searchHistory, function (index, search) {
        let $div = $('<div/>', {
          class: 'hit'
        });
        let $a = $('<a/>', {
          href: search.href
        }).text(search.search);

        $div.append($a);

        html += $div.prop('outerHTML');
      });

      html += $('<div class="hit"><a class="js-search-suggestion-clear">' + app.resources.CLEAR_RECENT_SEARCHES + '</a></div>').prop('outerHTML');

      // update the results div
      app.ui.searchResults.html(html).show();

    },

    // Clear the search history
    clearSearchHistory: function () {
      localStorage['searchHistory'] = JSON.stringify([]);
    },

    // Desktop - Show search
    showSearch: function ($elm, event) {
      event.preventDefault();
      app.nav.closePrimary();
      app.ui.searchContainer.slideToggle(400, function () {
        if ($(this).is(':visible')) {
          app.ui.searchInput.trigger('focus');
          app.search_activated = 1;
          if (app.ui.searchResults.length) {
            app.ui.searchResults.html("");
          }
        }
        else {
          app.ui.searchAutocomplete.hide();
        }
      });

      // close search if click is anywhere else
      $('html').off('click.search');
      $('html').on('click.search', function (e) {
        app.searchbar.hideSearch($elm, e);
      });

      // set focus on search input
      app.ui.searchInput.trigger('focus');

    },
    // Desktop - Hide search
    hideSearch: function ($elm, event) {
      if (app.page.ns !== 'search') {
        app.ui.searchContainer.slideUp(400);
      }
      else {
        if (app.isMobile() || app.isiPad()) {
          q = app.ui.searchInput.val();
          location.href = "/search/products/" + q + "/";
        }
        else {
          app.ui.searchContainer.slideUp(400);
          app.ui.searchAutocomplete.hide();
          app.ui.searchInput.val('');
          app.search_activated = 0;
        }
      }

      // remove click event on html
      $('html').off('click.search');

      document.activeElement.blur();
      // set focus back on body
    },

    hideHits: function() {
      if (!app.isMobile() && !app.isiPad()) {
        app.ui.searchAutocomplete.hide();
      }
    }
  };
}(window.app = window.app || {}, jQuery));
/*!
 * app.ns.search.js
 */
(function(app, $) {
	var $cache = {};

	function initializeDom() {
		app.ui.searchInput.val($cache.search);
		//app.ui.searchContainer.slideDown(400);
		app.ui.searchToggle.addClass('disabled').addClass('hidden-xs hidden-ipad').off('click');

		$cache.searchPageInput.focus();

		// Do the actual search!
		app.search.lookup();
	}

	function initializeEvents() {

		// Re-bind the nav search link
		app.ui.searchToggle.on('click',function(e) {
			e.preventDefault();
			$cache.searchPageInput.focus();
		});

		// Set all input fields to the same and lookup
		$cache.searchPageInput.on('keyup',function(){
			app.search.lookup();
		});

		// Mobile refine by button
		$('#asideTrigger').on('click',function(event) {
			event.preventDefault();
			$(this).toggleClass('open');
			$('#search_sidebar').toggleClass('open');
		});

		// Mobile filter button
		$('#searchFiltersTrigger').on('click',function(event) {
			event.preventDefault();
			$('#searchFiltersHolder').toggleClass('open');
			if ($('#searchFiltersHolder').hasClass('open')) {
				$(this).children('span').addClass('rotated');
			} else {
				$(this).children('span').removeClass('rotated');
			}
		});

		// Click to show more categories
		$cache.document.on('click','#show_more_type_filters',function (){
			$('#show_more_type_filters').hide();
			$("#more_type_filters").slideDown();
		});

		// Close refine
		$cache.document.on('click','.close-refine',function() {
			$('#search_sidebar').toggleClass('open');
		});

		// Type of element click on filters
		$cache.document.on('click','.tab_switch',function(event){
			event.preventDefault();
			$cache.type = $(this).attr('data-tab');
			$cache.load_more = false;
			app.search.lookup();
		});

		// Color filter image is clicked
		$cache.document.on('click', ".color_filter", function(e){
			e.preventDefault();
			let new_facet = 'colors:'+$(this).attr('data-name');
			if ($.inArray(new_facet,$cache.facets.color) === -1) {
				// Add filter
				$cache.facets.color.push(new_facet);
			} else {
				// Remove filter
				delete $cache.facets.color[$.inArray(new_facet,$cache.facets.color)];
			}

			app.search.filterChange();
		});

		// Material Filtering
		$cache.document.on('change', ".material_filter input", function(e){
			e.preventDefault();
			let new_facet = 'nice_names:'+$(this).parents('li').attr('data-name');
			if ($.inArray(new_facet,$cache.facets.material) === -1) {
				// Add filter
				$cache.facets.material.push(new_facet);
			} else {
				// Remove filter
				delete $cache.facets.material[$.inArray(new_facet,$cache.facets.material)];
			}

			app.search.filterChange();
		});

		// Actual category filter (Facet Type)
		$cache.document.on('change', ".type_filter input", function(e){
			e.preventDefault();
			let new_facet = 'terms:'+$(this).parents('li').attr('data-name');
			if ($.inArray(new_facet,$cache.facets.type) === -1) {
				// Add filter
				$cache.facets.type.push(new_facet);
			} else {
				// Remove filter
				delete $cache.facets.type[$.inArray(new_facet,$cache.facets.type)];
			}

			app.search.filterChange();
		});

		/* Sort by rating or price */
		$cache.document.on('change',"#sort_filter",function(e){
			e.preventDefault();
			$cache.productIndex = $(this).val();
			$cache.page = 0;
			app.search.lookup();
		});

		// implement autoscrolling
		//app.search.initAutoScroll();

		/* Load more button */
		$cache.document.on('click',"#loadSearchProds",function(e){
			e.preventDefault();
			$cache.page++;
			$cache.load_more=true;
			app.search.lookup();
		});

		/*
		// no hits
		if ($('.no-hits-main').length > 0) {

			// show chat
			var $chatlink = $(".chat-link");
			if ($chatlink.length > 0 && !$chatlink.hasClass('offline')) {
				$('.no-hits-messageus').css('display', 'inline-block');
			}

			$('.no-hits-messageus').on('click', function() {
				$('.chat-link').click();
				return false;
			});

			// desktop events
			if (!app.isMobileInit) {
				app.searchsuggest.init('.no-hits-search');
				$('.no-hits-search input[name=q]').focus();
			}// mobile events
			else {
				// initialize mobile search open
				$('.no-hits-search input').on('click', function() {
					$('.mobile-search-trigger').click();
				});
			}
		} else {
			// Results found
			var $searchheader = $('#search_caption');
			var $searchTool = $('#search_tools');
			if ($searchheader.length > 0) {
				// stick the search header on scroll
				var spacer = app.isMobileInit ? 60 : 45;

				$(window).on("scroll", function() {
					app.components.stick(app.ui.contentContainer, $searchTool, spacer, null, null, $searchTool.parent());
				}).scroll();

				var windowWidth = $(window).width();
				$(window).on("resize", function() {

					// check window width has actually changed and it's not just iOS triggering a resize event on scroll
					if ($(window).width() != windowWidth) {

						// Update the window width for next time
						windowWidth = $(window).width();

						app.components.restick(app.ui.contentContainer, $searchTool);
					}

				});

			}

			app.search.setRefinements();

			// on mobile when refining create a dialog and get html from desktop
			$('body').on('click', '#asideTrigger, #searchFiltersTrigger', function() {
				var $refine = $('#search_sidebar');
				//$refine.find('.ar-refinement-category').remove();
				//$refine.find('.ar-refinement').removeClass('expanded');

				var $dialog = $("<div/>", {
					"id": "ar-refinements-mobile",
					"class": "ar-refinements",
					"html": $refine.html()
				});

				$dialog.dialog({
					resizable: false,
					title: app.resources.FILTER_SELECT,
					dialogClass: "refinements-dialog",
					close: function(event, ui) {
						$dialog.remove();
					}
				});
			});

			// handle toggle refinement blocks
			// toggle is not used because refinements look
			// like select boxes
			$('body').on("click", ".refineSearch>li", function(e) {
				$(this).toggleClass('expanded');

				// reset the sticky menus cached height on toggle
				var $stickymenu = $('#search_sidebar');
				$stickymenu.data('elmheight', $stickymenu.height());
			});

			// handle events for updating grid
			//$('body').on("click", ".refinements a, .breadcrumb-refinement-value a, a.ar-refinement-level-2", function(e) {
			$('body').on('click', ".refineSearch a", function(e) {
				var $this = $(this);
				if ($this.parent().hasClass("unselectable")) {
					return;
				}

				var $mobiledialog = $('#search_sidebar');
				if ($mobiledialog.hasClass('open')) {
					$mobiledialog.removeClass('open');
				}

				var uri = app.util.getUri(this);

				// set virtual page view for gaa
				gaa.filter(uri.query);

				if (uri.query.length > 1 && history.pushState) {
					//window.location.hash = uri.query.substring(1);
					var url = uri.path + uri.query;
					//decodeURIComponent(url)
					history.pushState({}, document.title, url);
					updateProductListing();
				} else {
					window.location.href = this.href;
				}

				return false;
			});

			// implement autoscrolling
			app.search.initAutoScroll();

			if (app.isMobileInit) {
				$('body').on('change', '.select-search-mobile', function() {
					var url = $(this).val();
					// get selected value

					gaa.sendEvent("nav-category");

					if (url) {
						// require a URL
						window.location = url;
						// redirect
					}
					return false;
				});
			}
		}
		*/
	}

	/*
	// replaces breadcrumbs, lefthand nav and product listing with ajax and puts a loading indicator over the product listing
	function updateProductListing() {

		app.progress.show(app.ui.contentContainer);
		app.ui.contentContainer.data('busy', true);

		app.ajax.load({
			url: app.util.appendParamToURL(window.location.href, "format", "ajax"),
			callback: function(data) {

				// Dirty regex hack to get the search-result list
				// should be refactored to use XML parsing
				try {
					//var myData = data;

					// Update paging
					var rDiv = jQuery('<div/>');
					rDiv[0].innerHTML = data;

					// response has a main div, must only get contents of main. Ex. clearing all filters
					if (rDiv.find("#main").length) {
						if (rDiv.find("#main").hasClass('container_30')) {
							rDiv[0].innerHTML = rDiv.find("#main").children().first().html();
							// get html of first child
						} else {
							rDiv[0].innerHTML = rDiv.find("#main").html();
						}
					}

					// if full width template we need to inject to child div
					if ($cache.main.hasClass('container_30')) {
						var $firstchild = $cache.main.children().first();
						$firstchild.html(rDiv.html());
					} else {
						$cache.main.html(rDiv.html());
					}

					// fade in lazy images
					$cache.main.find("#primary img.lazy").lazyload({
						effect: "fadeIn"
					}).removeClass("lazy");

					window.picturefill();

					$('#primary').data('busy', false);

				} catch (e) {
					$cache.main.html(data);
				}

				//app.product.compare.init();
				app.product.tile.init();
				app.progress.hide();

				// responsive
				//initRefinements();
				setProductGrid();

				// TODO: What is this? Removing the last element on mobile??
				if (window.innerWidth < 768 && $('.search-result-items').length > 0) {
					var numitems = $('.search-result-items').children('li.grid-tile').length;
					if ($('.load_btn').is(':visible') && (numitems == 21 || numitems == 19 || numitems == 17)) {
						$('.search-result-items').children('li.grid-tile').last().remove();
					}
				}

				// reinit the sticky left column
				if (window.innerWidth >= 768 || document.body.clientWidth >= 768) {
					app.nav.unStickRefinementBar();
					// clear the cached variables
					app.nav.stickRefinementBar();
				}

				// collapse not used filter
				app.search.setRefinements();

				// reinitialize cateogry swiper on mobile
				var $mobilecateogory = $('.ar-search-header .ar-swiper');
				if ($mobilecateogory.length > 0) {
					app.carousel.swiper($mobilecateogory);
				}

				// set scroll location
				var scrollTo = $('#main').offset().top - 25;
				if (app.isMobileInit) {
					scrollTo -= 40;
				}

				// trigger a height change
				$(document).trigger('heightChange');

				$('html, body').animate({
					scrollTop: scrollTo
				}, 400);
			}
		});

	}
	*/

	app.search = {
		client: algoliasearch('6COW5PRN5I', 'bc1bbe633e133311653923461e0d151c'),

		init: function() {
			$cache = {
				type: $("#drupal_i").val(), // type of search
				search: $("#drupal_q").val(), // keyword of search
				searchTab: $('#search_tab'),
				searchText: $('#search_q'),
				searchPageInput: $("#rove-search-keyword"),
				page: 0, // pagination page
				country: app.getCountry(),
				back_button_clicked: false,
				productIndex: 'products',
				load_more: false,
				wall: null,
				limits: {
					hitsProduct: 1,
					hitsProduct: 24,
					hitsPage: 20,
					hitsCategory: 5,
					hitsCustomerPhotos: 10,
					hitsReviews: 10,
					hitsSTL: 20
				},
				colors: {
					White: '#fff',
					Black: '#000',
					Beige: '#d7ba89',
					Brown: '#554437',
					Blue: '#3097a8',
					Orange: '#d28c3e',
					Purple: '#92417a',
					Gray: '#7f807a',
					Grey: '#7f807a',
					Red: '#b7381f',
					Pink: '#bd4a5a',
					Green: '#7fa00b',
					Yellow: '#00FFFF'
				},
				facets: {
					color: [],
					material: [],
					type: [],
				},

				main: app.ui.contentContainer,
				total_hits: $('#total_hits'),
				more_button: $("#loadSearchProds"),
				items: $("#search_hits"),
				reviewWall: '#reviewWall',
				backToTop: false,
				backTopID: 'btn-backTop',
				'document': $(document)
			};

			let hidden_filter = '';
			switch ($cache.country){
				case 'US':
					hidden_filter = 'usa_hide';
					break;
				case 'CA':
					hidden_filter = 'canada_hide';
					break;
				case 'HK':
					hidden_filter = 'hk_hide';
					break;
				default:
					hidden_filter = $cache.country.toLowerCase()+'_hide';
					break;
			}
			$cache.send_filter = '["'+hidden_filter+'=0"]';
			// $cache.send_filter = $cache.country === 'US' ? '["usa_hide=0"]' : '["canada_hide=0"]';
			switch($cache.type) {
				case 'STL':
				case 'stl':
					$cache.typeCode = 'stl_pages';
					break;
				case 'pages':
					$cache.typeCode = 'static_pages';
					break;
				default:
					$cache.typeCode = $cache.type;
					break;
			}

			//app.product.tile.init();

			initializeDom();
			initializeEvents();
		},

		formatFilter: function(type) {
			$cache.facets[type] = $cache.facets[type].filter(function(el) { return el; });
			if ($cache.facets[type].length > 1) {
				return '('+$cache.facets[type].join()+')';
			} else if ($cache.facets[type].length === 1) {
				return $cache.facets[type].join();
			} else {
				return '';
			}
		},

		filterChange: function() {
			let uri = app.util.getUri(window.location.href);
			// set virtual page view for gaa
			//gaa.filter(uri.query);

			let url = uri.path + uri.query;
			//decodeURIComponent(url)
			history.pushState({}, document.title, url);

			$cache.page = 0;
			app.search.lookup();
		},

		getFacetFilters: function() {
      let fColor = app.search.formatFilter('color');
      let fMat = app.search.formatFilter('material');
      let fType = app.search.formatFilter('type');
      let fGroup = [];

      if (fColor.length > 2) { fGroup.push(fColor); }
      if (fMat.length > 2) { fGroup.push(fMat); }
      if (fType.length > 2) { fGroup.push(fType); }

      let facets = fGroup.filter(function(el) { return el; }).join(',');
      if (!facets.length) {
        facets = '*';
      }
      return facets;
		},

		lookup: function() {
			app.progress.show(app.ui.contentContainer);
			app.ui.contentContainer.data('busy', true);

			if (!$cache.load_more) {
				$cache.page = 0;
			}

			// Update our variables
			$cache.search = $cache.searchPageInput.filter(':visible').val();
			$("#drupal_q").val($cache.search);

			let facets = app.search.getFacetFilters();

			let queries = [{
				indexName: $cache.productIndex,
				query: $cache.search,
				params: {hitsPerPage: $cache.limits.hitsProduct, facets: facets, numericFilters: $cache.send_filter, facetFilters: facets, page: $cache.page}
			}, {
				indexName: 'pages',
				query: $cache.search,
				params: {hitsPerPage: $cache.limits.hitsPage, page: $cache.page }
			}, {
				indexName: 'category',
				query: $cache.search,
				params: {hitsPerPage: $cache.limits.hitsCategory }
			}, {
				indexName: 'customer_photos',
				query: $cache.search,
				params: {hitsPerPage: $cache.limits.hitsCustomerPhotos, page: $cache.page }
			}, {
				indexName: 'reviews',
				query: $cache.search,
				params: {hitsPerPage: $cache.limits.hitsReviews, page: $cache.page }
			}, {
				indexName: 'STL',
				query: $cache.search,
				params: {hitsPerPage: $cache.limits.hitsSTL, page: $cache.page }
			}];

			app.search.client.search(queries, app.search.searchDetailedCallback);
			if(!$cache.back_button_clicked) {
				window.history.pushState("", "", "/search/" + $cache.type + "/" + $cache.search + (facets ? "/filter/" + facets + "/" : "" ));
			} else {
				$cache.back_button_clicked = false;
			}
		},

		searchDetailedCallback: function(err, content) {
			// Track search event
			//gaa.search(app.ui.searchInput.val().trim());

			// cache the facets param
			app.search.determineFacets();

			let results = {
				products: content.results[0],
				static_pages: content.results[1],
				stl_pages: content.results[5],
				customer_photos: content.results[3],
				reviews: content.results[4]
			};

			app.search.identifyTab(results.products, results.static_pages, results.customer_photos, results.reviews, results.stl_pages);

			let name = 'Products';
			switch($cache.type) {
				case 'STL':
					name = 'Shop the look';
					break;
				case 'reviews':
					name = 'Reviews';
					break;
				case 'customer_photos':
					name = 'Customer photos';
					break;
				case 'pages':
					name = 'Pages';
					break;
			}
			$cache.searchTab.html(name);
			$cache.searchText.html(results.products.query);

			// Only products and customer_photos should have these filters.
			if ($cache.type !== 'products' && $cache.type !== 'customer_photos') {
				$('#search_material, #search_colors, #search_type, #search_price, #search_sorting').hide();
			}

			app.search.setFilters(results.products, results.static_pages, results.customer_photos);
			app.search.handleResults(results);
			app.search.setRefineBy(results);


			app.ui.contentContainer.data('busy', false);
			//app.product.tile.init();
			app.progress.hide();

			// set scroll location
			//var scrollTo = app.ui.contentContainer.offset().top - 25;
			//if (app.isMobileInit) {
			//	scrollTo -= 40;
			//}

			// trigger a height change
			$(document).trigger('heightChange');

			/*
			$('html, body').animate({
				scrollTop: scrollTo
			}, 400);
			*/

			app.tracking.track('search',{term:$cache.search});
			app.tracking.track('searchViewResults',{term:$cache.search,items:results.products});
		},

		identifyTab: function(products, static_pages, customer_photos, reviews, stl_pages) {
			let max_result_hits;
			if ($cache.type == 'undefined' || !$cache.type) {
				$cache.type = 'products';
				return 'products';
			} else if($cache.type === 'products' && products.nbHits === 0){
				max_result_hits = static_pages.nbHits;
				if (customer_photos.nbHits > max_result_hits){
					max_result_hits = customer_photos.nbHits;
					return 'customer_photos';
				}
				if (reviews.nbHits > max_result_hits){
					return 'reviews';
				}
				return 'pages';
			}
			else if($cache.type === 'pages' && static_pages.nbHits === 0){
				max_result_hits = products.nbHits;
				if (customer_photos.nbHits > max_result_hits){
					max_result_hits = customer_photos.nbHits;
					return 'customer_photos';
				}
				if (reviews.nbHits > max_result_hits){
					return 'reviews';
				}
				return 'products';
			}
			else if($cache.type === 'STL' && stl_pages.nbHits === 0){
				max_result_hits = products.nbHits;
				if (customer_photos.nbHits > max_result_hits){
					max_result_hits = customer_photos.nbHits;
					return 'customer_photos';
				}
				if (reviews.nbHits > max_result_hits){
					return 'reviews';
				}
				return 'products';
			}
			else if($cache.type === 'customer_photos' && customer_photos.nbHits === 0){
				max_result_hits = products.nbHits;
				if (static_pages.nbHits > max_result_hits){
					max_result_hits = static_pages.nbHits;
					return 'pages';
				}
				if (reviews.nbHits > max_result_hits){
					return 'reviews';
				}
				return 'products';
			}
			else if($cache.type === 'reviews' && reviews.nbHits === 0){
				max_result_hits = static_pages.nbHits;
				if (customer_photos.nbHits > max_result_hits){
					max_result_hits = customer_photos.nbHits;
					return 'customer_photos';
				}
				if (products.nbHits > max_result_hits){
					return 'products';
				}
				return 'pages';
			}
			else {
				return $cache.type;
			}
		},

		determineFacets: function() {
			let facets = ($cache.facets.color.length ? $cache.facets.color.join(',') : '');
			if(facets !== '' ) {
				facets += ($cache.facets.material.length ? ','+$cache.facets.material.join(',') : '');
			} else {
				facets = ($cache.facets.material.length ? ','+$cache.facets.material.join(',') : '');
			}
			if(facets !== '' ) {
				facets += ($cache.facets.type.length ? ','+$cache.facets.type.join(',') : '');
			} else {
				facets = ($cache.facets.type.length ? ','+$cache.facets.type.join(',') : '');
			}
			if(facets === '') {
				facets = '*';
			}
			$cache.facetsDetermined = facets;
		},

		setFilters: function(products, static_pages, customer_photos) {
			//let facets = $cache.facetsDetermined;

			let $color_facets_html = $('<div/>');
			let $material_facets_html = $('<div/>');
			let $type_facets_html = $('<div/>');

			let index = app.search.client.initIndex('products');
			let q = $cache.searchPageInput.val();
			index.search(q, { hitsPerPage: 0, facets: '*', numericFilters: $cache.send_filter, facetFilters: app.search.getFacetFilters() },  function(e, c){
				let type_counter;
				for(let facet in c.facets) {
					if (c.facets.hasOwnProperty(facet)) {
						if (facet === 'colors') {
							for (let color in c.facets[facet]) {
								if (c.facets[facet].hasOwnProperty(color)) {
									if ($cache.colors[color]) {
										let $a = $('<a/>',{
											class:'color_filter' + ($cache.facets.color.length ? ($.inArray('colors:'+color,$cache.facets.color)!== -1?' current':'') : ''),
											'data-name':color,
											href: '#',
											style: "background-color:" + $cache.colors[color]
										}).text(color);
										$color_facets_html.append($a);
									}
								}
							}
						}
						if (facet === 'nice_names') {
							for (let material in c.facets[facet]) {
								if (c.facets[facet].hasOwnProperty(material)) {
									let $li = $('<li/>',{class:'material_filter','data-name':material});
									let $div = $('<div/>',{class: 'form-item form-type-checkbox checkbox lab_check'});
									let $input = $('<input/>',{
										checked:($cache.facets.material.length ? ($.inArray('nice_names:'+material,$cache.facets.material)!== -1?'checked':false) : false),
										class:'styled checkbox-primary form-checkbox',
										type: 'checkbox',
										id: 'nn_'+material.replace(' ','')
									});
									let $label = $('<label/>',{class:'control-label','for':'nn_'+material.replace(' ','')}).text(app.util.capitalizeFirstLetter(material) + ' (' + c.facets[facet][material] + ')');
									$div.append($input);
									$div.append($label);
									$li.append($div);
									$material_facets_html.append($li);
								}
							}
						}
						if (facet === 'terms') {
							type_counter = 0;
							let $more_li = $('<li/>',{id:'show_more_type_filters'}).text('More');
							for (let type in c.facets[facet]) {
								if (c.facets[facet].hasOwnProperty(type)) {
									if (type_counter === 6) {
										$type_facets_html.append($more_li);
									}
									let $li = $('<li/>',{class:'type_filter','data-name':type});
									if (type_counter > 6) {
										$li.attr('style','display:none;');
									}
									let $div = $('<div/>',{class:'form-item form-type-checkbox checkbox lab_check'});
									let $input = $('<input/>',{
										checked:($cache.facets.type.length ? ($.inArray('terms:'+type,$cache.facets.type) !== -1?'checked':false) : false),
										class:'styled checkbox-primary form-checkbox',
										type: 'checkbox',
                    id: 'nn_'+type.replace(' ','')
									});
									let $label = $('<label/>',{class:'control-label','for':'nn_'+type.replace(' ','')}).text(app.util.capitalizeFirstLetter(type) + ' (' + c.facets[facet][type] + ')');
									$div.append($input);
									$div.append($label);
									$li.append($div);
									$type_facets_html.append($li);

									type_counter++;
								}
							}
						}
					}
				}

				$("#search_material_facets, #search_colors_facets, #search_type_facets").empty();
				$("#search_material_facets").append($material_facets_html);
				$("#search_colors_facets").append($color_facets_html);
				$("#search_type_facets").append($type_facets_html);

				if($material_facets_html.html().length) {
					$('#search_material').show();
				} else {
					$('#search_material').hide();
				}
				if($color_facets_html.html().length) {
					$('#search_colors').show();
				} else {
					$('#search_colors').hide();
				}

				$('#search_type, #search_price, #search_sorting').show();
			});
		},

		showHideMore: function(hits) {
			if($cache.page+1 === parseInt(hits[$cache.typeCode].nbPages) || $cache.page === parseInt(hits[$cache.typeCode].nbPages) || parseInt(hits[$cache.typeCode].nbPages) < 2) {
				$cache.more_button.hide();
			} else {
				$cache.more_button.show();
			}
		},

		handleResults: function(hits) {
			let $hitResult = $('<div/>');

			// PRODUCTS
			if($cache.type === 'products') {
				if(!hits.products.nbHits) {
					hits.products.nbHits = 0;
				}
				$cache.total_hits.html(hits.products.nbHits);
				let index_products = app.search.client.initIndex($cache.type);
				index_products.search(app.ui.searchInput.val().trim(), {
					hitsPerPage: $cache.limits.hitsProduct,
					facets: '*',
					numericFilters: $cache.send_filter,
					page: $cache.page,
					facetFilters: $cache.facetsDetermined
				}, function(e, c) {
					//hits.products = c; // TODO: Why are we overwriting?

					// This is to hide/show the more button
					app.search.showHideMore(hits);

					if (hits.products.hits.length > 0) {
						$divA = $('<div/>',{id:'rove_products',class:'clearfix grid-4x'});
						$divB = $('<div/>',{class:'row mcr'});

						for (i = 0; i < hits.products.hits.length; ++i) {
							$divB.append(app.search.templateProduct(hits.products.hits[i]));
						}
						$hitResult.append($cache.load_more ? $divB : $divA.append($divB));
					}
					else {
						if(!$cache.load_more) {
							$hitResult.append($('<div/>',{class:'clearfix tCent'}).text('No products found.'));
						}
					}
					if($cache.load_more) {
						$cache.items.find('#rove_products .row').append($($hitResult.html()).html());
					} else {
						$cache.items.html($hitResult.html());
					}

					app.components.getLazy().update();

					$cache.load_more = false;
				});

				Drupal.attachBehaviors(document, Drupal.settings);
				setTimeout(function() {
					app.components.love();
				},200);
			}

			// Customer Photos
			else if ($cache.type === 'customer_photos'){
				$('#search_material, #search_colors, #search_type, #search_price, #search_sorting').hide();
				$cache.total_hits.html(hits.customer_photos.nbHits);
				if(!hits.customer_photos.nbHits) {
					hits.customer_photos.nbHits = 0;
				}

				// This is to hide/show the more button
				app.search.showHideMore(hits);

				if (hits.customer_photos.hits.length > 0) {
					let $rovewall = $('<div/>');
					if(!$cache.load_more) {
						$rovewall = $('<div/>',{id:'rovewall'});
					}
					for (i = 0; i < hits.customer_photos.hits.length; ++i) {
						$rovewall.append(app.search.templatePhoto(hits.customer_photos.hits[i]));
					}
          $hitResult.append($cache.load_more ? $($rovewall.html()) : $rovewall);
				}
				else {
					if(!$cache.load_more) {
						$hitResult.append($('<div/>',{class:'clearfix tCent'}).text('No photos found.'));
					}
				}
				if($cache.load_more) {
					//$cache.items.append(result);
					//let freewallElems = $($hitResult.html()).toArray();
					$cache.main.find('#rovewall').append($hitResult.html());
          $cache.wall.recalculate();
				}
				else{
					$cache.items.html($hitResult.html());
					let options = app.myrove.options;
					options.brickSelector = '#rovewall';
					$cache.wall = app.myrove.setupWall(options);
				}
				Drupal.attachBehaviors(document, Drupal.settings);
				$cache.load_more = false;
			}

			// REVIEWS
			if ($cache.type === 'reviews') {
				$cache.total_hits.html(hits.reviews.nbHits);
				if (!hits.reviews.nbHits) {
					hits.reviews.nbHits = 0;
				}

				// This is to hide/show the more button
				app.search.showHideMore(hits);

				/* ----- Reviews ----------- */
				if (hits.reviews.hits.length > 0) {
					let $section = $('<div/>');
					let $trustpilot = $('<div/>');

					if (!$cache.load_more) {
						$section = $('<section/>',{id:'reviews_holder',class:'page-trustpilot'});
						$trustpilot = $('<div/>',{
							id:'reviewWall','data-selector':'.views-row'});
					}
					for (i = 0; i < hits.reviews.hits.length; ++i) {
						$trustpilot.append(app.search.templateReview(hits.reviews.hits[i]))
					}
					$hitResult.append($cache.load_more ? $($trustpilot.html()) : $section.append($trustpilot));
				}
				else {
					if (!$cache.load_more) {
						$hitResult.append($('<div/>',{class:'clearfix tCent'}).text('No reviews found.'));
					}
				}
				if ($cache.load_more) {
					$cache.items.find('#reviewWall').append($hitResult.html());
          $cache.wall.recalculate();
				} else {
					$cache.items.html($hitResult.html());
					let options = app.reviews.options;
					options.brickSelector = '#reviewWall';
					$cache.wall = app.reviews.setupWall(options);
				}
				$cache.load_more = false;

			// SHOP THE LOOK
			} else if ($cache.type === 'STL') {
				/* ----- STL ------ */
				$cache.total_hits.html(hits.stl_pages.nbHits);
				if(!hits.stl_pages.nbHits) {
					hits.stl_pages.nbHits = 0;
				}

				// This is to hide/show the more button
				app.search.showHideMore(hits);
        let country = $cache.country;

        let cur_language = (country == 'KR')?'ko_KR':(country == 'HK'?'ch_HK':'en');

        if (hits.stl_pages.hits.length > 0) {
					let $stl_html = $('<div/>',{id:'resources_holder'});
					for (i = 0; i < hits.stl_pages.hits.length; ++i) {
            let show_in_result = 0;
            if(typeof hits.stl_pages.hits[i].language === 'undefined') {
              show_in_result = 1;
            } else if(hits.stl_pages.hits[i].language !== 'undefined' && (hits.stl_pages.hits[i].language == 'und' || hits.stl_pages.hits[i].language == 'en' || hits.stl_pages.hits[i].language == cur_language)) {
              show_in_result = 1;
            }
            if(show_in_result == 1) {
              $stl_html.append(app.search.templatePage(hits.stl_pages.hits[i]));
            }

					}
					$hitResult.append($stl_html);
				}
				else {
					if(!$cache.load_more) {
						$hitResult.append($('<div/>',{class:'clearfix tCent'}).text('No pages found.'));
					}
				}
				if($cache.load_more) {
					$cache.items.append($hitResult.html());
				} else {
					$cache.items.html($hitResult.html());
				}
				$cache.load_more = false;

			// STATIC PAGES
			} else if ($cache.type === 'pages'){
				/* ----- Pages ----------- */
        let country = $cache.country;
        let cur_language = (country == 'KR')?'ko_KR':(country == 'HK'?'ch_HK':'en');
				$cache.total_hits.html(hits.static_pages.nbHits);
				if(!hits.static_pages.nbHits) {
					hits.static_pages.nbHits = 0;
				}

				// This is to hide/show the more button
				app.search.showHideMore(hits);
				if (hits.static_pages.hits.length > 0) {
					let $static_html = $('<div/>',{id:'resources_holder'});
					for (i = 0; i < hits.static_pages.hits.length; ++i) {
            let show_in_result = 0;
            if(typeof hits.static_pages.hits[i].language === 'undefined') {
              show_in_result = 1;
            } else if(hits.static_pages.hits[i].language !== 'undefined' && (hits.static_pages.hits[i].language == 'und' || hits.static_pages.hits[i].language == 'en' || hits.static_pages.hits[i].language == cur_language)) {
              show_in_result = 1;
            }
            if(show_in_result == 1) {
              $static_html.append(app.search.templatePage(hits.static_pages.hits[i]));
            }

					}
					$hitResult.append($static_html);
				}
				else {
					if(!$cache.load_more) {
						$hitResult.append($('<div/>',{class:'clearfix tCent'}).text('No pages found.'));
					}
				}
				if($cache.load_more) {
					$cache.items.append($hitResult.html());
				} else {
					$cache.items.html($hitResult.html());
				}
				$cache.load_more = false;
			}
		},

		setRefineBy: function(hits) {
			$("#search_refine_by").empty();

			let $refineBy = $('');
			let $span = $('');
			if(hits.products.nbHits > 0 || hits.customer_photos.nbHits > 0 || hits.reviews.nbHits > 0 || hits.static_pages.nbHits > 0) {
				$span = $('<span/>').text('Category');

				$refineBy = $('<ul/>');
				if (hits.products.nbHits > 0) {
					$refineBy.append($('<li/>').append($('<a/>',{'data-tab':'products',class:'tab_switch',href:'/search/products/'+$cache.search}).text('Products ('+hits.products.nbHits + ')')));
				}
				if (hits.customer_photos.nbHits > 0) {
					$refineBy.append($('<li/>').append($('<a/>',{'data-tab':'customer_photos',class:'tab_switch',href:'/search/customer_photos/'+$cache.search}).text('Customer Photos ('+hits.customer_photos.nbHits + ')')));
				}
				if (hits.reviews.nbHits > 0) {
					$refineBy.append($('<li/>').append($('<a/>',{'data-tab':'reviews',class:'tab_switch',href:'/search/reviews/'+$cache.search}).text('Reviews ('+hits.reviews.nbHits + ')')));
				}
				if (hits.static_pages.nbHits > 0) {
					$refineBy.append($('<li/>').append($('<a/>',{'data-tab':'pages',class:'tab_switch',href:'/search/pages/'+$cache.search}).text('Pages ('+hits.static_pages.hits.length + ')')));
				}
				if (hits.stl_pages.nbHits > 0) {
					$refineBy.append($('<li/>').append($('<a/>',{'data-tab':'STL',class:'tab_switch',href:'/search/STL/'+$cache.search}).text('Shop the Look ('+hits.stl_pages.hits.length + ')')));
				}
			} else {
				$span = $('<span/>').text('Nothing found.');
			}
			$("#search_refine_by").append($span).append($refineBy);
		},

		setRefinements: function() {
			var $refinements = $('.refineSearch>li');
			if ($refinements.length > 1) {
				var numselected = 0;
				$.each($refinements, function() {
					var $this = $(this)
					var checks = $this.find(':checked');
					if (checks.length === 0) {
						if (!$this.attr('id') !== "search_refine_by") {
							$this.removeClass('expanded');
						}
					} else {
						//$this.addClass('expanded');
						numselected += checks.length;
					}
				});

				if (numselected > 0) {
					$('#asideTrigger').html("Refine By " + ' (' + numselected + ')');
				}
			}
		},

		templateProduct: function(hit) {
			const membershipEnable = $('#membership_enable').val();
			const membershipRate = $('#membership_rate').val();
			// let default_price = $cache.country === 'US' ? parseFloat(hit.prices.price.usd) : parseFloat(hit.prices.price.cad);
			var currency = '';
			var default_price = 0;
			var sale_price = 0;
			switch ($cache.country){
				case 'CA':
					currency = 'cad';
					// default_price = hit.prices.price.cad;
					// sale_price = default_price - parseFloat(hit.prices.sale_amount.cad);
					break;
				case 'US':
					currency = 'usd';
					// default_price = hit.prices.price.usd;
					// sale_price = default_price - parseFloat(hit.prices.sale_amount.usd)
					break;
				case 'HK':
					currency = 'hkd';
					// default_price = hit.prices.price.hkd;
					// sale_price = default_price - parseFloat(hit.prices.sale_amount.hkd)
					break;
				default:
					currency = $cache.country.toLowerCase()+'d';
					// default_price = hit['prices']['price'][currency];
					// sale_price = default_price - parseFloat(hit['prices']['sale_amount'][currency])
					break;
			}
			let priceData = {
				default_price:	default_price,
				sale_price: sale_price,
				$sale_msg: $('<div/>'),
				$sale_strike: $('<div/>')
			};
			let sign = '$';
			if($cache.country === 'CA'){
				sign = 'C$';
			}
            if($cache.country === 'AU'){
                sign = 'AU$';
            }
            if($cache.country === 'HK'){
                sign = 'HK$';
            }
            if($cache.country === 'UK'){
                sign = '£';
            }
            if($cache.country === 'KR'){
                sign = '원';
            }
			let membershipPrice = default_price;
			if(membershipEnable && parseInt(membershipEnable) !== 0){
				if (typeof hit['sale'] != 'undefined' && typeof hit['sale'][currency] != 'undefined' && parseInt(hit['sale'][currency]) === 1) {
					membershipPrice = Math.round(priceData.sale_price * ( 1 - membershipRate / 100 ));
					priceData.$sale_msg = $('<div/>',{class:'product_sale'}).text('Sale');
					priceData.$sale_strike.append($('<div/>',{class:'member_price'}).append($('<strong/>').text(sign+app.util.number_format(membershipPrice,0,'.','')+' '+'MEMBER')));
					// priceData.$sale_strike.append('REGULAR ');
					priceData.$sale_strike.append($('<div/>',{class:'original'}).text(sign+app.util.number_format(priceData.default_price,0,'.','')+' '+'REGULAR'));
					priceData.$sale_strike.append($('<div/>',{class:'sale_price'}).text(sign+app.util.number_format(priceData.sale_price,0,'.','')+' '+'SALE'));
				} else {
					membershipPrice = Math.round(default_price * ( 1 - membershipRate / 100 ));
					priceData.$sale_strike.append($('<div/>',{class:'member_price'}).append($('<strong/>').text(sign+app.util.number_format(membershipPrice,0,'.','')+' '+'MEMBER')));
					priceData.$sale_strike.append(sign+app.util.number_format(default_price,0, '.','')+' '+'REGULAR');
				}
			}else{
				if (typeof hit['sale'] != 'undefined' && typeof hit['sale'][currency] != 'undefined' && parseInt(hit['sale'][currency]) === 1) {
					priceData.$sale_msg = $('<div/>',{class:'product_sale'}).text('Sale');
					priceData.$sale_strike.append($('<div/>',{class:'original'}).text('$'+app.util.number_format(priceData.default_price,2,'.',',')));
					priceData.$sale_strike.append($('<div/>',{class:'sale_price'}).text('$'+app.util.number_format(priceData.sale_price,2,'.',',')+' '+$cache.country+'D'));
				} else {
					priceData.$sale_strike.append('$'+app.util.number_format(default_price,2, '.',',')+' '+$cache.country+'D');
				}
			}

			let $output = $('<div/>',{class:'product_listing col-xs-12 col-sm-12 col-md-3 col-lg-3'});
			let $a = $('<a/>',{href:hit.url+hit.url_query.replace(/&amp;/g, '&'),'data-pnid':hit.nid});
			let $img = $('<div/>',{class:'product_image hover-fade'});
			let $picture = $('<picture/>',{});

			let sizes = [320,480,768];
			let src = [];
			for(let s in sizes) {
				src.push(hit.image_lrg.replace('uc_product_list','picture_'+sizes[s]+'_1x') + ' ' + sizes[s] + 'w');
			}
			$picture.append($('<img/>',{
				class:'img-responsive lazy',
				typeof:'foaf:Image',
				alt:hit.title,
				'data-src': hit.image_lrg.replace('uc_product_list','picture_'+sizes[0]+'_1x'),
				'data-srcset': src.join(', '),
				'data-sizes': '(min-width: 769px) 320px, (max-width: 768px) 480px, 100vw'
			}));


			/*
			$picture.append('<!--[if IE 9]><video style="display: none;"><![endif]-->');
			let sizes = [320,480,768];
			for(let s in sizes) {
				$picture.append($('<source/>',{
					media:'(max-width:'+s+'px)',
					sizes:'',
					srcset:hit.image_lrg.replace('uc_product_list','picture_'+s+'_1x')+' 1x, '+hit.image_lrg.replace('uc_product_list','picture_'+s+'_2x')+' 2x, '+hit.image_lrg.replace('uc_product_list','picture_'+s+'_3x')+' 3x'
				}));
			}
			$picture.append('<!--[if IE 9]></video><![endif]-->');
			$picture.append($('<img/>',{
				class:'img-responsive lazy',
				typeof:'foaf:Image',
				alt:hit.title,
				srcset:hit.image_lrg.replace('uc_product_list','picture_320_1x')+' 1x, '+hit.image_lrg.replace('uc_product_list','picture_320_2x')+' 2x, '+hit.image_lrg.replace('uc_product_list','picture_320_3x')+' 3x',
			}));
			*/
			$img.append($picture);

			// Link image
			let $hover = $('<div/>',{class:'product-hover'});
			src = [];
			for(let s in sizes) {
				src.push(hit.image_alt_lrg.replace('uc_product_list','picture_'+sizes[s]+'_1x') + ' ' + sizes[s] + 'w');
			}
			$picture = $('<picture/>',{});
			$picture.append($('<img/>',{
				class:'img-responsive lazy',
				typeof:'foaf:Image',
				alt:hit.title,
				'data-src': hit.image_alt_lrg.replace('uc_product_list','picture_'+sizes[0]+'_1x'),
				'data-srcset': src.join(', '),
				'data-sizes': '(min-width: 769px) 320px, (max-width: 768px) 480px, 100vw'
			}));
			/*
			$picture.append('<!--[if IE 9]><video style="display: none;"><![endif]-->');
			for(let s in sizes) {
				$picture.append($('<source/>',{
					media:'(max-width:'+s+'px)',
					sizes:'',
					srcset:hit.image_alt_lrg.replace('uc_product_list','picture_'+s+'_1x')+' 1x, '+hit.image_alt_lrg.replace('uc_product_list','picture_'+s+'_2x')+' 2x, '+hit.image_alt_lrg.replace('uc_product_list','picture_'+s+'_3x')+' 3x'
				}));
			}
			$picture.append('<!--[if IE 9]></video><![endif]-->');
			$picture.append($('<img/>',{
				class:'img-responsive lazy',
				typeof:'foaf:Image',
				alt:hit.title,
				srcset:hit.image_alt_lrg.replace('uc_product_list','picture_320_1x')+' 1x, '+hit.image_alt_lrg.replace('uc_product_list','picture_320_2x')+' 2x, '+hit.image_alt_lrg.replace('uc_product_list','picture_320_3x')+' 3x',
			}));
			*/
			$output.append($a.append($img.append($hover.append($picture))));

			let $productInfo = $('<div/>',{class:'product_info','data-love':hit.nid});
			//$productInfo.append($('<div/>',{class:'product_brand hidden-xs'}).text(hit.brand_name));
			$productInfo.append($('<div/>',{class:'product_title'}).append($('<a/>',{href:hit.url,'data-pnid':hit.nid}).text(hit.title)));
			// $productInfo.append($('<div/>',{class:'product_price'}).append(priceData.$sale_strike));
			$productInfo.append($('<div/>',{class:'product_colors hidden-xs'}).text((1?' + Colors':hit.swatches)));
			let $li = $('');
			$li.append($('<li/>',{class:'love'}).append($('<a/>',{class:'icon-heart-empty',href:'#','data-nid':hit.nid}).append($('<span/>'))));
			//$li.append($('<li/>',{class:'pinit'}).append($('<a/>',{href:'http://pinterest.com/pin/create/button/?media='+hit.image+'&amp;description='+hit.title+' | roveconcepts.com&amp;url='+hit.url,'data-width':750,'data-height':700})));
			$productInfo.append($('<div/>',{class:'love-info'}).append($('<div/>',{class:'love-bar'}).append($('<ul/>',{class:'love-social'}).append($li))));

			$output.append($productInfo);
			$output.prepend(priceData.$sale_msg);

			return $output;
		},

		templateReview: function(hit) {
			let $output = $('<div/>',{class:'views-row'});
			let $trustpilot = $('<div/>',{class:'trustpilot_review'}).append($('<meta/>',{itemprop:'itemReviewed',content:hit.products}));
			$trustpilot.append($('<div/>',{class:'rv_name'}).append($('<a/>',{href:hit.url,rel:'nofollow',target:'_blank'}).text(hit.name)));
			$trustpilot.append($('<h2/>',{class:'rv_title',itemprop:'author'}).text(hit.title));
			$trustpilot.append($('<h7/>',{class:'rv_time',itemprop:'datePublished'}).text(hit.date));
			let $reviewRate = $('<div/>',{class:'review_rate clearfix'});
			$reviewRate.append($('<span/>',{class:'stars large'}).append($('<span/>',{class:'rating',style:'width:'+((parseFloat(hit.rating)/5)*100)+'%;'})));
			$reviewRate.append($('<div/>',{class:'average_rating hide',itemprop:'reviewRating',itemscope:'',itemtype:'http://schema.org/Rating'}).append($('<span/>',{itemprop:'ratingValue'}).text(hit.rating)));
			$trustpilot.append($reviewRate);
			$trustpilot.append($('<div/>',{class:'rv_text',itemprop:'description'}).text(hit.review));
			$output.append($trustpilot);
			return $output;
		},

		templatePage: function(hit) {
			let $output = $('<div/>',{class:'page_item row'});
			let $img = $('<div/>',{class:'page_img col-xs-3'});
			$img.append($('<a/>',{href:hit.url}).append($('<img/>',{class:'img-responsive',src:hit.image_large})));
			$output.append($img);
			let $content = $('<div/>',{class:'page_content col-xs-9'});
			$content.append($('<h2/>').text(hit.title));
			$content.append($('<p/>').text(hit.content));
			$content.append($('<a/>',{href:hit.url,class:'page_link'}).text(hit.url));
			$output.append($content);
			return $output;
		},

		templatePhoto: function(hit) {
			let $output = $('<div/>',{class:'flowitem item sizeSm clearfix'});
			let $wrap = $('<div/>',{class:'item-wrapper'});
			$wrap.append($('<a/>',{href:'#item-'+hit.objectID,class:'free-img'}).append($('<img/>',{class:'img-responsive',src:hit.image_small})));
			let $details = $('<div/>',{class:'item-details'});
			$details.append($('<div/>',{class:'box'}).append($('<a/>',{href:'#item-'+hit.objectID,class:'cphoto cboxElement'}).append($('<div/>',{class:'slidein-text'}).text('Get the look'))));
			$wrap.append($details);
			$output.append($wrap);
			$output.append($('<div/>',{class:'inline-deets'}).append($('<div/>',{class:'deets-title'}).text(hit.name)).append($('<div/>',{class:'deets-location'}).text(hit.location)));
			let $item = $('<div/>',{class:'item-full-details',id:'item-'+hit.objectID});
			$item.append($('<div/>',{class:'col-xs-12 col-sm-7'}).append($('<img/>',{src:hit.image_medium,alt:'Image by '+hit.name})).append($('<div/>',{class:'well-30'}).append($('<div/>',{class:'row'}).append($('<div/>',{class:'item_desc col-xs-12 col-sm-8'}).append($('<p/>').text('@'+hit.name))))));
			let $look = $('<div/>',{class:'col-xs-12 col-sm-5'});
			$look.append($('<h1/>').text('Get the look'));

			let $photos = $('');
			if (hit.product_photos) {
				for (j = 0; j < hit.product_photos.length; ++j) {
					$photos.append($('<div/>',{class:'col-xs-12 col-sm-6'}).append($('<a/>',{href:hit.product_photos[j].url}).append($('<div/>',{class:'item_image'}).append($('<img/>',{src:hit.product_photos[j].image,alt:hit.product_photos[j].name}))).append($('<div/>',{class:'item_title'}).text(hit.product_photos[j].name))));
				}
			}
			$look.append($('<div/>',{class:'well-30'}).append($('<div/>',{class:'row'}).append($photos)));
			$output.append($item.append($look));
			return $output;
		},

		initAutoScroll: function() {
			/*
			let scrollPercent = 0.65;
			let scrollPoint = ($(document).height() - $(window).height()) * scrollPercent;
			let backTopScrollPoint = $(window).height() * 3;

			$(window).on('scroll',function() {
				let sTop = $(window).scrollTop();
				if (sTop > scrollPoint) {
					let $loadbtn = $cache.more_button.filter(':visible');
					if ($loadbtn.length > 0 && !$loadbtn.data('busy') && !app.ui.contentContainer.data('busy')) {
						app.ui.contentContainer.data('busy', true);

						app.search.loadProducts($loadbtn, $loadbtn.attr('href'));

						// update url so if a user comes back
						if (history.pushState) {
							let numitems =$cache.items.find('.product_listing').length;

							let newurl = app.util.appendParamsToUrl(location.href, {
								"lastViewed": (numitems + 1)
							});
							history.pushState({}, document.title, decodeURIComponent(newurl));
						}
					}
				}

				// no button
				if (sTop > backTopScrollPoint && !$cache.backToTop) {
					$cache.backToTop = $("<a/>", {
						"id": $cache.backTopID,
						"class": "hidden-xs hidden-sm",
						"html": app.resources.BACK_TO_TOP
					}).append($("<span/>", {
						"class": "ar-icon ar-icon-arrow-right-sm"
					})).appendTo('body').fadeIn();
				} else if (sTop > backTopScrollPoint && $cache.backToTop) {
					$cache.backToTop.fadeIn();
				} else if (sTop <= backTopScrollPoint && $cache.backToTop) {
					$cache.backToTop.fadeOut();
				}

			});

			$(document).on('heightChange', function() {
				setTimeout(function() {
					scrollPoint = ($(document).height() - $(window).height()) * scrollPercent;
					app.ui.contentContainer.data('busy', false);
				}, 5000);
			});

			$('body').on("click", "#" + $cache.backTopID, function(e) {
				e.preventDefault();

				$('html, body').animate({
					scrollTop: 0
				}, 400);
			});
			*/
		},

		/*
		loadProducts: function(button, url) {
			var $button = $(button);

			var lpEnablePromos = $button.data('enablepromos');
			var lpNumberOfPromos = $button.data('numpromos');
			var loader = $button.data('loader');

			if (lpEnablePromos && (lpNumberOfPromos > 1)) {
				url = url.replace('sz=17', 'sz=21');
			}

			if (lpEnablePromos && (lpNumberOfPromos <= 1)) {
				url = url.replace('sz=19', 'sz=21');
			}

			// Prevent multiple requests while processing
			if ($button.data('busy')) {
				return false;
			}

			$button.data('busy', true).hide().parent().append('<img src="' + loader + '" alt="loader" style="margin-left: 79px;"/>');

			$.get(url, function(e) {
				var $resultsDiv = $('<div/>');
				var $productsList = $('.search-result-content:last').find('ul.search-result-items');

				$resultsDiv[0].innerHTML = e;
				// Using jQuery occasionally fails in IE

				$('.loadmore').html($resultsDiv.find(".loadmore").html());

				var $newproducts = $resultsDiv.find(".search-result-content-container ul.search-result-items").html();

				$productsList.append($newproducts);

				if (window.innerWidth < 768) {
					setProductGrid();
				}

				$productsList.find("img.lazy").lazyload({
					effect: "fadeIn"
				}).removeClass("lazy");

				$(document).trigger('heightChange');

				// Clean up
				$button.data('busy', false).show().parent().find("img").remove();

				// Add mouse over events to all product images
				var $plpImages = $("body").find(".product-image img");
				app.product.tile.imgHover($plpImages);

				// rum beta
				//if (typeof mPtimer !== 'undefined'){ mPtimer.loaded(); }

			});

			return false;
		},

		mobileLoadProducts: function(button, url) {
			var $button = $(button);

			var loader = $button.data('loader');

			// Prevent multiple requests while processing
			if ($button.data('busy')) {
				return false;
			}

			$button.data('busy', true).hide().parent().append('<img src="' + loader + '" alt="loader" style="margin-left: 79px;"/>');

			$.get(url, function(e) {

				var $resultsDiv = $('<div/>');
				var $productsList = $('.search-result-content:last').find('ul');

				$resultsDiv[0].innerHTML = e;
				// Using jQuery occasionally fails in IE

				$('.loadmore').html($resultsDiv.find(".loadmore").html());

				var $newproducts = $resultsDiv.find(".search-result-content-container ul").html();

				$productsList.append($newproducts);

				setProductGrid();

				$productsList.find("img.lazy").lazyload({
					effect: "fadeIn"
				}).removeClass("lazy");

				// Product Listing: Remove clearfix from desktop site and remove 21st element from initial page load
				if ($('.search-result-items').length > 0) {
					var numitems = $('.search-result-items').children('li.grid-tile').length;
					if ($('.load_btn').is(':visible') && (numitems == 21 || numitems == 19 || numitems == 17)) {
						$('.search-result-items').children('li.grid-tile').last().remove();
					}
				}

				$(document).trigger('heightChange');

				// Clean up
				$button.data('busy', false).show().parent().find("img").remove();

				// rum beta
				//if (typeof mPtimer !== 'undefined'){ mPtimer.loaded(); }

			});

			return false;
		}
		*/
	};

}(window.app = window.app || {}, jQuery));
/*!
 * app.ui.components.js
 */

(function (app, rv, $) {

  var $cache = {
    isOnePageCheckout: true, // For now always false
    ytLoaded: false,
    ytVideosLoaded: [],
    wistiaLoaded: false,
    wistiaVideosLoaded: [],
    mulberryLoaded: false,
    mulberryCLID: '.mulberry_modal',
    mulberryLocal: true,
    mulberryDefaultWidth: '500px',
    mulberryDefaultHeight: '100%',
    mulberryInline: false,
    accountStaffRole: false,
    videosLoaded: [],
    affirm_settings: [],
    affirm_url: '',
    _affirm_config: '',
    affirm_submit_selector: '.payment-continue',
    paybright_settings: [],
    document: $(document),
    nextAutoScroll: null,  // for autoscrolling
    pagesLoaded: 1,   // for autoscrolling
    ytPlayer: null
  };

  function initializeEvents() {
    $cache.document.on('deviceChange', function () {
      $("[data-yt],[data-yt-mobile],[data-video],[data-video-mobile]").each(function () {
        app.components.reloadVideo($(this));
      });
    });

    $('.love-info .love-social li a, a.love-product').on('click', function (e) {
      e.preventDefault();
      let $this = $(this);
      if ($this.parent().hasClass('love') || $this.hasClass('love-product')) {
        //app.components.loveDo($this, $this.data('nid'), 'love', '');
        app.components.loveValidate($this, $this.data('nid'));
      }
    });

    if (app.getCountry() === 'KR') {
      $('.account-text p').html('내 계정');
      var html = $('.r-menu-info-wrap a[href="/cart"]').html().replace('My Bag', '장바구니').replace('items', '개');
      $('.r-menu-info-wrap a[href="/cart"]').html(html);
      $('.r-menu-info-wrap li:nth-child(4) a[href^="/user"]').html('내 계정');
      $('.r-menu-info-wrap a[href^="/wishlist"]').html('찜한 제품');
      $('.r-menu-info-wrap li:nth-child(5) a[href^="/user"]').html(Drupal.t('주문 내역'));
      $('.r-menu-info-wrap a[href="/user/logout"]').html(Drupal.t('로그아웃'));
    }

    // Login form 2FA
    $('#user-login-form').on('submit', function (e) {
      return;
      e.preventDefault();
      app.components.loginRoleCheck($('#user-login-form #edit-name').val())
        .then((data) => {
          if ($cache.accountStaffRole) {
            // TODO: Force entry
          } else {
            // Not needed TFA
          }
        })
        .catch((error) => {
          // Error trying to get TFA status
        });
    });

    $cache.mulberryOffers = $cache.document.find('#mulberry-offers');
    if ($cache.mulberryOffers.length) {
      $cache.mulberryOffers.on('click', '.mul-offer', function (e) {
        app.components.mulberrySelectOffer($(this));
      });
    }


  }

  function initializeDom() {
    $("[data-yt],[data-yt-mobile],[data-wistia],[data-wistia-mobile],[data-video],[data-video-mobile],[data-bunny],[data-bunny-mobile]").each(function () {
      app.components.loadVideo($(this));
    });

    /* COLORBOX Override */
    $cache.document.on({
      'cbox_complete': function () {
        // Affirm specific
        if ($('#colorbox').hasClass('financemodal')) {
          $('#cboxCurrent, #cboxSlideshow, #cboxPrevious, #cboxNext').addClass('element-invisible');
          $('#cboxLoadedContent, #cboxOverlay').off('mouseover');
        }
        $('#cboxClose').attr("aria-label", "close");
        $('#cboxNext').attr("aria-label", "next");
        $('#cboxPrevious').attr("aria-label", "previous");
        $('#cboxClose').html('<span class="icon-close"></span>').addClass('cbox-close-plain');
        $('#cboxTitle').hide();
      },
      'cbox_closed': function () {
        $('#cboxClose').removeClass('cbox-close-plain');
      }
    });

    app.components.lovePlacement();
  }

  app.components = {
    // For autoscroll
    autoScrollOptions: {
      containerSelector: '.autoscroller',
      nextSelector: 'a.next:last',
      loadFunction: 'app.components.loadItems',
      itemCallback: null,
      completeCallback: null,
      pagerCallback: null,
      maxPages: 5
    },
    autoScrollContainer: null,

    // If HLS is used
    hls: null,
    hlsVideo: null,

    mulberryModalUrl: '/ajax/uc_mulberry/modal',

    init: function () {

      initializeDom();
      initializeEvents();

      // Add videos to scroll event listener
      app.addEventListener('app.components.video', 'scroll');

      // lazy images
      app.components.lazyImages();

      // carousel
      app.components.carousel();

      // custom style selects
      //app.components.selectStyle();

      // tabs
      app.components.tabs();

      // vertical tabs
      app.components.verticalTabs();

      // uc_love
      app.components.love();

      // paybright
      app.components.paybright();

      // affirm
      app.components.affirm();

      // mulberry
      //app.components.mulberry();

      // product hover image replace
      app.components.hoverProduct();

      // Panel collapse
      app.components.panelCollapse();

      // Dropdowns
      app.components.dropdownToggle();

      // Brick Walls
      //app.components.brickWall();

      // Scroll to (data-scrollto="")
      app.components.scrollTo();

      // share
      app.components.share();

      // show/hide passwords
      app.components.passwordRevealToggle();

      //handle room filter with image
      $cache.roomCategoryImage = $cache.document.find('#room-filter #edit-room .filter-card');
      if ($cache.roomCategoryImage.length) {
        app.components.roomFilterWImage();
      }

      // Enable double member checkout
      if (app.isCheckoutPage()){
        $("body").addClass("double-member-opt-out");
      }

      //swipers
      if ($('.ar-swiper').length > 0) {
        $.each($('.ar-swiper'), function (index, value) {
          app.carousel.swiper($(this));
        });
      }

      // product accordian
      if ($('.products-item').length > 0) {
        app.carousel.buildProductSwiper('.products-item');
      }

      // Video play mobile fix
      //app.components.heroBannerFix();
    },



    heroBannerFix: function () {
      Object.defineProperty(HTMLMediaElement.prototype, 'playing', {
        get: function () {
          return !!(this.currentTime > 0 && !this.paused && !this.ended && this.readyState > 2);
        }
      });
      if ($('.highlighted video').get(0)) {
        $('body').on('click touchstart', function () {
          let videoElement = $('.highlighted video').get(0);
          $('body').append(videoElement.length);
          if (videoElement.playing) {
            // video is already playing so do nothing
          } else {
            // video is not playing
            // so play video now
            videoElement.play();
          }
        });
      }
    },

    scrollTo: function () {
      $('[data-scrollto]').on('click', function (e) {
        e.preventDefault();
        app.components.doScrollTo($(this).data('scrollto'), -40, 1000);
        return false;
      });
    },

    doScrollTo: function (ele, offset, speed) {
      var $ele = $(ele);
      $('html, body').animate({
        scrollTop: $ele.offset().top + offset
      }, speed);
    },

    roveLoader: function (selector) {
      let $dots = $('<div/>', {class: 'dots'});
      $(selector).prepend($('<div/>', {class: 'rove-loader'}).append($('<div/>', {class: 'loader-container'}).append($dots).append($dots).append($dots)));
    },

    loginRoleCheck: function (name) {
      $cache.accountStaffRole = false;
      return new Promise((resolve, reject) => {
        $.ajax({
          url: '/user/login/check-role',
          data: {name: name},
          method: 'POST',
          success: function (response) {
            $cache.accountStaffRole = response.check_role;
            resolve(response);
          },
          error: function (error) {
            $cache.accountStaffRole = false;
            reject(error);
          }
        });
      });
    },

    linkLoader: function ($ele) {
      let $past = $ele.clone();
      let key = Math.floor(Math.random() * 100) + ':' + Date.now();

      $ele.attr('data-ajaxremove', key);
      $past.attr('data-ajaxid', key);

      $past.html(app.ui.loadClick);
      $past.addClass('linkLoading').attr('disabled', 'disabled').off('click');
      $ele.addClass('hide').after($past);

      $ele.on('ajaxEnded', function () {
        // Find the clone and remove
        $(this).next().remove();


        //let key = $(this).attr('data-ajaxremove');
        //app.ui.contentContainer.find('[data-ajaxid="'+key+'"]').remove();

        //$past.remove();
        $(this).removeClass('hide').attr('data-ajaxremove', null);//.off('ajaxEnded');
      });
    },

    tabs: function () {
      $('[data-toggle=tab]').each(function () {
        $(this).on('click', function (e) {
          e.preventDefault();
          let $this = $(this);
          let $ele = $($this.attr('href'));
          $this.parents('ul').find('li.active').removeClass('active');
          $this.parents('li').addClass('active');
          $ele.parents('.tab-content').find('.tab-pane').removeClass('active').removeClass('in');
          $ele.addClass('active').addClass('in');
        });
      });
    },

    verticalTabs: function () {
      $('[data-toggle=vertical-tab]').each(function () {
        $(this).on('click', function (e) {
          e.preventDefault();
          let $this = $(this);
          if ($this.parents('li').hasClass('active')) {
            $this.parents('ul').find('li.active').removeClass('active');
          } else {
            $this.parents('ul').find('li.active').removeClass('active');
            $this.parents('li').addClass('active');
          }
        });
      });
    },

    panelCollapse: function () {
      $('a[data-toggle="collapse"]').on('click', function (e) {
        e.preventDefault();
        let $this = $(this);
        let target = $this.data('target') ? $this.data('target') : $this.attr('href');
        let parent = $this.data('parent') ? $this.data('parent') : false;
        if (parent !== false) {
          $(parent).find('.collapse.in').not(target).removeClass('in');
          $(parent).find('.collapsed.icon-negative').not($this).toggleClass('icon-negative icon-plus')
        }
        $(target).toggleClass('in');
        if ($this.hasClass('icon-plus') || $this.hasClass('icon-negative')) {
          $this.toggleClass('icon-plus icon-negative');
        }
      });
    },

    dropdownToggle: function () {
      $('.dropdown-toggle').on('click', function (e) {
        e.preventDefault();
        let $this = $(this);
        $this.attr('aria-expanded', function (_, attr) {
          return !attr
        });
        $this.toggleClass("open");
        $this.next('.dropdown-menu').toggleClass('open');
      });
    },

    brickWall: function (selector, columns = 3) {
      return Macy({
        container: selector,
        trueOrder: false,
        waitForImages: false,
        margin: 24,
        columns: columns,
        breakAt: {
          1200: 3,
          768: 2,
          767: 1
        }
      });
    },

    roomFilterWImage: function(){
      $cache.roomCategoryImageLoading = $cache.document.find('#room-filter .filter-loading');
        $cache.roomCategoryImage.on('click', function (e) {
          $cache.roomCategoryImage.removeClass('active');
          $(this).addClass('active');
          if($cache.roomCategoryImageLoading.length){
            let $loadingInterval = setInterval(function (){
              if ($(".filter-card .ajax-progress").length){
                $cache.roomCategoryImageLoading.addClass("active")
              } else {
                $cache.roomCategoryImageLoading.removeClass("active");
                clearInterval($loadingInterval);
              }
            }, 500)

          }
        });

        $cache.roomCategoryImageNav = $cache.document.find('#room-filter .carousel-nav button');
        if ($cache.roomCategoryImageNav.length) {
          $cache.roomCategoryImageNav.on('click', function (e) {
            if($(this).hasClass('next')){
              $("#edit-room").scrollLeft(1000);
            } else {
              $("#edit-room").scrollLeft(0);
            }
          });
        }


    },

    selectStyleDestroy: function ($element) {
      let $parent = $element.parent().parent();
      $element.prependTo($parent);
      $element.removeClass('select-hidden');
      $parent.find('.select').remove();
    },

    /* Styles <select> */
    selectStyle: function () {
      function refresh() {
        // detatch
        destroy();
        attachSelect();
      }

      function destroy() {
        $('select.select-hidden').each(function () {
          app.components.selectStyleDestroy($(this));
        });
      }

      // Build list items
      function buildList($ele, $list) {
        var i;
        for (i = 0; i < $ele.children('option').length; i++) {
          let opt = $ele.children('option').eq(i);
          $('<li />', {
            html: (typeof opt.data('subtext') !== 'undefined' ? opt.data('subtext') : '') + opt.text(),
            rel: opt.val(),
            class: opt.is(':selected') ? 'selected icon-check icon-right' : ''
          }).appendTo($list);
        }
        for (i = 0; i < $ele.children('optgroup').length; i++) {
          buildList($ele.children('optgroup').eq(i), $list);
        }
      }

      // Set the text of the replacement <select>
      function setElementInfo($ele, $selected, $multi, $clickElement) {
        let vals = $ele.val();
        if ($multi && vals) {
          let filtLen = vals.filter(String).length;
          if (filtLen > 1) {
            $selected.text(selDefaultText($ele) + ': ' + (filtLen) + ' selected').removeClass('active');
          } else if (filtLen === 1) {
            $selected.text($ele.find(':selected').text()).removeClass('active');
          } else {
            $selected.text(selDefaultText($ele));
          }
        } else if ($clickElement.length && !$multi) {
          $selected.text($clickElement.text()).removeClass('active');
        } else {
          $selected.text(selDefaultText($ele));
        }
      }

      // Move dropdown on click
      $(document).on('click', function () {
        $('div.select-styled').removeClass('active');
        $('ul.select-options').hide();
      });

      // Set default text
      function selDefaultText($this) {
        return $this.data('none-selected-text') ? $this.data('none-selected-text') : $this.children('option').eq(0).text();
      }

      function attachSelect() {
        // Attach to each select element
        $('select:not(".select-hidden")').each(function () {
          var $this = $(this), numberOfOptions = $(this).children('option').length;
          var $actionbox = $this.data('actions-box');
          var $multi = $this.prop('multiple');

          $this.addClass('select-hidden');
          $this.wrap('<div class="select"></div>');
          $this.after('<div class="select-styled transition"></div>');

          var $styledSelect = $this.next('div.select-styled');
          setElementInfo($this, $styledSelect, $multi, '');

          var $list = $('<ul />', {
            'class': 'select-options'
          }).insertAfter($styledSelect);
          buildList($this, $list);

          if ($actionbox || $this.data('none-selected-text')) {
            if ($this.find('option').first().val() === '') {
              $list.find('li').first().addClass('hide');
            }
            if ($actionbox) {
              $('<li />', {text: 'Clear', class: 'clear'}).appendTo($list);
            }
          }

          var $listItems = $list.children('li');

          $styledSelect.on('click', function (e) {
            e.stopPropagation();
            $('div.select-styled.active').not(this).each(function () {
              $(this).removeClass('active').next('ul.select-options').hide();
            });
            $(this).toggleClass('active').next('ul.select-options').toggle();
          });

          $listItems.on('click', function (e) {
            e.stopPropagation();
            var $clickElement = $(this);
            if ($clickElement.hasClass('clear')) {
              $styledSelect.text(selDefaultText($this));
              $this.val('');
              $this.find('li.selected').removeClass('selected');
            } else {

              if (!$multi) {
                $listItems.filter('.icon-check').toggleClass('selected').toggleClass('icon-check').toggleClass('icon-right');
                $this.val($clickElement.attr('rel'));


              } else {
                if ($clickElement.hasClass('selected')) {
                  $this.find('option[value="' + $clickElement.attr('rel') + '"]').prop("selected", false);
                } else {
                  $this.find('option[value="' + $clickElement.attr('rel') + '"]').prop("selected", true);
                }
                $this.find('li.selected').removeClass('icon-check').removeClass('icon-right');
              }
              $clickElement.toggleClass('selected').toggleClass('icon-check').toggleClass('icon-right');

              setElementInfo($this, $styledSelect, $multi, $clickElement);

            }
            $list.hide();
            $this.trigger('change');
          });
        });
      }

      // run
      attachSelect();
    },
    youtubeOnPlayerStateChange: function (event) {

    },
    youtubeOnReady: function (event) {
      event.target.mute();
      event.target.playVideo();

      if (!app.isIOS) {
        setTimeout(function () {
          $cache.youtubePlayer.unMute();
          $cache.youtubePlayer.setVolume(70);
        }, 500);
      }
    },
    youtubePlay: function (volume) {
      $cache.youtubePlayer.playVideo();
      if (volume) {
        $cache.youtubePlayer.setVolume(70);
      }
    },
    youtubeStop: function () {
      $cache.youtubePlayer.stopVideo();
    },
    youtubeCreatePlayer: function (videoId) {
      return new YT.Player($cache.youtubePlayerId, {
        videoId: videoId,
        host: 'https://www.youtube-nocookie.com',
        height: '100%',
        width: '100%',
        events: {
          'onReady': app.components.youtubeOnReady,
          'onStateChange': app.components.youtubeOnPlayerStateChange
        },
        playerVars: {
          playsinline: 1,
          autohide: 1,
          autoplay: 1,
          color: 'white',
          modestbranding: 1,
          enablejsapi: 1,
          controls: app.isIOS ? 1 : 1,
          iv_load_policy: 3,
          rel: 0
        }
      });
    },
    youtubeBindPlayer: function (playerId) {
      $cache.youtubePlayerId = playerId;
    },
    youtubeLoadVideoId: function (videoId) {
      let deferred = $.Deferred();

      if ($cache.youtubeReady && $cache.youtubePlayerId) {
        if ($cache.youtubePlayer && $cache.youtubePlayer.hasOwnProperty('loadVideoById')) {
          $cache.youtubePlayer.loadVideoById(videoId);
        }
      }

      deferred.resolve();
      return deferred.promise;
    },
    youtubeIsReady: function () {
      return $cache.youtubeReady;
    },
    youtubeLoad: function (videoId) {

      $cache.youtubePlayerId = null;
      $cache.youtubePlayer = null;
      $cache.youtubeReady = false;
      $cache.youtubePreloadVideoId = videoId;

      // Youtube callback when API is ready
      window.onYouTubeIframeAPIReady = function () {
        $cache.youtubePlayer = app.components.youtubeCreatePlayer($cache.youtubePreloadVideoId);
        $cache.youtubeReady = true;
      };

      app.components.youtubeBindPlayer('youtubePlayer');

      if (!$cache.youtubeLoaded) {
        $.getScript('//www.youtube.com/iframe_api');
      }
    },
    ytLoad: function () {
      if (!$cache.ytLoaded) {
        let tag = document.createElement('script');
        tag.src = "https://www.youtube.com/player_api";
        let firstScriptTag = document.getElementsByTagName('script')[0];
        firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);
        window.onYouTubePlayerAPIReady = function () {
          $cache.ytLoaded = true;
        };
      }
    },

    wistiaLoad: function () {
      if (!$cache.wistiaLoaded) {
        $.getScript('//fast.wistia.com/assets/external/E-v1.js', function (data, textStatus, jqxhr) {
          $cache.wistiaLoaded = true;
        });
      }
    },
    reloadVideo: function ($el) {
      if (!$el.attr('data-yt') && !$el.attr('data-yt-mobile')) {
        $el.empty();
      }
      app.components.loadVideo($el);
    },
    wistiaVid: function (videoid, type, height, components, img) {
      if (!components || !components.length) {
        components = 'videoFoam=true autoPlay=true silentAutoPlay=allow muted=true fullscreenButton=false playButton=false playbar=false smallPlayButton=false volumeControl=false controlsVisibleOnLoad=false';
      }
      let $script = $('<script/>', {src: '//fast.wistia.com/embed/medias/' + videoid + '.jsonp'});
      let $div = $('<div/>', {class: 'wistia_responsive_padding'}).addClass('ws_' + type);
      let $videoContainer = $('<div/>', {class: 'wistia_embed wistia_async_' + videoid + ' ' + components});
      $videoContainer.html('&nbsp;');
      if (img) {
        $videoContainer.addClass('stillUrl=' + img);
      }
      $div.append($('<div/>', {class: 'wistia_responsive_wrapper'}).css('style', 'height:' + height + ';').append($videoContainer));

      return $('<div/>').html($script).append($div);
    },
    ytVid: function (videoId, containerId, type, height, components, img) {
      // console.log("ytVid", videoId, $("iframe#" + containerId).length);
      // if ($("iframe#" + containerId).length !== 0) {
      //   console.log("test2", videoId);
      //   $cache.ytPlayer.loadVideoById(videoId);
      // } else {
      //   console.log("test", videoId);
      //
      // }

      window.onYouTubePlayerAPIReady = function () {
        $cache.ytPlayer = new YT.Player(containerId, {
          width: '100%',
          height: '120%',
          videoId: videoId,
          playerVars: {
            'autoplay': 1,
            'mute': 1,
            'controls': 0,
            'showinfo': 0,
            'modestbranding': 1,
            'loop': 1,
            'playlist': videoId,
            'fs': 0,
            'cc_load_policy': 0,
            'iv_load_policy': 3,
            'playsinline': 1,
            'rel': 0,
            'disablekb': 1
          },
          events: {
            'onReady': onPlayerReady,
            'onStateChange': onPlayerStateChange
          }
        });
      };

      function onPlayerReady(e) {
        e.target.mute();
        e.target.playVideo();
      }

      function onPlayerStateChange(e) {
        if (e.data === YT.PlayerState.PLAYING) {
          document.querySelector('.banner-inner picture').classList.add('has-video');
        }
      }
    },
    plyrVid: function (id, mp4, webm, img, type) { // Local js video player
      let $div = $('<div/>', {class: 'wistia_responsive_padding'}).addClass('ws_' + type);
      let $videoContainer = $('<video/>', {id: id, class: 'video', poster: img, playsinline: ''});
      $videoContainer.append($('<source/>', {src: mp4, type: 'video/mp4'}));
      $videoContainer.append($('<source/>', {src: webm, type: 'video/webm'}));
      $div.append($('<div/>', {class: 'wistia_responsive_wrapper'}).append($videoContainer));
      return $('<div/>').append($videoContainer);
    },
    jsVid: function (id, mp4, webm, img, type) { // Local js video player
      if (typeof videojs === 'undefined') {
        app.util.loadJScript('/sites/all/themes/rove2018/js/app.plugins.video.min.js', true);
      }
      let $div = $('<div/>', {class: 'wistia_responsive_padding'}).addClass('ws_' + type);
      //let $videoContainer = $('<video/>', {id:id,class: 'video-js',poster:img,controls:false,style:'width:100%;','data-setup':'{ "controls": false, "autoplay": true, "preload": "auto", "loop":true, "muted":true}'});
      let $videoContainer = $('<video/>', {
        id: id,
        class: 'video-js',
        poster: img,
        controls: false,
        style: 'width:100%;height:auto;',
        'data-setup': '{ "controls": false}'
      });
      $videoContainer.append($('<source/>', {src: mp4, type: 'video/mp4'}));
      //$videoContainer.append($('<source/>',{src: 'https://s3-us-west-2.amazonaws.com/rove-image-store/output/outputs/moviex.m3u8',type:'application/x-mpegURL'}));
      //$videoContainer.append($('<source/>',{src: webm,type:'video/webm'}));
      $div.append($('<div/>', {class: 'wistia_responsive_wrapper'}).append($videoContainer));
      return $('<div/>').append($div);
    },
    html5HLS: function ($element, id, m3u8, img, type) {
      img = img.replace('default/files', 'default/files/styles/picture_1024_2x/public');
      let vidRestarts = 0;
      let $div = $('<div/>', {class: 'wistia_responsive_padding'}).addClass('ws_' + type);
      let $videoContainer = $('<video/>', {
        id: id,
        class: 'video-bg',
        autoplay: 'autoplay',
        muted: 'muted',
        loop: 'loop',
        playsinline: 'playsinline',
        style: 'width:100%;height:auto;',
      });
      //let $img = $('<div/>',{tabindex:'-1','aria-disabled':false,style:'background-image: url('+img+');background-size:cover;width:100%;'});
      //$div.append($('<div/>', {class: 'wistia_responsive_wrapper'}).append($videoContainer).append($img));
      $div.append($('<div/>', {class: 'wistia_responsive_wrapper'}).append($videoContainer));
      $element.html($('<div/>').append($div).html());

      app.components.hlsVideo = document.getElementById(id);
      if (Hls.isSupported()) {

        app.components.hls = new Hls({
          startLevel: -1, xhrSetup: function (xhr, url) {
            //xhr.withCredentials = true; // do send cookie
            //xhr.setRequestHeader("Access-Control-Allow-Headers","Content-Type, Accept, X-Requested-With");
            xhr.setRequestHeader("Access-Control-Allow-Origin", "https://www.roveconcepts.com");
            //xhr.setRequestHeader("Access-Control-Allow-Credentials","true");
          }
        });
        app.components.hls.loadSource(m3u8);
        app.components.hls.attachMedia(app.components.hlsVideo);
        app.components.hls.on(Hls.Events.MANIFEST_PARSED, function (event, data) {
          app.components.hlsVideo.play();
        });
        app.components.hls.on(Hls.Events.MEDIA_ATTACHED, function () {
          const hlsFragments = [];
          app.components.hls.loadSource(m3u8);
          app.components.hls.on(Hls.Events.FRAG_LOADED, function (event, data) {
            hlsFragments.push(data.frag);
          });
          app.components.hls.on(Hls.Events.LEVEL_SWITCHED, function (event, data) {
            const fragmentLevels = hlsFragments.map(fragment => fragment.level);
            const maxLevel = fragmentLevels.reduce((max, cur) => Math.max(max, cur), 0);
            hlsFragments.map(function (fragment, index) {
              if (fragment.level < maxLevel) {
                app.components.hls.trigger(Hls.Events.BUFFER_FLUSHING, {
                  startOffset: fragment.startPTS,
                  endOffset: fragment.endPTS
                });
                hlsFragments.splice(index, 1);
              }
            });
            /*
            hlsFragments.map((fragment, index) => {
                if (fragment.level < maxLevel) {
                    app.components.hls.trigger(Hls.Events.BUFFER_FLUSHING, {startOffset: fragment.startPTS, endOffset: fragment.endPTS});
                    return hlsFragments.splice(index, 1);
                }
            });
            */
          });
        });
        app.components.hls.on(Hls.Events.ERROR, function (event, data) {
          if (data.fatal) {
            switch (data.type) {
              case Hls.ErrorTypes.NETWORK_ERROR: // app.components.hls.config.manifestLoadingMaxRetry = 1
                // try to recover network error
                vidRestarts++;
                console.log("fatal network error encountered, try to recover #" + vidRestarts);
                //app.components.hls.startLoad();

                app.components.hls.destroy();
                // append the picture instead...
                $('video#' + id).hide().after($('<img/>', {src: img, class: 'img-responsive'}));
                break;
              case Hls.ErrorTypes.MEDIA_ERROR:
                console.log("fatal media error encountered, try to recover");
                app.components.hls.recoverMediaError();
                break;
              default:
                // cannot recover
                app.components.hls.destroy();

                // append the picture instead...
                $('video#' + id).hide().after($('<img/>', {src: img, class: 'img-responsive'}));
                break;
            }
          }
          //console.log(data);
        });
      }
        // hls.js is not supported on platforms that do not have Media Source Extensions (MSE) enabled.
        // When the browser has built-in HLS support (check using `canPlayType`), we can provide an HLS manifest (i.e. .m3u8 URL) directly to the video element throught the `src` property.
      // This is using the built-in support of the plain video element, without using hls.js.
      else if (app.components.hlsVideo.canPlayType('application/vnd.apple.mpegurl')) {
        app.components.hlsVideo.src = m3u8;
        app.components.hlsVideo.addEventListener('canplay', function () {
          app.components.hlsVideo.play();
        });
      }
    },
    html5Vid: function (id, mp4, webm, img, type) {
      let $div = $('<div/>', {class: 'wistia_responsive_padding'}).addClass('ws_' + type);
      //let $videoContainer = $('<video/>', {id:id,class: 'video-js',poster:img,controls:false,style:'width:100%;','data-setup':'{ "controls": false, "autoplay": true, "preload": "auto", "loop":true, "muted":true}'});
      let $videoContainer = $('<video/>', {
        id: id,
        class: 'video-bg',
        autoplay: 'autoplay',
        muted: 'muted',
        loop: 'loop',
        style: 'width:100%;height:auto;'
      });
      $videoContainer.append($('<source/>', {src: mp4, type: 'video/mp4'}));
      //$videoContainer.append($('<source/>',{src: 'https://s3-us-west-2.amazonaws.com/rove-image-store/output-hls/Fall_Asher_Bed_Splash_Web.m3u8',type:'application/x-mpegURL'}));
      //$videoContainer.append($('<source/>',{src: webm,type:'video/webm'}));
      let $img = $('<div/>', {
        tabindex: '-1',
        'aria-disabled': false,
        style: 'background-image: url(' + img + ');'
      });
      $div.append($('<div/>', {class: 'wistia_responsive_wrapper'}).append($videoContainer).append($img));
      return $('<div/>').append($div);
    },
    loadVideo: function ($el) { // only works for carousel
      if ($el.attr('data-yt') || $el.attr('data-yt-mobile')) {
        app.components.loadYtVideo($el);
      } else if ($el.attr('data-wistia') || $el.attr('data-wistia-mobile')) {
        app.components.loadWistiaVideo($el);
      } else if ($el.attr('data-bunny') || $el.attr('data-bunny-mobile')) {
        app.components.loadBunnyVideo($el);
      } else {
        // Local video (carousel?)
        let video, img;
        img = $el.attr('data-video-img') ? $el.attr('data-video-img') : '';

        if (app.isMobile() || app.isiPad()) {
          if ($el.attr('data-video-mobile')) {
            video = $el.attr('data-video-mobile');
            img = $el.attr('data-video-mobile-img') ? $el.attr('data-video-mobile-img') : img;
          } else {
            return true;
          }
        } else {
          video = $el.data('video');
        }

        if (!video) {
          return true;
        }
        let id = 'vid_' + Math.random().toString(36).substr(2, 9);
        let type = $el.attr('data-video-type') ? $el.attr('data-video-type') : 'page';
        //$el.html(app.components.jsVid(id,video,video.replace('.mp4','.webm'),img,type).html());
        //$el.html(app.components.html5Vid(id,video,video.replace('.mp4','.webm'),img,type).html());
        app.components.html5HLS($el, id, video, img, type);
        $cache.videosLoaded.push(video);

        let autoplay = document.getElementById(id);
        autoplay.autoplay = true;
        autoplay.controls = false;
        autoplay.preload = 'auto';
        autoplay.responsive = true;
        autoplay.loop = true;
        autoplay.muted = true;
        autoplay.load();
        autoplay.play(); // Only for html5vid
        //let vid = videojs(id);
        //vid.play();
      }
    },
    loadBunnyVideo: function ($el) {
      let vidRestarts = 0;
      let $div = $('<div/>', {class: 'bunny-video-wrapper'});
      let $vid_id = (app.isMobile() || app.isiPad()) ? $el.data('bunny-mobile') : $el.data('bunny');

      var $iframe = $('<iframe>', {
        src: 'https://player.mediadelivery.net/embed/659083/'+$vid_id+'?autoplay=true&loop=true&muted=true&controls=false',
        id: 'bunny-video-frame',
        frameborder: 0,
        allow: 'autoplay; fullscreen; picture-in-picture',
        allowfullscreen: true,
        css: {
          'width': '100%',
          'height': '102%',
          'border': 'none',
          'transition': 'opacity 0.5s ease-in-out'
        }
      })

      $div.append($iframe);

      $el.html($('<div/>').append($div).html());


    },
    loadWistiaVideo: function ($el) {
      let video = (app.isMobile() || app.isiPad()) && $el.attr('data-wistia-mobile') ? $el.attr('data-wistia-mobile') : $el.data('wistia');
      if (!video) {
        return true;
      }

      if (!$cache.wistiaLoaded) {
        app.components.wistiaLoad();
      }

      let height = $el.attr('data-wisita-height') ? $el.attr('data-wisita-height') : '100%';
      let type = $el.attr('data-wistia-type') ? $el.attr('data-wistia-type') : 'page';
      let img = $el.attr('data-wistia-img') ? $el.attr('data-wistia-img') : '';
      $cache.wistiaVideosLoaded.push(video);

      //$el.html($script).append($div);
      $el.html(app.components.wistiaVid(video, type, height, '', img).html());
    },

    loadYtVideo: async function ($el) {
      let video = (app.isMobile() || app.isiPad()) && $el.attr('data-yt-mobile') ? $el.attr('data-yt-mobile') : $el.data('yt');
      let id = $el.attr('data-id');
      if (!video) {
        return true;
      }

      if (!$cache.ytLoaded) {
        await app.components.ytLoad();
      }

      let height = $el.attr('data-yt-height') ? $el.attr('data-yt-height') : '100%';
      let type = $el.attr('data-yt-type') ? $el.attr('data-yt-type') : 'page';
      let img = $el.attr('data-yt-img') ? $el.attr('data-yt-img') : '';
      $cache.ytVideosLoaded.push(video);

      //$el.html($script).append($div);
      app.components.ytVid(video, id, type, height, '', img);
    },

    // <picture data-loader="pictureLoader">
    lazyImg: function () {
      $('.lazy').Lazy({
        pictureLoader: function (element, response) {
          $(element).children().each(function () {
            $(this).attr('data-srcset') && ($(this).attr('srcset', $(this).attr('data-srcset')), $(this).removeAttr('data-srcset'))
          });
        }
      });
    },

    getLazy: function () {
      return $cache.lazyLoader;
    },
    lazyImages: function () {

      // lazy load images
      $cache.lazyLoader = new LazyLoad({
        elements_selector: ".lazy",
        effect: "fadeIn",
        class_loading: 'lazyLoading',
        callback_loaded: function (el) {
          $(el).trigger('lazyLoaded', {'element': $(el)});
        },
        callback_reveal: function (el) {
          $(el).removeAttr('data-srcset data-src data-sizes');
          $(el).removeClass('lazy');
        }
      });
    },
    set_trustpilot_rating_score: async function () {
      $.getJSON("https://api.trustpilot.com/v1/business-units/4ea54dc50000640005115832?apikey=ys68fk9bJnJGsB2B7lPIAhpPhcop0jWg",
        (r) => {
          $(".rating-score").html(r.numberOfReviews.total + " Reviews");
        }
      );
    },
    carousel: function () {

      app.components.carouselFront();
      app.components.carouselProductPage();
      app.components.carouselCollections();;
       app.components.carouselKayeConfig();
    },

    carouselFront: function(){
      let $carouselCont = $(".carousel-cont");
      if ($carouselCont.length <= 0) {
        return;
      }

      $carouselCont.find(".carousel-nav button").on("click", function(){
        let $carousel = $(this).parent().siblings(".carousel");
        let $carouselWidth = $carousel.width();
        let $carouselPos = $carousel.scrollLeft();
        if ($(this).hasClass("prev")){
          $carousel.scrollLeft($carouselPos - $carouselWidth);
        } else {
          $carousel.scrollLeft($carouselPos + $carouselWidth);
        }
      })
    },

    carouselCollections: function () {
      if (window.innerWidth <=700){
        let owl = $(".home-collections-list");
        if (owl.length <= 0) {
          return;
        }
        owl.addClass("owl-carousel");
        owl.owlCarousel({
          singleItem: true,
          items: 1,
          loop: true,
          margin: 0,
          autoplay: true,
          center: true,
          autoplayTimeout: 5000,
          autoplaySpeed: 1000,
          autoplayHoverPause: true,
          nav: false,
          dots: false
        });
      }



    },
    carouselProductPage: function () {


      let $press = $(".press-quote-cont.owl-carousel");
      if ($press.length > 0) {
        $press.owlCarousel({
          items:1,
          center: true,
          loop:true,
          margin:20,
          autoplay:true,
          autoplayTimeout:5000,
          autoplaySpeed: 1000,
          autoplayHoverPause:true,
          nav: true
        });
      }

      let $ugc = $(".customer-photos-cont.owl-carousel");
      if ($ugc.length > 0) {
        $ugc.owlCarousel({
          items: 4,
          margin:10,
          navText: ["<i class='fa fa-chevron-left'></i>","<i class='fa fa-chevron-right'></i>"],
          responsive: {
            0: {
              items: 1,
              slideBy: 1,
              margin:0,
              dots: true,
              nav: false
            },
            640: {
              items: 4,
              slideBy: 4,
              margin:10,
              dots: false,
              nav: true
            }
          }
        });
      }


      let $product_display = $('.block-uc-display .row');
      if ($product_display.length) {
        if (app.isMobile() || app.isiPad()) {
          $product_display.addClass('owl-carousel').owlCarousel({
            items: 1,
            loop: true,
            autoHeight: true,
            margin: 0,
            stagePadding: 0,
            responsive: {
              0: {
                items: 1,
              },
              768: {
                items: 2,
                loop: false,
                slideBy: 1
              }
            }
          });
        } else {
          $product_display.owlCarousel('destroy').removeClass('owl-carousel');
          /*
          jQuery('.block-uc-display .row').owlCarousel('destroy').removeClass('owl-carousel');
          jQuery('.block-uc-display .row').addClass('owl-carousel').owlCarousel({
            items: 1,
            loop: true,
              center: true
          });
          */
        }

        let $product_display1 = $('.block-uc-display#duvet-review-block .row');
        if ($product_display1.data('carousel')) {
          $product_display1.addClass('owl-carousel').owlCarousel({
            items: 1,
            loop: true,
            autoHeight: true,
            margin: 0,
            stagePadding: 0,
            responsive: {
              0: {
                items: 1,
              }
            }
          });
        } else {
          $product_display1.owlCarousel('destroy').removeClass('owl-carousel');
          /*
          jQuery('.block-uc-display .row').owlCarousel('destroy').removeClass('owl-carousel');
          jQuery('.block-uc-display .row').addClass('owl-carousel').owlCarousel({
            items: 1,
            loop: true,
              center: true
          });
          */
        }

        $(document).on('deviceChange', function () {
          app.components.carouselFront();
        });
      }
    },
    carouselKayeConfig: function(){
      let $custOwl = $(".kaye-config-img");
      if ($custOwl.length > 0) {
        $custOwl.owlCarousel({
          singleItem: true,
          items: 1,
          loop: true,
          autoplay: true,
          center: true,
          autoplayTimeout: 5000,
          autoplaySpeed: 1000,
          autoplayHoverPause: true,
          nav: true,
        });
      }

      var kayeObserver = new MutationObserver(function(mutations) {
        app.components.kayeConfigOnChange();
      });

      let obsEle = document.querySelector('.kaye-config-img .owl-stage');
      if (obsEle !== null) {
        kayeObserver.observe(obsEle, {characterData: true, subtree: true, childList: true, attributes: true});
      }
    },
    kayeConfigOnChange: function(){
      let $c = "." + $(".kaye-config-img .owl-item.active img").attr("data-class");
      $(".kaye-config-txt-cont ul li.active").removeClass("active");
      $(".kaye-config-txt-cont ul").children($c).addClass("active");
    },
    kayeConfig: function(i){
      $(".kaye-config-img").trigger('stop.owl.autoplay')
      $(".kaye-config-img").trigger('to.owl.carousel', i,0)
      app.components.kayeConfigOnChange();
    },
    hoverProduct: function () {
      $('.hover-fade:not(.hv)').each(function () {
        let $this = $(this);
        let flip = $this.hasClass('flip');
        let $path = $this.data('hover');
        if ($path) {
          let $productHover = $('<div/>', {class: 'product-hover'});
          let $ele = $this.find('picture, div[data-video]');
          let $img;
          switch ($ele.prop("tagName")) {
            case 'DIV':
              $img = $(this).find('picture');
              $img.html($img.html().replace(new RegExp(/public\/[a-zA-Z0-9_\s\-%\.]+?("|\s[0-9]+w)/, 'gi'), 'public/' + $path + '$1'));
              break;
            case 'PICTURE':
            default:
              $img = $ele.clone();
              //$img.html($img.html().replace(/public\/.+?"/gi, 'public/' + $path + '"'));
              $img.html($img.html().replace(new RegExp(/public\/[a-zA-Z0-9_\s\-%\.]+?("|\s[0-9]+w)/, 'gi'), 'public/' + $path + '$1'));
              break;
          }
$productHover.append("<div class='product-hover-cta'>Add to Cart</div>");
          if (flip) {
            $productHover.append($this.find('picture'));
            $this.append($img);
            $this.append($productHover);
          } else {
            $productHover.append($img);
          }

          $this.addClass('hv');
          $this.append($productHover);
        }
      });
      $cache.lazyLoader.update();
    },
    hoverFlip: function () {
      $('.product_listing .product_image').each(function () {
        app.components.hoverFlipListing($(this));
      });

      $(document).on('lazyLoaded', '.product_listing .product_image', function () {
        app.components.hoverFlipListing($(this));
      });
    },

    hoverFlipListing: function ($this) {
      if ($this.hasClass('flipped')) {
        return;
      }
      let appLoaded = $('html').hasClass('roveApp-processed');
      let one = $this.find('picture:first img');
      let two = $this.find('.product-hover img');

      if (appLoaded && two) {
        // Already processed
        $this.find('picture:first img').remove();
        $this.find('picture:first').append(two);
        $this.find('.product-hover img').remove();
        $this.find('.product-hover picture').append(one);
      } else {
        let prevImg = $this.data('hover');
        let path = one.match(new RegExp(/public\/[a-zA-Z0-9_\s\-%\.]+?"/, 'gi'))[0].replace('public/', '');
        let oneClone = one.clone();
        oneClone.html(oneClone.html().replace(new RegExp(/public\/[a-zA-Z0-9_\s\-%\.]+?("|\s[0-9]+w)/, 'gi'), 'public/' + prevImg + '$1'));
        one.replaceWith(oneClone);
        $this.data('hover', path);
      }
      $this.addClass('flipped');
    },

    love: function () {
      // Get all nid data on page and add selected
      $("[data-love]").each(function (i) {
        let nid = $(this).data('love');
        if (typeof Drupal.settings.uc_love !== 'undefined' &&
          typeof Drupal.settings.uc_love.user[nid] !== 'undefined' &&
          parseInt(Drupal.settings.uc_love.user[nid]) === nid) {
          $(this).find('.love a, a.love-product').addClass('selected');
        }
      });
    },
    loveValidate: function (element, nid) {
      let email_submit = false;
      let $element = $(element);
      $element.addClass('spin');
      if ($element.hasClass('blog-like')) {
        app.components.loveDo($element, parseInt(nid), 'love', '', 0);
        return;
      }

      Promise.resolve($.ajax({
        url: '/uc_love/ajax_validate',
        dateType: 'json',
        method: 'GET'
      })).then(function (response) {
        if (response.validate && response.html) {
          $.colorbox({
            height: '350px', width: '690px', maxWidth: '95%', opacity: 0.35,
            html: response.html,
            onComplete: function () {
              $element.removeClass('spin');
              $('input[name="love_email"]').on('focus', function () {
                if ($('input[name="love_email"]').val() === 'Email Address') {
                  $('input[name="love_email"]').val('');
                }
              });
              $('#love_email_sbmit').on('hover', function () {
                $('#love_email_sbmit').css('background-color', '#333333');
                $('#love_email_sbmit').css('color', '#fff');
              }, function () {
                $('#love_email_sbmit').css('background-color', '#fff');
                $('#love_email_sbmit').css('color', '#333');
              });
              $('#love_email_sbmit').on('click', function () {
                var email = $('[name="love_email"]').val();
                var subscribe = $('.checkbox [name="subscribe"]').val();
                if (app.validator.validateEmail(email)) {
                  app.components.loveDo(element, nid, 'love', email, subscribe);
                  email_submit = true;
                  $.colorbox.close();
                } else {
                  $('#error_msg').html('<span style="color:red;"> Please enter a valid email address.</span>');
                }
              });

            },
            onClosed: function () {
              if (!email_submit) {
                app.components.loveDo(element, nid, 'love', '', 0);
              }

            }
          });

        } else {
          app.components.loveDo(element, nid, 'love', '', 0);
        }
      }).catch(function (reason) {
        console.log('Ajax/Promise error on loving validation', reason);
      });
    },
    loveDo: function (element, nid, op, email, subscribe) {
      let $ele = $(element);
      Promise.resolve($.ajax({
        url: '/uc_love/ajax',
        data: {op: op, nid: nid, email: email, subscribe: subscribe},
        dateType: 'json',
        method: 'GET'
      })).then(function (response) {
        $ele.toggleClass('selected');
        if ($ele.hasClass('blog-like')) {
          $ele.find('span').html(response.cnt + ' Likes');
        } else {
          $ele.find('span').html(response.cnt);
          $("[data-love='" + nid + "']").find('.love-social>span').html(response.cnt);
        }

        let $usrCnt = $('.uc_love_user_cnt');
        if ($ele.hasClass('selected') && !$(element).hasClass('blog-like')) {
          $usrCnt.html(parseInt($usrCnt.html()) + 1);
          if (typeof $ele.data('on') !== 'undefined') {
            $ele.html($ele.data('on'));
          }
          $(document).trigger('wishlist', ['add', nid, op, email, $ele]);
        } else {
          $usrCnt.html(parseInt($usrCnt.html()) - 1);
          if (typeof $ele.data('off') !== 'undefined') {
            $ele.html($ele.data('off'));
          }
          $(document).trigger('wishlist', ['remove', nid, op, email, $ele]);
        }
        // Track API
        //if (typeof $(document).segmentApi !== "undefined" && typeof data.item !== "undefined") {
        //	if ($.isFunction($(window).segmentApi)) {
        //		$(document).segmentApi({op: 'wishlist',action: (!$(element).hasClass('selected')?'add':'remove'),data: data.item});
        //	}
        //}
      }).catch(function (reason) {
        console.log('Ajax/Promise error on loving', reason);
      });
    },
    disclaimerPopup: function(campaign="General"){

     let $data = [
       {
         campaign: "General",
         copy: {
          title: "Terms & Conditions",
          body: "<p>By entering your email, you agree to receive our newsletter about new arrivals, sales, and promotions. You can unsubscribe at any time. View our privacy policy here. For California residents, see our Notice of Financial Incentives.</p>"
        }
       },{
         campaign: "John Legend",
         copy: {
           title: "Terms & Conditions",
           body: "<p>NO PURCHASE NECESSARY TO ENTER OR WIN.<br>By entering your email, you agree to receive our newsletter about new arrivals, sales, and promotions. You can unsubscribe at any time. View our privacy policy here. Contest ends at 11:59 a.m. PST on September 2, 2024.</p>"
         }
       }
     ];

      var $filteredData = $data.filter(function (el) {
        return el.campaign == campaign
      });

      let $sizeWidth = $(window).width() < 400 ? ($(window).width() - 20) : 400;
      let $sizeHeight = $sizeWidth < 400 ? 350 : 260;

      $.colorbox({
        position: "fixed",
        width: $sizeWidth + "px",
        height: $sizeHeight + "px",
        maxWidth: '100%',
        opacity: 1,
        inline: false,
        html: "<div class='disclaimer-popup'><h2>"+$filteredData[0].copy.title+"</h2><div class='disclaimer-popup-cont'>"+$filteredData[0].copy.body+"</div></div>",
        onOpen: function () {
          $('body').css('overflow', 'hidden');
        },
        onClosed: function () {
          $('body').css('overflow', 'auto')
        }
      });

    },
    memberInfo: function () {
      $(".product-membership-cont").on("click", function () {
        app.components.memberInfoModal();
      })
    },

    mulberry: function () {
      if (typeof Drupal.settings.mulberry !== 'undefined' &&
        (!Drupal.settings.mulberry.exclude || typeof Drupal.settings.mulberry.order_id !== 'undefined')) {
        if (typeof $cache.mulberryLoaded === 'undefined' || !$cache.mulberryLoaded) {
          app.components.mulberrySetup();
        }
      }
    },
    mulberrySelectOffer: function (offerId) {
    },
    mulberryModalOpen: function () {
      let data = {ajax: 1, hide_title: 1};
      if (typeof Drupal.settings.product !== 'undefined') {
        data.product = {
          nid: Drupal.settings.product.nid,
          model: app.product.getSelectedModel(app.product.getSelectedOptions())
        };
      } else {
        app.components.mulberryModalUrl = '/ajax/uc_mulberry/modal-checkout/' + Drupal.settings.mulberry.order_id;
      }
      $.colorbox({
        //?width=95%&amp;maxwidth=820&amp;inline=true&amp;fixed=true
        width: $cache.mulberryDefaultWidth,
        maxWidth: '100%',
        maxHeight: '100%',
        opacity: 0.35,
        height: $cache.mulberryDefaultHeight,
        inline: false,
        href: app.components.mulberryModalUrl,
        data: data,
        onComplete: function () {
          $('#colorbox').css('position', 'fixed').css('top', '');
          $("body").css('overflow', 'hidden');
          $('.mul-item-container .mul-item-container__title-container').on('click', function () {
            $(this).parent().toggleClass('active');
            $(this).find('.icon').toggleClass('icon-plus icon-negative');
          });
          $('.faqLink').on('click', function () {
            $('#mulberry_warranty').fadeOut(function () {
              $('.mul-faqs-container').removeClass('hide').fadeIn();
            });
          });
          $('.mul-faqs-header__label').on('click', function () {
            $('.mul-faqs-container').fadeOut(function () {
              $(this).addClass('hide');
              $('#mulberry_warranty').fadeIn();
            });
          });
        },
        onCleanup: function(){
          $("body").css('overflow', 'scroll');
        }
      });

      // Track the click
      if (typeof app.tracking !== 'undefined') {
        app.tracking.track('mulberryView');
      }
    },
    mulberryModal: function (params) {
      // Prepare html
      let low = 999999;
      if (params.hasOwnProperty('override_order_charge') && params.override_order_charge) {
        low = params.override_order_charge_term_3;
      } else {
        // find lowest offer
        Object.keys(params.offers).forEach(item => {
          if (params.offers[item].cost !== null) {
            low = Math.min(params.offers[item].cost, low);
          }
        });
      }

      if (low > 0 && low !== 999999) {
        $('.shipping-info').after($('<div>', {class: 'mulberry-inline-container'})
          .html(app.components.mulberryInlineTemplate(low))
          .append(app.components.mulberryInlineTemplateLegacy(low)));
        // $('.mulberry-inline-container').html(app.components.mulberryInlineTemplate(low));
        // $('.mulberry-inline-container').html($('<a>', {href: '#'}).text('Accident Protection from only $' + app.util.number_format(low, 2, '.', '')));
        $('.mulberry-inline-container a').on('mousedown', app.components.mulberryModalOpen);
      }
      /*
      app.util.bindFirst($($cache.mulberryCLID),'mousedown',(e) => {
          e.preventDefault();
          app.components.mulberryModalOpen();
      });
      */
    },
    mulberryInlineTemplate: function (price) {
      return $('<a>', {class: 'mulberry-inline-wrap', href: '#'})
        .append($('<div>', {class: 'mulberry-header-cont'})
          .append($('<div>', {class: 'mulberry-title'})
            .append($('<img>', {src: './svg/shield-w-check-orange.svg', alt: ''}))
            .append($('<p>', {}).text('Accident Protection'))
          )
          .append($('<p>', {}).html('from $' + app.util.number_format(price, 2, '.', '')))
        )
        .append($('<hr>'), {})
        .append($('<div>', {class: 'mulberry-inline-data'})
          .append($('<p>', {})
            .text('Covers accidental damage, spills, mechanical failures, and more. Hassle-free claims process.')
          )
          .append($('<p>', {class: 'learn-more-btn'})
            .text('Learn more')
            .append($('<img>',{src: 'https://cdn.roveconcepts.com/sites/default/files/images/icon-arrow-right.png', alt: ''}))
          )
        )
    },
    mulberryInlineTemplateLegacy: function (price) {
      return $('<div>', {class: 'mulberry-inline-wrap'})
        .append($('<div>', {class: 'mulberry-inline-img'})
          .append($('<img>', {
            src: '//cdn.roveconcepts.com/sites/default/files/images/bone-shield-rove.png',
            width: 30,
            alt: "Accident Protection Icon"
          })))
        .append($('<div>', {class: 'mulberry-inline-data'})
          .append($('<a>', {href: '#'})
            .text('Accident Protection').append($('<span>', {}).html('from $' + app.util.number_format(price, 2, '.', ''))))
          .append($('<p>', {})
            .text(app.isiPadAndSmallerInit ? 'Protect again stains, rips & more' : 'Accident Protection Plans protect against stains, rips & more'))
        );
    },
    mulberryNotice: function (params) {
      app.components.mulberryModal(params);
    },
    mulberryGetOffers: function (products) {
      return new Promise(function (resolve, reject) {
        jQuery.ajax({
          url: '/ajax/uc_mulberry',
          data: products,
          dateType: 'json',
          method: 'POST'
        }).done(function (response) {
          resolve(response);
        })
      });
    },
    mulberrySetup: function () {
      $cache.mulberryLoaded = !0;

      if (typeof Drupal.settings.product !== 'undefined') {
        async function initializeMulberry() {
          await app.components.mulberryGetOffers({
            title: Drupal.settings.product.title,
            id: Drupal.settings.product.nid,
            model: app.product.getSelectedModel(app.product.getSelectedOptions())
            //price:app.util.number_format(parseFloat(Drupal.settings.product.sell_price)-parseFloat(Drupal.settings.product.sale_amount),2,'.','')
          }).then(function (response) {
            app.components.mulberryNotice(response);
            return response;
          }).catch(function (e) {
            console.log('Ajax/Promise error on mulberry', e)
          });
        }

        initializeMulberry()
      }

      // Colorbox popup for checkout
      $('.colorbox-mulberry').on('click', function (e) {
        e.preventDefault();
        // Override the Modal URL since we are on checkuot
        //app.components.mulberryModalUrl = '/ajax/uc_mulberry/modal-checkout/'+Drupal.settings.mulberry.order_id;
        if (!app.isMobile()) {
          $cache.mulberryDefaultWidth = '800px';
          $cache.mulberryDefaultHeight = '550px';
        } else {
          $cache.mulberryDefaultWidth = '100%';
          $cache.mulberryDefaultHeight = '550px';
        }
        app.components.mulberryModalOpen();
      });
    },
    memberInfoModal: function () {
      // let data = {ajax:1,hide_title:1};
      let $sizeWidth = $(window).width() < 650 ? $(window).width() - 40 : 650;
      let $sizeHeight = $(window).width() < 620 ? $(window).height() - 100 : 620;
      let memberFee = Drupal.settings.memberFee ? Drupal.settings.memberFee : 200;
      let memberDiscount = Drupal.settings.memberDiscount ? Drupal.settings.memberDiscount : 0.25;
      let voucherRate = Drupal.settings.voucherRate ? Drupal.settings.voucherRate : 0.1;
      let voucherType = Drupal.settings.voucherType ? Drupal.settings.voucherType : 'rate';
      let voucherAmtPer = Drupal.settings.voucherAmtPer ? Drupal.settings.voucherAmtPer : 0;
      let voucherMax = Drupal.settings.voucherMax ? Drupal.settings.voucherMax : "500";
      let locationCA = $("body.location-ca").length > 0;
      let locationHK = $("body.location-hk").length > 0;
      let currency = "$";
      if (locationCA) {
        currency = "C$";
      } else if (locationHK){
        currency = "HK$";
      };
        voucherString = voucherType === 'rate' ? parseInt(voucherRate * 100) + "% back in voucher*" : "$"+ parseInt(voucherRate) + " per $" + parseInt(voucherAmtPer) + " spent back in voucher*";
      let html = "<div class='member-info-cont'>" +
          "<div class='member-info-bg'></div>" +
          "<div class='member-info-main'>" +
          "<div class='member-info-title-cont'><h2 class='member-info-title'>Rove Members Program</h2></div>" +
          "<div class='member-benefits'>" +
          "<p class='first'>For " + currency + memberFee + "* annually, member benefits include:</p>" +
          "<div class='member-benefit'>" +
          "<div class='benefit-check'></div>" +
          "<p class='benefit'>25% off sitewide for an entire year</p>" +
          "</div>" +
        "<div class='member-benefit'>" +
        "<div class='benefit-check'></div>" +
        "<p class='benefit'>Up to 20% spent back in voucher*</p>" +
        "</div>";

        if (!locationHK){
        html+= "<div class='member-benefit'>" +
          "<div class='benefit-check'></div>" +
          "<p class='benefit'>Complimentary design consultation.</p>" +
          "</div>";
      }
       html+=  "<div class='member-benefit'>" +
         "<div class='benefit-check'></div>" +
         "<p class='benefit'>Dedicated concierge order service.</p>" +
         "</div>" +
         "<div class='member-benefit'>" +
         "<div class='benefit-check'></div>" +
         "<p class='benefit'>VIP access to sales events.</p>" +
         "</div>" +
         "</div>" +
         "<p class='member-note'>";
        if (memberDiscount > 0.3 || voucherRate > 0.1){
          html += "<span style='color: var(--red);'><strong style='color: var(--red);'>CURRENT OFFER:</strong><br>Members save <s>25%</s> <strong style='color: var(--red);'>"+memberDiscount*100+"%</strong> sitewide + <s>10%</s> <strong style='color: var(--red);'>"+ voucherRate*100 +"</strong> back in voucher.<br>*Limited-time only. Standard member benefits apply after.</span><br><br>";

        }
      html+= "Join our members program <a style='color: var(--gray); font-weight: bold; text-decoration: underline;' href='/user/membership/enroll/login?register=1' target='_blank'>here</a> or at checkout.<br>*Voucher cap at " + currency + voucherMax + "<br>*Promotional offer.</p>" +
         "</div></div>";

      const now = Math.floor(Date.now() / 1000); // current time in seconds (like REQUEST_TIME)

      if (now > 1756509000 && now < 1756796400) {
        html = "<div class='member-info-cont'>" +
            "<div class='member-info-bg'></div>" +
            "<div class='member-info-main'>" +
            "<div class='member-info-title-cont'><h2 class='member-info-title'>Rove Members Program</h2></div>" +
            "<div class='member-benefits'>" +
            "<p class='first'>For " + currency + memberFee + "* annually, member benefits include:</p>" +
            "<div class='member-benefit'>" +
            "<div class='benefit-check'></div>" +
            "<p class='benefit'>25% off sitewide for an entire year</p>" +
            "</div>" +
            "<div class='member-benefit'>" +
            "<div class='benefit-check'></div>" +
            "<p class='benefit'>" + voucherString + "</p>" +
            "</div>";

        if (!locationHK){
          html+= "<div class='member-benefit'>" +
              "<div class='benefit-check'></div>" +
              "<p class='benefit'>Complimentary design consultation.</p>" +
              "</div>";
        }

        html+=  "<div class='member-benefit'>" +
            "<div class='benefit-check'></div>" +
            "<p class='benefit'>Dedicated concierge order service.</p>" +
            "</div>" +
            "<div class='member-benefit'>" +
            "<div class='benefit-check'></div>" +
            "<p class='benefit'>VIP access to sales events.</p>" +
            "</div>" +
            "</div>" +
            "<p class='member-note' style='color:darkred;'>Labor Day Sale Offer: Members save <s>25%</s>&nbsp;30% + <s>10%</s>&nbsp;20% back in voucher until Sept.1</p>" +
            "<p class='member-note'>Join our members program <a style='color: var(--gray); font-weight: bold; text-decoration: underline;' href='/user/membership/enroll/login?register=1' target='_blank'>here</a> or at checkout.<br>*Voucher cap at " + currency + voucherMax + "<br>*Promotional offer.</p>" +
            "</div></div>";
      }

      $.colorbox({
        //?width=95%&amp;maxwidth=820&amp;inline=true&amp;fixed=true
        width: $sizeWidth + "px",
        maxWidth: '100%',
        maxHeight: '100%',
        opacity: 0.35,
        height: $sizeHeight + "px",
        inline: false,
        // href: app.components.mulberryModalUrl,
        // data: data,
        html: html,
        onComplete: function () {
          $('#colorbox').css('position', 'fixed').css('top', ($(window).height() - $sizeHeight) / 2 + "px");
          $("body").css('overflow', 'hidden');
        },
        onCleanup: function(){
          $("body").css('overflow', 'scroll');
        }
      });
    },
    timingInfoModal: function () {
      // let data = {ajax:1,hide_title:1};
      let $sizeWidth = $(window).width() < 370 ? $(window).width() : 370;
      let $sizeHeight = 280;
      $.colorbox({
        width: $sizeWidth + "px",
        maxWidth: '100%',
        maxHeight: '100%',
        opacity: 0.35,
        height: $sizeHeight + "px",
        inline: false,
        html: "<div class='checkout-timing-modal'><div class='timing-modal-cont'><div><h4>Your checkout is about to expire.</h4><p>Your checkout will expire in 5 minutes for the security purposes. Please continue with purchase or checkout will refresh. </p></div><div class='btn primary-btn'>OK</div></div></div>",
        onComplete: function () {
          $('#colorbox').css('position', 'fixed').css('top', ($(window).height() - $sizeHeight) / 2 + "px");
        }
      });
      $(".timing-modal-cont .btn").on("click", function () {
        $("#cboxClose").trigger("click")
      })
    },
    hostListingPopup: function (info) {
      // let data = {ajax:1,hide_title:1};
      let $sizeWidth = $(window).width() < 500 ? ($(window).width() - 20) : 600;
      let $sizeHeight = $(window).height() - 40;
      let $products = "";
      let $img = "";
      let $url = info.url ? info.url : "https://airtable.com/shrUmSMoHOJgUOHrM";

      let hidden_filter = '';
      switch (app.searchbar.country) {
        case 'US':
          hidden_filter = '["usa_hide=0"]';
          break;
        case 'CA':
          hidden_filter = '["canada_hide=0"]';
          break;
        default:
          hidden_filter = '["' + app.searchbar.country.toLowerCase() + '_hide=0"]';
          break;
      }

      info.products.forEach((o) => {
        if (typeof o === "object"){
          let $productUrl = o.name.toLowerCase().split(' ').join('-');
          $products += ("<a class='host-product-card' href='" + $productUrl + "'><img class='host-product-card-image' src='https://cdn.roveconcepts.com/sites/default/files/styles/uc_product_list/public/"+o.image+"' alt='"+o.name+"'/><div class='host-product-card-copy-cont'><div class='host-product-card-title'>" + o.name + "</div><div class='host-product-card-config'>"+o.option+"</div></div></a>");
        } else {
          let $title = o.indexOf(" - ") > 0 ? o.substring(0, o.indexOf(" - ")) : o;
          let $config = o.indexOf(" - ") > 0 ? o.substring(o.indexOf(" - ") + 3) : "";
          let queries = [{
            indexName: 'products',
            query: $title,
            params: {
              hitsPerPage: 1,
              numericFilters: hidden_filter
            }
          }];
          app.searchbar.client.search(queries, (err, content) => {
            if (content.results[0].hits.length>0){
              $products += ("<a class='host-product-card' href='" + content.results[0].hits[0].url + "'><img class='host-product-card-image' src='"+content.results[0].hits[0].image_category_lrg+"' alt='"+o+"'/><div class='host-product-card-copy-cont'><div class='host-product-card-title'>" + $title + "</div><div class='host-product-card-config'>"+$config+"</div></div></a>");
            }
            // $productImg += '<div class="product-img-frame" style="background-image: url(' + $url + ')"></div>'
          });
        }
      })

      for (let i = 1; i <= info.imgCount; i++) {
        let $url = "https://cdn.roveconcepts.com/sites/default/files/images/rove-host/" + info.fname + "-" + info.lname + "/host-" + info.fname + "-" + info.lname + "-" + i + ".jpg";
        $img += '<img class="img-frame owl-lazy" data-src="' + $url.toLocaleLowerCase() + '" alt="Host'+ info.fname + ' ' + info.lname +' image"/>';
      }


        $.colorbox({
          position: "fixed",
          width: $sizeWidth + "px",
          height: $sizeHeight + "px",
          maxWidth: '100%',
          opacity: 1,
          inline: false,
          html: "<div class='host-listing-modal'><div class='host-listing-modal-img-cont skeleton-loading'></div><div class='host-listing-modal-right'> <p class='host-modal-name'>" + info.fname + " " + info.lname + "'s Home</p><div class='host-product-cont'><div class='host-product-card'><div class='host-product-card-image skeleton-loading'></div><div class='host-product-card-copy-cont'><div class='host-product-card-title skeleton-loading'></div><div class='host-product-card-config skeleton-loading'></div></div></div><div class='host-product-card'><div class='host-product-card-image skeleton-loading'></div><div class='host-product-card-copy-cont'><div class='host-product-card-title skeleton-loading'></div><div class='host-product-card-config skeleton-loading'></div></div></div><div class='host-product-card'><div class='host-product-card-image skeleton-loading'></div><div class='host-product-card-copy-cont'><div class='host-product-card-title skeleton-loading'></div><div class='host-product-card-config skeleton-loading'></div></div></div><div class='host-product-card'><div class='host-product-card-image skeleton-loading'></div><div class='host-product-card-copy-cont'><div class='host-product-card-title skeleton-loading'></div><div class='host-product-card-config skeleton-loading'></div></div></div></div></div></div>",
          onOpen: function () {
                  $('body').css('overflow', 'hidden');
                },
                onClosed: function () {
                  $('body').css('overflow', 'auto')
                }
        });

      setTimeout(function(){
        $.colorbox({
          position: "fixed",
          width: $sizeWidth + "px",
          height: $sizeHeight + "px",
          maxWidth: '100%',
          maxHeight: '900px',
          opacity: 1,
          inline: false,
          html: "<div class='host-listing-modal'><div class='host-listing-modal-img-cont owl-carousel'>" + $img + "</div><div class='host-listing-modal-right'><div class='host-listing-modal-copy'><p class='host-modal-name'>" + info.fname + " " + info.lname + "'s Home</p><a href='"+$url+"' target='_blank'>Connect Virtually</a></div><div class='host-product-cont'>" + $products + "</div></div></div>",
          onComplete: function () {
            $('#colorbox').css('position', 'fixed').css('top', ($(window).height() - $sizeHeight) / 2 + "px");
          },
          onOpen: function () {
            $('body').css('overflow', 'hidden');
          },
          onClosed: function () {
            $('body').css('overflow', 'auto')
          }
        });

        $(".host-listing-modal-img-cont.owl-carousel").owlCarousel({
          items: 1,
          center: true,
          dots: true,
          nav: true,
          lazyLoad:true,
          loop:true,
          navText: ["<img src='/svg/chevron-right.svg' alt=''>","<img src='/svg/chevron-right.svg' alt=''>"]
        });

      }, 1000)


    },

    ugcPopup: function (info) {
      // let data = {ajax:1,hide_title:1};
      let $sizeWidth = $(window).width() < 500 ? ($(window).width() - 20) : 480;
      let $sizeHeight = $(window).height() < 650 ? $(window).height() - 160 : 800;
      let $products = "";
      let $img = "<img class='as-seen-in-popup-img' src='https://cdn.roveconcepts.com/sites/default/files/" + info.high_res_img + "' alt='" + info.title + "'";

      info.products.forEach((o) => {
        let $productUrl = o.name.toLowerCase().split(' ').join('-');
        $products += ("<a class='ugc-v2-product-card' href='" + $productUrl + "'><img class='ugc-v2-product-card-image' src='https://cdn.roveconcepts.com/sites/default/files/styles/uc_product_list/public/"+o.image+"' alt='"+o.name+"'/><div class='ugc-v2-product-card-copy-cont'><div class='ugc-v2-product-card-title'>" + o.name + "</div></div></a>");
      })


      $.colorbox({
        position: "fixed",
        width: $sizeWidth + "px",
        height: $sizeHeight + "px",
        maxWidth: '100%',
        opacity: 1,
        inline: false,
        html: "<div class='ugc-v2-modal'><div class='ugc-v2-modal-img-cont skeleton-loading'></div><div class='ugc-v2-modal-bottom'> <p class='ugc-v2-modal-name'>" + info.title + "</p><div class='ugc-v2-product-cont'><div class='ugc-v2-product-card'><div class='ugc-v2-product-card-image skeleton-loading'></div><div class='ugc-v2-product-card-copy-cont'><div class='ugc-v2-product-card-title skeleton-loading'></div></div></div><div class='ugc-v2-product-card'><div class='ugc-v2-product-card-image skeleton-loading'></div><div class='ugc-v2-product-card-copy-cont'><div class='ugc-v2-product-card-title skeleton-loading'></div></div></div></div></div></div>",
        onOpen: function () {
          $('body').css('overflow', 'hidden');
        },
        onClosed: function () {
          $('body').css('overflow', 'auto')
        }
      });

      setTimeout(function(){
        $.colorbox({
          position: "fixed",
          width: $sizeWidth + "px",
          height: $sizeHeight + "px",
          maxWidth: '100%',
          maxHeight: '900px',
          opacity: 1,
          inline: false,
          html: "<div class='ugc-v2-modal'><div class='ugc-v2-modal-img-cont'>" + $img + "</div><div class='ugc-v2-modal-bottom'><div class='ugc-v2-modal-copy'><p class='ugc-v2-modal-name'>" + info.title + "</p></div><div class='ugc-v2-product-cont'>" + $products + "</div></div></div>",
          onComplete: function () {
            $('#colorbox').css('position', 'fixed').css('top', (($(window).height() - $sizeHeight) / 2) + 40 + "px");
          },
          onOpen: function () {
            $('body').css('overflow', 'hidden');
          },
          onClosed: function () {
            $('body').css('overflow', 'auto')
          }
        });

      }, 1000)

    },

    showHostListing: function (data, page) {
      $(".host-connect-section-listing").empty();
      $.each(data, function (index, value) {
        const $bookingUrl = value.url ? value.url : 'https://airtable.com/shrUmSMoHOJgUOHrM';
        let $hostCard = $('<div class="host-listing-cont" tabindex="0">' +
          '<img src="https://cdn.roveconcepts.com/sites/default/files/styles/uc_incident/public/images/rove-host/'+ value.fname.toLowerCase() + '-' + value.lname.toLowerCase() + '/host-' + value.fname.toLowerCase() + '-' + value.lname.toLowerCase() + '-1.jpg" alt="Host '+ value.fname.toLowerCase() + ' ' + value.lname.toLowerCase() +'"/>' +
          '<div class="host-listing-copy"><p class="host-name">'+ value.fname + ' ' + value.lname +'\'s Home</p>' +
        '<div class="host-listing-btn-cont"><a class="host-connect-btn" href="'+$bookingUrl+'" target="_blank" onclick="event.stopPropagation();"><p>Connect Virtually</p>' +
          '<div class="listing-details-btn btn btn-primary"><img src="https://cdn.roveconcepts.com/svg/x.svg" alt="Connect"></div>' +
        '</a></div></div>' +
          '</div>');

        $hostCard.on("click", function(){
          app.components.hostListingPopup(value);
        })

        $(".host-connect-section-listing").append($hostCard);


      });
      document.querySelector("#rove-host-filters").scrollIntoView();
      $(".host-connect-listing-page button").each(function (i) {
        if (i == page) {
          $(this).addClass("selected");
          $(this).attr("disabled", true);
        } else {
          $(this).removeClass("selected");
          $(this).attr("disabled", false);
        }
      });
      if (page == 1) {
        $(".host-connect-listing-page button").first().attr("disabled", true);
      } else if (page == ($(".host-connect-listing-page button").length - 2)) {
        $(".host-connect-listing-page button").last().attr("disabled", true);
      }
    },

    showHostPage: function (direction) {
      if (direction == "next") {
        $(".host-connect-listing-page button.selected").next().trigger("click");
      } else if (direction == "prev") {
        $(".host-connect-listing-page button.selected").prev().trigger("click");
      }
    },

    showHostFilterResult: function (e, data, hpp) {

      let $result = [];
      let $filter = [];
      if ($(e).hasClass("selected")) {
        $(e).removeClass("selected");
      } else {
        $(e).addClass("selected");
      }
      $(".host-connect-filter-cont button.selected").each(function () {
        $filter.push({"type": $(this).attr("data-filter-type"), "filter": $(this).text()});
      })

      $.each($filter, function (index, value) {
        let $filteredData = $.grep(data, function (n, i) {
          return n[value.type].includes(value.filter);
        })
        $.merge($result, $filteredData)
      });

      let $result2 = [];
      $.each($result, function (i, e) {
        var $matchingItems = $.grep($result2, function (item) {
          return item.fname === e.fname && item.lname === e.lname;
        });

        if ($matchingItems.length === 0) {
          $result2.push(e);
        }
      });

      if ($result2.length === 0) {
        $result2 = data
      }
      ;
      $(".page-btn-cont").empty();
      let $page = [];
      while ($result2.length) {
        $page.push($result2.splice(0, hpp));
      }


      $.each($page, function (i, v) {
        let $pageBtn = $("<button type='button'><span>" + (i + 1) + "</span></button>");
        $pageBtn.click(() => app.components.showHostListing(v, i + 1));
        $(".page-btn-cont").append($pageBtn);
      })
      $(".page-btn-cont button").first().trigger("click");
    },


    paybright: function () {
      // Only run for Canada
      if (app.getCountry() !== 'CA') {
        return;
      }

      // Register a ajax command
      Drupal.ajax.prototype.commands.uc_paybright_payment_select = function (ajax, response) {
        Drupal.attachBehaviors('#payment-details');
      };

      $cache.paybright_settings = Drupal.settings.uc_paybright || {};
      if (!Object.keys($cache.paybright_settings).length) {
        return;
      }

      app.components.paybrightCheckout();
    },

    paybrightCheckout: function () {
      if ($cache.isOnePageCheckout) {
        //let $submit = $('.payment-continue');
        //$('#edit-back').css('float', 'left');

        $(document).off('click.paybright');
        $(document).on('click.paybright', '.payment-continue', function (e) {
          e.preventDefault();
          if ($('[name="panes[payment][payment_method]"]:checked').val() === 'paybright') {
            app.components.paybrightTriggerCheckout();
          }
        });
      }
    },

    paybrightTriggerCheckout: function () {
      let method = $('[name="panes[payment][payment_method]"]:checked').val();
      if (method === 'paybright') {
        // load data via ajax...
        $.ajax({
          url: '/ajax/uc_affirm/paybright/' + Drupal.settings.track.order_id
        })
          .fail(function () {
          })
          .done(function (data) {
            window.location.href = data.url;
          });
      }
    },

    affirm: function () {
      // Only run for United States
      if (app.getCountry() !== 'US') {
        return;
      }

      // Register a ajax command
      Drupal.ajax.prototype.commands.uc_affirm_payment_select = function (ajax, response) {
        Drupal.attachBehaviors('#payment-details');
      };

      $cache.affirm_settings = Drupal.settings.uc_affirm || {};
      if (!Object.keys($cache.affirm_settings).length) {
        return;
      }

      app.components.affirmSetup();
      app.components.affirmAsLowAs();
      app.components.affirmCheckout();
    },

    affirmSetup: function () {
      $cache.affirm_url = ($cache.affirm_settings.ApiMode === 'live')
        ? 'https://cdn1.affirm.com/js/v2/affirm.js'
        : 'https://cdn1-sandbox.affirm.com/js/v2/affirm.js';
      $cache._affirm_config = {
        public_api_key: $cache.affirm_settings.hasOwnProperty('PublicKey') ? $cache.affirm_settings.PublicKey : '',
        script: $cache.affirm_url
      };
      (function (l, g, m, e, a, f, b) {
        var d, c = l[m] || {}, h = document.createElement(f), n = document.getElementsByTagName(f)[0],
          k = function (a, b, c) {
            return function () {
              a[b]._.push([c, arguments])
            }
          };
        c[e] = k(c, e, "set");
        d = c[e];
        c[a] = {};
        c[a]._ = [];
        d._ = [];
        c[a][b] = k(c, a, b);
        a = 0;
        for (b = "set add save post open empty reset on off trigger ready setProduct".split(" "); a < b.length; a++) d[b[a]] = k(c, e, b[a]);
        a = 0;
        for (b = ["get", "token", "url", "items"]; a < b.length; a++) d[b[a]] = function () {
        };
        h.async = !0;
        h.src = g[f];
        n.parentNode.insertBefore(h, n);
        delete g[f];
        d(g);
        l[m] = c
      })(window, $cache._affirm_config, "affirm", "checkout", "ui", "script", "ready");
      affirm.ui.ready(function () {
        //if (Drupal.settings.gtm.user != 'undefined' && Drupal.settings.gtm.user.id == 1) {
        //    $('body').append('<p class="affirm-prequal-text" data-promo-id="prequal_text_rove_concepts"></p>');
        //}
        //define the Prequal JSON object
        var a = {
          "page_type": typeof Drupal.settings.gtm !== 'undefined' && Drupal.settings.gtm.google_tag_params.ecomm_pagetype !== 'undefined' ? Drupal.settings.gtm.google_tag_params.ecomm_pagetype : "home",
          "mode": "modal"
        };
        //set the Prequal configuration
        affirm.prequal.set(a);
      });
    },

    /**
     * Used when displaying from prices
     */
    affirmAsLowAs: function () {
      affirm.ui.ready(function () {
        updateAffirmAsLowAs($cache.affirm_settings.amount)
      }); // change to your template value for product or cart price
      function updateAffirmAsLowAs(amount) {
        if ((amount == null) || (amount < 1000)) {
          return;
        } // Only display as low as for items over $10 CHANGE FOR A DIFFERENT LIMIT
        // payment estimate options
        var options = {
          apr: $cache.affirm_settings.financing_program === 'zero_pct_3_6_12_standard' ? 0 : "0.10", // percentage assumed APR for loan
          months: 12, // can be 3, 6, or 12
          amount: amount // USD cents
        };
        try {
          typeof affirm.ui.payments.get_estimate;
          /* try and access the function */
        } catch (e) {
          return;
          /* stops this function from going any further - affirm functions are not loaded and will throw an error */
        }

        // use the payment estimate response
        function handleEstimateResponse(payment_estimate) {
          // the payment comes back in USD cents
          let dollars = ((payment_estimate.payment + 99) / 100) | 0; // get dollars, round up, and convert to int
          // Set affirm payment text
          let a = document.getElementById('learn-more');
          let iText = ('innerText' in a) ? 'innerText' : 'textContent';
          a[iText] = $cache.affirm_settings.aslowas_string.replace(':dollars', dollars);
          //a[iText] = "Starting at $" + dollars + " a month. Learn More";
          // open the customized Affirm learn more modal
          a.onclick = payment_estimate.open_modal;
          a.style.visibility = "visible";
        };
        // request a payment estimate
        affirm.ui.payments.get_estimate(options, handleEstimateResponse);
      }
    },

    affirmCheckout: function () {
      let $submit = $($cache.affirm_submit_selector);

      // Update changes incase ajax doesnt get run.
      $.each(app.checkout.getShipInputs(), function (i, e) {
        e.on("change keyup input paste", function () {
          app.components.affirmUpdateAddress($(this));
        });
      })

      //$('#edit-back').css('float', 'left');
      $(document).off('click.affirm');
      $(document).on('click.affirm', '.payment-continue', function (e) {
        e.preventDefault();
        if ($('[name="panes[payment][payment_method]"]:checked').val() == 'affirm') {
          app.components.affirmTriggerCheckout();
        }
      });
    },

    affirmUpdateAddress: function ($ele) {
      let isShared = $('[name="panes[billing][copy_address]"]').is(':checked');
      if ($ele.attr('name').indexOf('delivery_street1') !== -1) {
        $cache.affirm_settings.ShippingAddressLn1 = $ele.val();
        if (isShared) {
          $cache.affirm_settings.BillingAddressLn1 = $ele.val();
        }
      }
      if ($ele.attr('name').indexOf('delivery_street2') !== -1) {
        $cache.affirm_settings.ShippingAddressLn2 = $ele.val();
        if (isShared) {
          $cache.affirm_settings.BillingAddressLn2 = $ele.val();
        }
      }
      if ($ele.attr('name').indexOf('delivery_country') !== -1) {
        $cache.affirm_settings.ShippingAddressCountry = parseInt($ele.val()) === 840 ? 'US' : 'CA';
        if (isShared) {
          $cache.affirm_settings.BillingAddressCountry = parseInt($ele.val()) === 840 ? 'US' : 'CA';
        }
      }
      if ($ele.attr('name').indexOf('delivery_postal_code') !== -1) {
        $cache.affirm_settings.ShippingAddressPostCode = $ele.val();
        if (isShared) {
          $cache.affirm_settings.BillingAddressPostCode = $ele.val();
        }
      }
      if ($ele.attr('name').indexOf('delivery_city') !== -1) {
        $cache.affirm_settings.ShippingAddressCity = $ele.val();
        if (isShared) {
          $cache.affirm_settings.BillingAddressCity = $ele.val();
        }
      }
      if ($ele.attr('name').indexOf('delivery_phone') !== -1) {
        $cache.affirm_settings.ShippingTelephone = $ele.val();
        if (isShared) {
          $cache.affirm_settings.BillingTelephone = $ele.val();
        }
      }
      if (!isShared) {
        if ($ele.attr('name').indexOf('billing_street1') !== -1) {
          $cache.affirm_settings.BillingAddressLn1 = $ele.val();
        }
        if ($ele.attr('name').indexOf('billing_street2') !== -1) {
          $cache.affirm_settings.BillingAddressLn2 = $ele.val();
        }
        if ($ele.attr('name').indexOf('billing_country') !== -1) {
          $cache.affirm_settings.BillingAddressCountry = parseInt($ele.val()) === 840 ? 'US' : 'CA';
        }
        if ($ele.attr('name').indexOf('billing_postal_code') !== -1) {
          $cache.affirm_settings.BillingAddressPostCode = $ele.val();
        }
        if ($ele.attr('name').indexOf('billing_city') !== -1) {
          $cache.affirm_settings.BillingAddressCity = $ele.val();
        }
        if ($ele.attr('name').indexOf('billing_phone') !== -1) {
          $cache.affirm_settings.BillingTelephone = $ele.val();
        }
      }
    },

    // Ajax calls this for updating
    financingUpdateOrder: function (data) {
      switch (data.method) {
        case 'affirm':
          Drupal.settings.uc_affirm = data.data;
          break;
        case 'paybright':
          if (typeof Drupal.settings.uc_paybright !== 'undefined') {
            Drupal.settings.uc_paybright.url = data.url;
            Drupal.settings.uc_paybright.data = data.data;
          } else {
            Drupal.settings.uc_paybright = data;
          }
          break;
      }
    },

    affirmTriggerCheckout: function () {
      let settings = $cache.affirm_settings;
      let affirm_settings = {
        "merchant": {
          "public_api_key": settings.PublicKey,
          "user_confirmation_url": settings.ConfirmUrl,
          "user_confirmation_url_action": "POST",
          "user_cancel_url": settings.CancelUrl
        },
        //"financing_program":"custom_financing_program",
        "config": {
          "financial_product_key": settings.FinancialProductKey
        },
        "billing": {
          "name": {
            "full": settings.BillingFullName,
            "first": settings.BillingFirstName,
            "last": settings.BillingLastName
          },
          "address": {
            "line1": settings.BillingAddressLn1,
            "line2": settings.BillingAddressLn2,
            "city": settings.BillingAddressCity,
            "state": settings.BillingAddressState,
            "zipcode": settings.BillingAddressPostCode,
            "country": settings.BillingAddressCountry
          },
          "email": settings.Email,
          "phone_number": settings.BillingTelephone
        },
        "items": settings.items,
        "shipping": {
          "name": {
            "full": settings.ShippingFullName,
            "first": settings.ShippingFirstName,
            "last": settings.ShippingLastName
          },
          "address": {
            "line1": settings.ShippingAddressLn1,
            "line2": settings.ShippingAddressLn2,
            "city": settings.ShippingAddressCity,
            "state": settings.ShippingAddressState,
            "zipcode": settings.ShippingAddressPostCode,
            "country": settings.ShippingAddressCountry
          },
          "email": settings.Email,
          "phone_number": settings.ShippingTelephone
        },
        metadata: settings.metadata,
        //"discounts": settings.discounts,
        "order_id": settings.OrderId,
        "shipping_amount": settings.ShippingTotal,
        "tax_amount": Math.round(settings.TaxAmount, 0),
        "total": Math.round(settings.ProductsTotal, 0)
      };
      if (Drupal.settings.rove.development_site) {
        affirm_settings['financing_program'] = 1 === 2 ? 'zero_pct_3_6_12_standard' : 'standard_3_6_12';
      } else {
        affirm_settings['financing_program'] = 1 === 1 ? 'standard_3_6_12' : 'zero_pct_3_6_12_standard';
      }
      // This variable is now available
      affirm_settings['financing_program'] = Drupal.settings.uc_affirm.financing_program;
      affirm.checkout(affirm_settings);

      // Submit and redirect to checkout flow.
      affirm.checkout.post();
    },

    share: function () {
      var $sharewidget = $('.share-widget');

      if ($sharewidget.length > 0) {
        app.sendToFriend.initializeDialog('.share-widget', '.send-to-friend');

        // pinterest hacks
        $('.share-pinterest a').click(function () {
          // trigger all images to appear
          var $lazy = $('img');
          $.each($lazy, function (index, value) {
            var $img = $(this);
            var src = $img.attr('data-original');
            if (src) {
              $img.attr('src', src);
            }
          });

          // exlucde hero
          $('.pictureFill img').attr("data-pin-nopin", "true");

        });

        $('.share-social a').click(function () {
          var $this = $(this);
          window.open($this.attr('href'), 'aritzia_share', 'scrollbars=yes,resizable=yes,toolbar=no,location=yes,width=550,height=420,top=100,left=100');
          return false;
        });

        // copy to clipboard
        var clip = new Clipboard('.share-copy a');
        clip.on("success", function (e) {
          var $parent = $(e.trigger).parent();
          var $feedback = $('<div/>', {
            "html": app.resources.COPIED_URL,
            "class": "share-label"
          });

          $parent.addClass('copied');
          $parent.append($feedback);

          setTimeout(function () {
            $parent.removeClass('copied');
            $parent.find('.share-label').remove();
          }, 3000);
        });

      }

    },

    // TODO - This is currently bound to an event listener
    video: function () {
      let $lazyvideos = $('.lazy-video');
      if ($lazyvideos.length > 0) {
        $.each($lazyvideos, function () {
          let $this = $(this);
          // div in viewport, inject video
          if (app.util.isInViewPortPartial($this) && $this.hasClass('lazy-video')) {

            let video = '';
            let poster = '';

            if (app.isMobile() || app.isiPad()) {
              // load mobile video
              video = $this.data('video-mobile');
              poster = $this.data('poster-mobile');
            } else {
              // load desktop video
              video = $this.data('video-desktop');
              poster = $this.data('poster-desktop');
            }

            if (video != '' && poster != '') {
              let $v = $('<video/>').attr({
                "poster": poster,
                "class": "mw-100 w-100",
                "autoplay": "autoplay",
                "loop": "loop",
                "muted": "muted",
                "playsinline": "playsinline"
              });

              $('<source/>').attr({
                "alt": "Your browser does not support the video tag.",
                "src": video
              }).appendTo($v);

              $('<img/>').attr({
                "alt": "Your browser does not support the video tag.",
                "src": poster
              }).appendTo($v);

              $this.empty();
              $this.removeClass('lazy-video');
              $this.append($v);
            }

          }
        });
      }

    },

    // function to be called from a window resize
    restick: function (container, elm) {

      $.each(elm.data(), function (index, value) {
        elm.removeData(index);
      });

      elm.removeAttr('style');

      elm.data('elmheight', elm.height());
      elm.data('elmwidth', elm.width());

      app.components.stick(container, elm);
    },

    stick: function (container, elm, spacer, lastScrollTop, direction, parentPlaceholderElm, recalculate) {
      if (container.length > 0) {

        // cacheable variables
        if (!elm.data('state')) {
          elm.data('state', 'top');
        }
        if (!elm.data('direction')) {
          elm.data('direction', direction);
        }
        if (!elm.data('topspacer')) {
          elm.data('topspacer', (typeof spacer !== 'undefined' && spacer !== false) ? spacer : 50);
        }
        if (!elm.data('position')) {
          elm.data('position', elm.css('position'));
        }
        if (!elm.data('top')) {
          elm.data('top', elm.css('top'));
        }

        if (!!recalculate || !elm.data("elmheight")) {
          elm.data("elmheight", elm.height())
        }
        if (!!recalculate || !elm.data("elmwidth")) {
          elm.data("elmwidth", elm.width())
        }

        var topSpacer = elm.data('topspacer');
        var elmHeight = elm.data('elmheight');
        var elmWidth = elm.data('elmwidth');

        // uncacheable variables
        var totalHeight = elmHeight + topSpacer;
        var changeDirection = false;

        var position = $(window).scrollTop() + topSpacer;
        var primaryHeight = container.height();

        // break points
        var stickyTop = container.offset().top;
        var stickyBottom = stickyTop + primaryHeight - elmHeight; // Bottom isnt padded enough?

        // sticky item is too tall for window
        // 1571 > 969 && up
        if (totalHeight > $(window).height() && elm.data('direction') !== undefined) {

          var curTop = parseInt(elm.css('top'));

          if (elm.data('direction') !== direction) {
            changeDirection = true;
            elm.data('direction', direction);
          }

          var scrollDiff, transition;
          if (elm.data('direction') === 'down') {
            var offsetHeight = totalHeight - $(window).height() + topSpacer;
            stickyTop += offsetHeight; // 100 -> 812px
            stickyBottom += offsetHeight; // 3792 -> 4504
            topSpacer -= offsetHeight; // 50 -> -663

            // transitioning down
            if (!isNaN(curTop) && curTop > topSpacer) {
              scrollDiff = lastScrollTop - $(window).scrollTop();	// -1
              transition = curTop + scrollDiff; // 49
              topSpacer = (transition > topSpacer) ? transition : topSpacer; // 49
              changeDirection = true;
              // force dom update
            }
          } else if (elm.data('direction') === 'up') {
            // transitioning up
            if (!isNaN(curTop) && curTop < topSpacer) {
              scrollDiff = lastScrollTop - $(window).scrollTop();
              transition = curTop + scrollDiff;

              topSpacer = (transition < topSpacer) ? transition : topSpacer;
              changeDirection = true;
              // force dom update
            }
          }

        }

        // middle
        if (position >= stickyTop && position <= stickyBottom) {
          if (elm.data('state') !== 'middle' || changeDirection) {
            if (elm.data('state') === 'bottom') {
              // changing from absolute to fixed
              topSpacer = elm.data('topspacer');
            }

            if (parentPlaceholderElm != null) {
              parentPlaceholderElm.css({
                'height': parentPlaceholderElm.outerHeight()
              });
            }

            elm.css({
              "position": "fixed",
              "top": topSpacer + "px",
              "width": elmWidth
            }).addClass('sticky');
            elm.data('state', 'middle');
          }
        }// bottom
        else if (position > stickyBottom && primaryHeight > elmHeight) {
          if (elm.data('state') !== 'bottom') {
            //var tp = (container.position().top + primaryHeight - elmHeight);
            var tp = primaryHeight - elmHeight;
            elm.css({
              "position": "absolute",
              "top": tp + "px",
              "width": elmWidth
            }).addClass('sticky');
            elm.data('state', 'bottom');
          }
        }// top
        else {
          if (elm.data('state') !== 'top') {
            if (parentPlaceholderElm != null) {
              parentPlaceholderElm.css({
                'height': 'auto'
              });
            }

            elm.css({
              "position": elm.data('position'),	// static
              "top": elm.data('top')	// auto
            }).removeClass('sticky');
            elm.data('state', 'top');
          }
        }

      }
    },

    passwordRevealToggle: function () {
      if ($('.js-input-password-toggle').length) {
        $('body').on('click', '.js-input-password-toggle', function (e) {
          e.preventDefault();
          var $input = $(this).parents('.form-row').find('.password-input');

          if ($input.hasClass('password-input--revealed')) {
            $input[0].type = 'password';
            $input.removeClass('password-input--revealed');
          } else {
            $input[0].type = 'text';
            $input.attr('autocapitalize', 'off');
            $input.addClass('password-input--revealed');
          }
        });
      }
    },

    initAutoScroll: function (options) {
      $.extend(app.components.autoScrollOptions, options);
      app.components.autoScrollContainer = app.ui.content.find(app.components.autoScrollOptions.containerSelector);
      $cache.nextAutoScroll = app.ui.content.find(app.components.autoScrollOptions.nextSelector);

      $cache.window = $(window);
      $cache.document = $(document);
      $cache.scrollPercent = 0.65;
      $cache.scrollPoint = ($cache.document.height() - $cache.window.height()) * $cache.scrollPercent;
      $cache.backTopID = "btn-backTop";
      $cache.backTopScrollPoint = $cache.window.height() * 3;

      app.components.initPager();

      app.addEventListener('app.components.autoScroll', 'scroll');
      $cache.window.trigger('scroll');

      $cache.document.on('heightChange', function () {
        setTimeout(function () {
          $cache.scrollPoint = ($cache.document.height() - $cache.window.height()) * $cache.scrollPercent;
          app.ui.content.data('busy', false);
        }, 2000);
      });
    },
    initPager: function () {
      // reset scroll points
      $cache.document.trigger('heightChange');

      // Reset elements as they have been replaced.
      $cache.nextAutoScroll = app.ui.content.find(app.components.autoScrollOptions.nextSelector);

      // Reset data content
      app.ui.content.data('busy', false);
    },
    autoScroll: function () {
      let sTop = $cache.window.scrollTop();
      if (sTop > $cache.scrollPoint) {
        if ($cache.nextAutoScroll.length > 0 && !app.ui.content.data('busy')) {
          app.ui.content.data('busy', true);

          $('<div/>', {
            class: 'rove-load-more', 'aria-label': 'Loading more items'
          }).append($('<span/>', {class: 'icon-load icon-large'})).appendTo(app.components.autoScrollContainer);

          app.executeFunctionByName(app.components.autoScrollOptions.loadFunction, window, $cache.nextAutoScroll, app.components.autoScrollContainer, $cache.nextAutoScroll.attr('href'));
        }
      }

      // no button
      if (sTop > $cache.backTopScrollPoint && !$cache.backToTop) {
        $cache.backToTop = $("<a/>", {
          "id": $cache.backTopID,
          "class": "hidden-phone",
          "html": app.resources.BACK_TO_TOP
        }).append($("<span/>", {
          "class": "icon-arrow rotate-270"
        })).appendTo('body').fadeIn();
        $("#" + $cache.backTopID).on('click', function (e) {
          e.preventDefault();
          $('html, body').animate({
            scrollTop: 0
          }, 400);
        });
      } else if (sTop > $cache.backTopScrollPoint && $cache.backToTop) {
        $cache.backToTop.fadeIn();
      } else if (sTop <= $cache.backTopScrollPoint && $cache.backToTop) {
        $cache.backToTop.fadeOut();
      }
    },

    // Callback function to load new items
    loadItems: function ($button, $container, url) {
      $.ajax({
        url: url,
        data: [],
        success: function (e) {
          $('.rove-load-more').remove();

          if (!e.length || $button.data('lock')) {
            $button.data('lock', true);
            return;
          }

          // Item(s) Callback
          if (app.components.autoScrollOptions.itemCallback) {
            app.executeFunctionByName(app.components.autoScrollOptions.itemCallback, window, app.components.autoScrollContainer, e);
          } else {
            for (let i = 0; i < e.length; i++) {
              app.components.autoScrollContainer.append(e[i].html);
            }
          }

          // Update the pager
          if (app.components.autoScrollOptions.pagerCallback) {
            app.executeFunctionByName(app.components.autoScrollOptions.pagerCallback, window, $button, e);
          } else {
            let currenturl = app.util.getUri($cache.nextAutoScroll.attr('href'));
            let newpath = currenturl.path.split('/');
            newpath.shift();
            newpath[2] = parseInt(newpath[2]) + 1;
            $cache.nextAutoScroll.attr('href', currenturl.protocol + '//' + currenturl.host + '/' + newpath.join('/') + currenturl.query);
          }

          // Trigger events
          $cache.document.trigger('heightChange').trigger('pagerNext');
        },
        error: function () {
          console.error('Error trying to obtain new photos.');
        },
        complete: function () {
          // Complete callback
          if (app.components.autoScrollOptions.completeCallback) {
            app.executeFunctionByName(app.components.autoScrollOptions.completeCallback, window, app.components.autoScrollContainer);
          }

          // Increment and remove if we hit the max pages.
          $cache.pagesLoaded++;
          if ($cache.pagesLoaded >= app.components.autoScrollOptions.maxPages) {
            app.removeEventListener('app.components.autoScroll', 'scroll');
          }
        }
      });
    },

    // function for form submissions with a timeout
    createFunctionWithTimeout: function (callback, opt_timeout) {
      let called = false;

      function fn() {
        if (!called) {
          called = true;
          callback();
        }
      }

      setTimeout(fn, opt_timeout || 1000);
      return fn;
    },

    sha256: function (ascii) {
      function rightRotate(value, amount) {
        return (value >>> amount) | (value << (32 - amount));
      };

      var mathPow = Math.pow;
      var maxWord = mathPow(2, 32);
      var lengthProperty = 'length';
      var i, j; // Used as a counter across the whole file
      var result = '';

      var words = [];
      var asciiBitLength = ascii[lengthProperty] * 8;

      //* caching results is optional - remove/add slash from front of this line to toggle
      // Initial hash value: first 32 bits of the fractional parts of the square roots of the first 8 primes
      // (we actually calculate the first 64, but extra values are just ignored)
      var hash = app.components.sha256.h = app.components.sha256.h || [];
      // Round constants: first 32 bits of the fractional parts of the cube roots of the first 64 primes
      var k = app.components.sha256.k = app.components.sha256.k || [];
      var primeCounter = k[lengthProperty];
      /*/
      var hash = [], k = [];
      var primeCounter = 0;
      //*/

      var isComposite = {};
      for (var candidate = 2; primeCounter < 64; candidate++) {
        if (!isComposite[candidate]) {
          for (i = 0; i < 313; i += candidate) {
            isComposite[i] = candidate;
          }
          hash[primeCounter] = (mathPow(candidate, .5) * maxWord) | 0;
          k[primeCounter++] = (mathPow(candidate, 1 / 3) * maxWord) | 0;
        }
      }

      ascii += '\x80'; // Append '1' bit (plus zero padding)
      while (ascii[lengthProperty] % 64 - 56) ascii += '\x00'; // More zero padding
      for (i = 0; i < ascii[lengthProperty]; i++) {
        j = ascii.charCodeAt(i);
        if (j >> 8) return; // ASCII check: only accept characters in range 0-255
        words[i >> 2] |= j << ((3 - i) % 4) * 8;
      }
      words[words[lengthProperty]] = ((asciiBitLength / maxWord) | 0);
      words[words[lengthProperty]] = (asciiBitLength)

      // process each chunk
      for (j = 0; j < words[lengthProperty];) {
        var w = words.slice(j, j += 16); // The message is expanded into 64 words as part of the iteration
        var oldHash = hash;
        // This is now the "working hash", often labelled as variables a...g
        // (we have to truncate as well, otherwise extra entries at the end accumulate
        hash = hash.slice(0, 8);

        for (i = 0; i < 64; i++) {
          var i2 = i + j;
          // Expand the message into 64 words
          // Used below if
          var w15 = w[i - 15], w2 = w[i - 2];

          // Iterate
          var a = hash[0], e = hash[4];
          var temp1 = hash[7]
            + (rightRotate(e, 6) ^ rightRotate(e, 11) ^ rightRotate(e, 25)) // S1
            + ((e & hash[5]) ^ ((~e) & hash[6])) // ch
            + k[i]
            // Expand the message schedule if needed
            + (w[i] = (i < 16) ? w[i] : (
                w[i - 16]
                + (rightRotate(w15, 7) ^ rightRotate(w15, 18) ^ (w15 >>> 3)) // s0
                + w[i - 7]
                + (rightRotate(w2, 17) ^ rightRotate(w2, 19) ^ (w2 >>> 10)) // s1
              ) | 0
            );
          // This is only used once, so *could* be moved below, but it only saves 4 bytes and makes things unreadble
          var temp2 = (rightRotate(a, 2) ^ rightRotate(a, 13) ^ rightRotate(a, 22)) // S0
            + ((a & hash[1]) ^ (a & hash[2]) ^ (hash[1] & hash[2])); // maj

          hash = [(temp1 + temp2) | 0].concat(hash); // We don't bother trimming off the extra ones, they're harmless as long as we're truncating when we do the slice()
          hash[4] = (hash[4] + temp1) | 0;
        }

        for (i = 0; i < 8; i++) {
          hash[i] = (hash[i] + oldHash[i]) | 0;
        }
      }

      for (i = 0; i < 8; i++) {
        for (j = 3; j + 1; j--) {
          var b = (hash[i] >> (j * 8)) & 255;
          result += ((b < 16) ? 0 : '') + b.toString(16);
        }
      }
      return result;
    },

    lovePlacement: function () {
      if ($('.love-info').length !== 0) {
        $(document).ready(() => {
          $(".love-info").css("top", -Math.abs($(".product_listing .product_image").height() + 5) + "px")
          if ($("#rove_products .row").length !== 0) {
            let $x = new MutationObserver(function () {
              $(".love-info").css("top", -Math.abs($(".product_listing .product_image").height() + 5) + "px")
            });
            $x.observe($("#rove_products .row")[0], {childList: true});
          }
        })

      }
    },

    onElementInView: function(selector, callback, options = {}) {
      const element = document.querySelector(selector);
      if (!element) return;

      const observer = new IntersectionObserver(
        (entries, observerInstance) => {
          entries.forEach(entry => {
            if (entry.isIntersecting) {
              callback(entry.target);
              observerInstance.unobserve(entry.target); // remove if only needed once
            }
          });
        },
        {
          root: null,         // viewport
          rootMargin: '0px',
          threshold: 0.1     // trigger when 10% visible
          //...options          // allow overrides
        }
      );

      observer.observe(element);
    }
    // app.components.onElementInView('.block-uc-display',function() { alert('in view'); },{})

    /*
    customInputValidation: function ($input, events, validator, options) {
        options = options || {};
        var $form = $input.parents('form');
        var $formRow = $input.parents('.form-row');
        var $formCaption = $formRow.find('.form-caption');

        var inputErrorClass = 'error';
        var rowErrorClass = 'form-row-error';

        validator = validator === 'numeric' ? function (value) {
                return value.length < 1 ? true : /^\d+$/.test(value) ? true : options.error || ''
            }
            : validator;
        validator = validator === 'email' ? function (value) {
                return value.length < 1 ? true : /^[\w.%+-]+@[\w.-]+\.[\w]{2,6}/.test(value) ? true : options.error || app.resources.INVALID_EMAIL2
            }
            : validator;
        validator = validator === 'phone' ? function (value) {
                return value.length < 1 ? true : /^[+\-() \d]{10,20}$/.test(value) ? true : options.error || app.resources.INVALID_PHONE2
            }
            : validator;
        validator = validator === 'cc-number' ? function (value) {
                return value.length < 1 ? true : /^[\d* ]+$/.test(value) ? true : options.error || ''
            }
            : validator;
        validator = validator === 'cc-name' ? function (value) {
                return value.length < 1 ? true : !/[`~#$%^*_=;|\<\>\"\[\]\{\}]{1,}/.test(value) ? true : options.error || app.resources.CC_NAME
            }
            : validator;
        validator = typeof validator === 'function' ? validator : function (value) {
            return true;
        }
        ;

        var validate = function () {
            var value = $input.val();
            var result = validator(value, options);

            if (result === true) {
                $input.removeClass(inputErrorClass);
                $formRow.removeClass(rowErrorClass);
                $formCaption.remove();
            } else {
                $formCaption = $formCaption.length > 0 ? $formCaption.eq(0) : $('<span class="form-caption error-message ar-error-text" />');
                $input.addClass(inputErrorClass);
                $formRow.addClass(rowErrorClass);
                $formCaption.text(result);
                $formRow.append($formCaption);
            }

            return result === true;
        };

        $form.on('submit', function (e) {
            if (!validate()) {
                e.preventDefault();
            }
        });

        $input.on(events, validate);
    }
    */
  };


}(window.app = window.app || {}, window.rv, jQuery));


(function ($) {
  /**
   * Handle an event that triggers an Ajax response.
   *
   * When an event that triggers an Ajax response happens, this method will
   * perform the actual Ajax call. It is bound to the event using
   * bind() in the constructor, and it uses the options specified on the
   * ajax object.
   */
  Drupal.ajax.prototype.eventMimic = function (element) {
    // Create a synonym for this to reduce code confusion.
    var ajax = this;
    let deferred = $.Deferred();

    // Do not perform another ajax command if one is already in progress.
    if (ajax.ajaxing) {
      return deferred;
    }

    try {
      if (ajax.form) {
        if (ajax.setClick) {
          element.form.clk = element;
        }

        ajax.form.ajaxSubmit(ajax.options);
      } else {
        ajax.beforeSerialize(ajax.element, ajax.options);
        return $.ajax(ajax.options);
      }
    } catch (e) {
      // Unset the ajax.ajaxing flag here because it won't be unset during
      // the complete response.
      ajax.ajaxing = false;
      alert("An error occurred while attempting to process: " + e.message);
    }

    return deferred;
  };
})(jQuery);

const queryString = window.location.search;
if (queryString.indexOf('locale=en_UK') > 0) {
  var element = document.querySelector(".nav-country-icon");
  element.classList.remove("ca-icon", "us-icon", "kr-icon", "hk-icon", "au-icon");
  element.classList.add("uk-icon");

}

const controller = new ScrollMagic.Controller();

const HOMEPAGE_MEMBERSHIP_CAROUSEL_CONTENT = [
  {
    title: "studio x room planner",
    type: "video",
    description:
      "Receive photorealistic, real-time renders of your newly designed space, scaled perfectly to your personal floor plan.",
  },
  {
    title: "VIP ACCESS",
    type: "video",
    description: "To our exclusive events just for our members.",
  },
  {
    title: "complimentary design consultations",
    type: "image",
    description: "To bring your vision to life.",
  },
  {
    title: "dedicated concierge service",
    type: "image",
    description: "For personalized support tailored just for your taste.",
  },
];

// Create dots using DocumentFragment
const addCarouselDots = (parentEl, dots) => {
  const dotsFragment = document.createDocumentFragment();
  for (let i = 0; i < dots; i++) {
    const dot = document.createElement("button");
    dot.className = "carousel-dot";
    if (i === 0) dot.classList.add("active");
    dotsFragment.appendChild(dot);
  }
  parentEl.appendChild(dotsFragment);
};

const updateCarouselContent = (
  index,
  carouselControls,
  carouselBackgroundContent
) => {
  const title = document.querySelector("#carousel-title");
  const description = document.querySelector("#carousel-description");

  // Add fade out effect

  document.querySelectorAll(".carousel-background").forEach((item) => {
    item.style.opacity = "0";
  });

  // Remove active class from all controls
  carouselControls.forEach((ctrl) => ctrl.classList.remove("active"));

  // Wait for fade out, then change image and fade in
  setTimeout(() => {
    const content = HOMEPAGE_MEMBERSHIP_CAROUSEL_CONTENT[index];
    title.textContent = content.title;
    description.textContent = content.description;
    carouselBackgroundContent.style.opacity = "1";
    if (carouselBackgroundContent.children.length > 0) {
      carouselBackgroundContent.children[0].style.opacity = "1";
    }

    // Add load event listener to ensure image is loaded before fading in
    carouselBackgroundContent.onload = () => {
      carouselBackgroundContent.style.opacity = "1";
    };

    carouselControls[index].classList.add("active");
  }, 200);
};

const updateCarouselDots = (index, carouselDots) => {
  const dots = carouselDots.children;
  Array.from(dots).forEach((dot, i) => {
    dot.classList.toggle("active", i === index);
  });
};

const updateCarouselControls = (
  index,
  carouselControlUp,
  carouselControlDown
) => {
  carouselControlUp.classList.toggle("disabled", index === 0);
  carouselControlDown.classList.toggle(
    "disabled",
    index === HOMEPAGE_MEMBERSHIP_CAROUSEL_CONTENT.length - 1
  );
};

const handleMembershipCarousel = () => {
  const carouselDots = document.querySelector("#carousel-dots");
  const carouselControls = document.querySelectorAll(".carousel-control-item");
  const carouseContentlList = document.querySelector("#carousel-content-list");
  const carouselControlUp = document.querySelector("#carousel-control-up");
  const carouselControlDown = document.querySelector("#carousel-control-down");

  addCarouselDots(carouselDots, HOMEPAGE_MEMBERSHIP_CAROUSEL_CONTENT.length);
  carouselDots.querySelectorAll(".carousel-dot").forEach((dot, index) => {
    dot.addEventListener("click", () => {
      state.index = index;
    });
  });
  carouseContentlList.children[0].style.opacity = "1";

  // New function to update carousel content

  // Create a simple state object to track changes
  const state = {
    activeIndex: 0,
    listeners: new Set(),
    set index(value) {
      this.activeIndex = value;
      this.notify();
    },
    get index() {
      return this.activeIndex;
    },
    subscribe(callback) {
      this.listeners.add(callback);
    },
    notify() {
      this.listeners.forEach((callback) => callback(this.activeIndex));
    },
  };

  // Subscribe to state changes
  state.subscribe((index) => {
    updateCarouselContent(
      index,
      carouselControls,
      carouseContentlList.children[index]
    );
    // Update carousel dots
    updateCarouselDots(index, carouselDots);
    //Update carousel controls
    updateCarouselControls(index, carouselControlUp, carouselControlDown);
  });

  // Update click handlers to use state
  carouselControls.forEach((control, index) => {
    control.addEventListener("click", () => {
      state.index = index;
    });
  });

  carouselControlUp.addEventListener("click", () => {
    if (state.index >= 1) {
      state.index = state.index - 1;
    }
  });

  carouselControlDown.addEventListener("click", () => {
    if (state.index < HOMEPAGE_MEMBERSHIP_CAROUSEL_CONTENT.length - 1) {
      state.index = state.index + 1;
    }
  });
};

const handlePoemTitleScrolling = (controller) => {
  new ScrollMagic.Scene({
    triggerElement: "#fixed-overlay-container",
    triggerHook: 0.3,
  })
    .setPin("#fixed-overlay-container")
    .addTo(controller);
};

const handlePoemSectionScrolling = (controller) => {
  document.getElementById("lookbook-wrapper").addEventListener("click", () => {
    window.open(
      "https://lookbook.roveconcepts.com/2025-rove-concepts-lookbook/?_gl=1*jrla90*_gcl_aw*R0NMLjE3MzY5NjQ1ODAuRUFJYUlRb2JDaE1Jdi16eW82bjRpZ01WM1E1RUNCMTNGQnhURUFBWUFTQUFFZ0lXMl9EX0J3RQ..*_gcl_au*MTQzNzAzODE0NC4xNzM4MjU1MDc4",
      "_blank"
    );
  });
  const poemContainer = document.querySelector("#fixed-overlay-container-poem");
  const poemContainerWrapper = document.querySelector(
    "#journey-wrapper-overlay-poem"
  );
  const poemContainerWrapperHeight = poemContainerWrapper.offsetHeight;
  const setToRelativePoem = () => {
    poemContainer.style.position = "relative";
    poemContainer.style.top = "0";
    poemContainer.style.left = "0";
    poemContainer.style.transform = "none";
  };
  let containerPoemFixed = true;

  var scenePoem = new ScrollMagic.Scene({
    triggerElement: "#journey-wrapper-overlay-poem",
    duration: poemContainerWrapperHeight,
    triggerHook: "onLeave",
  }).addTo(controller);

  scenePoem.on("enter", function (event) {
    setToRelativePoem();
    containerPoemFixed = false;
  });
};

const handleOriginalDesignsCarousel = () => {
  let currentIndex = 0;
  const originalsSlider = document.querySelector("#originals-slider");
  const originalsSliderItem1 = document.querySelector(
    "#originals-slider-item-1"
  );
  const buttonPrev = document.querySelector(
    "#original-designs-carousel-control-prev"
  );
  const buttonNext = document.querySelector(
    "#original-designs-carousel-control-next"
  );
  buttonPrev.addEventListener("click", () => {
    changeSlide("prev");
  });
  buttonNext.addEventListener("click", () => {
    changeSlide("next");
  });
  addCarouselDots(document.querySelector("#originals-slider-dots"), 3);

  const hideShowControls = () => {
    if (currentIndex === 0) {
      buttonPrev.classList.add("invisible-left");
    } else {
      buttonPrev.classList.remove("invisible-left");
    }
    if (currentIndex === 2) {
      buttonNext.classList.add("invisible-right");
    } else {
      buttonNext.classList.remove("invisible-right");
    }
  };

  const changeSlide = (direction) => {
    if (direction === "prev") {
      currentIndex--;
    } else {
      currentIndex++;
    }
    hideShowControls();
    const slideWidth = originalsSliderItem1.offsetWidth + 30;
    originalsSlider.scrollBy({
      left: direction === "prev" ? -slideWidth : slideWidth,
      behavior: "smooth",
    });
  };
  originalsSlider.addEventListener("scroll", () => {
    setInterval(() => {
      const currentPage = Math.round(
        originalsSlider.scrollLeft / originalsSliderItem1.offsetWidth
      );
      let dotsContainer = document.querySelector("#originals-slider-dots");
      const dots = dotsContainer.querySelectorAll(".carousel-dot");
      hideShowControls();
      dots.forEach((dot, index) => {
        if (index === currentPage) {
          currentIndex = index;
          dot.classList.add("active");
        } else {
          dot.classList.remove("active");
        }
      });
    }, 300);
  });
};

const handleOriginalDesignsScrolling = (controller) => {
  const originalsSlider = document.querySelector("#originals-slider");
  const originalsSliderHeight = originalsSlider.offsetHeight - 100;
  const maxSliderScrollDesktop = 67; // Maximum slider scroll percentage
  const isMobile = window.innerWidth <= 1050;
  if (!isMobile) {
    let sceneIsInAction = false;
    var sceneDesigns = new ScrollMagic.Scene({
      triggerElement: "#original-designs-wrapper",
      duration: 1500,
      triggerHook: 0,
    })
      .setPin("#original-designs-wrapper")
      .addTo(controller);
    sceneDesigns.on("enter", function (event) {
      sceneIsInAction = true;
    });

    sceneDesigns.on("leave", function (event) {
      sceneIsInAction = false;
    });

    const isElementAboveScreen = () => {
      const element = document.querySelector('#original-designs-wrapper');
      if (!element) return false;

      const rect = element.getBoundingClientRect();
      // If the bottom of the element is above the top of the viewport
      return rect.bottom < 0;
    };

    let isAboveTheScreen = undefined
    let scrollProgress = undefined

    document.addEventListener("mousewheel", () => {
      if(isAboveTheScreen === undefined){
        isAboveTheScreen = isElementAboveScreen()
        console.log(isAboveTheScreen)
        scrollProgress =  isAboveTheScreen ? maxSliderScrollDesktop : 0;
        originalsSlider.style.transform = `translateY(-${scrollProgress}%)`
      }
    })
    const scrollSensitivity = 0.07; // Adjust this value to control scroll speed // Adjust this value to control scroll speed

    const scrollDesignsSlider = (delta) => {
      if (sceneIsInAction) {
        scrollProgress += delta * scrollSensitivity;
        scrollProgress = Math.max(
          0,
          Math.min(maxSliderScrollDesktop, scrollProgress)
        );
        originalsSlider.style.transform = `translateY(-${scrollProgress}%)`;
      }
    };

    document.addEventListener(
      "mousewheel",
      (e) => {
        if (sceneIsInAction) {
          scrollDesignsSlider(e.deltaY);
        }
      },
      { passive: false }
    );
  }
};

function slideBestSellersAndNewArrivalsCarousel(direction) {
  const activeProductsList = document.querySelector(
    '#best-sellers-products-list:not([style*="display: none"]), #new-arrivals-products-list:not([style*="display: none"])'
  );

  if (!activeProductsList) return;

  const itemWidth = 345; // 325px width + 20px gap
  const scrollAmount = direction === "prev" ? -itemWidth * 4 : itemWidth * 4;

  if (direction === "prev" && activeProductsList.scrollLeft === 0) {
    return;
  }

  const isAtEnd =
    activeProductsList.scrollLeft + activeProductsList.clientWidth >=
    activeProductsList.scrollWidth - 10; // 10px tolerance
  if (direction === "next" && isAtEnd) {
    return;
  }

  activeProductsList.scrollBy({
    left: scrollAmount,
    behavior: "smooth",
  });
}
function toggleBestSellersAndNewArrivalsProducts(type) {
  const bestSellers = document.querySelector("#best-sellers-toggle");
  const newArrivals = document.querySelector("#new-arrivals-toggle");
  const shopAllLink = document.querySelector("#top-products-shop-all-button");
  const bestSellersProductsList = document.querySelector(
    "#best-sellers-products-list"
  );
  const newArrivalsProductsList = document.querySelector(
    "#new-arrivals-products-list"
  );
  const topProductsTogglesHr = document.querySelector(
    "#top-products-toggles-hr"
  );

  // First fade out both lists
  bestSellersProductsList.classList.add("fade-out");
  newArrivalsProductsList.classList.add("fade-out");

  // Wait for fade out to complete before switching
  setTimeout(() => {
    switch (type) {
      case "best-sellers":
        bestSellers.style.opacity = "1";
        newArrivals.style.opacity = "0.5";
        topProductsTogglesHr.style.left = "0";
        newArrivalsProductsList.style.display = "none";
        bestSellersProductsList.style.display = "flex";
        shopAllLink.href = "/best-sellers";
        // Remove fade out class to fade in
        setTimeout(
          () => bestSellersProductsList.classList.remove("fade-out"),
          50
        );

        break;
      case "new-arrivals":
        bestSellers.style.opacity = "0.5";
        newArrivals.style.opacity = "1";
        topProductsTogglesHr.style.left = "50%";
        bestSellersProductsList.style.display = "none";
        newArrivalsProductsList.style.display = "flex";
        shopAllLink.href = "/new-arrivals";
        // Remove fade out class to fade in
        setTimeout(
          () => newArrivalsProductsList.classList.remove("fade-out"),
          50
        );
        break;
    }
  }, 200); // Match this with the CSS transition duration
}

const handleBestSellersAndNewArrivalsCarousel = () => {
  const bestSellersProductsList = document.querySelector(
    "#best-sellers-products-list"
  );
  const newArrivalsProductsList = document.querySelector(
    "#new-arrivals-products-list"
  );
  const itemWidth = 345;
  let visibleItemsAmount = 4;

  if (window.innerWidth < 1020) visibleItemsAmount = 3;
  if (window.innerWidth < 680) visibleItemsAmount = 2;
  if (window.innerWidth < 540) visibleItemsAmount = 1;
};

const handleAdvantagesContentGrid = () => {
  let isHovered = false;

  const advantagesContentGrid = document.querySelector(
    "#advantages-content-grid"
  );
  const advantagesContentGridItems = advantagesContentGrid.querySelectorAll(
    ".carousel-background-video, .carousel-background-image"
  );
  const carouselBackgroundLayerContainer =
    advantagesContentGrid.querySelectorAll(
      ".carousel-background-layer-container"
    );
  const carouselContent = advantagesContentGrid.querySelectorAll(
    ".carousel-content"
  );
  const carouselBackgroundThumbnail = advantagesContentGrid.querySelectorAll(
    ".carousel-background-thumbnail"
  );
  if (!isHovered) {
    advantagesContentGridItems[0].classList.remove("sepia");
    carouselBackgroundLayerContainer[0].classList.add("active-layer");
    carouselContent[0].classList.add("carousel-content-active");
    carouselBackgroundThumbnail[0].style.opacity = "0";
  }
  const makeDefaultBlockActive = () => {
    advantagesContentGridItems[0].classList.remove("sepia");
    carouselBackgroundLayerContainer[0].classList.add("active-layer");
    carouselContent[0].classList.add("carousel-content-active");
    carouselBackgroundThumbnail[0].style.opacity = "0";
  };
  const cleanInitialHover = () => {
    advantagesContentGridItems[0].classList.add("sepia");
    carouselBackgroundLayerContainer[0].classList.remove("active-layer");
    carouselContent[0].classList.remove("carousel-content-active");
    carouselBackgroundThumbnail[0].style.opacity = "1";
    isHovered = true;
  };
  advantagesContentGridItems.forEach((item, index) => {
    item.addEventListener("mouseenter", () => {
      cleanInitialHover();
      item.classList.remove("sepia");
      carouselBackgroundLayerContainer[index].classList.add("active-layer");
      carouselContent[index].classList.add("carousel-content-active");
      if(index < 2){
        carouselBackgroundThumbnail[index].style.opacity = "0";
      }
    });
    item.addEventListener("mouseleave", () => {
      cleanInitialHover();
      item.classList.add("sepia");
      carouselBackgroundLayerContainer[index].classList.remove("active-layer");
      carouselContent[index].classList.remove("carousel-content-active");
      if(index < 2){
        carouselBackgroundThumbnail[index].style.opacity = "1";
      }
    });
  });
  advantagesContentGrid.addEventListener("mouseleave", () => {
    makeDefaultBlockActive()
  });
};

const fillBottomGap = () => {
  const currentPath = window.location.pathname;
  if (currentPath !== '/' && currentPath !== '/home') {
    return;
  }

  let bottomGapDiv = document.getElementById('bottom-gap');
  if (!bottomGapDiv) {
    bottomGapDiv = document.createElement('div');
    bottomGapDiv.id = 'bottom-gap';
    bottomGapDiv.style.position = 'fixed';
    bottomGapDiv.style.bottom = '0';
    bottomGapDiv.style.left = '0';
    bottomGapDiv.style.width = '100%';
    bottomGapDiv.style.height = '30px';
    bottomGapDiv.style.backgroundColor = '#efeeea';
    bottomGapDiv.style.zIndex = '100';
    bottomGapDiv.style.display = 'none';
    document.body.appendChild(bottomGapDiv);
  }

  // Check for scroll position and show/hide the div
  window.addEventListener('scroll', () => {
    const scrollPosition = window.scrollY + window.innerHeight;
    const pageHeight = document.body.scrollHeight;

    // If scrolled to the bottom (with a small tolerance)
    if (pageHeight - scrollPosition < 10) {
      bottomGapDiv.style.display = 'block';
    } else {
      bottomGapDiv.style.display = 'none';
    }
  });
}


/*!
 * app.ui.category.js
 */
(function (app, rv, $) {
	var $cache = {
		catProducts: $('#rove_products'),
		defaultGrid: 4,
		termForm: $('#uc-display-term-form'),
		items: $('#rove_products>.row')
	};

	function initializeEvents() {
		$('.icon-toggle a').on('click', function (e) {
			e.preventDefault();
			app.category.gridSizeChange($(this).hasClass('icon-4x') ? 4 : 6);
		});

		$('.product_inlay').on('click', function () {
			var href = $(this).find('a').first().attr('href');
			window.location.href = href;
		});

		// Update URL for every input change
		$cache.termForm.find('input').on('change', function () {
			let $this = $(this);
			let sortedVal = $this.val();
			let enabled = true; // whether or not we are adding or removing
			if (typeof sortedVal === 'object' && sortedVal) {
				sortedVal.sort();
			}

			switch ($this.attr('type')) {
				case 'checkbox':
				case 'radio':
					enabled = $this.is(':checked') || $this.is(':selected');
					break;
				default:
					enabled = sortedVal.length;
					break;
			}

			if (!enabled) {
				// remove from url
				app.util.replaceUrlState(decodeURIComponent(app.util.removeParamFromURL(window.location.href, $this.attr('name'))), null);
			} else {
				// add or update url
				let params = {};
				params[$this.attr('name')] = sortedVal;
				app.util.replaceUrlState(decodeURIComponent(app.util.appendParamsToUrl(window.location.href, params)), null);
			}
		});

		// Append to the current URL our new selection
		$cache.termForm.find('select').on('change', function () {
			// This will update window history if true on change
			let $this = $(this);
			if ($this.find('option[value="' + $this.val() + '"]').data('url')) {
				let url = app.util.getUri(window.location.href);
				app.util.replaceUrlState($this.find('option[value="' + $this.val() + '"]').data('url') + url.query + url.hash, null);
				//window.location.reload();
				app.page.refresh();
			} else {
				let sortedVal = $this.val();
				if (typeof sortedVal === 'object' && sortedVal) {
					sortedVal.sort();
				}
				let params = {};
				params[$this.attr('name')] = sortedVal;
				app.util.replaceUrlState(decodeURIComponent(app.util.appendParamsToUrl(window.location.href, params)), null);
			}
		});
	}

	function initializeDom() {
		// Set default grid display
		if (parseInt($.cookie('rove_grid')) > 0) {
			//$cache.catProducts.removeClass('grid-4x').removeClass('grid-6x').addClass('grid-'+$.cookie('rove_grid')+'x');
			app.category.gridSizeChange($.cookie('rove_grid'));
		}
	}

	app.category = {
		init: function () {
			app.category.pagerInit();
			app.category.openSwatchPreview();

			initializeDom();
			initializeEvents();

			// custom style selects
			app.components.selectStyle(true); // true = replace state (history)

			// Auto Scroll
			app.category.initAutoScroll();

			app.category.drupalAjax();
		},

		drupalAjax: function() {
			// invoke triggered
			$.fn.updateSaleInfo = function(data) {
				app.category.updateSaleInfo(data);
			};

			// Category pages function to append selections to the url location
			$.fn.uc_display_pushstate = function(data) {
				app.category.updatePushState(data);
			};

			// Indicator when category has updated (form submit)
			$.fn.categoryUpdated = function() {
				//$(document).trigger('categoryUpdated');
				app.category.pagerInit();
			};
		},

		gridSizeChange: function (gridSize) {
			gridSize = parseInt(gridSize);
			$('.icon-toggle a').removeClass('active');
			$('.icon-' + gridSize + 'x').addClass('active');
			let $inlay = $('.product_listing:not(.product_inlay)');
			let size = 12 / gridSize;
			let inverse = 12 / size === 4 ? 12 / 6 : 12 / 4;

			$inlay.addClass('col-md-' + size).removeClass('col-md-' + inverse);
			$inlay.addClass('col-lg-' + size).removeClass('col-lg-' + inverse);
			$cache.catProducts.addClass('grid-' + gridSize + 'x').removeClass('grid-' + (12 / inverse) + 'x');
			$('input.grid-column').val(gridSize);

			//let $last = $('a#next:last');
			if ($cache.next.length && $cache.next.attr('href').indexOf('?') === -1) {
				$cache.next.attr('href', $cache.next.attr('href') + '?columns=' + gridSize);
			} else if ($cache.next.length) {
				$cache.next.attr('href', $cache.next.attr('href').replace('columns=' + (12 / inverse), 'columns=' + gridSize));
			}

			$.cookie('rove_grid', gridSize, {
				expires: 14,
				path: '/',
				domain: app.util.getUri(window.location.href).host
			});

			if ($cache.defaultGrid === gridSize) {
				app.util.replaceUrlState(decodeURIComponent(app.util.removeParamFromURL(window.location.href, 'columns')), null);
			} else {
				let params = {};
				params['columns'] = gridSize;
				app.util.replaceUrlState(decodeURIComponent(app.util.appendParamsToUrl(window.location.href, params)), null);
			}

			$(document).trigger('heightChange');
		},

		initAutoScroll: function () {
			let $window = $(window);
			let $document = $(document);

			let scrollPercent = 0.55;
			let scrollPoint = ($document.height() - $window.height()) * scrollPercent;

			let backTopID = "btn-backTop";
			let backTopScrollPoint = $(window).height() * 3;

			$window.on('scroll.cat', function () {
				let sTop = $window.scrollTop();
				if (sTop > scrollPoint) {
					if ($cache.next.length > 0 && !$cache.next.data('busy') && !app.ui.content.data('busy')) {
						app.ui.content.data('busy', true);

						$('<div/>', {
							class: 'rove-load-more', 'aria-label': 'Looking for more products'
						}).append($('<span/>', {class: 'icon-load icon-large'})).appendTo($cache.catProducts);
						app.category.loadProducts($cache.next, $cache.next.attr('href'));
						$("[data-wistia],[data-wistia-mobile],[data-video],[data-video-mobile]").each(function () {
							app.components.reloadVideo($(this));
						});

						// update url so if a user comes back we know how many items to preload
						if (false && history.pushState) {
							let numitems = $cache.items.find('.product_listing').not('.product_inlay').length;
							let url = app.util.appendParamsToUrl(window.location.href, {
								"lastViewed": (numitems + 1)
							});
							app.util.replaceUrlState(url, null);
						}

					}
				}

				// no button
				if (sTop > backTopScrollPoint && !$cache.backToTop) {
					$cache.backToTop = $("<a/>", {
						"id": backTopID,
						"class": "hidden-phone",
						"html": app.resources.BACK_TO_TOP
					}).append($("<span/>", {
						"class": "icon-arrow rotate-270"
					})).appendTo('body').fadeIn();
					$("#" + backTopID).on('click', function (e) {
						e.preventDefault();
						$('html, body').animate({
							scrollTop: 0
						}, 400);
					});
				} else if (sTop > backTopScrollPoint && $cache.backToTop) {
					$cache.backToTop.fadeIn();
				} else if (sTop <= backTopScrollPoint && $cache.backToTop) {
					$cache.backToTop.fadeOut();
				}
			});

			$(document).on('heightChange', function () {
				setTimeout(function () {
					scrollPoint = ($document.height() - $window.height()) * scrollPercent;
					app.ui.content.data('busy', false);
				}, 2000);
			});
		},

		pagerInit: function() {
			// reset scroll points
			$(document).trigger('heightChange');

			// Reset elements as they have been replaced.
			$cache.next = app.ui.content.find('a#next:last');
			$cache.catProducts = $('#rove_products');
			$cache.items = $('#rove_products>.row');

			// Reset data content
			app.ui.content.data('busy', false);
		},

		loadProducts: function (button, url) {
			let $button = $(button);
			$.get(url, function (e) {
				$('.rove-load-more').remove();

				// If there are no more items...
				if (typeof e.items === 'undefined' || $cache.next.data('lock')) {
					$cache.next.data('lock',true);
					return;
				}

				let $items = e.items;
				let $details = e.details;

				for (let i = 0; i < $items.length; i++) {
					$cache.items.append($items[i].html);
				}

				// Load videos if applicable
				$("[data-wistia],[data-wistia-mobile],[data-video],[data-video-mobile]").each(function () {
					if (!$(this).children().length) {
						app.components.reloadVideo($(this));
					}
				});

				// Refresh sale items.
				//$(document).updateSalesHTML('.product_sale_display');

				// Tracking API
				//Drupal.settings.segment.products = $.merge(Drupal.settings.segment.products,$details);
				//if ($.isFunction($(window).segmentApi)) {
				//	$(document).segmentApi({op:'browse', action: 'list', products: $details});
				//}

				// Update the pager
				let currenturl = app.util.getUri($cache.next.attr('href'));
				let newpath = currenturl.path.split('/');
				newpath.shift();
				newpath[4] = parseInt(newpath[4]) + 1;
				$cache.next.attr('href', currenturl.protocol + '//' + currenturl.host + '/' + newpath.join('/') + currenturl.query);

				$(document).trigger('heightChange');
				$(document).trigger('pagerNext');

        app.abtest.abtestCategory();
			});
		},

		/**
		 * Update sale information via ajax callback (ajax_info.json)
		 * @param  {[type]} data [description]
		 * @return {[type]}      [description]
		 */
		updateSaleInfo: function(data) {
			Drupal.settings.sales_data = data.data;
			app.category.updateSalesHTML(data.selector);
		},
		updateSalesHTML: function(selector) {
			$(selector).each(function() {
				if (typeof Drupal.settings.sales_data !== 'undefined' &&
					typeof Drupal.settings.sales_data[$(this).data('infonid')] !== 'undefined' &&
					typeof Drupal.settings.sales_data[$(this).data('infonid')][$(this).data('infomodel')] !== 'undefined') {
					let info = Drupal.settings.sales_data[$(this).data('infonid')][$(this).data('infomodel')];
					let totalDiscount = Math.floor(info.sell_price - Math.round((info.sell_price - info.amt) * (1 - Drupal.settings.memberDiscount)));
					let csymbol = (info.currency === 'CAD' ? 'C$' : '$');
					// let string = parseInt(info.available) === 0 ? Drupal.t('Sold Out') : Drupal.t('Save !amt &mdash; !available Left',{'!amt':info.amt,'!available':info.available});
					let string = parseInt(info.available) === 0 ? Drupal.t('Sold Out') : Drupal.t('Members Save !c!amt',{'!amt':totalDiscount, '!c':csymbol});
					if(info.available === '10+' || info.available === 'Limited Stock'){
						// string = Drupal.t('Save !amt &mdash; Limited Stock',{'!amt':info.amt});
						string = Drupal.t('Members Save !c!amt',{'!amt':totalDiscount, '!c':csymbol});
					}
					$(this).html(string);
				}
			});
		},
		updatePushState: function(data) {
			let par = window.location.pathname;
			let key; // iterator
			if (typeof data.filtering !== 'undefined') {
				for (key in data.filtering) {
					if (data.filtering.hasOwnProperty(key)) {
						switch(typeof(data.filtering[key])) {
							case 'object':
								for (var subkey in data.filtering[key]) {
									if (data.filtering[key].hasOwnProperty(subkey)) {
										par = app.util.appendParamToURL(par,key+'['+subkey+']',data.filtering[key][subkey]);
									}
								}
								break;
							//case 'string':
							default:
								par = app.util.appendParamToURL(par,key,data.filtering[key]);
								break;
						}
					}
				}
			}
			if (typeof(data) !== 'undefined') {
				for (key in data) {
					if (data.hasOwnProperty(key)) {
						if (key !== 'filtering') {
							par = app.util.appendParamToURL(par,key,data[key]);
						}
					}
				}
			}
			app.util.appendParamToURL(par,'','');
		},
    openSwatchPreview: function (){
		  let showed = [];
      function showSwatch(){
        $(".swatch-pre-opener").each(function(i){
          showed[i] = false;
          $(this).on("click", function(){
            $(".swatch_preview").addClass("hidden")
            if (!showed[i]){
              $(this).siblings(".swatch_preview").removeClass("hidden")
              showed[i] = true;
            } else {
              showed[i] = false;
            }

          })

        })

        $(".swatch-pre-opener").hover(function(){
          // $(".swatch_preview").addClass("hidden")
          $(this).siblings(".swatch_preview").removeClass("hidden")
        }, function (){
          $(this).siblings(".swatch_preview").addClass("hidden")
        })
        $(".swatch_preview").hover(function(){
          $(this).removeClass("hidden")
        }, function (){
          $(this).addClass("hidden")
        })
      }

      showSwatch();
      let observer = new MutationObserver(function( mutations ) {
        showSwatch();
      });

      observer.observe($("#rove_products").parent("div")[0], {
        childList: true,
        subtree: true,
      });
    }
	};
}(window.app = window.app || {}, window.rv, jQuery));
/*!
 * app.product.js
 */
(function (app, $) {
  let $cache = {};

  function initializeCache() {
    $cache = {
      'window': $(window),
      ajaxRunning: false,
      document: $(document),
      mobileUseRatio: true, // Fix width to window size on widest image
      mobileLowestRatio: 9999,    // Placeholder
      mobileMaxHeight: 256,   // If mobileUseRatio = false
      enableScrollLock: false, // Enables focus scrolling
      actionsWrap: $('#product-actions'),
      stickWrap: $('#product-stick'),
      check: $('<div/>', {class: 'check_image'}),
      resizeTimeout: null,
      windowWidth: null,
      lastScrollTop: 0,
      direction: '',
      backTopID: "btn-backTop",
      panelRecalculate: false,

      productWrap: $('.node-product'),
      productImages: $('.photo-item>img, .photo-item picture>img'),
      productVideos: $('.product-videos'),
      photoContainer: $('.product-photos-container'),
      videoContainer: $('#videoOverlay'),
      addToCartForm: $('.add-to-cart>form'),
      addToCartBtn: $('.node-add-to-cart'),
      addToCartSelected: $('.selected-variant'),
      // checkoutBtn: $('.checkout-btn'),
      mfBtn: $('.mf-btn'),
      vsBtn: $('.vs-btn'),
      swatchFilters: $('#product_swatch_filter'),
      mediaWrapper: $("#product-media-wrap"),
      imageWrapper: $("#product-img-wrap"),
      navThumbs: $(".image-nav-thumbs"),
      breakdown: $('.breakdown'),
      popOvers: $('.product-swatch-popovers'),
      reviewWall: null,
      productState: 'ONLY_STOCK',

      destinationPopup: $('.destination-popup'),
      destinationPopupUpdate: $('.destination-popup, .restricted-region-entry').find('a'),
      destinationLocation: $('.delivery-location'),
      destinationRestriction: $('.restricted-region-entry'),

      // Trials
      //trialProceedConfirmed: false
    };
    $cache.windowWidth = $cache.window.width();
    $cache.backTopScrollPoint = ($cache.window.height() * 3);
    $cache.pos = 0;
    $cache.infoTip = $('.member-info').clone();
  }


  function initializeDom() {
    // Set what the current displayed model is (images)
    // Based on uc_attribute_group_get_defaults -> $_GET['aid'] is already fixed
    // So if it doesnt match the combination, we can replace it below if set
    let $esiFind = $('[data-modeldefaults]');
    if ($esiFind.length && $esiFind.data('modeldefaults').length) {
      $cache.current_model_display = Drupal.settings.default_model = $esiFind.data('modeldefaults');
    } else {
      $cache.current_model_display = Drupal.settings.default_model;
    }

    // Init images
    app.product.initImageEvents();

    app.product.moveVideoToSecondPosition();

    app.product.stickyAddToCart();

    // Make sure selections are valid
    if ($cache.current_model_display) {
      if (!app.product.modelValidate($cache.current_model_display)) {
        // model is currently not validated to add to cart
        // todo: change default model
      }
    }

    let selModel = app.product.getSelectedModel(app.product.getSelectedOptions());
    if (selModel) {
      // Configuration text needs updating always
      app.product.updateButton(selModel);
      // app.product.checkoutBtn();
      // app.product.mfBtn();

      // Change/update final sale text
      app.product.finalSale(selModel);
    }

    // Patch delivery text on initial load even when selModel is empty and updateButton wasn't called
    (function () {
      var _savedPostal = ($.cookie('destination-override-' + app.getCountry().toLowerCase()) || '').replace(/\s/g, '').toUpperCase();
      var _isFastDelivery = app.getCountry() === 'CA'
        ? new Set((Drupal.settings.fastDeliveryCaFsas || [])).has(_savedPostal.substring(0, 3))
        : new Set((Drupal.settings.fastDeliveryUsZips || [])).has(_savedPostal);
      if (_isFastDelivery) {
        $('.config-status').html(function (_, html) {
          return html.replace('Delivery in 1-3 weeks', 'Delivery in 3-5 days');
        });
      }
    })();

    // Obtain the params from the default model (passed in from esi)
    let selModelParams = {};
    if (typeof Drupal.settings.product_models[selModel] !== 'undefined') {
      // Not the right count of aid[] passed for model
      for (let x in Drupal.settings.product_models[selModel]) {
        if (Drupal.settings.product_models[selModel].hasOwnProperty(x)) {
          selModelParams[$('li[data-oid="' + Drupal.settings.product_models[selModel][x] + '"]').data('material')] = Drupal.settings.product_models[selModel][x];
        }
      }
    }

    // First check if there is a preset param set
    let search = app.product.getWindowSearch();
    if (decodeURIComponent(search).indexOf('aid[') !== -1) {
      // make the url look a little nicer
      app.util.replaceUrlState(decodeURIComponent(app.util.appendParamsToUrl(decodeURIComponent(app.product.emptyLocationParams()), app.util.getQueryStringParams(app.product.getWindowSearch()))), null);
      search = app.product.getWindowSearch();
      let initParams = app.util.getQueryStringParams(search);
      let filterParams = {};
      let regex = /aid\[([0-9]+)\]/gm;
      // Params will look like {aid[00]: 000} not {75: 000}
      for (let x in initParams) {
        if (initParams.hasOwnProperty(x)) {
          if (x.indexOf('aid[') !== false) {
            filterParams[x.replace(regex, '$1')] = parseInt(initParams[x]);
          }
        }
      }

      // Is there a difference of the two arrays?
      if (app.util.differenceOf2Arrays(filterParams, selModelParams).length > 0) {
        // We want the default to override
        app.product.resetLocationParams(selModelParams);
        //app.product.emptyLocationParams();
      }

      // Validate selected params as a sellable product
      //app.product.validateSelectedParams(selModelParams,selModel);

      // todo: not sure if we even need this anymore?
      if (selModel === app.product.getSelectedModel(app.product.getSelectedOptions())) {
        $cache.current_model_display = selModel;
        app.product.updateImages(initParams);
      }

      // Calculate top...
      app.product.recalculateStickyPosition();
    } else {
      // Validate default product
      //if (!app.product.validateSelectedParams(app.product.getSelectedOptions(),selModel)) {
      // todo: set selected options based on Drupal.settings.default_model
      // todo: what to return from validateSelectedParams? - false?
      //}
    }


    // Video link
    //append($('<div/>',{class:'video-play-btn'}).html('play video').prepend($('<span/>',{class:'icon-play-dark'})));

    // Handle swatch hovers
    app.product.handlePopovers();

    let $img = $cache.productImages.first();
    if (!app.isMobile()) {
      // Hiding this option for now
      //app.components.selectStyle(true);

      // Init sticky
      $img.imageloaded(function () {
        // show product copy after purchase panel scroll behavior is initialized
        //app.components.stick($cache.productWrap, $cache.stickWrap, false, 0, '');
      });
      app.addEventListener('app.product.scrollLock', 'scroll');

      $cache.popOvers.width($cache.actionsWrap.width());
    } else {
      // We add a class for the video button to show after first image is loaded
      $img.imageloaded(function () {
        $cache.productWrap.addClass('img-loaded');
      });

      $cache.popOvers.width('');
    }

    // Colorbox images
    app.product.imageColorbox();

    // Colorbox video click + plays
    app.product.initVideo();

    // Disable all unavailable swatches in the active set
    app.product.disableUnavailableSwatches();

    // Assign a resize handler for the product
    app.addEventListener('app.product.resizeHandler', 'resize');

    // Listen to swatch changes
    app.product.initSwatch();

    // Format the reviews
    app.product.reviewWall();

    // Mobile Swatch Popup
    if ($cache.windowWidth < 769){
      app.product.mobileSwatch();
    }

    //Load upsell popup
    // app.product.upsellPopup();

    // Setup Customer Gallery colorbox modal
    app.myrove.sm_load_colorbox('init');


    //Listen to quantity change
    $("[id*='edit-qty']").on("change", function () {
      let selectedOptions = app.product.getSelectedOptions();
      let selectedModel = app.product.getSelectedModel(selectedOptions);
      app.product.updateBreakdown(selectedModel);
    })


    // Track lookbook clicks from product page
    $cache.document.on('click', '.vs-btn, .mf-btn, .download-lookbook', function (e, types) {
      app.tracking.track('lookbookEngage', {
        lookbook: $(this).hasClass('vs-btn') ? 'Vegan Suede' : ($(this).hasClass('mf-btn') ? 'Microfiber' : 'Product Page'),
      });
    });
  }

  function initializeEvents() {
    app.util.bindFirst($cache.addToCartBtn, 'mousedown', function (e) {
      e.preventDefault();

      app.components.linkLoader($cache.addToCartBtn);

      //let trial = {enable: false};

      // Is cart available to add?
      // if (!app.product.trialCartActive() && app.product.trialProductIsTrial()) {
      //   // Cart has non trial items and we are trying to add a bedding item for free trial
      //   trial = $.extend(trial, {
      //     enable: true,
      //     title: 'Free Trial',
      //     warnings: 'Free trial is only available to bedding products. ' +
      //       'Please place a separate order for any additional products.',
      //     buttons: {
      //       yes: 'Yes, Proceed',
      //       no: {
      //         prefix: 'Continue with my current cart - ',
      //         text: 'Go Back'
      //       }
      //     }
      //   });
      // } else if ((app.product.trialCartActive() && typeof Drupal.settings.track.cart.items !== "undefined" && Drupal.settings.track.cart.items.length > 0) && !app.product.trialProductIsTrial()) {
      //   // Cart is free trial and we are adding a non free trial item
      //   trial = $.extend(trial, {
      //     enable: true,
      //     title: 'Free Trial Notification',
      //     warnings: 'Free trial is only available to bedding products. Adding ' +
      //       Drupal.settings.product.title + ' to your cart will void the free trial. ' +
      //       'Please place a separate order for a bedding free trial.',
      //     buttons: {
      //       yes: 'Yes, Add to Cart',
      //       no: {
      //         prefix: 'Continue with my free trial - ',
      //         text: 'Go Back'
      //       }
      //     }
      //   });
      // }

      // Do we want to continue with trial popup?
      // if (trial.enable && !$cache.trialProceedConfirmed) {
      //   // Prevent other binds from executing
      //   e.stopImmediatePropagation();
      //   e.stopPropagation();
      //
      //   // Create modal
      //   $('#wrap>div.modal_hold').find('#trialAddModal').parent().remove();
      //   $('#wrap').append($('<div/>', {class: 'modal_hold hidetoggle'}).append(app.product.trialModal(trial)));
      //
      //   // Set the modal window in cache
      //   $cache.trialModal = $('#trialAddModal');
      //
      //   let promise = app.product.trialAddToCart();
      //   promise.done(function () {
      //     if (app.product.trialProductIsTrial()) {
      //       // Remove all non free trial items.
      //       $.ajax({
      //         url: '/free-trial/api/remove-non-trial-items',
      //         method: 'POST'
      //       }).done(function (data) {
      //         $.colorbox.close();
      //         // Continue with rest of submissions
      //         $cache.trialProceedConfirmed = true;
      //         $cache.addToCartBtn.trigger('mousedown');
      //         Drupal.settings.track.cart = data.items;
      //       }).fail(function () {
      //         $('#cboxLoadedContent .message-popup .warnings').replaceWith(
      //           $('<div/>', {class: 'alert alert-block alert-danger messages error'}).text('There has been an error. Please try again ' +
      //             'and close this dialog.')
      //         );
      //         $('#cboxLoadedContent .message-popup .actions').remove();
      //       });
      //     } else {
      //       // Just continue adding product since this is not a free trial item
      //       $.colorbox.close();
      //       $cache.trialProceedConfirmed = true;
      //       $cache.addToCartBtn.trigger('mousedown');
      //     }
      //   });
      //   promise.fail(function () {
      //     $.colorbox.close();
      //   });
      // } else {
      //   // This will occur second time though after cart triggers mousedown above
      //   //$cache.trialProceedConfirmed = false;
      // }
    });
    /*
    $cache.addToCartBtn.on('mousedown', function (e) {
        e.preventDefault();
    });
    */

    // linkLoader turn off if colorbox modal closed
    $(document).on('cbox_closed', function () {
      $(".node-add-to-cart").trigger('ajaxEnded');
    });

    if (typeof app.klarna !== 'undefined') {
      app.klarna.productObserver();
    }

    $(document).ajaxSend(function (event, jqxhr, sett) {
      if (sett.url === window.location.pathname) {
        $cache.ajaxRunning = true;
        $cache.addToCartBtn.attr('disabled', 'disabled');
      }
    });
    $(document).ajaxStop(function () {
      $cache.ajaxRunning = false;
      $cache.addToCartBtn.attr('disabled', !!$cache.addToCartBtn.data('disabled'));
    });

    // Changing 'Available', 'Custom', 'Expedited'
    $('.filter-tabs-triggers a').on('click', function (e) {
      e.preventDefault();
      app.product.swatchDisplayChange($(this));
    });

    // Notify me button
    app.product.notifyMeInit();

    // Destination Postal Code
    app.product.destinationInit();

    // Swatch icon changing
    //$cache.actionsWrap.on("click", "li.swatch_opt", app.product.onChangeSwatchHandler);

    // swatch tips (bigger then ipad)
    $('#product-swatches li.swatch_opt').on('mouseenter', function () {
      if (!app.isMobile()) {
        $('.txt_opt' + $(this).data('oid')).show();
      }
    }).on('mouseleave', function () {
      if (!app.isMobile()) {
        $cache.popOvers.find('.txt_opt' + $(this).data('oid')).hide();
      }
    });

    // Video play button
    $('.video-play-btn').on('click', function () {
      let $this = $(this);
      // GA event tracking
      if (typeof ga !== 'undefined' && $.isFunction(ga)) {
        let event_label = $this.closest('.node-product').attr('about');
        ga('send', 'event', 'Video', 'play', event_label);
      }

      let $vid = $('.product-videos-container .vid-preview');
      let mq = window.matchMedia('(min-width: 768px)');
      if (mq.matches) {
        $([document.documentElement, document.body]).animate({
          scrollTop: $cache.productVideos.offset().top
        }, 1000, function () {
          $vid.trigger('click');
        });
      } else {
        $vid.trigger('click');
      }
    });

    // Load video is tag is set
    if (app.util.getUri(window.location.href).hash === '#play-video') {
      $('.video-play-btn').trigger('click');
    }

    // Sticky event - If ajax or pagination occurs on actionsWrap, then we want to trigger this event
    $("body").on("stickyPanelRecalculate", function () {
      app.product.recalculateStickyPosition();
    });

    // Tabs change the height for sticky.
    $cache.actionsWrap.find('[data-toggle=tab]').on('click', function (e) {
      e.preventDefault();
      app.product.recalculateStickyPosition();
    });

    // Make sure a swatch is chosen
    if (!$('#swatches_group li.selected').is(':visible')
      && $('#swatches_group .check_image').parents('li').not(':visible')) {
      $('.trigger-custom').trigger('click');
    } else if ($('#swatches_group li.selected').length === 0) {
      // Make sure something is checked.
      $('#swatches_group li:visible').first().trigger('click');
    }
    // This will make instock items primary first even though it might not actually be the default selection...
    // DONT WANT THIS RIGHT NOW
    if (false && !$('#swatches_group li.selected').is(':visible')) {
      // Automatically select the first visible swatch
      $('#swatches_group li:visible').first().trigger('click');
    }
  }

  app.product = {

    init: function () {
      initializeCache();
      initializeDom();
      initializeEvents();

      //Member info popup
      app.product.showPrice();
      app.components.memberInfo();
      app.product.instockOnlyCheck();

      app.product.productFeaturesBlock();

      if ($("body").hasClass("product-v2")) {
        app.product.productUgcV2();
      }

      if ($("#dqe-block .owl-carousel").length > 0){
        app.product.dqeBlocks();
      }

      let $country = app.getCountry();
      if ($country === "CA") {
        app.product.financeCA();
      } else if ($country === "KR") {
        app.product.koreanTranslation();
      }

      // if ($(window).width()<769){
      //   app.product.mobileCustomerPhoto();
      // }

      // For Ophelia bed
      app.product.externalSiteLink();

    },

    // Validate that a model is able to add to cart
    modelValidate: function (model) {
      // Make sure selections are valid
      if (model) {
        let options = Drupal.settings.product_models[model];
        // Verify the model is selectable
        for (let x in options) {
          if (options.hasOwnProperty(x)) {
            let oid = options[x];
            switch ($cache.productState) {
              case "ONLY_STOCK":
                if (!$('#product-swatches').find('li.opt' + oid).length) {
                  return false;
                }
                break;
              case "DISABLE_CUSTOM":
                break;
              case "DISABLE_CUSTOM_840":
                break;
              case "DISABLE_CUSTOM_124":
                break;
              default:
                break;
            }
          }
        }
        return true;
      }
      return false;
    },

    // Add to cart was triggered, how do we proceed?
    // trialAddToCart: function () {
    //   let deferred = new $.Deferred();
    //
    //   let colorbox = {
    //     fixed: true,
    //     open: true,
    //     overlayClose: false,
    //     scrolling: false,
    //     maxHeight: '100%',
    //     maxWidth: '100%',
    //     width: '500px',
    //     initialWidth: '500px',
    //     initialHeight: '500px',
    //     className: 'add-to-cart-modal'
    //   };
    //   if (app.isMobile()) {
    //     colorbox.initalHeight = colorbox.initialWidth = colorbox.width = colorbox.height = '100%';
    //   }
    //   colorbox = $.extend({inline: true, href: '#' + $cache.trialModal.attr('id')}, colorbox);
    //   colorbox.onClosed = deferred.reject;
    //
    //   // On approve, resolve promise
    //   $cache.trialModal.on('trialAddValid', deferred.resolve);
    //
    //   $.colorbox(colorbox);
    //
    //   // On 'Yes' we want to go ahead
    //   $cache.trialModal.find('button.trialYes').on('click', function (e) {
    //     e.preventDefault();
    //     $cache.trialModal.trigger('trialAddValid');
    //     //deferred.resolve;
    //   });
    //   $cache.trialModal.find('a.trialNo').on('click', deferred.reject);
    //
    //   // Always run on success or failure
    //   deferred.always(function () {
    //     //$.colorbox.close();
    //   });
    //
    //   return deferred;
    // },

    // Is the cart empty or have only bedding items
    // trialCartActive: function () {
    //   // Are any products in cart not a bedding product?
    //   let items = typeof Drupal.settings.track.cart !== 'undefined'
    //   && typeof Drupal.settings.track.cart.items !== 'undefined' ?
    //     Drupal.settings.track.cart.items : [];
    //   if (!items.length) {
    //     return true;
    //   }
    //
    //   for (let k in items) {
    //     if (items.hasOwnProperty(k)) {
    //       if (items[k].category.indexOf('Bedding') === -1) {
    //         //if (items[k].category.indexOf('Side Chairs') === -1) {
    //         return false;
    //       }
    //     }
    //   }
    //   return true;
    // },

    // Is the current product a free trial product?
    // trialProductIsTrial: function () {
    //   return Drupal.settings.product.brand === 'Rora'; // TODO: Use this
    //   //return Drupal.settings.product.model === "HW5";
    // },

    // The HTML for the trial popup modal
    // trialModal: function (trial) {
    //   return $('<div/>', {id: 'trialAddModal'})
    //     .append($('<div/>', {class: 'message-popup'})
    //       .append($('<h2/>').text(trial.title))
    //       .append($('<div/>', {class: 'warnings'}).text(trial.warnings))
    //       .append($('<div/>', {class: 'actions'})
    //         .append($('<div/>')
    //           .append($('<button/>', {class: 'trialYes ignore-warning-btn btn btn-secondary full-width'}).text(trial.buttons.yes))
    //         )
    //         .append($('<div/>')
    //           .append($('<span/>').text(trial.buttons.no.prefix))
    //           .append($('<a/>', {class: 'trialNo'}).text(trial.buttons.no.text))
    //         )
    //       )
    //     );
    // },

    resizeHandler: function () {
      clearTimeout($cache.resizeTimeout);
      $cache.resizeTimeout = setTimeout(function () {
        if ($cache.window.width() !== $cache.windowWidth) {
          app.product.initImageEvents();
          app.product.handlePopovers();

          // Update the window width for next time
          $cache.windowWidth = $cache.window.width();
          if (!app.isMobile()) {
            //app.components.restick($cache.productWrap, $cache.stickWrap);
            //app.components.restick($('#product'), $('#pdp-thumbnails-stuck'));
            if (!app.checkEventListener('app.product.scrollLock', 'scroll')) {
              app.addEventListener('app.product.scrollLock', 'scroll');
            }
          } else {
            app.product.scrollLockRemove();
            if (app.checkEventListener('app.product.scrollLock', 'scroll')) {
              app.removeEventListener('app.product.scrollLock', 'scroll');
            }

          }
        }
      }, 500);
    },

    // Resize the container of the swatch popovers
    handlePopovers: function () {
      if (!app.isMobile()) {
        $cache.popOvers.width($cache.actionsWrap.width());
      } else {
        $cache.popOvers.width('');
      }
    },

    recalculateStickyPosition: function () {
      $cache.panelRecalculate = true;
      if ($cache.panelRecalculate && $cache.mediaWrapper.height() < $cache.stickWrap.height() + parseInt($cache.stickWrap.css("top"))) {
        $("html, body").animate({
          scrollTop: 0
        });
        $cache.stickWrap.css({
          top: 0
        })
      }
    },

    initImageEvents: function () {
      $cache.productImages = $('.photo-item>img, .photo-item picture>img');

      let $imageContainer = $cache.productWrap.find("#product-photos");
      let $photoItems = $cache.imageWrapper.find('.photo-item');

      // enable photoswipe on both mobile and iPad
      if (app.isMobile()) {
        // Remove styled selects for mobile
        // app.components.selectStyleDestroy($('.sf_mat select.select-hidden'));
        if ($cache.mobileUseRatio) {
          $imageContainer.find("img").each(function () {
            $cache.mobileLowestRatio = Math.min($(this).data('ratio'), $cache.mobileLowestRatio);
          });
          $cache.mobileMaxHeight = $cache.mobileLowestRatio * $cache.window.width();
        }

        // Images
        let imgwidths = 0;
        $.each($photoItems, function () {
          let $img = $(this).find('img');
          imgwidths += ($img.data('width') / ($img.data('height') / $cache.mobileMaxHeight)) + 4;
          $(this).width($img.data('width') * ($cache.mobileMaxHeight / $img.data('height')));
        });
        // Videos...
        $.each($cache.productVideos, function () {
          let $img = $(this).find('img');
          imgwidths += ($img.data('width') / ($img.data('height') / $cache.mobileMaxHeight)) + 4;
          $(this).width($img.data('width') * ($cache.mobileMaxHeight / $img.data('height')));
        });
        $cache.imageWrapper.width(imgwidths);
        $cache.imageWrapper.height($cache.mobileMaxHeight);
        $(".product-videos:not(.photo-item)").addClass("hidden");
        $(".lookbook-product-image").addClass("hidden");
      } else {
        // Make sure nothing is set on desktop
        $cache.mediaWrapper.css('width', '').css('height', '');
        $photoItems.css('width', '');
        $cache.productVideos.css('width', '');
        //app.components.selectStyle(true);
        //$('.gal').colorbox.remove();
      }

      if ($cache.imageWrapper.find("img").eq(0).height() > 2) {
        $cache.imageWrapper.css("height", $cache.imageWrapper.find("img").eq(0).height() + "px");
      }
      let x = new MutationObserver(function () {
        if ($cache.imageWrapper.find("img").eq(0).height() > 2) {
          $cache.imageWrapper.css("height", $cache.imageWrapper.find("img").eq(0).height() + "px");
        }
      });
      if ($cache.imageWrapper.find("img").length) {
        x.observe($cache.imageWrapper.find("img").eq(0)[0], {attributes: true});
      }
      $cache.imageWrapper.find("picture").css("width", $cache.mediaWrapper.width() + "px");
      $cache.imageWrapper.css("width", $cache.mediaWrapper.width() + "px");
      app.product.imgNav();

    },
    imgNav: function () {

      $cache.navThumbs.empty();
      $cache.imageWrapper.find("picture").each(function () {
        $cache.navThumbs.append('<div class="unfilled"/>');
      });
      $cache.navThumbs.children("div").eq($cache.pos).removeClass("unfilled");
      $cache.navThumbs.children("div").on("click", function () {
        let $this = $(this);
        $cache.navThumbs.children("div").each(function (i) {
          if ($(this).is($this)) {
            app.product.imageSwipe(i);
            $(this).removeClass("unfilled");
          } else {
            $(this).addClass("unfilled");
          }
        })
      });


      //IMAGE slide
      $(document).off("touchstart").on('touchstart', handleTouchStart);
      $(document).off("touchmove").on('touchmove', handleTouchMove);


      let xDown = null;
      let yDown = null;

      function getTouches(evt) {
        return evt.touches ||             // browser API
          evt.originalEvent.touches; // jQuery
      }

      function handleTouchStart(evt) {
        const firstTouch = getTouches(evt)[0];
        xDown = firstTouch.clientX;
        yDown = firstTouch.clientY;
      }

      function handleTouchMove(evt) {
        if (!xDown || !yDown) {
          return;
        }

        let xUp = evt.touches[0].clientX;
        let yUp = evt.touches[0].clientY;

        let xDiff = xDown - xUp;
        let yDiff = yDown - yUp;

        if (Math.abs(xDiff) > Math.abs(yDiff)) {
          if (xDiff > 0) {
            app.product.imageSwipe("right");
          } else {
            app.product.imageSwipe();
          }
        }
        xDown = null;
        yDown = null;
      }

      let $imgRight = $(".img-right");
      let $imgLeft = $(".img-left");

      $(".img-right, .img-left").off("click");
      $imgRight.on("click", function () {
        app.product.imageSwipe("right")
      });

      $imgLeft.on("click", function () {
        app.product.imageSwipe()
      });

      //let $swatchOpt = $(".swatch_opt").not(".opthide");
      let $swatchOpt = $(".swatch_opt");
      $swatchOpt.off("click");
      $swatchOpt.on("click", function () {
        //RESET
        if (!$(this).hasClass("selected")) {
          $imgRight.off("click");
          $imgLeft.off("click");
          // document.removeEventListener('touchstart', handleTouchStart, true);
          // document.removeEventListener('touchmove', handleTouchMove, true);
          app.product.imageSwipe("reset");
          // app.product.mfBtn();
        }

      });
      //$(".swatch_opt").not(".opthide").on("click", app.product.onChangeSwatchHandler);
      $swatchOpt.on("click", app.product.onChangeSwatchHandler);
      $swatchOpt.on("click", app.product.swatchBtn);
      $swatchOpt.on("click", app.product.instockOnlyHideOptions);
    },

    moveVideoToSecondPosition: function () {
      let $videoElements = $cache.imageWrapper.find('.photo-item.video-item, .product-videos');
      if ($videoElements.length) {
        let $firstPhotoItem = $cache.imageWrapper.find('.photo-item').not('.video-item, .product-videos').first();
        if ($firstPhotoItem.length) {
          // Detach and reinsert after first image
          $videoElements.detach();
          $firstPhotoItem.after($videoElements);

          // Update navigation
          app.product.imgNav();
        }
      }
    },

    imageColorbox: function () {
      // Colorbox
      $cache.productImages.not('.cboxElement').each(function () {
        let $this = $(this);
        $this.colorbox({
          rel: 'gal',
          width: '100%',
          className: 'productGroup',
          height: '100%',
          trapFocus: true,
          photo: true,
          fixed: true,
          reposition: true,
          current: "{current} of {total}",
          next: '<span class="icon-arrow"></span>',
          previous: '<span class="icon-arrow rotate-180"></span>',
          href: function () {
            if ($this.data('preview')) {
              return $this.data('preview').replace('uc_product', 'uc_product_full');
            } else if ($this.data('src')) {
              return $this.data('src').replace('uc_product', 'uc_product_full');
            }
            return $this.attr('src').replace('uc_product', 'uc_product_full');
          },
          onComplete: function () {
            if (app.isMobile()) {
              $('#cboxLoadedContent').zoom({
                onZoomIn: function () {
                  $(this).addClass('active');
                }, onZoomOut: function () {
                  $(this).removeClass('active');
                }
              });
            }
          },
          onOpen: function () {
            $('html').addClass('no-overflow');
            if ($cache.productVideos.find('.vid-preview')) {
              $('#cboxTitle').after($('<div/>', {class: 'productControls'}).append($('#cboxPrevious')).append($('#cboxNext,#cboxCurrent')).append($('<a/>', {
                href: '#',
                class: 'videoTrigger'
              }).text('Videos')));
              $('#cboxPrevious,#cboxNext,#cboxCurrent').show();
              $('.videoTrigger').on('click', function (e) {
                e.preventDefault();
                $cache.productVideos.find('.vid-preview').trigger('click');
                $('#cboxTitle').after($('#cboxPrevious,#cboxNext,#cboxCurrent'));
                $('.productControls, .videoTrigger').remove();
              });
            }
          },
          onClosed: function () {
            $('html').removeClass('no-overflow');
            $('#cboxTitle').after($('#cboxPrevious,#cboxNext,#cboxCurrent'));
            $('.productControls, .videoTrigger').remove();
          }
        });
      });

      // Product dimension image
      $('a.dim').colorbox({
        rel: 'dim',
        width: '100%',
        className: 'productGroup',
        height: '100%',
        trapFocus: true,
        photo: true,
        fixed: true,
        href: function () {
          return $(this).attr('href');
        },
        onComplete: function () {
          //app.product.wheelZoom({});
          $('#cboxLoadedContent').css('display', 'flex').css('align-items', 'center').css('justify-content', 'center');
          $('#cboxLoadedContent img').css('margin', '0');
          $('#cboxLoadedContent img').wrap('<span style="display:inline-block"></span>').css('display', 'block').parent().zoom({
            on: 'grab',
            url: $(this).attr('href')
          });
        },
        onClosed: function () {

        }
      });
    },
    // replace url encoded brackets
    getWindowSearch: function () {
      //return window.location.search.replaceAll('%5B', '[').replaceAll('%5D', ']');
      return window.location.search.replace(/%5B/gi, '[').replace(/%5D/gi, ']');
    },
    // remove all aid[] from querystring
    emptyLocationParams: function () {
      let currentUrl = window.location.href;
      let qs = app.util.getQueryStringParams(app.product.getWindowSearch());
      for (let k in qs) {
        if (qs.hasOwnProperty(k)) {
          if (k.match(/^aid\[/)) {
            currentUrl = app.util.removeParamFromURL(currentUrl, k);
          }
        }
      }
      return currentUrl;
    },
    // replace aid[]'s with set aids[]
    resetLocationParams: function (selectedOptions) {
      // Update the current URL
      let currentUrl = app.product.emptyLocationParams();
      app.util.replaceUrlState(decodeURIComponent(app.util.appendParamsToUrl(currentUrl, {aid: selectedOptions})), null);
    },
    // Validate params with model, and return what the params should be
    validateSelectedParams: function (filterParams, selModel) {
      // Validate querystring
      for (let x in filterParams) {
        if (filterParams.hasOwnProperty(x)) {
          if (typeof Drupal.settings.oid_to_model[filterParams[x]] === 'undefined'
            || typeof Drupal.settings.oid_to_model[filterParams[x]][selModel] === 'undefined') {
            delete (filterParams[x]);
          }
        }
      }

      // Validate querystring - if count invalid, return params for default model
      if (typeof Drupal.settings.product_models[selModel] !== 'undefined'
        && Object.keys(filterParams).length !== Drupal.settings.product_models[selModel].length) {
        // Not the right count of aid[] passeDue to increased order volume and current precautions at our warehouses, it may take up to an additional week to process orders prior to shipment. You will receive an email with your tracking details as soon as your order is set up for shipment.d for model
        console.log(Drupal.settings.product_models[selModel].length + ' vs ' + Object.keys(filterParams).length);
        let newParams = {};
        for (let x in Drupal.settings.product_models[selModel]) {
          if (Drupal.settings.product_models[selModel].hasOwnProperty(x)) {
            newParams[$('li[data-oid="' + Drupal.settings.product_models[selModel][x] + '"]').data('material')] = Drupal.settings.product_models[selModel][x];
          }
        }
        return newParams;
      }

      let validParams = {};
      for (let x in filterParams) {
        if (filterParams.hasOwnProperty(x)) {
          if (typeof Drupal.settings.product_models[selModel] !== 'undefined'
            && $.inArray(filterParams[x], Drupal.settings.product_models[selModel]) !== -1) {
            validParams[x] = filterParams[x];
          }
        }
      }
      if (validParams.length !== filterParams.length) {
        // Reset params..
        //console.log('invalid count');
        //app.product.resetLocationParams(validParams);
      }

      return validParams;
    },

    initVideo: function () {
      // Remove old handlers first to avoid duplicates
      $cache.productVideos.find('.vid-preview').off('click.videoPreview');
      $cache.videoContainer.find('.vid-preview').off('click.videoPreview');

      $cache.productVideos.find('.vid-preview').on('click.videoPreview', function (e) {
        e.preventDefault();
        let video = $cache.videoContainer.find('.vid-preview').first();
        //$cache.videoContainer.addClass('active');
        if (typeof video.data('wistia-url') !== 'undefined') {
          app.product.videoPlay(video.data('wistia-url'), video.data('title'), 'wistia');
        } else {
          app.product.videoPlay(video.data('youtube-url'), video.data('title'), 'youtube');
        }
      });
      $cache.videoContainer.find('.vid-preview').on('click.videoPreview', function (e) {
        e.preventDefault();
        let video = $(this);
        if (typeof video.data('wistia-url') !== 'undefined') {
          app.product.videoPlay(video.data('wistia-url'), video.data('title'), 'wistia');
        } else {
          app.product.videoPlay(video.data('youtube-url'), video.data('title'), 'youtube');
        }
      });
    },
    videoPlay: function (url, title, provider) {
      let $script;
      let $pad = $('<div/>', {class: 'wistia_responsive_padding'});
      let $wrap = $('<div/>', {class: 'wistia_responsive_wrapper'});
      let $con = $('<div/>', {
        id: 'youtubePlayer',
        class: 'wistia_embed wistia_async_' + url + ' autoPlay=true videoFoam=true playerColor=e5e5e5'
      });
      let $title = $('<div/>', {class: 'video-title'}).append($('<h2/>').text(title));
      let $wrapper = $cache.videoContainer.clone();
      $pad.append($wrap.append($con));
      $wrapper.find('.video_play').append($pad).append($title);

      let isYoutubeInit = app.components.youtubeIsReady();
      if (provider === "wistia") {
        app.components.wistiaLoad();
        $script = $('<script/>', {src: "//fast.wistia.com/embed/medias/" + url + ".jsonp", async: ''});
      } else if (provider === 'youtube') {
        if (app.components.youtubeIsReady()) {
          app.components.youtubeLoadVideoId(url);
          $('#video_play .video-title').replaceWith($title);
          if (typeof window.videoColorbox !== 'undefined' && $('.video_play:visible').length > 0) {
            return;
          }
        } else {
          app.components.youtubeLoad(url);
        }
        //youtubePlayer.loadVideoById(url);
      }

      //$cache.videoContainer.find('.video_display').html($script+$pad+$('<div/>',{class:'video-title'}).append($('<h2/>').text(title)));
      window.videoColorbox = $.colorbox({
        //rel: 'gal',app.
        width: '100%',
        className: 'productGroup',
        height: '100%',
        trapFocus: true,
        photo: false,
        fixed: true,
        next: 'Next',
        overlayClose: false,
        html: $wrapper.html() + $('<div/>').append($script).html(),
        onComplete: function () {
          $('.video-list-container .vid-preview').on('click.videoPreview', function (e) {
            e.preventDefault();
            let video = $(this);
            if (typeof video.data('wistia-url') !== 'undefined') {
              app.product.videoPlay(video.data('wistia-url'), video.data('title'), 'wistia');
            } else {
              app.product.videoPlay(video.data('youtube-url'), video.data('title'), 'youtube');
            }
          });
          app.components.lazyImages();

          if (isYoutubeInit) {
            window.onYouTubeIframeAPIReady();
          }
        },
        onOpen: function () {
          $('html').addClass('no-overflow');
          $(window).on('resize.productGroup', function () {
            app.product.productColorboxResize();
          });
          window.addEventListener("orientationchange", app.product.productColorboxResize, false);
        },
        onClosed: function () {
          $('html').removeClass('no-overflow');
          $(window).off('resize.productGroup');
        }
      });
    },
    productColorboxResize: function () {
      if (typeof $cache.resizeTimer !== 'undefined' && $cache.resizeTimer) clearTimeout($cache.resizeTimer);
      $cache.resizeTimer = setTimeout(function () {
        if ($('#cboxOverlay').is(':visible')) {
          $.colorbox.resize({width: '100%', height: '100%'});
          if (typeof wistiaEmbeds !== 'undefined' && typeof wistiaEmbeds[0] !== 'undefined') {
            if (wistiaEmbeds[0].state() === 'playing') {
              $(wistiaEmbeds[0].container).parent().width('100%')
            }
            wistiaEmbeds[0].width($(wistiaEmbeds[0].container).width(), {constrain: true});
          }
          //$.colorbox.settings.width = $.colorbox.settings.height = $.colorbox.settings.maxWidth = $.colorbox.settings.maxHeight = '100%';
          //$.colorbox.load(true);
        }
      }, 300);
    },

    stickyAddToCart: function(){

        $(window).on('scroll', function() {
          var elementTop = $cache.addToCartBtn[0].getBoundingClientRect().top;

          if (elementTop <= 180) {
            $cache.addToCartSelected.addClass('sticky');
            $('#fc_frame.fc-widget-small').addClass('sticky');
          } else {
            $cache.addToCartSelected.removeClass('sticky');
            $('#fc_frame.fc-widget-small').removeClass('sticky')
          }
        });

      $cache.addToCartSelected.find(".selected-variant-config .image-cont").html($(".photo-item").eq(0).find("picture").html());


      $cache.addToCartSelected.find("button").on("click",function(){
        if($(".node-add-to-cart").is(":visible")){
          $(".node-add-to-cart").trigger("mousedown");
          app.components.linkLoader($cache.addToCartSelected.find("button"));
          $(".node-add-to-cart").on('ajaxEnded', function () {
            $cache.addToCartSelected.find("button").trigger('ajaxEnded');
          });
        } else {
          $("#edit-notifyme").trigger("mousedown")
        }
      });

    },

    scrollLock: function () {
      if ($cache.enableScrollLock && !app.isMobile()) {
        let scrollTop = $cache.window.scrollTop();
        let direction = null;

        // Determine the direction
        if (scrollTop >= $cache.lastScrollTop) {
          direction = 'down';
        } else {
          direction = 'up';
        }

        //app.components.stick($cache.productWrap, $cache.stickWrap, 120, $cache.lastScrollTop, direction);
        app.components.stick($cache.productWrap, $cache.stickWrap, false, $cache.lastScrollTop, direction, null, $cache.panelRecalculate);
        $cache.panelRecalculate = false;

        $cache.lastScrollTop = scrollTop;

        // This is a scroll to top button
        if (scrollTop > $cache.backTopScrollPoint && !$cache.backToTop) {
          $cache.backToTop = $("<a/>", {
            "id": $cache.backTopID,
            "class": "hidden-phone",
            "html": app.resources.BACK_TO_TOP
          }).append($("<span/>", {
            "class": "icon-arrow rotate-270"
          })).appendTo('body').fadeIn();
          $("#" + $cache.backTopID).on('click', function (e) {
            e.preventDefault();
            $('html, body').animate({
              scrollTop: 0
            }, 400);
          });
        } else if (scrollTop > $cache.backTopScrollPoint && $cache.backToTop) {
          $cache.backToTop.fadeIn();
        } else if (scrollTop <= $cache.backTopScrollPoint && $cache.backToTop) {
          $cache.backToTop.fadeOut();
        }
      }
    },

    scrollLockRemove: function () {
      $cache.stickWrap.removeAttr('style').removeClass('sticky');
    },

    // Run once on load to setup swatches
    initSwatch: function () {
      // disable all empty select options
      $cache.addToCartForm.find('.attributes select option[value=""]').attr('disabled', 'disabled');
      // set attribute to empty (a hidden attribute also a grouped attribute)
      // @see uc_attribute_group_form_alter
      $cache.addToCartForm.find('.attributes select.attribute-disabled').val('');

      //Update swatch header
      app.product.updateSwatchTitle();
    },
    // Event handler for change of swatch
    onChangeSwatchHandler: function (e) {
      e.preventDefault();

      // Grab out values
      let $this = $(this);
      let $current = $this.parents('.attribute_groups, .solo_group').find('.check_image');

      // Make sure there is actually a change or is not already running
      if ($this === $current.parent() || $this.hasClass('disabled') || $cache.ajaxRunning) {
        return false;
      }

      // Remove current selection
      $current.parent('li').removeClass('selected');
      $current.remove();
      // TODO: This can be replaced for a function to run at the end to unset all select and set the val's from array
      if ($this.parents('.grouped').length) {
        $('.product-swatch-contents .grouped').each(function () {
          let $grp = $(this);
          // If this group isn't the one we just selected, reset the select
          if (parseInt($grp.data('aid')) !== parseInt($this.data('material'))) {
            $('.form-item-attributes-' + $grp.data('aid') + ' select').prop('selected', false).val('');
          }
        });
      }

      // Set new attributes
      $('.add-to-cart .attributes .attribute-' + $this.data('material') + ' select').val($this.data('oid'));

      // Add new selection
      $this.addClass('selected').append($cache.check.clone());

      if (app.isMobile()) {
        $('.sw_prv').each(function () {
          $(this).hide();
        })

        $('.txt_opt' + $(this).data('oid')).show();
      }

      // Run operations on the swatch change
      app.product.setSwatchSelected($this);
    },
    // show and hide the restricted form/elements
    handleRestricted: function (isRestricted) {
      let $restrictedElement = $('[data-restricted-product]');
      if (!parseInt($restrictedElement.attr('data-is-validated'))) {
        if (parseInt($restrictedElement.attr('data-restricted-product'))) {
          let isCurrentlyRestricted = parseInt($restrictedElement.attr('data-is-restricted'));
          if (isCurrentlyRestricted && isRestricted) {
            // We don't need to do anything
          } else if (isRestricted) {
            // We want to turn on restricted fields
            $restrictedElement.attr('data-is-restricted', 1);

            $('.isRestricted').each(function () {
              if ($(this).hasClass('hide')) {
                $(this).removeClass('hide');
              } else {
                $(this).addClass('hide');
              }
            });
          } else if (isCurrentlyRestricted && !isRestricted) {
            // We want to move from restricted to non-restricted
            // We want to turn on restricted fields
            $restrictedElement.attr('data-is-restricted', 0);

            $('.isRestricted').each(function () {
              if ($(this).hasClass('hide')) {
                $(this).removeClass('hide');
              } else {
                $(this).addClass('hide');
              }
            });
          }
        }
      }
    },
    // Set the swatch as changed
    setSwatchSelected: function ($this) {
      // Get selected values
      //let oid = $this.data('oid');
      //let aid = $this.data('material');
      //let price = $this.data('price');
      let selectedOptions = app.product.getSelectedOptions();
      let selectedModel = app.product.getSelectedModel(selectedOptions);
      let isRestricted = $('[data-restricted-product]').data('restricted-product') &&
        (typeof Drupal.settings.restricted['n' + Drupal.settings.product.nid] == 'undefined' || typeof Drupal.settings.restricted['n' + Drupal.settings.product.nid][selectedModel] !== 'undefined');
      app.product.handleRestricted(isRestricted);

      // A product package is allowed to have no attribute so check the package first.
      if (parseInt($('[name=is_package]').val()) !== 1) {
        // Prevent adding of products with invalid attribute selections
        if (!selectedModel.length) {
          $('.config-price, .configuration-price-action .form-actions, .attribute-config_breakdown').hide();
        } else {
          $('.config-price, .configuration-price-action .form-actions, .attribute-config_breakdown').show();
        }
      }

      // Current state of filtering
      // TODO: There is logic we might need to use with these, ie if toggling between stock and custom...
      //var ss_stock = $('input[name="stocksale[stock]"]').is(':checked');
      //var ss_expedited = $('input[name="stocksale[expedited]"]').is(':checked');

      // List of all attributes on the page
      /*
      let attributes = $('.attribute_groups ul').map(function () {
          return $(this).data('aid');
      }).get();
      */

      // Set the current configuration message to loading

      if (!selectedModel.length) {
        $('.configuration-msg').html("<p style=\"\n" +
          "    color: #f06f4d;\n" +
          "\">Please select all the options</p>");
      } else {
        let $img_loading = $('<img/>', {width: 60, height: 60, alt: 'loading ...'})
          .attr('src', 'data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNjBweCIgaGVpZ2h0PSI2MHB4IiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAxMDAgMTAwIiBwcmVzZXJ2ZUFzcGVjdFJhdGlvPSJ4TWlkWU1pZCIgY2xhc3M9InVpbC1iYWxscyI+PHJlY3QgeD0iMCIgeT0iMCIgd2lkdGg9IjEwMCIgaGVpZ2h0PSIxMDAiIGZpbGw9Im5vbmUiIGNsYXNzPSJiayI+PC9yZWN0PjxnIHRyYW5zZm9ybT0icm90YXRlKDAgNTAgNTApIj4NCiAgPGNpcmNsZSByPSI1IiBjeD0iMzAiIGN5PSI1MCIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoMTUuMzMzMyAtMTUuMzMzMykiPg0KICAgIDxhbmltYXRlVHJhbnNmb3JtIGF0dHJpYnV0ZU5hbWU9InRyYW5zZm9ybSIgdHlwZT0idHJhbnNsYXRlIiBiZWdpbj0iMHMiIHJlcGVhdENvdW50PSJpbmRlZmluaXRlIiBkdXI9IjFzIiB2YWx1ZXM9IjAgMDsxOS45OTk5OTk5OTk5OTk5OTYgLTIwIiBrZXlUaW1lcz0iMDsxIj48L2FuaW1hdGVUcmFuc2Zvcm0+DQogICAgPGFuaW1hdGUgYXR0cmlidXRlTmFtZT0iZmlsbCIgZHVyPSIxcyIgYmVnaW49IjBzIiByZXBlYXRDb3VudD0iaW5kZWZpbml0ZSIga2V5VGltZXM9IjA7MSIgdmFsdWVzPSIjZmZmOyM5OTkiPjwvYW5pbWF0ZT4NCiAgPC9jaXJjbGU+DQo8L2c+PGcgdHJhbnNmb3JtPSJyb3RhdGUoOTAgNTAgNTApIj4NCiAgPGNpcmNsZSByPSI1IiBjeD0iMzAiIGN5PSI1MCIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoMTUuMzMzMyAtMTUuMzMzMykiPg0KICAgIDxhbmltYXRlVHJhbnNmb3JtIGF0dHJpYnV0ZU5hbWU9InRyYW5zZm9ybSIgdHlwZT0idHJhbnNsYXRlIiBiZWdpbj0iMHMiIHJlcGVhdENvdW50PSJpbmRlZmluaXRlIiBkdXI9IjFzIiB2YWx1ZXM9IjAgMDsxOS45OTk5OTk5OTk5OTk5OTYgLTIwIiBrZXlUaW1lcz0iMDsxIj48L2FuaW1hdGVUcmFuc2Zvcm0+DQogICAgPGFuaW1hdGUgYXR0cmlidXRlTmFtZT0iZmlsbCIgZHVyPSIxcyIgYmVnaW49IjBzIiByZXBlYXRDb3VudD0iaW5kZWZpbml0ZSIga2V5VGltZXM9IjA7MSIgdmFsdWVzPSIjOTk5OyMwMDAiPjwvYW5pbWF0ZT4NCiAgPC9jaXJjbGU+DQo8L2c+PGcgdHJhbnNmb3JtPSJyb3RhdGUoMTgwIDUwIDUwKSI+DQogIDxjaXJjbGUgcj0iNSIgY3g9IjMwIiBjeT0iNTAiIHRyYW5zZm9ybT0idHJhbnNsYXRlKDE1LjMzMzMgLTE1LjMzMzMpIj4NCiAgICA8YW5pbWF0ZVRyYW5zZm9ybSBhdHRyaWJ1dGVOYW1lPSJ0cmFuc2Zvcm0iIHR5cGU9InRyYW5zbGF0ZSIgYmVnaW49IjBzIiByZXBlYXRDb3VudD0iaW5kZWZpbml0ZSIgZHVyPSIxcyIgdmFsdWVzPSIwIDA7MTkuOTk5OTk5OTk5OTk5OTk2IC0yMCIga2V5VGltZXM9IjA7MSI+PC9hbmltYXRlVHJhbnNmb3JtPg0KICAgIDxhbmltYXRlIGF0dHJpYnV0ZU5hbWU9ImZpbGwiIGR1cj0iMXMiIGJlZ2luPSIwcyIgcmVwZWF0Q291bnQ9ImluZGVmaW5pdGUiIGtleVRpbWVzPSIwOzEiIHZhbHVlcz0iIzAwMDsjZmZmIj48L2FuaW1hdGU+DQogIDwvY2lyY2xlPg0KPC9nPjxnIHRyYW5zZm9ybT0icm90YXRlKDI3MCA1MCA1MCkiPg0KICA8Y2lyY2xlIHI9IjUiIGN4PSIzMCIgY3k9IjUwIiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgxNS4zMzMzIC0xNS4zMzMzKSI+DQogICAgPGFuaW1hdGVUcmFuc2Zvcm0gYXR0cmlidXRlTmFtZT0idHJhbnNmb3JtIiB0eXBlPSJ0cmFuc2xhdGUiIGJlZ2luPSIwcyIgcmVwZWF0Q291bnQ9ImluZGVmaW5pdGUiIGR1cj0iMXMiIHZhbHVlcz0iMCAwOzE5Ljk5OTk5OTk5OTk5OTk5NiAtMjAiIGtleVRpbWVzPSIwOzEiPjwvYW5pbWF0ZVRyYW5zZm9ybT4NCiAgICA8YW5pbWF0ZSBhdHRyaWJ1dGVOYW1lPSJmaWxsIiBkdXI9IjFzIiBiZWdpbj0iMHMiIHJlcGVhdENvdW50PSJpbmRlZmluaXRlIiBrZXlUaW1lcz0iMDsxIiB2YWx1ZXM9IiNmZmY7Izk5OSI+PC9hbmltYXRlPg0KICA8L2NpcmNsZT4NCjwvZz48L3N2Zz4=');
        $('.configuration-msg').html($img_loading);
      }

      // Update the current URL
      let currentUrl = app.product.emptyLocationParams();

      if (selectedModel.length) {
        app.util.replaceUrlState(decodeURIComponent(app.util.appendParamsToUrl(currentUrl, {aid: selectedOptions})), null);

        // Update Images
        app.product.swapImages(selectedOptions, selectedModel);

        // Update Price
        app.product.updatePrice(selectedModel);

        // Update the add to cart button
        app.product.updateButton(selectedModel);

        // Update the breakdown information
        app.product.updateBreakdown(selectedModel);

        // Change/update final sale text
        app.product.finalSale(selectedModel);

        //update swatch header
        app.product.updateSwatchTitle();

        // Show/update the model
        $('.model').html(selectedModel);

        // Trigger all the event listeners
        // set the current oid
        Drupal.settings.last_clicked_oid = $this.attr('data-oid');
        $(document).trigger('pre_product_change', [
          Drupal.settings.last_clicked_oid,
          typeof Drupal.settings.oid_details[Drupal.settings.last_clicked_oid] !== 'undefined'
            ? Drupal.settings.oid_details[Drupal.settings.last_clicked_oid].name
            : '',
          selectedModel
        ]);
      }

    },
    //Update selected swatch information
    updateSwatchTitle: function(){
      function instockSwatch(){
          let swatchName = $(".swatch_opt.selected").attr("title");
          let stockMsg = ($(".configuration-msg").text().toLowerCase().includes("in-stock") || $(".configuration-msg").text().toLowerCase().includes("in stock")) ? "In stock" : "Pre-order";
          $("#product-swatches a[href*='#swatches-instock'] .heading").html("Available<span> | " + stockMsg + " (" + swatchName + ")</span>");
      }
      function customSwatch() {
          let swatchName = $(".swatch_opt.selected").attr("title");

          if ($("#product-swatches a[href*='#swatches-custom'] span").length) {
           $("#product-swatches a[href*='#swatches-custom'] span").text(" (" + swatchName + ")");
          } else {
            document.querySelector("#product-swatches a[href*='#swatches-custom']").insertAdjacentHTML('beforeend', '<span> (' + swatchName + ')</span>');
          }
      }

      function soloSwatch(e){
        let swatchName = $(e).find(".swatch_opt.selected").attr("title");
        if (e.previousSibling.querySelector("span")) {
          e.previousSibling.querySelector("span").innerHTML = " (" + swatchName + ")";
        } else {
          e.previousSibling.insertAdjacentHTML('beforeend', '<span> (' + swatchName + ')</span>');
        }
      }

      if ($("#product-swatches .active[href*='#swatches-instock']").length > 0){
        instockSwatch();
      } else if ($("#product-swatches .active[href*='#swatches-custom']").length > 0) {
        customSwatch();
      }

      if ($('#product-swatches .solo_group')){
        $("#product-swatches .solo_group").each(function(i,e){
          soloSwatch(e);
        });
      }
    },
    // Replace images with the right images for the model
    updateImages: function (selectedOptions) {
      // TODO: Default images shouldnt change if already loaded

      // Preserve video elements before manipulating images
      let $videoElements = $cache.imageWrapper.find('.photo-item.video-item, .product-videos').detach();

      // Remove previous related images
      //$cache.productImages = $('.photo-item>img, .photo-item picture>img');
      $cache.productImages.not('img[data-oid=""]').each(function () {
        if (Object.values(selectedOptions).indexOf(parseInt($(this).data('oid')))) {
          $(this).parents('.photo-item').remove();
        }
      });
      $cache.productImages = $('.photo-item>img, .photo-item picture>img');

      // Make sure images are not already set, if so ignore
      if ($cache.productImages.not('img[data-oid=""]').length) {
        // Re-insert videos at second position before returning
        if ($videoElements.length) {
          let $firstPhotoItem = $cache.imageWrapper.find('.photo-item').not('.video-item, .product-videos').first();
          if ($firstPhotoItem.length) {
            $firstPhotoItem.after($videoElements);
          } else {
            $cache.imageWrapper.append($videoElements);
          }
        }
        return false;
      }

      // Loop through each aid/oid to locate images
      let allImgs = Drupal.settings.product_imgs.data;
      let template = Drupal.settings.product_imgs.template.replace(':img.png', ':img');
      let optionImages = null;
      for (let x in selectedOptions) {
        if (allImgs.hasOwnProperty(selectedOptions[x]) === true || typeof allImgs[selectedOptions[x]] !== 'undefined') {
          optionImages = allImgs[selectedOptions[x]];

          for (let i = (optionImages.length - 1); i >= 0; i--) {
            let img = template.replace(new RegExp(':img', 'g'), optionImages[i].d);
            img = img.replaceAll('.jpg.jpg', '.jpg');
            img = img.replace(new RegExp('width=""', 'g'), 'width="' + optionImages[i].w + '"');
            img = img.replace(new RegExp('height=""', 'g'), 'height="' + optionImages[i].h + '"');
            img = img.replace(new RegExp(':ratio', 'g'), optionImages[i].h / optionImages[i].w);
            img = img.replace('<picture>', '<picture style="height:0;padding-bottom:' + ((optionImages[i].h / optionImages[i].w) * 100) + '%;">');
            img = img.replace(':oid', selectedOptions[x]);

            $cache.imageWrapper.prepend($('<div/>', {class: 'photo-item'}).append(img));
            app.product.imgNav();

            $cache.addToCartSelected.find(".selected-variant-config .image-cont").html(img);
          }
        }
      }

      // Insert video elements at second position (after first image)
      if ($videoElements.length) {
        let $firstPhotoItem = $cache.imageWrapper.find('.photo-item').not('.video-item, .product-videos').first();
        if ($firstPhotoItem.length) {
          $firstPhotoItem.after($videoElements);
        } else {
          $cache.imageWrapper.append($videoElements);
        }
      }

      // Update navigation after all images and videos are in place
      app.product.imgNav();

      // Reset the cache field
      $cache.productImages = $('.photo-item>img, .photo-item picture>img');

      // Update lazy load for new images
      app.components.getLazy().update();
    },

    // Change and adjust the appropriate images
    swapImages: function (selectedOptions, selectedModel) {
      if (typeof Drupal.settings.current_model_display === 'undefined' && typeof $cache.current_model_display === 'undefined') {
        $cache.current_model_display = Drupal.settings.default_model;
      }

      // If there is no change of model, don't change the images...
      if (selectedModel === $cache.current_model_display) {
        return false;
      }

      // Set the current model
      $cache.current_model_display = selectedModel;

      // Replace images in the DOM
      app.product.updateImages(selectedOptions);

      // Structure images
      app.product.initImageEvents();

      // Reset colorbox for new images
      app.product.imageColorbox();

      // Re-initialize video handlers after videos are re-appended
      app.product.initVideo();
    },
    updateSatellite: function (satelliteId) {
      $('.swatch_opt').each(function () {
        let oids = $(this).attr('data-satellitestock').split('|');
        let found = false;
        for (let x = 0; x < oids.length; x++) {
          if (oids[x].length && (parseInt(oids[x]) === parseInt(satelliteId) || parseInt(oids[x]) === 0)) {
            found = true;
            break;
          }
        }
        if (found) {
          $(this).attr('data-stock', 'yes');
          $(this).data('stock', 'yes');
        } else {
          $(this).attr('data-stock', 'no');
          $(this).data('stock', 'no');
        }
      });

      app.product.swatchDisplayChange($('.filter-tabs-triggers .panel-heading a.active'))
    },
    checkSatellite: function () {
      if (typeof Drupal.settings.satellite_id_init !== 'undefined') {
        if (Drupal.settings.satellite_id_init !== Drupal.settings.satellite_id) {
          // Trigger button change
          app.product.updateButton(app.product.getSelectedModel(app.product.getSelectedOptions()));
        }
      }
    },
    updateButton: function (selectedModel) {
      // We disabled the #ajax callback of the form in uc_rove_supplier.module
      let msgs = Drupal.settings.stock_messages;
      let modelStock = {s: "0", pr: "0", m: selectedModel, p: 0};
      let msg = '';
      let premsg = '';
      let stockModel = Drupal.settings.models_stock[selectedModel];
      let currency = $.cookie('uc_warehouse_location') === 'CA' ? 'CAD' : ($.cookie('uc_warehouse_location') === 'AU' ? 'AUD' : ($.cookie('uc_warehouse_location') === 'KR' ? 'KRW' : ($.cookie('uc_warehouse_location') === 'UK' ? 'GBP' : $.cookie('uc_warehouse_location') === 'HK' ? 'HKD' : 'USD')));
      let price = app.product.memberDiscount(stockModel.p);

      if (Drupal.settings.models_stock[selectedModel] !== 'undefined') {
        modelStock = Drupal.settings.models_stock[selectedModel];
      }


      let FAST_DELIVERY_CA_FSAS = new Set((Drupal.settings.fastDeliveryCaFsas || []));
      let FAST_DELIVERY_ZIPS = new Set((Drupal.settings.fastDeliveryUsZips || []));
      let $btnText = 'Add to cart';
      let $notifyTxt = "Sold Out - Notify Me";
      let _savedPostal = ($.cookie('destination-override-' + app.getCountry().toLowerCase()) || '').replace(/\s/g, '').toUpperCase();
      let _isFastDelivery = app.getCountry() === 'CA'
        ? FAST_DELIVERY_CA_FSAS.has(_savedPostal.substring(0, 3))
        : FAST_DELIVERY_ZIPS.has(_savedPostal);
      const deliveryEtaTxt = _isFastDelivery ? 'Delivery in 3-5 days' : 'Delivery in 1-3 weeks';

      $cache.addToCartBtn.attr('class', 'node-add-to-cart btn-primary full-width ajax-processed');
      $cache.addToCartBtn.attr('disabled', false).attr('onclick', null);
      $cache.addToCartBtn.attr('data-actual', $cache.addToCartBtn.attr('value')).attr('value', 'Add to cart').html($btnText.toString());
      $cache.addToCartForm.find('button.notify').html($notifyTxt);

      let $satelliteZone = $.cookie('destination-override-zone-' + app.getCountry().toLowerCase()) && parseInt($.cookie('destination-override-zone-' + app.getCountry().toLowerCase())) > 1;
      if (modelStock.h) {
        // Hidden
        // $cache.addToCartBtn.attr('value', 'Custom Order').html('Custom Order');
        msg = msgs.hidden;
      } else if ($satelliteZone && parseInt(modelStock.hs) > 0) {
        $cache.addToCartBtn.addClass('custom');
        // msg = msgs.stock.replace('!qty', (modelStock.hs + modelStock.s >= 10 ? '10+' : (modelStock.hs + modelStock.s))) + ' ' + msgs.shipout.replace('!real_delivery_date', modelStock.hsh);
        if (parseInt(modelStock.hs) + parseInt(modelStock.s) >= 10) {
          msg = '<span class="stock-info in-stock">In-stock</span> - ' + deliveryEtaTxt;
        } else {
          msg = msgs.stock.replace('In-stock.', '<span class="stock-info low-stock">Only ' + (parseInt(modelStock.hs) + parseInt(modelStock.s)) + ' left in stock</span> - ' + deliveryEtaTxt);
        }
        msg += ' ' + msgs.shipout.replace('!real_delivery_date', modelStock.hsh);
        premsg = "<div class=\"config-status instock\" data-s-default=\"" + modelStock.s + "\" data-s-satellite=\"" + modelStock.hs + "\">" + msg + "</div>";
      } else if (parseInt(modelStock.s) > 0) {
        // $cache.addToCartBtn.attr('value', 'Add to cart').html('Add to cart');
        // msg = msgs.stock.replace('!qty', (modelStock.s >= 10 ? '10+' : modelStock.s)) + ' ' + msgs.shipout.replace('!real_delivery_date', modelStock.sh);
        $cache.addToCartBtn.addClass('custom');
        if (parseInt(modelStock.s) >= 10) {
          msg = "<span class='stock-info in-stock'>In-stock</span> - " + deliveryEtaTxt
        } else {
          msg = msgs.stock.replace('In-stock.', '<span class="stock-info low-stock">Only ' + parseInt(modelStock.s) + ' left in stock</span> - ' + deliveryEtaTxt)
        }
        msg += ' ' + msgs.shipout.replace('!real_delivery_date', modelStock.sh);
        premsg = "<div class=\"config-status instock\">" + msg + "</div>";
      } else if (parseInt(modelStock.pr) > 0) {
        // $cache.addToCartBtn.attr('value', 'Pre-order').html('Pre-order');
        $cache.addToCartBtn.addClass('preorder');
        msg = msgs.preorder.replace('!cnt', (modelStock.pr >= 10 ? '10+' : modelStock.pr)).replace('!date', modelStock.eta);
        premsg = "<div class=\"config-status preorder\"><strong>" + msg + "</strong>.</div>";
      } else {
        // $cache.addToCartBtn.attr('value', 'Custom Order').html('Custom Order');
        msg = msgs.custom.replace();
        premsg = "<div class=\"config-status custom\">" + msg + "</div>";
        if (modelStock.d) {
          // Disabled
          // $cache.addToCartBtn.attr('value', 'Add to cart').html('Add to cart');
          $cache.addToCartBtn.attr('disabled', true);
          msg = msgs.disallow;
        }

      }

      // Hide/Show Notify Me button
      if ($cache.addToCartBtn.attr('disabled')) {
        $cache.addToCartForm.find('button.notify').show();
        $cache.addToCartForm.find('button.node-add-to-cart').hide();
        $cache.addToCartForm.find('button.checkout-btn').hide();
        $cache.addToCartSelected.find("button").text("Notify Me");
      } else {
        $cache.addToCartForm.find('button.notify').hide();
        $cache.addToCartForm.find('button.node-add-to-cart').show();
        $cache.addToCartForm.find('button.checkout-btn').show();
        $cache.addToCartSelected.find("button").text("Add to Cart");
      }

      // Update messages
      $('.config-status').replaceWith(premsg);
      $('.configuration-msg').attr('data-s-default', modelStock.s).attr('data-s-satellite', modelStock.hs).html(msg);
    },

    // checkoutBtn: function(){
    //   $('.checkout-btn').click(function(e) {
    //     e.preventDefault();
    //     $('.node-add-to-cart').trigger('mousedown');
    //     let $r_menu_cart = $('#r-menu-cart');
    //     let $color_box = $('#colorbox');
    //     waitForElementToDisplay(100);
    //     function waitForElementToDisplay(time) {
    //       if($r_menu_cart.hasClass("open") || $color_box.css('display') === "block") {
    //         $r_menu_cart.hasClass("open") ? $r_menu_cart.removeClass("open") : $color_box.css("display", "none");
    //         window.location.replace("https://roveconcepts.com/cart/checkout");
    //         return;
    //       }
    //       else {
    //         setTimeout(function() {
    //           waitForElementToDisplay(100);
    //         }, time);
    //       }
    //     }
    //   });
    // },

    swatchBtn: function () {

      $cache.mfBtn.addClass("hidden");
      $cache.vsBtn.addClass("hidden");
      if ($(".swatch_opt.selected").attr("data-attribute") == "Microfiber Leather") {
        $cache.mfBtn.removeClass("hidden");
        if ($(window).width() < 1280) {
          $(".download-lookbook").css({"grid-row": "2/3", "grid-column": "1/3"});
        } else {
          $(".download-lookbook").css({"grid-column": "3/4"});
        }

        if ($(".photo-item").find('img[data-preview*="Microfiber-Leather"]').length > 0) {
          $(".photo-item").find('img[data-preview*="Microfiber-Leather"]').parents(".photo-item").off("click");
          $(".photo-item").find('img[data-preview*="Microfiber-Leather"]').parents(".photo-item").on("click", () => {
            window.open('https://lookbook.roveconcepts.com/rove-concepts-microfiber-leather-2020/', '_blank');
          });
        }

      } else if ($(".swatch_opt.selected").attr("data-attribute") == "Venice Vegan Suede" || $(".swatch_opt.selected").attr("data-attribute") == "Vegan Venice Suede") {
        $cache.vsBtn.removeClass("hidden");
        if ($(window).width() < 1280) {
          $(".download-lookbook").css({"grid-row": "2/3", "grid-column": "1/3"});
        } else {
          $(".download-lookbook").css({"grid-column": "3/4"});
        }
        if ($(".photo-item").find('img[data-preview*="Vegan-Venice-Suede"]').length > 0) {
          $(".photo-item").find('img[data-preview*="Vegan-Venice-Suede"]').parents(".photo-item").off("click");
          $(".photo-item").find('img[data-preview*="Vegan-Venice-Suede"]').parents(".photo-item").on("click", () => {
            window.open('https://lookbook.roveconcepts.com/vegan-venice-suede/', '_blank');
          });
        }
      } else {
        $(".download-lookbook").css({"grid-row": "1/2", "grid-column": "2/3"});
      }

    },

    mobileSwatch: function(){
    function openSwatchPopup(){
      document.querySelector(".product-swatch-popovers").classList.add("active");
      document.querySelector("body").classList.add("scroll-active");
    }

    const newNode = document.createElement("div");
    newNode.classList.add("btn-close")
    newNode.addEventListener("click", function(){
      document.querySelector(".product-swatch-popovers").classList.remove("active");
      document.querySelector("body").classList.remove("scroll-active");
    })

    if (document.querySelector(".product-swatch-popovers").children[0]){
      document.querySelector(".product-swatch-popovers").insertBefore(newNode, document.querySelector(".product-swatch-popovers").children[0]);
    }


    let swatches = document.querySelectorAll("#product-swatches li.swatch_opt");

    for (let i = 0; i < swatches.length; ++i) {
      swatches[i].addEventListener("mousedown", function(){
        if (swatches[i].classList.contains("selected")){
          openSwatchPopup();
        }
      })
    }

    function swatchPopup(e){
      e.stopPropagation();
      e.preventDefault();
      document.querySelector("#product-swatches li.swatch_opt.selected").click();
    }

    if (document.querySelector("#product-swatches .active span")){
      document.querySelector("#product-swatches .active span").addEventListener("click", function(e){
        swatchPopup(e)
      })
      document.querySelector("#product-swatches .active span").setAttribute("listener", "true")
    }

    let instockObserver = new MutationObserver(() => {
      if (document.querySelector("#product-swatches a[href*='#swatches-instock'] span")) {
        if (document.querySelector("#product-swatches a[href*='#swatches-instock'] span").getAttribute("listener") == null) {
          document.querySelector("#product-swatches a[href*='#swatches-instock'] span").addEventListener("click", function (e) {
            swatchPopup(e);
          })
          document.querySelector("#product-swatches a[href*='#swatches-instock'] span").setAttribute("listener", "true")
        }
      }
    });

    if (document.querySelector("#swatches-instock")){
      instockObserver.observe(document.querySelector("#swatches-instock"), {subtree: true, childList: true});
    }

    let customObserver = new MutationObserver(() => {
      if (document.querySelector("#product-swatches a[href*='#swatches-custom'] span")){
        if (document.querySelector("#product-swatches a[href*='#swatches-custom'] span").getAttribute("listener") == null){
          document.querySelector("#product-swatches a[href*='#swatches-custom'] span").addEventListener("click", function(e){
            swatchPopup(e)
          })
          document.querySelector("#product-swatches a[href*='#swatches-custom'] span").setAttribute("listener", "true")
        }
      }
    });

    if (document.querySelector("#swatches-custom")){
      customObserver.observe(document.querySelector("#swatches-custom"), {subtree: true, childList: true});
    }
  },

    // Standing Desks blocks
    productFeaturesBlock: function () {
      if ($(".feature-card .btn-feature-card-open").length > 0){
        $(".feature-card .btn-feature-card-open").on("click", function () {
          $(this).closest(".feature-card").children(".feature-card-overlay").addClass("open");
        });

        $(".feature-card .btn-feature-card-close").on("click", function () {
          $(this).closest(".feature-card-overlay").removeClass("open");
        });
      }

    },

    productUgcV2: function () {
      let $ugcCont = $(".ugc-v2-card-cont.owl-carousel");
      if ($ugcCont.length > 0) {
        $ugcCont.owlCarousel({
          items: 4,
          navText: ["<i class='fa fa-chevron-left'></i>", "<i class='fa fa-chevron-right'></i>"],
          responsive: {
            0: {
              items: 1,
              slideBy: 1,
              dots: true,
              nav: true
            },
            640: {
              items: 3,
              dots: false,
              nav: true,
              margin: 20
            }
          }
        });
      }
      // let ugcInt = setInterval(function () {
      //   if (Wistia.api($('.ugc-wistia').first().data("wistia")) !== null) {
      //     clearInterval(ugcInt);
      //
      //     $(".ugc-v2-card").each(function () {
      //       if ($(this).find(".ugc-wistia").length > 0) {
      //         // Wisita UGC
      //         $ugc.push({
      //           container: $(this),
      //           type: "wistia",
      //           wistia: Wistia.api($(this).find(".ugc-wistia").data("wisita"))
      //         })
      //       } else {
      //         // Image UGC
      //         $ugc.push({
      //           container: $(this),
      //           type: "image"
      //         })
      //       }
      //     })
      //
      //
      //     nextUgc();
      //
      //     function nextUgc() {
      //       if ($currentUgc < $ugc.length) {
      //         // if ($(window).width() < 768){
      //         if ($ugc[$currentUgc].type === "wistia") {
      //           $ugc[$currentUgc].wistia.mute();
      //           $ugc[$currentUgc].wistia.play();
      //           $ugc[$currentUgc].wistia.bind("end", function (t) {
      //             $currentUgc++;
      //             $ugcCont.trigger('next.owl.carousel', [500]);
      //             nextUgc();
      //           });
      //         } else {
      //           setTimeout(function () {
      //             $currentUgc++;
      //             $ugcCont.trigger('next.owl.carousel', [500]);
      //             nextUgc();
      //           }, 5000)
      //         }
      //         // } else {
      //         //   if ($ugc[$currentUgc].type === "wistia"){
      //         //     $ugc[$currentUgc].wistia.play();
      //         //     $ugc[$currentUgc].wistia.bind("end", function(t) {
      //         //       $currentUgc++;
      //         //       nextUgc();
      //         //     });
      //         //   } else {
      //         //       $currentUgc++;
      //         //       nextUgc();
      //         //   }
      //         // }
      //       }
      //     }
      //
      //     $(".ugc-v2-card-copy button").on("click", function (e) {
      //       e.stopPropagation();
      //       if (!$(this).siblings("a").hasClass("expanded")) {
      //         $(this).siblings("a").addClass("expanded");
      //         $(this).text("Read less");
      //       } else {
      //         $(this).siblings("a").removeClass("expanded");
      //         $(this).text("Read more");
      //       }
      //
      //     })
      //   }
      // }, 500);


    },

    dqeBlocks: function(){
      let $dqe = $("#dqe-block .owl-carousel");
      if ($dqe.length > 0) {
        $dqe.owlCarousel({
          singleItem: true,
          items: 1.3,
          loop: true,
          margin: 20,
          autoplay: true,
          center: true,
          autoplayTimeout: 5000,
          autoplaySpeed: 1000,
          autoplayHoverPause: true,
          responsive: {
            769: {
              singleItem: false,
              items: 3,
              loop: false,
              margin: 0,
              autoplay: false,
              center: false
            }
          }
        });
      }
    },

    // Grab the member discount amount
    memberDiscount: function (amount) {
      let isMembership = typeof Drupal.settings.isMembership !== 'undefined' ? Drupal.settings.isMembership : false;
      let isMember = typeof Drupal.settings.isMember !== 'undefined' ? Drupal.settings.isMember : true;
      if (!isMembership) {
        return amount;
      }
      let rate = typeof Drupal.settings.memberDiscount !== 'undefined' ? Drupal.settings.memberDiscount : 0.2;
      return app.util.number_format(amount * (1 - rate), 0, '.', '');
    },

    // TODO: Find a way to not use do many arrays in Drupal.settings
    updatePrice: function (selectedModel) {
      let isMembership = typeof Drupal.settings.isMembership !== 'undefined' ? Drupal.settings.isMembership : false;
      let isMember = typeof Drupal.settings.isMember !== 'undefined' ? Drupal.settings.isMember : false;

      let currency = $.cookie('uc_warehouse_location') === 'CA' ? 'CAD' : ($.cookie('uc_warehouse_location') === 'AU' ? 'AUD' : ($.cookie('uc_warehouse_location') === 'KR' ? 'KRW' : ($.cookie('uc_warehouse_location') === 'UK' ? 'GBP' : $.cookie('uc_warehouse_location') === 'HK' ? 'HKD' : 'USD')));
      let $price = $('.config-price');
      let $priceOnly = $('.config-price-only');
      let $priceSticky =  $cache.addToCartSelected.find('.selected-variant-price .price');
      let $premium = $('.premium-price');
      let $premiumSticky = $cache.addToCartSelected.find('.selected-variant-price .reg-price');
      let stockModel = Drupal.settings.models_stock[selectedModel];
      let productModel = Drupal.settings.product_models[selectedModel];

      let showMSRP = typeof Drupal.settings.isMSRPShown !== 'undefined' ? Drupal.settings.isMSRPShown : true;

      // Featured Sale callout — display only, never a price change.
      // models_stock[model].fsc holds pre-rendered markup (absent when this
      // variant has no amount configured), so switching swatch swaps the text.
      $('.rove-featured-sale-extra-discount-wrap').html(stockModel.fsc ? stockModel.fsc : '');

      // change the active price
      let price = app.product.memberDiscount(stockModel.p);
      if (app.isLockedComparePrice) {
        $price.html(app.product.formatCurrency(price, currency));
      } else {
        // $price.html(app.product.formatCurrency(price, currency) + (isMembership ? ' Member' : ''));
        $priceOnly.html(app.product.formatCurrency(price, currency));
        $priceSticky.html(app.product.formatCurrency(price, currency));
        // $price.prepend($cache.infoTip);

      }
      $price.attr('data-base', price);

      // change the active price on top
      $price.find('.offers-price .uc-price').html('$' + price);
      $price.find('.offers-price').attr('content', price);

      // Update the premium / save price
      let sellprice = Drupal.settings.product.sell_price;
      let listprice = (Drupal.settings.product.list_price / Drupal.settings.product.sell_price < 0.3) ? Drupal.settings.product.sell_price : Drupal.settings.product.list_price;
      for (let x in productModel) {
        if (productModel.hasOwnProperty(x)) {
          sellprice += parseFloat(Drupal.settings.oid_details[productModel[x]].price);
          listprice += parseFloat(Drupal.settings.oid_details[productModel[x]].price);
        }
      }
      let saveon = Math.floor(sellprice - parseFloat(stockModel.p));
      if (!isMembership && showMSRP) {
        $premium.html('List ' + app.product.formatCurrency(listprice, currency));
        if (saveon > 0) {
          $premium.append(' - <span class="orange">Save ' + app.product.formatCurrency(saveon, currency) + '</span>');
        }
      } else if (app.isLockedComparePrice) {
        if (saveon > 0) {
          $price.html('<s style="font-size:80%;margin-right:10px;">' + app.product.formatCurrency(app.product.memberDiscount(stockModel.ori), currency) + '</s><span class="actualPrice orange">' + $price.html() + '</span>');
          $premium.html('COMPARE AT ' + app.product.formatCurrency(listprice, currency));
        } else {
          $premium.html('COMPARE AT ' + app.product.formatCurrency(listprice, currency));
        }
      } else if (showMSRP) {
        let $sale_percentage = 0;
        if (saveon > 0) {
          $sale_percentage = ((sellprice - price) / sellprice) * 100;
          $premium.html('<span>Regular <s>' + app.product.formatCurrency(sellprice, currency) + '</s></span>');
          $premium.append('<span class="sale dark-gray">' + app.product.formatCurrency(stockModel.p, currency) + ' Sale</span>');
          $premium.find('span').wrapAll("<div></div>");
        } else {
          $sale_percentage = ((parseFloat(stockModel.p) - price) / parseFloat(stockModel.p)) * 100;
          $premium.html(app.product.formatCurrency(stockModel.p, currency) + " Regular");
        }
      }
      $premiumSticky.html($premium.html());
      if (app.isLockedComparePrice) {
        $premium.prepend($cache.infoTip);
      }

      //app.util.replaceMembersOnlyText($premium,'REGULAR','COMPARE AT');
      if (typeof app.klarna !== 'undefined' && app.klarna.enabled() && app.getCountry() === 'US') {
        app.klarna.refreshPrice(price);
      }

      // Run ABTEST (if applicable)
      app.abtest.abtestProduct();
    },
    formatCurrency: function (amount, currency) {
      let sign = '$';
      let price = parseFloat(amount).toFixed(0);
      switch (currency) {
        case 'CAD':
          sign = 'C$';
          break;
        case 'AUD':
          sign = 'AU$';
          break;
        case 'KRW':
          sign = '원';
          price = app.product.thousandsSeparators(parseFloat(amount).toFixed(0));
          break;
        case 'HKD':
          sign = 'HK$';
          break;
        case 'GBP':
          sign = '£';
          break;
        default:
          sign = '$';
          break;
      }
      let displayPrice = sign + price;
      if (currency == 'KRW') {
        displayPrice = price + sign;
      }
      return displayPrice;
    },
    thousandsSeparators: function (number) {
      var num_parts = number.toString().split(".");
      num_parts[0] = num_parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ",");
      return num_parts.join(".");
    },
    // Change the final sale text if applicable
    finalSale: function (selectedModel) {
      let sck = Drupal.settings.models_stock[selectedModel];
      if (typeof (sck.msg) !== 'undefined') {
        //$('.price_and_qty .final-sale').html(sck.msg.text).attr('data-original-title', sck.msg.tip);
        $('.price_and_qty .final-sale').html(sck.msg.text).attr('title', sck.msg.tip);
        if (sck.msg.text.length) {
          $('.breakdown').append($('<div class="final-sale" data-toggle="tooltip" data-placement="bottom" title="' + sck.msg.tip + '">' + sck.msg.text + '</div>'));
          //$('[data-toggle="tooltip"]').tooltip()
        }
      } else {
        //$('.price_and_qty .final-sale').html('').attr('data-original-title', '');
        $('.price_and_qty .final-sale').html('').attr('title', '');
      }
    },
    // Update the breakdown of selected options
    updateBreakdown: function (selectedModel) {
      let modelInfo = Drupal.settings.product_models[selectedModel];
      let attr_costs = 0;
      let aids = $('[data-aid]').map(function (i, x) {
        return $(x).data('aid');
      }).get();
      let options = [];
      let oid_prices = null;
      let price = null;
      let extclass = null;
      let position = null;

      // Remove all information from breakdown
      $cache.breakdown.find('div').remove();
      $cache.addToCartSelected.find('.product-config').html('');

      if (typeof (modelInfo) !== 'undefined') {
        for (let x = 0; x < modelInfo.length; x++) {
          oid_prices = Drupal.settings.oid_details[modelInfo[x]];
          price = parseFloat(oid_prices.price) > 0 ? '+' + oid_prices.formatted_price : '';
          extclass = parseFloat(oid_prices.price) > 0 ? '' : '';
          position = aids.indexOf(oid_prices.aid);
          options.push({
            label: oid_prices.label,
            extclass: extclass,
            name: oid_prices.name,
            display_mode: oid_prices.display_mode,
            position: position,
            price: price
          });
          attr_costs += parseFloat(oid_prices.price);
        }
        options.sort(function (a, b) {
          if (a.position < b.position) {
            return -1;
          } else if (a.position > b.position) {
            return 1;
          }
          return 0;
        });

        let displayLabel = 0;
        let labelDisplayed = false;
        options.forEach(function (x, i) {
          if (parseInt(x.display_mode) === 0) {
            displayLabel++;
          } else { // if aid is hidden (in product page --> attribute tab), we don't want to
            // display it.
            let label = '';
            let priced = x.price === '' ? '' : ' (' + x.price + ')';
            if (i === displayLabel && !labelDisplayed) {
              label = x.label + ", ";
              labelDisplayed = true;
            }
            $cache.breakdown.append($('<div class="aid"><div class="attr clearfix ' + x.extclass + '">' + label + x.name + priced + '.&nbsp;</div></div>'));
            $cache.addToCartSelected.find('.product-config').append(x.name);
            if (i < options.length - 1 ){
              $cache.addToCartSelected.find('.product-config').append(', ');
            } else {
              let $stock = $(".configuration-msg .stock-info").text().includes("pre-order") ?  "Pre-order" : $(".configuration-msg .stock-info").text();
              $cache.addToCartSelected.find('.product-config').append(' • Qty: ' + $('#edit-qty').val() + '<br><span class="stock-level">'+ $stock +'</span>');
            }
          }
        });
      }
    },

    // Gets a keyed aid=>oid array of the current select options
    getSelectedOptions: function () {
      let selected_oids = {};
      $cache.addToCartForm.find('.attributes input, .attributes select').each(function () {
        let $input = $(this);
        if (typeof $input.find(':selected,:checked').val() !== 'undefined' && $input.find(':selected,:checked').val().length > 0) {
          selected_oids[parseInt($input.attr('id').replace('edit-attributes-', ''))] = parseInt($input.find(':selected,:checked').val());
        }
      });
      //selected_oids = selected_oids.filter(function(e,i,arr){return e;}); // removes empty '' values
      return selected_oids;
    },

    // TODO: Not optimized
    getSelectedModel: function (selected_oids) {
      let models = Drupal.settings.product_models;
      let oidmodels = Drupal.settings.oid_to_model;

      for (let i in selected_oids) {
        if (selected_oids.hasOwnProperty(i)) {
          let available_models = oidmodels[selected_oids[i]];
          model_loop:
            for (let model in available_models) {
              if (available_models.hasOwnProperty(model)) {
                let model_options = models[model];
                let winner = true;
                for (let x = 0; x < model_options.length; x++) {
                  //if ($.inArray(parseInt(model_options[x]),selected_oids) === -1) {
                  if (Object.values(selected_oids).indexOf(parseInt(model_options[x])) === -1) {
                    winner = false;
                    continue model_loop;
                  }
                }
                if (winner) {
                  return model;
                }
              }
            }
        }
      }
      return '';
    },

    destinationUpdate: function ($postalField, nid, model, $clickElement) {
      let postal = $postalField.val();
      $clickElement.addClass('btn-disabled');
      Promise.resolve($.ajax({
        url: '/ajax/destination/update',
        data: {postal: postal, nid: nid, model: model},
        dateType: 'json',
        method: 'POST'
      })).then(function (response) {
        let jsonResponse = JSON.parse(response);

        // Block restricted shipping zones — zone_restricted set by PHP backend
        if (jsonResponse.zone_restricted) {
          $postalField.addClass('error');
          $postalField.parent().next().text(Drupal.t("Sorry, we cannot ship to this address.")).fadeIn();
          return;
        }

        let location = jsonResponse.geo.city + ", " + jsonResponse.geo.state_id;
        console.log('Updating destination to ' + postal + ' at zone ' + jsonResponse.zone);
        if (jsonResponse.hasOwnProperty('geo')) {
          $.cookie('destination-override-' + app.getCountry().toLowerCase(), postal, {
            expires: 365,
            path: '/',
            domain: document.domain
          });
          $.cookie('destination-override-location-' + app.getCountry().toLowerCase(), location, {
            expires: 365,
            path: '/',
            domain: document.domain
          });
          $.cookie('destination-override-zone-' + app.getCountry().toLowerCase(), jsonResponse.zone, {
            expires: 365,
            path: '/',
            domain: document.domain
          });
          $cache.destinationPopup.removeClass('active');
          $cache.destinationLocation.find('a').text(location);
          Drupal.settings.models_stock = jsonResponse.models_stock;
          app.product.updateSatellite(jsonResponse.satellite_id);
          app.product.updateButton(app.product.getSelectedModel(app.product.getSelectedOptions()));

          // Set all postal code entries to the same value
          $(".restricted-postal, .destination-postal").val(postal);

          // Remove the hide on add to cart button
          if (jsonResponse.hasOwnProperty('restricted')) {
            let $productFormActions = $('.configuration-price-action>.form-actions, .configure-stock-info, .config_breakdown, .destination-msg');
            let $restrictedRegion = $('.restricted_region');
            let $restrictedElement = $('[data-restricted-product]');
            if (!jsonResponse.restricted) {
              $productFormActions.removeClass('hide');
              $restrictedRegion.addClass('hide');
              $restrictedElement.attr('data-is-restricted', 0);
              $restrictedElement.attr('data-is-validated', 1);

              if (jsonResponse.restricted_validated) {
                $restrictedElement.attr('data-is-validated', 1);
              } else {
                $restrictedElement.attr('data-is-validated', 0);
              }
            } else {
              $productFormActions.addClass('hide');
              $restrictedRegion.removeClass('hide');
              $restrictedElement.attr('data-is-restricted', 1);
              $restrictedElement.attr('data-is-validated', 0);
              $cache.destinationRestriction.find('.alert').text(Drupal.t("This product is fragile and not available for delivery to !postal.", {'!postal': postal.toUpperCase()})).fadeIn();
            }
          }
        } else {
          $postalField.addClass('error');
          $cache.destinationPopup.find('.alert').text("Error response.").fadeIn();
        }
      }).catch(function (reason) {
        $postalField.addClass('error');
        $cache.destinationPopup.find('.alert').text("An error has occurred.").fadeIn();
        console.log('Ajax/Promise error on loving', reason);
      }).finally(function () {
        $clickElement.removeClass('btn-disabled');
      });
    },

    destinationButton: function ($clickElement, $postalField) {
      let postal = $postalField.val();
      let $alert = $postalField.parent().next();
      let model = app.product.getSelectedModel(app.product.getSelectedOptions());
      $alert.fadeOut();
      if ($postalField.hasClass('entry-ca') && !/[a-zA-Z][0-9][a-zA-Z](-| |)[0-9][a-zA-Z][0-9]/.test(postal)) {
        $postalField.addClass('error');
        $alert.text("Invalid Postal Code").fadeIn();
      } else if ($postalField.hasClass('entry-us') && !/(^\d{5}$)|(^\d{5}-\d{4}$)/.test(postal)) {
        $postalField.addClass('error');
        $alert.text("Invalid Zip Code").fadeIn();
      } else if (!$postalField.hasClass('entry-ca') && !$postalField.hasClass('entry-us')) {
        $postalField.addClass('error');
        $alert.text("This will only work in Canada and the United States.").fadeIn();
      } else {
        $postalField.removeClass('error');

        // Update the postal code
        app.product.destinationUpdate($postalField, Drupal.settings.product.nid, model, $clickElement);
      }
    },

    destinationInit: function () {
      let destinationZone = $.cookie('destination-override-zone-' + app.getCountry().toLowerCase());
      let destinationOverride = $.cookie('destination-override-' + app.getCountry().toLowerCase());
      let destinationLocation = $.cookie('destination-override-location-' + app.getCountry().toLowerCase());

      if (destinationLocation) {
        $('.delivery-location a').text(destinationLocation);
      }

      if (destinationOverride) {
        $('.destination-postal, .restricted-postal').val(destinationOverride);

        // Trigger submission on page load
        //let $fakeClick = $('.restricted-region-entry a');
        //let $postalField = $fakeClick.parent().hasClass('restricted-region-entry') ? $(".restricted-postal") : $(".destination-postal");
        //app.product.destinationButton($fakeClick, $postalField);
      }

      // Destination entry link
      if (!$cache.destinationPopup.length) {
        return;
      }
      if ($cache.destinationLocation.length) {
        $cache.destinationLocation.find('a').on('click', function (e) {
          e.preventDefault();
          $cache.destinationPopup.toggleClass('active');
        }).on();
      }
      $cache.destinationPopupUpdate.on('click', function (e) {
        e.preventDefault();

        if (!$(this).hasClass('btn-disabled')) {
          let $postalField = $(this).parent().hasClass('restricted-region-entry') ? $(".restricted-postal") : $(".destination-postal");
          app.product.destinationButton($(this), $postalField);
        }
      });
      $(document).mouseup(function (e) {
        let container = $('.destination-popup.active');
        // if the target of the click isn't the container nor a descendant of the container
        if (!container.is(e.target) && container.has(e.target).length === 0) {
          container.removeClass('active');
        }
      });
    },

    // Notify me
    notifyMeInit: function () {
      $cache.addToCartForm.find('.notify').on('mousedown', app.product.notifyMe);
      $('.close-notifyme').on('click', function () {
        $.colorbox.close();
      });
    },
    notifyMe: function (e) {
      let $this = $(this);
      let $form = $('#uc-warehouse-popup-notifyme-form');
      let $notify = $('#notifyme');
      if ($this.hasClass('notify')) {
        e.preventDefault();
        $form.find('input[name="model"]').val($('.breakdown .model').html());
        $form.find('input[name="qty"]').val($cache.addToCartForm.find('.form-item-qty input, .form-item-qty select :selected').val());
        $notify.find('.enterdata').show();
        $notify.find('.submitdata').hide();
        $notify.find('.notifyme-title div').html('');
        $('.breakdown:visible .aid').each(function () {
          $notify.find('.notifyme-title div').append($this.find('.attr').html());
        });
        $.colorbox({
          inline: true, href: '#notifyme', maxWidth: '90%', width: 500, speed: 0, onClosed: function () {
            $notify.find('.enterdata').show();
            $notify.find('.submitdata').hide();
          }
        });
      }
    },

    /* Disable certain elements in filter dropdowns */
    disableUnavailableSwatches: function () {
      // We can try to disable bootstrap select items that have no available items.
      $cache.swatchFilters.find('select option').attr('disabled', false);
      $('ul.grouped').each(function () {
        if (!$(this).find('li:visible').length) {
          $cache.swatchFilters.find('select option[value="' + $(this).data('aid') + '"]').attr('disabled', 'disabled');
        }
      });
      //$cache.swatchFilters.find('select').refresh('refresh');
    },
    // Toggle the available/custom
    swatchDisplayChange: function ($element) {
      let holder = $element.attr('aria-controls');

      // Reset
      $('[name="filter-availability"]').prop('checked', false);
      $('#edit-stocksale input.form-checkbox').prop('checked', false); // set sale checkbox to unchecked
      $(".filter-tabs-triggers a").removeClass('active');

      // Handle click
      $element.addClass('active');
      $element.find('input').prop('checked', true);
      $('#swatches_group').appendTo('#' + holder);

      switch (holder) {
        case 'swatches-custom':
          $('#edit-stocksale-custom').prop('checked', true).trigger('change');
          break;
        case 'swatches-expedited':
          $('#edit-stocksale-expedited').prop('checked', true).trigger('change');
          break;
        case 'swatches-instock':
          $('#edit-stocksale-stock').prop('checked', true).trigger('change');
          break;
      }

      app.product.instockOnlyFilterInit();

      // Make sure a swatch is chosen
      if (!$('#swatches_group li.selected').is(':visible')) {
        // Automatically select the first visible swatch
        $('#swatches_group li:visible').first().trigger('click');
      }
    },

    externalSiteLink: function () {
      return false;
      if (parseInt(Drupal.settings.product.nid) === 3185 && app.getCountry() === 'US') {
        $('#product-img-wrap img[data-oid=""]').each(function (e, i) {
          $(this).after($('<a>', {
            href: "https://www.opheliabed.com?utm_source=referral&utm_medium=ophelia-bed&utm_id=rove",
            class: 'externalLinkOut'
          }).append($('<img>', {
            src: 'https://cdn.roveconcepts.com/sites/default/files/ophelia-overlay.png',
            class: 'img-responsive img-overlay-carousel',
            style: 'z-index: 0; position: absolute;top: 0;left: 0;width: 100%;'
          })));
        });

        $(document).on('click', 'a.externalLinkOut', function (e) {
          e.preventDefault();
          var url = $(this).attr('href');
          var callback = function () {
            if (typeof (url) != 'undefined') {
              window.location = url;
            }
          };

          gtag('event', 'conversion', {
            'send_to': 'AW-1016437901/sT1VCKuO784DEI251uQD',
            'event_callback': callback
          });

          return false;
        });
      }
    },

    reviewWall: function () {
      let $reviewWall = $('#reviewWall');

      let $productName = $('#product-actions h1').text();



      // Clicking on load more
      $('.review_load_more>a').on('click', function (e) {
        e.preventDefault();
        let $this = $(this);

        $.ajax({
          url: $this.attr('href'),
          data: [],
          success: function (data) {
            for (let x = 0; x < data.reviews.length; x++) {
              $reviewWall.append(data.reviews[x]);
            }
            if (data.next) {
              $this.attr('href', data.next);
            } else {
              $this.parent().remove();
            }
          },
          error: function () {
            console.error('Error trying to obtain new reviews.');
          }
        });
      });


    },
    upsellPopup: function () {
      let $sizeWidth = $(window).width() < 500 ? ($(window).width() - 20) : 480;
      let $sizeHeight = $(window).width() < 500 ? (($(window).width() - 20) * 1.45 ) : 630;
      const $data = [
        {
          title: 'Florian Outdoor Cover',
          image: 'Florian-Outdoor-Lounger_Cover_1.jpg'
        },
        {
          title: 'Dresden Outdoor Left/Right Arm Sofa Cover',
          image: 'Dresden_Outdoor_Right-Arm-Sofa_Cover_1.jpg'
        },
        {
          title: 'Dresden Outdoor Armless Sofa Cover',
          image: 'Dresden_Outdoor_Armless-Sofa_Armrest_Cover_1.jpg'
        },
        {
          title: 'Dresden Outdoor Left/Right Chaise Cover',
          image: 'Dresden_Outdoor_Right-Chaise-Armrest_Cover_1.jpg'
        },
        {
          title: 'Arya Outdoor Armless Cover',
          image: 'Arya_Armless_Cover_1_0.jpg'
        },
        {
          title: 'Arya Outdoor Left Arm Cover',
          image: 'Arya_Left_Arm_Cover_1.jpg'
        },
        {
          title: 'Arya Outdoor Ottoman Cover',
          image: 'Arya_Ottoman_Cover_1.jpg'
        },
        {
          title: 'Arya Outdoor Right Arm Cover',
          image: 'Arya_Right_Arm_Cover_1.jpg'
        },
        {
          title: 'Francis Outdoor Left Arm 2 Seater Cover',
          image: 'Francis_2_Seater_LHF_Outdoor_Cover_01.jpg'
        },
        {
          title: 'Francis Outdoor Right Arm 2 Seater Cover',
          image: 'Francis_2_Seater_RHF_Outdoor_Cover_01.jpg'
        },
        {
          title: 'Francis Outdoor Left/Right Chaise Cover',
          image: 'Francis_Chaise_LHF_Outdoor_Cover_1.jpg'
        },
        {
          title: 'Francis Outdoor Lounger Cover',
          image: 'Francis_Lounger_Outdoor_Cover_1.jpg'
        },
        {
          title: 'Francis Outdoor Ottoman Cover',
          image: 'Francis_Outdoor_Ottoman_Couver_01.jpg'
        },
        {
          title: 'Louis Outdoor Armchair Cover',
          image: 'Louis_Armchair_Outdoor_Cover_1_0.jpg'
        },
        {
          title: 'Louis Outdoor Loveseat Cover',
          image: 'Louis_Loveseat_Outdoor_Cover_1.jpg'
        },
        {
          title: 'Louis Outdoor Sofa Cover',
          image: 'Louis_Sofa_Outdoor_Cover_1.jpg'
        },
        {
          title: 'Jericho Sling Chair Cover',
          image: 'Jericho_Sling_Chair_Outdoor_Cover_1.jpg'
        },
        {
          title: 'Mika Outdoor Left Arm Chaise Cover',
          image: 'Mika-Left-Arm-Chaise-Cover_1.jpg'
        },
        {
          title: 'Mika Outdoor Right Arm Chaise Cover',
          image: 'Mika-Right-Arm-Chaise-Cover_1.jpg'
        },
        {
          title: 'Mika Outdoor Ottoman Cover',
          image: 'Mika-Ottoman-Cover_1.jpg'
        },
        {
          title: 'Mika Outdoor Armless Open Left 3 Seater Cover',
          image: 'Mika-Open-Left-Seater-Cover_1.jpg'
        },
        {
          title: 'Mika Outdoor Armless Open Right 3 Seater Cover',
          image: 'Mika-Open-Right-Seater-Cover_2.jpg'
        },
        {
          title: 'Tano Outdoor Left Corner Cover',
          image: 'Tano_Outdoor_Left_Corner_Cover_1.jpg'
        },
        {
          title: 'Tano Outdoor Armless Cover',
          image: 'Tano%20_Outdoor_Armless_Cover_1.jpg'
        },
        {
          title: 'Tano Outdoor Right Corner Cover',
          image: 'Tano_Outdoor_Right_Corner_Cover_1.jpg'
        },
        {
          title: 'Tola Outdoor Dining Chair Cover',
          image: 'Tola_Outdoor_Dining_Chair_Cover_1.jpg'
        },
        {
          title: 'Tola Outdoor Lounge Chair Cover',
          image: 'Tola_Outdoor_Lounge_Chair_Cover_1.jpg'
        }
      ];
      const $upsell = [
        {
          main_product: 'Florian Outdoor Lounger',
          upsell_product: ['Florian Outdoor Cover']
        },{
          main_product: 'Dresden Outdoor Right Arm Sofa',
          upsell_product: ['Dresden Outdoor Left/Right Arm Sofa Cover']
        },{
          main_product: 'Dresden Outdoor Left Arm Sofa',
          upsell_product: ['Dresden Outdoor Left/Right Arm Sofa Cover']
        },{
          main_product: 'Dresden Outdoor Armless Sofa with Armrest',
          upsell_product: ['Dresden Outdoor Armless Sofa Cover']
        },{
          main_product: 'Dresden Outdoor Armless Sofa with Side Table',
          upsell_product: ['Dresden Outdoor Armless Sofa Cover']
        },{
          main_product: 'Dresden Outdoor Right Chaise with Armrest',
          upsell_product: ['Dresden Outdoor Left/Right Chaise Cover']
        },{
          main_product: 'Dresden Outdoor Left Chaise with Armrest',
          upsell_product: ['Dresden Outdoor Left/Right Chaise Cover']
        },{
          main_product: 'Arya Outdoor Armless',
          upsell_product: ['Arya Outdoor Armless Cover']
        },{
          main_product: 'Arya Outdoor Left Arm',
          upsell_product: ['Arya Outdoor Left Arm Cover']
        },{
          main_product: 'Arya Outdoor Ottoman',
          upsell_product: ['Arya Outdoor Ottoman Cover']
        },{
          main_product: 'Arya Outdoor Right Arm',
          upsell_product: ['Arya Outdoor Right Arm Cover']
        },{
          main_product: 'Francis Outdoor Left Arm 2 Seater',
          upsell_product: ['Francis Outdoor Left Arm 2 Seater Cover']
        },{
          main_product: 'Francis Outdoor Right Arm 2 Seater',
          upsell_product: ['Francis Outdoor Right Arm 2 Seater Cover']
        },{
          main_product: 'Francis Outdoor Right Chaise',
          upsell_product: ['Francis Outdoor Left/Right Chaise Cover']
        },{
          main_product: 'Francis Outdoor Left Chaise',
          upsell_product: ['Francis Outdoor Left/Right Chaise Cover']
        },{
          main_product: 'Francis Outdoor Lounger',
          upsell_product: ['Francis Outdoor Lounger Cover']
        },{
          main_product: 'Francis Outdoor Ottoman',
          upsell_product: ['Francis Outdoor Ottoman Cover']
        },{
          main_product: 'Louis Outdoor Armchair',
          upsell_product: ['Louis Outdoor Armchair Cover']
        },{
          main_product: 'Louis Outdoor Loveseat',
          upsell_product: ['Louis Outdoor Loveseat Cover']
        },{
          main_product: 'Louis Outdoor Sofa',
          upsell_product: ['Louis Outdoor Sofa Cover']
        },{
          main_product: 'Jericho Sling Chair',
          upsell_product: ['Jericho Sling Chair Cover']
        },{
          main_product: 'Mika Outdoor Left Arm Chaise',
          upsell_product: ['Mika Outdoor Left Arm Chaise Cover']
        },{
          main_product: 'Mika Outdoor Right Arm Chaise',
          upsell_product: ['Mika Outdoor Right Arm Chaise Cover']
        },{
          main_product: 'Mika Outdoor Ottoman',
          upsell_product: ['Mika Outdoor Ottoman Cove']
        },{
          main_product: 'Mika Outdoor Armless Open Left 3 Seater',
          upsell_product: ['Mika Outdoor Armless Open Left 3 Seater Cover']
        },{
          main_product: 'Mika Outdoor Armless Open Right 3 Seater',
          upsell_product: ['Mika Outdoor Armless Open Right 3 Seater Cover']
        },{
          main_product: 'Tano Outdoor Left Corner',
          upsell_product: ['Tano Outdoor Left Corner Cover']
        },{
          main_product: 'Tano Outdoor Armless',
          upsell_product: ['Tano Outdoor Armless Cover']
        },{
          main_product: 'Tano Outdoor Right Corner',
          upsell_product: ['Tano Outdoor Right Corner Cover']
        },{
          main_product: 'Tola Outdoor Dining Chair',
          upsell_product: ['Tola Outdoor Dining Chair Cover']
        },{
          main_product: 'Tola Outdoor Lounge Chair',
          upsell_product: ['Tola Outdoor Lounge Chair Cover']
        }
      ];

      let $upsellMatch = $upsell.filter(function (e) {
        return e.main_product === $(".product-info-desktop h1").text();
      });

      if ($upsellMatch.length > 0) {
        function upsellModal() {
          let $prod = {};
          let $productUrl = ""
          $upsellMatch[0].upsell_product.forEach(function (o) {
            $prod = $data.filter(function (e) {
              return e.title === o;
            })[0];
            $productUrl = $prod.title.toLowerCase().replace(/\//g, "").split(' ').join('-');
          });

          setTimeout(function () {
            $.colorbox({
              position: "fixed",
              width: $sizeWidth + "px",
              height: $sizeHeight + "px",
              maxWidth: '100%',
              maxHeight: '900px',
              opacity: 1,
              inline: false,
              html: "<div class='upsell-modal'><div class='upsell-modal-top'><img class='upsell-product-card-image' src='https://cdn.roveconcepts.com/sites/default/files/styles/uc_product_list/public/" + $prod.image + "' alt='" + $prod.title + "'/></div><div class='upsell-modal-bottom'><h2>Shop Matching Cover</h2><p>Don't forget to add matching outdoor cover to protect your new furniture.</p><a class='btn-primary' href='" + $productUrl + "' target='_blank'>View Cover</a><button type='button' class='close-btn'>No thanks, I don't want to protect my furniture.</button></div></div>",
              onComplete: function () {
                // $('#colorbox').css('position', 'fixed').css('top', (($(window).height() - $sizeHeight) / 2) + 40 + "px");
                $(".close-btn").on("click", function(){$.colorbox.close()})
              },
              onOpen: function () {
                $('body').css('overflow', 'hidden');
              },
              onClosed: function () {
                $('body').css('overflow', 'auto');
                $('#colorbox').removeClass("upsell-colorbox");
              }
            });
          }, 2000);
        };


        $("button.node-add-to-cart").one("mousedown touch", function () {upsellModal();})

        // $("button.node-add-to-cart").one("mousedown touch", function () {
        //   if ($(window).width() < 769){
        //     let cartPopupInterval = setInterval(function (){
        //       if ($(".add-to-cart-modal").length > 0){
        //         clearInterval(cartPopupInterval);
        //         $(".add-to-cart-modal #cboxClose").one("mousedown touch", function () {
        //           upsellModal();
        //         });
        //       }
        //     }, 1000);
        //   } else {
        //       upsellModal();
        //   }
        // });




      }
    },

    imageSwipe: function (opt) {

      if (opt === "reset") {
        $cache.pos = 0;
        $cache.imageWrapper.css("right", 0);
      } else {
        if (!isNaN(opt)) {
          $cache.pos = opt;
        } else if (opt === "right") {
          if ($cache.pos < $cache.imageWrapper.children(".photo-item").length - 1) {
            $cache.pos++;
          }
        } else {
          if ($cache.pos > 0) {
            $cache.pos--;
          }
        }
        let $pos = 0;
        $cache.imageWrapper.find("picture").each(function (i) {
          if (i < $cache.pos) {
            $pos += $(this).width();
          }
        })
        $cache.imageWrapper.css("right", $pos + "px");
        $cache.navThumbs.children("div").each(function (i) {
          if (i !== $cache.pos) {
            $(this).addClass("unfilled")
          } else {
            $(this).removeClass("unfilled")
          }
        })
      }

      // Check if current position is a video item, use previous image height if so
      let $currentItem = $cache.imageWrapper.children(".photo-item").eq($cache.pos);
      let isVideo = $currentItem.hasClass('video-item') || $currentItem.hasClass('product-videos');
      let heightIndex = isVideo && $cache.pos > 0 ? $cache.pos - 1 : $cache.pos;

      $cache.imageWrapper.css("height", $cache.imageWrapper.find("img").eq(heightIndex).height() + "px")
      let x = new MutationObserver(function () {
        if ($cache.imageWrapper.find("img").eq(heightIndex).height() > 2) {
          $cache.imageWrapper.css("height", $cache.imageWrapper.find("img").eq(heightIndex).height() + "px")
        }
      });
      if ($cache.imageWrapper.find("img").length) {
        x.observe($cache.imageWrapper.find("img").eq(heightIndex)[0], {attributes: true});
      }
      if ($cache.pos === $cache.imageWrapper.children(".photo-item").length - 1) {
        $(".img-right").css("opacity", 0);
        $(".img-left").css("opacity", 0.5);
      } else if ($cache.pos === 0) {
        $(".img-right").css("opacity", 0.5);
        $(".img-left").css("opacity", 0);
      } else {
        $(".img-right").css("opacity", 0.5);
        $(".img-left").css("opacity", 0.5);
      }
    },
    financeCA: function () {
      $(".price_and_qty").after("<div class='ca-payright-cont'><div class='payright-inline-date'><p>Get the furniture you love today. Pay later.<span>Learn more</span></p></div></div>");
      $(".ca-payright-cont span").on("click", () => {
        let $sizeWidth = $(window).width() < 820 ? $(window).width() * 0.95 : 820;
        let $sizeHeight = $(window).width() < 476 ? $(window).height() : ($(window).width() < 991 ? 530 : 700);
        $.colorbox({
          //?width=95%&amp;maxwidth=820&amp;inline=true&amp;fixed=true
          width: $sizeWidth + "px",
          maxWidth: '100%',
          maxHeight: '100%',
          opacity: 0.35,
          height: $sizeHeight + "px",
          inline: false,
          html: '<div class="modal_hold">' +
            '<div id="financemodal" class="centerfont">' +
            '<div class="">' +
            '<div class="affirmTitles">' +
            '<h3 class="subtitle toptitle">Low Interest</h3>' +
            '<h2 class="title">Financing</h2>' +
            '<h3 class="subtitle">Up To 24 Months</h3>' +
            '<div class="affirmHead">Get the furniture you love today. Pay Later.</div>' +
            '</div>' +
            '<div class="affirmPoints">' +
            '<div class="affirmBox col-xs-12 col-sm-6">' +
            '<img src="https://cdn.roveconcepts.com/sites/all/modules/glh/uc_affirm/images/icon-affirm-monthly-opt.png" alt="Monthly Payments">' +
            '<h3>Easy Monthly Payments</h3>' +
            '<p>Provide some basic information and get instantly approved to split your purchase into 12, 18, or 24 monthly payments. Affirm offers rates from <?php print (variable_get("uc_paybright_rate_lowest",0.1)*100); ?>-19.95% interest based on your credit. </p>' +
            '</div>' +
            '<div class="affirmBox col-xs-12 col-sm-6">' +
            '<img src="https://cdn.roveconcepts.com/sites/all/modules/glh/uc_affirm/images/icon-affirm-flexible-opt.png" alt="Flexible Payment">' +
            '<h3>Flexible Payment</h3>' +
            '<p>Simply pay your monthly bill using a bank transfer or credit card.</p>' +
            '<div class="affirmNote">Just select "Pay with Affirm" at checkout.</div>' +
            '</div>' +
            '</div>' +
            '<div class="affirm_disclaimer col-xs-12">' +
            'Previous purchases are ineligible for offer. Offer is subject to change at any time. Pay over 12, 18, or 24 months with <?php print (variable_get("uc_paybright_rate_lowest",0.1)*100); ?>% interest financing when you complete a purchase using Affirm. Eligibility subject to applicant`s creditworthiness. Applicants that do not qualify for <?php print (variable_get("uc_paybright_rate_lowest",0.1)*100); ?>% interest financing will be evaluated for loans with 12, 18 or 24 monthly installments at rates from <?php print (variable_get("uc_paybright_rate_lowest",0.1)*100); ?>-19,95% interest based on creditworthiness.' +
            '</div>' +
            '</div>' +
            '<div class="clearfix"></div>' +
            '</div>' +
            '</div>',
          onComplete: function () {
            $('#colorbox').css('position', 'fixed').css('top', ($(window).height() - $sizeHeight) / 2 + "px");
          }
        });
      })
    },

    showPrice: function () {
      $(".product-price-cont").html($(".config-price, .premium-price, .premium-price-vat"));
      $(".product-price-cont .config-price, .product-price-cont .premium-price, .product-price-cont .premium-price-vat").removeClass("hide");
      $cache.addToCartSelected.find(".price").html($(".config-price-only").html());
      $cache.addToCartSelected.find(".reg-price").html($(".premium-price").html());
      let selectedOptions = app.product.getSelectedOptions();
      let selectedModel = app.product.getSelectedModel(selectedOptions);
      if (selectedModel.length)
      {
        // Update the breakdown information
        app.product.updateBreakdown(selectedModel);
      }
      },

    instockOnlyCheck: function () {
      app.product.instockOnlyFilterInit();
      $("#checkbox_instock_only").off("click").on("click", function (e) {
        app.product.instockOnlyHideOptions();
      });
    },

    instockOnlyHideOptions: function () {
      const stockOids = Drupal.settings.in_stock_oids;
      if ($("#checkbox_instock_only").is(":checked")) {
        $("#checkbox_instock_only_container").addClass('isChecked');
        $("#product-swatches li").each(function () {
          if (typeof $(this).data('oid') !== 'undefined') {
            const oid = $(this).data('oid') + '';
            if (!stockOids.includes(oid)) {
              $(this).addClass('hide');
              $(this).addClass('in_stock_only_hide');
            }
          }
        });
        //check it after hide the no-stock options
        app.product.optionVisibleCheck();
        //check the combination of each selected option
        app.product.instockOnlyHideCombos();
        //check it again after hiding the combos
        app.product.optionVisibleCheck();
      } else {
        $("#checkbox_instock_only_container").removeClass('isChecked');
        $("#product-swatches .in_stock_only_hide").each(function () {
          $(this).removeClass('hide');
          $(this).removeClass('in_stock_only_hide');
        });
      }
    },

    instockOnlyHideCombos: function () {
      const oid = $('#swatches_group li.selected').data('oid') + '';
      const combos = Drupal.settings.in_stock_combos;
      if (typeof combos[oid] !== 'undefined' && combos[oid]) {
        $('.attribute_solos .solo_group li').each(
          function () {
            var checkOid = $(this).data('oid') + '';
            if (typeof checkOid !== 'undefined' && checkOid) {
              if (!combos[oid].includes(checkOid)) {
                $(this).addClass('hide');
                $(this).addClass('in_stock_only_hide');
              } else {
                $(this).removeClass('hide');
                $(this).removeClass('in_stock_only_hide');
              }
            }
          }
        );
      }

      $('.attribute_solos .solo_group').each(
        function () {
          var oidGroupSolo = $(this).find('li.selected').data('oid') + '';
          if (typeof combos[oidGroupSolo] !== 'undefined' && combos[oidGroupSolo]) {
            $('#swatches-instock li').each(
              function () {
                var checkOid = $(this).data('oid') + '';
                if (typeof checkOid !== 'undefined' && checkOid) {
                  if (!combos[oidGroupSolo].includes(checkOid)) {
                    $(this).addClass('hide');
                    $(this).addClass('in_stock_only_hide');
                  } else {
                    $(this).removeClass('hide');
                    $(this).removeClass('in_stock_only_hide');
                  }
                }
              }
            );
          }
        }
      );

    },

    instockOnlyFilterInit: function () {
      if ($(".trigger-stock").hasClass('active')) {
        $("#checkbox_instock_only_container").removeClass('hide');
      } else {
        $("#checkbox_instock_only_container").addClass('hide').removeClass('isChecked');
        $("#checkbox_instock_only").prop('checked', false);
        $("#product-swatches .in_stock_only_hide").each(function () {
          $(this).removeClass('hide');
          $(this).removeClass('in_stock_only_hide');
        });
      }
    },

    optionVisibleCheck: function () {
      // Make sure a swatch is chosen
      if (!$('#swatches_group li.selected').is(':visible')) {
        // Automatically select the first visible swatch
        $('#swatches_group li:visible').first().trigger('click');
      }
      $('.attribute_solos .solo_group').each(
        function () {
          if (!$(this).find('li.selected').is(':visible')) {
            // Automatically select the first visible swatch
            $(this).find('li:visible').first().trigger('click');
          }
        }
      );
    },

    // mobileCustomerPhoto: function() {
    //   let $clonePhotos = $(".customer-photos-cont").clone();
    //   $clonePhotos.addClass("customer-photos-cont-rep").removeClass("customer-photos-cont");
    //   $(".customer-photos-cont").after($clonePhotos);
    //   $(".customer-photos-cont").css("display","none");
    //   $.each($(".customer-photos-cont-rep>div"),function(i){
    //     let index = i;
    //     $(this).off("click").on("click", function(e){
    //       $(".customer-photos-cont>div").find(".cphoto").eq(index).click()})
    //   });
    // },

    koreanTranslation: function () {
      $(".product-reviews .rv_top div:first-of-type p").html("여러분의 홈데코 스타일을 담은 사진을 공유해주세요.  전체 갤러리는 <a href='/trustpilot'>여기서</a> 확인해주세요.")
    },

    wheelZoom: function (options) {
      let imageClassName = '.cboxPhoto';
      $cache.wZoomFrame = document.getElementById('cboxLoadedContent');
      $cache.wZoomImage = document.querySelector(imageClassName);

      if ($cache.wZoomImage.complete) {
        init();
      } else {
        $cache.wZoomImage.onload = init;
      }

      function init() {
        let wrapper = document.createElement('div');
        $cache.wZoomImage.parentNode.insertBefore(wrapper, $cache.wZoomImage);
        wrapper.appendChild($cache.wZoomImage);
        wrapper.setAttribute("id", "zoomerrFrame");

        options = {};
        options.type = 'html';
        options.width = $cache.wZoomImage.naturalWidth;
        options.height = $cache.wZoomImage.naturalHeight;
        options.dragScrollableOptions = {
          onGrab: function () {
            $cache.wZoomFrame.style.cursor = 'grabbing';
          },
          onDrop: function () {
            $cache.wZoomFrame.style.cursor = 'grab';
          }
        }


        $cache.wZoomImage.style.width = 'auto';
        $cache.wZoomImage.style.height = 'auto';
        $cache.wZoomImage.style.margin = 'auto';

        $cache.wZoomFrame.style.display = 'flex';
        $cache.wZoomFrame.style.justifyContent = 'center';
        $cache.wZoomFrame.style.alignItems = 'center';

        $cache.wzoom = WZoom.create(wrapper, options);
      }
    },
    wheelZoomDestroy: function () {
      if (typeof $cache.wzoom !== 'undefined') {
        $cache.wzoom.destroy();
        $cache.wzoom = null;
      }
    }
  }

}(window.app = window.app || {}, jQuery));

var youtubePlayer;

/*!
 * app.ui.page.js
 */
(function (app, $) {
  let $cache = {storeClosingIntervals:[]};
  app.page = {
    title: "",
    type: "",
    setContext: function (o) {
      $.extend(app.page, o);
    },
    params: app.util.getQueryStringParams(window.location.search.substr(1)),
    refresh: function () {
      let u = window.location.href.replace(window.location.hash, "");
      // remove hash from url
      let t = setTimeout(function () {
        window.location.assign(u);
      }, 500);
    },
    init: function () {

      // Trade page specific functionality
      app.page.homePage();

      app.page.visitUs();
      app.page.stlHome();
      app.page.hostPage();
      app.page.initMenuHeight();
      app.page.openNewTab([".menu-sofa-guide a"]);
      app.page.userMembershipPage();


      if (app.page.title.indexOf("Reviews") > -1) {
        app.page.updateReviews();
      }

      if (app.page.title.indexOf("Host Program") > -1) {
        app.page.hostProgramCarousel();
      }


      if (app.page.title.indexOf("Maria Collection") > -1) {
        app.page.mariaPg();
      }

      if (app.page.title.indexOf("John Legend Collection") > -1) {
        app.page.jlPage();
      }

      if (app.page.title.indexOf("Membership") > -1) {
        app.page.membershipLanding();
      }

      if (app.page.title.indexOf("Trade Membership Application") > -1) {
        app.page.tradeForm();
      }

      if (app.page.title.indexOf("Trade") > -1) {
        app.page.tradePage();
        app.page.tradeScrollIndicator('.trade-details-cont','.trade-detail-cont','.trade-details-thumb');
        app.page.tradeScrollIndicator('.testimonials-cont','.testimonial-cont','.testimonial-thumb');
      }

      app.page.storeClosingInterval('au');
      // app.page.storeClosingInterval('hk');
      app.page.storeClosingInterval('kr');

      // if (!window.location.origin.includes("team.roveconcepts.com") && !window.location.pathname.includes("-showroom") && !window.location.pathname.includes("cart") && !window.location.pathname.includes("user/")&& !window.location.pathname.includes("ar/")){
      //     app.page.showroomPopup();
      // }

      if (app.page.title.indexOf("Showroom:") > -1) {
        app.page.showroomPage();
      }

    },

    initMenuHeight: function () {
      let $body = $('body');
      let $menuHeight = $('#header').outerHeight();
      if ($('#anouncement')[0]) {
        $menuHeight += $('#anouncement').outerHeight();
      }
      $body.css('--menuHeight', $menuHeight + 'px');
      $body.css('--menuHeightMobile', ($menuHeight + $('#nav-menu-search').outerHeight()) + 'px');
      if ($('#countdown')[0]) {
        $menuHeight += $('#countdown').outerHeight();
        $body.css('--menuHeightWCountdown', $menuHeight + 'px');
        $body.css('--menuHeightMobileWCountdown', ($menuHeight + $("#nav-menu-search").outerHeight()) + 'px');
      }

    },

    hostProgramCarousel: function(){
      let $hostInfoOwl = $(".host-info-card-cont");
      let $hostOwl = $(".host-list-card-cont");
      let $testimonialOwl = $(".host-testimonial-card-cont");

      if ($hostInfoOwl.length > 0) {
        $hostInfoOwl.owlCarousel({
          singleItem: true,
          items: 1,
          loop: true,
          autoplay: true,
          center: true,
          autoplaySpeed: 1000,
          dots: true
        });


        if ($hostOwl.length > 0) {
          if ($(window).width() < 769){
            $hostOwl.owlCarousel({
              singleItem: true,
              items: 1.3,
              loop: true,
              center: true,
              autoplaySpeed: 1000,
              margin: 20,
              dots: false
            });
          } else {
            $hostOwl.addClass("off");
          }
        }
      }

      if ($testimonialOwl.length > 0) {
        $testimonialOwl.owlCarousel({
          singleItem: true,
          items: 1,
          loop: true,
          autoplay: true,
          center: true,
          autoplaySpeed: 1000,
        });
      }
    },

    storeClosingInterval: function(store) {
      let $closingBlock = $("#block-block-116");
      if ($closingBlock.length > 0) {
        $cache.storeClosingIntervals[store] = setInterval(function () {
          if (typeof app !== 'undefined' && typeof app.getCountry !== 'undefined' && !window.location.href.includes("team")) {
            clearInterval($cache.storeClosingIntervals[store]);
            if (app.getCountry() === store.toUpperCase() || window.location.href.includes(app.getCountryLangCode(store)) || (store.toUpperCase() === 'AU' && window.location.href.includes("au.roveconcepts.com"))) {
              $closingBlock.css('display','block');
              $closingBlock.find("." + store+'-storeClosingBox').css('display','block');
              document.querySelector("." + store + "-closing-modal").classList.add("open");
              document.body.style.overflow = "hidden";
            }
          }
        }, 500);
      }
    },
    showroomPopup: function(){
      let $data = [
        {country: "US",
          region: [
            {
              state: "California",
              cities: ["Los Angeles", "Santa Monica", "Irvine", "Beverly Hills", "Lucerne Valley", "Pasadena", "Newport Beach", "West Hollywood", "Culver City", "El Segundo", "Venice", "Torrance", "Costa Mesa", "Burbank", "Santa Ana", "Aliso Viejo", "Woodland Hills", "Long Beach", "Anaheim", "Westlake Village", "Glendale", "Manhattan Beach", "Marina Del Rey", "Sherman Oaks", "Encino", "Huntington Beach", "Orange", "Van Nuys", "Lake Forest", "San Clemente", "Chatsworth", "Riverside", "Valencia", "Calabasas", "Walnut", "Agoura Hills", "Redondo Beach", "Tustin", "Laguna Hills", "Thousand Oaks", "Temecula", "Fountain Valley", "Mission Viejo", "Malibu", "Studio City", "North Hollywood", "Laguna Beach", "Ventura", "Fullerton", "Hermosa Beach", "Murrieta", "Corona", "Pomona", "San Juan Capistrano", "Rancho Santa Margarita", "Rancho Cucamonga", "Monrovia", "Gardena", "Simi Valley", "Camarillo", "Oxnard", "Brea", "Garden Grove", "Palm Springs", "Whittier", "Monterey Park", "Cerritos", "Palm Desert", "City Of Industry", "San Bernardino", "Tarzana", "Buena Park", "Northridge", "Pacific Palisades", "La Canada Flintridge", "Canoga Park", "Ontario", "Diamond Bar", "West Covina", "Laguna Niguel", "Foothill Ranch", "Playa Vista", "La Mirada", "Santa Clarita", "Claremont", "Alhambra", "Lancaster", "Yorba Linda", "Redlands", "Westminster", "Toluca Lake", "Hawthorne", "Carson", "Ladera Ranch", "Newbury Park", "Rancho Palos Verdes", "Sylmar", "South Pasadena", "Inglewood", "Arcadia", "Azusa", "Glendora", "Moreno Valley", "Moorpark", "Cypress", "Dana Point", "El Monte", "Reseda", "Altadena", "Palmdale", "Santa Fe Springs", "Chino", "San Dimas", "Panorama City", "Rancho Dominguez", "Commerce", "Fontana", "Seal Beach", "Granada Hills", "Sun Valley", "Playa Del Rey", "Canyon Country", "Rosemead", "Universal City", "Century City", "Covina", "Upland", "Chino Hills", "Victorville", "Signal Hill", "Tujunga", "West Hills", "Artesia", "Placentia", "Palos Verdes Estates", "Lakewood", "San Fernando", "Norwalk", "Lomita", "South El Monte", "Compton", "Temple City", "Baldwin Park", "West Los Angeles", "Valley Village", "San Pedro", "Bellflower", "La Puente", "La Crescenta", "Huntington Park", "Montebello", "Rowland Heights", "Colton", "Wildomar", "Lake Elsinore", "Yucca Valley", "La Habra", "Sunland", "Mission Hills", "South Gate", "Downey", "Rolling Hills Estates", "Wilmington", "San Marino", "San Gabriel", "Lynwood", "Barstow", "Yucaipa", "Norco", "Newport Coast", "Cathedral City", "La Quinta", "Desert Hot Springs", "Rancho Mirage", "Ojai", "Pacoima", "North Hills", "Oak Park", "Stanton", "La Palma", "Maywood", "Duarte", "Paramount", "Pico Rivera", "Stevenson Ranch", "Menifee", "Hesperia", "Montclair", "Loma Linda", "Apple Valley", "Grand Terrace", "Beaumont", "Trabuco Canyon", "Laguna Woods", "Indio", "Hemet", "San Jacinto", "Santa Paula", "Acton", "Harbor City", "Joshua Tree", "Mountain Pass", "Villa Park", "Blythe", "Adelanto", "Bell Gardens", "Newhall", "Montrose", "Palos Verdes Peninsula", "Topanga", "Lawndale", "Highland", "Mira Loma", "Lake Arrowhead", "La Verne", "Sun City", "Hacienda Heights", "Rialto", "Los Alamitos", "Idyllwild", "Indian Wells", "Coachella", "Banning", "Midway City", "Sierra Madre", "Thermal", "Port Hueneme Cbc Base", "Sunset Beach", "Silverado", "Avalon", "Castaic", "East Los Angeles", "Bell", "Bloomington", "Bryn Mawr", "Helendale", "Baker", "Mentone", "Big Bear City", "Patton", "Guasti", "Big Bear Lake", "Perris", "Calimesa", "Hawaiian Gardens", "Capistrano Beach", "Twentynine Palms", "Thousand Palms", "Cabazon", "Fillmore", "Port Hueneme", "Ludlow", "Running Springs", "Lytle Creek", "North Long Beach", "Oro Grande", "Nuevo", "Landers", "Phelan", "Parker Dam", "Winnetka", "Rimforest", "Newberry Springs", "Verdugo City", "Pioneertown", "Crestline", "Blue Jay", "March Air Reserve Base", "Valyermo", "Morongo Valley", "Trona", "Charter Oak", "Somis", "Mount Wilson", "Point Mugu Nawc", "Forest Falls", "Littlerock", "Anza", "Mecca", "Winchester", "Amboy", "Crest Park", "Wrightwood", "Piru", "Atwood", "Cedar Glen", "El Toro", "Fort Irwin", "Angelus Oaks", "Skyforest", "Vidal", "Cedarpines Park", "Rolling Hills", "Oak View", "Mountain Center", "Earp", "Hinkley", "Surfside", "Fawnskin", "Yermo", "Aguanga", "North Palm Springs", "Daggett", "Green Valley Lake", "Pearblossom", "Twin Peaks", "Sugarloaf", "Llano", "Nipton", "East Irvine", "Desert Center", "Lake Hughes", "Brandeis", "Homeland", "Needles"],
              store: [""]
            }, {
              state: "California",
              cities: ["Carlsbad","Chula Vista","Coronado","Del Mar","El Cajon","Encinitas","Escondido","Imperial Beach","La Mesa","Lemon Grove","National City","Oceanside","Poway","San Diego","San Marcos","Santee","Solana Beach","Vista"],
              store: [""]
            }, {
              state: "Florida",
              cities: ["Miami","Homestead","Florida City","Miami Beach","Coral Gables","Hialeah","North Miami","Opa-locka","Miami Springs","South Miami","Golden Beach","North Miami Beach","Miami Shores","Biscayne Park","Surfside","El Portal","Indian Creek Village","Sweetwater","North Bay Village","West Miami","Bay Harbor Islands","Bal Harbour","Virginia Gardens","Hialeah Gardens","Medley","Key Biscayne","Aventura","Pinecrest","Sunny Isles Beach","Miami Lakes","Palmetto Bay","Miami Gardens","Doral","Cutler Bay"],
              store: [""]
            }
          ]},{
          country: "CA",
          region: [
            {
              state: "Ontario",
              cities: ["Ajax","Aurora","Brampton","Brock","Burlington","Caledon","Clarington","Durham","East Gwillimbury","Georgina","Halton","Halton Hills","King","Markham","Mississauga","Milton","Newmarket","Oakville","Oshawa","Peel","Pickering","Richmond Hill","Scugog","Toronto","Uxbridge","York","Vaughan","Whitchurch-Stouffville","Whitby"],
              store: [""]
            }, {
              state: "British Columbia",
              cities: ["Anmore","Belcarra","Bowen Island","Burnaby","Coquitlam","Delta","Langley","Lions Bay","Maple Ridge","New Westminster","North Vancouver","Pitt Meadows","Port Coquitlam","Port Moody","Richmond","Surrey","Tsawwassen","Vancouver","West Vancouver","White Rock","Victoria","Nanaimo","Abbotsford","Mission","Chilliwack","Hope","Whistler","Squamish"],
              store: [""]
            }
          ]
        }
      ];

      let $store = [
        {
          name: "Melrose",
          url: "/melrose-showroom",
          header: "Los Angeles, our showroom is now open!",
          copy: "Come in and experience Rove Concepts products in person at a showroom nearest you. No appointment is necessary.",
          img: "https://cdn.roveconcepts.com/sites/default/files/images/RC_Melrose_ExteriorDecal_Option_FINAL(1).jpg"
        },{
          name: "Santa Fe Springs",
          url: "/santa-fe-springs-showroom",
          header: "",
          copy: "",
          img: ""
        },{
          name: "San Diego",
          url: "/san-diego-showroom",
          header: "San Diego, our showroom is now open!",
          copy: "Come in and experience Rove Concepts products in person at a showroom nearest you. No appointment is necessary.",
          img: "https://cdn.roveconcepts.com/sites/default/files/images/IMG_74851.JPG"
        },{
          name: "Miami",
          url: "/miami-showroom-grand-opening-event/rsvp?source=modal",
          header: "You’re Invited<br>Miami Showroom Grand Opening",
          copy: "Join us for free flow canapés & bar service, live music headlined by DJ Vice, special appearances by John Legend and the main cast of Selling Sunset, and more.",
          cta_copy: "RSVP Now",
          img: "https://cdn.roveconcepts.com/sites/default/files/styles/picture_1024_1x/public/images/RC_ND-304.jpg"
        },{
          name: "Vancouver",
          url: "/vancouver-showroom?source=modal",
          header: "Vancouver Exclusive:<br>Complimentary Welcome Package",
          copy: "Sign up or renew your Rove Concepts Membership in our Vancouver showroom to receive a complimentary welcome package.",
          cta_copy: "Plan Your Visit Today",
          img: "https://cdn.roveconcepts.com/sites/default/files/styles/picture_1024_1x/public/images/DSC00581-HDR.jpg"
        },{
          name: "Toronto",
          url: "/toronto-showroom",
          header: "Now Open: Toronto Showroom",
          copy: "Come visit us at our showroom in downtown, Toronto.",
          img: "https://cdn.roveconcepts.com/sites/default/files/images/IMG_26162.jpg"
        }
      ];

        if ($(".pvo-modal")){
          window.setTimeout(function(){
            // First check, if localStorage is supported.
            if (window.localStorage) {
              // Get the expiration date of the previous popup.
              var nextPopup = localStorage.getItem( 'nextPvo');

              if (nextPopup > new Date()) {
                return;
              }

              var newsletterPopup = localStorage.getItem( 'klaviyoOnsite');
              if(newsletterPopup == null){
                return;
              } else {
                newsletterPopup = JSON.parse(newsletterPopup);
                if (newsletterPopup.viewedForms.modal.disabledForms.Uz7sx4 === undefined){
                  return;
                }
              }


              const url = `https://freeipapi.com/api/json`; // get current request's ip info

              $.get(url, function (data) {
                $.each($data, function (i1,o){
                  if (o.country === data.countryCode){
                    $.each(o.region, function (i2, region){
                      if (region.state === data.regionName){
                        if ($.inArray(data.cityName, region.cities) !== -1){
                          $.each(region.store, function(i, name){
                            let $storeDetails = $.grep($store, function(v) {
                              return v.name === name;
                            })[0];
                            if (i === 0) {
                              $(".pvo-image").css("background-image", "url('" + $storeDetails.img + "')");
                              $(".pvo-heading h1").html($storeDetails.header);
                              $(".pvo-copy p").html($storeDetails.copy);
                            }
                            if (region.store.length > 1){
                              $(".pvo-showroom-cta").append('<a class="pvo-btn" href="'+$storeDetails.url+'" target="_blank">'+$storeDetails.name+'</a>');
                            } else {
                              if ($storeDetails.cta_copy !== null){
                                $(".pvo-showroom-cta").append('<a class="pvo-btn" href="'+$storeDetails.url+'" target="_blank">'+$storeDetails.cta_copy+'</a>');
                              } else {
                                $(".pvo-showroom-cta").append('<a class="pvo-btn" href="'+$storeDetails.url+'" target="_blank">Visit Now</a>');
                              }
                            }
                            var expires = new Date();
                            expires = expires.setHours(expires.getHours() + 48);
                            localStorage.setItem( 'nextPvo', expires );

                            $("#block-block-151").css({"visibility": "visible", "opacity": 1});
                            $(".pvo-lightbox").css({"visibility": "visible", "opacity": 1});
                          });
                        }
                      }
                    });
                  }
                });
              });
            }
          }, 5000);

          let pvoClose = document.querySelector(".pvo-close-btn");
          if (pvoClose !== null) {
            document.querySelector(".pvo-close-btn").addEventListener("click", () => {
              $(".pvo-lightbox").css({"visibility": "hidden", "opacity": 0});
            });
          }
        }

    },

    tradePage: function () {
      let $select = $('#edit-submitted-personal-info-business-type');
      $select.on('change', function () {
        let $other = $('#edit-submitted-personal-info-business-type-other');
        if ($(this).val() === 'Other') {
          $other.show();
        } else {
          $other.hide();
        }
      });
      $select.trigger('change');

      // Trade page carousels
      app.page.tradeCarousel('trade-detail-cont-1');
      app.page.tradeCarousel('trade-detail-cont-2');
      app.page.tradeCarousel('trade-detail-cont-3');
      app.page.tradeCarousel('trade-offer-sum', true);


      // Trade newsletter popup
      $(document).ready(function(){
        if (document.cookie.indexOf("tradeNewsletterPopup=true") === -1) {
          document.cookie = "tradeNewsletterPopup=true; max-age=86400"; // 86400: seconds in a day
          setTimeout(function(){
            $(".trade-newsletter-popup").removeClass("hide");
          },10000);
        }

        $(".trade-newsletter-popup, .trade-newsletter-popup .trade-newsletter-close").on("click", function () {
          $(".trade-newsletter-popup").addClass("hide");
        });

        $(".trade-newsletter-modal").on("click", function (e) {
          e.stopPropagation();
        });

        function isEmail(email) {
          var regex = /^([a-zA-Z0-9_.+-])+\@(([a-zA-Z0-9-])+\.)+([a-zA-Z0-9]{2,4})+$/;
          return regex.test(email);
        }

        $("#trade-newsletter #email").on("change keydown", function () {
          if (isEmail($(this).val())) {
            $("#trade-newsletter button").attr("disabled", false);
          } else {
            $("#trade-newsletter button").attr("disabled", true);
          }
        });

        $("#trade-newsletter button").on("click", function (e) {
          e.preventDefault();
          let $email = $("#trade-newsletter #email").val();

          const options = {
            method: 'POST',
            headers: {revision: '2023-02-22', 'content-type': 'application/json'},
            body: JSON.stringify({
              data: {
                type: 'subscription',
                attributes: {
                  list_id: 'X85mZc',
                  email: $email
                }
              }
            })
          };

          if (isEmail($email)){
            fetch('https://a.klaviyo.com/client/subscriptions/?company_id=KBNd6n', options)
              .then((response) => {
                if (response.status === 202) {
                  $(".trade-newsletter-copy").html('<div><h2>Thank you</h2><p>Stay tuned for our latest updates!</p></div>');
                }
              })
              .catch(err => console.error(err));
          }
      })

      });


      // Switch the annoucement msg
      if ($("#anouncement")){
        let $msg = "CONNECT WITH OUR TRADE PROGRAM SPECIALIST: TRADE@ROVECONCEPTS.COM | PHONE: 1-800-705-6217";
        if ($(window).width() < 768){
          $msg = "TRADE@ROVECONCEPTS.COM | 1-800-705-6217";
        };
        $("#anouncement a").attr("href", "https://www.roveconcepts.com/help");
        $("#anouncement a span").text($msg);
      }
    },

    tradeCarousel: function(tag, mobileOnly = false) {
      //<link crossOrigin="anonymous" href="https://cdnjs.cloudflare.com/ajax/libs/OwlCarousel2/2.3.4/assets/owl.theme.default.min.css" integrity="sha512-sMXtMNL1zRzolHYKEujM2AqCLUR9F2C4/05cdbxjjLSRvMQIciEPCQZo++nk7go3BtSuK9kfa/s+a4f4i5pLkw==" referrerpolicy="no-referrer" rel="stylesheet" />
      let owl = $("."+tag+" .owl-carousel");
      let owlConfig = {
        items: 3,
        center: false,
        dots: false,
        loop: true,
        margin: 20,
        autoplay: true,
        autoplayTimeout: 5000,
        autoplaySpeed: 1000,
        autoplayHoverPause: true,
        responsive: {
          0 : {
            items: 1.3,
            dots: true,
            center: true
          },
          700: {
            items: 3,
            dots: false,
            center: false
          }
        }
      };

      if (mobileOnly){
        if ($(window).width() < 1025){
          owl.owlCarousel(owlConfig);
        }
      } else {
        owl.owlCarousel(owlConfig);
      }


      $("."+tag+" .trade-nav-next").click(function () {
        owl.trigger('next.owl.carousel');
      });

      $("."+tag+" .trade-nav-prev").click(function () {
        owl.trigger('prev.owl.carousel');
      });
    },

    visitUs: function () {
      if (app.page.title.indexOf("Visit Us") >= 0) {
        let $btn = $(".hr-btn");
        $btn.on('click', function () {
          let $_btn = $(this);
          let $_target = $($(this).data('target'));
          if ($_btn.hasClass("init")) {
            $_btn.removeClass("init");
            $_btn.addClass("expand");
            $_target.removeClass("init");
            $_target.addClass("expand");
          } else {
            $_btn.removeClass("expand");
            $_btn.addClass("init");
            $_target.removeClass("expand");
            $_target.addClass("init");
          }
        });
      }
    },

    stlHome: function () {
      if ($("#shop-this-look-block").length !== 0) {
        $("#shop-this-look-block .section-titles").after("<div class='stl-cont'><div class='img-nav-btns'><div class='img-left'></div><div class='img-right'></div></div><div class='owl-dots nav-thumbs'></div>");
        $(".img-nav-btns").after($("#shop-this-look-block .row"));
        $(".img-nav-btns").css("width", $(".stl-cont").width() + "px");

        $cache.pos = 0;
        $cache.imageWrapper = $(".stl-cont .row");
        $cache.isMobile = app.isMobile();

        if ($cache.isMobile === true) {
          $cache.navThumbs = $(".nav-thumbs"),
            $cache.navThumbs.empty();
          $cache.imageWrapper.children("div").each(function (i, o) {
            if (i === 0) {
              $cache.navThumbs.append('<div class="owl-dot active"><span></span></div>');
            } else {
              $cache.navThumbs.append('<div class="owl-dot"><span></span></div>');
            }
          });
        }


        $(document).off("touchstart").on('touchstart', handleTouchStart);
        $(document).off("touchmove").on('touchmove', handleTouchMove);


        let xDown = null;
        let yDown = null;

        function getTouches(evt) {
          return evt.touches ||             // browser API
            evt.originalEvent.touches; // jQuery
        }

        function handleTouchStart(evt) {
          const firstTouch = getTouches(evt)[0];
          xDown = firstTouch.clientX;
          yDown = firstTouch.clientY;
        }

        function handleTouchMove(evt) {
          if (!xDown || !yDown) {
            return;
          }

          let xUp = evt.touches[0].clientX;
          let yUp = evt.touches[0].clientY;

          let xDiff = xDown - xUp;
          let yDiff = yDown - yUp;

          var topPos = $(".stl-cont").offset().top - $(window).scrollTop();
          var bottomPos = $(".stl-cont").offset().top + $(".stl-cont").outerHeight(true) - $(window).scrollTop();


          if (yDown > topPos && yDown < bottomPos) {
            if (Math.abs(xDiff) > Math.abs(yDiff)) {
              if (xDiff > 0) {
                app.page.imageSwipe("right");
              } else {
                app.page.imageSwipe();
              }
            }
          }

          xDown = null;
          yDown = null;
        }

        let $imgRight = $(".img-right");
        let $imgLeft = $(".img-left");

        $(".img-right, .img-left").off("click");
        $imgRight.on("click", function () {
          app.page.imageSwipe("right");
        });

        $imgLeft.on("click", function () {
          app.page.imageSwipe();
        });
      }
    },

    imageSwipe: function (opt) {
      if (opt === "reset") {
        $cache.pos = 0;
        $cache.imageWrapper.css("right", 0);
      } else {
        if (!isNaN(opt)) {
          $cache.pos = opt;
        } else if (opt === "right") {
          if ($cache.pos < ($cache.isMobile ? ($cache.imageWrapper.children("div").length - 1) : (($cache.imageWrapper.children("div").length / 2) - 1))) {
            $cache.pos++;
          }
        } else {
          if ($cache.pos > 0) {
            $cache.pos--;
          }
        }
        if ($cache.isMobile && typeof $cache.navThumbs !== 'undefined') {
          $cache.navThumbs.children("div").each(function (i) {
            if (i !== $cache.pos) {
              $(this).removeClass("active");
            } else {
              $(this).addClass("active");
            }
          });
        }

      }
      $cache.imageWrapper.css("right", $cache.pos * ($cache.isMobile ? 1 : 2) * ($cache.imageWrapper.children("div").eq(0).width() + 40) + "px");
      if ($cache.pos === ($cache.isMobile ? ($cache.imageWrapper.children("div").length - 1) : (($cache.imageWrapper.children("div").length / 2) - 1))) {
        $(".img-right").css("opacity", 0);
        $(".img-left").css("opacity", 0.75);
      } else if ($cache.pos === 0) {
        $(".img-right").css("opacity", 0.75);
        $(".img-left").css("opacity", 0);
      } else {
        $(".img-right").css("opacity", 0.75);
        $(".img-left").css("opacity", 0.75);
      }
    },
    homePage: function()
    {
      $cache.document = $(document);
      if ($('body.page-node-6').length !== 0) {
        // Track lookbook clicks from home page
        $cache.document.on('click', '.lookbook-wrapper .btn-primary', function (e, types) {
          app.tracking.track('lookbookEngage', {
            lookbook: 'Home page',
          });
        });

        //Sticky Menu Bar on Desktop

        if ($(window).width() >= 769){
          var num = $('#header').height(); //number of pixels before modifying styles

          $(window).bind('scroll', function () {
            if ($(window).scrollTop() > num) {
              $('#header').addClass('sticky');
            } else {
              $('#header').removeClass('sticky');
            }
          });

        }


        //[John Legend] Trip to LA Form on Homepage Banner

        let $jlCampaignSignupCont = $(".jl-campaign-form-cont");
        if ($jlCampaignSignupCont.length > 0) {
          $jlCampaignSignupCont.prepend(`<form id="jl-sign-up-cont"> <label for="email">Enter your email:</label> <input type="email" id="jl-sign-up-email" class="jl-title thin-txt" data-sharkid="__0" data-sharklabel="email"> <button type="submit" title="submit">Enter</button></form>`);

          $(".banner-body-wrap .jl-btn.mobile-only").on("click", function (){
            $(this).css("display", "none");
            $(".jl-campaign-form-cont").css("display", "flex");
          });

          $jlCampaignSignupCont.parents(".jl-cont").on("click", function (e) {
            if (!$(e.target).is("button")){
              e.preventDefault();
            }

          $("#jl-sign-up-cont").on("submit", function (e) {
              $("#jl-sign-up-cont").css("pointer-events", "none");
              if ($("#jl-sign-up-email").val().length < 2){
                return false;
              }
              e.preventDefault();

              const options = {
                method: 'POST',
                headers: {revision: '2023-01-24', 'content-type': 'application/json'},
                body: JSON.stringify({
                  data: {
                    type: 'subscription',
                    attributes: {
                      list_id: 'W8ryFy',
                      email: $("#jl-sign-up-email").val()
                    }
                  }
                })
              };


              fetch('https://a.klaviyo.com/client/subscriptions/?company_id=KBNd6n', options)
                .then((response) => {
                  if (response.status === 202) {
                    $jlCampaignSignupCont.html("<p class='success-msg'>Thank you! Hope to see you in LA soon.</p>");
                    setTimeout(function () {
                      window.location.href = 'JohnLegend';
                    }, 1000)
                    app.tracking.track('leadSubmit', {
                      name: 'John Legend Campaign Signup - Front',
                      email: $("#jl-sign-up-email").val()
                    });
                  }
                })
                .catch(err => console.error(err));
            });
          });
        }
      }
    },
    hostPage: function () {
      if ($("#host-page-block").length !== 0) {
        $(".host-q-cont").each(function (i, e) {
          $(this).on("click", () => {
            if (!$(this).hasClass("expand")) {
              $(".host-q-cont").each(function () {
                $(this).removeClass("expand")
              });
              $(".host-a").each(function () {
                $(this).removeClass("expand")
              });
              $(this).addClass("expand");
              $(".host-a").eq(i).addClass("expand");
            } else {
              $(".host-q-cont").each(function () {
                $(this).removeClass("expand")
              });
              $(".host-a").each(function () {
                $(this).removeClass("expand")
              });
            }
          });
        });
      }
    },

    // Depends on block 167
    userMembershipPage: function() {
      if ($('body.page-user-membership').length !== 0) {
        $('#user_profile_account_page button').on('click',function(e) {
          let $entity = $('#membershipRenewOverlay');
          let $editRenww = $('#edit-renew');
          let $accountPage = $('#user_profile_account_page');
          let promoSaved = false;
          if ($entity.length > 0 && !$('#edit-renew').is(':checked')) {
            e.preventDefault();
            $.colorbox({
              inline:true,
              href:'#membershipRenewOverlay',
              onComplete: function() {
                $('.mem-renew-cta .btn-close').on('click',function(e) {
                  $.colorbox.close();
                });

                $('.mem-renew-cta .btn-primary').on('click',function(e) {
                  // Save auto renewal with discount
                  let jqxhr = $.ajax( "/user/membership/renewal" )
                  .done(function() {
                    // Display success message
                    $accountPage.find('.notice').html('You are currently enrolled for our promotional discount on renewal.').show();
                    if (!$editRenww.is(':checked')) {
                      $editRenww.trigger('click');
                    }
                    promoSaved = true;
                  })
                  .fail(function() {
                    // Say anything about the error?
                  })
                  .always(function() {
                    $.colorbox.close();
                  });
                });
              },
              onClosed: function() {
                if (!promoSaved) {
                  // Submit the form
                  $('#uc-membership-renew-page').submit();
                }
              }
            });
          }

        });
      }
    },


    openNewTab: function (selector) {
      selector.forEach(function (o) {
        $(o).attr("target", "_blank");
      });
    },

    mariaPg: function () {


      let $elements = [$(".maria-intro-cont"), $(".maria-intro-video > iframe"), $(".maria-cta")];
      let $products = $.map($("[class*='maria-item-']"), function (val) {
        return [val];
      });
      let $animated = [];
      let $animatedItems = [];
      let $scrollaleAnimated = false;


      $(".maria-banner").ready(function () {
        $(".maria-loader").css("opacity", 0);

        setTimeout(function () {
          $(".maria-loader").css("display", "none");
          $(".maria-banner .maria-x-logo, .maria-banner-overlay, .maria-banner-txt-cont .new-collection").addClass("animated");
        }, 500);
      });
      $elements.forEach(function () {
        $animated.push(false);
      });

      $(window).on("scroll", function () {
        $animated.forEach(function (e, i) {
          if (e === false) {
            if (enterViewport($elements[i])) {
              $elements[i].addClass("animated");
              $animated[i] = true;

            }
            return false;
          }
        });

        $products.forEach(function (e, i) {
          if ($animatedItems[i] !== true) {
            if (enterViewport(e)) {
              $products[i].classList.add("animated");
              $animatedItems[i] = true;
            }
            return false;
          }
        });

      });

      $(".maria-product-tag-pointer").on("mouseover", function () {
        $(this).siblings(".maria-product-tag-toast-cont").addClass("showed");
      });

      $(".maria-product-tag-pointer").on("mouseout", function () {
        $(this).siblings(".maria-product-tag-toast-cont").removeClass("showed");
      });

      function enterViewport(e) {
        var $docViewTop = $(window).scrollTop();
        var $docViewBottom = $docViewTop + $(window).height() - 100;

        var $elemTop = $(e).offset().top;

        return (($elemTop <= $docViewBottom));
      }
    },

    jlPage: function() {

      // LANDING PAGE

      //Submit JL Campaign Email to Klaviyo
      let $listId = $("#jl-sign-up-cont").data("list");
      $("#jl-sign-up-cont").submit(function(e) {
        $("#jl-sign-up-cont").css("pointer-events","none");
        // $("#sign-up-cont button").html($loading)
        e.preventDefault();

        if ($("#jl-sign-up-email").val().length < 2){
          return false;
        }

        const options = {
          method: 'POST',
          headers: {revision: '2023-01-24', 'content-type': 'application/json'},
          body: JSON.stringify({
            data: {
              type: 'subscription',
              attributes: {
                list_id: $listId,
                email: $("#jl-sign-up-email").val()
              }
            }
          })
        };

        fetch('https://a.klaviyo.com/client/subscriptions/?company_id=KBNd6n', options)
          .then((response) => {
            if (response.status === 202){
              $("#jl-sign-up-cont").html("<p class='jl-title thin-txt'>Thank you! Hope to see you in LA soon.</p>");
              app.tracking.track('leadSubmit', {name:'John Legend Campaign Signup',email: $("#jl-sign-up-email").val()});
            }})
          .catch(err => console.error(err));
      });



      if ($(window).width() >= 769) {
        gsap.to('.jl-sec-1 .jl-sec-1-foreground>p', {
          scrollTrigger: {
            trigger: ".jl-sec-1 .limit",
            start: "top center",
            end : "+=500",
            scrub: true,
          },
          opacity: 1,
          scaleX: 1,
          scaleY: 1,
          duration: 2
        });
      } else {
        gsap.to('.jl-sec-1 .jl-sec-1-foreground>p', {
          scrollTrigger: {
            trigger: ".jl-sec-1 .limit",
            start: "top center",
            end : "+=250",
            scrub: true,
          },
          opacity: 1,
          scaleX: 1,
          scaleY: 1,
          duration: 5
        });
      }

      var jlMobile = gsap.timeline({
        scrollTrigger: {
          trigger: ".jl-sec-3",
          start: "top center",
          end : "0",
        },
      });

      var jlDesktop = gsap.timeline({
        scrollTrigger: {
          trigger: ".jl-sec-3",
          start: "top center",
          end : "+=500",
          scrub: true,
        },
      });

      const creditJlLinesMobile = gsap.utils.toArray('.credit-style-txt.mobile-only .credit-line');
      creditJlLinesMobile.forEach((creditLine, i) => {
        jlMobile.to(creditLine, {opacity: 1, y: 0, duration: 1.5}, ">-0.5");
      });

      const creditJlLinesDesktop = gsap.utils.toArray('.credit-style-txt.desktop-only .credit-line');
      creditJlLinesDesktop.forEach((creditLine, i) => {
        jlDesktop.to(creditLine, {opacity: 1,duration: 1.5, delay: i});
      });

      let $jlProductDetailImages = $(".jl-product-details-image-carousel.owl-carousel");
      if ($jlProductDetailImages.length > 0) {
        if ($(window).width() >= 769) {
          $jlProductDetailImages.owlCarousel({
            margin: 0,
            nav: true,
            navText: ["<img src='https://cdn.roveconcepts.com/sites/default/files/jl-assets/arrow-cream.svg' alt='Prev'/>","<img src='https://cdn.roveconcepts.com/sites/default/files/jl-assets/arrow-cream.svg' alt='Next'/>"],
            singleItem: true,
            items: 1,
            loop: true,
            dots: false,
            autoplay: true,
            autoplayTimeout: 5000,
            smartSpeed: 2000,
            autoplayHoverPause: true
          });
        }
      }

      let $jlProductDetails = $(".jl-product-details-card .jl-product-card-header");
      if ($jlProductDetails.length > 0){
        $jlProductDetails.each(function (){
          $(this).on("click", function(){
            $(".jl-product-details-card").removeClass("active");
            $(this).parent().addClass("active");
            if ($( window ).width() < 769){
              $('html, body').animate({
                scrollTop: $(this).offset().top - 20
              });
            } else {
              $(".jl-product-details-image-carousel").removeClass("active");
              $(".jl-product-details-image-carousel").eq($(this).parent().data("image")).addClass("active");
              $jlProductDetailImages.trigger('refresh.owl.carousel');
              $('html, body').animate({
                scrollTop: $(this).offset().top - 170
              });
            }

          });
        });
      };

      let $jlShopProducts = $(".product-collection-cont.owl-carousel");
      if ($jlShopProducts.length > 0){
        if ($( window ).width() < 1400){
          $jlShopProducts.owlCarousel({
            margin: 20,
            center: true,
            nav: false,
            singleItem: true,
            items: 1,
            loop: true,
            dots: true,
            responsive: {
              0: {
                items: 1,
              },
              600: {
                items: 2,
                center: false,
                singleItem: false,
              },
              900: {
                items: 3,
                center: false,
                singleItem: false,
              }
            }
          });
        } else {
          $jlShopProducts.addClass("off");
        }
      }

      let $productHovers = $(".jl-product-hover");
      if ($productHovers.length > 0){
        $productHovers.each(function (){
          $(this).on("click", function(){
            let $cards = $(this).siblings(".jl-product-hover-card-cont").children(".jl-product-hover-card");
            $cards.removeClass("active");
            $cards.eq($(this).data("card")).addClass("active");
          })
        })
      }

      window.addEventListener("load", () => {
        const imageArcwareGameJohnLegend = document.getElementById('iframe-arcware-game-john-legend');
        imageArcwareGameJohnLegend.addEventListener('click', () => {
          document.body.style.cursor = "wait";
          let arcwareIframe = document.createElement("iframe");
          arcwareIframe.src="https://www.roveconcepts.com/john-legend-iframe-page";
          arcwareIframe.scrolling = "no";
          arcwareIframe.classList.add("iframe-arcware-game");
          $(".jl-sec-xr .limit").html(arcwareIframe);
          arcwareIframe.addEventListener("load", () => {
            document.body.style.cursor = "auto";
          })
        })
      })
    },

    updateReviews: function(){
      $(document).ready(function() {
          $.getJSON("https://api.trustpilot.com/v1/business-units/4ea54dc50000640005115832?apikey=ys68fk9bJnJGsB2B7lPIAhpPhcop0jWg",
            function(r) {
              $(".trustpilot_heading .count").html(Math.floor(r.numberOfReviews.total / 1000) + "k+ Reviews");
            }
          );
        });
    },

    hostListingImage: function (type, i) {
      let $imgWidth = $(".host-img-cont-scroll").eq(i).find(".img-frame").width();
      let $imgQuantity = Math.round($(".host-img-cont").eq(i).width() / $imgWidth);
      let $currentPosition = Math.round(Math.abs(parseFloat($(".host-img-cont").eq(i).css("left"))) / $imgWidth);
      if (type === "right") {
        $(".host-img-cont").eq(i).css("left", "-" + (($currentPosition + 1) * $imgWidth) + "px");
        if ($currentPosition === ($imgQuantity - 2)) {
          $(".host-img-cont-scroll").eq(i).find(".img-right").css("visibility", "hidden");
          $(".host-img-cont-scroll").eq(i).find(".img-left").css("visibility", "visible");
        } else {
          $(".host-img-cont-scroll").eq(i).find(".img-right").css("visibility", "visible");
          $(".host-img-cont-scroll").eq(i).find(".img-left").css("visibility", "visible");
        }
      } else {
        $(".host-img-cont").eq(i).css("left", "-" + (($currentPosition - 1) * $imgWidth) + "px");
        if ($currentPosition === 1) {
          $(".host-img-cont-scroll").eq(i).find(".img-left").css("visibility", "hidden");
          $(".host-img-cont-scroll").eq(i).find(".img-right").css("visibility", "visible");
        } else {
          $(".host-img-cont-scroll").eq(i).find(".img-left").css("visibility", "visible");
          $(".host-img-cont-scroll").eq(i).find(".img-right").css("visibility", "visible");
        }
      }
    },
    hostListingModalImage: function (type) {
      let $imgWidth = $(".host-listing-modal-img-cont .img-frame").width();
      let $imgQuantity = Math.round($(".host-listing-modal-img-cont").width() / $imgWidth);
      let $currentPosition = Math.round(Math.abs(parseFloat($(".host-listing-modal-img-cont").css("left"))) / $imgWidth);
      if (type === "right") {
        $(".host-listing-modal-img-cont").css("left", "-" + (($currentPosition + 1) * $imgWidth) + "px");
        if ($currentPosition === ($imgQuantity - 2)) {
          $(".host-listing-popup-img-cont-scroll .img-nav-btns .img-right").css("visibility", "hidden");
          $(".host-listing-popup-img-cont-scroll .img-nav-btns .img-left").css("visibility", "visible");
        } else {
          $(".host-listing-popup-img-cont-scroll .img-nav-btns .img-right").css("visibility", "visible");
          $(".host-listing-popup-img-cont-scroll .img-nav-btns .img-left").css("visibility", "visible");
        }
      } else {
        $(".host-listing-modal-img-cont").css("left", "-" + (($currentPosition - 1) * $imgWidth) + "px");
        if ($currentPosition === 1) {
          $(".host-listing-popup-img-cont-scroll .img-nav-btns .img-left").css("visibility", "hidden");
          $(".host-listing-popup-img-cont-scroll .img-nav-btns .img-right").css("visibility", "visible");
        } else {
          $(".host-listing-popup-img-cont-scroll .img-nav-btns .img-left").css("visibility", "visible");
          $(".host-listing-popup-img-cont-scroll .img-nav-btns .img-right").css("visibility", "visible");
        }
      }
    },

    hostConnectReview: function (d) {
      if (d === "right") {
        $('.host-connect-review-cont').animate({
          scrollLeft: "+=1500px"
        }, "slow");
      } else {
        $('.host-connect-review-cont').animate({
          scrollLeft: "-=1500px"
        }, "slow");
      }
    },

    ARTutorial: function () {
          if ((!localStorage.getItem("ar-tour") && $(".ar-orientation-overlay").hasClass("hidden")) || (!localStorage.getItem("ar-tour") && $(".ar-orientation-overlay").length === 0)) {
            let isMobile = $(window).width() <= 426;
            let interval = setInterval(function () {
              if ($(".v-label.theme--light")[0]) {
                clearInterval(interval);
                let $steps = [];
                if (isMobile) {
                  $("#rove").prepend('<div class="ar-tour-overlay"><div class="ar-tour-arrow"></div><div class="ar-tour-content"><p></p><div class="ar-tour-btn">NEXT</div> </div> </div>');
                  $steps = [{
                    dom: ".expivi-options-wrapper>div>div>div>div>div>div:last-of-type",
                    domStyle: {
                      position: 'relative',
                      background: '#f3f3f3',
                      'border-radius': '7px',
                      padding: '10px 50px'
                    },
                    text: "Welcome to the 3D AR Planner.<br/>Select your configuration.",
                  }, {
                    dom: ".xpv__viewer_toolbar_container #xpv-toolbar-item-web-ar",
                    text: 'Tap on the AR icon to see the product in your space.',
                    domStyle: {background: 'white'},
                    action: true,
                  }];
                } else {
                  $("#rove").prepend('<div class="ar-tour-overlay"></div> <div class="ar-tour-content"><p></p><div class="ar-tour-btn">NEXT</div> </div> </div>');
                  $steps = [{
                    dom: ".expivi-options-wrapper>div>div>div>div>div>div:last-of-type",
                    domStyle: {
                      position: 'relative',
                      background: '#f3f3f3',
                      'border-radius': '7px',
                      padding: '10px 50px'
                    },
                    text: "Welcome to the 3D AR Planner.<br/>Select your configuration.",
                  }, {
                    dom: ".catalogue-button",
                    domStyle: {position: 'relative'},
                    text: "To view multiple products together, select, ‘Add Product to Scene’, drag and drop products to the main scene.",
                  }, {
                    dom: ".expivi-options-wrapper>div>div>div>div>div>div:nth-of-type(2)>div:last-of-type",
                    domStyle: {
                      position: 'relative',
                      background: '#f3f3f3',
                      'border-radius': '7px',
                      padding: '5px',
                      margin: "0"
                    },
                    text: "Click on the product from the added product list to adjust the configurations or remove the item.",
                  }, {
                    dom: ".expivi-button",
                    text: 'Click "VIEW IN MY ROOM" and<br/>scan the QR to see the configured product from your phone.',
                    action: true
                  }];
                }


                let $initStyles = [];
                let $completedSteps = 0;

                $.each($steps, function (i) {
                  $initStyles.push($($steps[i].dom).attr("style"));
                });

                let showTour = function showTut() {
                  $("#content-wrap, #rove").css("position", "static");
                  $.each($steps, function (i) {
                    if (i === $completedSteps) {
                      if ($completedSteps === 1 && isMobile) {
                        $($steps[$completedSteps].dom).css("z-index", "100001");
                        if ($steps[$completedSteps].domStyle) {
                          $($steps[$completedSteps].dom).css($steps[$completedSteps].domStyle);
                        }
                      } else {
                        $($steps[$completedSteps].dom).css("z-index", "100001");
                        if ($steps[$completedSteps].domStyle) {
                          $($steps[$completedSteps].dom).css($steps[$completedSteps].domStyle);
                        }
                      }
                    } else {
                      $($steps[i].dom).attr("style", $initStyles[i] === undefined ? "" : "");
                    }
                  });
                  $(".ar-tour-content p").css("opacity", 0);
                  $(".ar-tour-content p").empty();
                  $(".ar-tour-content p").html($steps[$completedSteps].text);
                  $(".ar-tour-content p").css("opacity", 1);
                  if ($completedSteps === $steps.length - 1) {
                    $(".ar-tour-btn").text("CLOSE");
                    $(".ar-tour-btn").off("click").on("click", function () {
                      $(".ar-tour-overlay").remove();
                      $(".ar-tour-content").remove();
                      localStorage.setItem('ar-tour', JSON.stringify(true));
                      $('body').css('overflow', 'scroll');
                    });
                  } else {
                    $(".ar-tour-btn").text("NEXT");
                  }


                  if (isMobile) {
                    $('body').css('overflow', 'hidden');
                    $([document.documentElement]).animate({
                      scrollTop: $($steps[$completedSteps].dom).offset().top - 20
                    }, 300, function(){
                      let bodyRect = document.body.getBoundingClientRect(),
                        elemRect = $($steps[$completedSteps].dom).offset();
                      $(".ar-tour-content").css("top", elemRect.top - $(".ar-tour-content").outerHeight() - 15 );

                      if ($completedSteps < $steps.length - 1) {
                        $completedSteps++;
                      } else {
                        $completedSteps = 0;
                      }
                    });

                  } else {

                    $('<img/>').attr('src', 'https://d33o7r96pw821t.cloudfront.net/teams/1493/media/file_5f89e12a16b63/ModernFelt_Malmo_Diffuse_lod2_512_512.jpg').on('load', function () {
                      $(this).remove();
                      let elemRect = $($steps[$completedSteps].dom)[0].getBoundingClientRect();
                      $(".ar-tour-content").css("top", elemRect.top);
                      if (elemRect.left -  $(".ar-tour-content").width() - 60 > 0){
                        $(".ar-tour-content").css("left", elemRect.left -  $(".ar-tour-content").width() - 60);
                      } else {
                        $(".ar-tour-content").css("left", elemRect.right + 20);
                      }


                      if ($completedSteps < $steps.length - 1) {
                        $completedSteps++;
                      } else {
                        $completedSteps = 0;
                      }
                    });

                  }


                  if ($steps[$completedSteps].action) {
                    $($steps[$completedSteps].dom).on("click", function () {
                      $(".ar-tour-btn").trigger("click");
                      $("#content-wrap, #rove").removeAttr("style");
                    });
                  }

                };
                showTour();
                $(".ar-tour-btn").off("click").on("click", function () {
                  showTour();
                });
              }
            }, 500);
          }
    },

    // checkMobileOrientation: function () {
    //   if (window.innerWidth < 426 && window.innerHeight > window.innerWidth) {
    //     //portrait
    //     return false;
    //   } else {
    //     //landscape
    //     return true
    //   }
    // },
    //
    // AROrientation: function () {
    //   if (window.innerWidth < 426 || app.isMobile()) {
    //   let $run = true;
    //   setTimeout(() => {
    //     if ($(".ar-product").length > 0) {
    //       $("#page").prepend('<div class="ar-orientation-overlay hidden"><div class="phone"></div><p>Rotate your device for a better experience.</p> </div>');
    //     }
    //   }, 500)
    //   setInterval(() => {
    //       if (!app.page.checkMobileOrientation()) {
    //         if ($(".ar-tour-overlay").length > 0) {
    //           $(".ar-tour-overlay").remove();
    //           if (!localStorage.getItem("ar-tour")) {
    //             $run = true;
    //           }
    //         }
    //         $(".ar-orientation-overlay").removeClass("hidden");
    //         $('body').css('overflow', 'hidden');
    //       } else {
    //         $(".ar-orientation-overlay").addClass("hidden");
    //         if ($run) {
    //           app.page.ARTutorial();
    //           $run = false;
    //         }
    //         if (localStorage.getItem("ar-tour")){
    //           $('body').css('overflow', 'scroll');
    //         }
    //       }
    //   }, 1000) } else {
    //
    //   }
    // },
    //
    // ARTutToast: function(){
    //   setTimeout(() => {
    //     $(".catalogue-button").on("click", function(){
    //       $('body').append("<div class='ar-toast' style='display:none'>Drag item into the scene to add.</div>");
    //       setTimeout(function(){
    //         $(".draggable-item").each(function(){
    //           $(this).off("mousedown").on("mousedown", function (){
    //             $('.ar-toast').fadeIn(100).delay(2000).fadeOut(100);
    //           })
    //         })
    //       }, 2000)
    //     })
    //   }, 2000)
    //
    // },

    ARHelpBtn: function(){
      if ($(".ar-help-btn").length === 0){
        $(".page-header").append("<div class='ar-help-btn'></div>")
        $(".ar-help-btn").on("click", ()=>{
          localStorage.removeItem("ar-tour");
          app.page.ARTutorial();
        })
      }
  },

    productLandingUgc: function (e) {

      let $parent = $(e).parent().parent();
      let $pos = Math.round($parent.scrollLeft() / $(e).parent().next().width());
      if ($(e).hasClass("img-right")) {
        $pos++;
        $parent.animate({scrollLeft: $pos * $(e).parent().next().width()})
      } else {
        $pos--;
        $parent.animate({scrollLeft: $pos * $(e).parent().next().width()})
      }

      if ($pos === 0) {
        $parent.find(".img-left").css("visibility", "hidden");
        $parent.find(".img-right").css("visibility", "visible");
      } else if ($pos === $parent.children().length - 2) {
        $parent.find(".img-left").css("visibility", "visible");
        $parent.find(".img-right").css("visibility", "hidden");
      } else {
        $parent.find(".img-left").css("visibility", "visible");
        $parent.find(".img-right").css("visibility", "visible");
      }

    },

    showroomPage: function() {
      $("a:contains('Get Directions')").on('click',function(e) {
        let $location = $(this).parents('.node-page');
        if ($location.hasClass('showroom-toronto-downtown')) {
          $(document).trigger('directionsClicked', ['showroom-toronto-downtown']);
        }
        if ($location.hasClass('showroom-vancouver-downtown')) {
          $(document).trigger('directionsClicked', ['showroom-vancouver-downtown']);
        }
        if ($location.hasClass('showroom-melrose')) {
          $(document).trigger('directionsClicked', ['showroom-melrose']);
        }
        if ($location.hasClass('showroom-san-diego-la-jolla')) {
          $(document).trigger('directionsClicked', ['showroom-san-diego-la-jolla']);
        }
        if ($location.hasClass('showroom-hong-kong')) {
          $(document).trigger('directionsClicked', ['showroom-hong-kong']);
        }
      });
      if ($element) {

      }
    },

    tradeTestimonials: function(order){

      $(".testimonials-cont").scrollLeft(0.46*$(window).width()*order);

      $(".testimonial-cont").each(function(i){
        $(this).removeClass("active");
        if(i === order){
          $(this).addClass("active")
        }
      })

      $(".testimonial-thumb").each(function(i){
        $(this).removeClass("active");
        if(i === order){
          $(this).addClass("active")
        }
      })

    },

    tradeScrollIndicator: function(container, item, thumbnail){

        const list = document.querySelector(container);
        const items = Array.from(document.querySelectorAll(item));
        const indicators = Array.from(document.querySelectorAll(thumbnail));

        let threshold = items.length > 0 ? ((items[0].clientWidth + 20) < $(window).width()) ? 1 : 0.5 : 1;

        const observer = new IntersectionObserver(onIntersectionObserved, {
          root: list,
          threshold: threshold
        });


        items.forEach(item => {
          observer.observe(item);
        });


        function onIntersectionObserved(entries) {
          entries.forEach(entry => {
            if (entry.isIntersecting) {
              const intersectingIndex = items.indexOf(entry.target);
              activateIndicator(intersectingIndex);
            }
          });
        }

        function activateIndicator(index) {
          indicators.forEach((indicator, i) => {
            indicator.classList.toggle('active', i === index);
          });

          items.forEach((item, i) => {
            item.classList.toggle('active', i === index);
          });
        }
      //}
    },

    membershipLanding: function (){

    if ($( window ).width() < 769) {
      let $press = $(".cm-reviews-quote-cont.owl-carousel");
      if ($press.length > 0) {
        $press.owlCarousel({
          singleItem: true,
          items: 1,
          loop: true,
          margin: 20,
          autoplay: true,
          center: true,
          autoplayTimeout: 5000,
          autoplaySpeed: 1000,
          autoplayHoverPause: true
        });
      }
    }

    },

    tradeForm: function(){
      let $currentStep = 0;
      let $stepDom = [
        [$(".trade-welcome-note"),$(".trade-contact-cont")],
        [$(".trade-business-profile-cont")],
        [$(".trade-files-upload-cont")],
        [$(".trade-survey-cont"), $(".trade-agreement-cont")]
      ];
      $(".btn-prev").hide();

      let $companyType = {
        "dom": $(".form-item-enrollment-business-profile-company-type"),
        "otherDom": $(".form-item-enrollment-business-profile-company-type-other"),
        "step": 1
      }

      let $serviceState = {
        "dom": $(".form-item-enrollment-business-profile-service-us.form-group"),
        "detailDom": $(".form-item-enrollment-business-profile-service-area-state"),
        "step": 1
      }

      let $serviceProvince = {
        "dom": $(".form-item-enrollment-business-profile-service-canada.form-group"),
        "detailDom": $(".form-item-enrollment-business-profile-service-area-province"),
        "step": 1
      }

      let $fields = [
        [
          {"dom": $(".form-item-enrollment-contact-info-contact-first-name"), "type":"text", "required": true},
          {"dom": $(".form-item-enrollment-contact-info-contact-last-name"), "type":"text", "required": true},
          {"dom": $(".form-item-enrollment-contact-info-company-name"), "type":"text", "required": true},
          {"dom": $(".form-item-enrollment-contact-info-title"), "type":"text", "required": true},
          {"dom": $(".form-item-enrollment-contact-info-country"), "type":"radio", "required": true},
          {"dom": $(".form-item-enrollment-contact-info-contact-email"), "type":"email", "required": true},
          {"dom": $(".form-item-enrollment-contact-info-contact-phone"), "type":"tel", "required": true},
        ],
        [
          {"dom": $(".form-item-enrollment-business-profile-address-line1"), "type":"text", "required": true},
          {"dom": $(".form-item-enrollment-business-profile-address-line2"), "type":"text", "required": false},
          {"dom": $(".form-item-enrollment-business-profile-postal-code"), "type":"postal-code", "required": true},
          {"dom": $(".form-item-enrollment-business-profile-city"), "type":"text", "required": true},
          {"dom": $(".form-item-enrollment-business-profile-province-state"), "type":"select", "required": true},
        ],
        [
          {"dom": $(".form-item-enrollment-files-business-card-website-url"), "type":"url-file", "required": true},
          {"dom": $(".form-item-enrollment-files-business-card-file-1"), "type":"file-url", "required": true},
          {"dom": $(".form-item-enrollment-files-business-license-file-2"), "type":"file-select-input", "required": true},
          {"dom": $(".form-item-enrollment-files-business-license-professional-association"), "type":"select-input", "required": true},
          {"dom": $(".form-item-enrollment-files-business-license-membership-number"), "type":"input-select", "required": true},
          {"dom": $(".form-item-enrollment-files-business-license-tax-exempt"), "type":"radio", "required": true},
        ],[
          {"dom": $(".form-item-enrollment-survey-survey-1"), "type":"select", "required": true},
          {"dom": $(".form-item-enrollment-survey-survey-2"), "type":"select", "required": true},
          {"dom": $(".form-item-enrollment-survey-survey-3"), "type":"select", "required": false},
        ]
      ]

      $('#edit-register-save').on('click',function(){
        app.tracking.gtag('event', 'trade_create', {
          'non_interaction': false,
          'event_category': 'engagement',
          'event_label': 'trade_create'
        });
      });

      const generateSteps = () => {
        let existingSteps = $(".trade-form-step-cont").children().length;

        if (existingSteps !== $stepDom.length) {
          $.each($stepDom, function(i){
            $(".trade-form-step-cont").append('<div data-step='+i+' class="trade-step"></div>');
          });
        }
      }

      generateSteps();

      let $files = {
        "cont": $(".trade-files-upload-cont"),
        "fileTaxId": $fields[2][0]
      }

      var observer = new MutationObserver(function(mutations) {
        $files.fileTaxId.dom = $(".form-item-file-1");
      });

      observer.observe($files.cont[0], {childList: true, subtree: true});

      $(".trade-step[data-step="+$currentStep+"]").addClass("active");

      function formValidation(step){
        let $isValid = true;
        function validate(dom,type,require){
          let $result = {"valid": true, "message": ""};
          if (require){
            let fileUploadIsEmpty = $(".form-item-enrollment-files-business-license-file-2").find("button[type='submit']").val() === "Upload"
            let professionalAssociationIsEmpty = $('#edit-enrollment-files-business-license-professional-association').val() === ""
            let membershipNumberIsEmpty = $('#edit-enrollment-files-business-license-membership-number').val() === ""
            let allFieldsAreEmpty = fileUploadIsEmpty && professionalAssociationIsEmpty && membershipNumberIsEmpty
            switch(type){
              case "file":
                if(dom.find("button[type='submit']").val() === "Upload"){
                  $result = {"valid": false, "message": "Required"}
                }
                break;
              case "checkbox":
                if (dom.find("input:checked").length === 0){
                  $result = {"valid": false, "message": "Required"}
                }
                break;
              case "radio":
                if (dom.find("input:checked").length !== 1){
                  $result = {"valid": false, "message": ""}
                }
                break;
              case "select":
                let $selected = dom.find("select");
                if ($selected.length > 0 && $selected.val() === ''){
                  $result = {"valid": false, "message": "Required"}
                }
                break;
              case "file-url":
              case "url-file":
                if ($(".form-item-enrollment-files-business-card-file-1").find("button[type='submit']").val() === "Upload" && $('#edit-enrollment-files-business-card-website-url').val() === ""){
                  $result = {"valid": false, "message": "Required"}
                }
                break;
              case "file-select-input":
                if(fileUploadIsEmpty && professionalAssociationIsEmpty && membershipNumberIsEmpty){
                  $result = {"valid": false, "message": "Required"}
                }
                break;
              case "select-input":
              case "input-select":
                if (allFieldsAreEmpty || (!professionalAssociationIsEmpty && membershipNumberIsEmpty) || (professionalAssociationIsEmpty && !membershipNumberIsEmpty)){
                  $result = {"valid": false, "message": "Required"}
                }
                break;
              default:
                dom.children("input").val() === "" ? $result = {"valid": false, "message": "Required"} : "";
            }
          }

          if (dom.children("input").val()){
            switch(type){
              case "email":
                if (!dom.children("input").val().match(/^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/)){
                  $result = {"valid": false, "message": "Invalid"};
                }
                break;
              case "tel":
                if (!dom.children("input").val().match(/^[\+]?[(]?[0-9]{3}[)]?[-\s\.]?[0-9]{3}[-\s\.]?[0-9]{4,6}$/im)){
                  $result = {"valid": false, "message": "Invalid"};
                }
                break;
              case "url":
              case "url-file":
                const pattern = new RegExp('^(https?:\\/\\/)?'+ // protocol
                  '((([a-z\\d]([a-z\\d-]*[a-z\\d])*)\\.)+[a-z]{2,}|'+ // domain name
                  '((\\d{1,3}\\.){3}\\d{1,3}))'+ // OR ip (v4) address
                  '(\\:\\d+)?(\\/[-a-z\\d%_.~+]*)*'+ // port and path
                  '(\\?[;&a-z\\d%_.~+=-]*)?'+ // query string
                  '(\\#[-a-z\\d_]*)?$','i'); // fragment locator
                if (!dom.children("input").val().match(pattern)){
                  $result = {"valid": false, "message": "Invalid"};
                }
                break;
              case "number":
                let $num = dom.children("input").val();
                if(!$.isNumeric($num)) {
                  $result = {"valid": false, "message": "Invalid"};
                }
                break;
              case "whole-number":
                const intRegex = /^\d+$/;
                let $int = dom.children("input").val();
                if(!intRegex.test($int) || !$.isNumeric($int)) {
                  $result = {"valid": false, "message": "Invalid"};
                }
                break;
              case "postal-code":
                let $zip = dom.children("input").val();
                let $regex = /(^\d{5}$)|(^\d{5}-\d{4}$)/;
                if (!$.isNumeric($zip)){
                  //Canada
                  $regex = /^[ABCEGHJKLMNPRSTVXY]\d[ABCEGHJKLMNPRSTVXY][ -]?\d[ABCEGHJKLMNPRSTVXY]\d$/i;
                }
                if (!$regex.test($zip)){
                  $result = {"valid": false, "message": "Invalid"};
                }
                break;
              default:
            }
          }

          return $result;
        }

       $.each($fields[step], function(i,o){
         let $result = validate(o.dom, o.type, o.required);
         if (!$result.valid) {
           $isValid = false;
           o.dom.addClass("invalid");
           if (o.dom.children(".invalid-msg").length > 0) {
             o.dom.children(".invalid-msg").text($result.message);
           } else {
             o.dom.append("<p class='invalid-msg'>" + $result.message + "</p>")
           }
         } else {
           o.dom.removeClass("invalid");
         }
       })
        return $isValid;
      }

      function showStep() {
        $.each($stepDom, function (i, o) {
          if (i === $currentStep) {
            $.each(o, function (index, dom) {
              dom.removeClass("hide");
            })
          } else {
            $.each(o, function (index, dom) {
              dom.addClass("hide");
            })
          }
        })

        $.each($(".trade-step"), function (i) {
          let $this = $(this);
          if (i < $currentStep) {
            $this.removeClass("active");
            $this.addClass("completed");
          } else if (i === $currentStep){
            $this.addClass("active");
            $this.removeClass("completed");
          } else {
            $this.removeClass("active");
            $this.removeClass("completed");
          }
        })

        if ($currentStep === 0) {
          $(".btn-prev").hide();
        } else {
          $(".btn-prev").show();
        }

        var $nextButton = $('.btn-next');

        if ($currentStep >= $stepDom.length-1) {
            $nextButton.text('SUBMIT');
        } else {
            $nextButton.text('NEXT');
        }


        $(".trade-step.completed").on("click", function(){
          $currentStep = parseInt($(this).attr("data-step"));
          showStep();
    })
      }

      $(".btn-next").on("click", function (e){
        e.preventDefault();
        if(formValidation($currentStep)){
          if ($currentStep === $stepDom.length-1){
            $serviceState.dom.find("input").attr("name", "");
            $serviceProvince.dom.find("input").attr("name", "");
            $(".enroll-btn").click();
          } else {
            $currentStep++;
            showStep();
          }

        }
        else{
          console.log('invalid');
        }
      })

      $(".btn-prev").on("click", function (e){
        e.preventDefault();
        if ($currentStep > 0) {
          $currentStep--;
          showStep();
        }
      })

      $companyType.dom.find("input").last().on("change", function(){
        $companyType.otherDom.find("input").toggleClass("hide");
        let $index = $fields[$companyType.step].findIndex(o => o.dom === $companyType.otherDom);
        if ($(this).is(":checked")){
          $fields[$companyType.step][$index]["required"] = true;
          $companyType.otherDom.find("input").addClass("required");
        } else {
          $fields[$companyType.step][$index]["required"] = false;
          $companyType.otherDom.find("input").removeClass("required");
        }
      })

      // $serviceState.dom.find("input").attr("name", "");
      $serviceState.dom.find("input").on("change", function(){
        let $val = $(this).val();
        let $index = $fields[$serviceState.step].findIndex(o => o.dom === $serviceState.detailDom);
        if ($val === "1"){
          $serviceState.detailDom.parent(".col-sm-12").removeClass("hide");
          $fields[$serviceState.step][$index]["required"] = true;
          $serviceState.detailDom.find("select").addClass("required");
        } else {
          $serviceState.detailDom.parent(".col-sm-12").addClass("hide");
          $fields[$serviceState.step][$index]["required"] = false;
          $serviceState.detailDom.find("select").removeClass("required");
        }

        $serviceState.detailDom.find("select").val("");
      })

      // $serviceProvince.dom.find("input").attr("name", "");
      $serviceProvince.dom.find("input").on("change", function(){
        let $val = $(this).val();
        let $index = $fields[$serviceProvince.step].findIndex(o => o.dom === $serviceProvince.detailDom);
        if ($val === "1"){
          $serviceProvince.detailDom.parent(".col-sm-12").removeClass("hide");
          $fields[$serviceProvince.step][$index]["required"] = true;
          $serviceProvince.detailDom.find("select").addClass("required");
        } else {
          $serviceProvince.detailDom.parent(".col-sm-12").addClass("hide");
          $fields[$serviceProvince.step][$index]["required"] = false;
          $serviceProvince.detailDom.find("select").removeClass("required");
        }
        $serviceProvince.detailDom.find("select").val("");
      })

      $(".form-item-enrollment-contact-info-country input").on("change", function(){
        let $provinceDropdown = $(".form-item-enrollment-business-profile-province-state select");
        $provinceDropdown.val("");
        let $canadaGroup = $provinceDropdown.find("optgroup[label='Canada']");
        let $usGroup = $provinceDropdown.find("optgroup[label='United States']");
        if ($(this).val() === "CA"){
          $canadaGroup.removeClass("hide");
          $canadaGroup.attr("disabled", false);
          $usGroup.attr("disabled", true);
          $usGroup.addClass("hide");
        } else {
          $usGroup.removeClass("hide");
          $usGroup.attr("disabled", false);
          $canadaGroup.attr("disabled", true);
          $canadaGroup.addClass("hide");
        }
      })
    }

  };
}(window.app = window.app || {}, jQuery));
/*!
 * app.ui.myrove.js
 */
(function (app, $) {
	let $cache = {
		nextSelector: 'a#next:last',
		brickWall: null
	};

	function initializeEvents() {
		$('.infinitescroll_init').on('click', function (e) {
			e.preventDefault();
			app.components.initAutoScroll(app.myrove.options);
			$(this).remove();

			// Trigger scroll on first click
			$(window).trigger('scroll');
		});

		$('a.collapsed').on('click', function (e) {
			let $this = $(this);
			//$($this.attr('href')).toggleClass('in');
			$this.find('span').toggleClass('icon-plus icon-negative');
			$('#submit-photo-form').toggle();
		});
	}

	app.myrove = {
		options: {
			//brickSelector: '#rovewall',
			containerSelector: '#rovewall',
			nextSelector: $cache.nextSelector,
			//loadFunction: 'app.reviews.loadItems',
			pagerCallback: 'app.myrove.pagerCallback',
			itemCallback: 'app.myrove.itemCallback',
			completeCallback: 'app.myrove.updateComplete',
			maxPages: 10,
      columns: 4
		},

		init: function () {
			// Defaults
			initializeEvents();

			// Initialize and store the wall in cache
			app.myrove.setupWall(app.myrove.options);

			// Bind colorbox to default elements
			app.myrove.sm_load_colorbox('init');
		},

		setupWall: function(options) {
      $cache.brickWall = app.components.brickWall(options.containerSelector, options.columns);
			return $cache.brickWall;
		},

		updateComplete: function (container) {
      // Reposition elements
      $cache.brickWall.recalculate(true);

			// Bind colorbox
			app.myrove.sm_load_colorbox('reload');
		},

		pagerCallback: function ($button) {
			$button = $($cache.nextSelector);
			let currenturl = app.util.getUri($button.attr('href'));
			let newpath = currenturl.path.split('/');
			newpath.shift();
			newpath[2] = parseInt(newpath[2]) + 1;
			$button.attr('href', currenturl.protocol + '//' + currenturl.host + '/' + newpath.join('/') + currenturl.query);
		},

		itemCallback: function ($container, item) {
			for (let i = 0; i < item.length; i++) {
				$container.append(item[i].html);
			}
		},

		sm_load_colorbox: function (op) {
			switch (op) {
				case 'reload':
					$('.item .cphoto').colorbox.remove();
				case 'init':
					$('.item .cphoto').colorbox({
						rel: 'cphoto',
						inline: true,
						opacity: 0.4,
						innerWidth: $(window).width()<450?'100%':'80%',
						// innerHeight: $(window).width()<450?$(window).width()*1.35+'px':'100%',
						maxWidth: '420px',
						className: 'cphoto',
						fixed: true,
						next: '<span class="glyphicon glyphicon-menu-right" aria-hidden="true"></span>',
						previous: '<span class="glyphicon glyphicon-menu-left" aria-hidden="true"></span>',
						current: 'Displaying photo {current} of {total}',
						current: '',
						next: '',
						previous: '',
						onComplete: function () {
							// for scroll bar appear;
							//$('img').unveil(); // unveil is handled by roveUnveil()
							$(window).trigger("resize");
						}
					});
					break;
			}
		}
	};
}(window.app = window.app || {}, jQuery));
/*!
 * app.ui.reviews.js
 */
(function (app, $) {
	let $cache = {
		nextSelector: '.pager-next>a',
		brickWall: null
	};

	function initializeEvents() {
		$('.review_load_more a').on('click', function (e) {
			e.preventDefault();
			app.components.initAutoScroll(app.reviews.options);
			$(this).remove();

			// Trigger scroll on first click
			$(window).trigger('scroll');
		});
	}

	app.reviews = {
		options: {
			//brickSelector: '#reviewWall',
      containerSelector: '#reviewWall',
			nextSelector: $cache.nextSelector,
			//loadFunction: 'app.reviews.loadItems',
			pagerCallback: 'app.reviews.pagerCallback',
			itemCallback: 'app.reviews.itemCallback',
			completeCallback: 'app.reviews.updateComplete',
			maxPages: 7
		},
		init: function () {

			// Defaults
			initializeEvents();

			app.reviews.setupWall(app.reviews.options);
		},

		setupWall: function(options) {
			// Initialize and store the wall in cache
			$cache.brickWall = app.components.brickWall(app.reviews.options.containerSelector);
			return $cache.brickWall;
		},

		updateComplete: function (container) {
      // Reposition elements
      $cache.brickWall.recalculate(true);
		},

		pagerCallback: function ($button) {
			$button = $($cache.nextSelector);
			let currenturl = app.util.getUri($button.attr('href'));
			let page = parseInt(currenturl.queryParams.page) + 1;
			$button.attr('href', currenturl.protocol + '//' + currenturl.host + '/' + currenturl.path + '?page=' + page);
		},

		itemCallback: function ($container, item) {
			let $html = $(item);
			$html.find("#reviewWall .views-row").each(function () {
				$container.append($(this));
			});
		}
	};
}(window.app = window.app || {}, jQuery));/*!
 * app.swatch.js
 */
(function (app, $) {
  let $cache = {};

  function initializeCache() {
    $cache.deliveryAddressAutocompleteInputs = {
      address1: $('#edit-address1'),
      address2: $('#edit-address2'),
      province: $('#edit-province'),
      city: $('#edit-city'),
      postal_code: $('#edit-postal'),
      country: $('#edit-country')
    };

    $cache.googleMapsApi = 'https://maps.googleapis.com/maps/api/js?key=AIzaSyB9FLsOZjmxAr-8BNj3ttN0eAm_XPB2q4A&libraries=places';
  }

  function initializeDom() {
    $('#swatch_selected span').after(' / '+Drupal.settings.swatch_request_limit);

    // Swatches already set?
    if ($('#swatch_selector').length) {
      app.swatch.swatches = window.JSON.parse(app.swatch.swatchInput.val());
      $('#swatch_selected span').html(app.swatch.swatches.length);
      if (app.swatch.swatches.length) {
        for (var i = 0; i < app.swatch.swatches.length; i++) {
          app.swatch.addSwatchToForm(app.swatch.swatches[i]);
          //var $sw = $('[data-oid="'+app.swatch.swatches[i]+'"]');
          //deleteImage($sw);
        }
      }

      // if already submitted, then show the form first
      if (parseInt($('#has_been_submitted').val()) === 1) {
        app.swatch.swapSwatchForms($('.continue_button button'));
      }

      // drupal form validate fail will return previous form layout
      // which the edit-credit fieldset is closed by default. so make sure
      // to show if designer pack checkbox is check at first.
      // if ($('#edit-designer').is(':checked')) {
      //   $('#edit-credit, #swatch-payment').show();
      // }
      console.log("test");
      // Google API - Autocomplete address (Load script first)
      if (app.util.getUri(window.location.href).path == '/swatch-request' || app.util.getUri(window.location.href).path == '/swatch-request-intl/UK' || app.util.getUri(window.location.href).path == '/swatch-request-intl/US' || app.util.getUri(window.location.href).path == '/swatch-request-intl/CA') {
        $.getScript($cache.googleMapsApi, function () {
          app.swatch.addressLookup();

        });



      }


      //show Btn for microfiber
      var $mfbBtnTxt = app.getCountry() === 'KR' ? "Microfiber 가죽이란?" : "Learn more about Microfiber Leather";
      if ($(window).width() < 426){
        $("#swatch_group_135 .panel-body").prepend("<a target='_blank' href='https://lookbook.roveconcepts.com/rove-concepts-microfiber-leather-2020/' class='btn swatch-mf-btn btn-secondary full-width'>"+$mfbBtnTxt+"</a>");
      } else {
        $("#swatch_group_135 h3").text("Microfiber Leather   -   ");
        $("#swatch_group_135 h3").append("<a target='_blank' href='https://lookbook.roveconcepts.com/rove-concepts-microfiber-leather-2020/' class='swatch-mf-btn'>"+$mfbBtnTxt+"</a>");
    }

      //show Btn for vegan suede
      var $vsBtnTxt = app.getCountry() === 'KR' ? "Vegan Venice Suede 가죽이란?" : "Learn more about Vegan Venice Suede";
      if ($(window).width() < 426){
        $("#swatch_group_153 .panel-body").prepend("<a target='_blank' href='https://lookbook.roveconcepts.com/vegan-venice-suede/' class='btn swatch-mf-btn btn-secondary full-width'>"+$vsBtnTxt+"</a>");
      } else {
        $("#swatch_group_153 h3").text("Vegan Venice Suede   -   ");
        $("#swatch_group_153 h3").append("<a target='_blank' href='https://lookbook.roveconcepts.com/vegan-venice-suede/' class='swatch-mf-btn'>"+$vsBtnTxt+"</a>");
      }
  }
  }

  function initializeEvents() {
    // Add buttons
    $('.add_sw').on('click',function(e) {
      e.preventDefault();
      if ($(this).find('span').hasClass('icon-plus')) {
        // add
        app.swatch.addSwatchToForm($(this).parents('li').data('oid'));
      } else {
        // remove
        app.swatch.removeSwatchToForm($(this).parents('li').data('oid'));
      }
      app.swatch.swatchesRebind();		// rebind
    });

    // Swatch Images (Mobile)
    $(document).on('click','.swatch_image_area',function() {
      if (!app.isMobile()) {
        $.colorbox({
          escKey:true,
          closeButton:true,
          rel: 'group1',
          className: 'cb_popover',
          open: true,
          //inline:true,
          href: $(this).find('img').data('big'),
          //width:"600px",
          maxWidth:"600%",
          maxHeight:"100%",
          height:"100%",
          overlayClose:true,
          opacity:0.4
        });
      }
    });

    // SWATCHES
    $('#swatch_list .panel>div>a').on('click',function(e) {
      if (app.isMobile()) {
        if ($(this).hasClass("icon-negative")){
          // scroll to view
          app.components.doScrollTo($(this).attr('href'),-130,100);
        }

      }
    });

      $('.swatch_form .form-item-country select').on('change', function () {
          $('.form-item-province select optgroup').css('display', 'none');
          if ($(this).val() == 124) {
              $('.form-item-province select optgroup[label="Canada"]').css('display', 'block');
          }
          if ($(this).val() == 840) {
              $('.form-item-province select optgroup[label="United States"]').css('display', 'block');
          }
          if ($(this).val() == 410) {
              $('.form-item-province select optgroup[label="Korea, Republic of"]').css('display', 'block');
          }
          if ($(this).val() == 826) {
            $('.form-item-province select optgroup[label="United Kingdom"]').css('display', 'block');
          }
          if ($(this).val() == 36) {
              $('.form-item-province select optgroup[label="Australia"]').css('display', 'block');
          }
          if ($(this).val() == 344) {
              $('.form-item-province select optgroup[label="Hong Kong"]').css('display', 'block');

          }
      });

    $('#swatch_list li img, #swatch_list li .info-disp').on('click',function(e) {
      e.preventDefault();
      let ele = $(this).parents('li');

      // Remove if one already exists
      if ($('.swatch_attribute_group .swatch_full_detail').length) {
        // unbind
        $(ele).find('.swatch_button button').off('click');
        // same one?
        if ($(ele).data('oid') === $('.swatch_attribute_group .swatch_full_detail').data('oid')) {
          $('.swatch_attribute_group .swatch_full_detail').remove();
          return false;
        }
        $('.swatch_attribute_group .swatch_full_detail').remove();
      }

      // loop and find position to insert description
      var found_position = false;
      $('#swatch_group_'+$(ele).data('aid')+' li').each(function() {
        if ($(this).position().top > $(ele).position().top) {
          $(this).before($('#swatch_details_'+$(ele).data('oid')).clone());
          // if already select, change button text
          if ($('.sw_sel_'+$(ele).data('oid')).length) {
            $('.swatch_attribute_group #swatch_details_'+$(ele).data('oid')+' .swatch_button button').html(Drupal.t('Remove swatch'));
          }
          found_position = true;
          return false;
        }
      });
      // bottom element was clicked to insert to bottom
      if (!found_position) {
        //console.log($(this));
        $(this).parents('ul').append($('#swatch_details_'+$(ele).data('oid')).clone());
      }

      // bind close button
      $('.swatch_attribute_group #swatch_details_'+$(ele).data('oid')+' .swatch_close').on('click',function(e) {
        e.preventDefault();
        $(this).parents('.swatch_full_detail').remove();
      });

      // add new event listener
      $(ele).parent().find($('#swatch_details_'+$(ele).data('oid')+' .swatch_button button')).on('click',function(e) {
        e.preventDefault();

        if ($(this).html() === Drupal.t('Remove swatch')) {
          // remove
          app.swatch.removeSwatchToForm($(ele).data('oid'));
        } else {
          // add
          app.swatch.addSwatchToForm($(ele).data('oid'));
        }
        app.swatch.swatchesRebind();	 // rebind
      });

      // lazy load images
      app.components.getLazy().update();

      // scroll to view
      app.components.doScrollTo((app.isMobile()?'#swatch_details_'+$(ele).data('oid'):'.swatch_option[data-oid="'+$(ele).data('oid')+'"]'),-90,100);
    });

    // Show form by clicking continue button
    $('.continue_button button').on('click',function(e) {
      e.preventDefault();
      app.swatch.swapSwatchForms($(this));
    });

    // Toggle designer package
    // $('#edit-designer').on('change',function() {
    //   if ($(this).is(':checked')) {
    //     $('#edit-credit, #swatch-payment').show();
    //   } else {
    //     $('#edit-credit, #swatch-payment').hide();
    //   }
    // });

    $('#uc-swatch-request-form').on('submit',function(e){
      app.swatch.submit();
    });
    $('#uc-swatch-request-intl-form').on('submit',function(e){
      app.swatch.submit();
    });
    $('#uc-swatch-request-form #edit-save').on('click',function(e) {
      //e.preventDefault();
      //app.swatch.submit();
    });
  }

  app.swatch = {
    swatches: null,
    swatchInput: null,

    init: function() {
      app.swatch.swatchInput = $('#swatches'),
      app.swatch.swatches = app.swatch.swatchInput.length > 0 ? window.JSON.parse(app.swatch.swatchInput.val()) : '[]',

      initializeCache();
      initializeDom();
      initializeEvents();

      //app.swatch.phoneValidation();
    },


    // Google API - autocomplete address lookup
    addressLookup: function() {
      // Make sure we loaded the api
      if (typeof google === 'undefined' || typeof google.maps === 'undefined') {
        return false;
      }

      const options = {types: ['geocode']};
      if(Drupal.settings && Drupal.settings.uc_warehouse_location) {
        options.componentRestrictions = {country: Drupal.settings.uc_warehouse_location.initialLocale.toLowerCase()};
      }

      const autocomplete = new google.maps.places.Autocomplete(document.getElementById('edit-address1'), options);
      autocomplete.setFields(['address_components']);
      autocomplete.addListener('place_changed', () => {
        const place = autocomplete.getPlace();
        const types = {};
        place.address_components.forEach((component) => {
          const field = component.types[0];
          switch(field) {
            case 'floor':
              types.address2 = component.long_name;
              break;
            case 'street_number':
              if(types.address1) {
                types.address1 = component.short_name + ' ' + types.address1;
              }
              else {
                types.address1 = component.short_name;
              }
              break;
            case 'route':
              if(types.address1) {
                types.address1 = types.address1 + ' ' + component.short_name;
              }
              else {
                types.address1 = component.short_name;
              }
              break;
            case 'locality':
              types.city = component.short_name;
              break;
            case 'country':
              types.country = $('#edit-country option:contains(' + component.long_name + ')').val();
              break;
            case 'administrative_area_level_1':
              types.province = $('#edit-province option:contains(' + component.long_name + ')').val();
              break;
            case 'postal_code':
              types.postal_code = component.long_name;
              break;
            default:
              break;
          }
        });
        Object.keys(types).forEach((type) => {
          $cache.deliveryAddressAutocompleteInputs[type].val(types[type]);
        });
        $(document).trigger('swatchAddressChange',types);
      });
    },

    addSwatchToForm: function(oid) {
      // add
      if (app.swatch.swatches.length >= Drupal.settings.swatch_request_limit) {
        $('.alert.alert-block.alert-error.messages.error').remove();
        alert('Error message: Please limit your selection to '+Drupal.settings.swatch_request_limit+'.');
        //$('<div class="alert alert-block alert-error messages error"><a class="close" data-dismiss="alert" href="#">×</a><h4 class="element-invisible">Error message</h4>Please limit your selection to '+Drupal.settings.swatch_request_limit+'.</div>').insertAfter('.page-header');
        return;
      }
      var $div = $('<div class="sw_select clearfix"><div class="col-xs-4 col-sm-2 col-md-4 col-lg-4 sw_img"></div><div class="col-xs-8 col-sm-10 col-md-8 col-lg-8 sw_info"><a href="#" class="sw_remove" data-sw-oid="'+oid+'"><span class="icon-delete" aria-hidden="true"></span></a></div></div>');
      $div.addClass('sw_sel_'+oid);
      $div.find('.sw_img').html($('.swatch_option[data-oid="'+oid+'"] img').clone());
      $div.find('.sw_info').prepend($('.swatch_option[data-oid="'+oid+'"] .swatch_title').html());
      $('.swatch_selected').append($div);

      $('li[data-oid="'+oid+'"] .add_sw span').removeClass('icon-plus').addClass('icon-negative');
      $('#swatch_details_'+oid+' .swatch_button button').html(Drupal.t('Remove swatch'));

      if (app.swatch.swatches.indexOf(oid) < 0) {
	      app.swatch.swatches.push(oid);
      }

      // Mobile swatch count indicator
      $('#swatch_selected span').html(parseInt($('#swatch_selected span').html()) + 1);
    },

    swapSwatchForms: function(ele) {
      if ($('.swatch_form').is(':visible')) {
        $('.swatch_form').hide();
        $('#swatch_list, #swatch_menu').slideDown();
        $(ele).html(Drupal.t('Continue'));
      } else {
        $('#swatch_list, #swatch_menu').hide();
        $('.swatch_form').slideDown();
        $(ele).html(Drupal.t('Back'));
      }
    },

    swatchesRebind: function() {
      // Remove swatch button (unbind/rebind)
      $('.sw_remove').off('click');
      $('.sw_remove').on('click',function(e) {
        e.preventDefault();
        app.swatch.removeSwatchToForm($(this).data('sw-oid'));
        //$(this).parents('.sw_select').remove();
      });
    },

    removeSwatchToForm:function(oid) {
      $('.sw_sel_'+oid).remove();
      $('li[data-oid="'+oid+'"] .add_sw span').removeClass('icon-negative').addClass('icon-plus');
      $('#swatch_details_'+oid+' .swatch_button button').html(Drupal.t('Select swatch'));

      var index = app.swatch.swatches.indexOf(oid);
      if (index > -1) {
	      app.swatch.swatches.splice(index, 1);
      }

      // Mobile swatch count indicator
      $('#swatch_selected span').html(parseInt($('#swatch_selected span').html()) - 1);
    },

    phoneValidation: function(){
      $('[id*="edit-phone"]').off("keyup");
      var $prevInput = "";
      $('[id*="edit-phone"]').on("keyup", function () {
        if ($(this).val().length > 10) {
          if ($prevInput.length === $(this).val().length - 1) {
            if ($(this).val() === "1".concat($prevInput) || $(this).val() === "+1".concat($prevInput)){
              $(this).val(parseInt($(this).val()) % 10000000000);
            } else {
              $(this).val($(this).val().slice(0, 10));
            }
          } else {
            $(this).val(parseInt($(this).val()) % 10000000000);
          }
        }
        $prevInput = $(this).val();
      });
    },

    submit: function() {  // uc_swatch_submit
      app.swatch.swatchInput.val(window.JSON.stringify(app.swatch.swatches));
      $('#has_been_submitted').val(1);
      if (app.swatch.swatches.length) {
        return true;
      }
      return true;
    }
  };

}(window.app = window.app || {}, jQuery));


function search_korean_address_swatch() {
  new daum.Postcode({
    oncomplete: function (data) {
      var addr = data.address; // 최종 주소 변수

      // 주소 정보를 해당 필드에 넣는다.
      document.getElementById("edit-address1").value = addr;
    }
  }).open();
}
/*!
 * app.blog.js
 */
(function(app, $) {
  let $cache = {};

  function initializeDom() {

  }

  function initializeEvents() {
    $('.filter-category .filter-option>a').on('click',function(e) {
      e.preventDefault();
      $('#blog-filter input[name="field_tags_tid"]').val($(this).data('tid'));
      $('#blog-filter').submit();
    });

    $('.filter-sort .filter-option>a').on('click',function(e) {
      e.preventDefault();
      $('#blog-filter input[name="sort_by"]').val($(this).data('tid'));
      $('#blog-filter').submit();
    });

    $('.journal_load_more>a').on('click',function(e) {
      e.preventDefault();
      let $this = $(this);
      $this.parent().remove();

      let options = {
        containerSelector: '.view-blog .view-content .row',
        nextSelector: '.main-content .pagination .next a',
        //loadFunction: 'app.blog.loadItems',
        itemCallback: 'app.blog.itemCallback',
        completeCallback: 'app.blog.updateComplete',
        pagerCallback: 'app.blog.pagerCallback',
        maxPages: 5
      };
      app.components.initAutoScroll(options);
    });
  }

  app.blog = {
    init: function() {
      initializeDom();
      initializeEvents();
    },

    itemCallback: function ($container, item) {
      let $html = $(item);
      $html.find(".main-content .view-blog .view-content .row>div").each(function () {
        $container.append($(this));
      });
    },

    pagerCallback: function ($button, response) {
      $button = $($cache.nextSelector);
      let $html = $(response);
      let $responseButton = $html.find('.main-content .pagination .next a');
      if ($responseButton.length) {
        $button.attr('href',$responseButton.attr('href'));
      }
    },

    updateComplete: function (container) {
      //increment page #
      const pageMatch = $('.main-content .pagination .next a').attr("href").match(/page=(\d+)/);
      const page = pageMatch && parseInt(pageMatch[1])+1;
      const pageString = pageMatch && pageMatch[0];
      const link = $('.main-content .pagination .next a').attr("href");
      if(page) {
        $('.main-content .pagination .next a').attr("href", link.replace(pageString, 'page=' + page));
      }
    }
  };
}(window.app = window.app || {}, jQuery));/*!
 * app.videos.js
 */
(function(app, $) {
	let $cache = {
		videoContainer: '.view-videos .view-content .row',
		nextSelector: '.view-videos .pager-next a'
	};

	function initializeDom() {
		if (typeof app.util.getQueryStringParams(window.location.href)['video'] !== 'undefined') {
			setTimeout(function() {$('.vid_node_'+app.util.getQueryStringParams(window.location.href)['video']+'>a').trigger('click'); }, 1000);
		}

		let options = {
			containerSelector: $cache.videoContainer,
			nextSelector: $cache.nextSelector,
			//loadFunction: 'app.blog.loadItems',
			itemCallback: 'app.videos.itemCallback',
			completeCallback: 'app.videos.updateComplete',
			pagerCallback: 'app.videos.pagerCallback',
			maxPages: 15
		};
		app.components.initAutoScroll(options);
	}

	function initializeEvents() {
		app.ui.contentContainer.on('click','.video_wrap>a', function(e) {
			e.preventDefault();
			app.videos.videoClick($(this));
		});
	}

	app.videos = {
		init: function() {
			initializeDom();
			initializeEvents();
		},

		itemCallback: function ($container, item) {
			let $html = $(item);
			$html.find($cache.videoContainer + ">div").each(function () {
				$container.append($(this));
			});
		},

		pagerCallback: function ($button, response) {
			$button = $($cache.nextSelector);
			let $html = $(response);
			let $responseButton = $html.find($cache.nextSelector);
			if ($responseButton.length) {
				$button.attr('href',$responseButton.attr('href'));
			}
		},

		updateComplete: function (container) {
			// Do nothing
		},

		videoClick: function($this) {
			let videoid = $this.data('yt-id');

			$('.video-display, .video_embed').remove();
			$('.video_wrap a>img').removeClass('invisible');

			let $video_wrap = $('.video_wrap');

			let elements_per_row = app.isMobile() ? 2 : 3;
			let total_elements = $video_wrap.length - 1;
			let element_index = $video_wrap.find('>a').index($this);
			let row_position = element_index % elements_per_row;
			let video_position = Math.min(total_elements, element_index + (elements_per_row - (row_position +  1)));
			let $vid = $('#vid-'+videoid);
			let video_title = $vid.find('[data-content="title"]').html();
			let video_details = $vid.find('[data-content="description"]').html();
      // let $video_embed = app.components.wistiaVid(videoid,'video','100%','autoPlay=true videoFoam=true playerColor=e5e5e5',null);
      let $video_embed = '<iframe width="100%" height="100%" src="https://www.youtube.com/embed/'+videoid+'?autoplay=1" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerpolicy="strict-origin-when-cross-origin" allowfullscreen></iframe>';


      // app.components.wistiaLoad();

			if (elements_per_row === 3) {
				let $row = $('<div/>',{class: 'col-xs-12 video-display first-in-row'});
				let $vid_holder = $('<div/>',{class:'video-holder col-xs-12 col-sm-12 col-md-8 col-lg-8'}).append($video_embed);
				let $vid_detail = $('<div/>',{class:'video-details col-xs-12 col-sm-12 col-md-4 col-lg-4'}).append($('<h3/>').text(video_title)).append(video_details);
				$row.append($vid_holder).append($vid_detail);

				$('.video_wrap:eq(' + video_position + ')').parent('div').after($('<div/>').append($row).html());
				// app.components.roveLoader('.video-display .wistia_responsive_padding');
				app.components.doScrollTo('.video-display', -325, 500);
			} else {
				$this.addClass('hide');
				$this.after($video_embed);
			}
		}


	};
}(window.app = window.app || {}, jQuery));
/*!
 * app.checkout.js
 */
(function (app, $) {
  let $cache = {};
  let $steps = {};
  const $stepsTxt = {
    'STEP_EMAIL': 0,
    'STEP_MEMBERSHIP': 1,
    'STEP_ADDRESS': 2,
    'STEP_PROTECTION': 3,
    'STEP_PAYMENT': 4
  };
  let obs = new MutationObserver(function (mutations) {
    $("#quotes-pane").hide();
  });
  let $default = {};
  let $quoteCountdown = null;
  let $quoteDelay = null;
  let $loadingInterval = null;
  let $setMsg = null;

  function initializeCache() {
    $cache.validatePaymentMethod = true;
    $cache.GoogleAutocompleteLoaded = false;
    $cache.payClicked = false;
    $cache.checkoutLoading = false;
    $cache.lockMembershipOnly = false;
    $cache.emailInfo = {};

    $cache.shipInputs = {
      f_name: $('[id*="edit-panes-delivery-delivery-first-name"]'),
      l_name: $('[id*="edit-panes-delivery-delivery-last-name"]'),
      address1: $('[id*="edit-panes-delivery-delivery-street1"]'),
      province: $('[id*="edit-panes-delivery-delivery-zone"]'),
      country: $('[id*="edit-panes-delivery-delivery-country"]'),
      city: $('[id*="edit-panes-delivery-delivery-city"]'),
      postal_code: $('[id*="edit-panes-delivery-delivery-postal-code"]'),
      tel: $('[id*="edit-panes-delivery-delivery-phone"]')
    };

    let curCountry = $cache.shipInputs.country.children(":selected").text();
    switch(curCountry) {
      case "United States":
        $cache.country = "us";
        break;
      case "Hong Kong":
        $cache.country = "hk";
        break;
      case "Australia":
        $cache.country = "au";
        break;
      case "Korea, Republic of":
        $cache.country = "kr";
        break;
      case "South Korea":
        $cache.country = "kr";
        break;
      case "한국":
        $cache.country = "kr";
        break;
      default:
        $cache.country = "canada";
        break;
    }

    $cache.billInputs = {
      f_name: $('[id*="edit-panes-billing-billing-first-name"]'),
      l_name: $('[id*="edit-panes-billing-billing-last-name"]'),
      address1: $('[id*="edit-panes-billing-billing-street1"]'),
      province: $('[id*="edit-panes-billing-billing-zone"]'),
      country: $('[id*="edit-panes-billing-billing-country"]'),
      city: $('[id*="edit-panes-billing-billing-city"]'),
      postal_code: $('[id*="edit-panes-billing-billing-postal-code"]'),
      tel: $('[id*="edit-panes-billing-billing-phone"]')
    };

    $cache.isMembershipSelected = $('[name="panes[uc_membership][membership]"]:checked').val();

    $cache.optionalInputs = {
      address2: $('#edit-panes-delivery-delivery-street2'),
      company: $("#edit-panes-delivery-delivery-company")
    };
    $cache.optionalBillInputs = {
      address2: $('#edit-panes-billing-billing-street2'),
      company: $("#edit-panes-billing-billing-company")
    };

    $cache.shipHash = '';
    $cache.billHash = '';

    $cache.deliveryAddressAutocompleteInputs = {
      address1: $cache.shipInputs.address1,
      address2: $cache.shipInputs.address2,
      province: $cache.shipInputs.province,
      city: $cache.shipInputs.city,
      country: $cache.shipInputs.country,
      postal_code: $cache.shipInputs.postal_code
    };
    $cache.billingAddressAutocompleteInputs = {
      address1: $cache.billInputs.address1,
      address2: $cache.billInputs.address2,
      province: $cache.billInputs.province,
      city: $cache.billInputs.city,
      country: $cache.billInputs.country,
      postal_code: $cache.billInputs.postal_code
    };



    $cache.inputsCheck = {
      f_name: $('[id*="edit-panes-delivery-address"] .row div div label[for*="first-name"]'),
      l_name: $('[id*="edit-panes-delivery-address"] .row div div label[for*="last-name"]'),
      address1: $('[id*="edit-panes-delivery-address"] .row div div label[for*="street1"]'),
      province: $('[id*="edit-panes-delivery-address"] .row div div label[for*="zone"]'),
      country: $('[id*="edit-panes-delivery-address"] .row div div label[for*="country"]'),
      city: $('[id*="edit-panes-delivery-address"] .row div div label[for*="city"]'),
      postal_code: $('[id*="edit-panes-delivery-address"] .row div div label[for*="postal-code"]'),
      tel: $('[id*="edit-panes-delivery-address"] .row div div label[for*="phone"]')
    };


    $cache.inputsBillCheck = {
      f_name: $('[id*="edit-panes-billing-address"] .row div div label[for*="first-name"]'),
      l_name: $('[id*="edit-panes-billing-address"] .row div div label[for*="last-name"]'),
      address1: $('[id*="edit-panes-billing-address"] .row div div label[for*="street1"]'),
      province: $('[id*="edit-panes-billing-address"] .row div div label[for*="zone"]'),
      country: $('[id*="edit-panes-billing-address"] .row div div label[for*="country"]'),
      city: $('[id*="edit-panes-billing-address"] .row div div label[for*="city"]'),
      postal_code: $('[id*="edit-panes-billing-address"] .row div div label[for*="postal-code"]'),
      tel: $('[id*="edit-panes-billing-address"] .row div div label[for*="phone"]')
    };


    $cache.currentData = [];

    $cache.googleMapsApi = 'https://maps.googleapis.com/maps/api/js?key=AIzaSyB9FLsOZjmxAr-8BNj3ttN0eAm_XPB2q4A&libraries=places';

    $cache.ajaxRunning = false;

    $cache.document = $(document);

    $steps.sum = {account: [], address: [], bill_address: [], other: []};

    if(($cache.country === "us" || $cache.country === "ca" || $cache.country === "canada") && $(".mulberry_pane").length > 0){
      $cache.step = [{
        heading: $(".txt-step-title-0"),
        sum: $(".txt-step-sum-0")
      }, {heading: $(".txt-step-title-1"), sum: $(".txt-step-sum-1")}, {
        heading: $(".txt-step-title-2"),
        sum: $(".txt-step-sum-2")
      }, {heading: $(".txt-step-title-3"), sum: $(".txt-step-sum-3")}, {
        heading: $(".txt-step-title-4"),
        sum: $(".txt-step-sum-4")
      }];
      $steps.openStep = [app.checkout.openAccount, app.checkout.openMembership, app.checkout.openAddress, app.checkout.openOther, app.checkout.openPayment];
      $steps.closeStep = [[app.checkout.closeAccount], [app.checkout.closeMembership], [app.checkout.closeAddress, app.checkout.closeQuote], [app.checkout.closeOther], [app.checkout.closePayment]];
      $steps.currentStep = [true, false, false, false, false];
      $steps.completedStep = [false, false, false, false, false];
      $steps.sum = {account: [], member: [], address: [], other: [], bill_address: []};
      $cache.stepConts = [[$(".order_account")], [$(".membership_pane")], [$(".shipping-pane"), $(".pane-quotes")], [$(".other-pane")], [$(".payment-pane"), $(".coupon_pane")]];
    } else{
      $cache.step = [{
        heading: $(".txt-step-title-0"),
        sum: $(".txt-step-sum-0")
      }, {heading: $(".txt-step-title-1"), sum: $(".txt-step-sum-1")}, {
        heading: $(".txt-step-title-2"),
        sum: $(".txt-step-sum-2")
      }, {heading: $(".txt-step-title-4"), sum: $(".txt-step-sum-4")},];
      $steps.openStep = [app.checkout.openAccount, app.checkout.openMembership, app.checkout.openAddress, app.checkout.openPayment];
      $steps.closeStep = [[app.checkout.closeAccount], [app.checkout.closeMembership], [app.checkout.closeAddress, app.checkout.closeQuote], [app.checkout.closePayment]];
      $steps.currentStep = [true, false, false, false];
      $steps.completedStep = [false, false, false, false];
      $steps.sum = {account: [], member: [], address: [], bill_address: []};
      $cache.stepConts = [[$(".order_account")], [$(".membership_pane")], [$(".shipping-pane"), $(".pane-quotes")], [$(".payment-pane"), $(".coupon_pane")]];
    }

    $default = {
      membership: false,
      quote: false
    };
  }


  function initializeDom() {

    $cache.shipHash = app.checkout.addressHash('shipInputs');
    $cache.billHash = app.checkout.addressHash('billInputs');

    app.checkout.initStoreCredit();

    // Show the right pane
    $($('input[name="panes[payment][payment_method]"]:checked').data('details')).removeClass('hidden');

    // Google API - Autocomplete address (Load script first)
    if (app.util.getUri(window.location.href).path === '/cart/checkout') {
      $.getScript($cache.googleMapsApi, function () {
        $cache.GoogleAutocompleteLoaded = true;
        app.checkout.addressLookup('delivery');
        app.checkout.addressLookup('billing');
      });
    }

    $(document).ajaxSend(function (event, jqxhr, sett) {
      if (sett.url === window.location.pathname) {
        $cache.ajaxRunning = true;
        //$('.checkout_summary').css('opacity',0.5);
        $('body').addClass('pane-loading');

        $cache.lastAjaxTrigger = $('[name="' + sett.extraData._triggering_element_name + '"]');
        $cache.lastAjaxTrigger.parent().addClass('load-trigger');
      }
    });
    $(document).ajaxStop(function () {
      $cache.ajaxRunning = false;
      //$('.checkout_summary').css('opacity',1);
      $('body').removeClass('pane-loading');

      if (typeof $cache.lastAjaxTrigger !== 'undefined') {
        $cache.lastAjaxTrigger.parent().removeClass('load-trigger');
      }
    });

    if (($cache.country !== "us" && $cache.country !== "ca" && $cache.country !== "canada") || $('.pane-uc_mulberry').length === 0) {
      $(".step-cont-3").hide();
    }
  }

  function initializeEvents() {
    // Adjust number form types
    $("#edit-panes-payment-details-cc-number").attr("type", "number");
    $("#edit-panes-payment-details-cc-cvv").attr("type", "number");
    $("#edit-panes-payment-details-cc-exp-year").attr("type", "number");

    // Address Changer
    $cache.document.on('.checkoutAddressChange', function (e) {
    });
    $cache.document.on('.checkoutBillingAddressChange', function (e) {
    });
    $cache.document.on('shippingAddressChanged', function (e) {
      if (!$cache.shippingAddressChanged) {
        $cache.shippingAddressChanged = true;
        // Wait for all fields to change
        if (app.util.delay(1000)) {
          $('#quotes-pane button').trigger('mousedown');
          $cache.shippingAddressChanged = false;
        }
      }
    });
    $cache.document.on('billingAddressChanged', function (e) {
      console.log('billing address changed.')
    });

    $cache.document.on('click', '.btn-continue', function () {
      if ($(this).not('.hide').not('.linkLoading')) {
        let isPaymentBtn = $(this).hasClass('payment-continue');
        if (!isPaymentBtn) {
          app.checkout.resetBtns();
        }
        let $ele = $('.btn-continue').not('.linkLoading');
        if (isPaymentBtn) {
          $ele = $ele.not('.payment-continue');
        }
        $ele.each(function () {
          let $clone = $(this).clone();
          $clone.html(app.ui.loadClick).addClass('linkLoading').attr('disabled', 'disabled').off('click');
          $(this).addClass('hide').after($clone);
        });
      }
    });

    // This timer will re-enable buttons if ajax ended.
    $cache.btnTimer = setInterval(function () {
      if (!app.isAjaxRunning() && $('.linkLoading').not('.payment-continue').length > 0 && !$cache.payClicked) {
        app.checkout.resetBtns();
      }
    }, 2000);

    // Store credits pay
    $('body').on('change', 'input[name="panes[payment][usercredits]"]', function () {
      app.checkout.updateStoreCredit();
    });

    // Request live chat
    $('.helpzone .help_links a.chat-btn').on('click', function (e) {
      e.preventDefault();
      if (typeof SnapEngage === 'object' || typeof SnapEngage === 'function') {
        SnapEngage.startLink();
      }
    });

    // Hitting enter on form
    $('.uc-cart-checkout-form input[type="text"], .uc-cart-checkout-form input[type="number"], .uc-cart-checkout-form input[type="tel"]').on('keypress', function (e) {
      if (e.keyCode === 13) {
        e.preventDefault();
        let $id = $(this).attr('id');
        if ($id.includes('edit-panes-login-name') || $id.includes('edit-panes-login-pass')) {
          $(".rep-checkout-login-btn").trigger("click");
        } else if ($id.includes("edit-panes-customer-primary-email")) {
          $(".email-continue").trigger("click");
        } else if ($id.includes("cc")) {
          $(".payment-continue").trigger("click");
        } else {
          app.checkout.cartCheckoutSubmit();
        }
      }
    });

    // Login button clicked
    $('.uc-cart-checkout-form .checkout-login-btn').on('click', function (e) {
      e.preventDefault();
      app.checkout.cartLoginSubmit();
    });

    // Change payment method
    $('.uc-cart-checkout-form').on('change', 'input[name="panes[payment][payment_method]"]', function () {
      let $this = $(this);
      $('.payment-details').addClass('hidden');
      $($this.data('details')).removeClass('hidden');
      //$(document).trigger('checkoutAddressChange',[]);
    });

    $(document).ready(function () {
      $("input[name='panes[quotes][quotes][quote_option]']").each(function () {
        if ($(this).prop('checked')) {
          $(this).parent().find('label .description').show();
        } else {
          $(this).parent().find('label .description').hide();
        }
      });
    });

    $(document).on('click', "input[name='panes[quotes][quotes][quote_option]']",
      function () {
        $("input[name='panes[quotes][quotes][quote_option]']").parent().find('label .description').hide();
        if ($(this).prop('checked')) {
          $(this).parent().find('label .description').show();
        }
      }
    );

    /**
     * Checkout Progress Steps
     */
    $cache.document.on('click', '.email-continue', function (e, types) {
      app.tracking.track('checkoutEngage', {
        step: 1,
        option: 'Entered Email',
        value: Drupal.settings.track.checkout.total,
        coupon: '',    // picked up in next function
        items: []
      });
    });
    $cache.document.on('click', '.membership-continue', function (e, types) {
      app.tracking.track('checkoutEngage', {
        step: 2,
        option: 'Membership',
        value: Drupal.settings.track.checkout.total,
        coupon: '',    // picked up in next function
        items: []
      });
    });
    $cache.document.on('click', '.quote-continue', function (e, types) {
      app.tracking.gtag('event', 'shippingEntered', {});
      app.tracking.track('checkoutEngage', {
        step: 4,
        option: 'Shipping',
        value: Drupal.settings.track.checkout.total,
        coupon: '',    // picked up in next function
        items: []
      });
    });
    $cache.document.on('click', '.coupon-continue', function (e, types) {
      app.tracking.track('checkoutEngage', {
        step: 5,
        option: 'Mulberry',
        value: Drupal.settings.track.checkout.total,
        coupon: '',    // picked up in next function
        items: []
      });
    });
    $cache.document.on('click', '.payment-continue', function (e, types) {
      app.tracking.track('checkoutEngage', {
        step: 6,
        option: 'Payment',
        value: Drupal.settings.track.checkout.total,
        coupon: '',    // picked up in next function
        items: []
      });

      // Checkout Payment (Click)
      app.tracking.conversion('checkoutEngage', {
        send_to: 'AW-1016437901/Jp1XCO_717MaEI251uQD',
        value: Drupal.settings.track.checkout.total,
        currency: Drupal.settings.track.currency,
        transaction_id: Drupal.settings.track.checkout.order
      });
    });

    // Continue clicked
    $('.uc-cart-checkout-form .continue').on('click', function (e) {
      e.preventDefault();
      $('.uc-cart-checkout-form #navigation-pane .step2').trigger('click');
    });

    if ($('body.page-cart-checkout-review').length) {
      app.addEventListener('app.checkout.reviewResize', 'resize');
      app.checkout.reviewResize();
    }

    $(document).on('click', '.quote-learn a', function (e) {
      e.preventDefault();
      let $this = $(this);
      $this.parents('label').find('.description').slideToggle('slow', function () {
        if ($this.is(':visible')) {
          $this.parent().find('.quote-learn a').html(Drupal.t('learn less'));
        } else {
          $this.parent().find('.quote-learn a').html(Drupal.t('learn more'));
        }
      });
    });

    $(document).on('click', '.uc-cart-checkout-form a.remove-coupon-link', function (e) {
      e.preventDefault();
      let codeRemove = $(this).data('item');
      $('#uc-coupon-active-coupons-checkout>div input[value="' + codeRemove + '"]').attr('checked', false);
      $('[name="uc-coupon-remove"]').trigger('mousedown');
      $(this).parent().css('opacity', 0.2);
      //$(document).trigger('coupon',['remove',codeRemove]);
    });

    // Delivery Address
    if ($(".form-item-panes-delivery-select-address").length) {
      let observer = new MutationObserver(function (mutations, observer) {
        $cache.shipInputs = app.checkout.getShipInputs();

        $cache.inputsCheck = {
          f_name: $('[id*="edit-panes-delivery-address"] .row div div label[for*="first-name"]'),
          l_name: $('[id*="edit-panes-delivery-address"] .row div div label[for*="last-name"]'),
          address1: $('[id*="edit-panes-delivery-address"] .row div div label[for*="street1"]'),
          province: $('[id*="edit-panes-delivery-address"] .row div div label[for*="zone"]'),
          country: $('[id*="edit-panes-delivery-address"] .row div div label[for*="country"]'),
          city: $('[id*="edit-panes-delivery-address"] .row div div label[for*="city"]'),
          postal_code: $('[id*="edit-panes-delivery-address"] .row div div label[for*="postal-code"]'),
          tel: $('[id*="edit-panes-delivery-address"] .row div div label[for*="phone"]')
        };

        app.checkout.checkAutocomplete('delivery');
        let country = $cache.shipInputs.country.val();
        $('[id*="edit-panes-delivery-address"] .row div div label').each(function () {
          if ($(this).text().includes("*")) {
            if(country == '410') {
              $(this).text('필수 입력 사항입니다');
            } else {
              $(this).text(Drupal.t("Required"));
            }
          } else {
            $(this).empty();
          }
        });

        $.each($cache.shipInputs, function (i, e) {
          e.on("change keyup input paste", function () {
            app.checkout.showQuote();
          })
        });

        app.checkout.showQuote();

        $cache.shipInputs.address1.attr("autocomplete", "something");
        $cache.billInputs.address1.attr("autocomplete", "something");
      });

      if ($("#delivery-pane").length) {
        observer.observe($(".form-item-panes-delivery-select-address")[0], {attributes: true});
      }
    }

    // Billing Address
    if ($(".form-item-panes-billing-select-address").length) {
      let observer = new MutationObserver(function (mutations, observer) {
        $cache.billInputs = app.checkout.getBillInputs();

        $cache.inputsBillCheck = {
          f_name: $('[id*="edit-panes-billing-address"] .row div div label[for*="first-name"]'),
          l_name: $('[id*="edit-panes-billing-address"] .row div div label[for*="last-name"]'),
          address1: $('[id*="edit-panes-billing-address"] .row div div label[for*="street1"]'),
          province: $('[id*="edit-panes-billing-address"] .row div div label[for*="zone"]'),
          country: $('[id*="edit-panes-billing-address"] .row div div label[for*="country"]'),
          city: $('[id*="edit-panes-billing-address"] .row div div label[for*="city"]'),
          postal_code: $('[id*="edit-panes-billing-address"] .row div div label[for*="postal-code"]'),
          tel: $('[id*="edit-panes-billing-address"] .row div div label[for*="phone"]')
        };

        app.checkout.checkAutocomplete('billing');

        $('[id*="edit-panes-billing-address"] .row div div label').each(function () {
          if ($(this).text().includes("*")) {
            if($cache.shipInputs.country.val() == '410') {
              $(this).text('필수 입력 사항입니다')
            } else {
              $(this).text(Drupal.t("Required"));
            }
          } else {
            $(this).empty();
          }
        });

        $.each($cache.billInputs, function (i, e) {
          e.on("change keyup input paste", function () {
            app.checkout.showQuote();
          })
        });

        app.checkout.showQuote();

        $cache.shipInputs.address1.attr("autocomplete", "something");
        $cache.billInputs.address1.attr("autocomplete", "something");
      });

      if ($("#billing-pane").length) {
        observer.observe($(".form-item-panes-billing-select-address")[0], {attributes: true});
      }
    }

    if ($(".form-item-panes-delivery-select-address").length || $(".form-item-panes-billing-select-address").length) {
      app.checkout.initInputs();
    }

    // Prevent ENTER from submitting multiple times
    $('form.uc-cart-checkout-form').on('submit',function(e) { // submit more than once return false
      if ($cache.checkoutLoading || app.isAjaxRunning()) {
        return false;
      }
      $cache.checkoutLoading = true;

      // TODO: Remove this
      return true;

      // Let's re-submit for good measure of saving the order
      // in hopes of preventing duplicate mulberry products.
      $('.submit-progress').text(Drupal.t('Validating checkout')).fadeIn();
      let promise = app.checkout.submitReview();
      promise.done(function (response) {
        $('.submit-progress').text(Drupal.t('Securely processing payment'));
        return true;
      });
      promise.fail(function (response) {
        $('.submit-progress').fadeOut(300).text(Drupal.t('Securely processing payment')).fadeIn(300);
        setTimeout(function() {
          $('.submit-progress').text(Drupal.t('Securely processing payment')).fadeOut();
        },1000);
        $cache.checkoutLoading = true;
        return false;
      });
    });
  }

  function toggleAutocomplete(focus, focusOpt) {

    $.each($cache[focusOpt], function (i, e) {
      e.on("focus", function () {
        app.checkout.changeAutocomplete("on", [$(this)])
      });
      e.on("blur", function () {
        app.checkout.changeAutocomplete("off", [$(this)])
      });
    });

    $.each($cache[focus], function (i, e) {
      if (i === "f_name" || (i === "l_name" && $cache.country !== 'kr')) {
        e.on("focus", function () {
          app.checkout.changeAutocomplete("on", [$cache[focus].f_name, $cache[focus].l_name, $cache[focus].tel])
        });
        e.on("blur", function () {
          app.checkout.changeAutocomplete("off", [$cache[focus].f_name, $cache[focus].l_name, $cache[focus].tel])
        });
      } else if (i === "address1") {
        e.on("focus", function () {
          app.checkout.changeAutocomplete("on", [$cache[focus].address1, $cache[focus].address2, $cache[focus].city, $cache[focus].province, $cache[focus].postal_code])
        });
        e.on("blur", function () {
          app.checkout.changeAutocomplete("off", [$cache[focus].address1, $cache[focus].address2, $cache[focus].city, $cache[focus].province, $cache[focus].postal_code])
        });
      } else {
        e.on("focus", function () {
          app.checkout.changeAutocomplete("on", [$(this)])
        });
        e.on("blur", function () {
          app.checkout.changeAutocomplete("off", [$(this)])
        })
      }
    })

  }

  function showProductsTotal() {
    let $total = {reg: 0, mem: 0, fee:0, voucher: 0, promo: 0}
    let currencySign = '';
    $.each($(".uc-price"), function () {
      if ($(this).parent(".order_product_price").length) {
        if ((app.isCountryMembershipOnly || (!$(this).parents(".order_product_title").text().includes("Rove Members Program") && !$(this).parents(".order_product_title").text().includes("Mulberry")))) {
          // Just ignore for now
        }
        if ($(this).parent(".cart_deduct").length) {
          $total.mem += parseInt($(this).text().replace(/[^0-9.-]+/g, ""));
          currencySign = $(this).text().replace(/[0-9.,-]+/g, "");
        } else if ($(this).parent(".cart_fee").length) {
          $total.fee += parseInt($(this).text().replace(/[^0-9.-]+/g, ""));
          currencySign = $(this).text().replace(/[0-9.,-]+/g, "");
        } else {
          $total.reg += parseInt($(this).text().replace(/[^0-9.-]+/g, ""));
          currencySign = $(this).text().replace(/[0-9.,-]+/g, "");
        }

        $(this).text($(this).text().replace(/\B(?=(\d{3})+(?!\d))/g, ","));
      }
    });

    let $promoAmount = $(".total-promo-cont .promo-amount").first();
    if ($promoAmount.length) {
      $total.promo = parseInt($promoAmount.text().replace(/[^0-9.-]+/g, "")) || 0;
    }

    $total.voucher = calculateMemberVoucher($total.mem);

    if (!window.location.href.includes("checkout/complete")){
      $total.voucher = calculateMemberVoucher($total.mem);
      if($cache.country === 'kr' || $cache.country === 'KR' || $cache.country == '410' || currencySign == '원' || $cache.shipInputs.country.val() == '410') {
        $(".reg-amount").text(app.util.number_format(($total.reg + $total.fee - $total.promo), 0, '', ',')  + currencySign);
        $(".mem-amount").text(app.util.number_format(($total.mem + $total.fee - $total.promo), 0, '', ',')  + currencySign);
        $(".save-amount").text(app.util.number_format(($total.reg - $total.mem), 0, '', ',')  + currencySign);
        $(".voucher-amount").text(app.util.number_format(parseInt($total.voucher), 0, '', ',')  + currencySign);
      } else {
        $(".reg-amount").text(currencySign + app.util.number_format(($total.reg + $total.fee - $total.promo), 0, '', ','));
        $(".mem-amount").text(currencySign + app.util.number_format(($total.mem + $total.fee - $total.promo), 0, '', ','));
        $(".save-amount").text(currencySign + app.util.number_format(($total.reg - $total.mem), 0, '', ','));
        $(".voucher-amount").text(currencySign + app.util.number_format(parseInt($total.voucher), 0, '', ','));
      }
    }

    // Hide or show respective elements if member or not
    $('#rep-mem .form-item-panes-uc-membership-membership').find('input:checked').trigger('click')

    app.abtest.abtestCheckout();
  }

  function calculateMemberVoucher(subtotal) {
    const voucherrate = typeof Drupal.settings.rove_checkout !== 'undefined' && typeof Drupal.settings.rove_checkout.voucher_rate !== 'undefined' ? Drupal.settings.rove_checkout.voucher_rate : 0.1;
    const vouchertype = typeof Drupal.settings.rove_checkout !== 'undefined' && typeof Drupal.settings.rove_checkout.voucher_type !== 'undefined' ? Drupal.settings.rove_checkout.voucher_type : 'rate';
    const voucheramountper = typeof Drupal.settings.rove_checkout !== 'undefined' && typeof Drupal.settings.rove_checkout.voucher_amount_per !== 'undefined' ? Drupal.settings.rove_checkout.voucher_amount_per : 0;
    const voucherrangemin = typeof Drupal.settings.rove_checkout !== 'undefined' && typeof Drupal.settings.rove_checkout.voucher_min !== 'undefined' ? Drupal.settings.rove_checkout.voucher_min : null;
    const voucherrangemax = typeof Drupal.settings.rove_checkout !== 'undefined' && typeof Drupal.settings.rove_checkout.voucher_max !== 'undefined' ? Drupal.settings.rove_checkout.voucher_max : null;
    const vouchermax = typeof Drupal.settings.rove_checkout !== 'undefined' && typeof Drupal.settings.rove_checkout.voucher_maximum !== 'undefined' ? Drupal.settings.rove_checkout.voucher_maximum : 500;

    switch (vouchertype) {
      case 'amount_per':
        return Math.min(vouchermax,(Math.floor(subtotal/voucheramountper) * parseFloat(voucherrate)));
      case 'range':
        return Math.round(parseFloat(voucherrate));
      case 'rate':
      default:
        return Math.min(vouchermax,(subtotal * parseFloat(voucherrate)));
    }

  }

  function storeCreditPaidFull(){
    if ($('#edit-panes-payment-usercredits').is(':checked')) {
      if(typeof Drupal.settings.rove_checkout !== 'undefined' && Drupal.settings.rove_checkout.credits.amount_to_charge_usable === 0){
        return true;
      }
    }
    return false;
  }

  function changeUI() {
    app.checkout.collapseUI();

    //SET INPUT TYPE
    if ($cache.shipInputs.country.children(':selected').text() !== "Canada" && $cache.shipInputs.country.children(':selected').text() !== "United Kingdom") {
      $cache.shipInputs.postal_code.attr("type", "number");
    }
    if ($cache.billInputs.country.children(':selected').text() !== "Canada" && $cache.billInputs.country.children(':selected').text() !== "United Kingdom") {
      if (typeof $cache.billInputs.postal_code !== 'undefined') {
        $cache.billInputs.postal_code.attr("type", "number");
      }
    }

    // Billing has a country changer
    $cache.billInputs.country.on('change', function () {
      $cache.billInputs.province.find('option').attr('disabled', false);
      if (typeof $cache.billInputs.postal_code !== 'undefined' && parseInt($(this).find(':selected').val()) !== 124 && parseInt($(this).find(':selected').val()) !== 826) {
        $cache.billInputs.postal_code.attr("type", "number");
        $cache.billInputs.province.find('optgroup[label="Canada"] option').each(function () {
          $(this).attr('disabled', 'disabled');
        });
      } else if (typeof $cache.billInputs.postal_code !== 'undefined') {
        $cache.billInputs.postal_code.attr("type", "text");
        $cache.billInputs.province.find('optgroup[label="United States"] option').each(function () {
          $(this).attr('disabled', 'disabled');
        });
      }
    });

    //EMAIL CONTINUE
    $(".email-continue").on("click", async function () {
      if ($(".form-item-panes-customer-primary-email").length) {
        if (app.checkout.isEmail($('input[id*="edit-panes-customer-primary-email"]').val())) {
          //CHECKOUT AS GUEST
          $(".err-msg").empty();
          let $acc = await app.checkout.checkAccount($("#edit-panes-customer-primary-email").val().trim());
          $cache.emailInfo = $acc;

          if (!app.isCountryMembershipOnly) {
            // Force membership is on

            if ($cache.emailInfo.emailExists) {
              // Is either active member or active trade
              $(".pane-login").removeClass("sm-checkout-active");
              $(".pane-customer").addClass("sm-checkout-active");
              // $(".checkout-login-btn").clone().removeClass("checkout-login-btn").addClass("rep-checkout-login-btn").insertAfter('.checkout-login-btn')
              $(".checkout-login-btn").hide();

              //LOGIN INP CHECK
              $(".rep-checkout-login-btn").on("click", function (e) {
                e.preventDefault();
                let $c = true;
                $("#login-pane input").each(function () {
                  if ($(this).val().length === 0) {
                    $(this).addClass("error")
                  } else {
                    $(this).removeClass("error")
                    if ($(this).is($("#edit-panes-login-name"))) {
                      if (app.checkout.isEmail($("#edit-panes-login-name").val())) {
                        $(this).removeClass("error")
                      } else {
                        $(this).addClass("error")
                      }
                    }
                  }
                  if ($(this).hasClass("error")) {
                    $c = false
                  }
                })
                if ($c) {
                  $(".checkout-login-btn").trigger("click")
                }
              });
              $("#edit-panes-login-name").val($("#edit-panes-customer-primary-email").val())
              app.checkout.openLogin();
              app.checkout.closeEmail();
            } else {
              app.checkout.closeAccount();
              app.checkout.openMembership();
              app.checkout.getSum(0);
              app.checkout.setCompletedSteps();
              app.checkout.showNextStep();
              app.checkout.showSum();
            }
          } else {
            // Force membership is off
            if ($acc.emailExists && ($cache.emailInfo.memberExists || $cache.emailInfo.memberActive || $cache.emailInfo.tradeExists || $cache.emailInfo.tradeActive)) {
              if ($cache.emailInfo.memberActive || $cache.emailInfo.tradeActive) {
                // Is either active member or active trade
                $(".pane-login").removeClass("sm-checkout-active");
                $(".pane-customer").addClass("sm-checkout-active");
                // $(".checkout-login-btn").clone().removeClass("checkout-login-btn").addClass("rep-checkout-login-btn").insertAfter('.checkout-login-btn')
                $(".checkout-login-btn").hide();

                //LOGIN INP CHECK
                $(".rep-checkout-login-btn").on("click", function (e) {
                  e.preventDefault();
                  let $c = true;
                  $("#login-pane input").each(function () {
                    if ($(this).val().length === 0) {
                      $(this).addClass("error")
                    } else {
                      $(this).removeClass("error")
                      if ($(this).is($("#edit-panes-login-name"))) {
                        if (app.checkout.isEmail($("#edit-panes-login-name").val())) {
                          $(this).removeClass("error")
                        } else {
                          $(this).addClass("error")
                        }
                      }
                    }
                    if ($(this).hasClass("error")) {
                      $c = false
                    }
                  })
                  if ($c) {
                    $(".checkout-login-btn").trigger("click")
                  }
                });
                $("#edit-panes-login-name").val($("#edit-panes-customer-primary-email").val())
                app.checkout.openLogin();
                app.checkout.closeEmail();
              } else {
                if ($cache.emailInfo.memberExists || $cache.emailInfo.tradeExists) {
                  // Was either expired Member or Trade
                  if ($("#alert-messages").length) {
                    $("#alert-messages")
                      .append($('<div>', {class: 'alert alert-block alert-dismissible alert-danger messages error'})
                        .append($('<a>', {class: 'close', href: '#', 'data-dismiss': 'alert'})
                          .text('×')
                        ).append($('<span>').html('There is no membership attached to your email. A new membership will be added to your order. ' +
                          'If you think this is a mistake, please reach out to <a href="/help">here</a>.')));
                  }
                }
                app.checkout.closeAccount();
                app.checkout.openMembership();
                app.checkout.getSum(0);
                app.checkout.setCompletedSteps();
                app.checkout.showNextStep();
                app.checkout.showSum();
              }
            } else {
              app.checkout.closeAccount();
              app.checkout.openMembership();
              app.checkout.getSum(0);
              app.checkout.setCompletedSteps();
              app.checkout.showNextStep();
              app.checkout.showSum();
            }
          }
        } else {
          $(".err-msg").text(Drupal.t("Please enter a valid email address for this order"))
        }
      } else {
        app.checkout.closeAccount();
        app.checkout.openMembership();
        app.checkout.getSum(0);
        app.checkout.setCompletedSteps();
        app.checkout.showNextStep();
        app.checkout.showSum();
      }

      // Check if we are enforcing membership
      if ($steps.completedStep.indexOf(false) === $stepsTxt.STEP_MEMBERSHIP && app.checkout.isLockMembershipOnly()) {
        //$steps.completedStep[$steps.completedStep.indexOf(false)] = true
        app.checkout.membershipContinue();
      }

    });

    $(".no-login-btn").on("click", function () {
      app.checkout.closeAccount();
      app.checkout.closeLogin();
      app.checkout.openEmail();
      app.checkout.openMembership();

      app.checkout.getSum(0);
      app.checkout.setCompletedSteps();
      app.checkout.showNextStep();
      app.checkout.showSum();

      // Check if we are enforcing membership
      if ($steps.completedStep.indexOf(false) === $stepsTxt.STEP_MEMBERSHIP && app.checkout.isLockMembershipOnly()) {
        //$steps.completedStep[$steps.completedStep.indexOf(false)] = true
        app.checkout.membershipContinue();
      }
    })

    $(".back-email").on("click", function () {
      app.checkout.closeLogin();
      app.checkout.openEmail();
    })

    $(".forgot-pwd").on("click", function () {
      //app.checkout.closeLogin();
      app.checkout.openForgotPwd();
    })

    //CREATE REP MEMBERSHIP
    let $repmember;
    if ($("#edit-panes-uc-membership-membership-1").length) {
      $(".pane-membership").hide();
      let $repMem = $('<form class="mem-appended" />').append($("#edit-panes-uc-membership-membership").clone().prop("id", "rep-mem"));
      $(".rep-membership").empty().append($repMem);
      $repmember = $('#rep-mem .form-item-panes-uc-membership-membership');
      $repmember.each(function (index) {
        $(this).children("input").attr("id", (index + "-" + $(this).children("input").attr("id")));
        $(this).children("input").attr("name", ("clone-" + $(this).children("input").attr("name")));
        $(this).children("label").attr("for", (index + "-" + $(this).children("label").attr("id")));
      });
      let $currency = "$";
      let $total = {reg: 0, mem: 0, voucher: 0, savings: 0};
      $.each($(".uc-price"), function () {
        if ($(this).parent(".order_product_price").length) {
          if ($(this).parent(".cart_deduct").length) {
            $total.mem += parseInt($(this).text().replace(/[^0-9.-]+/g, ""));
          } else if ($(this).parent(".cart_fee").length) {


          } else {
            $total.reg += parseInt($(this).text().replace(/[^0-9.-]+/g, ""));
          }
        }
      })

      const vouchermax = typeof Drupal.settings.rove_checkout !== 'undefined' && typeof Drupal.settings.rove_checkout.voucher_maximum !== 'undefined' ? Drupal.settings.rove_checkout.voucher_maximum : 500;
      $total.voucher = calculateMemberVoucher($total.mem);
      $total.savings = $total.reg - $total.mem;
      $(".membership-modal-save span").text("-"+$currency+app.util.number_format(($total.savings), 0, '', ','));
      if ($total.voucher < vouchermax){
        $(".membership-modal-voucher span").text("+"+$currency+app.util.number_format(($total.voucher), 0, '', ','));
      } else {
        $(".membership-modal-voucher span").text($currency+app.util.number_format(($total.voucher), 0, '', ','));
      }
      if (parseInt($repmember.find("input:checked").val()) === 0){
        $('.non-member-disclaimer').removeClass("hide");
      }


      $repmember.on("mouseup", function (e) {
        e.preventDefault();
        $repmember.children('input').attr("checked", false);
        $(this).children('input').attr("checked", true);
        if (parseInt($(this).children('input').val()) === 1){
          // membership selected
          // $('.memberSelected').show();
          // $('.memberNotSelected').hide();
          $('.non-member-disclaimer').addClass("hide");
        } else {
          // membership NOT selected
          // $('.memberSelected').hide();
          // $('.memberNotSelected').show();
          $('.non-member-disclaimer').removeClass("hide");
        }
      });

      $repmember.find('label').on("click", function (e) {
        e.stopPropagation();
        $(this).siblings("input").trigger("click");
      });
      $('.mem-des-link').on("click", function (e) {
        e.stopPropagation();
      });

      if ($cache.lockMembershipOnly) {
        // run it again as we want to make sure no is hidden and unselected
        app.checkout.lockMembershipOnly();
      }
      $(".membership-continue").on("click", function () {
        //Check if double membership opt-out is enabled
        if ($("body").hasClass("double-member-opt-out")){
          //Double membership opt-out
          if (parseInt($repmember.find("input:checked").val()) === 0){
            $('.membership-opt-out').addClass("open")
            $(".membership-modal-cta .btn-primary").off("click").on("click", function(){
              // membership selected
              $repmember.first().find("input").click();
              $(".non-member-disclaimer").addClass("hide");
              $('.membership-opt-out').removeClass("open");
              app.checkout.membershipContinue();
            });
            $(".membership-modal-cta .btn-no").off("click").on("click", function(){
              // membership NOT selected
              $('.membership-opt-out').removeClass("open");
              app.checkout.membershipContinue();
              $(".order_product_price.not-member-selected .uc-price").css("text-decoration", "none");
            });
          } else {
            // membership selected
            app.checkout.membershipContinue();
          }
        } else {
          app.checkout.membershipContinue();
        }
      });
    } else {
      $(".membership-continue").on("click", function () {
        app.checkout.membershipContinue();
      });
    }

    //Load summary if thers something loading
    if ($loadingInterval == null){
      $loadingInterval = setInterval(function(){
        if ($(".checkout-cont .form-inputs .icon-load").length > 0){
          // console.log("loading");
          $(".checkout-right-cont .order_product>*").addClass("skeleton-loading");
        } else {
          $(".skeleton-loading").removeClass("skeleton-loading");
        }
      }, 1000)
    }


    // CHECK INPUTS
    app.checkout.initInputs();

    //Hide members program init ... showProductsTotal
    $(".order_product").each(function () {
      if ($(this).children(".order_product_title").text().includes("Rove Members Program") || $(this).children(".order_product_title").text().includes("Mulberry Warranty")) {
        if (!$('body').hasClass('memberonly')) {
          $(this).hide();
        } else {
          $(this).children(".order_product_title").text().includes("Rove Members Program") ? $(this).children(':not(.order_product_title)').hide() : $(this).children('.order_product_stock_info').hide();
        }
      }
    });

    //Hide or show login
    if (!$(".form-item-panes-customer-primary-email").length) {
      $(".pane-login").addClass("hidden");
    }

    if ($("#quotes-pane").length) {
      obs.observe($(".quote-pane")[0], {childList: true, subtree: true});
    }

    // DELIVERY CONTINUE
    $(".quote-continue").on("click", function () {
      if (app.checkout.getSum(2)) {
        // TODO: Add if statement if address has changed
        if (!app.isAjaxRunning()) {
          $('button.saveajax').trigger("mousedown");
        }
        app.checkout.setCompletedSteps();
        app.checkout.showNextStep();
        app.checkout.showSum();
      }
    });

    // COUPON CONTINUE
    $(".coupon-continue").on("click", function () {
      app.checkout.getSum(3);
      app.checkout.showSum();
      app.checkout.setCompletedSteps();
      app.checkout.showNextStep();
    });

    //EDIT BUTTONS
    $(".txt-step-title").on("click", function () {
      let $elem = $(this);
      let $title = $(".txt-step-title");
      let skip = app.checkout.isLockMembershipOnly() && $title.index($elem) === $stepsTxt.STEP_MEMBERSHIP;

      if (app.checkout.isLockMembershipOnly() && $('.pane-login').hasClass('sm-checkout-active')) {
        //&& ((!$cache.emailInfo.memberActive && !$cache.emailInfo.tradeActive) && ($cache.emailInfo.memberExists || $cache.emailInfo.tradeExists))) {
        // we are being asked to login
        return;
      }

      //Next step?
      if ($title.index($elem) > $steps.currentStep.indexOf(true) && !skip){
        //Validate the current step before moving forward
        $title.each(function(i){
          if (i >= $title.index($(".step-title-active")) && i <= $title.index($elem)){
            if (!app.checkout.getSum(i)){
              app.checkout.showNextStep(i);
              app.checkout.showSum();
              return false;
            }
            if (i === $title.index($elem)){
              let $lastCompletedStepIndex = $title.index($(".step-title-completed").last());
              if (i === $lastCompletedStepIndex + 1){
                $(".btn-continue")[$lastCompletedStepIndex].click();
              } else {
                app.checkout.showSum();
                app.checkout.showNextStep(i);
              }
            }
          }
        })
      } else if (!skip) {
        //Previous Step
        app.checkout.editBtns($elem, true);
      } else {

      }
    });

    //Mulberry Selection
    $(".mul-offer").on("click", function (e) {
      e.preventDefault();
      let $this = $(this);
      $(".mul-offer").each(function () {
        if ($(this).is($this)) {
          $(this).addClass("active");
        } else {
          $(this).removeClass("active");
        }
      });
    });

    let $prevError = false;

    $(".payment-continue").on("click", function (e) {
      // Copy billing
      if ($('[name="panes[billing][copy_address]"]').is(':checked')) {
        app.checkout.copyShipToBilling(true);
      }

      let $el = $('[name="panes[payment][payment_method]"]:checked');
      if ($el.val() === 'credit') {
        let $validated = app.checkout.ccValidation();
        if ($validated.length !== 0) {
          e.preventDefault();
          console.log($prevError);
          if ($prevError === true){
            app.checkout.loadingPaneShow();
            setTimeout(function(){
              app.checkout.loadingPaneHide();
            }, 500);
          }
          $(".uc-cart-checkout-form .payment-details .form-group:not(.form-wrapper)").each(function (i) {
            if ($validated.indexOf(i+1) !== -1) {
              $(this).children('[id*="edit-panes-payment-details"]').addClass("error");
              $(this).children("label").text(Drupal.t("Invalid")).show();
            } else {
              $(this).children('[id*="edit-panes-payment-details"]').removeClass("error");
              $(this).children("label").hide();
            }
          })
          $prevError = true;
        } else {
          $(".uc-cart-checkout-form .payment-details .form-group:not(.form-wrapper)").each(function (i) {
            $(this).children('[id*="edit-panes-payment-details"]').removeClass("error");
            $(this).children("label").hide();
          })
          $cache.payClicked = true;
          app.components.linkLoader($(this));
          $(".action-button .review").trigger("click");
        }
      } else if ($el.val() === 'affirm' || $el.val() === 'paybright' || $el.val() === 'klarna' || $el.val() === 'stripe') {
        e.preventDefault();
        $cache.payClicked = true;
        app.components.linkLoader($(this));
        if (typeof window.affirm !== 'undefined') {
          affirm.ui.ready(
            function () {
              affirm.ui.error.on("close", function () {
                // This will reset the loading button
                $(".payment-continue").trigger('ajaxEnded');
                $cache.payClicked = false;
              });
            }
          );
        }
      } else {
        e.preventDefault();
        $cache.payClicked = true;
        app.components.linkLoader($(this));
        $(".action-button .review").trigger("click");
      }
    });

    //COUPON
    $(".coupon-opener").on("click", function () {
      if (!$(".coupon_pane").hasClass("checkout-active")) {
        $(".coupon_pane").addClass("checkout-active")
      }
    });

    if (!$("#edit-panes-uc-membership-membership-1").length || !$("#edit-panes-uc-membership-membership-0").length) {
      if ($steps.completedStep[1] === false) {
        $(".txt-step-sum-0").empty();
        $steps.sum.account.push($("#customer-pane .fieldset-description").text().match(/([a-zA-Z0-9._-]+@[a-zA-Z0-9._-]+\.[a-zA-Z0-9_-]+)/gi));
        $steps.sum.account.push($("#uc_membership-pane .fieldset-wrapper").text().match(/\d{4}(\D)\d{2}\1\d{2}/g));

        app.checkout.setCompletedSteps();
        app.checkout.showNextStep();
        app.checkout.showSum();
      }
    }
  }

  function mobileCart() {
    app.checkout.setMobileStyling();
    $(".checkout_summary .section_title").on("click", function () {
      if ($(this).parents('div[id*="_checkout"]').hasClass("cart-expand")) {
        $(this).parents('div[id*="_checkout"]').removeClass("cart-expand")
        $(".checkout-arrow").addClass("checkout-arrow-flip")
        $(".checkout-lightbox").removeClass("checkout-lightbox-active")
      } else {
        $(this).parents('div[id*="_checkout"]').addClass("cart-expand")
        $(".checkout-arrow").removeClass("checkout-arrow-flip")
        $(".checkout-lightbox").addClass("checkout-lightbox-active")
      }
    });

    $(".checkout-lightbox").on("click", function () {
      $(".checkout_summary .section_title").trigger("click")
    });
  }

  app.checkout = {

    init: function () {
      if (window.location.toString().indexOf("complete") >= 0) {
        return;
      }
      initializeCache();
      initializeDom();
      initializeEvents();
      changeUI();
      showProductsTotal();
      mobileCart();

      // Add error messages where applicable
      app.checkout.setErrors();
      app.checkout.mulberry();
      app.checkout.cacheStep();

      if (!window.location.href.includes("checkout/complete")) {
        app.checkout.timingPopup();
        if ( app.getCountry() !== 'KR'){
          app.checkout.shippingNote();
        }

      }
      if (typeof app.klarna !== 'undefined' && app.klarna.enabled() && app.util.getUri(window.location.href).path !== '/cart/checkout/complete') {
        app.klarna.init();
      }
      if (typeof app.stripe !== 'undefined' && app.stripe.enabled()) {
        app.stripe.init(Drupal.settings.rove_checkout.total);
      }
    },

    resetBtns: function () {
      let $ele = $('.btn-continue').not('.linkLoading');

      $ele.each(function () {
        let $clone = $(this).next('.linkLoading');
        $clone.remove();
        $(this).removeClass('hide');
      });
    },

    initStoreCredit: function () {
      app.checkout.updateStoreCredit();
    },

    copyShipToBilling: function(triggerChange) {
      if (triggerChange) {
        $cache.billInputs.country.val($cache.shipInputs.country.find(':selected').val()).trigger('change');;
      } else {
        $cache.billInputs.country.val($cache.shipInputs.country.find(':selected').val());
      }
      $cache.billInputs.address1.val($cache.shipInputs.address1.val());
      $cache.billInputs.province.val($cache.shipInputs.province.find(':selected').val());
      $cache.billInputs.f_name.val($cache.shipInputs.f_name.val());
      $cache.billInputs.l_name.val($cache.shipInputs.l_name.val());
      $cache.billInputs.city.val($cache.shipInputs.city.val());
      $cache.billInputs.tel.val($cache.shipInputs.tel.val());
      $cache.billInputs.postal_code.val($cache.shipInputs.postal_code.val());
    },

    updateStoreCredit: function () {
      if (typeof Drupal.settings.rove_checkout !== 'undefined' && typeof Drupal.settings.rove_checkout.credits !== 'undefined') {
        let total_user_credits = Drupal.settings.rove_checkout.credits.credits;
        let usable = Drupal.settings.rove_checkout.credits.usable;
        let amount_to_charge_usable = Drupal.settings.rove_checkout.credits.amount_to_charge_usable;
        let expiry = Drupal.settings.rove_checkout.credits.expiry;
        let order_total = Drupal.settings.rove_checkout.total;

        let $methods = $('#payment-pane>div>.form-wrapper');
        let $non_credit_methods = $('div[id^="edit-payment-method-detailed"]>.form-group').not('[id^="edit-credit-wrapper"]');
        let $method_credit = $('div[id^="edit-credit-wrapper"]');
        if(typeof app.stripe !== 'undefined' && app.stripe.enabled()){
          $non_credit_methods = $('div[id^="edit-payment-method-detailed"]>.form-group').not('[id^="edit-stripe-wrapper"]');
          $method_credit = $('div[id^="edit-stripe-wrapper"]');
        }
        let $creditcheck = $('input[name="panes[payment][usercredits]"]');
        let $user_credit_div = $('.form-item-panes-payment-usercredits');

        if ($creditcheck.length) {
          if ($creditcheck.is(':checked')) {
            $method_credit.find('input.form-radio').trigger('click');
            if (amount_to_charge_usable > 0) {
              // Only covers partial
              $methods.slideDown();
              $non_credit_methods.slideUp();
              $non_credit_methods.find('input').attr('disabled', 'disabled').addClass('disabled');
              $user_credit_div.find('#card-charge').remove();
              $user_credit_div.append($('<div>', {id: 'card-charge'}).html('Amount to be charged: $' + app.util.number_format(amount_to_charge_usable, 2, '.', '')));
              $cache.validatePaymentMethod = true;
            } else {
              // Have enough to cover the entire order
              $methods.slideUp();
              $non_credit_methods.slideDown();
              $non_credit_methods.find('input').attr('disabled', false).removeClass('disabled');
              $user_credit_div.find('#card-charge').remove();
              $cache.validatePaymentMethod = false;
            }
          } else {
            // Not checked, so show everything
            $methods.slideDown();
            $non_credit_methods.slideDown();
            $non_credit_methods.find('input').attr('disabled', false).removeClass('disabled');
            $user_credit_div.find('#card-charge').remove();
            $cache.validatePaymentMethod = true;
          }
        }

        // Update the text
        if ($user_credit_div.find('.user-credit-total .uc-price').length) {
          $user_credit_div.find('.user-credit-total .uc-price').text('$' + app.util.number_format(total_user_credits, 0, '.', ''));
          $user_credit_div.find('.user-credit-usable .uc-price').text('$' + app.util.number_format(usable, 2, '.', ''));
        }
      }
    },

    productCheckoutUpdate: function(data) {
      $('#products_checkout').replaceWith(data.html);
      //changeUI();
      showProductsTotal();
    },

    storeCreditPaidFull: function(){
      if ($("input[name='panes[payment][usercredits]']").is(':checked')) {
        if(typeof Drupal.settings.rove_checkout !== 'undefined' && Drupal.settings.rove_checkout.credits.amount_to_charge_usable === 0){
          return true;
        }
      }
      return false;
    },

    getShipInputs: function () {
      return {
        f_name: $('[id*="edit-panes-delivery-delivery-first-name"]'),
        l_name: $('[id*="edit-panes-delivery-delivery-last-name"]'),
        address1: $('[id*="edit-panes-delivery-delivery-street1"]'),
        province: $('[id*="edit-panes-delivery-delivery-zone"]'),
        country: $('[id*="edit-panes-delivery-delivery-country"]'),
        city: $('[id*="edit-panes-delivery-delivery-city"]'),
        postal_code: $('[id*="edit-panes-delivery-delivery-postal-code"]'),
        tel: $('[id*="edit-panes-delivery-delivery-phone"]')
      };
    },

    getBillInputs: function () {
      return {
        f_name: $('[id*="edit-panes-billing-billing-first-name"]'),
        l_name: $('[id*="edit-panes-billing-billing-last-name"]'),
        address1: $('[id*="edit-panes-billing-billing-street1"]'),
        province: $('[id*="edit-panes-billing-billing-zone"]'),
        country: $('[id*="edit-panes-billing-billing-country"]'),
        city: $('[id*="edit-panes-billing-billing-city"]'),
        postal_code: $('[id*="edit-panes-billing-billing-postal-code"]'),
        tel: $('[id*="edit-panes-billing-billing-phone"]')
      };
    },

    addressHash: function (type) {
      let hash = '';
      // Object.keys($cache.shipInputs).forEach(function (key) {
      //   hash += ($cache.shipInputs[key].is('select')) ? $cache.shipInputs[key].find(':selected').val() : $cache.shipInputs[key].val();
      // });
      if (type === 'billInputs' && $('[name="panes[billing][copy_address]"]').is(':checked')) {
        return '';
      }
      hash = $cache[type].province.find(':selected').val() + $cache[type].city.val() + $cache[type].postal_code.val() + $('[name="clone-panes[uc_membership][membership]"]:checked').val();
      return hash;
    },

    // Google API - autocomplete address lookup
    addressLookup: function (mode) {
      // Make sure we loaded the api
      if (typeof google === 'undefined' || typeof google.maps === 'undefined') {
        return false;
      }

      const options = {types: ['geocode']};
      if (Drupal.settings && Drupal.settings.uc_warehouse_location) {
        options.componentRestrictions = {country: mode !== 'billing' ? Drupal.settings.uc_warehouse_location.initialLocale.toLowerCase() : ['ca', 'us', 'au', 'kr', 'hk', 'uk']};
      }

      let element = 'edit-panes-' + mode + '-' + mode + '-street1';
      const autocomplete = new google.maps.places.Autocomplete(document.getElementById(element), options);
      autocomplete.setFields(['address_components']);
      autocomplete.addListener('place_changed', () => {
        const place = autocomplete.getPlace();
        const types = {};
        place.address_components.forEach((component) => {
          const field = component.types[0];
          switch (field) {
            case 'floor':
              types.address2 = component.long_name;
              break;
            case 'street_number':
              if (types.address1) {
                types.address1 = component.short_name + ' ' + types.address1;
              } else {
                types.address1 = component.short_name;
              }
              break;
            case 'route':
              if (types.address1) {
                types.address1 = types.address1 + ' ' + component.short_name;
              } else {
                types.address1 = component.short_name;
              }
              break;
            case 'locality':
              types.city = component.short_name;
              break;
            case 'sublocality_level_1':
               types.city = component.short_name;
               break;
            case 'country':
              var country = component.short_name.toString().toLowerCase();
              types.country = (country === 'ca') ? 124 : ((country === 'au'? 36: (country === 'kr'? 410 : (country === 'uk'? 826 : (country === 'hk'? 344: 840)))));
              break;
            case 'administrative_area_level_1':
              if (component.short_name === "QC") {
                types.province = $('#edit-panes-' + mode + '-' + mode + '-zone option:contains(Quebec)').val();
              } else {
                types.province = $('#edit-panes-' + mode + '-' + mode + '-zone option:contains(' + component.long_name + ')').val();
              }
              break;
            case 'postal_code':
              types.postal_code = component.long_name;
              break;
            default:
              break;
          }
        });

        place.address_components.forEach((component) => {
          const field = component.types[0];
          if (field === 'administrative_area_level_1') {
            // Disable YT and NT for Canadian addresses
            if (mode === 'delivery' && types.country === 124 && (component.short_name === "YT" || component.short_name === "NT" ||
              component.long_name.includes("Yukon") || component.long_name.includes("Northwest Territories"))) {
              types.blocked_territory = true;
              types.province = null;
            }
          }
        });

        // Handle blocked territories
        if (types.blocked_territory) {
          $cache[mode + 'AddressAutocompleteInputs'].address1.val('');
          $cache[mode + 'AddressAutocompleteInputs'].city.val('');
          $cache[mode + 'AddressAutocompleteInputs'].province.val('0');
          $cache[mode + 'AddressAutocompleteInputs'].postal_code.val('');

          // Show error message
          let errorMsg = Drupal.t("Sorry, we cannot ship to this address.");
          $('[id*="edit-panes-delivery-address"] .row div div label[for*="zone"]').text(errorMsg).css("color", "#f06f4d");

          return;
        }

        Object.keys(types).forEach((type) => {
          let $evt = $.Event('change')
          $cache[mode + 'AddressAutocompleteInputs'][type].val(types[type]);
          $cache[mode + 'AddressAutocompleteInputs'][type].trigger($evt);
        });

        // $(document).trigger('checkoutAddressChange', types);
      });
    },


    cartLoginSubmit: function () {
      $('.uc-cart-checkout-form').prop('action', function (i, action) {
        if (!action.includes('destination')) {
          if (action.match(/[\?&]/)) {
            return action.replace(/([\?&][^&#]*)/, '$1' + "&destination=cart/checkout");
          } else {
            return action + "?destination=cart/checkout";
          }
        }
      });
      $('.uc-cart-checkout-form #edit-login').trigger('click');
    },

    cartCheckoutSubmit: function () {
      // Dont submit if ajax is running
      if ($cache.ajaxRunning) {
        console.log('Ajax is running, we cant use the carCheckoutSubmit yet.');
        return false;
      }
      let inputs = $('.uc-cart-checkout-form input:not([id*="cc"]), .uc-cart-checkout-form select:not([id*="cc"])');

      let error = false;
      let message = 'Please complete this field';
      let first_error = null;
      let $checked = $("[name='panes[payment][payment_method]']");
      $('label.error_message').remove();
      inputs.removeClass('error');
      inputs.each(function (k, input) {
        if ($(input).hasClass('required') || ($checked.val() === 'credit' && $(input).parents('.payment-details-credit').length)) {
          let method_active = $(input).parents('#' + $checked.parents('.form-wrapper').attr('id')).length > 0 ? true : false;
          if (($(input).parents('.pane-payment').length && method_active) || !$(input).parents('.pane-payment').length) {
            if ($(input).prop('tagName').toLowerCase() === 'input') {
              if ($(input).val() === '') {
                $(input).addClass('error');
                if (first_error === null) {
                  first_error = $(input);
                }
                error = true;
              }
            } else if ($(input).prop('tagName').toLowerCase() === 'select') {
              if ($(input).val() === '0') {
                $(input).addClass('error');
                if (first_error === null) {
                  first_error = $(input);
                }
                error = true;
              }
            }
          }
        }
      });

      if (error) {
        if ($(document).width() >= 768) {
          window.scrollTo(0, (first_error.offset().top - 90));
        } else {
          window.scrollTo(0, (first_error.offset().top - 119));
        }
        $(document).trigger('checkoutError', [message]);
      }
      // else {
      //   // Show loader
      //   app.components.linkLoader($('a.review'));
      //
      //   // Track event first, then submit form
      //   app.tracking.track('checkoutReviewed', {
      //     'event_callback': function () {
      //       app.components.createFunctionWithTimeout(function () {
      //         // Press the actual checkout button
      //         $('.uc-cart-checkout-form #edit-actions #edit-continue').trigger('click');
      //       })
      //     }
      //   });
      //
      //   // Press the actual checkout button
      //   //$('.uc-cart-checkout-form #edit-actions #edit-continue').trigger('click');
      // }

    },

    setErrors: function () {
      // Errors
      let err_icon = '<span class="glyphicon glyphicon-exclamation-sign" aria-hidden="true"></span> ';
      let hit_tab = 0;
      if ($('.step2.tab-pane .error').length) {
        $('#navigation-pane .step2').after('<div class="checkout_errors">' + err_icon + $('.step2.tab-pane .error').length + ' error(s).' + '</div>');
        $('.payment_checkout').append('<div class="checkout_errors">' + err_icon + $('.step2.tab-pane .error').length + ' error(s).' + '</div>');
        hit_tab = 2;
      }
      if ($('.step1.tab-pane .error').length) {
        $('#navigation-pane .step1').after('<div class="checkout_errors">' + err_icon + $('.step1.tab-pane .error').length + ' error(s).' + '</div>');
        $('.shipping_checkout').append('<div class="checkout_errors">' + err_icon + $('.step1.tab-pane .error').length + ' error(s).' + '</div>');
        hit_tab = 1;
      }
      if (hit_tab) {
        if ($('.uc-cart-checkout-form .shipping_checkout').is(':visible')) {
          if (hit_tab === 1) {
            $('.uc-cart-checkout-form .shipping_checkout').trigger('click');
          } else {
            $('.uc-cart-checkout-form .payment_checkout').trigger('click');
          }
        } else {
          $('#navigation-pane .step' + hit_tab).trigger('click');
        }
      }
    },

    // Resize handler for review page
    reviewResize: function () {
      let pane = $('.pane-actions');
      if (!app.isMobile()) {
        if ($('.pane-review .pane-actions').length) {
          return false;
        } else {
          //$('.checkout_review>.pane-actions').remove();
          $('.pane-review>.row').append(pane);
        }
      } else {
        if ($('.checkout_review>.pane-actions').length) {
          return false;
        } else {
          //$('.pane-review .pane-actions').remove();
          $('.checkout_review').append(pane);
        }
      }
    },

    collapseUI: function (message) {

      $("#nav-menu-secondary").addClass("hidden");

      if ($(window).width() < 500) {
        $(".txt-step-title-3").text(Drupal.t("Protection"))
      }

      $(".section_title h2").each(function () {
        if ($(this).siblings(".btn-edit").length) {
          $(this).data('yPos', $(this).offset().top - 300)
        }
      });

      app.checkout.closeAddress();
      app.checkout.closeQuote();
      app.checkout.closePayment();
      //
      // $("#edit-panes-delivery-address .row div > div").css({"display": "flex", "flex-direction": "column-reverse"})
      $("#edit-panes-delivery-address .row div div label").each(function () {
        if ($(this).text().includes("*")) {
          if($cache.shipInputs.country.val() == '410') {
            $(this).text('필수 입력 사항입니다')
          } else {
            $(this).text(Drupal.t("Required"));
          }
        } else {
          $(this).empty();
        }
      });

      $("#edit-panes-billing-address .row div div label").each(function () {
        if ($(this).text().includes("*")) {
          if($cache.shipInputs.country.val() == '410') {
            $(this).text('필수 입력 사항입니다')
          } else {
            $(this).text(Drupal.t("Required"));
          }
        } else {
          $(this).empty();
        }
      });

      app.checkout.checkAutocomplete('delivery');

      $("#phones_wrap input").attr("type", "number");
      let phone_len = ($cache.shipInputs.country.val() == '410' || $cache.shipInputs.country.val() == '826')?11:10;

      $("#phones_wrap input").on("input keypress change", function () {
        if ($(this).val().toString().length > phone_len) {
          $(this).val($(this).val().slice(0, phone_len))
        }
      })

    },

    initInputs: function () {
      let focuses = ['delivery', 'billing'];
      for (let i = 0; i < focuses.length; i++) {
        let focus = focuses[i] === 'delivery' ? 'shipInputs' : 'billInputs';
        $.each($cache[focus], function (key, val) {
          val.on("blur", () => {
            val.val((val.val() === null ? '' : val.val().trim()))
          })
        });
        $cache[focus].postal_code.on("input keypress change", function () {
          if ($cache[focus].country.children(':selected').text() === "Canada") {
            if ($cache[focus].postal_code.val().indexOf(" ") === -1) {
              $cache[focus].postal_code.attr("maxlength", "6")
            } else {
              $cache[focus].postal_code.attr("maxlength", "7")
            }
          } else if ($cache[focus].country.children(':selected').text() === "United Kingdom") {
              $cache[focus].postal_code.attr("maxlength", "8");
              if ($(this).val().toString().length > 8) {
                  $(this).val($(this).val().slice(0, 8))
              }

          } else {
            if ($(this).val().indexOf(" ") !== -1) {
              $(this).val($(this).val().trim())
            }
            if ($(this).val().toString().length > 5) {
              $(this).val($(this).val().slice(0, 5))
            }
          }
        });

        $cache[focus].tel.on("input keypress change", function () {
          $(this).val($(this).val().replace(/[^0-9]/g, ''));
          let phone_len = ($cache.shipInputs.country.val() == '410' || $cache.shipInputs.country.val() == '826')?11:10;
          if ($(this).val().toString().length > phone_len) {
            $(this).val($(this).val().slice(0, phone_len))
          }
        })
      }

      $("#edit-panes-payment-details-cc-number").on("input keypress change", function () {
        if ($(this).val().indexOf(" ") !== -1) {
          $(this).val($(this).val().trim())
        }
        if ($(this).val().toString().length > 16) {
          $(this).val($(this).val().slice(0, 16))
        }
      });

      $("#edit-panes-payment-details-cc-cvv").on("input keypress change", function () {
        if ($(this).val().indexOf(" ") !== -1) {
          $(this).val($(this).val().trim())
        }
        if ($(this).val().toString().length > 4) {
          $(this).val($(this).val().slice(0, 4))
        }
      });
    },

    activateBillingInputs: function () {


      // Remove labels
      //$('[id*="edit-panes-billing-address"] .row div div label').each(function(){
      //  $(this).empty();
      // });


      // Event listener


      //changeUI();
    },

    deactivateBillingInputs: function () {
      $cache.billInputs = $cache.optionalBillInputs = $cache.inputsBillCheck = $cache.billingAddressAutocompleteInputs = {};
    },

    iOS: function () {
      return [
          'iPad Simulator',
          'iPhone Simulator',
          'iPod Simulator',
          'iPad',
          'iPhone',
          'iPod'
        ].includes(navigator.platform)
        || (navigator.userAgent.includes("Mac") && "ontouchend" in document)
    },

    checkAutocomplete: function (mode) {
      let focus = mode === 'delivery' ? 'shipInputs' : 'billInputs';
      let focusOpt = mode === 'delivery' ? 'optionalInputs' : 'optionalBillInputs';
      if (app.checkout.iOS()) {
        $cache[focus].tel.attr("type", "number");
        $('input[id*="edit-panes-' + mode + '-' + mode + '-"]').keydown(function (e) {
          if (e.which === 13) {
            e.preventDefault();
            $('[id*="edit-panes-' + mode + '-' + mode + '-"]').eq($('[id*="edit-panes-' + mode + '-' + mode + '-"]').index($(this)) + 1).focus();
          }
        });
      } else {
        $cache[focus].tel.attr("type", "tel");
        $.each($cache[focus], function () {
          $(this).attr("readonly", true);
        });
        $.each($cache[focusOpt], function () {
          $(this).attr("readonly", true);
        });

        toggleAutocomplete(focus, focusOpt);
      }
    },

    closeForgotPwd: function() {
      $.colorbox.close()
    },

    openForgotPwd: function() {
      let data = {ajax: 1, hide_title: 1, email_address: $('[name="panes[login][name]"]').val()};
      $.colorbox({
        //?width=95%&amp;maxwidth=820&amp;inline=true&amp;fixed=true
        width: (app.isMobile() ? '100%' : '600px'),
        maxWidth: '100%',
        maxHeight: '100%',
        opacity: 0.35,
        height: (app.isMobile() ? '350px' : '350px'),
        inline: false,
        iframe: true,
        href: '/ajax/user/forgot-pwd/' + Drupal.settings.track.order_id + '/?ajax=1&hide_title=1&email_address='+$('[name="panes[login][name]"]').val(),
        data: data,
        onComplete: function () {
          $('#colorbox').css('position', 'fixed').css('top', '');
        }
      });

      // Track the click
      if (typeof app.tracking !== 'undefined') {
        app.tracking.track('forgotPwdCheckoutView');
      }
    },

    closeAccount: function () {
      $(".order_account").removeClass("checkout-active");
    },

    closeEmail: function () {
      $(".pane-customer").removeClass("sm-checkout-active");
    },

    closeLogin: function () {
      $(".pane-login").removeClass("sm-checkout-active");
    },

    closeMembership: function () {
      $(".membership_pane").removeClass("checkout-active");
      $(".account-title").removeClass("section_title-active");
      $(".account-sum").show();

    },

    closeAddress: function () {
      $(".shipping_address .section_title h2").removeClass("section_title-active");
      $(".shipping-pane").removeClass("checkout-active");
    },

    closeQuote: function () {
      $(".pane-quotes .section_title h2").removeClass("section_title-active");
      $(".quote-pane").removeClass("checkout-active");
      $(".address-sum").show();
    },

    closeOther: function () {
      $("#other_title").removeClass("section_title-active");
      $(".other-pane").removeClass("checkout-active");
    },

    closePayment: function () {
      $(".payment .section_title h2").removeClass("section_title-active");
      $(".payment-pane").removeClass("checkout-active");
      $(".action-button").hide();
      $(".checkout-cont").removeClass("payment-step");
    },

    openAccount: function () {
      $(".order_account").addClass("checkout-active")
      $(".account-title").addClass("section_title-active")
      $(".account-sum").hide();
      $(".btn-account-edit").hide();
    },

    openEmail: function () {
      $(".pane-customer").addClass("sm-checkout-active");
    },

    openLogin: function () {
      $(".pane-login").addClass("sm-checkout-active");
    },

    openMembership: function () {
      $(".membership_pane").addClass("checkout-active")
      $(".account-title").addClass("section_title-active")
      $(".btn-account-edit").hide();
    },

    openAddress: function () {
      $(".shipping_address .section_title h2").addClass("section_title-active");
      $(".shipping-pane").addClass("checkout-active");
      $(".address-sum").hide();
      $(".btn-shipping-edit").hide();
      if (app.checkout.checkInput('shipInputs') && app.checkout.checkInput('billInputs')) {
        app.checkout.openQuote();
        $(".quote-status").hide();
      } else {
        $(".quote-status").show();
        if($cache.shipInputs.country.val() == '410') {
          $(".quote-status").text('다음단계 진행을 위해 필요한 정보를 모두 작성해 주세요.');
        } else {
          $(".quote-status").text(Drupal.t("Please complete your details to continue."));
        }
        $(".quote-status").css("color", "#8E7748");
        app.checkout.closeQuote();
      }

      //DISABLE AUTOCOMPLETE
      $cache.shipInputs.address1.attr("autocomplete", "something");
      $cache.billInputs.address1.attr("autocomplete", "something");

      $.each($cache.shipInputs, function (i, e) {
        e.on("change keyup input paste", function () {
          if ($('[name="panes[billing][copy_address]"]').val() == 1) {
            // Dupe the post for billing
            app.checkout.copyShipToBilling(false);
          }
          app.checkout.showQuote();
        });
      });

      $.each($cache.billInputs, function (i, e) {
        e.on("change keyup input paste", function () {
          app.checkout.showQuote();
        })
      });

      $('[name="panes[billing][copy_address]"]').on('change', function () {
        app.checkout.showQuote();
      });

      app.checkout.showQuote();
    },

    openQuote: function () {
      $(".pane-quotes .section_title h2").addClass("section_title-active");
      $(".quote-pane").addClass("checkout-active");
      $("#quotes-pane").hide();
      $(".rep-quote").show();
      $(".btn-shipping-edit").hide();
    },

    openOther: function () {
      $("#other_title").addClass("section_title-active");
      $(".other-pane").addClass("checkout-active");
      $(".btn-other-edit").hide();
      $(".other-sum").hide();
    },

    loadingPaneShow: function() {
      $(".checkout-loading").css("visibility", "visible");
    },

    loadingPaneHide: function() {
      $(".checkout-loading").css("visibility", "hidden");
    },

    openPayment: async function () {
      let $checkFields = false;

      // Show loading window
      app.checkout.loadingPaneShow();

      // Ajax could be loading from shipping selection
      app.checkout.waitForElRemove('body.ajax-loading',async function(){
        // Validate Order Fields
        let $checkFields = await app.checkout.validateOrderFields($(".shipping_address .address-pane"));

        if ($checkFields === true) {
          $(".payment .section_title h2").addClass("section_title-active");
          $(".payment-pane").addClass("checkout-active");
          $(".action-button").css("display", "block");
          app.checkout.addAcceptedCards();
          $(".checkout-cont").addClass("payment-step");
          if ($("#coupon-messages .alert-danger").length) {
            // $(".coupon_pane").removeClass("checkout-active");
            // $("#coupon-messages").empty();
            $(".inp-coupon input").val("");
          }
          $('input[id*="cc"]').on("input keypress change", function () {
            let $validated = app.checkout.ccValidation();
            if ($validated.length !== 0) {
              let $this = $(this);
              $(".uc-cart-checkout-form .payment-details .form-group:not(.form-wrapper)").each(function (i) {
                if ($validated.indexOf(i+1) === -1) {
                  if ($(this).children('[id*="edit-panes-payment-details"]').hasClass("error")) {
                    $(this).children('[id*="edit-panes-payment-details"]').removeClass("error");
                    $(this).children("label").hide();
                  }
                }

              })
            }
          })
        } else {
          // Errors
          // Trigger click on address
          app.checkout.updateAddressText($('.form-item-panes-quotes-quotes-quote-option input:checked').parent().find('.control-label'));
          app.checkout.showSum();
          $('.step-cont-2 .txt-step-title').trigger('click');
          //app.checkout.closePayment();
          //app.checkout.openAddress();
        }

        // remove loading
        app.checkout.loadingPaneHide();
      });
    },

    clearErrorMsg: function($tab) {
      $tab.find('.alert-block').remove();
    },

    postErrorMsg: function($tab,msgs) {
      let $div = $('<div>',{'class':'alert alert-block alert-dismissible alert-danger messages error','role':'alert'});
      $div.append($('<a>',{'class':'close','data-dismiss':'alert','href':'#'}).text('×'));
      $div.append($('<h4>',{'class':'element-invisible'}).text('Error message'));
      let $ul = $('<ul>');
      for(let m in msgs) {
        if (msgs.hasOwnProperty(m)) {
          $ul.append($('<li>').text(msgs[m]));
        }
      }
      $div.append($ul);
      $tab.prepend($div);
      $div.fadeOut(1000).fadeIn(1000).fadeOut(1000).fadeIn(1000);
    },

    waitForElAdd: function(selector, callback) {
      if ($(selector).length) {
        callback();
      } else {
        setTimeout(function() {
          app.checkout.waitForElAdd(selector,callback);
        },100);
      }
    },

    waitForElRemove: function(selector, callback) {
      if (!$(selector).length) {
        callback();
      } else {
        setTimeout(function() {
          app.checkout.waitForElRemove(selector,callback);
        },100);
      }
    },

    validateOrderFields: async function($pane) {
      let $res = false;
      app.checkout.clearErrorMsg($pane);

      await $.ajax(
        {
          url: '/ajax/order-validate/'+Drupal.settings.track.order_id,
          method: 'get',
          //data: '{"key":"' + email.toLowerCase() + '"}',
          dataType: 'json'
        }
      ).done(function (res) {
        if (res.success) {
          // Continue onward as there are no errors
          $res = true;
        } else {
          /*
          for(let i in res.errors) {
            if (res.errors.hasOwnProperty(i)) {
              console.error(res.errors[i]);
            }
          }
           */
          app.checkout.postErrorMsg($pane,res.errors)
          return res;
        }
      }).fail(function (res) {
        console.error('Erroneous request.');
      })
      return $res;
    },

    changeAutocomplete: function (type, e) {
      if (type.toLowerCase() === "on") {
        $.each(e, function (val) {
          $(this).removeAttr("readonly")
        })
      } else {
        $.each(e, function (val) {
          $(this).attr("readonly", "true")
        })
      }
    },

    // type = shipInputs or billInputs
    checkInput: function (type) {
      let $c = true;
      let inCheck = type === 'shipInputs' ? 'inputsCheck' : 'inputsBillCheck';
      let reg = /^(((p[\s\.]?[o\s][\.]?)\s?)|(post\s?office\s?))((box|bin|b\.?)?\s?(num|number|#)?\s?\d+)/gmi;
      let auCityList = Drupal.settings.auEnabledCities;
      let auZoneList = Drupal.settings.auEnabledZones;
      let auPostalList = Drupal.settings.auEnabledPostalCodes;

      let memberTotal = (function (t) {
        t = (t == null ? '' : String(t)).replace(/[$,]/g, '').trim();
        var n = Number(t);
        return isFinite(n) ? n : 0;
      })($('.mem-amount').text());

      let regularTotal = (function (t) {
        t = (t == null ? '' : String(t)).replace(/[$,]/g, '').trim();
        var n = Number(t);
        return isFinite(n) ? n : 0;
      })($('.reg-amount').text());

      let checkPrice = memberTotal;

      if ($('.total-member-cont').is(':hidden')) {
        checkPrice = regularTotal;
      }

      $.each($cache[type], function (i, e) {
        if (i === "province") {
          let $zoneInput = e.val().toString().trim();
          if( $cache.shipInputs.country.val() !== '410') {
            // if (e.children(':selected').text().includes("California") && (checkPrice < 2500)) {
            //   $('.checkout_notice').show();
            // }else{
            //   $('.checkout_notice').hide();
            // }

            if (e.children(':selected').text().includes("State/Province")) {
              $c = false;
              $cache[inCheck][i].text(Drupal.t("Required"));
            } else if (e.children(':selected').text().includes("Section/Region")) {
              $c = false;
              $cache[inCheck][i].text(Drupal.t("Required"));
            } else if($cache.shipInputs.country.val() == '36' && typeof auZoneList !== 'undefined' && auZoneList && !auZoneList.includes($zoneInput) ){
              $c = false;
              $cache[inCheck][i].text(Drupal.t("Please contact us for shipping assistance"));
            } else {
              $cache[inCheck][i].text("");
            }
          }
        } else if (i === "address1") {
          if (e.val() && reg.exec(e.val().toString().trim()) !== null) {
            $c = false;
            $cache[inCheck][i].text(Drupal.t("We do not accept PO Boxes"));
          } else if (e.val() === "") {
            if($cache.shipInputs.country.val() == '410') {
              $cache[inCheck][i].text('필수 입력 사항입니다')
            } else {
              $cache[inCheck][i].text(Drupal.t("Required"));
            }
          } else {
            $cache[inCheck][i].text("");
          }
        } else if (i === "city") {
          let inputCity = e.val().toString().trim();
          let objectCountryCity = type === 'shipInputs' ? $('[name="panes[delivery][delivery_country]"] :selected').val() : $('[name="panes[billing][billing_country]"] :selected').val();

          if (type === 'shipInputs') {
            if (inputCity.toString().length === 0) {
              $c = false;
              if ($cache.shipInputs.country.val() == '410') {
                $cache[inCheck][i].text('필수 입력 사항입니다')
              } else {
                $cache[inCheck][i].text(Drupal.t("Required"));
              }
            }
            // else if (!auCityList.includes(inputCity.toLowerCase()) && parseInt(objectCountryCity) === 36) {
            //   $c = false;
            //   $cache[inCheck][i].text(Drupal.t("Please contact us for shipping assistance"));
            // }
            else {
              $cache[inCheck][i].text("")
            }
          }
        } else if (i === "postal_code") {
          if( $cache.shipInputs.country.val() !== '410' && $cache.shipInputs.country.val() !== '826') {
            let $pcInput = e.val().toString().trim();
            let $us = new RegExp("^\\d{5}(-{0,1}\\d{4})?$");
            let $ca = new RegExp(/([ABCEGHJKLMNPRSTVXY]\d)([ABCEGHJKLMNPRSTVWXYZ]\d){2}/i);
            let $au = new RegExp("^\\d{4}(-{0,1}\\d{3})?$");
            let objectCountry = type === 'shipInputs' ? $('[name="panes[delivery][delivery_country]"] :selected').val() : $('[name="panes[billing][billing_country]"] :selected').val();
            let testResult = false;
            switch (parseInt(objectCountry)) {
              case 124:
                testResult = $ca.test($pcInput.toString().replace(/\W+/g, ''));
                break;
              case 36:
                testResult = $au.test($pcInput.toString());
                break;
              default:
                testResult = $us.test($pcInput.toString());
                break;
            }
            // let testResult = (parseInt(objectCountry) === 124) ? $ca.test($pcInput.toString().replace(/\W+/g, '')) : $us.test($pcInput.toString());
            if (parseInt(objectCountry) !== 344) {
              if (testResult) {
                if (parseInt(objectCountry) == 36){
                  if(typeof auPostalList !== 'undefined' && auPostalList){
                    if(!auPostalList.includes($pcInput.toLowerCase())){
                      $c = false;
                      $cache[inCheck][i].text(Drupal.t("Please contact us for shipping assistance"));
                    }else{
                      $cache[inCheck][i].text("")
                    }
                  }else{
                    $cache[inCheck][i].text("")
                  }
                }else{
                  $cache[inCheck][i].text("")
                }
              } else {
                $c = false;
                if ($pcInput.toString().length === 0) {
                  if ($cache.shipInputs.country.val() == '410') {
                    $cache[inCheck][i].text('필수 입력 사항입니다')
                  } else {
                    $cache[inCheck][i].text(Drupal.t("Required"));
                  }
                } else {
                  $cache[inCheck][i].text(Drupal.t("Invalid"))
                }
              }
            }
          }
        } else if (i === 'tel') {
          let $sd = e.val().replace(/[^0-9]/gi, '');
          let objectCountry = type === 'shipInputs' ? $('[name="panes[delivery][delivery_country]"] :selected').val() : $('[name="panes[billing][billing_country]"] :selected').val();
          let $len = (parseInt(objectCountry) == 344)?8:((parseInt(objectCountry) == 36)?9:((parseInt(objectCountry) == 410 || parseInt(objectCountry) == 826)?11:10));
          if ($sd.charAt(0) === '1') {
            $c = false;
            $cache[inCheck][i].text(Drupal.t("Cannot start with 1"));
          } else if ($sd.length < $len) {
            $c = false
            if ($sd.length === 0) {
              if($cache.shipInputs.country.val() == '410') {
                $cache[inCheck][i].text('필수 입력 사항입니다')
              } else {
                $cache[inCheck][i].text(Drupal.t("Required"));
              }

            } else {
              $cache[inCheck][i].text(Drupal.t("Invalid"))
            }
          } else {
            $cache[inCheck][i].text("")
          }
        } else {
          if (!($cache.shipInputs.country.val() == '410' && i === 'province')) {

            if (e.val() === "") {
              $c = false;
              if($cache.shipInputs.country.val() == '410') {
                $cache[inCheck][i].text('필수 입력 사항입니다')
              } else {
                $cache[inCheck][i].text(Drupal.t("Required"));
              }


            } else {
              $cache[inCheck][i].text("");
            }

            if ($cache[inCheck][i].text() === Drupal.t("Invalid") || $cache[inCheck][i].text() === Drupal.t("Not shippable city")) {
              $cache[inCheck][i].css("color", "#f06f4d")
            } else {
              $cache[inCheck][i].css("color", "#c9c9c9")
            }
          }
        }
      })
      return $c;
    },

    createRepQuote: function () {
      let $repQuote = $('<form class="appended" />').append($("#quote").clone().prop("id", "rep-quote"));
      $(".rep-quote").empty();
      $(".rep-quote").append($repQuote);
      $('#rep-quote .form-item-panes-quotes-quotes-quote-option').each(function (index) {
        $(this).children("input").attr("id", (index + "-" + $(this).children("input").attr("id")));
        $(this).children("input").attr("name", ("clone-" + $(this).children("input").attr("name")));
        $(this).children("label").attr("for", (index + "-" + $(this).children("label").attr("for")));
      });

      $('#rep-quote .form-item-panes-quotes-quotes-quote-option').on("click", function (e) {
        e.preventDefault();
        $("#rep-quote .form-item-panes-quotes-quotes-quote-option").each(function () {
          $("#rep-quote .form-item-panes-quotes-quotes-quote-option").children('input').attr("checked", false);
        });
        $(this).children('input').attr("checked", true);
      });

      $('#rep-quote .form-item-panes-quotes-quotes-quote-option input').on("click", function (e) {
        e.stopPropagation();
        let $this = $(this).siblings("label");
        $('#rep-quote .form-item-panes-quotes-quotes-quote-option label .description').each(function () {
          if ($(this).is($this.children(".description"))) {
            $(this).css("display", "block")
          } else {
            $(this).css("display", "none")
          }
        });
        //$('#quote input[value="'+$(this).val()+'"]').trigger('click');
      });
      $('#rep-quote .form-item-panes-quotes-quotes-quote-option label').on("click", function (e) {
        e.stopPropagation();
        $(this).siblings("input").trigger("click");
      });
    },

    showQuote: async function () {
      await app.util.delay(600);
      if (app.checkout.checkInput('shipInputs') && ($('[name="panes[billing][copy_address]"]').is(':checked') || app.checkout.checkInput('billInputs')) || $cache.country === 'kr') {
        //Wait for membership to finish fetching
        if ($("#edit-panes-uc-membership-membership .icon-load").length) {
          // Loading
          if ($quoteDelay === null) {
            $quoteDelay = setInterval(function () {
              if ($("#edit-panes-uc-membership-membership .icon-load").length === 0) {
                clearInterval($quoteDelay);
                let $checkHash = app.checkout.addressHash('shipInputs');
                if ($cache.shipHash !== $checkHash) {
                  $cache.document.trigger('shippingAddressChanged');
                  $cache.shipHash = $checkHash;
                }
                let $checkBillHash = app.checkout.addressHash('billInputs');
                if ($cache.billHash !== $checkBillHash) {
                  $cache.document.trigger('billingddressChanged');
                  $cache.billHash = $checkBillHash;
                }
              }
            }, 500)
          }
        } else {
          let $checkHash = app.checkout.addressHash('shipInputs');
          if ($cache.shipHash !== $checkHash) {
            $cache.document.trigger('shippingAddressChanged');
            $cache.shipHash = $checkHash;
          }
          let $checkBillHash = app.checkout.addressHash('billInputs');
          if ($cache.billHash !== $checkBillHash) {
            $cache.document.trigger('billingddressChanged');
            $cache.billHash = $checkBillHash;
          }
        }

        // obs.disconnect();

        let $animationDots = ["", ".", "..", "..."];
        let $count = 0;
        $(".quote-status").show();
        if ($quoteCountdown === null) {
          $quoteCountdown = setInterval(function () {
            if ($('div[id*="ajax-progress-edit-panes-quotes-quote-button"]').length || $(".checkout-right-cont .order_product>.skeleton-loading").length) {
              if ($setMsg === null) {
                $(".quote-status").css("color", "var(--gray)");
                $setMsg = setInterval(function () {
                  if ($cache.shipInputs.country.val() == '410') {
                    $(".quote-status").text('배송비 견적을 진행중이오니 잠시만 기다려주세요.' + $animationDots[$count]);
                  } else {
                    $(".quote-status").text(Drupal.t("Please wait while we're retrieving your shipping quote") + $animationDots[$count]);
                  }
                  $count++;
                  if ($count > 3) {
                    $count = 0
                  }
                }, 500);
              }
              app.checkout.closeQuote();
            } else {
              app.checkout.createRepQuote();
              app.checkout.openQuote();
              clearInterval($setMsg);
              $setMsg = null;
              clearInterval($quoteCountdown);
              $quoteCountdown = null;
              $(".quote-status").hide()
            }
          }, 500);
        }

      } else {
        clearInterval($quoteCountdown);
        $quoteCountdown = null;
        clearInterval($setMsg);
        $setMsg = null;
        if ($cache.shipInputs.country.val() == '410') {
          $(".quote-status").text('다음단계 진행을 위해 필요한 정보를 모두 작성해 주세요.');
        } else {
          $(".quote-status").text(Drupal.t("Please complete your details to continue."));
        }

        $(".quote-status").show()
          .css("color", "#f06f4d");
        app.checkout.closeQuote();
      }


    },

    addAcceptedCards: function () {
      if (!$(".support-card-cont").length) {
        $("div[id*='edit-credit-wrapper'] .payment-row .payment-left .form-type-radio").append('<div class="support-card-cont"><p class="txt-cards">Secured payment with</p><img class="img-cards" src="https://cdn.roveconcepts.com/sites/default/files/images/accepted-cards-icon.png" alt="Accepted Payment Cards"></div>');
      }
      if (!$(".support-card-cont2").length) {
        $("div[id*='edit-stripe-wrapper'] .payment-row .payment-left .form-type-radio").append('<div class="support-card-cont2"><p class="txt-cards">Secured payment with</p><img class="img-cards" src="https://cdn.roveconcepts.com/sites/default/files/images/accepted-cards-icon.png" alt="Accepted Payment Cards"></div>');
      }
    },

    getSteps: function () {
      return $steps;
    },

    // Mainly only called from ajax for membership
    updateSteps: function (data) {
      let step = parseInt(data.step);
      switch(step) {
        case 3331:
          app.checkout.membershipContinue();
          break;
        default:
          app.checkout.getSum(step);
          app.checkout.setCompletedSteps();
          app.checkout.showNextStep();
          app.checkout.showSum();
          break;
      }
    },

    showNextStep: function (step) {
      let $currentStep = $steps.currentStep.indexOf(true);

      // Hide Member tab if mobile and necessary
      if (app.isCountryMembershipOnly && app.isMobile()) {
        $('.step-cont-1').hide();
      } else {
        $('.step-cont-1').show();
      }

      $(".err-msg").empty();
      $steps.currentStep.forEach(function (item, index) {
        $steps.currentStep[index] = false
      });
      $("html, body").animate({scrollTop: 0}, 600);
      if (step !== undefined) {
        if ($currentStep === 0) {
          if ($('[id*="edit-panes-customer-primary-email"]').length) {
            $('[id*="edit-panes-customer-primary-email"]').val($steps.sum.account[0])
          }
        } else if ($currentStep === 1) {
          if ($("#rep-mem").length) {
            if ($steps.sum.member.length > 0) {
              if ($steps.sum.member[0] === null) {
                $('#rep-mem [id*="edit-panes-uc-membership-membership"]').eq(1).trigger("click")
              } else {
                $('#rep-mem [id*="edit-panes-uc-membership-membership"]').eq(0).trigger("click")
              }
            }
          }
        } else if ($currentStep === 2) {
          if ($steps.sum.address.length > 0) {
            $cache.shipInputs.l_name.val($steps.sum.address[0].split(" ").pop())
            $cache.shipInputs.f_name.val($steps.sum.address[0].replace($steps.sum.address[0].split(" ").pop(), "").trim())
            $cache.shipInputs.address1.val($steps.sum.address[1])
            $cache.shipInputs.city.val($steps.sum.address[2])
            if (parseInt($cache.shipInputs.country.val()) === 124) {
              $cache.shipInputs.postal_code.val($steps.sum.address[3].slice(-7))
            } else {
              $cache.shipInputs.postal_code.val($steps.sum.address[3].match(/\d+/))
            }
            $cache.shipInputs.province.find('option:contains(' + $steps.sum.address[3].replace($steps.sum.address[3].match(/\d+/), "").trim() + ')').prop("selected", true)
            $cache.shipInputs.tel.val($steps.sum.address[4].match(/\d+/))
          }
          if ($steps.sum.bill_address.length > 0) {
            $cache.billInputs.l_name.val($steps.sum.bill_address[0].split(" ").pop())
            $cache.billInputs.f_name.val($steps.sum.bill_address[0].replace($steps.sum.bill_address[0].split(" ").pop(), "").trim())
            $cache.billInputs.address1.val($steps.sum.bill_address[1])
            $cache.billInputs.city.val($steps.sum.bill_address[2])
            if (parseInt($cache.billInputs.country.val()) === 124) {
              $cache.billInputs.postal_code.val($steps.sum.bill_address[3].slice(-7))
            } else {
              $cache.billInputs.postal_code.val($steps.sum.bill_address[3].match(/\d+/))
            }
            $cache.billInputs.province.find('option:contains(' + $steps.sum.bill_address[3].replace($steps.sum.bill_address[3].match(/\d+/), "").trim() + ')').prop("selected", true)
            $cache.billInputs.tel.val($steps.sum.bill_address[4].match(/\d+/))
          }
          if ($steps.sum.address.length > 0) {
            $("#rep-quote .quote_title").each(function () {
              if ($(this).text().includes($steps.sum.address[5].replace("Delivery: ", "").trim())) {
                $(this).parent().siblings().trigger("click")
              }
            })
          }
        } else if ($currentStep === 3) {
          if ("other" in $steps.sum) {
            if ($steps.sum.other.length > 0) {
              if ($steps.sum.other[0] !== null) {
                $(".mul-offer input").each(function () {
                  if ($(this).val().toString() === $steps.sum.other[0].match(/\d+/)[0].toString()) {
                    $(this).trigger("click")
                  }
                })
              } else {
                $(".none-offer-cont input").prop("checked", true)
              }
            }
          }
        }
        $steps.currentStep[step] = true;
        $.each($steps.currentStep, function (i, e) {
          $cache.step[i].heading.removeClass("step-title-active")
          $cache.step[i].heading.removeClass("step-title-completed")
          if (e === true) {
            $steps.openStep[i]();
            $cache.step[i].heading.addClass("step-title-active")
          } else {
            if ($steps.completedStep[i] === true) {
              $cache.step[i].heading.addClass("step-title-completed")
            }
            $.each($steps.closeStep[i], function (index, val) {
              $steps.closeStep[i][index]();
            })
          }
        })
      } else {
        if (app.isCountryMembershipOnly) {
          $steps.completedStep[1] = true;
        }
        $.each($steps.completedStep, function (i, e) {
          $cache.step[i].heading.removeClass("step-title-active")
          $cache.step[i].heading.removeClass("step-title-completed")
          if (e === false) {
            if (false && app.isCountryMembershipOnly && i === 1) {



              $cache.step[i].heading.addClass("step-title-completed")
              $.each($steps.closeStep[i], function (index, val) {
                $steps.closeStep[i][index]();
              })
            } else {
              $cache.step[i].heading.addClass("step-title-active")
              $steps.openStep[i]();
              $steps.currentStep[i] = true;
              return false;
            }
          } else {
            $cache.step[i].heading.addClass("step-title-completed")
            $.each($steps.closeStep[i], function (index, val) {
                $steps.closeStep[i][index]();
              }
            )
          }
        })
      };

      // Reset the internal checkout scroll container(s) so a newly opened step
      // starts at its top -- not wherever the previous step's Continue button
      // left the scroll. .form-inputs (and the active pane) is a height-capped
      // overflow-y container; the page scrolls to 0 above but this inner div
      // kept its old position, leaving the user at the bottom after clicking a
      // left/top nav section. Inactive panes collapse to height:0, so the
      // active pane sits at the top and scrollTop 0 == top of the new section.
      var _resetCheckoutScroll = function () {
        $('.form-inputs, .form-inputs .checkout-active').scrollTop(0);
      };
      _resetCheckoutScroll();
      // Run again after layout settles / any input auto-focus scroll.
      window.setTimeout(_resetCheckoutScroll, 60);
    },

    setCompletedSteps: function () {
      if ( ($steps.completedStep.indexOf(false) === $steps.currentStep.indexOf(true)) ) {
        let idex = $steps.completedStep.indexOf(false);
        $steps.completedStep[idex] = true;
        if (app.isCountryMembershipOnly && idex === 0) {
          $steps.completedStep[1] = true;
        }
      }

      if ($steps.completedStep[$steps.completedStep.length - 1] === true) {
        $steps.completedStep[$steps.completedStep.length - 1] = false
      }
    },

    showSum: function () {
      $cache.step.forEach(function (o, i) {
        o.sum.empty();
        if (o.heading.text().toLowerCase().includes("account")) {
          if ($steps.sum.account.length !== 0) {
            o.sum.append(Drupal.t("Order confirmation will be sent to ") + $steps.sum.account[0])
          }
        } else if (o.heading.text().toLowerCase().includes("members")) {
          if ($steps.sum.member.length !== 0) {
            if ($steps.sum.member[0] !== null) {
              o.sum.append("Your Membership is valid until " + $steps.sum.member[0] + "<br>Member pricing applied to your cart");
              $("body").removeClass("show-regular").addClass("show-member");
              if ($(".order_product_price.cart_deduct.trade").length){
                $("body").addClass("show-trade");
              }
            } else {
              o.sum.append("Rove Members opted out<br>Regular pricing applied to your cart");
              $("body").addClass("show-regular").removeClass("show-member");
            }
          }
        } else if (o.heading.text().toLowerCase().includes("address")) {
          if (!$('[name="panes[billing][copy_address]"]').is(':checked')) {
            o.sum.append("<strong>Billing Address</strong><br/>");
            $steps.sum.bill_address.forEach(function (v) {
              o.sum.append(v + "<br/>");
            });
            o.sum.append("<br/>");
            o.sum.append("<strong>Delivery Address</strong><br/>");
          }
          $steps.sum.address.forEach(function (v) {
            o.sum.append(v + "<br/>")
          });
        } else if (o.heading.text().toLowerCase().includes("mulberry")) {
          if ($steps.sum.other[0] !== undefined) {
            if ($steps.sum.other[0] !== null) {
              o.sum.append($steps.sum.other[0] + " Mulberry Protection")
            } else {
              o.sum.append(Drupal.t("Mulberry Protection opted out"))
            }
          }
        }
      })
    },
    getSum: function (order) {
      let $c = true;
      if (order === 0) {
        if (!$(".form-item-panes-customer-primary-email").length) {
          let $email = $("#customer-pane .fieldset-description").text().match(/([a-zA-Z0-9._-]+@[a-zA-Z0-9._-]+\.[a-zA-Z0-9_-]+)/gi);
          if ($email !== null) {
            $steps.sum.account.unshift($email)
          } else {
            $c = false;
          }
        } else {
          if (app.checkout.isEmail($("#edit-panes-customer-primary-email").val())) {
            if (typeof $cache.emailInfo.emailExists !== 'undefined' && $cache.emailInfo.memberExists && !$cache.emailInfo.memberActive) {
              // Display expired membership
            }

            // Forced to login
            if (app.isCountryMembershipOnly) {
              if (typeof $cache.emailInfo.emailExists !== 'undefined' && !$cache.emailInfo.emailExists) {
                // No email exists
                $steps.sum.account.unshift($("#edit-panes-customer-primary-email").val())
              } else if (typeof $cache.emailInfo.emailExists !== 'undefined' && $cache.emailInfo.emailExists && typeof Drupal.settings.track.user.id === 'undefined') {
                // They should login at this point, since not logged in but email exists
              } else if (typeof Drupal.settings.track.user.id !== 'undefined' && Drupal.settings.track.user.id) {
                // Logged in... proceed
                $steps.sum.account.unshift($("#edit-panes-customer-primary-email").val())
              }
            } else {
              $steps.sum.account.unshift($("#edit-panes-customer-primary-email").val())
            }

          }
        }
        if ($steps.sum.account[0] === "" || $steps.sum.account.length === 0) {
          $c = false
        }
      } else if (order === 1) {
        if ($steps.sum.account[0] !== "" && $steps.sum.account.length !== 0) {
          let $memOption = "";
          $('#rep-mem input[id*="edit-panes-uc-membership-membership"]').each(function () {
            if ($(this).is(':checked')) {
              $memOption = $(this).attr("id")
            }
          });
          if ($memOption.includes("edit-panes-uc-membership-membership-1")) {
            // Moving ahead
            let date = new Date();
            let $formattedDate = {d: date.getDate(), m: date.getMonth() + 1, y: date.getFullYear() + 1};
            $steps.sum.member.unshift($formattedDate.y + "-" + $formattedDate.m + "-" + $formattedDate.d)
          } else if ($memOption.includes("edit-panes-uc-membership-membership-0")) {
            // Turning off
            $steps.sum.member.unshift(null)
            //$steps.sum.member = [null];
          } else {
            // Should we ever get here?
            $steps.sum.member.unshift($("#uc_membership-pane .fieldset-wrapper").text().match(/\d{4}(\D)\d{2}\1\d{2}/g));
          }
        }
      } else if (order === 2) {
        // app.checkout.createRepQuote();
        $("#rep-quote .control-label").each(function (index) {
          if (!$(this).text().includes("Please select a shipping method") && index > 0) {
            if ($(this).siblings('input').is(':checked')) {
              app.checkout.updateAddressText($(this));
              $('#quote .form-item-panes-quotes-quotes-quote-option').eq(index).children("input").trigger("click");
            }
          } else {
            if ($(this).siblings('input').is(':checked')) {
              $(".err-msg")[0].innerText = "Please select a shipping option to continue";
              $c = false;
            }
          }
        });
        if (!app.checkout.checkInput('shipInputs') || (!$('[name="panes[billing][copy_address]"]').is(':checked') && !app.checkout.checkInput('billInputs'))) {
          $c = false;
        }
        if ($steps.sum.address.length === 0 || $steps.sum.bill_address.length === 0) {
          $c = false;
        }
      } else if (order === 3) {
        if ($("#edit-panes-uc-mulberry-info-term").length) {
          // Triggering click is okay, but if Mulberry isnt actually on order, we want to force it to load.
          let hasWarranty = false;
          let setting = app.getCountry() === 'US' ? Drupal.settings.uc_klarna : Drupal.settings.uc_paybright;
          if (typeof setting !== 'undefined' && typeof setting.order !== 'undefined') {
            for (let i in setting.order.order_lines) {
              if (setting.order.order_lines.hasOwnProperty(i)) {
                if (setting.order.order_lines[i].name === "Mulberry Warranty") {
                  hasWarranty = true;
                  break;
                }
              }
            }
          }

          let $active = $(".col.mul-offer.co.active").find("input");
          // We want to trigger save, if nothing is on order yet
          if (!hasWarranty && parseInt($active.val()) > 0) {
            $active.trigger("click");
            $active.trigger("change");
          } else {
            $active.trigger("click");
          }
          if ($(".col.mul-offer.co.active").find(".control-label").children().is("#no-offer")) {
            $steps.sum.other.unshift(null)
          } else {
            $steps.sum.other.unshift($(".col.mul-offer.co.active").find(".duration").text())
          }
        }
        if ($steps.sum.other.length === 0) {
          $c = false
        }
      }
      return $c;
    },

    updateAddressText: function($shipElement) {
      $steps.sum.address = [$cache.shipInputs.f_name.val() + " " + $cache.shipInputs.l_name.val(), $cache.shipInputs.address1.val() + " " + $cache.optionalInputs.address2.val(), $cache.shipInputs.city.val(), $cache.shipInputs.province.children(':selected').text() + " " + $cache.shipInputs.postal_code.val(), "Tel: " + $cache.shipInputs.tel.val()];
      $steps.sum.bill_address = [$cache.billInputs.f_name.val() + " " + $cache.billInputs.l_name.val(), $cache.billInputs.address1.val() + " " + $cache.optionalBillInputs.address2.val(), $cache.billInputs.city.val(), $cache.billInputs.province.children(':selected').text() + " " + $cache.billInputs.postal_code.val(), "Tel: " + $cache.billInputs.tel.val()];
      if ($cache.optionalInputs.company.val().length) {
        $steps.sum.address.splice(1, 0, $cache.optionalInputs.company.val())
      }
      if ($cache.optionalBillInputs.company.val().length) {
        $steps.sum.bill_address.splice(1, 0, $cache.optionalBillInputs.company.val())
      }
      let shipMethod = $shipElement.children(".quote_title").text().substring(0, $shipElement.children(".quote_title").text().indexOf("-"));
      $steps.sum.address.push("Delivery: " + (shipMethod ? shipMethod : '<span style="color:#f00;">Please select</span>'));
    },

    editBtns: function (e, completed) {
      if ($cache.country === "US" || $cache.country === "CA" || $cache.country === "canada" || $('.pane-uc_mulberry').length > 0) {
        app.checkout.showNextStep($(".txt-step-title").index(e));
      } else {
        app.checkout.showNextStep($(".txt-step-title:not(.txt-step-title-3)").index(e));
      }

    },

    ccValidation: function () {
      if (!$cache.validatePaymentMethod) {
        console.log('invalid payment method');
        return '';
      }
      $cache.ccInfo = {
        name: $('#edit-panes-payment-details-cc-owner'),
        num: $("#edit-panes-payment-details-cc-number"),
        month: $("#edit-panes-payment-details-cc-exp-month"),
        year: $("#edit-panes-payment-details-cc-exp-year"),
        cvv: $("#edit-panes-payment-details-cc-cvv")
      };
      let $msg = [];
      let $cardType = "";
      $.each($cache.ccInfo, function (key, val) {
        if (key === "name") {
          if (!val.val().length) {
            $msg.push(1)
          } else if (/^\d+$/.test(val.val())) {
            $msg.push(1)
          }

        } else if (key === "num") {
          if (parseInt(val.val().toString().substring(0, 2)) === 34 || parseInt(val.val().toString().substring(0, 2)) === 37) {
            //AMEX
            $cardType = "amex"
          } else if (parseInt(val.val().toString().substring(0, 1)) === 4) {
            $cardType = "visa"
          } else if (parseInt(val.val().toString().substring(0, 4)) >= 2221 && parseInt(val.val().toString().substring(0, 4)) <= 2720) {
            $cardType = "mastercard"
          } else if (parseInt(val.val().toString().substring(0, 2)) >= 51 && parseInt(val.val().toString().substring(0, 2)) <= 55) {
            $cardType = "mastercard"
          }
          if ($cardType === "amex") {
            if (val.val().toString().length !== 15) {
              $msg.push(2);
            }
          } else if ($cardType === "visa" || $cardType === "mastercard") {
            if (val.val().toString().length !== 16) {
              $msg.push(2);
            }
          } else {
            $msg.push(2);
          }
        } else if (key === "cvv") {
          if ($cardType === "amex") {
            if (val.val().toString().length !== 4) {
              $msg.push(5)
            }
          } else if ($cardType === "visa" || $cardType === "mastercard") {
            if (val.val().toString().length !== 3) {
              $msg.push(5)
            }
          } else {
            if (val.val().toString().length === 0) {
              $msg.push(5)
            }
          }
        } else if (key === 'year') {

          let $d = new Date();
          if (isNaN(val.val())) {
            $msg.push(3)
          } else {
            if (parseInt(val.val()) < $d.getFullYear()) {
              $msg.push(3)
            } else if (parseInt(val.val()) === $d.getFullYear()) {
              if (parseInt($cache.ccInfo.month.find('option:selected').val()) < $d.getMonth() + 1) {
                $msg.push(3)
              }
            }
          }
        }
      })
      return $msg;
    },

    isEmail: function (email) {
      let regex = /^([a-zA-Z0-9_.+-])+\@(([a-zA-Z0-9-])+\.)+([a-zA-Z0-9]{2,4})+$/;
      return regex.test(email);
    },

    checkAccount: async function (email) {
      let $res = {
        emailExists: false,
        memberExists: false,
        memberActive: false,
        tradeExists: false,
        tradeActive: false
      };
      await $.ajax(
        {
          url: '/json/user/exists/check',
          method: 'post',
          data: '{"email":"' + email.toLowerCase() + '"}',
          dataType: 'json'
        }
      ).done(function (res) {
        if (res.hasOwnProperty('emailExists') && res.emailExists === true) {
          $res = res;
        }
      }).fail(function (res) {

      })
      return $res;
    },

    checkMembershipChange: async function (selectedValue) {
      let $res = {
        valueChanged: false
      };
      await $.ajax(
        {
          url: '/json/user/membership/validate',
          method: 'post',
          data: '{"value":"' + selectedValue + '"}',
          dataType: 'json'
        }
      ).done(function (res) {
        if (res.hasOwnProperty('valueChanged') && res.valueChanged === true) {
          $res = res;
        }
      }).fail(function (res) {

      })
      return $res;
    },

    setMobileStyling: function () {
      if ($(".legal-purchase-note").height() > 30) {
        $(".legal-purchase-note a").before("<br>")
      }
      if (window.location.href.indexOf("checkout") > -1 && $(window).width() < 426) {
        $(document).ready(app.checkout.adjustPacPos());
        $("body").css("overflow", "hidden")
        // $(".total-sum").removeClass("hidden")
        $(document).ready(function () {
          $("head").append("<meta name='viewport' content='width=device-width, initial-scale=1.0, maximum-scale=1.0, user-scalable=no >");
        });

        $(".total-sum").text(Drupal.t("Total: ") + $(".cart_total span.regCartTotal").text())

        let observer3 = new MutationObserver(function (e) {
          $(".total-sum").text(Drupal.t("Total: ") + $(".cart_total span.regCartTotal").text())
        });

        if (!window.location.href.includes("checkout/complete")){
          observer3.observe($(".pane-cart")[0], {characterData: true, childList: true, subtree: true});
        }


      }
    },

    cacheStep: function () {
      app.checkout.createRepQuote();
      let $c = true;
      let $count = 0;
      if ($cache.country === "us" || $cache.country === "ca" || $cache.country === "canada") {
        $count = 3
      } else {
        $count = 2
      }
      if ($("#alert-messages div").length) {
        $("#alert-messages div").each(function () {
          if ($(this).hasClass("alert-danger")) {
            if ($(this).text().includes("username") || $(this).text().includes("account") || $(this).text().includes("email")) {
              $steps.completedStep.forEach(function (obj, index) {
                $steps.completedStep[index] = false;
              })
            } else {
              if ($("input.error").length) {
                $cache.stepConts.forEach((item, index) => {
                  item.forEach((e) => {
                    if ($("input.error").closest(".checkout-pane").is(e)) {
                      $steps.completedStep.forEach(function (obj, i) {
                        if (i < index) {
                          $steps.completedStep[i] = true;
                          app.checkout.getSum(i)
                        } else {
                          $steps.completedStep[i] = false;
                        }
                      });
                    }
                  })
                })
              }
            }
            $c = false;

          }
        })
      }
      if ($c === true) {
        for (let i = 0; i <= $count; i++) {
          if ($c === true) {
            if (!app.checkout.getSum(i)) {
              if (i === 2) {
                i = 1;
              }
              $steps.completedStep.forEach(function (item, index) {
                if (index < i) {
                  $steps.completedStep[index] = true;
                } else {
                  $steps.completedStep[index] = false;
                }
              });
              $c = false;
            }
          }
        }
      }


      if ($c === true) {
        $steps.completedStep.forEach(function (val, index) {
          if (index !== $steps.completedStep.length - 1) {
            $steps.completedStep[index] = true
          } else {
            $steps.completedStep[index] = false
          }
        })
      }

      // Check if we are enforcing membership
      if ($steps.completedStep.indexOf(false) === $stepsTxt.STEP_MEMBERSHIP && app.checkout.isLockMembershipOnly()) {
        $steps.completedStep[$stepsTxt.STEP_MEMBERSHIP] = true
        //app.checkout.membershipContinue();
      }

      app.checkout.showSum();
      app.checkout.showNextStep();
    },

    mulberry: function () {
      let $muloffer = $(".mul-offer");
      if ($muloffer.length) {
        //hide no, thanks
        $muloffer.eq(0).addClass("hidden");
        if ($(".shipping .cart_line_item span").text().match(/\d+/)[0] !== "0") {
          let $m = false
          $(".order_product").each(function () {
            if ($(this).children(".order_product_title").text().includes("Mulberry")) {
              $m = true;
            }
          });
          if ($m === false) {
            $muloffer.eq(0).trigger("click");
            $(".none-offer-cont input").click();
          }
        }
        if ($muloffer.eq(0).hasClass("active")) {
          $(".none-offer-cont input").click();
        }
        //make sure the highest option is selected
        if (!$(".mul-offer.active").length) {
          $muloffer.eq($(".mul-offer").length - 1).trigger("click")
        }
        $('div[id*="mulberry-offers"]').append("<div class='none-offer-cont'><input type='radio'><label>No thanks</label></div>")
        $(".none-offer-cont label").on("click", () => {
          $(".none-offer-cont label").siblings("input").trigger("click")

        })
        let $newinput = $(".none-offer-cont input");
        $newinput.on("click", (e) => {
          $muloffer.eq(0).trigger("click");
        })
        $('.mul-offer:not([class*="hidden"])').on("click", () => {
          $newinput.prop("checked", false)
        })
        if (parseInt($('[name="panes[uc_mulberry][info][term]"]:checked').val()) === 0) {
          //$newinput.attr('checked','checked');
          $newinput.trigger('click');
        }
      }
    },

    adjustPacPos: function () {

      let checkExist = setInterval(function () {
        if ($('.pac-container').length) {
          let observer4 = new MutationObserver(function (mutation) {
            $(".pac-container").css("top", parseInt($(".pac-container").css("top").match(/\d+/)) - 40)
          });

          observer4.observe($(".pac-container")[0], {
            childList: true,
            subtree: true
          });
          clearInterval(checkExist);

        }
      }, 100);
    },

    membershipContinue: async function() {
      let $repmember = $('#rep-mem .form-item-panes-uc-membership-membership');
      if (typeof $repmember !== 'undefined' && $repmember.length) {
        $repmember.each(function (index) {
          if ($(this).children('input').is(':checked')) {
            $('input[id*="edit-panes-uc-membership-membership-"]').eq(index).trigger("click");
          }
        });
      }
      app.checkout.getSum(1);
      app.checkout.setCompletedSteps();
      app.checkout.showNextStep();
      app.checkout.showSum();

      $cache.isMembershipSelected = $('[name="panes[uc_membership][membership]"]:checked').val();
      let $checkChange = await app.checkout.checkMembershipChange($cache.isMembershipSelected);
      if ($checkChange.valueChanged) {
        //$('button.saveajax').trigger("mousedown");
      }
    },

    submitReview: function() {
      let base = 'edit-panes-quotes-quote-buttonx';
      let $element = $('#edit-panes-quotes-quote-button');
      Drupal.ajax[base] = new Drupal.ajax(base,$element,{
        url:'/cart/checkout',
        data:{
          _triggering_element_name: "op",
          _triggering_element_value: "Calculate Shipping"
        }
      });
      return Drupal.ajax[base].eventMimic($element);
    },

    timingPopup: function(){
      setTimeout( ()=>{app.components.timingInfoModal()}, 1500000);
    },

    shippingNote: function(){
      let customOrder = false;
        $(".order_product_stock_info").each(function (){
        if ($(this).text().toLowerCase().includes("custom")){
          customOrder = true;
          return;
        }
      })
      let leadtime = "";
        if (customOrder){
          if ($cache.country === "us"){
            leadtime = "Please note it takes 14 - 20 weeks to process custom orders prior to shipment."
          } else if ($cache.country === "hk") {
            leadtime = "Please note it takes 8 - 10 weeks to process custom orders prior to shipment."
          } else {
            leadtime = "<span>Please note it takes 14 - 20 weeks to process custom orders prior to shipment. You will receive an email with your tracking details as soon as your order is set up for shipment.<br><br></span>"
          }
        } else {
          if ($cache.country === "hk"){
            leadtime = "Please note it is an estimated 1-2 business days to process orders prior to shipment."
          }
          // else if ($cache.country === "us") {
          //   leadtime = "Please note it is an estimated 1-5 business days to process orders prior to shipment."
          // } else {
          //   leadtime = "Please note it is an estimated 1-4 business days to process orders prior to shipment."
          // }
        }
      let obrs = new MutationObserver(   function(){
        if (document.querySelectorAll("#rep-quote .form-item-panes-quotes-quotes-quote-option label .description .shipping-note").length <= document.querySelectorAll("#rep-quote .form-item-panes-quotes-quotes-quote-option label .description").length){
          let x = document.querySelectorAll("#rep-quote .form-item-panes-quotes-quotes-quote-option label .description");
          for (let i = 0; i < x.length; i++) {
            let txt=document.createElement("p");
            if ($cache.country === "hk"){
              txt.innerHTML = leadtime + " You will receive an email with your tracking details as soon as your order is set up for shipment.";
            } else {
              txt.innerHTML="<span>" + leadtime + " You will receive an email with your tracking details as soon as your order is set up for shipment.</span>";
            }
            txt.classList.add("shipping-note");
            x[i].appendChild(txt);
          }
        }
      }   );
      obrs.observe( document.querySelector(".rep-quote")  , {childList: true} );

    },

    lockMembershipOnly: function() {
      $('form.mem-appended .form-type-radio:first .control-label').trigger('click');
      $('form.mem-appended .form-type-radio:last').hide();
      //$(".step-cont-"+$stepsTxt.STEP_MEMBERSHIP).hide(); // hide Members tab
      $(".txt-step-title-"+$stepsTxt.STEP_MEMBERSHIP).addClass('step-title-completed').addClass('step-title-locked');
      $cache.lockMembershipOnly = true;
    },

    isLockMembershipOnly: function() {
      return $cache.lockMembershipOnly;
    }

  };

}(window.app = window.app || {}, jQuery));


function search_korean_address() {
  new daum.Postcode({
    oncomplete: function (data) {
      var addr = data.address; // 최종 주소 변수

      // 주소 정보를 해당 필드에 넣는다.
      document.querySelector("#edit-panes-delivery-delivery-postal-code").value = data.zonecode;
      document.getElementById("edit-panes-delivery-delivery-street1").value = addr;
      document.querySelector("#edit-panes-delivery-delivery-city").value=data.sigungu;
    }
  }).open();
}

/**
 * @file
 * Initializes Klarna API
 */

(function (app, $) {

    let $cache = {
        klarna_session: {},
        order: {},
        order_id: {}
    };

    function initializeCache() {
        $cache.klarna_session = Drupal.settings.uc_klarna.response || '';
        //$cache.order = Drupal.settings.uc_klarna.order;
        $cache.order_id = Drupal.settings.uc_klarna.order_id;
    }

    /*
    function initializeEventsBak() {
        $('#uc-klarna-redirect-form #edit-klarna-submit')
            .off('click.roveklarna')
            .on('click.roveklarna',function(e) {
                $(this).attr('disabled','disabled').css('background-color', '#eee').css('border-color', '#eee').html('Processing...');
                // console.log('authorize button hit');
            e.preventDefault();
            app.klarna.authorize();
        });
    }
    */

    function initializeEvents() {
        $('.payment-continue')
            .off('click.roveklarna')
            .on('click.roveklarna',function(e) {
                if ($('[name="panes[payment][payment_method]"]:checked').val() === 'klarna') {
                    e.preventDefault();
                    $(this)
                        .attr('disabled','disabled')
                        .data('bgcolor',$(this).css('background-color'))
                        .css('background-color', '#eee')
                        .data('bdcolor',$(this).css('border-color'))
                        .css('border-color', '#eee')
                        .data('text',$(this).text())
                        .html('Processing...');
                    // console.log('authorize button hit');
                    app.klarna.authorize(); 
                    $(this).trigger('ajaxEnded');
                }
            });
    }

    app.klarna = {
        init: function() {
            if (app.klarna.enabled()) {
                // console.log('klarna init');
                initializeCache();
                app.klarna.load();
                // if(app.util.getUri(window.location.href).path == '/cart/checkout/review'){
                    initializeEvents();
                    // app.klarna.review();
                // }
            }
        },

        enabled: function(){
            return app.getCountry() === 'US' && typeof Drupal.settings.uc_klarna !== 'undefined' && Drupal.settings.uc_klarna.enabled;
        },

        initReview: function() {
            if (app.getCountry() === 'US') {
                // console.log('klarna review');
                initializeCache();
                Klarna.Payments.init({client_token: $cache.klarna_session.client_token});
                initializeEvents();
                app.klarna.review();

            }
        },
        
        review: function() {
            try {
                Klarna.Payments.loadPaymentReview({
                    container: '#klarna-review-container'
                }, app.klarna.stripOrderForLoad(Drupal.settings.uc_klarna.order), function (res) { // loadPaymentReview~callback
                    // ...
                })
            } catch (e) {
                // Handle error. The loadPaymentReview~callback will have been called
                // with "{ show_form: false }" at this point.
                // console.log(e);
            }
        },

        load: function () {
            // console.log($cache.klarna_session);
            // console.log(Drupal.settings.uc_klarna.order);

            try {
                // console.log('klarna success');
                Klarna.Payments.init({client_token: $cache.klarna_session.client_token});
                Klarna.Payments.load({
                    container: '#klarna-payments-container',
                    payment_method_category: app.klarna.getCategory(),
                }, app.klarna.stripOrderForLoad(Drupal.settings.uc_klarna.order), function (res) {
                    app.klarna.togglePaymentWidget(res.show_form);
                    // console.debug(res);
                });
            } catch (e) {
                // Handle error. The loadPaymentReview~callback will have been called
                // with "{ show_form: false }" at this point.
                app.klarna.togglePaymentWidget(false);
                // console.log(e);
            }
        },

        togglePaymentWidget: function($show){
            if(!$show){
                $('#edit-klarna-wrapper').hide();
                $('div[id^="edit-credit-wrapper"] input.form-radio').trigger('click');
            }else {
                $('#edit-klarna-wrapper').show();
            }
        },

        // We need a lite version of the order object for the klarna load() function
        stripOrderForLoad: function($object) {
            return  {
                "locale": $object.locale,
                "purchase_country": $object.purchase_country,
                "purchase_currency": $object.purchase_currency,
                "order_amount": $object.order_amount,
                "order_tax_amount": $object.order_tax_amount,
                "order_lines": $object.order_lines
            };
        },

        stripOrderForAuthorize: function($object) {
            let order = {
                "locale": $object.locale,
                "purchase_country": $object.purchase_country,
                "purchase_currency": $object.purchase_currency,
                "order_amount": $object.order_amount,
                "order_tax_amount": $object.order_tax_amount,
                "order_lines": $object.order_lines
            };

            if($object.billing_address && $object.billing_address !== 'undefined'){
                order.billing_address = $object.billing_address;
            }

            if($object.shipping_address && $object.shipping_address !== 'undefined'){
                order.shipping_address = $object.shipping_address;
            }

            return order;
        },

        authorize: function() {
            Klarna.Payments.authorize({
                payment_method_category: app.klarna.getCategory()
            }, app.klarna.stripOrderForAuthorize(Drupal.settings.uc_klarna.order), function (res) { // authorize~callback
                if(res.approved && res.authorization_token){
                    // console.log('authorization_token: ' + res.authorization_token);
                    // console.log('authorization success');
                    $.getJSON('/ajax/klarna/'+$cache.order_id,{client_token: $cache.klarna_session.client_token, res: res},function(data) {
                        // console.log(data);
                        window.location.href = data.redirect_url;
                    });
                }else{
                    const btn = $('.payment-continue');
                    btn.attr('disabled',false).css('background-color', btn.data('bgcolor')).css('border-color', btn.data('bdcolor')).html(btn.data('text'));
                    // console.log('authorization failed');
                }
                // console.log(res);
            });
        },

        refreshPrice: function (price) {
            $('klarna-placement').attr('data-purchase-amount', price*100);
            window.KlarnaOnsiteService.push({ eventName: 'refresh-placements' });
        },

        getCategory: function() {
            let category = 'pay_over_time';
            if(typeof $cache.klarna_session.payment_method_categories !== 'undefined' && $cache.klarna_session.payment_method_categories[0]){
                category = $cache.klarna_session.payment_method_categories[0].identifier;
            }
            return category;
        },

        // Ajax calls this for updating
        updateOrder: function(data) {
            Drupal.settings.uc_klarna.order = data.order;
        },

        // Called from product pages
        productObserver: function() {
            if (app.klarna.enabled()) {
                let $item = $(".klarna-product");
                if ($item.length) {
                    let observer = new MutationObserver(function () {
                        let $product = $(".klarna-product");
                        let price = parseInt($product.attr('data-purchase-amount'));
                        if (price >= 40000) {
                            $product.height(15);
                        } else {
                            $product.height(40);
                        }
                    });
                    observer.observe($(".klarna-product")[0], {attributes: true, subtree: true});
                }
            }
        }
    };
}(window.app = window.app || {}, jQuery));
/**
 * @file
 * app.stripe.js
 */

(function (app, $) {
    let $cache = {
        publicKey: '',
        orderId: '',
        selectedStripeMethod: 'card'
    };
    function initializeCache(){
        $cache.publicKey = Drupal.settings.uc_stripe.publicKey || '';
        $cache.orderId = Drupal.settings.uc_stripe.order_id;
    }

    function initializeEvents() {
        $('#edit-panes-payment-usercredits').bind('change',function() {
            var active = 0;
            if ($("input[name='panes[payment][usercredits]']").is(':checked')) {
                active = 1;
            }
            if(app.checkout.storeCreditPaidFull()){
                // $(".payment-continue").on("click", function (e) {
                //     $(".action-button .review").trigger("click");
                //     app.components.linkLoader($(this));
                // });
                console.log('store credit full');
                $('.payment-continue')
                    .off('click.rovestripe')
                    .on('click.rovestripe',function(e) {
                        if ($('[name="panes[payment][payment_method]"]:checked').val() === 'stripe') {
                            e.preventDefault();
                            $(this)
                                .attr('disabled','disabled')
                                .data('bgcolor',$(this).css('background-color'))
                                .css('background-color', '#eee')
                                .data('bdcolor',$(this).css('border-color'))
                                .css('border-color', '#eee')
                                .data('text',$(this).text())
                                .html('Processing...');
                            $(this).trigger('ajaxEnded');
                        }
                    });
                window.location.href = '/uc_stripe/credit/complete/'+$cache.orderId;

            }else{
                $(".payment-continue").on("click", function (e) {
                    e.preventDefault();
                    app.components.linkLoader($(this));
                    if (typeof window.affirm !== 'undefined') {
                        affirm.ui.ready(
                            function () {
                                affirm.ui.error.on("close", function () {
                                    // This will reset the loading button
                                    $(".payment-continue").trigger('ajaxEnded');
                                });
                            }
                        );
                    }
                });
            }
            app.stripe.load(active);
        });

    }

    function processingBtn(){
        const btn = $('.payment-continue');
        if (btn.html() !== 'Processing...') {
          btn.attr('disabled', 'disabled')
            .attr('data-bgcolor', btn.css('background-color'))
            .css('background-color', '#eee')
            .attr('data-bdcolor', btn.css('border-color'))
            .css('border-color', '#eee')
            .attr('data-text', btn.text())
            .html('Processing...')
            .css('cursor', 'not-allowed')
          ;
        }
    }

    function disableBtn(){
        const btn = $('.payment-continue');
        if (btn.attr('disabled') !== 'disabled' && btn.attr('disabled') !== true) {
          btn.attr('disabled', 'disabled')
            .attr('data-bgcolor', btn.css('background-color'))
            .css('background-color', '#eee')
            .attr('data-bdcolor', btn.css('border-color'))
            .css('border-color', '#eee')
            .attr('data-text', btn.text())
          ;
        }
    }

    function enableBtn(){
        const btn1 = $('.payment-continue');
        if (btn1.attr('disabled') !== false)
        btn1.attr('disabled',false)
            .css('background-color', btn1.attr('data-bgcolor'))
            .css('border-color', btn1.attr('data-bdcolor'))
            .html(btn1.attr('data-text'))
            .css('cursor','pointer')
        ;
        $('#payment-processing-message').hide();
    }

    app.stripe = {
        init: function(amount=0) {
            if (app.stripe.enabled()) {
                // console.log('Stripe init');
                initializeCache();
                app.stripe.load(0, amount);
                // console.log('Stripe success');
                initializeEvents();
                // app.stripe.load();
                // if(app.util.getUri(window.location.href).path == '/cart/checkout/review'){
                // app.klarna.review();
                // }
            }
        },
        enabled: function(){
            return typeof Drupal.settings.uc_stripe !== 'undefined' && Drupal.settings.uc_stripe.enabled;
        },
        load: async function (creditActive=0, amount=0) {
            // console.log(creditActive);
            try {
                // console.log('stripe success');
                var stripe = Stripe($cache.publicKey);
                // disableBtn();

                await fetch("/stripeAjax/"+$cache.orderId, {
                    method: "POST",
                    headers: {
                        "Content-Type": "application/json"
                    },
                    body:  JSON.stringify({creditActive:creditActive, amount:amount})
                })
                .then(function(result) {
                    return result.json();
                })
                .then(function(data) {
                    if(data.clientSecret){
                        // console.log(data.clientSecret);
                        if(data.clientSecret === 'fullPaidByStoreCredit'){

                        }else if(data.clientSecret === 'missingBillingAddress'){
                            $("#stripe-payments-container").html('Please complete your shipping address before processing your order.');
                        }else{
                            let style = {
                              base: {
                                color: "#32325d",
                                fontFamily: 'Arial, sans-serif',
                                fontSmoothing: "antialiased",
                                fontSize: "16px",
                                "::placeholder": {
                                  color: "#32325d"
                                }
                              },
                              invalid: {
                                fontFamily: 'Arial, sans-serif',
                                color: "#fa755a",
                                iconColor: "#fa755a"
                              }
                            };

                            /*
                            const options = {
                              mode: 'payment',
                              setup_future_usage: 'off_session',
                              currency: Drupal.settings.track.currency.toLowerCase(),
                              amount: data.amount,
                            };
                            */
                            const options = {
                              clientSecret:data.clientSecret
                            };
                            //var elements = stripe.elements(options);
                            var elements = stripe.elements(options);

                            if (false) {
                              var card = elements.create("card", {style: style});
                              card.mount("#card-element"); // Stripe injects an iframe into the DOM
                            }

                            /*
                            const linkAuthenticationElement = elements.create("linkAuthentication");
                            linkAuthenticationElement.mount("#link-authentication-element");
                            */

                            const paymentElementOptions = {
                              layout: {
                                type: 'accordion',
                                defaultCollapsed: false,
                                radios: true,
                                spacedAccordionItems: false
                              },
                              style: style,
                              paymentMethodOrder: ['card','us_bank_account', 'acss_debit'],
                              fields: {
                                billingDetails: {
                                  address: 'never'
                                }
                              }
                            };

                            const paymentElement = elements.create("payment", paymentElementOptions);
                            paymentElement.mount("#payment-element"); // Stripe injects an iframe into the DOM
                            paymentElement.on("change", function (event) {
                                // Disable the Pay button if there are no card details in the Element
                                if(((event.empty || event.complete === false) && !(event.value.type === 'google_pay' || event.value.type === 'apple_pay' || event.value.type === 'affirm' || event.value.type === 'klarna')) && $('#edit-panes-payment-payment-method-stripe').is(':checked')){
                                    disableBtn();
                                }else{
                                    enableBtn();
                                }
                                document.querySelector("#card-error").textContent = event.error ? event.error.message : "";
                                $cache.selectedStripeMethod = event.value.type;
                            });

                            $('#payment-processing-message').hide();

                            $('.form-item-panes-payment-payment-method .form-radio').on('click', function(e){
                                if(!$('#edit-panes-payment-payment-method-stripe').is(':checked')){
                                    enableBtn();
                                }
                            });

                            $('.form-item-panes-payment-payment-method .control-label').on('click', function(e){
                                if(!$('#edit-panes-payment-payment-method-stripe').is(':checked')){
                                    enableBtn();
                                }
                            });

                            $('.payment-continue')
                                .off('click.rovestripe')
                                .on('click.rovestripe',function(e) {
                                    if ($('[name="panes[payment][payment_method]"]:checked').val() === 'stripe'
                                        || $('[name="membership_payment"]').val() === 'stripe'
                                        || $('[name="terminal_payment"]').val() === 'stripe'
                                        || $('[name="swatch_payment"]').val() === 'stripe'
                                        || $('[name="quote_payment"]').val() === 'stripe') {
                                        e.preventDefault();
                                        $(this)
                                            .attr('disabled','disabled')
                                            .data('bgcolor',$(this).css('background-color'))
                                            .css('background-color', '#eee')
                                            .data('bdcolor',$(this).css('border-color'))
                                            .css('border-color', '#eee')
                                            .data('text',$(this).text())
                                            .css('cursor','not-allowed')
                                            .html('Processing...')
                                        ;
                                        let formId = 'uc_cart_checkout_form';
                                        if($('[name="membership_payment"]').val() === 'stripe'){
                                            formId = "uc_membership_enroll_payment_form";
                                        }else if( $('[name="terminal_payment"]').val() === 'stripe'){
                                            formId = "uc_stripe_payment_terminal";
                                        }else if( $('[name="swatch_payment"]').val() === 'stripe'){
                                            formId = "uc_swatch_payment_form";
                                        }else if( $('[name="quote_payment"]').val() === 'stripe'){
                                            formId = "uc_order_quote_payment_form";
                                        }

                                        const referralSource = $('#edit-panes-uc-referral-sources-uc-referral-sources-uc-referral-sources-rid').val();
                                        const referralOther = $('#edit-panes-uc-referral-sources-uc-referral-sources-uc-referral-sources-other').val();
                                        const referralAssociate = $('#edit-panes-uc-referral-sources-uc-referral-sources-uc-referral-sources-associate').val();

                                        // $('.legal-purchase-note').html('Please wait and do NOT close the browser or refresh the page during the payment processing.').css('color','red');
                                        // $('#payment-processing-message').show();
                                        // console.log('authorize button hit');
                                        // app.stripe.authorize();

                                        let adjustAmount = 0;
                                        if(typeof data.adjustAmount !== 'undefined' && data.adjustAmount > 0){
                                            adjustAmount = data.adjustAmount;
                                        }

                                        switch($cache.selectedStripeMethod) {
                                          case 'affirm':
                                            app.stripe.payAffirm(stripe, elements, data.clientSecret, data.address, data.name, data.email, data.orderId, data.customerId, data.level3, formId, adjustAmount, referralSource, referralOther, referralAssociate);
                                            break;
                                          case 'klarna':
                                            app.stripe.payKlarna(stripe, elements, data.clientSecret, data.address, data.name, data.email, data.orderId, data.customerId, data.level3, formId, adjustAmount, referralSource, referralOther, referralAssociate);
                                            break;
                                          case 'apple_pay':
                                          case 'google_pay':
                                          case 'card':
                                          default:
                                            app.stripe.pay(stripe, elements, data.clientSecret, data.address, data.name, data.customerId, data.level3, formId, adjustAmount, referralSource, referralOther, referralAssociate);
                                            break;
                                        }

                                        //app.stripe.payWithCard(stripe, card, data.clientSecret, data.customerId, formId, adjustAmount, referralSource, referralOther, referralAssociate);
                                        $(this).trigger('ajaxEnded');
                                    }
                                });

                            // $('#payment-processing-message').hide();

                            // var form = document.getElementById("uc-cart-checkout-form");
                            // form.addEventListener("submit", function(event) {
                            //         event.preventDefault();
                            //         // Complete payment when the submit button is clicked
                            //         payWithCard(stripe, card, data.clientSecret);
                            // });
                        }
                    }

                });

            } catch (e) {
                // Handle error. The loadPaymentReview~callback will have been called
                // with "{ show_form: false }" at this point.
                console.log(e);
            }
        },
        // Ajax calls this for updating
        updateOrder: function(data) {
            Drupal.settings.uc_stripe.orderId = data.orderId;
        },

        payAffirm: function(stripe, elements, clientSecret, address, name, email, orderId = null, customerId = null,  level3 = null, formId = '', adjustAmount = 0, referralSource = '', referralOther ='', referralAssociate=0)
        {
          stripe.confirmAffirmPayment(
            clientSecret,
            {
              payment_method: {
                // Billing information is optional but recommended to pass in.
                billing_details: {
                  email: email,
                  name: name,
                  address: {
                    postal_code: address.postalCode,
                    country: address.country,
                    state: address.state,
                    city: address.city,
                    line1: address.line1,
                    line2: address.line2
                  },
                },
              },

              // Return URL where the customer should be redirected after the authorization.
              return_url: app.util.getUri(window.location.href).protocol + '//' + app.util.getUri(window.location.href).host + '/uc_affirm/payment/complete/'+orderId,
            }
          ).then(function(result) {
            if (typeof result.error !== "undefined" && result.error) {
              // Show error to your customer
              app.stripe.showError(result.error);
            } else if (typeof result.paymentIntent !== "undefined" && (result.paymentIntent.status === 'succeeded' || result.paymentIntent.status === 'processing' || result.paymentIntent.status === 'requires_capture')) {
              // The payment succeeded!
              //app.stripe.orderComplete(result.paymentIntent, customerId, formId, adjustAmount, referralSource, referralOther, referralAssociate);
            } else {
              // Default error
              app.stripe.showError({
                code: "invalid",
                message: "Unknown error has occurred with Stripe",
                type: "validation_error"
              });
            }
          });
        },
        payKlarna: function(stripe, elements, clientSecret, address, name, email, orderId = null, customerId = null, level3 = null, formId = '', adjustAmount = 0, referralSource = '', referralOther ='', referralAssociate=0)
        {
          stripe.confirmKlarnaPayment(
            clientSecret,
            {
              payment_method: {
                billing_details: {
                  email: email,
                  name: name,
                  address: {
                    country: address.country,
                  },
                },
              },

              // Return URL where the customer should be redirected after the authorization.
              return_url: app.util.getUri(window.location.href).protocol + '//' + app.util.getUri(window.location.href).host + '/uc_klarna/payment/complete/'+orderId,
            }
          ).then(function(result) {
            if (typeof result.error !== "undefined" && result.error) {
              // Show error to your customer
              app.stripe.showError(result.error);
            } else if (typeof result.paymentIntent !== "undefined" && (result.paymentIntent.status === 'succeeded' || result.paymentIntent.status === 'processing' || result.paymentIntent.status === 'requires_capture')) {
              // The payment succeeded!
              //app.stripe.orderComplete(result.paymentIntent, customerId, formId, adjustAmount, referralSource, referralOther, referralAssociate);
            } else {
              // Default error
              app.stripe.showError({
                code: "invalid",
                message: "Unknown error has occurred with Stripe",
                type: "validation_error"
              });
            }
          });
        },

        pay: function(stripe, elements, clientSecret, address, name, customerId = null, level3 = null, formId = '', adjustAmount = 0, referralSource = '', referralOther ='', referralAssociate=0)
        {
          let configParams = {
            //return_url: 'https://example.com/order/123/complete',
            payment_method_data: {
              billing_details: {
                name: name,
                address: {
                  postal_code: address.postalCode,
                  country: address.country,
                  state: address.state,
                  city: address.city,
                  line1: address.line1,
                  line2: address.line2
                }
              }
            }
          };
          stripe.confirmPayment({
            elements,
            confirmParams: configParams,
            // Uncomment below if you only want redirect for redirect-based payments
            redirect: "if_required",
          }).then(function(result) {
            if (typeof result.error !== "undefined" && result.error) {
              // Show error to your customer
              app.stripe.showError(result.error);
            } else if (typeof result.paymentIntent !== "undefined" && (result.paymentIntent.status === 'succeeded' || result.paymentIntent.status === 'processing' || result.paymentIntent.status === 'requires_capture')) {
              // The payment succeeded!
              app.stripe.orderComplete(result.paymentIntent, customerId, formId, adjustAmount, referralSource, referralOther, referralAssociate);
            } else {
              // Default error
              app.stripe.showError({
                code: "invalid",
                message: "Unknown error has occurred with Stripe",
                type: "validation_error"
              });
            }
          });
        },

        // Calls stripe.confirmCardPayment
        // If the card requires authentication Stripe shows a pop-up modal to
        // prompt the user to enter authentication details without leaving your page.
        payWithCard: function(stripe, card, clientSecret, customerId=null, level3 = null, formId='', adjustAmount=0, referralSource='', referralOther='', referralAssociate=0) {
            app.stripe.loading(true);
            if(typeof referralSource === 'undefined'){
                referralSource = '';
            }
            if(typeof referralOther === 'undefined'){
                referralOther = '';
            }
            if(typeof referralAssociate === 'undefined'){
                referralAssociate = 0;
            }
            stripe
                .confirmCardPayment(clientSecret, {
                    payment_method: {
                        card: card
                    },
                    setup_future_usage: 'off_session'
                })
                .then(function(result) {
                    if (result.error) {
                        // Show error to your customer
                        app.stripe.showError(result.error);
                    } else {
                        // The payment succeeded!
                        app.stripe.orderComplete(result.paymentIntent, customerId, formId, adjustAmount, referralSource, referralOther, referralAssociate);
                    }
                });
        },

        createCheckoutLoader: function() {
          let $loadBtn = $('<button>',{
            class: 'truck-button'
          });
          $loadBtn.append(
            $('<span>',{
              class: 'default'
            })
              .text('Completing your purchase')
          );
          $loadBtn.append(
            $('<span>',{
              class: 'success'
            })
              .html('Success <svg viewbox="0 0 12 10"><polyline points="1.5 6 4.5 9 10.5 1"></polyline></svg><br/>Please wait <div class="loaderDotter"></div>')
          );
          $loadBtn.append(
            $('<div>',{
              class: 'truck'
            })
              .append($('<div>',{class:'wheel'}))
              .append($('<div>',{class:'back'}))
              .append($('<div>',{class:'front'}))
              .append($('<div>',{class:'box'}))
          );
          $('body').prepend($('<div>',{class:'completeOrderLoader hidden'}).append($loadBtn));
        },

        runCheckoutLoader: function() {
          scrollTo(0,0);
          document.querySelector(".completeOrderLoader").classList.remove("hidden");

          let button = document.querySelector('.truck-button'), box = button.querySelector('.box'),
            truck = button.querySelector('.truck');
          button.classList.remove('done');
          button.classList.add('animation');

          gsap.to(button, {
            '--box-s': 1,
            '--box-o': 1,
            duration: .3,
            delay: .5
          });
          gsap.to(box, {
            x: 0,
            duration: .4,
            delay: .7
          });

          gsap.to(button, {
            '--hx': -5,
            '--bx': 50,
            duration: .18,
            delay: .92
          });

          gsap.to(box, {
            y: 0,
            duration: .1,
            delay: 1.15
          });

          gsap.set(button, {
            '--truck-y': 0,
            '--truck-y-n': -26
          });

          gsap.to(button, {
            '--truck-y': 1,
            '--truck-y-n': -25,
            duration: .2,
            delay: 2.25,
            onComplete() {
              gsap.timeline({
                onComplete() {
                  button.classList.add('done');
                }
              }).to(truck, {
                x: 0,
                duration: .4
              }).to(truck, {
                x: 40,
                duration: 1
              }).to(truck, {
                x: 20,
                duration: .6
              }).to(truck, {
                x: 196,
                duration: .4
              });
              gsap.to(button, {
                '--progress': 1,
                duration: 4.4,
                ease: "power2.in"
              });
            }

          });
        },

        // Shows a success message when the payment is complete
        orderComplete: function(paymentIntent, customerId=null, formId='', adjustAmount=0, referralSource='', referralOther='', referralAssociate=0) {
            app.stripe.loading(false);
            app.stripe.createCheckoutLoader();
            app.stripe.runCheckoutLoader();

            document.querySelector(".result-message").classList.remove("hidden");

            processingBtn();
            if(typeof paymentIntent.customer !== 'undefined' && paymentIntent.customer){
                customerId = paymentIntent.customer;
            }
            var amount = paymentIntent.amount/100;
            if(typeof paymentIntent.amount_received !== 'undefined' && paymentIntent.amount_received){
                amount = paymentIntent.amount_received/100;
            }

            let url = "/uc_stripe/payment/complete/"+$cache.orderId;
            if(formId === 'uc_membership_enroll_payment_form'){
                url = "/user/membership/payment_complete/"+$cache.orderId;
            }else if(formId === 'uc_stripe_payment_terminal'){
                url = "/uc_stripe/terminal/complete/"+$cache.orderId;
            }else if(formId === 'uc_swatch_payment_form'){
                url = "/user/swatch/payment_complete/"+$cache.orderId;
            }else if(formId === 'uc_order_quote_payment_form'){
                url = "/user/quote/payment_complete/"+$cache.orderId;
            }

            fetch(url, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json"
                },
                body: JSON.stringify({
                  amount:amount,
                  paymentIntentId: paymentIntent.id,
                  paymentMethodId: paymentIntent.payment_method,
                  status: paymentIntent.status,
                  customerId:customerId,
                  adjustAmount:adjustAmount,
                  referralSource:referralSource,
                  referralOther:referralOther,
                  referralAssociate:referralAssociate
                })
            })
            .then(function(result) {
                return result.json();
            })
            .then(function(data) {
                if(data.success){
                    // console.log('success');
                    window.location.href = data.url;
                }else{
                    console.log(data);
                }
            });
            // $.getJSON('/uc_stripe/payment/complete/'+$cache.orderId,{amount:amount, paymentIntentId: paymentIntent.id, paymentMethodId: paymentIntent.payment_method, customerId:customerId},function(data) {
            //     if(data.success){
            //         // console.log(data);
            //         window.location.href = data.url;
            //     }else{
            //         console.log('Stripe finalizing ajax failed.');
            //     }
            // });
            // var url = "https://testteam.roveconcepts.com/uc_stripe/payment/complete/"+$cache.orderId+"?amount="+amount+"&paymentIntentId="+paymentIntent.id+"&paymentMethodId="+paymentIntent.payment_method+"&customerId="+customerId;
            // $(location).attr('href',url);
        },
        // Show the customer the error from Stripe if their card fails to charge
        showError: function(response) {
            errorMsgText = response.message;
            app.stripe.loading(false);
            var errorMsg = document.querySelector("#card-error");
            errorMsg.textContent = errorMsgText;
            setTimeout(function() {
                errorMsg.textContent = "";
            }, 4000);
            let url = "/uc_stripe/payment/declined/"+$cache.orderId;
            fetch(url, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json"
                },
                body: JSON.stringify({response:response})
            })
                .then(function(result) {
                    return result.json();
                })
                .then(function(data) {
                    if(data.success){
                        // console.log('success');
                        // window.location.href = data.url;
                    }else{
                        console.log(data);
                    }
                });


        },
        // Show a spinner on payment submission
        loading: function(isLoading) {
            if (isLoading) {
                // Disable the button and show a spinner
                enableBtn();
                // disableBtn();
                // document.querySelector("#spinner").classList.remove("hidden");
                // document.querySelector("#button-text").classList.add("hidden");
            } else {
                enableBtn();
                // document.querySelector("#spinner").classList.add("hidden");
                // document.querySelector("#button-text").classList.remove("hidden");
            }
        },

    }
}(window.app = window.app || {}, jQuery));
/*!
 * app.cart.js
 */
(function (app, $) {
	let $cache = {};

	function initializeCache() {
		$cache.updateTimer = null;
	}

	function initializeDom() {

	}

	function initializeEvents() {
		$('.qty button').on('click',function(e) {
			e.preventDefault();
			var type = $(this).data('type');
			var fieldname = $(this).data('field');
			var field = $('[name="' + fieldname + '"]');
			var newVal;
			if(isNaN(field.val())) {
				return false;
			}
			switch(type) {
				case 'minus': {
					if(field.val()) {
						newVal = parseInt(field.val()) - 1;
						field.val(newVal);
					}
					break;
				}
				case 'plus': {
					newVal = parseInt(field.val()) + 1;
					field.val(newVal);
				}
			}
			field.trigger('change');
		});

		$('.remove-coupon-link').on('click.remove-coupon', function(e) {
			e.preventDefault();
			var item_id = $(this).data('item');
			var $field = $('#edit-items-'+item_id+'-remove');
			if ($field.length) {
				$field.trigger('click');
				$(document).trigger('coupon',['remove',$(this).parents('.discount').attr('id').replace('coupon-','')]);
			}
		});

		$('#uc-cart-view-form input.form-text').on('change', function(e) {
			e.preventDefault();
			let $this = $(this);
			if(isNaN($this.val())) {
				return false;
			}

			clearTimeout($cache.updateTimer);

			let itemId = $this.attr('id').split("-")[2];
			$cache.updateTimer = setTimeout(function() {
				$('#edit-items-' + itemId + '-update-qty').mousedown();
				$('.cart_loader').css('display', 'block');
			}, 700);
		});

		$('#uc-cart-view-form input.form-text').on('keydown',function(e) {
			if(e.keyCode === 13) {
				let $this = $(this);
				e.preventDefault();
				$this.blur();
				clearTimeout($cache.updateTimer);
				let itemId = $this.attr('id').split("-")[2];
				$('#edit-items-' + itemId + '-update-qty').mousedown();
				$('.cart_loader').css('display', 'block');
			}
		});

		$('.edit-qty').on('click',function(e) {
			e.preventDefault();
			let $this = $(this).parents('.cart_row, tr');
			$this.find('.qty-text').hide();
			$this.find('.form-type-uc-quantity, button').show();
		});


		$(document).on('click','#checkout-extra-btn',function(e) {
			e.preventDefault();
			let $extra_btn = $(this);
			if ($('#uc_cart_custom').length && !$('#uc_cart_custom').hasClass('ignore')) {
				// Custom form needs to show first
				if (!$('#uc_cart_custom').is(':visible') && $('#edit-agree').prop('checked') === false) {
					$('.cart_overview').addClass('custom-form-display');
					// Show form
					if (!app.isMobile()) {
						$('#uc_cart_custom').show();
						$.colorbox({escKey:false, closeButton:false, inline:true, href:'#uc_cart_custom', 'width':"700px",'height':"770px",'overlayClose':false,opacity:0.4});
					} else {
						// Hide table
						$('#cart-form-pane table, #cart-form-pane .cart-products, #cart-form-pane .cart_display, .cart_overview').hide();
						$('#uc_cart_custom').show(function(){
							//doScrollTo('uc_cart_custom',0);
							app.components.doScrollTo('#uc_cart_custom', 0, 500);
						});
					}
					$extra_btn.addClass('disabled');
					return;
				}
			}
			// Show loader
			app.components.linkLoader($(this));

			$('#cart-form-pane #edit-actions .btn-default').trigger('click');
		});

		$('#uc_cart_custom').on('click','#cart-custom-agree-button',function(){
			$.colorbox.close();
			$('#uc_cart_custom').hide();
			$('#edit-agree').prop('checked',true);
			$('#cart-form-pane table, #cart-form-pane .cart-products, #cart-form-pane .cart_display, .cart_overview').show();
			$('#uc_cart_custom').trigger('change');
		});

		$('#uc_cart_custom').on('click','#cart-custom-back-link',function(){
			$('#edit-agree').prop('checked',false);
			$('#checkout-extra-btn').removeClass('disabled');
			if (!app.isMobile()) {
				$('#uc_cart_custom').hide();
				$('#cart-form-pane table, #cart-form-pane .cart-products, #cart-form-pane .cart_display, .cart_overview').show();
				$.colorbox.close();
			} else {
				$('#cart-form-pane table, #cart-form-pane .cart-products, #cart-form-pane .cart_display, .cart_overview').show();
				$('#uc_cart_custom').hide();
			}

		});
		$('#uc_cart_custom').on('change.agreecustom',function() {
			$('#checkout-extra-btn').removeClass('disabled').trigger('click');
		});

	}

	app.cart = {

		init: function() {
			initializeCache();
			initializeDom();
			initializeEvents();

      //Member info popup
      app.components.memberInfo();
		}

	};

}(window.app = window.app || {}, jQuery));
/*!
 * app.ui.validator.js
 */
(function(app, $) {

	app.validator = {
		regex: {
			phone: {
				na: /^\(?([2-9][0-8][0-9])\)?[\-\. ]?([2-9][0-9]{2})[\-\. ]?([0-9]{4})(\s*x[0-9]+)?$/,
				us: /^\(?([2-9][0-8][0-9])\)?[\-\. ]?([2-9][0-9]{2})[\-\. ]?([0-9]{4})(\s*x[0-9]+)?$/,
				ca: /^\(?([2-9][0-8][0-9])\)?[\-\. ]?([2-9][0-9]{2})[\-\. ]?([0-9]{4})(\s*x[0-9]+)?$/
			},
			pobox: /\bp*(ost)*\.*\s*[o|0]*(ffice)*\.*\s*b[o|0]x\b/,
			postal: {
				us: /^\d{5}(-\d{4})?$/,
				ca: /^([ABCEGHJKLMNPRSTVXY]|[abceghiklmnprstvxy]){1}\d{1}([A-Z]|[a-z]){1} *\d{1}([A-Z]|[a-z]){1}\d{1}$/,
				gb: /^GIR?0AA|[A-PR-UWYZ]([0-9]{1,2}|([A-HK-Y][0-9]|[A-HK-Y][0-9]([0-9]|[ABEHMNPRV-Y]))|[0-9][A-HJKS-UW])?[0-9][ABD-HJLNP-UW-Z]{2}$/
			},
			email: /^[\w.%+\-]+@[\w.\-]+\.[\w]{2,6}$/
		},
		init: function() {
			//("form:not(.suppress)").each(function() {
			//	$(this).validate(app.validator.settings);
			//});
		},

		validatePhone: function(value, country) {
			if (country.length === 0 || !app.validator.regex.phone[country.toLowerCase()]) {
				return true;
			}

			let rgx = app.validator.regex.phone[country.toLowerCase()];
			return rgx.test($.trim(value));
		},

		validateNoPoBox: function(value) {
			return !app.validator.regex.pobox.test($.trim(value.toLowerCase()));
		},

		validatePostal: function(value, country) {
			if (country.length === 0 || !app.validator.regex.postal[country.toLowerCase()]) {
				return true;
			}

			let rgx = app.validator.regex.postal[country.toLowerCase()];
			return rgx.test($.trim(value));
		},

		validateEmail: function(value) {
			return app.validator.regex.email.test($.trim(value));
		},

		validatePasswordLength: function(value) {
			return !(value.length <= 4);
		},

		validateMessageLength: function(value) {
			return (value.length <= 5000);
		},

		validatePasswordMatch: function(value, value2) {
			return value === value2;
		}
	};
}(window.app = window.app || {}, jQuery));/*!
 * app.gaa.js
 */
(function (app, $) {
	let $cache = {
		isCheckout: false,
		isCart: false,
		debug: false,
		windowLoading: false,
    elevarUserInformation: false,
    elevarLastEvent: false
	};

	app.enhancedEcommerce = {
		// Enhanced Ecommerce Data Values
		impression: function (product) {
			if (typeof product.google_business_vertical === 'undefined') {
				product.google_business_vertical = 'retail';
			}
			if (typeof product.brand === 'undefined') {
				product.brand = 'Rove Concepts';
			}
			return product;
		}
	};

	function initializeCache() {
		$cache.document = $(document);

		// Identify where we are
		$cache.isCart = app.util.getUri(window.location.href).path === '/cart';
		$cache.isCheckout = app.util.getUri(window.location.href).path.indexOf('/cart/checkout') !== -1;
		$cache.debug = $.cookie('trackDebug') ? $.cookie('trackDebug') : false;

		// Keep track of passed events
		$cache.steps = [];  // TODO: if necessary
	}

	function initializeEvents() {
		// Events passed in from PHP (track.inc)
		for (let k in Drupal.settings.track.events) {
			app.tracking.track(k, Drupal.settings.track.events[k]);
		}

		// Dynamic Remarketing
		//app.tracking.track('page_view', Drupal.settings.track.remarketing);

		// Trigger list view if not category page but a listing is present
    /*
		if (typeof Drupal.settings.track.events['viewCategory'] === 'undefined'
				&& $('.product_listing').length) {
			// Emulate a category view if there are product listings
			app.tracking.track('viewCategory', {
				tid: null,
				name: Drupal.settings.track.events['view']['page_title'],
				label: 'product_impression_re',
				items: []
			});
		}
     */

		// Conversions passed in from PHP (track.inc)
		for (let k in Drupal.settings.track.conversions) {
			app.tracking.conversion(k, Drupal.settings.track.conversions[k]);
		}

		/**
		 * Call this function when a user clicks on a product link. This function uses the event
		 * callback datalayer variable to handle navigation after the ecommerce data has been sent
		 * to Google Analytics.
		 * @param {Object} productObj An object representing a product.
		 */
		//$('a[data-pnid], div[data-pnid]').off('click.gtm');
		$(document).on('click', 'a[data-pnid], div[data-pnid]', function (e) {
			let $this = $(this);
			//e.preventDefault();
			app.tracking.clickProduct(Drupal.settings.track.pageItems[$this.data('pnid')], $this);
		});

		/**
		 * Handles clicks to add to cart
		 * Measure adding a product to a shopping cart by using an 'add' actionFieldObject
		 * and a list of productFieldObjects.
		 */
		//$('.node-add-to-cart').off('click.gtm');
		$('.node-add-to-cart').on('mousedown.gtm', function () {
			let nid = $('.add-to-cart>form').attr('id').replace(/[^0-9]+/, '');
			let product = typeof Drupal.settings.track.items[parseInt(nid)] !== 'undefined' ? Drupal.settings.track.items[parseInt(nid)] : [];
			let variant = app.product.getSelectedModel(app.product.getSelectedOptions());
			if (product.length === 0) {
				// Exit as info isnt available... maybe throw exception
				return;
			}
			product['price'] = typeof Drupal.settings.models_stock[variant].p !== 'undefined' ? Drupal.settings.models_stock[variant].p : product.price;
			product['variant'] = variant;
			product['quantity'] = $('.form-type-uc-quantity>input, .form-item-qty>select :selected').val();

			app.tracking.addToCart(product);

			// Google Ads conversions
      if (app.tracking.isGA4LocalEnabled()) {
        app.tracking.conversion('add_to_cart', {'send_to': 'AW-1016437901/piAxCM2S8WgQjbnW5AM'});
        app.tracking.conversion('add_to_cart', {'send_to': 'AW-11062140594/r3UhCJeQtbcYELK965op'}); // Dynamic
        app.tracking.conversion('add_to_cart', {'send_to': 'AW-11062140594/Y9AxCJyLg5AYELK965op'});
      }
    });

		/**
		 * A function to handle a click on a checkout button. This function uses the eventCallback
		 * data layer variable to handle navigation after the ecommerce data has been sent to Google Analytics.
		 */
		//$('.r-cart-checkout>a, #cart-form-pane #edit-actions .btn-default').off('click.checkout');
		$cache.document.on('click.checkout', 'a.r-cart-checkout, #cart-form-pane #edit-actions .btn-default', function (e) {
			if ($(this).hasClass('checkout') && !$('#edit-agree').is(':checked')) {
				return true;
			}
			//e.preventDefault();

			// Show loader
			app.components.linkLoader($(this));

			//app.tracking.checkoutClick(Drupal.settings.track.cart);
		});

    /**
     * Get directions is clicked.
     */
    $cache.document.on('directionsClicked', function (e, location) {
      app.tracking.track('directionsClicked', {location: location});
    });

		/**
		 * Add/Remove to wishlist (Triggered from doLove() in app.components
		 */
		$cache.document.on('wishlist', function (e, addOrRemove, nid, op, email, $ele) {
			let product;
			if (typeof Drupal.settings.track.pageItems[parseInt(nid)] !== 'undefined') {
				product = Drupal.settings.track.pageItems[parseInt(nid)];
			} else {
				for (let k in Drupal.settings.track.items) {
					if (parseInt(Drupal.settings.track.items[k].nid) === parseInt(nid)) {
						product = Drupal.settings.track.items[k];
					}
				}
			}
			app.tracking.wishlist(addOrRemove, product);
		});

		if ($cache.isCart || $cache.isCheckout) {
			/**
			 * Cart changing quantity
			 */
			$('.qty button').on('click.track', function (e) {
				let $this = $(this);
				let product = Drupal.settings.track.cart.items[parseInt($this.data('id'))];
				switch ($this.data('type')) {
					case 'minus':
						//product.quantity = parseInt(product.quantity) - 1;
						product.quantity = 1; // only 1 removed for event tracking
						app.tracking.removeFromCart(product);
						break;
					case 'plus':
						//product.quantity = parseInt(product.quantity) + 1;
						product.quantity = 1; // only 1 added for event tracking
						app.tracking.addToCart(product);
						break;
				}
			});

			/**
			 * Remove from cart
			 */
			$cache.document.on('click.track', '.item_remove .btn-danger, .cart-remove>button', function (e) {
				let pos = parseInt($(this).attr('name').replace('remove-', ''));
				let product = Drupal.settings.track.cart.items[pos];
				app.tracking.removeFromCart(product);
			});

			/**
			 * Add/Remove Coupon
			 */
			$cache.document.on('coupon', function (e, addOrRemove, coupon) {
				app.tracking.coupon(addOrRemove, coupon);
			});

			/**
			 * Add coupon form
			 */
			$('#uc-coupon-form [name="uc-coupon-apply"]').on('click', function (e) {
				app.tracking.coupon('add', $('#uc-coupon-form [name="code"]').val());
			});

			/**
			 * Checkout errors will be reported in app.checkout.js when clicking submit button
			 */
			$cache.document.on('checkoutError', function (e, message) {
				app.tracking.track('checkoutError', {message: message});
			});

			/**
			 * Email myself the cart was completed.
			 */
			$cache.document.on('emailCartComplete', function (e, data) {
				app.tracking.track('emailCart', {data: data});
			});
		}

		/**
		 * Swatch option was selected on product page
		 */
		$cache.document.on('pre_product_change', function (e, oid, material_name, model) {
			app.tracking.track('swatchDisplayed', {
				oid: oid,
				material_name: material_name,
				model: model
			});
		});

		/**
		 * Act on country changes
		 */
		$cache.document.on('changeCountry', function (e, country) {
			app.tracking.track('changeCountry', country);
		});

		/**
		 * Act on form submissions (taken from logic of app.klaviyo.js
		 */
		$cache.document.on('formEvent', function (e, form) {
			app.tracking.formTrackEvent(form);
		});

		/**
		 * If form events already occurred, call them
		 */
		if (typeof app.eventQueue['formEvent'] !== 'undefined') {
			app.tracking.formTrackEvent(app.eventQueue['formEvent']);
		}

		/**
		 * Free swatches on product page was clicked.
		 */
		$('.get-swatches').on('click', function (e) {
			app.tracking.track('freeSwatches', [Drupal.settings.track.events.viewProduct.name]);
		});

		/**
		 * SnapEngage chat
		 */
		//app.tracking.chat();
	}

	function initializeDom() {
		// Page load vars passed in from PHP (track.inc)
		for (let k in Drupal.settings.track.page_load) {
			if (Drupal.settings.track.page_load.hasOwnProperty(k)) {
				app.tracking.track(k, Drupal.settings.track.page_load[k]);
			}
		}

    // Setup predefined 'set' variables
    if (typeof Drupal.settings.track.set !=='undefined' &&
      Object.keys(Drupal.settings.track.set).length &&
      typeof gtag !== 'undefined') {
      gtag('set', Drupal.settings.track.set);
    }

    // Setup predefined 'set' variables
    if (typeof Drupal.settings.track.userData !=='undefined' &&
      Object.keys(Drupal.settings.track.userData).length &&
      typeof gtag !== 'undefined') {
      gtag('set', 'user_data', Drupal.settings.track.userData);
    }

		// append all product views
		$('[data-pnid]').each(function () {
			let $ele = $(this);
      app.tracking.addProductFromPNID($ele);
		});
    app.tracking.setProductPageItems();
	}

	app.tracking = {

    ga4_enabled: $('body').attr('data-ga4') === 'true',
    pinterest_enabled: $('body').attr('data-pintrk') === 'true',
	initialized: false,
	pinterest_customer_id: '2620995540341',
	facebook_catalog_id: app.getCountry() === 'US' ? '748002085342486' : '268341670194198',
	facebook_default_pixel_id: '872502959494934',
	facebook_rora_pixel_id: '475702469821499',
	quantcast_id: 'p-jfb_8TamccbYW',
	podsights_id: '939e0f8bcc6d4c56905b4c6d8a3a49c0',

	init: function () {
		initializeCache();
		initializeDom();

		// Store gclid
		app.tracking.gclid();

		// Track initial landing page
		app.tracking.initUrl();

		// Start tracking elevar elements
		app.tracking.elevarInit();

		app.tracking.adsCampaignType();

		if ($.inArray('nogtm',Object.keys(app.util.getQueryStringParams(window.location.search))) === -1) {
        		//app.tracking.pinterest_enabled = app.tracking.getCookie('pinterest_enable') !== "0";

				// Enable Pinterest tracker (Before events incase of static..)
				if (app.tracking.pinterest_enabled) {
				  app.tracking.pinterestPayload();
				}

				// Enable Quantcast tracking
				//app.tracking.quantcastPayload();

				// Enable Podsigns tracking
				app.tracking.podsightsPayload();

				// Enable SnapEngage live chat
				// app.tracking.snapEngagePayload();

				// Enable freshdesk live chat
				 app.tracking.freshdeskPayload();
			}

			initializeEvents();

			// Track that this has been initialized
			app.tracking.initialized = true;
		},

    addProductFromPNID: function($ele) {
      let nid = $ele.data('pnid');
      // only do this if we need to
      if (typeof Drupal.settings.track.pageItems[nid] !== 'undefined') {
        return;
      }
      let title = typeof $ele.data('title') !== 'undefined' ? $ele.data('title') : $ele.attr('title');
      let category = typeof $ele.data('category') !== 'undefined' ? $ele.data('category') : $ele.attr('category');
      let categories = typeof category !== 'undefined' && category.length > 0 ? category.split(' > ') : [];
      let id = typeof $ele.data('sku') !== 'undefined' ? $ele.data('sku') : nid;
      let price = typeof $ele.data('price') !== 'undefined' ? $ele.data('price') : '0.00';
      let fullsku = typeof $ele.data('fsku') !== 'undefined' ? $ele.data('fsku') : id;
      let gsku = typeof $ele.data('gsku') !== 'undefined' ? $ele.data('gsku') : fullsku;
      let $img = $ele.find('.product_image').length ? $ele.find('.product_image') : $ele.parents('.product_listing').find('.product_image');
      if ($img.length === 0) {
        // try from search results
        $img = $ele.find('img').parent();
      }
      let image = $img.find('img').attr('src') ? $img.find('img').attr('src') : $img.find('img').data('src');
      let url = $ele.attr('href');
      let catpath = $ele.data('catpath') !== 'undefined' ? $ele.data('catpath') : '/home';
      if (typeof Drupal.settings.track.pageItems[nid] === 'undefined' && typeof title !== 'undefined') {
        Drupal.settings.track.pageItems[nid] = {
          'item_id': id,
          'item_name': title,
          'price': price,
          'item_brand': 'Rove Concepts',
          //'item_category': category,
          //'item_variant': '',
          'parent': id,
          'index': Object.keys(Drupal.settings.track.pageItems).length,
          'fsku': fullsku,
          'gsku': gsku,
          'nid': nid,
          'image': image,
          'url': url,
          'catpath': catpath
        };
        for(let x = 0; x < categories.length; x++) {
          Drupal.settings.track.pageItems[nid]['item_category'+(x>0?x:'')] = categories[x];
        }
      }
    },

    setProductPageItems: function() {
      Drupal.settings.track.pageItems = app.tracking.remarketing(Drupal.settings.track.pageItems);
    },

    isGA4LocalEnabled: function() {
      return app.tracking.ga4_enabled;
    },

    gclid: function() {
      // Store gclid as cookie
      if (window.location.href.indexOf('gclid') > 0) {
        let gclidParams = app.util.getQueryStringParams(window.location.href);
        if (gclidParams.hasOwnProperty('gclid')) {
          $.cookie('gclid', gclidParams.gclid, {
            expires: 90,
            path: '/',
            domain: '.'+app.util.getUri(window.location.href).host.replace('www.','')
          });
        }
      }
    },

    getGclid: function() {
      return $.cookie('gclid');
    },

    initUrl: function() {
      // Store gclid as cookie
      //if (!app.tracking.getInitUrl() && app.util.getUri(document.referrer)['host'] !== app.util.getUri(window.location.href)['host']) { // Doesnt work because varnish redirects the request setting local referrer
      if (!app.tracking.getInitUrl()) {
        let urlInit = app.util.getUri(window.location.href);
        if (urlInit.hasOwnProperty('urlWithQuery')) {
          $.cookie('initurl', urlInit.urlWithQuery, {
            expires: 90,
            path: '/',
            domain: '.'+urlInit.host.replace('www.','')
          });
        }
      }
    },

    getInitUrl: function() {
      return $.cookie('initurl');
    },

    adsCampaignType: function() {
      if (window.location.href.indexOf('campaign_type') > 0) {
        // Is there an existing (initial) campaign? If not, save it to a cookie
        if (app.tracking.getAdsCampaignType() === null || app.tracking.getAdsCampaignType().length > 0) {
          let gclidParams = app.util.getQueryStringParams(window.location.href);
          if (gclidParams.hasOwnProperty('campaign_type')) {
            $.cookie('campaign_type', gclidParams.campaign_type, {
              expires: 90,
              path: '/',
              domain: '.' + app.util.getUri(window.location.href).host.replace('www.', '')
            });
          }
        }
      }
    },

    getAdsCampaignType: function() {
      return $.cookie('campaign_type');
    },

    isConversionBranded: function() {
      return app.tracking.getAdsCampaignType() === 'branded'
    },

    isConversionGeneric: function() {
      return app.tracking.getAdsCampaignType() !== 'branded'
    },

		track: function (eventName, eventArgs) {
			// Call the actual event requested
			if (typeof app.tracking[eventName] !== 'undefined') {
				app.tracking[eventName].apply(this, [eventArgs]);
			}
		},

		conversion: function (conversion_name, params) {
      //if (!app.tracking.isGA4LocalEnabled()) {
      //  alert('Conversion fired when it shouldnt have! ' + conversion_name);
      //}
			app.tracking.gtag('event', 'conversion', params);
		},

		// Simple function to add remarketing info to item events
		remarketing: function (items) {
			for (let k in items) {
				if (typeof items[k].google_business_vertical === 'undefined') {
					items[k].google_business_vertical = 'retail';
				}
			}
			return items;
		},

    // Get the tracked user...
    userid: function(params) {
      // attach user_id to all request if applicable
      if ($.cookie('userTrack')) {
        return $.cookie('userTrack');
      } else if (typeof Drupal.settings.track.user.hash !== 'undefined' && typeof params.user_id === 'undefined') {
        return Drupal.settings.track.user.hash;
      }
      return false;
    },

    // Get the tracked user...
    useremail: function(params) {
      // attach user_id to all request if applicable
      if ($.cookie('userTrackEmail')) {
        return $.cookie('userTrackEmail');
      } else if (typeof Drupal.settings.track.user.mail !== 'undefined' && typeof params.user_id === 'undefined') {
        return Drupal.settings.track.user.mail;
      }
      return false;
    },

		// Lets put all gtag calls through a wrapper first in case we want to alter
		gtag: function (type, event, params) {
			if (typeof gtag === 'undefined') {
        if (app.tracking.isGA4LocalEnabled()) {
          console.log('GTAG Not initiated.');
          if (typeof params.event_callback !== 'undefined' && params.event_callback !== null) {
            params.event_callback();
          }
        } else {
          app.tracking.dataLayerPush(type,event,params);
        }
				return;
			}
			if ($cache.debug) {
				console.log('GTAG Type: ' + type);
				console.log('GTAG Event: ' + event);
				console.log('GTAG Params:');
				console.log(params);
			}
			if (typeof params !== 'undefined') {
				if (event !== 'conversion') {
					// attach user_id to all request if applicable
					let userid = app.tracking.userid(params);
					if (userid) {
						params.user_id = userid;
					}
				}
				gtag(type, event, params); // event typically
			} else {
				gtag(type, event);  // set, etc
			}
		},

    // GTM handles events this way
    dataLayerPush: async function(type, event, params) {
      dataLayer.push(arguments);

      if (type === 'event' && typeof window.ElevarDataLayer !== 'undefined') {
        let eventData = app.tracking.elevarEvents(type,event,params)
          .then(function (data) {
            if (typeof data !== 'undefined') {
              $cache.elevarLastEvent = app.tracking.elevarGetLastEvent();
              //console.log('Last event: ' + $cache.elevarLastEvent);
              switch (Array.isArray(data)) {
                case true:
                  for(let i=0;i<data.length;i++) {
                    // Ensure we dont send this consecutively - slip if sent last
                    // dl_subscribe is sent from Elevar, so this breaks our logic of tracking last event
                    // Just send always instead
                    //console.log('Event Loop: ' + data[i].event);
                    if ($cache.elevarLastEvent !== data[i].event) {
                      window.ElevarDataLayer.push(data[i]);
                    }
                  }
                  break;
                case false:
                default:
                  //console.log('Event Single: ' + data.event);
                  window.ElevarDataLayer.push(data);
                  break;
              }
            }
          });
      }
    },

    elevarInit: function() {
      // Product page item list
      app.components.onElementInView('.block-uc-display, .top-collect-list-cont',function(element) {
        let $ele = $(element);

        let pageItems = app.tracking.getCategoryItems();
        let items = pageItems.items;

        // Emulate a category view if there are product listings
        app.tracking.track('viewCategory', {
          tid: null,
          name: Drupal.settings.track.events['view']['page_title'],
          label: 'product_impression_re',
          items: []
        });

        /*
        app.tracking.dataLayerPush('event','view_item_list',{
          'item_list_id': 'related_products',
          'item_list_name': 'Related Products',
          'items': app.tracking.limit(app.tracking.remarketing(app.tracking.modifyProducts(items,'google')),4)
        });
         */
      },{});
    },

    elevarGetLastEvent: function() {
      let lastEvent = '';
      for (let i = 0; i < window.ElevarDataLayer.length; i++) {
        if (window.ElevarDataLayer[i].hasOwnProperty('event')) {
          lastEvent = window.ElevarDataLayer[i].event;
        }
      }
      return lastEvent;
    },

    elevarEvents: async function(type, event, params) {
      /**
       * Base Events
       * dl_user_data
       *
       * Account Management Events
       * dl_sign_up
       * dl_login
       *
       * Ecommerce Funnel Events
       * dl_view_item_list
       * dl_view_search_results
       * dl_select_item
       * dl_view_item
       * dl_add_to_cart
       * dl_remove_from_cart
       * dl_view_cart
       *
       * Checkout Funnel Events
       * dl_begin_checkout
       * dl_add_shipping_info
       * dl_add_payment_info
       * dl_purchase
       *
       * Subscribe Events
       * dl_subscribe
       */
      let userProperties = await app.tracking.elevarTransformUser();
      //await app.tracking.elevarTransformUser().then(function(userProperties) {
        let dl_index = 1;
        let dl_impressions = [];
        let dl_products = [];
        if (typeof params.items !== 'undefined') {
          for(let i in params.items) {
            if (params.items.hasOwnProperty(i)) {
              dl_impressions.push(app.tracking.elevarTransformImpression(params.items[i],event,params.item_list_id,dl_index,false))
              dl_products.push(app.tracking.elevarTransformImpression(params.items[i],event,params.item_list_id,dl_index,true))
              dl_index++
            }
          }
        }

        switch(event) {
          case 'login':
            return {
              event: "dl_login",
              user_properties: userProperties
            }
          case 'user_data':
          case 'page_view':
            return {
              event: "dl_user_data",
              cart_total: Drupal.settings.track.cart.value.toString(),
              user_properties: userProperties, // See user properties object below
              ecommerce: {
                currencyCode: app.getCurrency(),
                cart_contents: {
                  products: dl_products // See the products array below
                }
              }
            }
          case 'Newsletter':
            return {
              event: "dl_subscribe",
              lead_type: "email", // should be "email" or "phone"
              user_properties: {
                customer_email: typeof params['#email'] == 'object' ? params['#email'].email : params['#email'],
                //customer_phone: "..."
              }
            }
          case 'dl_sign_up':
            break;
          case 'dl_login':
            break;
          case 'view_item_list':
            return {
              event: "dl_view_item_list",
              user_properties: userProperties,
              ecommerce: {
                currencyCode: app.getCurrency(),
                impressions: dl_impressions,
              }
            }
          case 'view_item':
            return [
              // dl_user
              await app.tracking.elevarEvents('event','user_data',params),
              // dl_view_item
              {
                event: "dl_view_item",
                user_properties: userProperties,
                ecommerce: {
                  currencyCode: app.getCurrency(),
                  detail: {
                    actionField: {
                      list: app.util.getUri(document.referrer)['path'], // this should be the collection page URL that user clicked product from
                      action: "detail"
                    },
                    "products": dl_products
                  }
                }
              }
            ];
          case 'select_item':
            let curPath = app.util.getUri(document.location.href)['path'];

            // We want to keep track of where customers initially clicked on a product (list)
            let productHistoryUrl = app.tracking.elevarGetProductTrackingValue(dl_products[0].id);
            if (productHistoryUrl === null) {
              productHistoryUrl = curPath;
              app.tracking.elevarSetProductTrackingUrl(dl_products[0].id,productHistoryUrl);
            }
            return {
              event: "dl_select_item",
              user_properties: userProperties,
              ecommerce: {
                currencyCode: app.getCurrency(),
                click: {
                  actionField: {
                    list: curPath, // this should be the collection page URL
                    action: "click"
                  },
                  products: dl_products
                }
              },
            }
          case 'view_search_results':
            // dl_user must fire before dl_view_search_results
            return [
              // dl_user
              await app.tracking.elevarEvents('event','user_data',params),
              // dl_view_search_results
              {
                event: "dl_view_search_results",
                user_properties: userProperties,
                ecommerce: {
                  currencyCode: app.getCurrency(),
                  actionField: {
                    "list": "search results"
                  },
                  impressions: dl_impressions,
                }
              }
            ];
          case 'view_cart':
            // ammend quantity
            // dl_user must fire before dl_view_cart
            return [
              // dl_user
              await app.tracking.elevarEvents('event','user_data',params),
              // dl_view_cart
              {
                event: "dl_view_cart",
                user_properties: userProperties,
                cart_total: params.value.toString(),
                ecommerce: {
                  currencyCode: app.getCurrency(),
                  actionField: {
                    list: 'Shopping Cart'
                  },
                  impressions: dl_impressions,
                }
              }
            ];
          case 'add_to_cart':
            return {
              event: "dl_add_to_cart",
              user_properties: userProperties,
              ecommerce: {
                currencyCode: app.getCurrency(),
                add: {
                  actionField: {
                    list: app.util.getUri(document.location.href)['path'] // this should be the collection page URL that user clicked product from
                  },
                  products: dl_products // See the products array below
                }
              }
            }
          case 'remove_from_cart':
            return {
              event: "dl_remove_from_cart",
              user_properties: userProperties,
              ecommerce: {
                currencyCode: app.getCurrency(),
                remove: {
                  actionField: {
                    list: app.util.getUri(document.location.href)['path']// this should be the collection page URL that user clicked product from
                  },
                  products: dl_products // See the products array below
                }
              }
            }
          case 'begin_checkout':
            // dl_user must fire before dl_begin_checkout
            return [
              // dl_user
              await app.tracking.elevarEvents('event','user_data',params),
              // dl_begin_checkout
              {
                event: "dl_begin_checkout",
                user_properties: userProperties,
                marketing: {
                  landing_site: app.tracking.elevarLandingUrl()
                },
                ecommerce: {
                  currencyCode: app.getCurrency(),
                  checkout: {
                    actionField: {
                      step: "1"
                    },
                    products: dl_products,
                  }
                }
              }
            ];
          case 'add_shipping_info':
            return {
              event: "dl_add_shipping_info",
              marketing: {
                landing_site: app.tracking.elevarLandingUrl()
              },
              user_properties: userProperties,
              ecommerce: {
                currencyCode: app.getCurrency(),
                checkout: {
                  actionField: {
                    step: "2"
                  },
                  products: dl_products,
                }
              }
            }
          case 'add_payment_info':
            return {
              event: "dl_add_payment_info",
              marketing: {
                landing_site: app.tracking.elevarLandingUrl()
              },
              user_properties: userProperties,
              ecommerce: {
                currencyCode: app.getCurrency(),
                checkout: {
                  actionField: {
                    step: "3"
                  },
                  products: dl_products,
                }
              }
            }
          case 'purchase':
            // dl_user must fire before dl_purchase
            return [
              // dl_user
              await app.tracking.elevarEvents('event','user_data',params),
              // dl_purchase
              {
                event: "dl_purchase",
                marketing: {
                  landing_site: app.tracking.elevarLandingUrlToPath()
                },
                user_properties: userProperties,
                ecommerce: {
                  currencyCode: params.currency,
                  purchase: {
                    actionField: {
                      id: params.transaction_id.toString(), // Order ID
                      order_name: params.order_id.toString(), // Order User-Friendly ID
                      revenue: params.value.toString(), // Revenue
                      tax: params.tax.toString(),
                      shipping: params.shipping.toString(),
                      sub_total: Math.round(params.value - params.tax,2).toString(), // Sub total
                      product_sub_total: params.product_subtotal.toString(), // Product Sub total
                      discount_amount: params.discount.toString()
                    },
                    products: dl_products
                  }
                }
              }
            ];
        }
      //})
    },

    elevarGetProductTracking: function() {
      return $.cookie('elevarProductHistory') !== null ? JSON.parse($.cookie('elevarProductHistory')) : [];
    },

    elevarGetProductTrackingValue: function(parentSku) {
      let elevarProductHistory = app.tracking.elevarGetProductTracking();
      var found = elevarProductHistory.filter(function(item) { return item.id === parentSku; });
      if (typeof found[0] !== 'undefined') {
        return found[0];
      }
      return null;
    },

    elevarSetProductTrackingUrl: function(parentSku, urlPath) {
      let elevarProductHistory = app.tracking.elevarGetProductTracking();
      elevarProductHistory.push({id:parentSku,path:urlPath});
      return app.tracking.elevarSetProductTracking(elevarProductHistory);
    },

    elevarSetProductTracking: function(elevarProductHistory) {
      let urlCurrent = app.util.getUri(window.location.href);
      if (urlCurrent.hasOwnProperty('urlWithQuery')) {
        $.cookie('elevarProductHistory', JSON.stringify(elevarProductHistory), {
          expires: 90,
          path: '/',
          domain: '.'+urlCurrent.host.replace('www.','')
        });
      }
      return elevarProductHistory;
    },

    elevarLandingUrlToPath: function() {
      let url = app.util.getUri(app.tracking.getInitUrl());
      return url.path + url.query;
    },

    elevarLandingUrl: function() {
      let initUrl = app.tracking.getInitUrl();
      let curCurl = app.util.getUri(window.location.href);
      let url = app.util.getUri(initUrl ? initUrl : (curCurl.protocol + "//" + curCurl.host + "/"));
      return url.urlWithQuery;
    },

    elevarTransformProduct: function(product, item_list_id, is_product, include_image) {
      let category = [product.item_category];
      if (typeof product.item_category1 !== 'undefined' && product.item_category1.length > 0) {
        category.push(product.item_category1);
      }
      if (typeof product.item_category2 !== 'undefined' && product.item_category2.length > 0) {
        category.push(product.item_category2);
      }
      let categoryString = category.join(",").replaceAll(' > ',',');
      let image = include_image ? product.image : null;
      if (image !== null && typeof image !== 'undefined') {
        let imgUrl = app.util.getUri(image);
        image = imgUrl.urlWithQuery;
      }
      let elevarRefUrl = app.tracking.elevarGetProductTrackingValue(product.parent);
      let catPath = elevarRefUrl !== null ? elevarRefUrl.path : product.catpath;
      return {
        //id: (typeof product.item_variant === 'undefined' || product.item_variant.length > product.item_id.length) ? product.item_id : product.item_variant, // SKU
        id: product.parent,
        name: product.item_name, // Product title
        brand: product.brand,
        category: categoryString ? categoryString : 'General',
        variant: product.fsku,
        //parent: product.id !== 'undefined' ? product.id : '',
        price: product.price.toString(),
        //quantity: is_product ? "1" : null, // Only required for dl_view_cart
        list: catPath ? catPath : '/home', // Not required for dl_view_cart; The list the product is displayed in
        //product_id: product.nid, // The product_id
        //variant_id: product.nid, // id or variant_idproduct_id: impression.nid, // The product_id
        product_id: product.nid.toString(), // id or variant_idproduct_id: impression.nid, // The product_id
        variant_id: app.util.skuToNumeric(product.fsku), // id or variant_id
        compare_at_price: Math.round((product.price*1.4),2).toString(),
        image: image
        //compare_at_price: "139.99", // If available
      }
    },

    elevarTransformImpression: function(impression, event, item_list_id, index, is_product) {
      let data = app.tracking.elevarTransformProduct(impression, item_list_id, is_product,true);
      if (is_product) {
        let urlData = app.util.getUri(window.location.href);
        data.quantity = "1";
        // Only if on checkout do we want to use full urls for some reason
        data.url = urlData.path.match(`^/cart/checkout`) !== null ? urlData.protocol + "//" + urlData.host + impression.url : impression.url;
      } else if (event === 'view_cart') {
        data.quantity = typeof data.item_quantity !== 'undefined' ? data.item_quantity.toString() : "1";
      }
      if (event === "begin_checkout" || event === "add_shipping_info" || event === "add_payment_info") {
        data.selling_plan_name = "one-time";
      }
      if (event === "purchase") {
        data.position = index.toString();
      } else {
        data.position = index;
      }
      return data;
    },

    elevarFetchUserInfo: async function() {
      let $res = {};
      await $.ajax(
        {
          url: '/ajax/rove_customer',
          method: 'get',
          //data: '{"key":"' + email.toLowerCase() + '"}',
          dataType: 'json'
        }
      ).done(function (res) {
        if (res.success) {
          // Continue onward as there are no errors
          $res = res;
        } else {
          console.log(res.errors)
          return res;
        }
      }).fail(function (res) {
        console.error('Erroneous request.');
      })
      return $res;
    },

    elevarTransformUser: async function() {
      if ($cache.elevarUserInformation) {
        return $cache.elevarUserInformation;
      }
      let user = {};
      if (Drupal.settings.rove.isLoggedIn) {
        user = Drupal.settings.rove.user_information;
      } else {
        // ucomment this if we want to attempt to grab user details when not logged in
        //user = await app.tracking.elevarFetchUserInfo();
      }
      if (Object.keys(user).length > 0) {
        $cache.elevarUserInformation = {
          // The following fields aren't required if unavailable
          /*
          customer_address_1: typeof user.customer_address_1 !== 'undefined' ? user.customer_address_1 : null,
          customer_address_2: typeof user.customer_address_2 !== 'undefined' ? user.customer_address_2 : null,
          customer_city: typeof user.customer_city !== 'undefined' ? user.customer_city : null,
          customer_country: typeof user.customer_country !== 'undefined' ? user.customer_country: null, // full name
          customer_email: typeof user.customer_email !== 'undefined' ? user.customer_email : null,
          customer_first_name: typeof user.customer_first_name !== 'undefined' ? user.customer_first_name : null,
          customer_id: typeof user.customer_id !== 'undefined' ? user.customer_id : null,
          customer_last_name: typeof user.customer_last_name !== 'undefined' ? user.customer_last_name : null,
          customer_order_count: typeof user.customer_order_count !== 'undefined' ? user.customer_order_count : null,
          customer_phone: typeof user.customer_phone !== 'undefined' ? user.customer_phone : null,
          customer_province: typeof user.customer_province !== 'undefined' ? user.customer_province : null,
          customer_province_code: typeof user.customer_province_code !== 'undefined' ? user.customer_province_code : null,
          customer_tags: "",
          customer_total_spent: typeof user.customer_total_spent !== 'undefined' ? user.customer_total_spent : null,
          customer_zip: typeof user.customer_zip !== 'undefined' ? user.customer_zip : null,
           */

          // The following field is required
          user_consent: "", // Use an empty string
          visitor_type: Drupal.settings.rove.isLoggedIn ? "logged_in" : 'guest' // "logged_in" || "guest"
        }
        if (typeof user.customer_address_1 !== 'undefined' && user.customer_address_1 !== null) {
          $cache.elevarUserInformation.customer_address_1 = user.customer_address_1;
        }
        if (typeof user.customer_address_2 !== 'undefined' && user.customer_address_2 !== null) {
          $cache.elevarUserInformation.customer_address_2 = user.customer_address_2;
        }
        if (typeof user.customer_city !== 'undefined' && user.customer_city !== null) {
          $cache.elevarUserInformation.customer_city = user.customer_city;
        }
        if (typeof user.customer_country !== 'undefined' && user.customer_country !== null) {
          $cache.elevarUserInformation.customer_country = user.customer_country;
        }
        if (typeof user.customer_email !== 'undefined' && user.customer_email !== null) {
          $cache.elevarUserInformation.customer_email = user.customer_email;
        }
        if (typeof user.customer_first_name !== 'undefined' && user.customer_first_name !== null) {
          $cache.elevarUserInformation.customer_first_name = user.customer_first_name;
        }
        if (typeof user.customer_id !== 'undefined' && user.customer_id !== null) {
          $cache.elevarUserInformation.customer_id = user.customer_id;
        }
        if (typeof user.customer_order_count !== 'undefined' && user.customer_order_count !== null) {
          $cache.elevarUserInformation.customer_order_count = user.customer_order_count;
        }
        if (typeof user.customer_phone !== 'undefined' && user.customer_phone !== null) {
          $cache.elevarUserInformation.customer_phone = user.customer_phone;
        }
        if (typeof user.customer_province !== 'undefined' && user.customer_province !== null) {
          $cache.elevarUserInformation.customer_province = user.customer_province;
        }
        if (typeof user.customer_province_code !== 'undefined' && user.customer_province_code !== null) {
          $cache.elevarUserInformation.customer_province_code = user.customer_province_code;
        }
        if (typeof user.customer_tags !== 'undefined' && user.customer_tags !== null) {
          $cache.elevarUserInformation.customer_tags = user.customer_tags;
        }
        if (typeof user.customer_total_spent !== 'undefined' && user.customer_total_spent !== null) {
          $cache.elevarUserInformation.customer_total_spent = user.customer_total_spent;
        }
        if (typeof user.customer_zip !== 'undefined' && user.customer_zip !== null) {
          $cache.elevarUserInformation.customer_zip = user.customer_zip;
        }
        if (typeof user.customer_last_name !== 'undefined' && user.customer_last_name !== null) {
          $cache.elevarUserInformation.customer_last_name = user.customer_last_name;
        }
        return $cache.elevarUserInformation
      }

      $cache.elevarUserInformation = {
        user_consent: "", // Use an empty string
        visitor_type: Drupal.settings.rove.isLoggedIn ? 'logged_in' : 'guest'
      }
      if ($.cookie('userTrackEmail') !== null && $.cookie('userTrackEmail').length > 0) {
        $cache.elevarUserInformation.customer_email = $.cookie('userTrackEmail');
      }

      return $cache.elevarUserInformation
    },

		// This it called for Enhanced Conversions
		gtagEnhancedConversion: function(params) {
			window.enhanced_conversion_data = params;
		},

		// Lets put all fbq (facebook) calls through a wrapper first
		fbq: function (type, event, params) {
      return null; // tag manager now runs the show for facebook
			if ($cache.debug) {
				console.log('FBQ Type: ' + type);
				console.log('FBQ Event: ' + event);
				console.log('FBQ Params:');
				console.log(params);
			}
			if (typeof myfbq !=='undefined') {
				// todo: trackCustom events?
				myfbq(app.tracking.facebook_default_pixel_id,event,params);
			} else if (typeof fbq !=='undefined'){
				//fbq(type, event, params);
				let newType = type === 'track' ? 'trackSingle' : 'trackSingleCustom';
				let pixel = app.tracking.facebook_default_pixel_id;
				if (typeof params.pixel !== 'undefined') {
					pixel = params.pixel;
					delete params.pixel;
				}
				fbq(newType, pixel, event, params);
			}
		},

    naver: function(type, event, params) {
      if (typeof window.wcs !=='undefined' && typeof window._nasa !=='undefined') {
        _nasa['cnv'] = wcs.cnv(event.toString(),params.value.toString());
        wcs_do(_nasa);
      }
    },

		// Bing conversions/events
		bing: function (type, event, params) {
			window.uetq = window.uetq || [];
			window.uetq.push(type,event,params);
		},

		/*
		rakuten: function(type, event, params) {
			// Conversion
			var rm_trans = params;
			app.tracking.rakutenConversionPayload(rm_trans);
		},
		*/

		upsellit: function(type, event, params) {
			USI_orderID = params.orderid;
			USI_orderAmt = params.revenue;
			USI_currency = params.currency;
			var USI_headID = document.getElementsByTagName("head")[0];
			var USI_dynScript = document.createElement("script");
			USI_dynScript.setAttribute('type','text/javascript');
			USI_dynScript.src = 'https://www.upsellit.com/active/roveconcepts_pixel.jsp';
			USI_headID.appendChild(USI_dynScript);
		},

		quantcast: function(type, event, params) {
			if (typeof window._qevents !== 'undefined') {
				window._qevents.push({
							qacct:app.tracking.quantcast_id,
							labels: '_fp.channel.Rove,_fp.subchannel.Web,_fp.event.Purchase Confirmation,_fp.customer.'+params.customerStatus+', _fp.pcat.Purchase',
							orderid: params.orderid,
							revenue: params.revenue,
							event: 'refresh'
						}
				);
			}
		},

		podsights: function(type, event, params) {
			if (typeof window.pdst !== 'undefined') {
				window.pdst(event,params);
			}
		},

		pintrk: function (type, event, params) {
			if (typeof pintrk === 'function') {
				pintrk(type, event, params);
			}
		},

		// Track visit referer
		referer: function (referer) {

		},

		// Track campaign such as utm
		campaign: function (campaign) {

		},

		// Track Page View
		view: function (page) {
			if ($cache.debug) {
				console.log('IGNORE GTM View');
			}

			let params = {
				value: 0,
				items: [],
				send_to: 'AW-1016437901'
			};
			let items = [];
      let iItems = Object.keys(Drupal.settings.track.items).length > 0 ? Drupal.settings.track.items : Drupal.settings.track.cart.items;
			if (Object.keys(iItems).length > 0) {
				for (let k in iItems) {
					//items.push({id:app.tracking.modifyProductID(Drupal.settings.track.items[k],'google')});
          items.push(app.tracking.modifyProduct(app.tracking.cartItemToPageItem(iItems[k]),'google'));
          //value += (Drupal.settings.track.cart.items[i].price * Drupal.settings.track.cart.items[i].quantity);
				}
			}
			/*
			if (Drupal.settings.track.pageItems.length > 0) {
				for (let k in Drupal.settings.track.pageItems) {
					items.push({id:Drupal.settings.track.pageItems[k].id});
				}
			}
			*/
			let userid = app.tracking.userid(params);
			if (userid) {
				params.user_id = userid;
			}
			if (items.length) {
				params.items = app.tracking.remarketing(items);
			}
      app.tracking.gtag('event', 'page_view', params);

      if (jQuery.cookie('DRUPAL_LOGGED_IN')) {
        // Cookie will expire on next load so trigger event
        app.tracking.gtag('event', 'login', params);
      }
		},

		home: function(params) {
			app.tracking.gtag('event', 'home', {
				'name': params.page_title,
				//'items': app.tracking.remarketing(items),
				'non_interaction': true,
				'send_to': 'AW-1016437901',
				//'google_business_vertical': 'retail',
				//'event_category': 'ecommerce',
				'event_label': 'home_page_visit'
			});
		},

		// Track country changed
		changeCountry: function (country) {
			app.tracking.gtag('event', 'change_country', {
				'non_interaction': false,
				'event_category': 'engagement',
				'event_label': country
			});
		},

    leadSubmit: function (params) {
      app.tracking.gtag('event', 'leadSubmit', {
				'event_category': 'Lead',
				'event_label': 'lead_submission',
        'email': params.email,
        'lead_name': params.name
			});

			// Facebook
			app.tracking.fbq('trackCustom', 'leadSubmit', {email: params.email, name: params.name})
    },

		// Track searched keyword
		search: function (search) {
      // GA4
			app.tracking.gtag('event', 'search', {
				'search_term': search.term,
				'non_interaction': false,
			});
		},

		searchViewResults: function (search) {
			let items = [];
			if (typeof search.items.hits !== 'undefined' && search.items.hits.length > 0) {
				for (let i = 0; i < search.items.hits.length; ++i) {
					// attempt to just get the parentid
					//let loc = search.items.hits[i].objectID.indexOf('-');
					let item = [];
					item['item_id'] = typeof search.items.hits[i].google_tag_id !== 'undefined' ? search.items.hits[i].google_tag_id : search.items.hits[i].objectID;
          item['price'] = typeof search.items.hits[i].prices.final[app.getCurrency().toLowerCase()] !== 'undefined' ? search.items.hits[i].prices.final[app.getCurrency().toLowerCase()] : 1;
          item['nid'] = search.items.hits[i].nid;
          item['item_name'] = search.items.hits[i].title;
          item['item_brand'] = 'Rove Concepts';
          //'item_category': category,
          item['index'] = i + 1;
          item['fsku'] = search.items.hits[i].objectID;
          item['id'] = item['parent'] = search.items.hits[i].objectID.substring(0,search.items.hits[i].objectID.indexOf('-'));
          item['gsku'] = search.items.hits[i].google_tag_id;
          item['brand'] = 'Rove Concepts';
          item['url'] = search.items.hits[i].url;
          item['image'] = search.items.hits[i].image;

          item['catpath'] = ''; // not in algolia
					items.push(item);
				}
			}
			app.tracking.gtag('event', 'view_search_results', {
				'search_term': search.term,
				'item_list_name': 'Search Results',
        'item_list_id': 'search_results',
				'items': app.tracking.limit(app.tracking.remarketing(items),3),
				'non_interaction': false,
			});
		},

    limit: function(items,limit) {
		  let newItems = [];
		  let cnt = 0;
      for (let k in items) {
        if (items.hasOwnProperty(k)) {
          cnt++;
          if (cnt > limit) {
            break;
          }
          newItems[k] = items[k];
        }
      }
      return newItems;
    },

		// Track searched result click
		searchClick: function (result) {

		},

		// Track cookie consent given
		cookieConsent: function (given) {

		},

		// Track cookie consent given
		mulberryView: function () {
			app.tracking.gtag('event', 'mulberryView', {
				'non_interaction': false,
				'event_category': 'engagement',
				'event_label': 'Mulberry'
			});
		},

		// Track form submission
		formTrackEvent: function(form) {
			app.tracking.track('formSubmission', [form]);

			if (typeof form.form !== 'undefined') {
				switch (form.form) {
					case 'swatch':
						app.tracking.track('swatchRequest', [form]);
            if (app.tracking.isGA4LocalEnabled()) {
              app.tracking.conversion('swatch_request_complete', {'send_to': 'AW-1016437901/thCICL2U8WgQjbnW5AM'});
            }
						break;
				}
			}
		},

		modifyProducts: function(products,medium) {
      let $items = [];
      for (const property in products) {
        if (products.hasOwnProperty(property)) {
          $items[property] = app.tracking.modifyProduct(products[property],medium);
        }
      }
      return $items;
		},

		modifyProduct: function(product,medium) {
			product.id = app.tracking.modifyProductID(product,medium);
			return product;
		},

		modifyProductID: function(product,medium) {
			switch (medium) {
				case 'pinterest':
					if (typeof product.id_default !== 'undefined') {
						return product.id_default;
					} else if(typeof product.fsku !== 'undefined') {
						return product.fsku;
					}
					return product.id;
				case 'facebook':
					if (typeof product.id_default !== 'undefined') {
						return (app.getCountry() === 'US' ? '' : 'C-') + product.id_default;
					} else if(typeof product.fsku !== 'undefined') {
						return (app.getCountry() === 'US' ? '' : 'C-') + product.fsku;
					}
					return (app.getCountry() === 'US' ? '' : 'C-') + product.id;
				case 'google':
					if (typeof product.id_google !== 'undefined') {
						return product.id_google;
					} else if (typeof product.gsku !== 'undefined') {
						return product.gsku;
					}
					return product.id;
			}
		},

    getCategoryItems: function () {
      let items = [];
      let pinterest_items = [];
      if (Drupal.settings.track.pageItems.length > 0) {
        // Impressions
        for (let k in Drupal.settings.track.pageItems) {
          items.push(app.tracking.modifyProduct(app.enhancedEcommerce.impression(Drupal.settings.track.pageItems[k]),'google'));
          pinterest_items.push({
            //product_price: Drupal.settings.track.pageItems[k].price,
            product_id: app.tracking.modifyProductID(Drupal.settings.track.pageItems[k],'pinterest'),
            //product_variant_id: Drupal.settings.track.pageItems[k].id,
            product_name: Drupal.settings.track.pageItems[k].name,
            //product_brand: 'Rove Concepts',
            product_category: 'Furniture'
          });
        }
      }
      return {
        items: items,
        pinterest_items: pinterest_items
      }
    },

		viewCategory: function (category) {
			let items = category.items;
			let pinterest_items = [];
      let pageItems = app.tracking.getCategoryItems();
      if (pageItems.items.length) {
        for (let k in pageItems.items) {
          items.push(pageItems.items[k]);
        }
      }
      if (pageItems.pinterest_items.length) {
        for (let k in pageItems.items) {
          pinterest_items.push(pageItems.pinterest_items[k]);
        }
      }

      // UA
      /*
			app.tracking.gtag('event', 'view_item_list', {
				'tid': category.tid,
				'name': category.name,
        'items': app.tracking.limit(app.tracking.remarketing(items),3),
				//'non_interaction': true,
				//'google_business_vertical': 'retail',
				'event_category': 'ecommerce',
				'event_label': typeof category.label !== 'undefined' ? category.label : 'product_impression_cv'
			});
       */

      // GA4
      app.tracking.gtag('event', 'view_item_list', {
				'item_list_id': app.isCategoryPage() ? category.tid : 'related_products',
				'item_list_name': app.isCategoryPage() ? category.name : 'Related Products',
        'items': app.tracking.limit(app.tracking.remarketing(app.tracking.modifyProducts(items,'google')),8)
			});

			// Pinterest
      if (app.tracking.pinterest_enabled) {
        app.tracking.pintrk('track', 'ViewCategory', {
          'name': category.name,
          //'items': app.tracking.remarketing(pinterest_items),
          value: 0,
          currency: Drupal.settings.track.currency,
          line_items: pinterest_items
        });
      }
		},

		// Track product view
		viewProduct: function (product) {
      // UA
      /*
			app.tracking.gtag('event', 'view_item', {
				'items': app.tracking.remarketing([app.tracking.modifyProduct(product,'google')]),
				'value': product.price,
        'id' : app.tracking.modifyProductID(product,'google'),
				//'non_interaction': true,
				'event_category': 'ecommerce',
				'event_label': 'product_impression_pp',
			});
       */

      // GA4
      app.tracking.gtag('event', 'view_item', {
				'items': app.tracking.remarketing([app.tracking.modifyProduct(app.tracking.cartItemToPageItem(product),'google')]),
				'value': product.price,
        'currency': app.getCurrency(),
        'id' : app.tracking.modifyProductID(product,'google')
			});

			let fbqparams = {
				content_type: 'product',
				content_ids: [app.tracking.modifyProductID(product,'facebook')],
				product_catalog_id: app.tracking.facebook_catalog_id,
				value: '0.00',
				currency: Drupal.settings.track.currency,
			};

			app.tracking.fbq('track', 'ViewContent', fbqparams);

			// Rora
			//if (product.category === 'Accents/Bed Accessories/Bedding') {
				//fbqparams.pixel = app.tracking.facebook_rora_pixel_id;
			//	app.tracking.fbq('track', 'ViewContent', fbqparams);
			//}

			// Pinterest
      if (app.tracking.pinterest_enabled) {
        app.tracking.pintrk('track', 'PageVisit', {
          value: parseFloat(product.price),
          currency: Drupal.settings.track.currency,
          line_items: [
            {
              //product_price: product.price,
              //product_id: product.variant,
              //product_variant_id: app.tracking.modifyProductID(product,'pinterest'),
              //product_name: product.name,
              //product_brand: 'Rove Concepts',
              product_category: 'Furniture',
              product_id: app.tracking.modifyProductID(product, 'pinterest')
            }
          ]
        });
      }
		},

		// Product clicked
		clickProduct: function (product, $elementClicked) {
			if (typeof product === 'undefined') {
				document.location = typeof $elementClicked.attr('href') !== 'undefined' && $elementClicked.attr('href').length > 0 ? $elementClicked.attr('href') : $elementClicked.find('a').attr('href');
				return;
			}
			let sourcePage = 'cp'; // category page

      // GA4
			app.tracking.gtag('event', 'select_content', {
				'content_id': app.tracking.modifyProduct(app.enhancedEcommerce.impression(product),'google').id,
				'content_type': 'product',
				'non_interaction': false
			});

      // GA4
      app.tracking.gtag('event', 'select_item', {
				'items': app.tracking.remarketing([app.tracking.modifyProduct(app.enhancedEcommerce.impression(product),'google')]),
        'item_list_name': "homepage",
        'item_list_id': "homepage",
        'currency': app.getCurrency()
				//'event_callback': function () {
				//	document.location = typeof $elementClicked.attr('href') !== 'undefined' && $elementClicked.attr('href').length > 0 ? $elementClicked.attr('href') : $elementClicked.find('a').attr('href');
				//}
			});

			/*
			setTimeout(function() {
				window.location = typeof $elementClicked.attr('href') !== 'undefined' && $elementClicked.attr('href').length > 0 ? $elementClicked.attr('href') : $elementClicked.find('a').attr('href');
			}, 500);
			*/
		},

		// Track notify me submission
		notifyMe: function (product, email) {
      // GA4
			app.tracking.gtag('event', 'notify_me', {
				'non_interaction': false,
				'content_type': 'product',
				'items': app.tracking.remarketing([app.tracking.modifyProduct(app.enhancedEcommerce.impression(product),'google')]),
				'email': email
			});
		},

		// Track wishlist addition
		wishlist: function (addOrRemove, product) {
			switch (addOrRemove) {
				case 'add':
          // UA
          /*
					app.tracking.gtag('event', 'add_to_wishlist', {
						'event_category': 'ecommerce',
						'event_label': addOrRemove,
						'value': product.price,
						'non_interaction': false,
						'items': app.tracking.remarketing([app.tracking.modifyProduct(app.enhancedEcommerce.impression(product),'google')])
					});
           */

          // GA4
          app.tracking.gtag('event', 'add_to_wishlist', {
						'value': product.price,
            'currency': app.getCurrency(),
						'items': app.tracking.remarketing([app.tracking.modifyProduct(app.enhancedEcommerce.impression(product),'google')]),
						'non_interaction': false
					});

					// Facebook
					let fbqparams = {
						content_type: 'product',
						content_ids: [app.tracking.modifyProductID(product,'facebook')],
						product_catalog_id: app.tracking.facebook_catalog_id,
						value: product.price,
						currency: Drupal.settings.track.currency,
					};
					app.tracking.fbq('track', 'AddToWishlist', fbqparams);

					// Rora
					//if (product.category === 'Accents/Bed Accessories/Bedding') {
						//fbqparams.pixel = app.tracking.facebook_rora_pixel_id;
					//	app.tracking.fbq('track', 'AddToWishlist', fbqparams);
					//}

					break;
				case 'remove':
          // UA
          /*
					app.tracking.gtag('event', 'remove_from_wishlist', {
						'event_category': 'ecommerce',
						'event_label': addOrRemove,
						'value': product.price,
						'non_interaction': false,
						'items': app.tracking.remarketing([app.tracking.modifyProduct(app.enhancedEcommerce.impression(product),'google')])
					});
           */

          // GA4
          app.tracking.gtag('event', 'remove_from_wishlist', {
						'value': product.price,
            'currency': app.getCurrency(),
						'items': app.tracking.remarketing([app.tracking.modifyProduct(app.enhancedEcommerce.impression(product),'google')]),
						'non_interaction': false
					});
					break;
			}

			/*
			app.tracking.gtag('event','wishlist',{
				'event_category':'wishlist:'+addOrRemove,
				'event_label':addOrRemove,
				'event_value':0,
				'non_interaction':false,
				'content_type':'product',
				'items':app.tracking.remarketing([app.enhancedEcommerce.impression(product)])
			});
			*/
		},

		// Track coupon add/remove
		coupon: function (addOrRemove, coupon) {
			switch (addOrRemove) {
				case 'remove':
					if (typeof Drupal.settings.track.cart.coupon !== 'undefined'
							&& Drupal.settings.track.cart.coupon === coupon) {
						Drupal.settings.track.cart.coupon = '';
					}
					break;
				case 'add':
					Drupal.settings.track.cart.coupon = coupon;
					break;
			}

			app.tracking.gtag('event', 'coupon', {
				'event_category': 'coupon:' + addOrRemove,
				'event_label': coupon,
				'event_value': 0,
				'non_interaction': false,
			});
		},

		// Track Popup
		popup: function () {

		},

		// Track form submission
		formSubmission: function (form) {
			// form.form, form.data
			app.tracking.gtag('event', 'form_submission', {
				'event_category': 'engagement',
				'event_label': form.form,
				'non_interaction': false,
			});
		},

		// Track Chat engaged
		chat: function () {
			var seAgent;
			var proactivePrompt = '';
			// Proactive chat started
			SnapEngage.setCallback('OpenProactive', function (agent, msg) {
				seAgent = agent;
				proactivePrompt = msg;
				gtag('event', 'ProactiveChat', {
					'event_category': 'SnapEngage',
					'event_label': agent
				});
				gtag('event', 'ProactivePrompt', {
					'event_category': 'SnapEngage',
					'event_label': msg
				});
			});

			// start chat
			SnapEngage.setCallback('StartChat', function (agent, msg, type) {
				seAgent = agent;
				gtag('event', 'Chat', {
					'event_category': 'SnapEngage',
					'event_label': agent
				});
				if (type === 'proactive') {
					gtag('event', 'ProactiveEngaged', {
						'event_category': 'SnapEngage',
						'event_label': proactivePrompt
					});
				}
			});

			// ChatMessageSent
			SnapEngage.setCallback('ChatMessageSent', function (msg) {
				gtag('event', 'Message:Chat', {
					'event_category': 'SnapEngage',
				});
			});

			// MessageSubmit
			SnapEngage.setCallback('MessageSubmit', function (msg) {
				gtag('event', 'Message:Offline', {
					'event_category': 'SnapEngage',
				});
			});
		},

		// Track newsletter signup
		newsletter: function (email) {
			app.tracking.gtag('event', 'Newsletter', {
				'event_category': 'Signup',
				'event_label': 'Registration',
				'value': 35.00,
        '#email': email
			});

			// Facebook
			app.tracking.fbq('trackCustom', 'Newsletter', {})
		},

		// Track free swatch button on product page
		freeSwatches: function (product_name) {
			app.tracking.gtag('event', 'swatch_free', {
				'non_interaction': false,
				'event_category': 'engagement',
				'event_label': product_name
			});
		},

		// Track color changed/selected
		swatchDisplayed: function (swatch) {
			//swatch.oid, swatch.material_name, swatch.model
			app.tracking.gtag('event', 'swatch_change', {
				'non_interaction': false,
				'event_category': 'engagement',
				'event_label': swatch.material_name,
				'items': [
					{id: swatch.model,google_business_vertical:'retail'}
				]
			});
		},

		// Track swatch request submitted
		swatchRequest: function (request) {
			app.tracking.gtag('event', 'swatch_request', {
				'non_interaction': false,
				'event_category': 'engagement',
				'event_label': 'Free Request',
				'value': 0
			});
		},

		// Track clicking on phone to call
		phone: function (phone) {

		},

    getCartCookie: function() {

    },

    setCartCookie: function(cartCookie) {

    },

    addCartCookieItem: function(cartCookieItem) {

    },

    updateCartCookieItem: function(cartCookieItem) {

    },

		// Track add to cart
		addToCart: function (product) {
      // UA
      /*
			app.tracking.gtag('event', 'add_to_cart', {
				'items': app.tracking.remarketing([app.tracking.modifyProduct(product,'google')]),
        'id' : app.tracking.modifyProductID(product,'google'),
        'value' : product.price,
				'non_interaction': false,
				'event_category': 'ecommerce',
				'event_label': 'add_to_cart_click'
			});
       */

      // Lets keep track of cart items for tracking purposes only
      app.tracking.addCartCookieItem(product);

      // GA4
      app.tracking.gtag('event', 'add_to_cart', {
				//'items': app.tracking.remarketing([app.tracking.modifyProduct(product,'google')]),
        'items': [app.tracking.modifyProduct(app.tracking.cartItemToPageItem(product),'google')],
        'value' : product.price,
        'currency' : app.getCurrency(),
				'non_interaction': false
			});

			/*
			if (typeof window._fbq !== 'undefined') {
				window._fbq.push(['track', 'AddToCart']); // Facebook
			} else if (typeof window.fbq !== 'undefined') {
				window.fbq.push(['track', 'AddToCart']); // Facebook
			}
			*/

			// Facebook
			let fbqparams = {
				content_type: 'product',
				content_ids: [app.tracking.modifyProductID(product,'facebook')],
				product_catalog_id: app.tracking.facebook_catalog_id,
				value: '30.00', // Fixed
				currency: Drupal.settings.track.currency
			};
			app.tracking.fbq('track', 'AddToCart', fbqparams);

			// Rora
			//if (product.category === 'Accents/Bed Accessories/Bedding') {
				//fbqparams.pixel = app.tracking.facebook_rora_pixel_id;
			//	app.tracking.fbq('track', 'AddToCart', fbqparams);
			//}

			// Re-arrange cart.items object if this product exists
			for (let k in Drupal.settings.track.cart.items) {
				if (Drupal.settings.track.cart.items[k].variant === product.variant) {
					// product exists so just update
					Drupal.settings.track.cart.items[k].quantity = parseInt(Drupal.settings.track.cart.items[k].quantity) + product.quantity;
				}
			}

			// Pinterest - We fake this now as a checkout page visit
      if (app.tracking.pinterest_enabled) {
        app.tracking.pintrk('track', 'AddToCart', {
          value: parseFloat(product.price) * product.quantity,
          order_quantity: product.quantity,
          currency: Drupal.settings.track.currency
        });
      }

      // Naver (Korea)
      // Events: Purchase (1), Membership Reg (2), Add to Cart (3), Request/Reservation (4), Other (5)
      app.tracking.naver('track', 3, { value: 1 });
		},

		removeFromCart: function (product) {
      // UA
      /*
			app.tracking.gtag('event', 'remove_from_cart', {
				'items': app.tracking.remarketing([app.tracking.modifyProduct(product,'google')]),
				"event_category": "ecommerce",
				"event_label": "remove_from_cart_click",
				"non_interaction": false
			});
      */

      // Keep track of cart in a cookie for tracking purposes only
      app.tracking.updateCartCookieItem(product);

      app.tracking.gtag('event', 'remove_from_cart', {
				//'items': app.tracking.remarketing([app.tracking.modifyProduct(product,'google')]),
        'items': [app.tracking.modifyProduct(app.tracking.cartItemToPageItem(product),'google')],
        'value': product.price,
        'currency': app.getCurrency(),
				"non_interaction": false
			});

			// Re-arrange positions of cart items
			let items = [];
			for (let k in Drupal.settings.track.cart.items) {
				if (k === (product.list_position - 1)) {
					if (parseInt(product.quantity) !== parseInt(Drupal.settings.track.cart.items[k].quantity)) {
						// Item only partially removed
						let item = app.tracking.cartItemToPageItem(Drupal.settings.track.cart.items[k]);
						item.quantity = parseInt(item.quantity) - parseInt(product.quantity);
						items.push(item);
					} else {
						// Item fully removed
					}
				} else {
					items.push(app.tracking.cartItemToPageItem(Drupal.settings.track.cart.items[k]));
				}
			}
			Drupal.settings.track.cart.items = items;
		},

    cartItemToPageItem: function(cartItem) {
      // If this is already a page item, ignore
      if (typeof cartItem.item_id !== 'undefined') {
        return cartItem;
      }
      let $item = {
        'item_id': typeof cartItem.id_default !== 'undefined' ? cartItem.id_default : cartItem.id,
        'item_name': cartItem.name,
        'item_brand': 'Rove Concepts',
        'price': cartItem.price,
        //'item_category': category,
        'index': Object.keys(Drupal.settings.track.pageItems).length,
        'fsku': cartItem.id_default,
        'parent': cartItem.id,
        'gsku': cartItem.id_google,
        'brand': typeof cartItem.brand !== 'undefined' ? cartItem.brand : 'Rove Concepts',

        'catpath': typeof cartItem.catpath !== 'undefined' ? cartItem.catpath : '',
        'url': typeof cartItem.url !== 'undefined' ? cartItem.url : '',
        'nid': cartItem.nid,
        'image': typeof cartItem.image !== 'undefined' ? cartItem.image : '',
        'item_quantity': cartItem.quantity
      }
      if (typeof cartItem.variant !== 'undefined') {
        $item.item_variant = cartItem.variant;
      }
      if (typeof cartItem.category !== 'undefined') {
        let categories = cartItem.category.split('/');
        for (let x = 0; x < categories.length; x++) {
          $item['item_category' + (x > 0 ? x : '')] = categories[x];
        }
      } else {
        if (typeof cartItem.item_category !== 'undefined') {
          $item.item_category = cartItem.item_category;
        }
        if (typeof cartItem.item_category2 !== 'undefined') {
          $item.item_category2 = cartItem.item_category2;
        }
        if (typeof cartItem.item_category3 !== 'undefined') {
          $item.item_category3 = cartItem.item_category3;
        }
        if (typeof cartItem.item_category4 !== 'undefined') {
          $item.item_category4 = cartItem.item_category4;
        }
        if (typeof cartItem.item_category5 !== 'undefined') {
          $item.item_category5 = cartItem.item_category5;
        }
      }
      return $item;
    },

		// Track cart page view
		viewCart: function (cart) {
			// We track this as the first step to checkout
			//app.tracking.checkoutInit(cart,false);

			let items = [];
      let value = 0;
			for(let i in Drupal.settings.track.cart.items) {
				if (Drupal.settings.track.cart.items.hasOwnProperty(i)) {
					items.push(app.tracking.modifyProduct(app.tracking.cartItemToPageItem(Drupal.settings.track.cart.items[i]),'google'));
          value += (Drupal.settings.track.cart.items[i].price * Drupal.settings.track.cart.items[i].quantity);
				}
			}
			// GA4
			app.tracking.gtag('event', 'view_cart', {
				'items': app.tracking.remarketing(items),
        'value': value,
        'currency': app.getCurrency(),
				'non_interaction': true
			});
		},

		// Emailed a cart
		emailCart: function (data) {
			let items = [];
			for(let i in Drupal.settings.track.cart.items) {
				if (Drupal.settings.track.cart.items.hasOwnProperty(i)) {
					items.push(app.tracking.modifyProduct(Drupal.settings.track.cart.items[i],'google'));
				}
			}
			app.tracking.gtag('event', 'email_cart', {
				'event_category': 'ecommerce',
				'event_label': 'sent',
				'event_value': 0,
				'non_interaction': true,
				'items': app.tracking.remarketing(items)
			});
		},

		// Checkout clicked
		checkoutClick: function (checkout) {
			//This might be already engaged from cart visit, but we will send again anyways
			app.tracking.checkoutInit(checkout);
		},

		// Track checkout page
		checkoutInit: function (checkout) {

      let existingInit = app.tracking.getCookie('checkoutOrderInit');
      if (existingInit.length > 0 && parseInt(existingInit) === parseInt(Drupal.settings.track.order_id)) {
        // we dont want to trigger anymore inits
      } else {
        app.tracking.setCookie('checkoutOrderInit', Drupal.settings.track.order_id, 1);
      }
			let googleItems = [];
			for(let i in checkout.items) {
				if (checkout.items.hasOwnProperty(i)) {
					googleItems.push(app.tracking.modifyProduct(app.tracking.cartItemToPageItem(checkout.items[i]),'google'));
				}
			}

      if (app.tracking.isGA4LocalEnabled()) {
        app.tracking.conversion('begin_checkout', {'send_to': 'AW-11062140594/HqgWCJ-Lg5AYELK965op'});
      }

      // GA4
      app.tracking.gtag('event', 'begin_checkout', {
				'items': app.tracking.remarketing(googleItems),
        'currency': app.getCurrency(),
				'coupon': checkout.coupon,
				'value': checkout.value,
				'non_interaction': true
			});

      // Naver
      app.tracking.naver('track', 5, { value: 1 });

			// Facebook
			let line_items = [];
			let ids = [];
			let rora_products = [];
			for (let k in checkout.items) {
				let i = {
					id: app.tracking.modifyProductID(checkout.items[k],'facebook'),
					quantity: checkout.items[k].quantity,
					item_price: Math.abs(parseFloat(checkout.items[k].price))
				};
				line_items.push(i);
				ids.push(app.tracking.modifyProductID(checkout.items[k],'facebook'));
				if (checkout.items[k].category === 'Accents/Bed Accessories/Bedding') {
					rora_products.push(i);
				}
			}

			let fbqparams = {
				content_type: 'product',  // 'product' if we are passing in full variant
				content_ids: ids,
				contents: line_items,
				product_catalog_id: app.tracking.facebook_catalog_id,
				currency: Drupal.settings.track.currency,
				value: Math.abs(parseFloat(checkout.value))
			};
			app.tracking.fbq('track', 'InitiateCheckout', fbqparams);
		},

    lookbookEngage: function (params) {
      app.tracking.gtag('event','lookbookOpen', {
        lookbook: params.lookbookName
      })
    },

		// Track checkout page engaged (form entry started)
		checkoutEngage: function (checkout) {

      // Step 1: .email-continue click
      // Step 2: .membership-continue click
      // Step 3: ajax response when shipping quotes come in after address entered valid (rove2018_ajax_render_alter)
      // Step 4: .quote-continue click
      // Step 5: .coupon-continue click (mulberry)
      // Step 6: .payment-continue click
      // Step 7: Completion page (triggered from self::init)

			let googleItems = [];
			let loopItems = typeof checkout.items !== 'undefined' && checkout.items.length > 0 ? checkout.items : Drupal.settings.track.cart.items;
			for(let i in loopItems) {
				if (loopItems.hasOwnProperty(i)) {
					googleItems.push(app.tracking.modifyProduct(app.tracking.cartItemToPageItem(loopItems[i]),'google'));
				}
			}

      if (checkout.step === 6) {
        // Shipping selected
        app.tracking.gtag('event', 'add_payment_info', {
          'currency': app.getCurrency(),
          'value': typeof checkout.value !== 'undefined' && checkout.value > 0 ? checkout.value : Drupal.settings.track.checkout.total,
          'items': app.tracking.remarketing(googleItems),
          'payment_type': 'Credit Card',
          'coupon': typeof checkout.coupon !== 'undefined' && checkout.coupon.length > 0 ? checkout.coupon : Drupal.settings.track.cart.coupon,
          'non_interaction': false,
        });
      }

      if (checkout.step === 4) {
        // Shipping selected
        app.tracking.gtag('event', 'add_shipping_info', {
          'currency': app.getCurrency(),
          'value': typeof checkout.value !== 'undefined' && checkout.value > 0 ? checkout.value : Drupal.settings.track.checkout.total,
          'items': app.tracking.remarketing(googleItems),
          'shipping_tier': 'Ground',
          'coupon': typeof checkout.coupon !== 'undefined' && checkout.coupon.length > 0 ? checkout.coupon : Drupal.settings.track.cart.coupon,
          'non_interaction': false,
        });
      }

			app.tracking.gtag('event', 'checkout_progress', {
				'checkout_step': checkout.step,
				'checkout_option': checkout.option,
				//'value': typeof checkout.value !== 'undefined' && checkout.value > 0 ? checkout.value : Drupal.settings.track.checkout.total,
				'items': app.tracking.remarketing(googleItems),
				'coupon': typeof checkout.coupon !== 'undefined' && checkout.coupon.length > 0 ? checkout.coupon : Drupal.settings.track.cart.coupon,

				'non_interaction': false,
				'event_category': 'ecommerce',
				'event_label': 'checkout_step_' + checkout.step,
				'event_callback': typeof checkout.event_callback !== 'undefined' ? checkout.event_callback : null
			});

			//if (checkout.step === 3) {
			//app.tracking.checkoutReviewed(checkout);
			//}
		},

		// Track checkout option changes
		checkoutOption: function (checkout) {
			app.tracking.gtag('event', 'set_checkout_option', {
				'checkout_step': checkout.step,
				'checkout_option': checkout.option,
				'value': checkout.value,
				'non_interaction': false,
				'event_category': 'ecommerce',
				'event_label': 'checkout_option_step_' + checkout.step
			});
		},

		// Track checkout reviewed (process card clicked)
		checkoutReviewed: function (checkout) {
			checkout.step = 4;
			checkout.option = 'Payment Entered';
			checkout.value = Drupal.settings.track.checkout.total;
			app.tracking.checkoutEngage(checkout);
		},

		// Track checkout page validation error
		checkoutError: function (error) {
			app.tracking.gtag('event', 'checkout_error', {
				'non_interaction': false,
				'event_category': 'ecommerce',
				'event_label': 'checkout_error',
				'event_value': error.message
			});
		},

    // Payment complete event
    paymentComplete: function (checkout) {
      // Google
      let googleItems = [];
      for(let i in checkout.items) {
        if (checkout.items.hasOwnProperty(i)) {
          googleItems.push(app.tracking.modifyProduct(checkout.items[i],'google'));
        }
      }
      app.tracking.gtag('event', 'payment_link', {
        'transaction_id': checkout.transaction_id,
        'affiliation': "Online Store",
        'shipping': checkout.shipping,
        'tax': checkout.tax,
        'value': checkout.value, // Verify this value
        'items': app.tracking.remarketing(googleItems),
        'coupon': checkout.coupon,

        'non_interaction': true,
        'event_category': 'ecommerce',
        'event_label': 'order_confirmation'
      });
    },

    membershipComplete: function(checkout) {
      // Google
			let googleItems = [];
      let productSubtotal = 0;
			for(let i in checkout.items) {
				if (checkout.items.hasOwnProperty(i)) {
					googleItems.push(app.tracking.modifyProduct(app.tracking.cartItemToPageItem(checkout.items[i]),'google'));

          // Get the product subtotal
          if (typeof checkout.items[i].nid !== 'undefined' && parseInt(checkout.items[i].nid) !== 4047 && parseInt(checkout.items[i].nid) !== 4085) {
            productSubtotal += (checkout.items[i].quantity * checkout.items[i].price);
          }
				}
			}

      app.tracking.gtag('event', 'membership', {
				'transaction_id': checkout.transaction_id,
        'order_id': checkout.id,
        'discount': typeof checkout.discount !== 'undefined' ? checkout.discount : 0.00,
        'product_subtotal': Math.round(productSubtotal,2),
				'shipping': checkout.shipping,
				'tax': checkout.tax,
				'value': checkout.value,
        'currency': app.getCurrency(),
				'items': app.tracking.remarketing(googleItems),
				'coupon': checkout.coupon,

				'non_interaction': true,
			});
    },

		// Track checkout form completed
		checkoutComplete: function (checkout) {
			// Google
			let googleItems = [];
      let productSubtotal = 0;
			for(let i in checkout.items) {
				if (checkout.items.hasOwnProperty(i)) {
					googleItems.push(app.tracking.modifyProduct(app.tracking.cartItemToPageItem(checkout.items[i]),'google'));

          // Get the product subtotal
          if (typeof checkout.items[i].nid !== 'undefined' && parseInt(checkout.items[i].nid) !== 4047 && parseInt(checkout.items[i].nid) !== 4085) {
            productSubtotal += (checkout.items[i].quantity * checkout.items[i].price);
          }
				}
			}
      // UA
      /*
			app.tracking.gtag('event', 'purchase', {
				'transaction_id': checkout.transaction_id,
				'affiliation': "Online Store",
				'shipping': checkout.shipping,
				'tax': checkout.tax,
				'value': checkout.value,
				'items': app.tracking.remarketing(googleItems),
				'coupon': checkout.coupon,

				'non_interaction': true,
				'event_category': 'ecommerce',
				'event_label': 'order_confirmation'
			});
       */

      // GA4
      app.tracking.gtag('event', 'purchase', {
				'transaction_id': checkout.transaction_id,
        'order_id': checkout.id,
        'discount': typeof checkout.discount !== 'undefined' ? checkout.discount : 0.00,
        'product_subtotal': Math.round(productSubtotal,2),
				'shipping': checkout.shipping,
				'tax': checkout.tax,
				'value': checkout.value,
        'currency': app.getCurrency(),
				'items': app.tracking.remarketing(googleItems),
				'coupon': checkout.coupon,

				'non_interaction': true,
			});

			if (typeof checkout.has_mulberry !== 'undefined' && checkout.has_mulberry) {
				app.tracking.gtag('event', 'mulberry', {
					'non_interaction': true,
					'event_category': 'ecommerce',
					'event_label': 'order_mulberry'
				});
			}

			// Facebook conversion
			let line_items = [];
			let ids = [];
			let rora_products = [];
			for (let k in checkout.items) {
				if (checkout.items.hasOwnProperty(k)) {
					// Omit Mulberry or Memberships
					if (typeof checkout.items[k].nid !== 'undefined' && (parseInt(checkout.items[k].nid) === 4047 || parseInt(checkout.items[k].nid) === 4085)) {
						continue;
					}
					let isvariant = /-[0-9]/.test(checkout.items[k].id);
					let i = {
						id: app.tracking.modifyProductID(checkout.items[k],'facebook'),
						quantity: checkout.items[k].quantity,
						item_price: checkout.items[k].price
					};
					line_items.push(i);
					ids.push(app.tracking.modifyProductID(checkout.items[k],'facebook'));
					if (checkout.items[k].category === 'Accents/Bed Accessories/Bedding') {
						rora_products.push(i);
					}
				}
			}

			let fbqparams = {
				contents: line_items,
				content_type: 'product',  // 'product' if we are passing in full variant
				content_ids: ids,
				product_catalog_id: app.tracking.facebook_catalog_id,
				value: checkout.value,
				currency: Drupal.settings.track.currency
			};
			app.tracking.fbq('track', 'Purchase', fbqparams);

      /*
			// Bing conversion
			app.tracking.bing('event', '', {
				revenue_value: checkout.value,
				currency: Drupal.settings.track.currency
			});
       */

      // Pinterest
			line_items = [];
			for (let k in checkout.items) {
				if (checkout.items.hasOwnProperty(k)) {
					line_items.push({
						product_quantity: checkout.items[k].quantity,
						product_price: checkout.items[k].price,
						product_id: app.tracking.modifyProductID(checkout.items[k],'pinterest'),
						//product_variant_id: app.tracking.modifyProductID(checkout.items[k],'pinterest'),
						//product_name: checkout.items[k].name,
						//product_brand: 'Rove Concepts',
						product_category: 'Furniture'
					});
				}
			}
      if (app.tracking.pinterest_enabled) {
        app.tracking.pintrk('track', 'Checkout', {
          value: checkout.value,
          order_id: checkout.id,
          order_quantity: line_items.length,
          currency: Drupal.settings.track.currency,
          line_items: line_items
        });
      }

			// Rakuten
			/*
			line_items = [];
			for (let k in checkout.items) {
				if (checkout.items.hasOwnProperty(k)) {
					line_items.push({
						quantity: checkout.items[k].quantity,
						unitPrice: checkout.items[k].price,
						unitPriceLessTax: checkout.items[k].price, // (TODO)
						SKU: checkout.items[k].id,
						productName: checkout.items[k].name,
						optionalData: {
							brand: 'Rove Concepts',
							cat: checkout.items[k].category,
							coupon: checkout.coupon
						}

					});
				}
			}
			app.tracking.rakuten('event', 'purchase', {
				affiliateConfig: {
					ranMID: "44428",
					discountType: "item",
					includeStatus: "false"
				},

				orderid: checkout.id,
				currency: Drupal.settings.track.currency,
				customerStatus: app.tracking.getCustomerType(),
				conversionType: "Sale",
				customerID: checkout.customer,
				discountCode: checkout.coupon,
				discountAmount: (checkout.discount * -1),
				taxAmount: checkout.tax,
				optionalData: {},    //THIS IS OPTIONAL
				lineitems: line_items
			});
			*/

			// Upsellit
			app.tracking.upsellit('event', 'purchase', {
				orderid: checkout.id,
				currency: Drupal.settings.track.currency,
				revenue: checkout.value
			});

      // Naver (Korea)
      // Events: Purchase (1), Membership Reg (2), Add to Cart (3), Request/Reservation (4), Other (5)
      app.tracking.naver('track', 1, { value: checkout.value });

			// Quantcast
			/*
			app.tracking.quantcast('event', 'purchase', {
				orderid: checkout.id,
				customerStatus: app.tracking.getCustomerType(),
				currency: Drupal.settings.track.currency,
				customerID: checkout.customer,
				discountCode: checkout.coupon,
				discountAmount: (checkout.discount * -1),
				taxAmount: checkout.tax,
				revenue: checkout.value
			});
			 */

			// Podsights
			app.tracking.podsights('event','purchase',{
				value: checkout.value,
				currency: Drupal.settings.track.currency,
				discount_code: checkout.coupon,
				order_id: checkout.id
			});
		},

		getCustomerType: function () {
			//New, Existing, or Returning

			if (typeof Drupal.settings.track.user.id !== 'undefined' &&
					(((new Date()).getTime()/1000|0) - Drupal.settings.track.user.created > 86400
							|| Drupal.settings.track.user.orders > 1)) {
				return 'Existing';
			}

			if (app.justuno.getCount() > 1) {
				return 'Returning';
			}

			return 'New';
		},

		// Track order success page
		viewCheckoutSuccess: function (order) {

		},

		// Track Error Page
		error: function (error) {

		},

    // Track checkout page validation error
		directionsClicked: function (location) {
			app.tracking.gtag('event', 'directions_click', {
				'non_interaction': false,
				'event_category': 'engagement',
				'event_label': 'directions_click',
				'event_value': location.location
			});
		},

		// Snap Engage Chat initiator
		snapEngagePayload: function() {
			(function() {
				var se = document.createElement('script'); se.type = 'text/javascript'; se.async = true;
				let scriptId = '83ed3d02-b5ff-43f1-8fd4-17ab3e6ebedb';
				let country = 'CA';
				if (typeof Drupal.settings.track.set !=='undefined'){
					country = Drupal.settings.track.set.country;
				}
				switch (country){
					case 'HK':
						scriptId = 'e2d00296-3b46-4ef2-acaa-fbd3cdeeddb7';
						break;
					case 'AU':
						scriptId = '7c8ae2a5-382c-4414-8b80-2257daddea90';
						break;
					case 'KR':
						scriptId = '377ce4aa-197b-40d5-8787-8578f0fa4edf';
						break;
					default:
						scriptId = '83ed3d02-b5ff-43f1-8fd4-17ab3e6ebedb';
						break;
				}
				se.src = 'https://storage.googleapis.com/code.snapengage.com/js/'+scriptId+'.js';
				var done = false;
				se.onload = se.onreadystatechange = function() {
					if (!done&&(!this.readyState||this.readyState==='loaded'||this.readyState==='complete')) {
						done = true;
						if (typeof app !== "undefined" && typeof app.tracking !== "undefined") {
							app.tracking.chat();
						}

						/* Custom SnapEngage JS */
						/*
						  Custom API code to pop-up the Pre-Chat Form on a specific webpage
						  Proactive Chat has been disabled for this page, to not interrupt!
						*/

						var popup_closed = app.tracking.getCookie('live_chat_closed');

						var webpageToShowPopup = 'test.html';
						var secondsToWait = 30;

						// If the visitor is on this specific webpage
						if (typeof popup_closed === "undefined" || !popup_closed || window.location.href.indexOf(webpageToShowPopup) > -1) {

						  // Disable proactive chat for this webpage
						  SnapEngage.allowProactiveChat(false);

						  // Wait X seconds
						  setTimeout(function() {
							// Check if agents are online
							SnapEngage.getAgentStatusAsync(function(online) {
							  // If agents are online
							  if (online) {
								// Show the pre-chat form*
								// *Requires that you've 'enabled' the pre-chat form in your Admin Dashboard
								SnapEngage.startLink();
							  }
							});
						  }, secondsToWait * 1000);

							app.tracking.setCookie('live_chat_closed', 1, 1);
						}
						/* End Custom SnapEngage JS */

					}
					// var iframe = $('#designstudio-iframe');
					// $('#icon-minimize', iframe.contents()).on('click',function(e){
					// 	app.tracking.setCookie('live_chat_closed', 1, 1095);
					// });
					// $('#icon-close', iframe.contents()).on('click',function(e){
					// 	app.tracking.setCookie('live_chat_closed', 1, 1095);
					// });
				};
				var s = document.getElementsByTagName('script')[0]; s.parentNode.insertBefore(se, s);
			})();
		},

		freshdeskPayload: function() {
			const loadScript = (src, callback) => {
				const script = document.createElement('script');
				script.src = src;
				script.async = true;
				script.onload = callback;
				document.head.appendChild(script);
			};

			const initFreshchat = () => {

				window.fcSettings = {
					token: "c4fc8168-cf13-4192-aa31-108f8b4d2eb1",
					host: "https://roveconcepts.freshchat.com",
					widgetUuid: "49d88ed6-ba68-4132-a3b9-19b6db65ed82",
					config: {
						cssNames: {
							widget: 'custom_fc_frame',
							expanded: 'custom_fc_expanded'
						}
					}
				};

				loadScript("https://roveconcepts.freshchat.com/js/widget.js");
			};

			// Load the pre-chat form library first, then initialize widget
			 loadScript("https://snippets.freshchat.com/js/fc-pre-chat-form-v2.min.js", initFreshchat);
		},

		initProactiveChat: function() {
			const DELAY_MS = 60000; // 1 minute
			const COOLDOWN_MS = 24 * 60 * 60 * 1000; // 24 hours
			const KEY = 'freshchat:nextAllowedAt';

			const now = () => Date.now();
			const getNextAllowed = () => parseInt(localStorage.getItem(KEY) || '0', 10);
			const inCooldown = () => now() < getNextAllowed();
			const startCooldown = () => localStorage.setItem(KEY, String(now() + COOLDOWN_MS));

			function openFreshchat() {
				try {
					const chatButton = document.querySelector('.d-hotline');
					if (!chatButton) {
						setTimeout(openFreshchat, 2000);
						return;
					}
					chatButton.click();

					setTimeout(() => {
						if (window.fcWidget && window.fcWidget.on) {
							window.fcWidget.on('widget:closed', function() {
								startCooldown();
							});
						}
					}, 2000);
				} catch (e) {
					// ignore
				}
			}

			function whenFreshchatReady(cb) {
				// If API is already ready, run immediately
				if (window.fcWidget && typeof window.fcWidget.open === 'function') return cb();

				// If event bus exists, hook into widget:ready
				if (window.fcWidget && typeof window.fcWidget.on === 'function') {
					window.fcWidget.on('widget:ready', cb);
					return;
				}

				// Fallback: poll until the API is available
				const iv = setInterval(() => {
					if (window.fcWidget && typeof window.fcWidget.open === 'function') {
						clearInterval(iv);
						cb();
					}
				}, 300);
			}

			setTimeout(() => {
				if (!inCooldown()) whenFreshchatReady(openFreshchat);
			}, DELAY_MS);
		},

		// Pinterest tracking code
		pinterestPayload: function() {
			!function(e){if(!window.pintrk){window.pintrk = function () {
				window.pintrk.queue.push(Array.prototype.slice.call(arguments))};var
					n=window.pintrk;n.queue=[],n.version="3.0";var
					t=document.createElement("script");t.async=!0,t.src=e;var
					r=document.getElementsByTagName("script")[0];
				r.parentNode.insertBefore(t,r)}}("https://s.pinimg.com/ct/core.js");
			pintrk('load', app.tracking.pinterest_customer_id, {em: Drupal.settings.track.user.hash});
			pintrk('page');
		},

		// Footer of the Rakuten conversion tag (here to keep it clean)
		/*
		rakutenConversionPayload: function(rm_trans) {
			//Do not edit any information beneath this line
			window.DataLayer?(DataLayer.events=DataLayer.events||{},DataLayer.Sale=DataLayer.Sale||{Basket:rm_trans},DataLayer.Sale.Basket=DataLayer.Sale.Basket||rm_trans):window.DataLayer={Sale:{Basket:rm_trans},events:{}},DataLayer.events.SPIVersion="3.3",DataLayer.Sale.Basket.Ready=!0;function __readRMCookie(e){for(var t=e+"=",a=document.cookie.split(";"),r=0;r<a.length;r++){for(var o=a[r];" "==o.charAt(0);)o=o.substring(1,o.length);if(0==o.indexOf(t))return o.substring(t.length,o.length)}return""}function __readRMCookiev2(e,t){for(var a=__readRMCookie(t=t||"rmStore");a!==decodeURIComponent(a);)a=decodeURIComponent(a);for(var r=a.split("|"),o=0;o<r.length;o++){var n=r[o].split(":")[0],i=r[o].split(":")[1];if(n===e)return i}return""}function __readParam(e,t,a,r){var o=t||"",n=a||"",i=r||{},s=__readRMCookiev2(e||""),d=i[o],u=(s=i.ignoreCookie||!1?0:s)||d||n;return u=("string"!=typeof u||"false"!==u.toLowerCase())&&u}function sRAN(){var e=DataLayer&&DataLayer.Sale&&DataLayer.Sale.Basket?DataLayer.Sale.Basket:{},t=e.affiliateConfig||{},a=__readParam("atm","tagType","pixel",t),r=__readParam("adr","discountType","order",t),o=__readParam("acs","includeStatus","false",t),n=__readParam("arto","removeOrderTax","false",t),i=__readParam("artp","removeTaxFromProducts","false",t),s=__readParam("artd","removeTaxFromDiscount","false",t),d=__readParam("atr","taxRate",0,t),u=(100+(d=Number(d)))/100,m=__readParam("ald","land",!1,{})||(t.land&&!0===t.land?__readRMCookie("ranLandDateTime"):t.land)||!1,c=__readParam("atrv","tr",!1,{})||(t.tr&&!0===t.tr?__readRMCookie("ranSiteID"):t.tr)||!1,l=!1,p=__readParam("amid","ranMID","",t)||e.ranMID;if(!p)return!1;if(!(void 0===t.allowCommission||"false"!==t.allowCommission))return!1;var y=encodeURIComponent(e.orderid||"OrderNumberNotAvailable"),v="",N="",f="",C="",_=e.currency||"";_=encodeURIComponent(_.toUpperCase());var h=e.taxAmount?Math.abs(Math.round(100*Number(e.taxAmount))):0,I=e.discountAmount?Math.abs(Math.round(100*Number(e.discountAmount))):0;s&&d&&(I=Math.round(I/u));var g="pixel"===a?"ep":"mop"===a?"eventnvppixel":"ep",D=(e.customerStatus||"")+"",R=document.location.protocol+"//track.linksynergy.com/"+g+"?",b="";D&&(o&&"EXISTING"==D.toUpperCase()||o&&"RETURNING"==D.toUpperCase())&&(b="R_");for(var L=[],U=0,S=0;S<(e.lineitems?e.lineitems.length:0);S++){var T=!1,w=window.JSON?JSON.parse(JSON.stringify(e.lineitems[S])):e.lineitems[S],P=Number(w.unitPriceLessTax||w.unitPrice||0);i&&d&&!w.unitPriceLessTax&&(P/=u);for(var x=0;x<L.length;x++){L[x].SKU===w.SKU&&(T=!0,L[x].quantity=Number(L[x].quantity)+Number(w.quantity),L[x].totalValueLessTax=Number(L[x].totalValueLessTax)+Number(w.quantity)*P,L[x].totalValue=Number(L[x].totalValue)+Number(w.quantity)*Number(w.unitPrice))}T||(w.totalValue=Number(w.quantity)*Number(w.unitPrice),w.totalValueLessTax=Number(w.quantity)*P,L.push(w)),U+=Number(w.quantity)*P*100}var A={};for(S=0;S<L.length;S++){w=L[S];var k=encodeURIComponent(w.SKU),O=w.totalValueLessTax||w.totalValue,M=w.quantity,E=encodeURIComponent(w.productName)||"",q=100*Number(O);"item"===r.toLowerCase()&&I&&(q-=I*q/U);var B=w.optionalData;for(var V in B)B.hasOwnProperty(V)&&(A[V]=A[V]||"",A[V]+=encodeURIComponent(B[V])+"|");v+=b+k+"|",N+=M+"|",f+=Math.round(q)+"|",C+=b+E+"|"}v=v.slice(0,-1),N=N.slice(0,-1),f=f.slice(0,-1),C=C.slice(0,-1),I&&"order"===r.toLowerCase()?(v+="|"+b+"DISCOUNT",C+="|"+b+"DISCOUNT",N+="|0",f+="|-"+I):I&&"item"===r.toLowerCase()&&(l=!0),n&&h&&(v+="|"+b+"ORDERTAX",N+="|0",f+="|-"+h,C+="|"+b+"ORDERTAX"),R+="mid="+p+"&ord="+y+"&skulist="+v+"&qlist="+N+"&amtlist="+f+"&cur="+_+"&namelist="+C+"&img=1&",m&&(R+="land="+m+"&"),c&&(R+="tr="+c+"&"),l&&(R+="discount="+I+"&");B=e.optionalData||{};e.discountCode&&(B.coupon=e.discountCode),e.customerStatus&&(B.custstatus=e.customerStatus),e.customerID&&(B.custid=e.customerID),I&&(B.disamt=I);for(var V in B)B.hasOwnProperty(V)&&(R+=encodeURIComponent(V)+"="+encodeURIComponent(B[V])+"&");for(var V in A)A.hasOwnProperty(V)&&(R+=encodeURIComponent(V)+"list="+A[V].slice(0,-1),I&&"order"===r.toLowerCase()&&(R+="disamt"==V||"margin"==V?"|0":"|DISCOUNT"),h&&n&&(R+="disamt"==V||"margin"==V?"|0":"|ORDERTAX"),R+="&");"&"===R[R.length-1]&&(R=R.slice(0,-1)),R.length>2037&&(R=R.slice(0,2037),R+="&trunc=true");var j,K=document.createElement("img");K.setAttribute("src",R),K.setAttribute("height","1px"),K.setAttribute("width","1px"),(j=document.getElementsByTagName("script")[0]).parentNode.insertBefore(K,j)}function sDisplay(){var e=null,t=e,a=e,r=e,o=e,n=window.DataLayer&&window.DataLayer.Sale&&window.DataLayer.Sale.Basket?window.DataLayer.Sale.Basket:{},i=n.displayConfig||{},s=(n.customerStatus||"")+"",d=n.discountAmount?Math.abs(Number(n.discountAmount)):0,u=e,m="",c=__readParam("dmid","rdMID","",i);if(!c)return!1;var l=__readParam("dtm","tagType","js",i),p="if"===(l="js"===l||"if"===l||"img"===l?l:"js")?"iframe":"img"===l?l:"script",y="//"+__readParam("ddn","domain","tags.rd.linksynergy.com",i)+"/"+l+"/"+c,v=__readParam("dis","includeStatus","false",i),N=__readParam("dcomm","allowCommission","notset",i);"true"===N||!0===N||"1"===N||1===N?m="1":"false"!==N&&!1!==N&&"0"!==N&&0!==N||(m="0");var f="";if(s&&(v&&"EXISTING"==s.toUpperCase()||v&&"RETURNING"==s.toUpperCase())&&(f="R_"),!n.orderid||!n.conversionType)return!1;r=0,a=encodeURIComponent(f+n.orderid),t="",o="conv",u=encodeURIComponent(n.currency||"");for(var C=0;C<(n.lineitems?n.lineitems.length:0);C++)r+=Number(n.lineitems[C].unitPriceLessTax)*Number(n.lineitems[C].quantity)||Number(n.lineitems[C].unitPrice)*Number(n.lineitems[C].quantity),t+=encodeURIComponent(n.lineitems[C].SKU)+",";r=Math.round(100*(r-d))/100,t=t.slice(0,-1),o&&(y=y.indexOf("?")>-1?y+"&pt="+o:y+"/?pt="+o),t&&(y=y.indexOf("?")>-1?y+"&prodID="+t:y+"/?prodID="+t),a&&(y=y.indexOf("?")>-1?y+"&orderNumber="+a:y+"/?orderNumber="+a),r&&(y=y.indexOf("?")>-1?y+"&price="+r:y+"/?price="+r),u&&(y=y.indexOf("?")>-1?y+"&cur="+u:y+"/?cur="+u),m&&(y=y.indexOf("?")>-1?y+"&tvalid="+m:y+"/?tvalid="+m);var _=document.createElement(p);_.src=y,"script"===p?_.type="text/javascript":"iframe"===p&&_.setAttribute("style","display: none;"),document.getElementsByTagName("body")[0].appendChild(_)}function sSearch(){var e=window.DataLayer&&window.DataLayer.Sale&&window.DataLayer.Sale.Basket?window.DataLayer.Sale.Basket:{},t=e.searchConfig||{},a=encodeURIComponent("...TRUNCATED"),r=__readParam("smid","rsMID","",t);if(!r)return!1;var o=__readParam("said","accountID","113",t),n=function(){var n={};if(n.conversionType=encodeURIComponent(__readParam("sct","conversionType",e.conversionType&&"sale"!==(e.conversionType+"").toLowerCase()?e.conversionType:"conv",t)),n.revenue=0,n.currency=encodeURIComponent(e.currency||"USD"),n.orderId=encodeURIComponent(e.orderid||""),n.promoCode=encodeURIComponent(e.discountCode||""),n.discountAmount=e.discountAmount?Math.abs(Number(e.discountAmount)):0,n.customerStatus=encodeURIComponent(e.customerStatus||""),n.productIDList="",n.productNameList="",e.lineitems&&e.lineitems.length){for(var i=0;i<e.lineitems.length;i++)n.revenue+=Number(e.lineitems[i].unitPrice||0)*Number(e.lineitems[i].quantity),n.productIDList+=(e.lineitems[i].SKU||"NA")+",",n.productNameList+=(e.lineitems[i].productName||"NA")+",";n.revenue=Math.round(100*(n.revenue-n.discountAmount))/100,n.productIDList=encodeURIComponent(n.productIDList.slice(0,-1)),n.productNameList=encodeURIComponent(n.productNameList.slice(0,-1)),n.productIDList.length>1024&&(n.productIDList=n.productIDList.substring(0,1024-a.length)+a),n.productNameList.length>1024&&(n.productNameList=n.productNameList.substring(0,1024-a.length)+a)}kenshoo.trackConversion(o,r,n)},i=document.location.protocol.indexOf("s")>-1?"https://":"http://";i+="services.xg4ken.com/js/kenshoo.js?cid="+r;var s=document.createElement("script");s.type="text/javascript",s.src=i,s.onload=n,s.onreadystatechange=function(){"complete"!=this.readyState&&"loaded"!=this.readyState||n()},document.getElementsByTagName("head")[0].appendChild(s)}sRAN(),sDisplay(),sSearch();
		},
		*/

		podsightsPayload: function() {
			(function(w, d){
				var id='pdst-capture', n = 'script';
				if (!d.getElementById(id)){
					w.pdst = w.pdst || function() {(w.pdst.q = w.pdst.q || []).push(arguments);};
					var e = d.createElement(n); e.id = id; e.async=1;
					e.src = 'https://cdn.pdst.fm/ping.min.js';
					var s = d.getElementsByTagName(n)[0];
					s.parentNode.insertBefore(e, s);
				}
				w.pdst('conf', { key: '939e0f8bcc6d4c56905b4c6d8a3a49c0' });
				w.pdst('view');
			})(window, document);
		},

		quantcastPayload: function() {
			window._qevents = window._qevents || [];
			(function() {
				var elem = document.createElement('script');
				elem.src = (document.location.protocol == "https:" ? "https://secure" : "http://edge") + ".quantserve.com/quant.js";
				elem.async = true;
				elem.type = "text/javascript";
				var scpt = document.getElementsByTagName('script')[0];
				scpt.parentNode.insertBefore(elem, scpt);
			})();
			window._qevents.push({
				qacct:app.tracking.quantcast_id
			});
		},

		setCookie: function(cname, cvalue, exdays) {
			const d = new Date();
			d.setTime(d.getTime() + (exdays*24*60*60*1000));
			let expires = "expires="+ d.toUTCString();
			document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
		},

		getCookie: function(cname) {
			let name = cname + "=";
			let decodedCookie = decodeURIComponent(document.cookie);
			let ca = decodedCookie.split(';');
			for(let i = 0; i <ca.length; i++) {
				let c = ca[i];
				while (c.charAt(0) == ' ') {
					c = c.substring(1);
				}
				if (c.indexOf(name) == 0) {
					return c.substring(name.length, c.length);
				}
			}
			return "";
		}

	};

}(window.app = window.app || {}, jQuery));


(function ($) {
	Drupal.behaviors.roveTracking = {
		attach: function (context, settings) {
			if (typeof Drupal.settings.track === 'undefined') {
				return;
			}
			// Waiting for snowplow to be loaded
			/*
			snowplow(function() {
			  // TODO: When ajax page ads more links...
				// snowplow('refreshLinkClickTracking');
			});
			*/

		} // END attach function
	}; //END DRUPAL behaviors object

	// callback when item is added to cart (rove2018_ajax_render_alter())
	Drupal.ajax.prototype.commands.ucGTMAjaxAddCartComplete = function (ajax, response, status) {
		var nid = $('.add-to-cart>form').attr('id').replace(/[^0-9]+/, '');
		var product = Drupal.settings.track.items[parseInt(nid)];
		let variant = app.product.getSelectedModel(app.product.getSelectedOptions());
		product['price'] = typeof Drupal.settings.models_stock[variant].p !== 'undefined' ? Drupal.settings.models_stock[variant].p : product.price;
		product['variant'] = variant;
		product['quantity'] = $('.form-type-uc-quantity>input, .form-item-qty>select :selected').val();
		Drupal.settings.track.cart.products = response.items;
		// We already track this with a mousedown event above
		//app.tracking.addToCart(product);
	};

	// callback when item is added to notify me (rove2018_ajax_render_alter())
	Drupal.ajax.prototype.commands.ucAjaxEventNotifyMe = function (ajax, response, status) {
		let product = Drupal.settings.track.events.viewProduct;
		product.quantity = response.qty;
		product.variant = response.model;
		app.tracking.notifyMe(product, response.email);
	};

	// callback when item is added to notify me (rove2018_ajax_render_alter())
	Drupal.ajax.prototype.commands.ucAjaxEventCoupon = function (ajax, response, status) {
		// Update the checkout total now that we changed coupons...
		Drupal.settings.track.checkout.total = response.total;
		app.tracking.coupon(response.op, response.coupon);
	};

	// callback when item is added to notify me (rove2018_ajax_render_alter())
	Drupal.ajax.prototype.commands.ucAjaxEventCheckout = function (ajax, response, status) {
		app.tracking.track(response.event, response.params);
	};

	// Callback when shipping method is changed.
	Drupal.ajax.prototype.commands.ucAjaxEventQuote = function (ajax, response, status) {
		// Update the order total
		Drupal.settings.track.checkout.total = response.total;
		// shipping = response.quote;
	};

	/**
	 * Capture the event triggered by hook_live_info_alter().
	 * @param ajax
	 * @param response
	 * @param status
	 */
	Drupal.ajax.prototype.commands.ucAjaxEventsDynamic = function (ajax, response, status) {
		Drupal.settings.tracker = response;
		Drupal.settings.track = Object.assign(Drupal.settings.track, response.track);

		app.tracking.init();
	};

})(jQuery);
/*!
 * app.klaviyo.js
 */
(function(app, $) {
	let $cache = {
		pnids: [],
		document: null,
		window: null
	};

	function initializeCache() {
		$cache.document = $(document);
		$cache.window = $(window);
	}

	function initializeDom() {
		/**
		 * Identify a logged in user first!
		 */
		if (Drupal.settings.rove.user && typeof Drupal.settings.rove.user.email !== 'undefined') {
			app.klaviyo.trackUser('user',Drupal.settings.rove.user);
			if ($.isFunction($(window).klaviyoApi)) {
				$(document).klaviyoApi({op: 'user', data: Drupal.settings.rove.user});
			}
		}

		/**
		 * Determines if this is a product listing page.
		 */
		if (Drupal.settings.klaviyo && Drupal.settings.klaviyo.type === "product_view") {
			app.klaviyo.track('product','viewed',Drupal.settings.klaviyo.data);
		}
	}

	function initializeEvents() {
		/**
		 * Handles clicks to add to cart
		 * Measure adding a product to a shopping cart by using an 'add' actionFieldObject
		 * and a list of productFieldObjects.
		 */
		/*
		 // Add to cart is done through ajax callback.
		 //$('.node-add-to-cart').off('click.seg');
		 $cache.document.on('click.seg','.node-add-to-cart', function () {
			 let nid = $('.add-to-cart>form').attr('id').replace(/[^0-9]+/, '');
			 let item = app.klaviyo.klaviyoParseProduct(Drupal.settings.product);
			 item.cart_id = '';
			 Drupal.settings.klaviyo.data.quantity = $('.form-type-uc-quantity>input, .form-item-qty>select :selected').val();
			 item.quantity = $('.form-type-uc-quantity>input, .form-item-qty>select :selected').val();
			 app.klaviyo.track('product','addtocart',Drupal.settings.klaviyo);
		 });
		 */

		/**
		 * Call this function when a user clicks on a product link. This function uses the event
		 * callback datalayer variable to handle navigation after the ecommerce data has been sent
		 * to Google Analytics.
		 * @param {Object} productObj An object representing a product.
		 */
		//$('[data-pnid]').off('click.seg');
		$cache.document.on('click.seg','[data-pnid]', function () {
			let nid = $(this).data('pnid');
			if ($.inArray(nid,$cache.pnids) >= 0) {
				if (typeof Drupal.settings.klaviyo !== 'undefined' && typeof Drupal.settings.klaviyo.products !== 'undefined') {
					$(Drupal.settings.klaviyo.products).each(function (i, e) {
						if (parseInt(e.product_id) === parseInt(nid)) {
							app.klaviyo.track('product','clicked',e);
						}
					});
				}
				$cache.pnids.push(nid);
			}
		});

		$cache.document.on('pre_product_change',function() {
			if (typeof Drupal.settings.klaviyo.data.Parent !== 'undefined') {
				Drupal.settings.klaviyo.data.Parent = Drupal.settings.klaviyo.data.SKU;
			}
			Drupal.settings.klaviyo.data.SKU = $('.breakdown .model').html();
			Drupal.settings.klaviyo.data.ClickedSwatch = $('.opt'+Drupal.settings.last_clicked_oid).attr('title');
			let segdata = Drupal.settings.klaviyo.data;
			segdata.oid = parseInt(Drupal.settings.last_clicked_oid);
			app.klaviyo.track('product','change',segdata);
		});

		/**
		 * Handles remove from cart
		 */
		//$('.cart_desc_actions .btn-danger').off('click.seg');
		$cache.document.on('click.seg','.cart_desc_actions .btn-danger', function () {
			let pos = parseInt($(this).attr('name').replace('remove-', ''));
			let item = Drupal.settings.klaviyo.data.products[pos];
			item.cart_id = Drupal.settings.klaviyo.data.cart_id;
			app.klaviyo.track('product','removefromcart',item);
		});

		/**
		 * Handles page cart view.
		 */
		if (Drupal.settings.klaviyo && Drupal.settings.klaviyo.type === "cart_view") {
			app.klaviyo.track('product','cartview',Drupal.settings.klaviyo.data);
		}

    /**
     * Handles Klaviyo email signups
     */
    $cache.document.on('mousedown','form.klaviyo-formX button.needsclick',function(e) {
        let emailVal = $(this).parent().parent().prev().find('input[name="email"]').val();
        if (typeof emailVal !== 'undefined' && app.klaviyo.isValidEmail(emailVal)) {
          $(document).klaviyoApi({op: 'newsletter', data: {email: emailVal,source: 'Klaviyo'}});
          app.tracking.track('newsletter',{email: emailVal});
        }
    });

		/**
		 * Email cart
		 */
		$('#emailCartButton').on('click.seg',function(e) {
			$(this).toggleClass('on');
			$('.email-cart-form').toggleClass('hidden');
			if(!$('.email-cart-form').hasClass('hidden')) {
				$('#emailCartButton').html('CANCEL');
				$('.email-cart-form input[type="email"]').focus();
			}
			else {
				$('#emailCartButton').html('EMAIL MY CART');
			}
		});

		/**
		 * Additional email
		 */
		$('.additional-email-btn').on('click',function(e) {
			e.preventDefault();
			let input = $('<input placeholder="Email Address" class="form-control form-text form-email" type="email" autocomplete="email" name="emails[]" />');
			$('.email-cart-form .emails').append(input);
			if($('.email-cart-form .emails input').length >= 3) {
				$('.additional-email-btn').remove();
			}
		});

		/**
		 * Email cart submit
		 */
		$('.email-cart-form').on('submit',function(e) {
			e.preventDefault();
			let form = $(this);
			form.find('button').prop('disabled', true);
			let data = {};
			let emails = [];
			$.each(form.serializeArray(), function(k, v) {
				if(v.name === 'emails[]') {
					let email = $.trim(v.value);
					if(email.length) {
						emails.push(email);
					}
				}
				if(v.name ==='body') {
                    data.body = $.trim(v.value);
                }
                if (v.name === 'subscribe') {
                    data.subscribe = $.trim(v.value);
                }
			});
			data.emails = emails;
			$.ajax({
				type: 'POST',
				url: Drupal.settings.basePath + 'klaviyo/email-myself',
				contentType: 'application/json',
				data: JSON.stringify(Object.assign({}, data, Drupal.settings.klaviyo.data)),
				complete: function (XMLHttpRequest, status) {
					//console.log(data);
					$('#emailCartButton').trigger('click').html('EMAIL SENT!').prop('disabled', true);
					$(document).trigger('emailCartComplete',[data]);
				}
			});
		});

		/**
		 * Handles page forms view.
		 */
		if (Drupal.settings.klaviyo && Drupal.settings.klaviyo.form_type) {
			switch(Drupal.settings.klaviyo.form_type) {
				case 'contact':
					app.klaviyo.trackForm('form','contact',Drupal.settings.klaviyo.form_data);
					break;
				case 'swatch':
					app.klaviyo.trackForm('form','swatch',Drupal.settings.klaviyo.form_data);
					break;
				case 'trade':
					app.klaviyo.trackForm('form','trade',Drupal.settings.klaviyo.form_data);
					break;
				case 'giftcard':
					app.klaviyo.trackForm('form','giftcard',Drupal.settings.klaviyo.form_data);
					break;
			}
		}

		/**
		 * Handles when we land on a term page.
		 */
		if (Drupal.settings.klaviyo && typeof Drupal.settings.klaviyo.display_term !== "undefined") {
			app.klaviyo.track('browse','list',Drupal.settings.klaviyo.products);
		}

		/**
		 * Handles checkout steps and checkout complete.
		 */
		if (Drupal.settings.klaviyo && Drupal.settings.klaviyo.checkout_data) {
			// Checkout Started
			if (Drupal.settings.klaviyo.checkout_data.checkout_start) {
				app.klaviyo.track('product','checkout',Drupal.settings.klaviyo.checkout_data.checkout_start);
			}
			// Step Viewed
			if (false && Drupal.settings.klaviyo.checkout_data.step_viewed) {
				app.klaviyo.track('product','checkoutstep',Drupal.settings.klaviyo.checkout_data.step_viewed);
			}
			// Step Completed
			if (false && Drupal.settings.klaviyo.checkout_data.step_complete) {
				app.klaviyo.track('product','checkoutstepcomplete',Drupal.settings.klaviyo.checkout_data.step_complete);
			}
			// Payment Entered
			if (false && Drupal.settings.klaviyo.checkout_data.payment_entered) {
				app.klaviyo.track('product','checkoutpayment',Drupal.settings.klaviyo.checkout_data.payment_entered);
			}
			// Order Complete
			if (false && Drupal.settings.klaviyo.checkout_data.complete) {
				app.klaviyo.track('product','ordercomplete',Drupal.settings.klaviyo.checkout_data.complete);
			}
		}

		/**
		 * Handles all coupon functions.
		 */
		if (Drupal.settings.klaviyo && Drupal.settings.klaviyo.coupon_data) {
			// Coupon entered
			if (Drupal.settings.klaviyo.coupon_data.entered) {
				app.klaviyo.track('coupon','entered',Drupal.settings.klaviyo.coupon_data.entered);
			}
			// Coupon applied
			if (Drupal.settings.klaviyo.coupon_data.applied) {
				app.klaviyo.track('coupon','applied',Drupal.settings.klaviyo.coupon_data.applied);
			}
			// Coupon denied
			if (Drupal.settings.klaviyo.coupon_data.denied) {
				app.klaviyo.track('coupon','denied',Drupal.settings.klaviyo.coupon_data.denied);
			}
			// Coupon removed
			if (Drupal.settings.klaviyo.coupon_data.removed) {
				app.klaviyo.track('coupon','removed',Drupal.settings.klaviyo.coupon_data.removed);
			}
		}

		// Trade Form
		$('.trade-registration input.form-email, .webform-component--personal-info--first-name input, .webform-component--personal-info--last-name input, .webform-component--personal-info--phone-number input').on('change',function (e) {
			let email = $('.trade-registration input.form-email').val();
			let firstname = $('.webform-component--personal-info--first-name input').val();
			let lastname = ($('.webform-component--personal-info--last-name input').length > 0)?$('.webform-component--personal-info--last-name input').val():'';
			let phone = $('.webform-component--personal-info--phone-number input').val();

			app.klaviyo.trackFormIdentity(email,firstname,lastname,phone);
		});

    // Newsletter popup
    $(document).on('change','.ju_wrap input[type="text"]',function() {
      if (app.klaviyo.isValidEmail($(this).val())) {
        app.klaviyo.trackFormIdentity($(this).val(),'','','');
      }
    });

		// Contact Form
		$('#contact-us-form-wrapper input.form-email, #contact-us-form-wrapper .webform-component--contact--name input, #contact-us-form-wrapper .webform-component--contact--phone-number input').on('change',function (e) {
			let email = $('#contact-us-form-wrapper .contact-us-form input.form-email').val();
			let firstname = $('#contact-us-form-wrapper .webform-component--contact--name input').val();
			let phone = $('#contact-us-form-wrapper .webform-component--contact--phone-number input').val();

			app.klaviyo.trackFormIdentity(email,firstname,'',phone);
		});

		// Swatch Form
		$('.swatch_form .form-item-email input, .swatch_form .form-item-first-name input, .swatch_form .form-item-last-name input, .swatch_form .form-item-phone input').on('change',function () {
			let email = $('.swatch_form .form-item-email input').val();
			let firstname = $('.swatch_form .form-item-first-name input').val();
			let lastname = $('.swatch_form .form-item-last-name input').val();
			let phone = $('.swatch_form .form-item-phone input').val();

			app.klaviyo.trackFormIdentity(email,firstname,lastname,phone);
		});

    // Newsletter Footer
    $('.klaviyo-subscribe-form .form-type-emailfield input').on('change',function (e) {
      let email = $('.klaviyo-subscribe-form .form-type-emailfield input').val();

      app.klaviyo.trackFormIdentity(email,'','','');
    });

    // Outlet email form
    $('input#outlet-klaviyo-email').on('change',function (e) {
      let email = $('input#outlet-klaviyo-email').val();

      app.klaviyo.trackFormIdentity(email,'','','');
    });

		// SnapEngage user
		if (typeof SnapABug !== 'undefined') {
			SnapABug.setCallback('StartChat', function (email, msg, type) {
				app.klaviyo._track({op: 'chat', data: {'email': email, 'msg': msg, 'type': type}});
			});
		}

		// Justuno signup
		$cache.document.on('JustunoOptinSuccess', function( event, om_email ){
			if(om_email){
				app.klaviyo._track({op: 'newsletter', data: {email: om_email,source: 'RoveWeb'}});
				app.klaviyo.gaNewsletterSignup(om_email);
			}
		});

		$cache.document.on('KlaviyoSignup', function(event, data) {
			let jsonData = window.JSON.parse(data);
			if(typeof jsonData.email !== 'undefined'){
				app.klaviyo._track({op: 'newsletter', data: {email: jsonData.email,source: 'Website'}});
			}
			app.klaviyo.gaNewsletterSignup(typeof jsonData.email !== 'undefined' ? jsonData.email : '');
		});
	}

	app.klaviyo = {
		init: function () {
			initializeCache();
			initializeDom();
			initializeEvents();
		},

    isValidEmail: function(email) {
      var regex = /^(([^<>()[\]\.,;:\s@\"]+(\.[^<>()[\]\.,;:\s@\"]+)*)|(\".+\"))@(([^<>()[\]\.,;:\s@\"]+\.)+[^<>()[\]\.,;:\s@\"]{2,})$/i;
      return regex.test(email);
    },

		gaNewsletterSignup: function(email) {
			app.tracking.track('newsletter',{email: email});
			//app.tracking.conversion('Newsletter');
		},

		_track: function (params) {
			if ($.isFunction($cache.window.klaviyoApi)) {
				$cache.document.klaviyoApi(params);
			}
		},

		track: function (op, action, data) {
			app.klaviyo._track({op: op, action: action, data: data});
		},

		trackForm: function (op, form, data) {
			app.klaviyo._track({op: op, form: form, data: data});
			if (op === 'form') {
				if (typeof app.tracking !== 'undefined' && app.tracking.initialized) {
					$(document).trigger('formEvent', [{
						form: form,
						data: data
					}]);
				} else {
					// app.tracking may not have loaded yet so put it in queue
					app.eventQueue['formEvent'] = {
						form: form,
						data: data
					};
				}
			}
		},

		trackUser: function (op, data) {
			app.klaviyo._track({op: op, data: data});
		},

		trackFormIdentity: function (email, firstname, lastname, phone) {
			// Do some light validation. Klaviyo will do more validation when the data is received.
			if (email && /@/.test(email)) {
				var data = {
					$email: email
				};
				if (firstname.length && lastname.length && phone.length) {
					data = {
						$email: email,
						$first_name: firstname,
						$last_name: lastname,
						$phone_number: phone
					};
				} else if (firstname.length && lastname.length) {
					data = {
						$email: email,
						$first_name: firstname,
						$last_name: lastname
					};
				} else if (firstname.length && phone.length) {
					data = {
						$email: email,
						$first_name: firstname,
						$phone_number: phone
					};
				} else if (lastname.length && phone.length) {
					data = {
						$email: email,
						$last_name: lastname,
						$phone_number: phone
					};
				} else if (firstname.length) {
					data = {
						$email: email,
						$first_name: firstname
					};
				} else if (lastname.length) {
					data = {
						$email: email,
						$last_name: lastname
					};
				} else if (phone.length) {
					data = {
						$email: email,
						$phone_number: phone
					};
				}
				app.klaviyo._track({op: 'identify', data: data});
			} else {
				//console.log('Email is invalid.');
			}
		},

		/**
		 * Parse a product for Klaviyo API.
		 *
		 * @param      {<type>}  e       { parameter_description }
		 * @return     {Object}  { description_of_the_return_value }
		 */
		klaviyoParseProduct: function (e) {
			return {
				product_id: e.nid,
				sku: e.model,
				category: typeof Drupal.settings.term.name !== "undefined" ? Drupal.settings.term.name : e.category,
				name: e.title,
				brand: e.brand_name,
				variant: typeof e.variant !== "undefined" ? e.variant : e.model,
				price: e.sale_amount === null ? parseFloat(e.sell_price) : (parseFloat(e.sell_price) - parseFloat(e.sale_amount)),
				quantity: 1,
				//coupon: 'MAYDEALS',
				position: 1
			};
		}
	};

}(window.app = window.app || {}, jQuery));



/**
 * This is klaviyo.com api integrations
 *
 * @return     {<type>}  { description_of_the_return_value }
 */
(function ($) {
	$.fn.klaviyoApi = function (args) {
		if (typeof(_learnq) == 'undefined') {
			console.log('Klaviyo is not yet integrated.');
		}

		/** Helper push function. **/
		function identify(data) {
			if (data.$email && /@/.test(data.$email)) {
				try {
					_learnq.push(["identify", data]);

					// set cookie for other uses
					$.cookie('userTrack',app.components.sha256(data.$email.toLowerCase()),{path:'/'});
          $.cookie('userTrackEmail',data.$email.toLowerCase(),{path:'/'});
					//console.log('Klaviyo Identified '+data.$email);

          // Let's also apply this to the datalayer
          if (typeof dataLayer !== 'undefined') {
            dataLayer.push({
              'event': 'formSubmitted',
              'leadsUserData': {
                'sha256_email_address': app.components.sha256(data.$email.trim().toLowerCase()),
              },
            });
          }
				} catch (err) {
					console.log('Klaviyo Not Integrated: Identify attemped with data below.');
					console.log(data);
				}
			} else {
				console.log('Could not identify as email is invalid.');
			}
		}

		/** Helper push function. **/
		function track(name,data) {
			try {
				_learnq.push(['track', name, data]);
				//console.log('Klaviyo Tracked Event '+name);
			} catch(err) {
				console.log('Klaviyo Not Integrated: Track to event '+name+' attempted with data below.');
				console.log(data);
			}
		}

		/** Helper push function. **/
		function push(type,data) {
			try {
				_learnq.push([type, data]);
				//console.log('Klaviyo Pushed Event '+type);
			} catch(err) {
				console.log('Klaviyo Not Integrated: '+type+' attempted with data below.');
				console.log(data);
			}
		}

		switch (args.op) {
			case 'identify':
				identify(args.data);
				break;
			case 'user': // confirmed on every page // TODO: Should only show this on special events
				identify({
					$email: typeof args.data.email !== 'undefined' ? args.data.email : args.data.init,
					$first_name: args.data.firstname,
					$last_name: args.data.lastname,
					$phone_number: args.data.phone
				});
				break;
			case 'newsletter':  // confirmed in custom.js signup callbacks
				identify({
					$email: args.data.email
				});
				track('Newsletter signup', args.data);
				break;
			case 'chat':  // confirmed in custom.js signup callbacks
				identify({
					$email: args.data.email
				});
				track('Chat Support', args.data);
				break;
			case 'form':
				// All forms need this info
				if (args.data.email.length > 0) {
					identify({
						$name: args.data.name,
						$first_name: args.data.firstname,
						$last_name: args.data.lastname,
						$email: args.data.email,
						$phone_number: args.data.phone,
						$country: args.data.country
					});
				}
				switch(args.form) {
					case 'swatch':
						track('Swatch request', {
							name: args.data.name,
							firstname: args.data.firstname,
							lastname: args.data.lastname,
							email: args.data.email,
							phone: args.data.phone,
							mobile_phone: args.data.mobile_phone,
							country: args.data.country,
							swatches: args.data.swatches
						});
						break;
					case 'contact':
						track('Contact request', {
							name: args.data.name,
							firstname: args.data.firstname,
							lastname: args.data.lastname,
							email: args.data.email,
							phone: args.data.phone,
							mobile_phone: args.data.mobile_phone,
							country: args.data.country,
						});
						break;
					case 'trade':
						track('Trade request', {
							name: args.data.name,
							firstname: args.data.firstname,
							lastname: args.data.lastname,
							email: args.data.email,
							phone: args.data.phone,
							mobile_phone: args.data.mobile_phone,
							company: args.data.company,
							country: args.data.country,
						});
						break;
					case 'giftcard':
						track('Giftcard sender', {
							name: args.data.sender.name,
							firstname: args.data.sender.firstname,
							lastname: args.data.sender.lastname,
							email: args.data.sender.email,
							phone: args.data.sender.phone,
							mobile_phone: args.data.sender.mobile_phone,
							amount: args.data.amount,
							country: args.data.sender.country
						});
						track('Giftcard recipient', {
							name: args.data.recipient.name,
							firstname: args.data.recipient.firstname,
							lastname: args.data.recipient.lastname,
							email: args.data.recipient.email,
							amount: args.data.amount,
							country: args.data.recipient.country
						});
						break;
				}
				break;
			case 'browse':
				switch (args.action) {
					case 'search': // Confirmed js - triggered by search-autocomplete.js
						track('Products Searched', {
							query: args.query
						});
						break;
					case 'list':   // Confirmed js - trigged by custom.js infinite scroll
						var pp = typeof args.products === "undefined" ? Drupal.settings.klaviyo.products : args.products;
						track('Product List Viewed', {
							ListID: Drupal.settings.klaviyo.term.tid,
							CategoryName: Drupal.settings.klaviyo.term.name,
							Items: pp,
							//ItemNames: pp.map(function(val) { return val.ProductName; })
							ItemNames: Drupal.settings.klaviyo.names
						});
						break;
					case 'filter':  // Confirmed js - triggers by uc_bootstrap uc_bootstrap_ajax_render_alter()
						let $avail = $('#edit-filtering-availability');
						let $brand = $('#edit-filtering-brands :selected');
						let $sale = $('#edit-filtering-stock-sale-sale');
						let $sort = $('#edit-filtering-sort');
						track('Product List Filtered', {
							list_id: Drupal.settings.klaviyo.term.tid,
							category: Drupal.settings.klaviyo.term.name,
							filters: [
								{
									type: 'availability',
									value: $avail.length && $avail.val().length ? $avail.val().replace('Availability','') : 'all'
								},
								{
									type: 'brand',
									value: $brand.length && $brand.text().length ? $avail.text().replace('Brands','') : 'all'
								},
								{
									type: 'sale',
									value: $sale.length && $sale.is(':checked')
								}
							],
							sorts: [
								{
									type: $sort.length && $sort.val().length ? $sort.val() : 'default',
									value: $sort.length && $sort.val().indexOf('DESC') ? 'asc' : 'desc'
								}
							],
							products: typeof args.products === "undefined" ? Drupal.settings.klaviyo.products : args.products
						});
						break;
				}
				break;
			case 'product':
				switch (args.action) {
					case 'clicked': // confirmed by data-pnid="" // TODO: Front page & Block listings
						track('Product Clicked', args.data);
						break;
					case 'change': // confirmed by pre_product_change
						track( 'Product Changed', args.data);
						break;
					case 'viewed': // confirmed above // TODO: When clicking on a product swatch, trigger view but change the variant
						track( 'Viewed Product', args.data);
						push('trackViewedItem', {
							Title: args.data.ProductName,
							ItemId: args.data.ProductID,
							Categories: args.data.Categories,
							ImageUrl: args.data.ImageURL,
							Url: args.data.URL,
							Metadata: {
								Brand: args.data.Brand,
								Price: args.data.Price,
								CompareAtPrice: args.data.CompareAtPrice
							}
						});
						//track( 'Product Viewed', args.data);
						break;
					case 'addtocart':   // Exists
						track( 'Product Added', args.data);// Handled by ajax_render
						break;
					case 'removefromcart':  // Exists
						track( 'Product Removed', args.data);
						break;
					case 'cartview':   // Exists
						track( 'Cart Viewed', args.data);
						break;
					case 'cartemail':
						track('Cart Saved For Later', args.data);
					case 'checkout':    // Exists
						// Note, this assumes a <form id="payment_form"> and an field <input name="email" type="email" value="" />
						var co_is_tracked = false;
						if (Drupal.settings.rove.isLoggedIn) {
							track('Started Checkout', args.data);
						} else {
							if ($('.form-item-panes-customer-primary-email input').val()) {
								var email = $('.form-item-panes-customer-primary-email input').val();
								var firstname = $('.form-item-panes-delivery-delivery-first-name input').val();
								var lastname = ($('.form-item-panes-delivery-delivery-last-name input').length> 0)?$('.form-item-panes-delivery-delivery-last-name input').val():'';
								if (email && /@/.test(email)) {
									var data = {
										$email: email
									};
									if (firstname.length && lastname.length) {
										data = {
											$email: email,
											$first_name: firstname,
											$last_name: lastname
										};
									} else if (firstname.length) {
										data = {
											$email: email,
											$first_name: firstname
										};
									} else if (lastname.length) {
										data = {
											$email: email,
											$last_name: lastname
										};
									}
									identify(data);
									if (!co_is_tracked) {
										track('Started Checkout', args.data);
										co_is_tracked = true;
									}
								}
							}
							$('.form-item-panes-customer-primary-email input, .form-item-panes-delivery-delivery-first-name input, .form-item-panes-delivery-delivery-last-name input').change(function (e) {
								var email = $('.form-item-panes-customer-primary-email input').val();
								var firstname = $('.form-item-panes-delivery-delivery-first-name input').val();
								var lastname = ($('.form-item-panes-delivery-delivery-last-name input').length > 0)?$('.form-item-panes-delivery-delivery-last-name input').val():'';

								// Do some light validation. Klaviyo will do more validation when the data is received.
								if (email && /@/.test(email)) {
									var data = {
										$email: email
									};
									if (firstname.length && lastname.length) {
										data = {
											$email: email,
											$first_name: firstname,
											$last_name: lastname
										};
									} else if (firstname.length) {
										data = {
											$email: email,
											$first_name: firstname
										};
									} else if (lastname.length) {
										data = {
											$email: email,
											$last_name: lastname
										};
									}
									identify(data);
									if (!co_is_tracked) {
										track('Started Checkout', args.data);
										co_is_tracked = true;
									}
								} else {
									//console.log('Email is invalid.');
								}
							});
						}
						break;
					case 'checkoutstepOLD':    // Confirmed - Above
						track( 'Checkout Step Viewed', args.data);
						if (parseInt(args.data.step) === 2) {
							// Review
							push(["identify", {
								$first_name: args.data.order_data.data.firstname,
								$last_name: args.data.order_data.data.lastname,
								$email: args.data.order_data.data.primary_email,
								$phone: args.data.order_data.data.phone
							}]);
						}
						break;
					case 'checkoutstepcomplete':    // Confirmed - Above
						track( 'Checkout Step Completed', args.data);
						break;
					case 'checkoutpayment': // Confirmed - Above
						track( 'Payment Info Entered', args.data);
						break;
					case 'ordercomplete':   // Confirmed - Above
						track( 'Order Completed', args.data);
						break;
					case 'orderupdated':    // TODO:
						track( 'Order Updated', {});// not implemented
						break;
					case 'orderrefunded':   // TODO:
						track( 'Order Refunded', {});// not implemented
						break;
					case 'ordercancel': // TODO:
						track( 'Order Cancelled', {});// not implemented
						break;
				}
				break;
			case 'promotion':
				switch (args.action) {
					case 'view':
						track( 'Promotion Viewed', {
							promotion_id: 'promo_1',
							creative: 'top_banner_2',
							name: '75% store-wide shoe sale',
							position: 'home_banner_top'
						});
						break;
					case 'click':
						track( 'Promotion Clicked', {
							promotion_id: 'promo_1',
							creative: 'top_banner_2',
							name: '75% store-wide shoe sale',
							position: 'home_banner_top'
						});
						break;
				}
				break;
			case 'coupon':  // TODO: Complete all via js!
				switch (args.action) {
					case 'entered':
						track( 'Coupon Entered', args.data);
						break;
					case 'applied':
						track( 'Coupon Applied', args.data);
						break;
					case 'denied':
						track( 'Coupon Denied', args.data);
						break;
					case 'removed':
						track( 'Coupon Removed', args.data);
						break;
				}
				break;
			case 'wishlist':
				switch (args.action) {
					case 'add': // Confirmed - uc_love.js
						track( 'Product Added to Wishlist', args.data);
						break;
					case 'remove':  // Confirmed - uc_love.js
						track( 'Product Removed from Wishlist', args.data);
						break;
					case 'addtocart':   // TODO: Compare cart items to wishlist item then trigger
						track( 'Wishlist Product Added to Cart', args.data);// Handled by ajax_render
						break;
				}
				break;
			case 'review':
				switch (args.action) {
					case 'Product Reviewed':    // TODO: During each import from trustpilot
						track( 'Product Reviewed', {});// not implemented
						break;
				}
				break;
			case 'share':
				switch (args.action) {
					case 'product':
						track( 'Product Shared', {});// not implemented
						break;
					case 'cart':
						track( 'Cart Shared', {});	// not implemented
						break;
				}
				break;

		}
	};
}(jQuery));
/*!
Justuno Replication
 */
(function (app, $) {
	let $cache = {
		subscribeTriggered:false,
		contentPopupTriggered:false,
		countdown: null,
		countdownHideLimit: 6
	};

	function initializeCache() {
		$cache.juWrap = $('#ju_wrap');
		$cache.juMail = $cache.juWrap.find('input[name="email_address"]');
		$cache.juBtn = $cache.juWrap.find('div[name="submit"]');
	}

	function initializeDom() {
		$('body').append($('<div>',{class:'modal_hold hidetoggle'})
			.append($('<div>',{id: 'contentPopups',class:'ju_wrap',style:'height:auto;'})
				.append($('<div>',{class:'ju_top visible-xs'})
					.append($('<div>',{class:'ju_bg'})))
				.append($('<div>',{class:'ju_side hidden-xs'})
					.append($('<div>',{class:'ju_bg'})))
				.append($('<div>',{class:'ju_content'}))));
		$cache.contentWrap = $('#contentPopups');
	}

	function initializeEvents() {

		// Track engagement time
		$cache.juWrap.on('click',function() {
			app.justuno.setLastEngaged((new Date()),'subscribe');
		});

		// Track engagement time
		$cache.contentWrap.on('click',function() {
			app.justuno.setLastEngaged((new Date()),'content');
		});
	}

	app.justuno = {

		// Determins if the useragent is a bot
		isBot: navigator.userAgent.match(/(PhantomJS|Insights|Applebot|Yeti|Claritybot|ContextAd|Ezooms|Gigabot|gomezagent|gomezagent|MLBot|oBot|SearQuBot|Snapbot|Lighthouse|AlwaysOnline|SuperPages|VoilaBot|J-BRW|TwengaBot|spbot|Spinn3r|Seznam|AugustBot|Google Web Preview|ZyBorg|Googlebot|Mediapartners|AdsBot|msnbot|bingbot|slurp|YahooSeeker|Scooter|Robozilla|Jeeves|lycos|Architext|externalhit|AppEngine|Yahoo Link|ScoutJet|Spider|LinkedInBot|Gulliver|crawler|TurnitinBot|PostRank|internetseer|nameprotect|PhpDig|StackRambler|UbiCrawler|y2bot|Sogou|Exabot|Yandex|aranhabot|AhrefsBot|80legs|DotBot|MJ12bot|VigLink)/gi),

    newsletterPopups: [],

		contentPopups: [],

		init: function() {
			initializeCache();
			initializeDom();
			initializeEvents();

			// Always run this
			app.justuno.runSession();

			// Are we running a popup?
			//app.justuno.setup({}); // Now initiated via live_ajax.json
		},

		setup: function(params) {
			if (!app.justuno.isBot) {
        let options = $.extend({}, {
					'popups': [],
					'contentpopups': [],
					'countdown': false,
					'countdownTitle': '',
					'countdownEnd': null, // new Date("29 April 2020 9:56:00 GMT+01:00"),
          'countdownCTA': '',
          'countdownCTALink': '',
          'countdownBackgroundColor' : '',
          'countdownForegroundColor' : '',

        }, params);

				// Activate
				if (options.countdown && !app.justuno.countdownIsHide()) {
					if (typeof options.countdownEnd === 'string') {
						options.countdownEnd = (new Date(options.countdownEnd));
					}
					$('body').append(app.justuno.countdownTemplate(options.countdownTitle, 'countdown'));
          var stickyCountdownTop = app.isGreaterThaniPad() ? $('#countdown').offset().top - 94 : $("#header").offset().top;

          var stickyCountdown = function() {
            var scrollTop = $(window).scrollTop();
            var shouldBeStickyCountdown = scrollTop > stickyCountdownTop;
            $('#countdown').toggleClass('sticky', shouldBeStickyCountdown);
          };
          stickyCountdown();

          $(window).on('scroll resize', function(e) {
            stickyCountdown();
          });

          $('#countdown-close').on('click',function(){
						app.justuno.countdownClose(true);
					});
					$cache.countdown = setInterval(function () {
						app.justuno.countdown(options.countdownEnd,'countdown');
					}, 1000);
				}

        if (options.countdownBackgroundColor && options.countdownForegroundColor) {
         app.justuno.countdownColors(options.countdownBackgroundColor, options.countdownForegroundColor, 'countdown');
        }

        if (options.countdownCTALink) {
          app.justuno.countdownCTA(options.countdownCTA, options.countdownCTALink, 'countdown');
        }

        // Activate Inline Countdowns
        if (options.countdown && $('.countdown-timer-flash').length) {
          if (typeof options.countdownEnd === 'string') {
						options.countdownEnd = (new Date(options.countdownEnd));
					}
          $('.countdown-inline').append(app.justuno.countdownTemplate(options.countdownTitle,'countdown-inline'));
          $('.countdown-timer-flash').show();
          $cache.countdownInline = setInterval(function () {
						app.justuno.countdown(options.countdownEnd,'countdown-inline');
					}, 1000);
        }

				// Subscribe (app.justuno.jsonExample())
				if (params.popups) {
				    app.justuno.newsletterPopups = params.popups;
					app.justuno.isSubscribe();
				}

				if (params.contentpopups) {
					app.justuno.contentPopups = params.contentpopups;
					app.justuno.runContentPopups();
				}
			}
		},

		countdownClose: function(endTime) {
			if (endTime) {
				window.localStorage.setItem('subscribe_hide', (new Date()));
			}
			$('#countdown').remove();
      $('body').removeClass("countdown-active");
			clearInterval($cache.countdown);
		},

		countdownIsHide: function() {
			return (window.localStorage.getItem('subscribe_hide'))
				? (Math.abs(((new Date(window.localStorage.getItem('subscribe_hide'))) - (new Date()))/1000/60/60) < $cache.countdownHideLimit)
				: false;
		},

		// app.justuno.countdown(new Date("29 April 2020 9:56:00 GMT+01:00"));
		countdown: function(endTime,id) {
			endTime = (Date.parse(endTime) / 1000);

			let now = new Date();
			now = (Date.parse(now) / 1000);

			let timeLeft = endTime - now;
			if (timeLeft <= 0) {
				app.justuno.countdownClose(false);
			}
			let days = Math.floor(timeLeft / 86400);
			let hours = Math.floor((timeLeft - (days * 86400)) / 3600);
			let minutes = Math.floor((timeLeft - (days * 86400) - (hours * 3600 )) / 60);
			let seconds = Math.floor((timeLeft - (days * 86400) - (hours * 3600) - (minutes * 60)));
      if (days < "10") { days = "0" + days; }
			if (hours < "10") { hours = "0" + hours; }
			if (minutes < "10") { minutes = "0" + minutes; }
			if (seconds < "10") { seconds = "0" + seconds; }

			let $countdown = $('#'+id);
      $countdown.removeClass('skeleton-loading');
				$countdown.find(".ct-days").html("<span class=\"num\">" + days +"</span><span>Days</span>");
			$countdown.find(".ct-hours").html("<span class=\"num\">" + hours + "</span><span>Hours</span>");
			$countdown.find(".ct-minutes").html("<span class=\"num\">" + minutes + "</span><span>Mins</span>");
			$countdown.find(".ct-seconds").html("<span class=\"num\">" + seconds + "</span><span>Secs</span>");
		},

		countdownTemplate: function(title,id) {
      $("body").addClass("countdown-active");
			return $('<div/>',{id:id, class: 'skeleton-loading'})
					.append($('<div/>',{id:id+'-wrapper'})
              .append($('<img/>',{id:id+'-close', src:'/svg/x.svg', alt: 'Close'}))
						.append($('<div/>',{id:id+'-headline'}).text(title))
						.append($('<div/>',{class:id+'-timer'})
							.append($('<div/>',{class:'ct-num ct-days'}))
              .append($('<div/>',{class:'ct-separator'}).text(':'))
							.append($('<div/>',{class:'ct-num ct-hours'}))
        .append($('<div/>',{class:'ct-separator'}).text(':'))
							.append($('<div/>',{class:'ct-num ct-minutes'}))
        .append($('<div/>',{class:'ct-separator'}).text(':'))
							.append($('<div/>',{class:'ct-num ct-seconds'})))
            .append($('<div/>',{id:id+'-cta'}))
          );
		},

    countdownColors:function(background, foreground, id){
      $('#'+id).css('--bg-color', background);
      $('#'+id).css('--fg-color', foreground);
    },

    countdownCTA:function(text, link, id){
      let $ctaTxt = text ? text : 'Shop Now';
      $('#'+id+'-cta').append($('<a/>',{href:link, class: 'ct-btn'}).text($ctaTxt));
    },

		conditionPages: function(number) {
			return app.justuno.getSessionPages() > number;
		},
		conditionLastShown: function(days) {
			return ((new Date()) - app.justuno.getLastShown()) / 1000 / 60 / 60 / 24 >= days;
		},
		conditionNeverShown: function() {
			return !app.justuno.getLastShown();
		},
		conditionClosed: function() {
			return !(app.justuno.lastActive() > app.justuno.getLastClosed()); // have not closed a popup this session
		},
		conditionEngaged: function() {
			return app.justuno.getLastEngaged();
		},
		conditionPath: function(path) {
			return app.util.getUri(window.location.href).path.indexOf(path) !== -1;
		},
    conditionNotPath: function(path) {
			return app.util.getUri(window.location.href).path.indexOf(path) === -1;
		},
		conditionOncePerSession: function() {
			return app.justuno.lastActive() > app.justuno.getLastShown();
		},
		conditionThisPopupShown: function(id) {
			return !(app.justuno.lastActive() > app.justuno.getLastThisClosed(id)); // have not closed a popup this session
		},
		conditionSubscribed: function() {
			return app.justuno.getLastSubscribed() > 0;
		},

		hideOverlay: function() {
			$('#cboxOverlay').hide();
		},

		isSubscribe: function() {
			// If already subscribed, ignore
			if (app.justuno.getLastSubscribed() > 0) {
				return false;
			}

			let jsonNewsletters = app.justuno.newsletterPopups;

			let active = true;
			for(let x = 0; x<jsonNewsletters.length;x++) {
				active = true;
				for(let condition in jsonNewsletters[x].conditions) {
					if (jsonNewsletters[x].conditions.hasOwnProperty(condition)) {
						if (!app.justuno.conditionRun(condition, jsonNewsletters[x].conditions[condition])) {
							active = false;
						}
					}
				}
				if (active) {
					// Start the event
					for (let evt in jsonNewsletters[x].event) {
						if (jsonNewsletters[x].event.hasOwnProperty(evt)) {
							app.justuno.eventRun(evt,jsonNewsletters[x],'newsletter');
						}
					}
				}
			}
		},

		runContentPopups: function() {
			let jsonPopups = app.justuno.contentPopups;
			let active = true;

			for(let x = 0; x<jsonPopups.length;x++) {
				active = true;
				for(let condition in jsonPopups[x].conditions) {
					if (jsonPopups[x].conditions.hasOwnProperty(condition)) {
						if (!app.justuno.conditionRun(condition, jsonPopups[x].conditions[condition])) {
							active = false;
						}
					}
				}
				if (active) {
					// Start the event
					for (let evt in jsonPopups[x].event) {
						if (jsonPopups[x].event.hasOwnProperty(evt)) {
							app.justuno.eventRun(evt,jsonPopups[x],'content');
						}
					}
				}
			}
		},

		eventRun: function(name,set,type) {
			switch(name) {
				case 'interval':
					let time = set.event.interval[0];
					let timeout = set.event.interval[1];
					let intCounter = setInterval(function() {
						switch(type) {
							case 'content':
								if (!$cache.contentPopupTriggered && (((new Date()) - app.justuno.getLastLoaded()) / 1000) > time) {
									app.justuno.contentLaunch(set.markup);
									clearInterval(intCounter);
								} else if($cache.contentPopupTriggered) {
									clearInterval(intCounter);
								}
								break;
							case 'newsletter':
							default:
								if (!$cache.subscribeTriggered && (((new Date()) - app.justuno.getLastLoaded()) / 1000) > time) {
									app.justuno.subscribeLaunch(set.markup);
									clearInterval(intCounter);
								} else if($cache.subscribeTriggered) {
									clearInterval(intCounter);
								}
								break;
						}
					},timeout);
					break;
				case 'scroll':
					let percent = set.event.scroll[0];
					$(window).on('scroll',function() {
						switch(type) {
							case 'content':
								if (!$cache.contentPopupTriggered && app.justuno.getScrollPercent() >= percent) {
									// trigger
									app.justuno.contentLaunch(set.markup);
									$(window).off('scroll.sub');
								} else if ($cache.contentPopupTriggered) {
									$(window).off('scroll.sub');
								}
								break;
							case 'newsletter':
							default:
								if (!$cache.subscribeTriggered && app.justuno.getScrollPercent() >= percent) {
									// trigger
									app.justuno.subscribeLaunch(set.markup);
									$(window).off('scroll.sub');
								} else if ($cache.subscribeTriggered) {
									$(window).off('scroll.sub');
								}
								break;
						}
					});
					break;
			}
		},

		conditionRun: function(name,args) {
			let r = false;
			if (name === 'or') {
				for(let orCondition in args) {
					if (args.hasOwnProperty(orCondition)) {
						if (!app.justuno.conditionRun(orCondition, args[orCondition])) {
							return false;
						}
					}
				}
				return true;
			} else {
				switch (name) {
					case 'conditionNeverShown':
						// args[0] # true or false
						r = app.justuno.conditionNeverShown();
						return args[0] ? r : !r;
					case 'conditionLastShown':
						// args[0] # integer for days
						return app.justuno.conditionLastShown(args[0]);
					case 'conditionPages':
						// args[0] # integer for pages
						return app.justuno.conditionPages(args[0]);
					case 'conditionClosed':
						// args[0] # true or false
						r = app.justuno.conditionClosed();
						return args[0] ? r : !r;
					case 'conditionOncePerSession':
						// args[0] # true or false
						r = app.justuno.conditionOncePerSession();
						return args[0] ? r : !r;
					case 'conditionThisPopupShown':
						// args[0] # id of popup
						// args[1] # true or false
						r = app.justuno.conditionThisPopupShown(args[0]);
						return args[1] ? r : !r;
					case 'conditionSubscribed':
						// args[0] # true or false
						r = app.justuno.conditionSubscribed();
						return args[0] ? r : !r;
					case 'conditionPath':
						// args[0] # string url path
						return app.justuno.conditionPath(args[0]);
				}
			}
		},

		contentLaunch: function(markup) {
			app.justuno.addCss(markup,function(markup) {
				$cache.contentPopupTriggered = true;
				$cache.contentPopupMarkup = markup;

				if (Object.keys(markup).length) {
					// Replace elements
					app.justuno.contentPopupContent(markup.html, markup.callback);
					app.justuno.contentpopup(markup.overlay);
				}
			});
		},

		subscribeLaunch: function(markup) {
			app.justuno.addCss(markup,function(markup) {
				$cache.subscribeTriggered = true;
				$cache.subscribeMarkup = markup;

				if (Object.keys(markup).length) {
					// Replace elements
					app.justuno.subscribeContent(markup.form, markup.callback);

					let promise = app.justuno.subscribe(markup.overlay);
					promise.done(function () {
						let email = $cache.juMail.val();

						$.ajax({
							url: '/klaviyo/api/subscribe',
							method: 'POST',
							data: {
								email: email,
								list: typeof markup.list !== 'undefined' ? markup.list : 'MyuG7G',
								list2: typeof markup.list2 !== 'undefined' ? markup.list2 : '',
							}
						}).done(function(data) {
							app.justuno.setLastSubscribed((new Date()));
							app.justuno.subscribeContent($cache.subscribeMarkup.done, function () {
								$cache.juMail.hide();
								$cache.juBtn.on('click', function () {
									$.colorbox.close();
								});
							});

							// Send event and tracking (Klaviyo API Signup on this event).
							$(document).trigger('JustunoOptinSuccess', email);
						});
					});

					promise.fail(function () {
						let email = $cache.juMail.val();
						app.justuno.setLastClosed((new Date()));

						// Send event and tracking
						$(document).trigger('JustunoOptinCancel', email);
					});
				}
			});
		},

		subscribeValidate: function() {
			let email = $cache.juMail.val();
			return /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(email);
		},

		contentpopup: function(overlay) {
			let colorbox = $.extend({inline: true, fixed: true, opacity: 0.5, href: '#' + $cache.contentWrap.attr('id')}, overlay);
			app.justuno.setLastShown((new Date()),'content');
			// Load Modal
			$.colorbox(colorbox);
			return true;
		},

		subscribe: function(overlay) {
			let deferred = new $.Deferred();
			let colorbox = $.extend({inline: true, fixed: true, opacity: 0.5, href: '#' + $cache.juWrap.attr('id')}, overlay);
			colorbox.onClosed = deferred.reject;

			// Set last shown
			app.justuno.setLastShown((new Date()),'subscribe');

			$cache.juWrap.on('subscribeValid', deferred.resolve);

			// Click Subscribe
			$cache.juBtn.on('click', function () {
				let $this = $(this);
				if (!$this.hasClass('disabled')) {
					$this.addClass('disabled');
					if (app.justuno.subscribeValidate()) {
						$cache.juMail.removeClass('error');
						$cache.juWrap.trigger('subscribeValid');
					}
					else {
						$cache.juMail.addClass('error');
					}
					$this.removeClass('disabled');
				}
			});

			// Load Modal
			$.colorbox(colorbox);

			// Always run on success or failure
			deferred.always(function () {
				//$.colorbox.close();
			});

			return deferred.promise();
		},

		contentPopupContent: function (markup,contentCallback) {
			$cache.contentWrap.find('.ju_content').html(markup);
			app.justuno.handleCallback(contentCallback,'content');
		},

		subscribeContent: function (markup,contentCallback) {
			let content = {
				heading: '',body:'',placeholder:'',button:'',link:'',legal:''
			};
			$.extend(content,markup);

			// Show all
			$cache.juMail.show();
			$cache.juBtn.show();

			$cache.juMail.attr('placeholder',content.placeholder);
			$cache.juWrap.find('.ju_heading span').html(content.heading);
			$cache.juWrap.find('.ju_subject span').html(content.body);
			$cache.juWrap.find('.ju_legal span').html(content.legal);
			if (content.button) {
				$cache.juBtn.find('span').html(content.button);
			} else {
				$cache.juBtn.hide();
			}

			app.justuno.handleCallback(contentCallback,'subscribe');
		},

		handleCallback: function(contentCallback,type) {
			$element = type === 'subscribe' ? $cache.juWrap : $cache.contentWrap;
			if (typeof contentCallback === 'function') {
				contentCallback();
			} else {
				for (let cbk in contentCallback) {
					if (contentCallback.hasOwnProperty(cbk)) {
						let elm = contentCallback[cbk];
						switch (cbk) {
							case 'backgroundImage':
								$element.find(elm[0]).css('background-image', 'url(' + elm[1] + ')');
								if (typeof(elm[2]) !== 'undefined') {
									$element.find(elm[2]).css('background-image', 'url(' + elm[3] + ')')
										.append($('<img>',{src:elm[3]}));
								}
								break;
							case 'setClosed':
								app.justuno.setLastThisClosed(elm[0], (new Date()), type);
								break;
							case 'removeClass':
								for (let x = 0; x < elm.length; x++) {
									$element.find(elm[x][0]).removeClass(elm[x][1]);
								}
								break;
							case 'addClass':
								for (let x = 0; x < elm.length; x++) {
									if (elm[x][0]) {
										$element.find(elm[x][0]).addClass(elm[x][1]);
									} else {
										$element.addClass(elm[x][1]);
									}
								}
								break;
						}
					}
				}
			}
		},

		addCss: function(markup,callback) {
			let file = '/sites/all/themes/rove2018/css/app.newsletter.min.css';
			/*
			if (!app.util.isCssLoaded(file)) {
				app.util.loadDynamicCss([file]);
			}
			*/
			let e = $('<link>')
				.attr('rel', 'stylesheet')
				.attr('type', 'text/css')
				.attr('href', file)
				.on('load', callback(markup))
				.on('error', function() { console.log('Error loading newsletter CSS') })
				.appendTo($('head'));
		},

		getLastShown: function() {
			return window.localStorage.getItem('user_web_subscribe_last_shown') ? (new Date(window.localStorage.getItem('user_web_subscribe_last_shown'))) : 0;
		},

		setLastShown: function (time,type) {
			window.localStorage.setItem('user_web_'+type+'_last_shown', time);

			// Track event
			if (type === 'subscribe') {
				app.tracking.gtag('event', 'Targeted Overlay', {
					event_category: 'RoveSubscribe',
					event_label: $cache.subscribeMarkup.id,
					event_value: 0
				});
			}
		},

		getLastClosed: function() {
			return (new Date(window.localStorage.getItem('user_web_subscribe_last_closed')));
		},

		setLastClosed: function (time) {
			window.localStorage.setItem('user_web_subscribe_last_closed', time);
		},

		getLastThisClosed: function(id) {
			return (new Date(window.localStorage.getItem('user_web_subscribe_last_closed_'+id)));
		},

		setLastThisClosed: function(id,time,type) {
			window.localStorage.setItem('user_web_'+type+'_last_closed_'+id, time);
		},

		getLastSubscribed: function() {
			return (new Date(window.localStorage.getItem('user_web_subscribe_last_subscribed')));
		},

		setLastSubscribed: function (time) {
			window.localStorage.setItem('user_web_subscribe_last_subscribed', time);
		},

		getLastEngaged: function() {
			return (new Date(window.localStorage.getItem('user_web_subscribe_last_engaged')));
		},

		setLastEngaged: function (time,type) {
			window.localStorage.setItem('user_web_'+type+'_last_engaged', time);

			// Track event
			if (type === 'subscribe') {
				app.tracking.gtag('event', 'Engagement - Incentivized Form', {
					event_category: 'RoveSubscribe',
					event_label: $cache.subscribeMarkup.id,
					event_value: 0
				});
			}
		},

		getScrollPercent: function () {
			var h = document.documentElement,
				b = document.body,
				st = 'scrollTop',
				sh = 'scrollHeight';

			return (h[st]||b[st]) / ((h[sh]||b[sh]) - h.clientHeight) * 100;
		},

		/* SESSION TRACKING */
		isLocalStorageSupported: function() {
			let testKey = 'test', storage = window.localStorage;
			try {
				storage.setItem(testKey, '1');
				storage.removeItem(testKey);
				return true;
			}
			catch (error) {
				return false;
			}
		},

		runSession: function() {
			if (app.justuno.isLocalStorageSupported()) {
				let count = app.justuno.getCount(),
					time = app.justuno.lastActive();

				app.justuno.incrementPages();

				if (count === 0 || app.justuno.isNewSession()) {
					app.justuno.setCount(count + 1);
					app.justuno.setLastActive(new Date());
					app.justuno.lastUtmCampaign(app.justuno.currentUtmCampaign());
					app.justuno.setSessionPages(1);
				}
			}
		},

		isNewSession: function() {
			// use definition from https://support.google.com/analytics/answer/2731565?hl=en
			const time = app.justuno.lastActive(),
				now = new Date();

			return [
				(now - time)/1000/60 > 30, // 30 days
				now.toDateString() !== time.toDateString(), // Different Day
				app.justuno.lastUtmCampaign() !== app.justuno.currentUtmCampaign()
			].some(b => b);
		},

		exitIntent: function() {
			setTimeout(() => {
				$(document).on("mouseout", evt => {
					if(evt.toElement === null && evt.relatedTarget === null) {
						$(evt.currentTarget).off("mouseout");
						// An intent to exit has happened
					}
				});
			}, 5000);
		},

		incrementPages: function() {
			// Increment page count
			app.justuno.setTotalPages(app.justuno.getTotalPages() + 1);
			app.justuno.setSessionPages(app.justuno.getSessionPages() + 1);

			// Update visit time
			app.justuno.setLastLoaded((new Date()));
		},

		getTotalPages: function() {
			return parseInt(window.localStorage.getItem('user_web_session_total_pages')) > 0 ? parseInt(window.localStorage.getItem('user_web_session_total_pages')) : 0;
		},

		setTotalPages: function(val) {
			window.localStorage.setItem('user_web_session_total_pages', val);
		},

		getSessionPages: function() {
			return parseInt(window.localStorage.getItem('user_web_session_session_pages'));
		},

		setSessionPages: function(val) {
			window.localStorage.setItem('user_web_session_session_pages', val);
		},

		lastActive: function() {
			const time = window.localStorage.getItem('user_web_session_last_active');

			if (time) {
				return new Date(time);
			}else{
				return new Date();
			}
		},

		setLastActive: function(time) {
			window.localStorage.setItem('user_web_session_last_active', time.toISOString());
		},

		getLastLoaded: function() {
			const time = window.localStorage.getItem('user_web_session_last_loaded');

			if (time) {
				return new Date(time);
			}else{
				return new Date();
			}
		},

		setLastLoaded: function (time) {
			window.localStorage.setItem('user_web_session_last_loaded', time.toISOString());
		},

		lastUtmCampaign: function() {
			return window.localStorage.getItem('user_web_session_utm_campaign');
		},

		setLastUtmCampaign: function(val) {
			window.localStorage.setItem('user_web_session_utm_campaign', val);
		},

		currentUtmCampaign: function() {
			const [ path, query = '' ] = window.location.href.split('?'),
				params = app.util.getQueryStringParams(query);

			return typeof params.utm_campaign !== 'undefined' ? params.utm_campaign : null;
		},

		getCount: function() {
			if (app.justuno.isLocalStorageSupported()) {
				return Number(window.localStorage.getItem('user_web_session_count'));
			}else{
				return 1;
			}
		},

		setCount: function(val) {
			window.localStorage.setItem('user_web_session_count', val);
		}

	};

}(window.app = window.app || {}, jQuery));
/*!
 * app.abtest.js
 */
(function (app, $) {
  // Callback when shipping method is changed.
	Drupal.ajax.prototype.commands.abtestCheckout = function (ajax, response, status) {
    app.abtest.abtestCheckout();
	};

	let $cache = {
		abtestTriggered:false,
    localStorageEnabled:null
	};

	function initializeCache() {
    $cache.localStorageEnabled = app.abtest.isLocalStorageSupported();
  }

	function initializeDom() {
		$('body').addClass('abtest');
	}

	function initializeEvents() {

	}

	app.abtest = {
    isVariant: false,
    comparePriceFactor: 3,
		init: function() {
			initializeCache();
			initializeDom();
			initializeEvents();

      $cache.variant = app.abtest.getVariant();
			if (false  && ($cache.variant === 'rove.shop' || app.isCountryMembershipOnly)) {
        app.abtest.isVariant = true;

        // Category pages
        app.abtest.abtestCategory();
        // Product pages
        app.abtest.abtestProduct();
        // Cart pages
        app.abtest.abtestCart();
        // Checkout pages
        app.abtest.abtestCheckout();
        // Checkout
        app.checkout.lockMembershipOnly();
        // Banners
        app.abtest.bannerSwap();
      }
		},

    abtestCategory: function() {
      if (app.abtest.isVariant && app.isCategoryPage()) {
        app.util.replaceText('product_price','REGULAR','COMPARE AT');
        app.abtest.replaceCategoryComparePrice();
      }
    },

    abtestProduct: function() {
      if (app.abtest.isVariant && app.isProductPage()) {
        app.util.replaceText('premium-price','REGULAR','COMPARE AT');
        app.abtest.replaceProductComparePrice();
      }
    },

    abtestCart: function() {
      if (app.abtest.isVariant && app.isCartPage()) {
        app.util.replaceText('mem_estimate_regular','Regular','COMPARE AT');
        app.util.replaceText('mem_price_reg','REGULAR','COMPARE AT');
        app.abtest.replaceCartPrice();
      }
    },

    abtestCheckout: function() {
      if (app.abtest.isVariant && app.isCheckoutPage()) {
        app.util.replaceText('order_product_price', 'REGULAR', 'COMPARE AT');
        app.util.replaceText('reg-title', 'Regular', 'Compare At');
        app.util.replaceText('description', 'regular price', 'compare at price');
        app.abtest.replaceCheckoutPrice('.order_product_title');
        app.abtest.replaceCheckoutPrice('.cart_product_title');
      }
    },

    replaceCategoryComparePrice: function() {
      if (app.abtest.isVariant && app.isCategoryPage()) {
        let eles = document.querySelectorAll('.product_price');
        for (let ele in eles) {
          if (eles.hasOwnProperty(ele)) {
            let e = eles[ele].querySelector('strong');
            if (e !== null && e.innerHTML.length) {
              let price = e.innerHTML.replace(/[^0-9.-]+/g, "")
              let compareAt = parseInt(price) * app.abtest.comparePriceFactor;
              eles[ele].innerHTML = eles[ele].innerHTML.trim().replace(/<br>([a-zA-Z\$]{1,2})([0-9.-]+)/gmi, "<br>$1" + compareAt);
            } else {
              e = eles[ele].querySelector('.sale_price');
              if (e !== null && e.innerHTML.length) {
                let price = e.innerHTML.replace(/[^0-9.-]+/g, "")
                let compareAt = parseInt(price) * app.abtest.comparePriceFactor;
                let original = eles[ele].querySelector('.original');
                if (original !== null) {
                  eles[ele].querySelector('.original').innerHTML = eles[ele].querySelector('.original').innerHTML.replace(/([a-zA-Z\$]{1,2})([0-9.-]+)/gmi, "$1" + compareAt);
                } else {
                  eles[ele].innerHTML = eles[ele].innerHTML.trim().replace(/<br>([a-zA-Z\$]{1,2})([0-9.-]+)/gmi, "<br>$1" + compareAt);
                }
              }
            }
          }
        }
      }
    },

    replaceProductComparePrice: function() {
      if (app.abtest.isVariant && app.isProductPage()) {
        let configPrice = document.querySelector('.config-price');
        let premiumPrice = document.querySelector('.premium-price');
        let price = configPrice.innerHTML.replace(/[^0-9.]+/g, "");
        let compareAt = parseInt(price) * app.abtest.comparePriceFactor;
        if (premiumPrice.innerHTML.indexOf('orange') >= 0) {
          // on sale
          premiumPrice.innerHTML = premiumPrice.innerHTML.replace(/<s>([a-zA-Z\s\$]+)([0-9.-]+)/gmi, "<s>$1" + compareAt);
        } else {
          // regular
          premiumPrice.innerHTML = premiumPrice.innerHTML.replace(/([a-zA-Z\s\$]+)([0-9.-]+)/gmi, "$1" + compareAt);
        }
      }
    },

    replaceCartPrice: function() {
      if (app.abtest.isVariant && app.isCartPage()) {
        let itemTotal = 0;
        let eles = document.querySelectorAll('.cart-product .cart-total>div');
        for (let ele in eles) {
          if (eles.hasOwnProperty(ele) && !eles[ele].classList.contains('final-sale')) {
            let memPrice = eles[ele].querySelector('.mem_price_line').innerHTML.replace(/[^0-9.-]+/g, "");
            let compareAt = parseInt(memPrice) * app.abtest.comparePriceFactor;
            itemTotal += compareAt;
            eles[ele].querySelector('.mem_price_reg').innerHTML = eles[ele].querySelector('.mem_price_reg').innerHTML.replace(/[0-9.-]+/g, compareAt.toString());
          }
        }

        let total = document.querySelector('.mem_estimate_regular>span');
        total.innerHTML = total.innerHTML.replace(/[0-9.-]+/g, itemTotal.toString());
      }
    },

    replaceCheckoutPrice: function(selector) {
      let memberTotal;
      if (app.abtest.isVariant && app.isCheckoutPage()) {
        let itemTotal = memberTotal = extraTotal = 0;
        let eles = document.querySelectorAll(selector);
        for (let ele in eles) {
          if (eles.hasOwnProperty(ele) && eles[ele].querySelector('.cart_deduct .uc-price') !== null) {
            let memPrice = eles[ele].querySelector('.cart_deduct .uc-price').innerHTML.replace(/[^0-9.]+/g, "");
            let compareAt = parseInt(memPrice) * app.abtest.comparePriceFactor;
            memberTotal += parseInt(memPrice);
            itemTotal += compareAt;
            if (eles[ele].querySelector('.compareStrike .uc-price') !== null) {
              eles[ele].querySelector('.compareStrike .uc-price').innerHTML = eles[ele].querySelector('.compareStrike .uc-price').innerHTML.replace(/[0-9.]+/g, compareAt.toString());
            }
          } else if (eles.hasOwnProperty(ele) && eles[ele].querySelector('.cart_fee .uc-price') !== null) {
            extraTotal += parseInt(eles[ele].querySelector('.cart_fee .uc-price').innerHTML.replace(/[^0-9.]+/g, ""));
          }
        }

        let totalRegAmount = document.querySelector('.total-reg-cont .reg-amount');
        if (totalRegAmount !== null) {
          totalRegAmount.innerHTML = totalRegAmount.innerHTML.replace(/[0-9.,]+/g, (itemTotal + extraTotal).toString());
        }
        //document.querySelector('.cart_total>span').innerHTML = document.querySelector('.cart_total>span').innerHTML.replace(/[0-9.,]+/g, (itemTotal + extraTotal).toString());
        let saveAmount = document.querySelector('.save-amount');
        if (saveAmount !== null) {
          saveAmount.innerHTML = saveAmount.innerHTML.replace(/[0-9.,]+/g, (itemTotal - memberTotal).toString());
        }
        let cartDeduct = document.querySelector('.cart_line_item .cart_deduct');
        if (cartDeduct !== null) {
          cartDeduct.innerHTML = cartDeduct.innerHTML.replace(/[0-9.,]+/g, (itemTotal - memberTotal).toString());
        }
      }
    },

    bannerSwap: function() {
      if (app.isFrontPage()) {
        $('.banner-inner source, .banner-inner img').each(function() {
          $('.banner-inner .has-video').removeClass('has-video');
          $('.banner-inner .carousel_body').hide();
          $('.banner-inner a').attr('href','/toronto-showroom');
          if ($(this).data('srcset')) {
              let newString = "";
              let matches = $(this).data('srcset').match(/https([a-zA-Z0-9-_\\.:\\/%]+)/g);
              for(let x = 0; x < matches.length; x++) {
                let filename = matches[x].substring(matches[x].lastIndexOf('/') + 1);
                if (matches[x].indexOf(filename) && matches[x].match(/(picture_(320|480|768))/g)) {
                  newString = newString + matches[x].replace(filename,'TorontoShowroomHomepageBannerMobile-Exterior.png') + " " + (x+1) + "x" + (x!=2?', ':'');
                } else {
                  newString = newString + matches[x].replace(filename,'TorontoShowroomHomepageBanner-Exterior.png') + " " + (x+1) + "x" + (x!=2?', ':'');
                }
              }
              jQuery(this).attr('data-srcset',newString)
              //console.log(jQuery(this).data('srcset'));
              //console.log(matches);
          }

          let imgsrc = '';
          if (imgsrc = $(this).data('src')) {
            let filename = imgsrc.substring(imgsrc.lastIndexOf('/') + 1);
            if (imgsrc.indexOf(filename) && imgsrc.match(/(picture_(320|480|768))/g)) {
              $(this).data('src',$(this).data('src').replace(filename,'TorontoShowroomHomepageBannerMobile-Exterior.png'));
            } else {
              $(this).data('src',$(this).data('src').replace(filename,'TorontoShowroomHomepageBanner-Exterior.png'));
            }
          }
        });
        $('.banner-inner').find('[data-wistia]').remove();
      }
    },

    getVariant: function() {
      if (this.currentUtmSource() === 'domain' && this.currentUtmCampaign() === 'rove.shop') {
        // changing utm source
        this.setActiveVariant(this.currentUtmCampaign());
      }

      if (this.currentUtmDirective() === 'kill') {
        this.killActiveVariant();
      }

      return this.getActiveVariant();
    },

    /* SESSION TRACKING */
		isLocalStorageSupported: function() {
			let testKey = 'test', storage = window.localStorage;
			try {
				storage.setItem(testKey, '1');
				storage.removeItem(testKey);
				return true;
			}
			catch (error) {
				return false;
			}
		},

		currentUtmCampaign: function() {
			const [ path, query = '' ] = window.location.href.split('?'),
				params = app.util.getQueryStringParams(query);

			return typeof params.utm_campaign !== 'undefined' ? params.utm_campaign : null;
		},
    currentUtmSource: function() {
			const [ path, query = '' ] = window.location.href.split('?'),
				params = app.util.getQueryStringParams(query);

			return typeof params.utm_source !== 'undefined' ? params.utm_source : null;
		},
    currentUtmDirective: function() {
      const [ path, query = '' ] = window.location.href.split('?'),
				params = app.util.getQueryStringParams(query);

			return typeof params.utm_directive !== 'undefined' ? params.utm_directive : null;
    },

    setActiveVariant: function(activeVariantName) {
      if ($cache.localStorageEnabled) {
        window.localStorage.setItem('user_web_session_variant_active', activeVariantName);
        $.cookie('user_web_session_variant_active',activeVariantName,{expires:365,path:'/',secure: true,domain:app.util.getUri(window.location.href).host});
      } else {
        $.cookie('user_web_session_variant_active',activeVariantName,{expires:365,path:'/',secure: true,domain:app.util.getUri(window.location.href).host});
      }
    },

    getActiveVariant: function() {
      if ($cache.localStorageEnabled) {
        return window.localStorage.getItem('user_web_session_variant_active');
      } else {
        return $.cookie('user_web_session_variant_active');
      }
    },

    killActiveVariant: function() {
      if ($cache.localStorageEnabled) {
        window.localStorage.removeItem('user_web_session_variant_active');
        $.cookie('user_web_session_variant_active',null,{expires:365,path:'/',secure: true,domain:app.util.getUri(window.location.href).host});
      } else {
        $.cookie('user_web_session_variant_active',null,{expires:365,path:'/',secure: true,domain:app.util.getUri(window.location.href).host});
      }
    }

	};

}(window.app = window.app || {}, jQuery));
"undefined"!=typeof window&&function(e,t){"object"==typeof exports&&"object"==typeof module?module.exports=t():"function"==typeof define&&define.amd?define([],t):"object"==typeof exports?exports.Hls=t():e.Hls=t()}(this,function(){return function(e){var t={};function r(i){if(t[i])return t[i].exports;var a=t[i]={i:i,l:!1,exports:{}};return e[i].call(a.exports,a,a.exports,r),a.l=!0,a.exports}return r.m=e,r.c=t,r.d=function(e,t,i){r.o(e,t)||Object.defineProperty(e,t,{enumerable:!0,get:i})},r.r=function(e){"undefined"!=typeof Symbol&&Symbol.toStringTag&&Object.defineProperty(e,Symbol.toStringTag,{value:"Module"}),Object.defineProperty(e,"__esModule",{value:!0})},r.t=function(e,t){if(1&t&&(e=r(e)),8&t)return e;if(4&t&&"object"==typeof e&&e&&e.__esModule)return e;var i=Object.create(null);if(r.r(i),Object.defineProperty(i,"default",{enumerable:!0,value:e}),2&t&&"string"!=typeof e)for(var a in e)r.d(i,a,function(t){return e[t]}.bind(null,a));return i},r.n=function(e){var t=e&&e.__esModule?function(){return e.default}:function(){return e};return r.d(t,"a",t),t},r.o=function(e,t){return Object.prototype.hasOwnProperty.call(e,t)},r.p="/dist/",r(r.s=24)}([function(e,t,r){"use strict";Object.defineProperty(t,"__esModule",{value:!0});var i=r(6);function a(){}var n={trace:a,debug:a,log:a,warn:a,info:a,error:a},o=n;var s=i.getSelfScope();function l(e){for(var t=[],r=1;r<arguments.length;r++)t[r-1]=arguments[r];t.forEach(function(t){o[t]=e[t]?e[t].bind(e):function(e){var t=s.console[e];return t?function(){for(var r=[],i=0;i<arguments.length;i++)r[i]=arguments[i];r[0]&&(r[0]=function(e,t){return t="["+e+"] > "+t}(e,r[0])),t.apply(s.console,r)}:a}(t)})}t.enableLogs=function(e){if(!0===e||"object"==typeof e){l(e,"debug","log","info","warn","error");try{o.log()}catch(e){o=n}}else o=n},t.logger=o},function(e,t,r){"use strict";Object.defineProperty(t,"__esModule",{value:!0});t.default={MEDIA_ATTACHING:"hlsMediaAttaching",MEDIA_ATTACHED:"hlsMediaAttached",MEDIA_DETACHING:"hlsMediaDetaching",MEDIA_DETACHED:"hlsMediaDetached",BUFFER_RESET:"hlsBufferReset",BUFFER_CODECS:"hlsBufferCodecs",BUFFER_CREATED:"hlsBufferCreated",BUFFER_APPENDING:"hlsBufferAppending",BUFFER_APPENDED:"hlsBufferAppended",BUFFER_EOS:"hlsBufferEos",BUFFER_FLUSHING:"hlsBufferFlushing",BUFFER_FLUSHED:"hlsBufferFlushed",MANIFEST_LOADING:"hlsManifestLoading",MANIFEST_LOADED:"hlsManifestLoaded",MANIFEST_PARSED:"hlsManifestParsed",LEVEL_SWITCHING:"hlsLevelSwitching",LEVEL_SWITCHED:"hlsLevelSwitched",LEVEL_LOADING:"hlsLevelLoading",LEVEL_LOADED:"hlsLevelLoaded",LEVEL_UPDATED:"hlsLevelUpdated",LEVEL_PTS_UPDATED:"hlsLevelPtsUpdated",AUDIO_TRACKS_UPDATED:"hlsAudioTracksUpdated",AUDIO_TRACK_SWITCHING:"hlsAudioTrackSwitching",AUDIO_TRACK_SWITCHED:"hlsAudioTrackSwitched",AUDIO_TRACK_LOADING:"hlsAudioTrackLoading",AUDIO_TRACK_LOADED:"hlsAudioTrackLoaded",SUBTITLE_TRACKS_UPDATED:"hlsSubtitleTracksUpdated",SUBTITLE_TRACK_SWITCH:"hlsSubtitleTrackSwitch",SUBTITLE_TRACK_LOADING:"hlsSubtitleTrackLoading",SUBTITLE_TRACK_LOADED:"hlsSubtitleTrackLoaded",SUBTITLE_FRAG_PROCESSED:"hlsSubtitleFragProcessed",INIT_PTS_FOUND:"hlsInitPtsFound",FRAG_LOADING:"hlsFragLoading",FRAG_LOAD_PROGRESS:"hlsFragLoadProgress",FRAG_LOAD_EMERGENCY_ABORTED:"hlsFragLoadEmergencyAborted",FRAG_LOADED:"hlsFragLoaded",FRAG_DECRYPTED:"hlsFragDecrypted",FRAG_PARSING_INIT_SEGMENT:"hlsFragParsingInitSegment",FRAG_PARSING_USERDATA:"hlsFragParsingUserdata",FRAG_PARSING_METADATA:"hlsFragParsingMetadata",FRAG_PARSING_DATA:"hlsFragParsingData",FRAG_PARSED:"hlsFragParsed",FRAG_BUFFERED:"hlsFragBuffered",FRAG_CHANGED:"hlsFragChanged",FPS_DROP:"hlsFpsDrop",FPS_DROP_LEVEL_CAPPING:"hlsFpsDropLevelCapping",ERROR:"hlsError",DESTROYING:"hlsDestroying",KEY_LOADING:"hlsKeyLoading",KEY_LOADED:"hlsKeyLoaded",STREAM_STATE_TRANSITION:"hlsStreamStateTransition"}},function(e,t,r){"use strict";Object.defineProperty(t,"__esModule",{value:!0});var i=r(6).getSelfScope().Number;t.Number=i,i.isFinite=i.isFinite||function(e){return"number"==typeof e&&isFinite(e)}},function(e,t,r){"use strict";Object.defineProperty(t,"__esModule",{value:!0}),t.ErrorTypes={NETWORK_ERROR:"networkError",MEDIA_ERROR:"mediaError",KEY_SYSTEM_ERROR:"keySystemError",MUX_ERROR:"muxError",OTHER_ERROR:"otherError"},t.ErrorDetails={KEY_SYSTEM_NO_KEYS:"keySystemNoKeys",KEY_SYSTEM_NO_ACCESS:"keySystemNoAccess",KEY_SYSTEM_NO_SESSION:"keySystemNoSession",KEY_SYSTEM_LICENSE_REQUEST_FAILED:"keySystemLicenseRequestFailed",MANIFEST_LOAD_ERROR:"manifestLoadError",MANIFEST_LOAD_TIMEOUT:"manifestLoadTimeOut",MANIFEST_PARSING_ERROR:"manifestParsingError",MANIFEST_INCOMPATIBLE_CODECS_ERROR:"manifestIncompatibleCodecsError",LEVEL_LOAD_ERROR:"levelLoadError",LEVEL_LOAD_TIMEOUT:"levelLoadTimeOut",LEVEL_SWITCH_ERROR:"levelSwitchError",AUDIO_TRACK_LOAD_ERROR:"audioTrackLoadError",AUDIO_TRACK_LOAD_TIMEOUT:"audioTrackLoadTimeOut",FRAG_LOAD_ERROR:"fragLoadError",FRAG_LOAD_TIMEOUT:"fragLoadTimeOut",FRAG_DECRYPT_ERROR:"fragDecryptError",FRAG_PARSING_ERROR:"fragParsingError",REMUX_ALLOC_ERROR:"remuxAllocError",KEY_LOAD_ERROR:"keyLoadError",KEY_LOAD_TIMEOUT:"keyLoadTimeOut",BUFFER_ADD_CODEC_ERROR:"bufferAddCodecError",BUFFER_APPEND_ERROR:"bufferAppendError",BUFFER_APPENDING_ERROR:"bufferAppendingError",BUFFER_STALLED_ERROR:"bufferStalledError",BUFFER_FULL_ERROR:"bufferFullError",BUFFER_SEEK_OVER_HOLE:"bufferSeekOverHole",BUFFER_NUDGE_ON_STALL:"bufferNudgeOnStall",INTERNAL_EXCEPTION:"internalException"}},function(e,t,r){"use strict";Object.defineProperty(t,"__esModule",{value:!0});var i=r(0),a=r(3),n=r(1),o={hlsEventGeneric:!0,hlsHandlerDestroying:!0,hlsHandlerDestroyed:!0},s=function(){function e(e){for(var t=[],r=1;r<arguments.length;r++)t[r-1]=arguments[r];this.hls=e,this.onEvent=this.onEvent.bind(this),this.handledEvents=t,this.useGenericHandler=!0,this.registerListeners()}return e.prototype.destroy=function(){this.onHandlerDestroying(),this.unregisterListeners(),this.onHandlerDestroyed()},e.prototype.onHandlerDestroying=function(){},e.prototype.onHandlerDestroyed=function(){},e.prototype.isEventHandler=function(){return"object"==typeof this.handledEvents&&this.handledEvents.length&&"function"==typeof this.onEvent},e.prototype.registerListeners=function(){this.isEventHandler()&&this.handledEvents.forEach(function(e){if(o[e])throw new Error("Forbidden event-name: "+e);this.hls.on(e,this.onEvent)},this)},e.prototype.unregisterListeners=function(){this.isEventHandler()&&this.handledEvents.forEach(function(e){this.hls.off(e,this.onEvent)},this)},e.prototype.onEvent=function(e,t){this.onEventGeneric(e,t)},e.prototype.onEventGeneric=function(e,t){try{(function(e,t){var r="on"+e.replace("hls","");if("function"!=typeof this[r])throw new Error("Event "+e+" has no generic handler in this "+this.constructor.name+" class (tried "+r+")");return this[r].bind(this,t)}).call(this,e,t).call()}catch(t){i.logger.error("An internal error happened while handling event "+e+'. Error message: "'+t.message+'". Here is a stacktrace:',t),this.hls.trigger(n.default.ERROR,{type:a.ErrorTypes.OTHER_ERROR,details:a.ErrorDetails.INTERNAL_EXCEPTION,fatal:!1,event:e,err:t})}},e}();t.default=s},function(e,t){e.exports=void 0},function(e,t,r){"use strict";Object.defineProperty(t,"__esModule",{value:!0}),t.getSelfScope=function(){return"undefined"==typeof window?self:window}},function(e,t,r){!function(t){var r=/^((?:[a-zA-Z0-9+\-.]+:)?)(\/\/[^\/?#]*)?((?:[^\/\?#]*\/)*.*?)??(;.*?)?(\?.*?)?(#.*?)?$/,i=/^([^\/?#]*)(.*)$/,a=/(?:\/|^)\.(?=\/)/g,n=/(?:\/|^)\.\.\/(?!\.\.\/).*?(?=\/)/g,o={buildAbsoluteURL:function(e,t,r){if(r=r||{},e=e.trim(),!(t=t.trim())){if(!r.alwaysNormalize)return e;var a=o.parseURL(e);if(!a)throw new Error("Error trying to parse base URL.");return a.path=o.normalizePath(a.path),o.buildURLFromParts(a)}var n=o.parseURL(t);if(!n)throw new Error("Error trying to parse relative URL.");if(n.scheme)return r.alwaysNormalize?(n.path=o.normalizePath(n.path),o.buildURLFromParts(n)):t;var s=o.parseURL(e);if(!s)throw new Error("Error trying to parse base URL.");if(!s.netLoc&&s.path&&"/"!==s.path[0]){var l=i.exec(s.path);s.netLoc=l[1],s.path=l[2]}s.netLoc&&!s.path&&(s.path="/");var u={scheme:s.scheme,netLoc:n.netLoc,path:null,params:n.params,query:n.query,fragment:n.fragment};if(!n.netLoc&&(u.netLoc=s.netLoc,"/"!==n.path[0]))if(n.path){var d=s.path,f=d.substring(0,d.lastIndexOf("/")+1)+n.path;u.path=o.normalizePath(f)}else u.path=s.path,n.params||(u.params=s.params,n.query||(u.query=s.query));return null===u.path&&(u.path=r.alwaysNormalize?o.normalizePath(n.path):n.path),o.buildURLFromParts(u)},parseURL:function(e){var t=r.exec(e);return t?{scheme:t[1]||"",netLoc:t[2]||"",path:t[3]||"",params:t[4]||"",query:t[5]||"",fragment:t[6]||""}:null},normalizePath:function(e){for(e=e.split("").reverse().join("").replace(a,"");e.length!==(e=e.replace(n,"")).length;);return e.split("").reverse().join("")},buildURLFromParts:function(e){return e.scheme+e.netLoc+e.path+e.params+e.query+e.fragment}};e.exports=o}()},function(e,t,r){"use strict";Object.defineProperty(t,"__esModule",{value:!0});var i=function(){function e(){}return e.isBuffered=function(e,t){try{if(e)for(var r=e.buffered,i=0;i<r.length;i++)if(t>=r.start(i)&&t<=r.end(i))return!0}catch(e){}return!1},e.bufferInfo=function(e,t,r){try{if(e){var i=e.buffered,a=[],n=void 0;for(n=0;n<i.length;n++)a.push({start:i.start(n),end:i.end(n)});return this.bufferedInfo(a,t,r)}}catch(e){}return{len:0,start:t,end:t,nextStart:void 0}},e.bufferedInfo=function(e,t,r){var i,a,n,o,s,l=[];for(e.sort(function(e,t){var r=e.start-t.start;return r||t.end-e.end}),s=0;s<e.length;s++){var u=l.length;if(u){var d=l[u-1].end;e[s].start-d<r?e[s].end>d&&(l[u-1].end=e[s].end):l.push(e[s])}else l.push(e[s])}for(s=0,i=0,a=n=t;s<l.length;s++){var f=l[s].start,c=l[s].end;if(t+r>=f&&t<c)a=f,i=(n=c)-t;else if(t+r<f){o=f;break}}return{len:i,start:a,end:n,nextStart:o}},e}();t.BufferHelper=i},function(e,t,r){"use strict";(function(e){var i=this&&this.__extends||function(){var e=Object.setPrototypeOf||{__proto__:[]}instanceof Array&&function(e,t){e.__proto__=t}||function(e,t){for(var r in t)t.hasOwnProperty(r)&&(e[r]=t[r])};return function(t,r){function i(){this.constructor=t}e(t,r),t.prototype=null===r?Object.create(r):(i.prototype=r.prototype,new i)}}();Object.defineProperty(t,"__esModule",{value:!0});var a=r(4),n=r(1);t.FragmentState={NOT_LOADED:"NOT_LOADED",APPENDING:"APPENDING",PARTIAL:"PARTIAL",OK:"OK"};var o=function(r){function o(e){var t=r.call(this,e,n.default.BUFFER_APPENDED,n.default.FRAG_BUFFERED,n.default.FRAG_LOADED)||this;return t.bufferPadding=.2,t.fragments=Object.create(null),t.timeRanges=Object.create(null),t.config=e.config,t}return i(o,r),o.prototype.destroy=function(){this.fragments=Object.create(null),this.timeRanges=Object.create(null),this.config=null,a.default.prototype.destroy.call(this),r.prototype.destroy.call(this)},o.prototype.getBufferedFrag=function(e,t){var r=this.fragments,i=Object.keys(r).filter(function(i){var a=r[i];if(a.body.type!==t)return!1;if(!a.buffered)return!1;var n=a.body;return n.startPTS<=e&&e<=n.endPTS});if(0===i.length)return null;var a=i.pop();return r[a].body},o.prototype.detectEvictedFragments=function(e,t){var r,i,a=this;Object.keys(this.fragments).forEach(function(n){var o=a.fragments[n];if(!0===o.buffered){var s=o.range[e];if(s){r=s.time;for(var l=0;l<r.length;l++)if(i=r[l],!1===a.isTimeBuffered(i.startPTS,i.endPTS,t)){a.removeFragment(o.body);break}}}})},o.prototype.detectPartialFragments=function(e){var t=this,r=this.getFragmentKey(e),i=this.fragments[r];i&&(i.buffered=!0,Object.keys(this.timeRanges).forEach(function(r){if(e.hasElementaryStream(r)){var a=t.timeRanges[r];i.range[r]=t.getBufferedTimes(e.startPTS,e.endPTS,a)}}))},o.prototype.getBufferedTimes=function(e,t,r){for(var i,a,n=[],o=!1,s=0;s<r.length;s++){if(i=r.start(s)-this.bufferPadding,a=r.end(s)+this.bufferPadding,e>=i&&t<=a){n.push({startPTS:Math.max(e,r.start(s)),endPTS:Math.min(t,r.end(s))});break}if(e<a&&t>i)n.push({startPTS:Math.max(e,r.start(s)),endPTS:Math.min(t,r.end(s))}),o=!0;else if(t<=i)break}return{time:n,partial:o}},o.prototype.getFragmentKey=function(e){return e.type+"_"+e.level+"_"+e.urlId+"_"+e.sn},o.prototype.getPartialFragment=function(e){var t,r,i,a=this,n=null,o=0;return Object.keys(this.fragments).forEach(function(s){var l=a.fragments[s];a.isPartial(l)&&(r=l.body.startPTS-a.bufferPadding,i=l.body.endPTS+a.bufferPadding,e>=r&&e<=i&&(t=Math.min(e-r,i-e),o<=t&&(n=l.body,o=t)))}),n},o.prototype.getState=function(e){var r=this.getFragmentKey(e),i=this.fragments[r],a=t.FragmentState.NOT_LOADED;return void 0!==i&&(a=i.buffered?!0===this.isPartial(i)?t.FragmentState.PARTIAL:t.FragmentState.OK:t.FragmentState.APPENDING),a},o.prototype.isPartial=function(e){return!0===e.buffered&&(void 0!==e.range.video&&!0===e.range.video.partial||void 0!==e.range.audio&&!0===e.range.audio.partial)},o.prototype.isTimeBuffered=function(e,t,r){for(var i,a,n=0;n<r.length;n++){if(i=r.start(n)-this.bufferPadding,a=r.end(n)+this.bufferPadding,e>=i&&t<=a)return!0;if(t<=i)return!1}return!1},o.prototype.onFragLoaded=function(t){var r=t.frag;e.isFinite(r.sn)&&!r.bitrateTest&&(this.fragments[this.getFragmentKey(r)]={body:r,range:Object.create(null),buffered:!1})},o.prototype.onBufferAppended=function(e){var t=this;this.timeRanges=e.timeRanges,Object.keys(this.timeRanges).forEach(function(e){var r=t.timeRanges[e];t.detectEvictedFragments(e,r)})},o.prototype.onFragBuffered=function(e){this.detectPartialFragments(e.frag)},o.prototype.hasFragment=function(e){var t=this.getFragmentKey(e);return void 0!==this.fragments[t]},o.prototype.removeFragment=function(e){var t=this.getFragmentKey(e);delete this.fragments[t]},o.prototype.removeAllFragments=function(){this.fragments=Object.create(null)},o}(a.default);t.FragmentTracker=o}).call(this,r(2).Number)},function(e,t,r){"use strict";Object.defineProperty(t,"__esModule",{value:!0});t.default={search:function(e,t){for(var r=0,i=e.length-1,a=null,n=null;r<=i;){var o=t(n=e[a=(r+i)/2|0]);if(o>0)r=a+1;else{if(!(o<0))return n;i=a-1}}return null}}},function(e,t,r){"use strict";Object.defineProperty(t,"__esModule",{value:!0});var i=function(){function e(){}return e.isHeader=function(e,t){return t+10<=e.length&&73===e[t]&&68===e[t+1]&&51===e[t+2]&&e[t+3]<255&&e[t+4]<255&&e[t+6]<128&&e[t+7]<128&&e[t+8]<128&&e[t+9]<128},e.isFooter=function(e,t){return t+10<=e.length&&51===e[t]&&68===e[t+1]&&73===e[t+2]&&e[t+3]<255&&e[t+4]<255&&e[t+6]<128&&e[t+7]<128&&e[t+8]<128&&e[t+9]<128},e.getID3Data=function(t,r){for(var i=r,a=0;e.isHeader(t,r);){a+=10,a+=e._readSize(t,r+6),e.isFooter(t,r+10)&&(a+=10),r+=a}if(a>0)return t.subarray(i,i+a)},e._readSize=function(e,t){var r=0;return r=(127&e[t])<<21,r|=(127&e[t+1])<<14,r|=(127&e[t+2])<<7,r|=127&e[t+3]},e.getTimeStamp=function(t){for(var r=e.getID3Frames(t),i=0;i<r.length;i++){var a=r[i];if(e.isTimeStampFrame(a))return e._readTimeStamp(a)}},e.isTimeStampFrame=function(e){return e&&"PRIV"===e.key&&"com.apple.streaming.transportStreamTimestamp"===e.info},e._getFrameData=function(t){var r=String.fromCharCode(t[0],t[1],t[2],t[3]),i=e._readSize(t,4);return{type:r,size:i,data:t.subarray(10,10+i)}},e.getID3Frames=function(t){for(var r=0,i=[];e.isHeader(t,r);){for(var a=e._readSize(t,r+6),n=(r+=10)+a;r+8<n;){var o=e._getFrameData(t.subarray(r)),s=e._decodeFrame(o);s&&i.push(s),r+=o.size+10}e.isFooter(t,r)&&(r+=10)}return i},e._decodeFrame=function(t){return"PRIV"===t.type?e._decodePrivFrame(t):"T"===t.type[0]?e._decodeTextFrame(t):"W"===t.type[0]?e._decodeURLFrame(t):void 0},e._readTimeStamp=function(e){if(8===e.data.byteLength){var t=new Uint8Array(e.data),r=1&t[3],i=(t[4]<<23)+(t[5]<<15)+(t[6]<<7)+t[7];return i/=45,r&&(i+=47721858.84),Math.round(i)}},e._decodePrivFrame=function(t){if(!(t.size<2)){var r=e._utf8ArrayToStr(t.data,!0),i=new Uint8Array(t.data.subarray(r.length+1));return{key:t.type,info:r,data:i.buffer}}},e._decodeTextFrame=function(t){if(!(t.size<2)){if("TXXX"===t.type){var r=1,i=e._utf8ArrayToStr(t.data.subarray(r));r+=i.length+1;var a=e._utf8ArrayToStr(t.data.subarray(r));return{key:t.type,info:i,data:a}}var n=e._utf8ArrayToStr(t.data.subarray(1));return{key:t.type,data:n}}},e._decodeURLFrame=function(t){if("WXXX"===t.type){if(t.size<2)return;var r=1,i=e._utf8ArrayToStr(t.data.subarray(r));r+=i.length+1;var a=e._utf8ArrayToStr(t.data.subarray(r));return{key:t.type,info:i,data:a}}var n=e._utf8ArrayToStr(t.data);return{key:t.type,data:n}},e._utf8ArrayToStr=function(e,t){void 0===t&&(t=!1);for(var r,i,a,n=e.length,o="",s=0;s<n;){if(0===(r=e[s++])&&t)return o;if(0!==r&&3!==r)switch(r>>4){case 0:case 1:case 2:case 3:case 4:case 5:case 6:case 7:o+=String.fromCharCode(r);break;case 12:case 13:i=e[s++],o+=String.fromCharCode((31&r)<<6|63&i);break;case 14:i=e[s++],a=e[s++],o+=String.fromCharCode((15&r)<<12|(63&i)<<6|(63&a)<<0)}}return o},e}(),a=i._utf8ArrayToStr;t.utf8ArrayToStr=a,t.default=i},function(e,t,r){"use strict";Object.defineProperty(t,"__esModule",{value:!0}),t.getMediaSource=function(){if("undefined"!=typeof window)return window.MediaSource||window.WebKitMediaSource}},function(e,t,r){"use strict";(function(e){var i=this&&this.__extends||function(){var e=Object.setPrototypeOf||{__proto__:[]}instanceof Array&&function(e,t){e.__proto__=t}||function(e,t){for(var r in t)t.hasOwnProperty(r)&&(e[r]=t[r])};return function(t,r){function i(){this.constructor=t}e(t,r),t.prototype=null===r?Object.create(r):(i.prototype=r.prototype,new i)}}();Object.defineProperty(t,"__esModule",{value:!0});var a=r(1),n=r(4),o=r(3),s=r(0),l=r(14),u=r(25),d=window.performance,f={MANIFEST:"manifest",LEVEL:"level",AUDIO_TRACK:"audioTrack",SUBTITLE_TRACK:"subtitleTrack"},c={MAIN:"main",AUDIO:"audio",SUBTITLE:"subtitle"},h=function(t){function r(e){var r=t.call(this,e,a.default.MANIFEST_LOADING,a.default.LEVEL_LOADING,a.default.AUDIO_TRACK_LOADING,a.default.SUBTITLE_TRACK_LOADING)||this;return r.loaders={},r}return i(r,t),Object.defineProperty(r,"ContextType",{get:function(){return f},enumerable:!0,configurable:!0}),Object.defineProperty(r,"LevelType",{get:function(){return c},enumerable:!0,configurable:!0}),r.canHaveQualityLevels=function(e){return e!==f.AUDIO_TRACK&&e!==f.SUBTITLE_TRACK},r.mapContextToLevelType=function(e){switch(e.type){case f.AUDIO_TRACK:return c.AUDIO;case f.SUBTITLE_TRACK:return c.SUBTITLE;default:return c.MAIN}},r.getResponseUrl=function(e,t){var r=e.url;return void 0!==r&&0!==r.indexOf("data:")||(r=t.url),r},r.prototype.createInternalLoader=function(e){var t=this.hls.config,r=t.pLoader,i=t.loader,a=new(r||i)(t);return e.loader=a,this.loaders[e.type]=a,a},r.prototype.getInternalLoader=function(e){return this.loaders[e.type]},r.prototype.resetInternalLoader=function(e){this.loaders[e]&&delete this.loaders[e]},r.prototype.destroyInternalLoaders=function(){for(var e in this.loaders){var t=this.loaders[e];t&&t.destroy(),this.resetInternalLoader(e)}},r.prototype.destroy=function(){this.destroyInternalLoaders(),t.prototype.destroy.call(this)},r.prototype.onManifestLoading=function(e){this.load(e.url,{type:f.MANIFEST,level:0,id:null})},r.prototype.onLevelLoading=function(e){this.load(e.url,{type:f.LEVEL,level:e.level,id:e.id})},r.prototype.onAudioTrackLoading=function(e){this.load(e.url,{type:f.AUDIO_TRACK,level:null,id:e.id})},r.prototype.onSubtitleTrackLoading=function(e){this.load(e.url,{type:f.SUBTITLE_TRACK,level:null,id:e.id})},r.prototype.load=function(e,t){var r=this.hls.config;s.logger.debug("Loading playlist of type "+t.type+", level: "+t.level+", id: "+t.id);var i,a,n,o,l=this.getInternalLoader(t);if(l){var u=l.context;if(u&&u.url===e)return s.logger.trace("playlist request ongoing"),!1;s.logger.warn("aborting previous loader for type: "+t.type),l.abort()}switch(t.type){case f.MANIFEST:i=r.manifestLoadingMaxRetry,a=r.manifestLoadingTimeOut,n=r.manifestLoadingRetryDelay,o=r.manifestLoadingMaxRetryTimeout;break;case f.LEVEL:i=0,a=r.levelLoadingTimeOut;break;default:i=r.levelLoadingMaxRetry,a=r.levelLoadingTimeOut,n=r.levelLoadingRetryDelay,o=r.levelLoadingMaxRetryTimeout}l=this.createInternalLoader(t),t.url=e,t.responseType=t.responseType||"";var d={timeout:a,maxRetry:i,retryDelay:n,maxRetryDelay:o},c={onSuccess:this.loadsuccess.bind(this),onError:this.loaderror.bind(this),onTimeout:this.loadtimeout.bind(this)};return s.logger.debug("Calling internal loader delegate for URL: "+e),l.load(t,d,c),!0},r.prototype.loadsuccess=function(e,t,r,i){if(void 0===i&&(i=null),r.isSidxRequest)return this._handleSidxRequest(e,r),void this._handlePlaylistLoaded(e,t,r,i);this.resetInternalLoader(r.type);var a=e.data;t.tload=d.now(),0===a.indexOf("#EXTM3U")?a.indexOf("#EXTINF:")>0||a.indexOf("#EXT-X-TARGETDURATION:")>0?this._handleTrackOrLevelPlaylist(e,t,r,i):this._handleMasterPlaylist(e,t,r,i):this._handleManifestParsingError(e,r,"no EXTM3U delimiter",i)},r.prototype.loaderror=function(e,t,r){void 0===r&&(r=null),this._handleNetworkError(t,r,!1,e)},r.prototype.loadtimeout=function(e,t,r){void 0===r&&(r=null),this._handleNetworkError(t,r,!0)},r.prototype._handleMasterPlaylist=function(e,t,i,n){var o=this.hls,l=e.data,d=r.getResponseUrl(e,i),f=u.default.parseMasterPlaylist(l,d);if(f.length){var c=f.map(function(e){return{id:e.attrs.AUDIO,codec:e.audioCodec}}),h=u.default.parseMasterPlaylistMedia(l,d,"AUDIO",c),p=u.default.parseMasterPlaylistMedia(l,d,"SUBTITLES");if(h.length){var g=!1;h.forEach(function(e){e.url||(g=!0)}),!1===g&&f[0].audioCodec&&!f[0].attrs.AUDIO&&(s.logger.log("audio codec signaled in quality level, but no embedded audio track signaled, create one"),h.unshift({type:"main",name:"main"}))}o.trigger(a.default.MANIFEST_LOADED,{levels:f,audioTracks:h,subtitles:p,url:d,stats:t,networkDetails:n})}else this._handleManifestParsingError(e,i,"no level found in manifest",n)},r.prototype._handleTrackOrLevelPlaylist=function(t,i,n,o){var s=this.hls,l=n.id,c=n.level,h=n.type,p=r.getResponseUrl(t,n),g=e.isFinite(l)?l:0,v=e.isFinite(c)?c:g,m=r.mapContextToLevelType(n),y=u.default.parseLevelPlaylist(t.data,p,v,m,g);if(y.tload=i.tload,h===f.MANIFEST){var _={url:p,details:y};s.trigger(a.default.MANIFEST_LOADED,{levels:[_],audioTracks:[],url:p,stats:i,networkDetails:o})}if(i.tparsed=d.now(),y.needSidxRanges){var E=y.initSegment.url;this.load(E,{isSidxRequest:!0,type:h,level:c,levelDetails:y,id:l,rangeStart:0,rangeEnd:2048,responseType:"arraybuffer"})}else n.levelDetails=y,this._handlePlaylistLoaded(t,i,n,o)},r.prototype._handleSidxRequest=function(e,t){var r=l.default.parseSegmentIndex(new Uint8Array(e.data));if(r){var i=r.references,a=t.levelDetails;i.forEach(function(e,t){var r=e.info,i=a.fragments[t];0===i.byteRange.length&&(i.rawByteRange=String(1+r.end-r.start)+"@"+String(r.start))}),a.initSegment.rawByteRange=String(r.moovEndOffset)+"@0"}},r.prototype._handleManifestParsingError=function(e,t,r,i){this.hls.trigger(a.default.ERROR,{type:o.ErrorTypes.NETWORK_ERROR,details:o.ErrorDetails.MANIFEST_PARSING_ERROR,fatal:!0,url:e.url,reason:r,networkDetails:i})},r.prototype._handleNetworkError=function(e,t,r,i){var n,l;void 0===r&&(r=!1),void 0===i&&(i=null),s.logger.info("A network error occured while loading a "+e.type+"-type playlist");var u=this.getInternalLoader(e);switch(e.type){case f.MANIFEST:n=r?o.ErrorDetails.MANIFEST_LOAD_TIMEOUT:o.ErrorDetails.MANIFEST_LOAD_ERROR,l=!0;break;case f.LEVEL:n=r?o.ErrorDetails.LEVEL_LOAD_TIMEOUT:o.ErrorDetails.LEVEL_LOAD_ERROR,l=!1;break;case f.AUDIO_TRACK:n=r?o.ErrorDetails.AUDIO_TRACK_LOAD_TIMEOUT:o.ErrorDetails.AUDIO_TRACK_LOAD_ERROR,l=!1;break;default:l=!1}u&&(u.abort(),this.resetInternalLoader(e.type));var d={type:o.ErrorTypes.NETWORK_ERROR,details:n,fatal:l,url:u.url,loader:u,context:e,networkDetails:t};i&&(d.response=i),this.hls.trigger(a.default.ERROR,d)},r.prototype._handlePlaylistLoaded=function(e,t,i,n){var o=i.type,s=i.level,l=i.id,u=i.levelDetails;if(u.targetduration)if(r.canHaveQualityLevels(i.type))this.hls.trigger(a.default.LEVEL_LOADED,{details:u,level:s||0,id:l||0,stats:t,networkDetails:n});else switch(o){case f.AUDIO_TRACK:this.hls.trigger(a.default.AUDIO_TRACK_LOADED,{details:u,id:l,stats:t,networkDetails:n});break;case f.SUBTITLE_TRACK:this.hls.trigger(a.default.SUBTITLE_TRACK_LOADED,{details:u,id:l,stats:t,networkDetails:n})}else this._handleManifestParsingError(e,i,"invalid target duration",n)},r}(n.default);t.default=h}).call(this,r(2).Number)},function(e,t,r){"use strict";Object.defineProperty(t,"__esModule",{value:!0});var i=r(0),a=r(1),n=Math.pow(2,32)-1,o=function(){function e(e,t){this.observer=e,this.remuxer=t}return e.prototype.resetTimeStamp=function(e){this.initPTS=e},e.prototype.resetInitSegment=function(t,r,i,n){if(t&&t.byteLength){var o=this.initData=e.parseInitSegment(t);null==r&&(r="mp4a.40.5"),null==i&&(i="avc1.42e01e");var s={};o.audio&&o.video?s.audiovideo={container:"video/mp4",codec:r+","+i,initSegment:n?t:null}:(o.audio&&(s.audio={container:"audio/mp4",codec:r,initSegment:n?t:null}),o.video&&(s.video={container:"video/mp4",codec:i,initSegment:n?t:null})),this.observer.trigger(a.default.FRAG_PARSING_INIT_SEGMENT,{tracks:s})}else r&&(this.audioCodec=r),i&&(this.videoCodec=i)},e.probe=function(t){return e.findBox({data:t,start:0,end:Math.min(t.length,16384)},["moof"]).length>0},e.bin2str=function(e){return String.fromCharCode.apply(null,e)},e.readUint16=function(e,t){e.data&&(t+=e.start,e=e.data);var r=e[t]<<8|e[t+1];return r<0?65536+r:r},e.readUint32=function(e,t){e.data&&(t+=e.start,e=e.data);var r=e[t]<<24|e[t+1]<<16|e[t+2]<<8|e[t+3];return r<0?4294967296+r:r},e.writeUint32=function(e,t,r){e.data&&(t+=e.start,e=e.data),e[t]=r>>24,e[t+1]=r>>16&255,e[t+2]=r>>8&255,e[t+3]=255&r},e.findBox=function(t,r){var i,a,n,o,s,l,u,d=[];if(t.data?(l=t.start,o=t.end,t=t.data):(l=0,o=t.byteLength),!r.length)return null;for(i=l;i<o;)a=e.readUint32(t,i),n=e.bin2str(t.subarray(i+4,i+8)),u=a>1?i+a:o,n===r[0]&&(1===r.length?d.push({data:t,start:i+8,end:u}):(s=e.findBox({data:t,start:i+8,end:u},r.slice(1))).length&&(d=d.concat(s))),i=u;return d},e.parseSegmentIndex=function(t){var r,i=e.findBox(t,["moov"])[0],a=i?i.end:null,n=0,o=e.findBox(t,["sidx"]);if(!o||!o[0])return null;r=[];var s=(o=o[0]).data[0];n=0===s?8:16;var l=e.readUint32(o,n);n+=4;n+=0===s?8:16,n+=2;var u=o.end+0,d=e.readUint16(o,n);n+=2;for(var f=0;f<d;f++){var c=n,h=e.readUint32(o,c);c+=4;var p=2147483647&h;if(1===(2147483648&h)>>>31)return void console.warn("SIDX has hierarchical references (not supported)");var g=e.readUint32(o,c);c+=4,r.push({referenceSize:p,subsegmentDuration:g,info:{duration:g/l,start:u,end:u+p-1}}),u+=p,n=c+=4}return{earliestPresentationTime:0,timescale:l,version:s,referencesCount:d,references:r,moovEndOffset:a}},e.parseInitSegment=function(t){var r=[];return e.findBox(t,["moov","trak"]).forEach(function(t){var a=e.findBox(t,["tkhd"])[0];if(a){var n=a.data[a.start],o=0===n?12:20,s=e.readUint32(a,o),l=e.findBox(t,["mdia","mdhd"])[0];if(l){o=0===(n=l.data[l.start])?12:20;var u=e.readUint32(l,o),d=e.findBox(t,["mdia","hdlr"])[0];if(d){var f={soun:"audio",vide:"video"}[e.bin2str(d.data.subarray(d.start+8,d.start+12))];if(f){var c=e.findBox(t,["mdia","minf","stbl","stsd"]);if(c.length){c=c[0];var h=e.bin2str(c.data.subarray(c.start+12,c.start+16));i.logger.log("MP4Demuxer:"+f+":"+h+" found")}r[s]={timescale:u,type:f},r[f]={timescale:u,id:s}}}}}}),r},e.getStartDTS=function(t,r){var i,a,n;return i=e.findBox(r,["moof","traf"]),a=[].concat.apply([],i.map(function(r){return e.findBox(r,["tfhd"]).map(function(i){var a,n;return a=e.readUint32(i,4),n=t[a].timescale||9e4,e.findBox(r,["tfdt"]).map(function(t){var r,i;return r=t.data[t.start],i=e.readUint32(t,4),1===r&&(i*=Math.pow(2,32),i+=e.readUint32(t,8)),i})[0]/n})})),n=Math.min.apply(null,a),isFinite(n)?n:0},e.offsetStartDTS=function(t,r,i){e.findBox(r,["moof","traf"]).map(function(r){return e.findBox(r,["tfhd"]).map(function(a){var o=e.readUint32(a,4),s=t[o].timescale||9e4;e.findBox(r,["tfdt"]).map(function(t){var r=t.data[t.start],a=e.readUint32(t,4);if(0===r)e.writeUint32(t,4,a-i*s);else{a*=Math.pow(2,32),a+=e.readUint32(t,8),a-=i*s,a=Math.max(a,0);var o=Math.floor(a/(n+1)),l=Math.floor(a%(n+1));e.writeUint32(t,4,o),e.writeUint32(t,8,l)}})})})},e.prototype.append=function(t,r,i,n){var o=this.initData;o||(this.resetInitSegment(t,this.audioCodec,this.videoCodec,!1),o=this.initData);var s,l=this.initPTS;if(void 0===l){var u=e.getStartDTS(o,t);this.initPTS=l=u-r,this.observer.trigger(a.default.INIT_PTS_FOUND,{initPTS:l})}e.offsetStartDTS(o,t,l),s=e.getStartDTS(o,t),this.remuxer.remux(o.audio,o.video,null,null,s,i,n,t)},e.prototype.destroy=function(){},e}();t.default=o},function(e,t,r){"use strict";(function(e){Object.defineProperty(t,"__esModule",{value:!0});var i=r(7),a=r(16),n=function(){function t(){var e;this._url=null,this._byteRange=null,this._decryptdata=null,this.tagList=[],this.programDateTime=null,this.rawProgramDateTime=null,this._elementaryStreams=((e={})[t.ElementaryStreamTypes.AUDIO]=!1,e[t.ElementaryStreamTypes.VIDEO]=!1,e)}return Object.defineProperty(t,"ElementaryStreamTypes",{get:function(){return{AUDIO:"audio",VIDEO:"video"}},enumerable:!0,configurable:!0}),Object.defineProperty(t.prototype,"url",{get:function(){return!this._url&&this.relurl&&(this._url=i.buildAbsoluteURL(this.baseurl,this.relurl,{alwaysNormalize:!0})),this._url},set:function(e){this._url=e},enumerable:!0,configurable:!0}),Object.defineProperty(t.prototype,"byteRange",{get:function(){if(!this._byteRange&&!this.rawByteRange)return[];if(this._byteRange)return this._byteRange;var e=[];if(this.rawByteRange){var t=this.rawByteRange.split("@",2);if(1===t.length){var r=this.lastByteRangeEndOffset;e[0]=r||0}else e[0]=parseInt(t[1]);e[1]=parseInt(t[0])+e[0],this._byteRange=e}return e},enumerable:!0,configurable:!0}),Object.defineProperty(t.prototype,"byteRangeStartOffset",{get:function(){return this.byteRange[0]},enumerable:!0,configurable:!0}),Object.defineProperty(t.prototype,"byteRangeEndOffset",{get:function(){return this.byteRange[1]},enumerable:!0,configurable:!0}),Object.defineProperty(t.prototype,"decryptdata",{get:function(){return this._decryptdata||(this._decryptdata=this.fragmentDecryptdataFromLevelkey(this.levelkey,this.sn)),this._decryptdata},enumerable:!0,configurable:!0}),Object.defineProperty(t.prototype,"endProgramDateTime",{get:function(){if(!e.isFinite(this.programDateTime))return null;var t=e.isFinite(this.duration)?this.duration:0;return this.programDateTime+1e3*t},enumerable:!0,configurable:!0}),Object.defineProperty(t.prototype,"encrypted",{get:function(){return!(!this.decryptdata||null===this.decryptdata.uri||null!==this.decryptdata.key)},enumerable:!0,configurable:!0}),t.prototype.addElementaryStream=function(e){this._elementaryStreams[e]=!0},t.prototype.hasElementaryStream=function(e){return!0===this._elementaryStreams[e]},t.prototype.createInitializationVector=function(e){for(var t=new Uint8Array(16),r=12;r<16;r++)t[r]=e>>8*(15-r)&255;return t},t.prototype.fragmentDecryptdataFromLevelkey=function(e,t){var r=e;return e&&e.method&&e.uri&&!e.iv&&((r=new a.default).method=e.method,r.baseuri=e.baseuri,r.reluri=e.reluri,r.iv=this.createInitializationVector(t)),r},t}();t.default=n}).call(this,r(2).Number)},function(e,t,r){"use strict";Object.defineProperty(t,"__esModule",{value:!0});var i=r(7),a=function(){function e(){this.method=null,this.key=null,this.iv=null,this._uri=null}return Object.defineProperty(e.prototype,"uri",{get:function(){return!this._uri&&this.reluri&&(this._uri=i.buildAbsoluteURL(this.baseuri,this.reluri,{alwaysNormalize:!0})),this._uri},enumerable:!0,configurable:!0}),e}();t.default=a},function(e,t,r){"use strict";Object.defineProperty(t,"__esModule",{value:!0});var i={audio:{a3ds:!0,"ac-3":!0,"ac-4":!0,alac:!0,alaw:!0,dra1:!0,"dts+":!0,"dts-":!0,dtsc:!0,dtse:!0,dtsh:!0,"ec-3":!0,enca:!0,g719:!0,g726:!0,m4ae:!0,mha1:!0,mha2:!0,mhm1:!0,mhm2:!0,mlpa:!0,mp4a:!0,"raw ":!0,Opus:!0,samr:!0,sawb:!0,sawp:!0,sevc:!0,sqcp:!0,ssmv:!0,twos:!0,ulaw:!0},video:{avc1:!0,avc2:!0,avc3:!0,avc4:!0,avcp:!0,drac:!0,dvav:!0,dvhe:!0,encv:!0,hev1:!0,hvc1:!0,mjp2:!0,mp4v:!0,mvc1:!0,mvc2:!0,mvc3:!0,mvc4:!0,resv:!0,rv60:!0,s263:!0,svc1:!0,svc2:!0,"vc-1":!0,vp08:!0,vp09:!0}};t.isCodecType=function(e,t){var r=i[t];return!!r&&!0===r[e.slice(0,4)]},t.isCodecSupportedInMp4=function(e,t){return window.MediaSource.isTypeSupported((t||"video")+'/mp4;codecs="'+e+'"')}},function(e,t,r){"use strict";Object.defineProperty(t,"__esModule",{value:!0});var i,a=r(1),n=r(3),o=r(19),s=r(36),l=r(14),u=r(37),d=r(40),f=r(41),c=r(44),h=r(6),p=r(0),g=h.getSelfScope();try{i=g.performance.now.bind(g.performance)}catch(e){p.logger.debug("Unable to use Performance API on this environment"),i=g.Date.now}var v=function(){function e(e,t,r,i){this.observer=e,this.typeSupported=t,this.config=r,this.vendor=i}return e.prototype.destroy=function(){var e=this.demuxer;e&&e.destroy()},e.prototype.push=function(e,t,r,n,s,l,u,d,f,c,h,p){var g=this;if(e.byteLength>0&&null!=t&&null!=t.key&&"AES-128"===t.method){var v=this.decrypter;null==v&&(v=this.decrypter=new o.default(this.observer,this.config));var m=i();v.decrypt(e,t.key.buffer,t.iv.buffer,function(e){var o=i();g.observer.trigger(a.default.FRAG_DECRYPTED,{stats:{tstart:m,tdecrypt:o}}),g.pushDecrypted(new Uint8Array(e),t,new Uint8Array(r),n,s,l,u,d,f,c,h,p)})}else this.pushDecrypted(new Uint8Array(e),t,new Uint8Array(r),n,s,l,u,d,f,c,h,p)},e.prototype.pushDecrypted=function(e,t,r,i,o,h,p,g,v,m,y,_){var E=this.demuxer;if(!E||(p||g)&&!this.probe(e)){for(var b=this.observer,S=this.typeSupported,T=this.config,A=[{demux:u.default,remux:f.default},{demux:l.default,remux:c.default},{demux:s.default,remux:f.default},{demux:d.default,remux:f.default}],R=0,L=A.length;R<L;R++){var D=A[R],O=D.demux.probe;if(O(e)){var w=this.remuxer=new D.remux(b,T,S,this.vendor);E=new D.demux(b,w,T,S),this.probe=O;break}}if(!E)return void b.trigger(a.default.ERROR,{type:n.ErrorTypes.MEDIA_ERROR,details:n.ErrorDetails.FRAG_PARSING_ERROR,fatal:!0,reason:"no demux matching with content found"});this.demuxer=E}var P=this.remuxer;(p||g)&&(E.resetInitSegment(r,i,o,m),P.resetInitSegment()),p&&(E.resetTimeStamp(_),P.resetTimeStamp(_)),"function"==typeof E.setDecryptData&&E.setDecryptData(t),E.append(e,h,v,y)},e}();t.default=v},function(e,t,r){"use strict";Object.defineProperty(t,"__esModule",{value:!0});var i=r(33),a=r(34),n=r(35),o=r(3),s=r(0),l=r(1),u=r(6).getSelfScope(),d=function(){function e(e,t,r){var i=(void 0===r?{}:r).removePKCS7Padding,a=void 0===i||i;if(this.logEnabled=!0,this.observer=e,this.config=t,this.removePKCS7Padding=a,a)try{var n=u.crypto;n&&(this.subtle=n.subtle||n.webkitSubtle)}catch(e){}this.disableWebCrypto=!this.subtle}return e.prototype.isSync=function(){return this.disableWebCrypto&&this.config.enableSoftwareAES},e.prototype.decrypt=function(e,t,r,o){var l=this;if(this.disableWebCrypto&&this.config.enableSoftwareAES){this.logEnabled&&(s.logger.log("JS AES decrypt"),this.logEnabled=!1);var u=this.decryptor;u||(this.decryptor=u=new n.default),u.expandKey(t),o(u.decrypt(e,0,r,this.removePKCS7Padding))}else{this.logEnabled&&(s.logger.log("WebCrypto AES decrypt"),this.logEnabled=!1);var d=this.subtle;this.key!==t&&(this.key=t,this.fastAesKey=new a.default(d,t)),this.fastAesKey.expandKey().then(function(a){new i.default(d,r).decrypt(e,a).catch(function(i){l.onWebCryptoError(i,e,t,r,o)}).then(function(e){o(e)})}).catch(function(i){l.onWebCryptoError(i,e,t,r,o)})}},e.prototype.onWebCryptoError=function(e,t,r,i,a){this.config.enableSoftwareAES?(s.logger.log("WebCrypto Error, disable WebCrypto API"),this.disableWebCrypto=!0,this.logEnabled=!0,this.decrypt(t,r,i,a)):(s.logger.error("decrypting error : "+e.message),this.observer.trigger(l.default.ERROR,{type:o.ErrorTypes.MEDIA_ERROR,details:o.ErrorDetails.FRAG_DECRYPT_ERROR,fatal:!0,reason:e.message}))},e.prototype.destroy=function(){var e=this.decryptor;e&&(e.destroy(),this.decryptor=void 0)},e}();t.default=d},function(e,t,r){"use strict";Object.defineProperty(t,"__esModule",{value:!0});var i=r(0),a=r(3),n=r(1);function o(e,t,r,o){var s,l,u,d,f,c=navigator.userAgent.toLowerCase(),h=o,p=[96e3,88200,64e3,48e3,44100,32e3,24e3,22050,16e3,12e3,11025,8e3,7350];if(s=1+((192&t[r+2])>>>6),!((l=(60&t[r+2])>>>2)>p.length-1))return d=(1&t[r+2])<<2,d|=(192&t[r+3])>>>6,i.logger.log("manifest codec:"+o+",ADTS data:type:"+s+",sampleingIndex:"+l+"["+p[l]+"Hz],channelConfig:"+d),/firefox/i.test(c)?l>=6?(s=5,f=new Array(4),u=l-3):(s=2,f=new Array(2),u=l):-1!==c.indexOf("android")?(s=2,f=new Array(2),u=l):(s=5,f=new Array(4),o&&(-1!==o.indexOf("mp4a.40.29")||-1!==o.indexOf("mp4a.40.5"))||!o&&l>=6?u=l-3:((o&&-1!==o.indexOf("mp4a.40.2")&&(l>=6&&1===d||/vivaldi/i.test(c))||!o&&1===d)&&(s=2,f=new Array(2)),u=l)),f[0]=s<<3,f[0]|=(14&l)>>1,f[1]|=(1&l)<<7,f[1]|=d<<3,5===s&&(f[1]|=(14&u)>>1,f[2]=(1&u)<<7,f[2]|=8,f[3]=0),{config:f,samplerate:p[l],channelCount:d,codec:"mp4a.40."+s,manifestCodec:h};e.trigger(n.default.ERROR,{type:a.ErrorTypes.MEDIA_ERROR,details:a.ErrorDetails.FRAG_PARSING_ERROR,fatal:!0,reason:"invalid ADTS sampling index:"+l})}function s(e,t){return 255===e[t]&&240==(246&e[t+1])}function l(e,t){return 1&e[t+1]?7:9}function u(e,t){return(3&e[t+3])<<11|e[t+4]<<3|(224&e[t+5])>>>5}function d(e){return 9216e4/e}function f(e,t,r,i,a){var n,o,s=e.length;if(n=l(e,t),o=u(e,t),(o-=n)>0&&t+n+o<=s)return{headerLength:n,frameLength:o,stamp:r+i*a}}t.getAudioConfig=o,t.isHeaderPattern=s,t.getHeaderLength=l,t.getFullFrameLength=u,t.isHeader=function(e,t){return!!(t+1<e.length&&s(e,t))},t.probe=function(e,t){if(t+1<e.length&&s(e,t)){var r=l(e,t);t+5<e.length&&(r=u(e,t));var i=t+r;if(i===e.length||i+1<e.length&&s(e,i))return!0}return!1},t.initTrackConfig=function(e,t,r,a,n){if(!e.samplerate){var s=o(t,r,a,n);e.config=s.config,e.samplerate=s.samplerate,e.channelCount=s.channelCount,e.codec=s.codec,e.manifestCodec=s.manifestCodec,i.logger.log("parsed codec:"+e.codec+",rate:"+s.samplerate+",nb channel:"+s.channelCount)}},t.getFrameDuration=d,t.parseFrameHeader=f,t.appendFrame=function(e,t,r,i,a){var n=f(t,r,i,a,d(e.samplerate));if(n){var o=n.stamp,s=n.headerLength,l=n.frameLength,u={unit:t.subarray(r+s,r+s+l),pts:o,dts:o};return e.samples.push(u),e.len+=l,{sample:u,length:l+s}}}},function(e,t,r){"use strict";Object.defineProperty(t,"__esModule",{value:!0});var i={BitratesMap:[32,64,96,128,160,192,224,256,288,320,352,384,416,448,32,48,56,64,80,96,112,128,160,192,224,256,320,384,32,40,48,56,64,80,96,112,128,160,192,224,256,320,32,48,56,64,80,96,112,128,144,160,176,192,224,256,8,16,24,32,40,48,56,64,80,96,112,128,144,160],SamplingRateMap:[44100,48e3,32e3,22050,24e3,16e3,11025,12e3,8e3],SamplesCoefficients:[[0,72,144,12],[0,0,0,0],[0,72,144,12],[0,144,144,12]],BytesInSlot:[0,1,1,4],appendFrame:function(e,t,r,i,a){if(!(r+24>t.length)){var n=this.parseHeader(t,r);if(n&&r+n.frameLength<=t.length){var o=i+a*(9e4*n.samplesPerFrame/n.sampleRate),s={unit:t.subarray(r,r+n.frameLength),pts:o,dts:o};return e.config=[],e.channelCount=n.channelCount,e.samplerate=n.sampleRate,e.samples.push(s),e.len+=n.frameLength,{sample:s,length:n.frameLength}}}},parseHeader:function(e,t){var r=e[t+1]>>3&3,a=e[t+1]>>1&3,n=e[t+2]>>4&15,o=e[t+2]>>2&3,s=e[t+2]>>1&1;if(1!==r&&0!==n&&15!==n&&3!==o){var l=3===r?3-a:3===a?3:4,u=1e3*i.BitratesMap[14*l+n-1],d=3===r?0:2===r?1:2,f=i.SamplingRateMap[3*d+o],c=e[t+3]>>6==3?1:2,h=i.SamplesCoefficients[r][a],p=i.BytesInSlot[a],g=8*h*p;return{sampleRate:f,channelCount:c,frameLength:parseInt(h*u/f+s,10)*p,samplesPerFrame:g}}},isHeaderPattern:function(e,t){return 255===e[t]&&224==(224&e[t+1])&&0!=(6&e[t+1])},isHeader:function(e,t){return!!(t+1<e.length&&this.isHeaderPattern(e,t))},probe:function(e,t){if(t+1<e.length&&this.isHeaderPattern(e,t)){var r=this.parseHeader(e,t),i=4;r&&r.frameLength&&(i=r.frameLength);var a=t+i;if(a===e.length||a+1<e.length&&this.isHeaderPattern(e,a))return!0}return!1}};t.default=i},function(e,t,r){"use strict";var i=this&&this.__extends||function(){var e=Object.setPrototypeOf||{__proto__:[]}instanceof Array&&function(e,t){e.__proto__=t}||function(e,t){for(var r in t)t.hasOwnProperty(r)&&(e[r]=t[r])};return function(t,r){function i(){this.constructor=t}e(t,r),t.prototype=null===r?Object.create(r):(i.prototype=r.prototype,new i)}}();Object.defineProperty(t,"__esModule",{value:!0});var a=function(e){function t(){return null!==e&&e.apply(this,arguments)||this}return i(t,e),t.prototype.trigger=function(e){for(var t=[],r=1;r<arguments.length;r++)t[r-1]=arguments[r];this.emit.apply(this,[e,e].concat(t))},t}(r(45).EventEmitter);t.Observer=a},function(e,t,r){"use strict";(function(e){Object.defineProperty(t,"__esModule",{value:!0});var i=r(0);function a(t,r,a){var n=t[r],o=t[a],s=o.startPTS;e.isFinite(s)?a>r?(n.duration=s-n.start,n.duration<0&&i.logger.warn("negative duration computed for frag "+n.sn+",level "+n.level+", there should be some duration drift between playlist and fragment!")):(o.duration=n.start-s,o.duration<0&&i.logger.warn("negative duration computed for frag "+o.sn+",level "+o.level+", there should be some duration drift between playlist and fragment!")):o.start=a>r?n.start+n.duration:Math.max(n.start-o.duration,0)}function n(t,r,i,n,o,s){var l=i;if(e.isFinite(r.startPTS)){var u=Math.abs(r.startPTS-i);e.isFinite(r.deltaPTS)?r.deltaPTS=Math.max(u,r.deltaPTS):r.deltaPTS=u,l=Math.max(i,r.startPTS),i=Math.min(i,r.startPTS),n=Math.max(n,r.endPTS),o=Math.min(o,r.startDTS),s=Math.max(s,r.endDTS)}var d=i-r.start;r.start=r.startPTS=i,r.maxStartPTS=l,r.endPTS=n,r.startDTS=o,r.endDTS=s,r.duration=n-i;var f,c,h,p=r.sn;if(!t||p<t.startSN||p>t.endSN)return 0;for(f=p-t.startSN,(c=t.fragments)[f]=r,h=f;h>0;h--)a(c,h,h-1);for(h=f;h<c.length-1;h++)a(c,h,h+1);return t.PTSKnown=!0,d}function o(e,t,r){if(e&&t)for(var i=Math.max(e.startSN,t.startSN)-t.startSN,a=Math.min(e.endSN,t.endSN)-t.startSN,n=t.startSN-e.startSN,o=i;o<=a;o++){var s=e.fragments[n+o],l=t.fragments[o];if(!s||!l)break;r(s,l,o)}}function s(e,t){var r=t.startSN-e.startSN,i=e.fragments,a=t.fragments;if(!(r<0||r>i.length))for(var n=0;n<a.length;n++)a[n].start+=i[r].start}t.addGroupId=function(e,t,r){switch(t){case"audio":e.audioGroupIds||(e.audioGroupIds=[]),e.audioGroupIds.push(r);break;case"text":e.textGroupIds||(e.textGroupIds=[]),e.textGroupIds.push(r)}},t.updatePTS=a,t.updateFragPTSDTS=n,t.mergeDetails=function(t,r){r.initSegment&&t.initSegment&&(r.initSegment=t.initSegment);var a,l=0;if(o(t,r,function(t,i){l=t.cc-i.cc,e.isFinite(t.startPTS)&&(i.start=i.startPTS=t.startPTS,i.endPTS=t.endPTS,i.duration=t.duration,i.backtracked=t.backtracked,i.dropped=t.dropped,a=i),r.PTSKnown=!0}),r.PTSKnown){if(l){i.logger.log("discontinuity sliding from playlist, take drift into account");for(var u=r.fragments,d=0;d<u.length;d++)u[d].cc+=l}a?n(r,a,a.startPTS,a.endPTS,a.startDTS,a.endDTS):s(t,r),r.PTSKnown=t.PTSKnown}},t.mergeSubtitlePlaylists=function(e,t,r){void 0===r&&(r=0);var i=-1;o(e,t,function(e,t,r){t.start=e.start,i=r});var a=t.fragments;if(i<0)a.forEach(function(e){e.start+=r});else for(var n=i+1;n<a.length;n++)a[n].start=a[n-1].start+a[n-1].duration},t.mapFragmentIntersection=o,t.adjustSliding=s,t.computeReloadInterval=function(e,t,r){var i=1e3*(t.averagetargetduration?t.averagetargetduration:t.targetduration),a=i/2;return e&&t.endSN===e.endSN&&(i=a),r&&(i=Math.max(a,i-(window.performance.now()-r))),Math.round(i)}}).call(this,r(2).Number)},function(e,t,r){"use strict";var i=this&&this.__extends||function(){var e=Object.setPrototypeOf||{__proto__:[]}instanceof Array&&function(e,t){e.__proto__=t}||function(e,t){for(var r in t)t.hasOwnProperty(r)&&(e[r]=t[r])};return function(t,r){function i(){this.constructor=t}e(t,r),t.prototype=null===r?Object.create(r):(i.prototype=r.prototype,new i)}}();Object.defineProperty(t,"__esModule",{value:!0});var a=r(7),n=r(3),o=r(13),s=r(28),l=r(29),u=r(9),d=r(30),f=r(54),c=r(55),h=r(57),p=r(0),g=r(58),v=r(1),m=function(e){function t(r){void 0===r&&(r={});var i=e.call(this)||this,a=t.DefaultConfig;if((r.liveSyncDurationCount||r.liveMaxLatencyDurationCount)&&(r.liveSyncDuration||r.liveMaxLatencyDuration))throw new Error("Illegal hls.js config: don't mix up liveSyncDurationCount/liveMaxLatencyDurationCount and liveSyncDuration/liveMaxLatencyDuration");for(var n in a)n in r||(r[n]=a[n]);if(void 0!==r.liveMaxLatencyDurationCount&&r.liveMaxLatencyDurationCount<=r.liveSyncDurationCount)throw new Error('Illegal hls.js config: "liveMaxLatencyDurationCount" must be gt "liveSyncDurationCount"');if(void 0!==r.liveMaxLatencyDuration&&(r.liveMaxLatencyDuration<=r.liveSyncDuration||void 0===r.liveSyncDuration))throw new Error('Illegal hls.js config: "liveMaxLatencyDuration" must be gt "liveSyncDuration"');p.enableLogs(r.debug),i.config=r,i._autoLevelCapping=-1;var h=i.abrController=new r.abrController(i),g=new r.bufferController(i),v=new r.capLevelController(i),m=new r.fpsController(i),y=new o.default(i),_=new s.default(i),E=new l.default(i),b=new c.default(i),S=i.levelController=new f.default(i),T=new u.FragmentTracker(i),A=[S,i.streamController=new d.default(i,T)],R=r.audioStreamController;R&&A.push(new R(i,T)),i.networkControllers=A;var L=[y,_,E,h,g,v,m,b,T];if(R=r.audioTrackController){var D=new R(i);i.audioTrackController=D,L.push(D)}if(R=r.subtitleTrackController){var O=new R(i);i.subtitleTrackController=O,A.push(O)}if(R=r.emeController){var w=new R(i);i.emeController=w,L.push(w)}return(R=r.subtitleStreamController)&&A.push(new R(i,T)),(R=r.timelineController)&&L.push(new R(i)),i.coreComponents=L,i}return i(t,e),Object.defineProperty(t,"version",{get:function(){return"0.12.4"},enumerable:!0,configurable:!0}),t.isSupported=function(){return h.isSupported()},Object.defineProperty(t,"Events",{get:function(){return v.default},enumerable:!0,configurable:!0}),Object.defineProperty(t,"ErrorTypes",{get:function(){return n.ErrorTypes},enumerable:!0,configurable:!0}),Object.defineProperty(t,"ErrorDetails",{get:function(){return n.ErrorDetails},enumerable:!0,configurable:!0}),Object.defineProperty(t,"DefaultConfig",{get:function(){return t.defaultConfig?t.defaultConfig:g.hlsDefaultConfig},set:function(e){t.defaultConfig=e},enumerable:!0,configurable:!0}),t.prototype.destroy=function(){p.logger.log("destroy"),this.trigger(v.default.DESTROYING),this.detachMedia(),this.coreComponents.concat(this.networkControllers).forEach(function(e){e.destroy()}),this.url=null,this.removeAllListeners(),this._autoLevelCapping=-1},t.prototype.attachMedia=function(e){p.logger.log("attachMedia"),this.media=e,this.trigger(v.default.MEDIA_ATTACHING,{media:e})},t.prototype.detachMedia=function(){p.logger.log("detachMedia"),this.trigger(v.default.MEDIA_DETACHING),this.media=null},t.prototype.loadSource=function(e){e=a.buildAbsoluteURL(window.location.href,e,{alwaysNormalize:!0}),p.logger.log("loadSource:"+e),this.url=e,this.trigger(v.default.MANIFEST_LOADING,{url:e})},t.prototype.startLoad=function(e){void 0===e&&(e=-1),p.logger.log("startLoad("+e+")"),this.networkControllers.forEach(function(t){t.startLoad(e)})},t.prototype.stopLoad=function(){p.logger.log("stopLoad"),this.networkControllers.forEach(function(e){e.stopLoad()})},t.prototype.swapAudioCodec=function(){p.logger.log("swapAudioCodec"),this.streamController.swapAudioCodec()},t.prototype.recoverMediaError=function(){p.logger.log("recoverMediaError");var e=this.media;this.detachMedia(),this.attachMedia(e)},Object.defineProperty(t.prototype,"levels",{get:function(){return this.levelController.levels},enumerable:!0,configurable:!0}),Object.defineProperty(t.prototype,"currentLevel",{get:function(){return this.streamController.currentLevel},set:function(e){p.logger.log("set currentLevel:"+e),this.loadLevel=e,this.streamController.immediateLevelSwitch()},enumerable:!0,configurable:!0}),Object.defineProperty(t.prototype,"nextLevel",{get:function(){return this.streamController.nextLevel},set:function(e){p.logger.log("set nextLevel:"+e),this.levelController.manualLevel=e,this.streamController.nextLevelSwitch()},enumerable:!0,configurable:!0}),Object.defineProperty(t.prototype,"loadLevel",{get:function(){return this.levelController.level},set:function(e){p.logger.log("set loadLevel:"+e),this.levelController.manualLevel=e},enumerable:!0,configurable:!0}),Object.defineProperty(t.prototype,"nextLoadLevel",{get:function(){return this.levelController.nextLoadLevel},set:function(e){this.levelController.nextLoadLevel=e},enumerable:!0,configurable:!0}),Object.defineProperty(t.prototype,"firstLevel",{get:function(){return Math.max(this.levelController.firstLevel,this.minAutoLevel)},set:function(e){p.logger.log("set firstLevel:"+e),this.levelController.firstLevel=e},enumerable:!0,configurable:!0}),Object.defineProperty(t.prototype,"startLevel",{get:function(){return this.levelController.startLevel},set:function(e){p.logger.log("set startLevel:"+e);-1!==e&&(e=Math.max(e,this.minAutoLevel)),this.levelController.startLevel=e},enumerable:!0,configurable:!0}),Object.defineProperty(t.prototype,"autoLevelCapping",{get:function(){return this._autoLevelCapping},set:function(e){p.logger.log("set autoLevelCapping:"+e),this._autoLevelCapping=e},enumerable:!0,configurable:!0}),Object.defineProperty(t.prototype,"autoLevelEnabled",{get:function(){return-1===this.levelController.manualLevel},enumerable:!0,configurable:!0}),Object.defineProperty(t.prototype,"manualLevel",{get:function(){return this.levelController.manualLevel},enumerable:!0,configurable:!0}),Object.defineProperty(t.prototype,"minAutoLevel",{get:function(){for(var e=this.levels,t=this.config.minAutoBitrate,r=e?e.length:0,i=0;i<r;i++){if((e[i].realBitrate?Math.max(e[i].realBitrate,e[i].bitrate):e[i].bitrate)>t)return i}return 0},enumerable:!0,configurable:!0}),Object.defineProperty(t.prototype,"maxAutoLevel",{get:function(){var e=this.levels,t=this.autoLevelCapping;return-1===t&&e&&e.length?e.length-1:t},enumerable:!0,configurable:!0}),Object.defineProperty(t.prototype,"nextAutoLevel",{get:function(){return Math.min(Math.max(this.abrController.nextAutoLevel,this.minAutoLevel),this.maxAutoLevel)},set:function(e){this.abrController.nextAutoLevel=Math.max(this.minAutoLevel,e)},enumerable:!0,configurable:!0}),Object.defineProperty(t.prototype,"audioTracks",{get:function(){var e=this.audioTrackController;return e?e.audioTracks:[]},enumerable:!0,configurable:!0}),Object.defineProperty(t.prototype,"audioTrack",{get:function(){var e=this.audioTrackController;return e?e.audioTrack:-1},set:function(e){var t=this.audioTrackController;t&&(t.audioTrack=e)},enumerable:!0,configurable:!0}),Object.defineProperty(t.prototype,"liveSyncPosition",{get:function(){return this.streamController.liveSyncPosition},enumerable:!0,configurable:!0}),Object.defineProperty(t.prototype,"subtitleTracks",{get:function(){var e=this.subtitleTrackController;return e?e.subtitleTracks:[]},enumerable:!0,configurable:!0}),Object.defineProperty(t.prototype,"subtitleTrack",{get:function(){var e=this.subtitleTrackController;return e?e.subtitleTrack:-1},set:function(e){var t=this.subtitleTrackController;t&&(t.subtitleTrack=e)},enumerable:!0,configurable:!0}),Object.defineProperty(t.prototype,"subtitleDisplay",{get:function(){var e=this.subtitleTrackController;return!!e&&e.subtitleDisplay},set:function(e){var t=this.subtitleTrackController;t&&(t.subtitleDisplay=e)},enumerable:!0,configurable:!0}),t}(r(22).Observer);t.default=m},function(e,t,r){"use strict";(function(e){Object.defineProperty(t,"__esModule",{value:!0});var i=r(7),a=r(15),n=r(26),o=r(16),s=r(27),l=r(0),u=r(17),d=/#EXT-X-STREAM-INF:([^\n\r]*)[\r\n]+([^\r\n]+)/g,f=/#EXT-X-MEDIA:(.*)/g,c=new RegExp([/#EXTINF:\s*(\d*(?:\.\d+)?)(?:,(.*)\s+)?/.source,/|(?!#)([\S+ ?]+)/.source,/|#EXT-X-BYTERANGE:*(.+)/.source,/|#EXT-X-PROGRAM-DATE-TIME:(.+)/.source,/|#.*/.source].join(""),"g"),h=/(?:(?:#(EXTM3U))|(?:#EXT-X-(PLAYLIST-TYPE):(.+))|(?:#EXT-X-(MEDIA-SEQUENCE): *(\d+))|(?:#EXT-X-(TARGETDURATION): *(\d+))|(?:#EXT-X-(KEY):(.+))|(?:#EXT-X-(START):(.+))|(?:#EXT-X-(ENDLIST))|(?:#EXT-X-(DISCONTINUITY-SEQ)UENCE:(\d+))|(?:#EXT-X-(DIS)CONTINUITY))|(?:#EXT-X-(VERSION):(\d+))|(?:#EXT-X-(MAP):(.+))|(?:(#)([^:]*):(.*))|(?:(#)(.*))(?:.*)\r?\n?/,p=/\.(mp4|m4s|m4v|m4a)$/i,g=function(){function t(){}return t.findGroup=function(e,t){if(!e)return null;for(var r=null,i=0;i<e.length;i++){var a=e[i];a.id===t&&(r=a)}return r},t.convertAVC1ToAVCOTI=function(e){var t,r=e.split(".");return r.length>2?(t=r.shift()+".",t+=parseInt(r.shift()).toString(16),t+=("000"+parseInt(r.shift()).toString(16)).substr(-4)):t=e,t},t.resolve=function(e,t){return i.buildAbsoluteURL(t,e,{alwaysNormalize:!0})},t.parseMasterPlaylist=function(e,r){var i,a=[];function n(e,t){["video","audio"].forEach(function(r){var i=e.filter(function(e){return u.isCodecType(e,r)});if(i.length){var a=i.filter(function(e){return 0===e.lastIndexOf("avc1",0)||0===e.lastIndexOf("mp4a",0)});t[r+"Codec"]=a.length>0?a[0]:i[0],e=e.filter(function(e){return-1===i.indexOf(e)})}}),t.unknownCodecs=e}for(d.lastIndex=0;null!=(i=d.exec(e));){var o={},l=o.attrs=new s.default(i[1]);o.url=t.resolve(i[2],r);var f=l.decimalResolution("RESOLUTION");f&&(o.width=f.width,o.height=f.height),o.bitrate=l.decimalInteger("AVERAGE-BANDWIDTH")||l.decimalInteger("BANDWIDTH"),o.name=l.NAME,n([].concat((l.CODECS||"").split(/[ ,]+/)),o),o.videoCodec&&-1!==o.videoCodec.indexOf("avc1")&&(o.videoCodec=t.convertAVC1ToAVCOTI(o.videoCodec)),a.push(o)}return a},t.parseMasterPlaylistMedia=function(e,r,i,a){var n;void 0===a&&(a=[]);var o=[],l=0;for(f.lastIndex=0;null!==(n=f.exec(e));){var u={},d=new s.default(n[1]);if(d.TYPE===i){if(u.groupId=d["GROUP-ID"],u.name=d.NAME,u.type=i,u.default="YES"===d.DEFAULT,u.autoselect="YES"===d.AUTOSELECT,u.forced="YES"===d.FORCED,d.URI&&(u.url=t.resolve(d.URI,r)),u.lang=d.LANGUAGE,u.name||(u.name=u.lang),a.length){var c=t.findGroup(a,u.groupId);u.audioCodec=c?c.codec:a[0].codec}u.id=l++,o.push(u)}}return o},t.parseLevelPlaylist=function(t,r,i,u,d){var f,g,m=0,y=0,_=new n.default(r),E=new o.default,b=0,S=null,T=new a.default,A=null;for(c.lastIndex=0;null!==(f=c.exec(t));){var R=f[1];if(R){T.duration=parseFloat(R);var L=(" "+f[2]).slice(1);T.title=L||null,T.tagList.push(L?["INF",R,L]:["INF",R])}else if(f[3]){if(e.isFinite(T.duration)){var D=m++;T.type=u,T.start=y,T.levelkey=E,T.sn=D,T.level=i,T.cc=b,T.urlId=d,T.baseurl=r,T.relurl=(" "+f[3]).slice(1),v(T,S),_.fragments.push(T),S=T,y+=T.duration,T=new a.default}}else if(f[4]){if(T.rawByteRange=(" "+f[4]).slice(1),S){var O=S.byteRangeEndOffset;O&&(T.lastByteRangeEndOffset=O)}}else if(f[5])T.rawProgramDateTime=(" "+f[5]).slice(1),T.tagList.push(["PROGRAM-DATE-TIME",T.rawProgramDateTime]),null===A&&(A=_.fragments.length);else{for(f=f[0].match(h),g=1;g<f.length&&void 0===f[g];g++);var w=(" "+f[g+1]).slice(1),P=(" "+f[g+2]).slice(1);switch(f[g]){case"#":T.tagList.push(P?[w,P]:[w]);break;case"PLAYLIST-TYPE":_.type=w.toUpperCase();break;case"MEDIA-SEQUENCE":m=_.startSN=parseInt(w);break;case"TARGETDURATION":_.targetduration=parseFloat(w);break;case"VERSION":_.version=parseInt(w);break;case"EXTM3U":break;case"ENDLIST":_.live=!1;break;case"DIS":b++,T.tagList.push(["DIS"]);break;case"DISCONTINUITY-SEQ":b=parseInt(w);break;case"KEY":var I=w,x=new s.default(I),F=x.enumeratedString("METHOD"),k=x.URI,C=x.hexadecimalInteger("IV");F&&(E=new o.default,k&&["AES-128","SAMPLE-AES","SAMPLE-AES-CENC"].indexOf(F)>=0&&(E.method=F,E.baseuri=r,E.reluri=k,E.key=null,E.iv=C));break;case"START":var M=w,N=new s.default(M).decimalFloatingPoint("TIME-OFFSET");e.isFinite(N)&&(_.startTimeOffset=N);break;case"MAP":var U=new s.default(w);T.relurl=U.URI,T.rawByteRange=U.BYTERANGE,T.baseurl=r,T.level=i,T.type=u,T.sn="initSegment",_.initSegment=T,(T=new a.default).rawProgramDateTime=_.initSegment.rawProgramDateTime;break;default:l.logger.warn("line parsed but not handled: "+f)}}}return(T=S)&&!T.relurl&&(_.fragments.pop(),y-=T.duration),_.totalduration=y,_.averagetargetduration=y/_.fragments.length,_.endSN=m-1,_.startCC=_.fragments[0]?_.fragments[0].cc:0,_.endCC=b,!_.initSegment&&_.fragments.length&&_.fragments.every(function(e){return p.test(e.relurl)})&&(l.logger.warn("MP4 fragments found but no init segment (probably no MAP, incomplete M3U8), trying to fetch SIDX"),(T=new a.default).relurl=_.fragments[0].relurl,T.baseurl=r,T.level=i,T.type=u,T.sn="initSegment",_.initSegment=T,_.needSidxRanges=!0),A&&function(e,t){for(var r=e[t],i=t-1;i>=0;i--){var a=e[i];a.programDateTime=r.programDateTime-1e3*a.duration,r=a}}(_.fragments,A),_},t}();function v(t,r){t.rawProgramDateTime?t.programDateTime=Date.parse(t.rawProgramDateTime):r&&r.programDateTime&&(t.programDateTime=r.endProgramDateTime),e.isFinite(t.programDateTime)||(t.programDateTime=null,t.rawProgramDateTime=null)}t.default=g}).call(this,r(2).Number)},function(e,t,r){"use strict";(function(e){Object.defineProperty(t,"__esModule",{value:!0});var r=function(){function t(e){this.endCC=0,this.endSN=0,this.fragments=[],this.initSegment=null,this.live=!0,this.needSidxRanges=!1,this.startCC=0,this.startSN=0,this.startTimeOffset=null,this.targetduration=0,this.totalduration=0,this.type=null,this.url=e,this.version=null}return Object.defineProperty(t.prototype,"hasProgramDateTime",{get:function(){return!(!this.fragments[0]||!e.isFinite(this.fragments[0].programDateTime))},enumerable:!0,configurable:!0}),t}();t.default=r}).call(this,r(2).Number)},function(e,t,r){"use strict";(function(e){Object.defineProperty(t,"__esModule",{value:!0});var r=/^(\d+)x(\d+)$/,i=/\s*(.+?)\s*=((?:\".*?\")|.*?)(?:,|$)/g,a=function(){function t(e){for(var r in"string"==typeof e&&(e=t.parseAttrList(e)),e)e.hasOwnProperty(r)&&(this[r]=e[r])}return t.prototype.decimalInteger=function(t){var r=parseInt(this[t],10);return r>e.MAX_SAFE_INTEGER?1/0:r},t.prototype.hexadecimalInteger=function(e){if(this[e]){var t=(this[e]||"0x").slice(2);t=(1&t.length?"0":"")+t;for(var r=new Uint8Array(t.length/2),i=0;i<t.length/2;i++)r[i]=parseInt(t.slice(2*i,2*i+2),16);return r}return null},t.prototype.hexadecimalIntegerAsNumber=function(t){var r=parseInt(this[t],16);return r>e.MAX_SAFE_INTEGER?1/0:r},t.prototype.decimalFloatingPoint=function(e){return parseFloat(this[e])},t.prototype.enumeratedString=function(e){return this[e]},t.prototype.decimalResolution=function(e){var t=r.exec(this[e]);if(null!==t)return{width:parseInt(t[1],10),height:parseInt(t[2],10)}},t.parseAttrList=function(e){var t,r={};for(i.lastIndex=0;null!==(t=i.exec(e));){var a=t[2];0===a.indexOf('"')&&a.lastIndexOf('"')===a.length-1&&(a=a.slice(1,-1)),r[t[1]]=a}return r},t}();t.default=a}).call(this,r(2).Number)},function(e,t,r){"use strict";(function(e){var i=this&&this.__extends||function(){var e=Object.setPrototypeOf||{__proto__:[]}instanceof Array&&function(e,t){e.__proto__=t}||function(e,t){for(var r in t)t.hasOwnProperty(r)&&(e[r]=t[r])};return function(t,r){function i(){this.constructor=t}e(t,r),t.prototype=null===r?Object.create(r):(i.prototype=r.prototype,new i)}}();Object.defineProperty(t,"__esModule",{value:!0});var a=r(1),n=r(4),o=r(3),s=r(0),l=function(t){function r(e){var r=t.call(this,e,a.default.FRAG_LOADING)||this;return r.loaders={},r}return i(r,t),r.prototype.destroy=function(){var e=this.loaders;for(var r in e){var i=e[r];i&&i.destroy()}this.loaders={},t.prototype.destroy.call(this)},r.prototype.onFragLoading=function(t){var r=t.frag,i=r.type,a=this.loaders,n=this.hls.config,o=n.fLoader,l=n.loader;r.loaded=0;var u,d,f,c=a[i];c&&(s.logger.warn("abort previous fragment loader for type: "+i),c.abort()),c=a[i]=r.loader=n.fLoader?new o(n):new l(n),u={url:r.url,frag:r,responseType:"arraybuffer",progressData:!1};var h=r.byteRangeStartOffset,p=r.byteRangeEndOffset;e.isFinite(h)&&e.isFinite(p)&&(u.rangeStart=h,u.rangeEnd=p),d={timeout:n.fragLoadingTimeOut,maxRetry:0,retryDelay:0,maxRetryDelay:n.fragLoadingMaxRetryTimeout},f={onSuccess:this.loadsuccess.bind(this),onError:this.loaderror.bind(this),onTimeout:this.loadtimeout.bind(this),onProgress:this.loadprogress.bind(this)},c.load(u,d,f)},r.prototype.loadsuccess=function(e,t,r,i){void 0===i&&(i=null);var n=e.data,o=r.frag;o.loader=void 0,this.loaders[o.type]=void 0,this.hls.trigger(a.default.FRAG_LOADED,{payload:n,frag:o,stats:t,networkDetails:i})},r.prototype.loaderror=function(e,t,r){void 0===r&&(r=null);var i=t.frag,n=i.loader;n&&n.abort(),this.loaders[i.type]=void 0,this.hls.trigger(a.default.ERROR,{type:o.ErrorTypes.NETWORK_ERROR,details:o.ErrorDetails.FRAG_LOAD_ERROR,fatal:!1,frag:t.frag,response:e,networkDetails:r})},r.prototype.loadtimeout=function(e,t,r){void 0===r&&(r=null);var i=t.frag,n=i.loader;n&&n.abort(),this.loaders[i.type]=void 0,this.hls.trigger(a.default.ERROR,{type:o.ErrorTypes.NETWORK_ERROR,details:o.ErrorDetails.FRAG_LOAD_TIMEOUT,fatal:!1,frag:t.frag,networkDetails:r})},r.prototype.loadprogress=function(e,t,r,i){void 0===i&&(i=null);var n=t.frag;n.loaded=e.loaded,this.hls.trigger(a.default.FRAG_LOAD_PROGRESS,{frag:n,stats:e,networkDetails:i})},r}(n.default);t.default=l}).call(this,r(2).Number)},function(e,t,r){"use strict";var i=this&&this.__extends||function(){var e=Object.setPrototypeOf||{__proto__:[]}instanceof Array&&function(e,t){e.__proto__=t}||function(e,t){for(var r in t)t.hasOwnProperty(r)&&(e[r]=t[r])};return function(t,r){function i(){this.constructor=t}e(t,r),t.prototype=null===r?Object.create(r):(i.prototype=r.prototype,new i)}}();Object.defineProperty(t,"__esModule",{value:!0});var a=r(1),n=r(4),o=r(3),s=r(0),l=function(e){function t(t){var r=e.call(this,t,a.default.KEY_LOADING)||this;return r.loaders={},r.decryptkey=null,r.decrypturl=null,r}return i(t,e),t.prototype.destroy=function(){for(var e in this.loaders){var t=this.loaders[e];t&&t.destroy()}this.loaders={},n.default.prototype.destroy.call(this)},t.prototype.onKeyLoading=function(e){var t=e.frag,r=t.type,i=this.loaders[r],n=t.decryptdata,o=n.uri;if(o!==this.decrypturl||null===this.decryptkey){var l=this.hls.config;i&&(s.logger.warn("abort previous key loader for type:"+r),i.abort()),t.loader=this.loaders[r]=new l.loader(l),this.decrypturl=o,this.decryptkey=null;var u,d,f;u={url:o,frag:t,responseType:"arraybuffer"},d={timeout:l.fragLoadingTimeOut,maxRetry:0,retryDelay:l.fragLoadingRetryDelay,maxRetryDelay:l.fragLoadingMaxRetryTimeout},f={onSuccess:this.loadsuccess.bind(this),onError:this.loaderror.bind(this),onTimeout:this.loadtimeout.bind(this)},t.loader.load(u,d,f)}else this.decryptkey&&(n.key=this.decryptkey,this.hls.trigger(a.default.KEY_LOADED,{frag:t}))},t.prototype.loadsuccess=function(e,t,r){var i=r.frag;this.decryptkey=i.decryptdata.key=new Uint8Array(e.data),i.loader=void 0,this.loaders[i.type]=void 0,this.hls.trigger(a.default.KEY_LOADED,{frag:i})},t.prototype.loaderror=function(e,t){var r=t.frag,i=r.loader;i&&i.abort(),this.loaders[t.type]=void 0,this.hls.trigger(a.default.ERROR,{type:o.ErrorTypes.NETWORK_ERROR,details:o.ErrorDetails.KEY_LOAD_ERROR,fatal:!1,frag:r,response:e})},t.prototype.loadtimeout=function(e,t){var r=t.frag,i=r.loader;i&&i.abort(),this.loaders[t.type]=void 0,this.hls.trigger(a.default.ERROR,{type:o.ErrorTypes.NETWORK_ERROR,details:o.ErrorDetails.KEY_LOAD_TIMEOUT,fatal:!1,frag:r})},t}(n.default);t.default=l},function(e,t,r){"use strict";(function(e){var i=this&&this.__extends||function(){var e=Object.setPrototypeOf||{__proto__:[]}instanceof Array&&function(e,t){e.__proto__=t}||function(e,t){for(var r in t)t.hasOwnProperty(r)&&(e[r]=t[r])};return function(t,r){function i(){this.constructor=t}e(t,r),t.prototype=null===r?Object.create(r):(i.prototype=r.prototype,new i)}}();Object.defineProperty(t,"__esModule",{value:!0});var a=r(10),n=r(8),o=r(31),s=r(1),l=r(9),u=r(15),d=r(13),f=r(23),c=r(48),h=r(3),p=r(0),g=r(49),v=r(50),m=r(51),y=r(52),_=function(t){function r(e,r){var i=t.call(this,e,s.default.MEDIA_ATTACHED,s.default.MEDIA_DETACHING,s.default.MANIFEST_LOADING,s.default.MANIFEST_PARSED,s.default.LEVEL_LOADED,s.default.KEY_LOADED,s.default.FRAG_LOADED,s.default.FRAG_LOAD_EMERGENCY_ABORTED,s.default.FRAG_PARSING_INIT_SEGMENT,s.default.FRAG_PARSING_DATA,s.default.FRAG_PARSED,s.default.ERROR,s.default.AUDIO_TRACK_SWITCHING,s.default.AUDIO_TRACK_SWITCHED,s.default.BUFFER_CREATED,s.default.BUFFER_APPENDED,s.default.BUFFER_FLUSHED)||this;return i.fragmentTracker=r,i.config=e.config,i.audioCodecSwap=!1,i._state=y.State.STOPPED,i.stallReported=!1,i.gapController=null,i}return i(r,t),r.prototype.startLoad=function(e){if(this.levels){var t=this.lastCurrentTime,r=this.hls;if(this.stopLoad(),this.setInterval(100),this.level=-1,this.fragLoadError=0,!this.startFragRequested){var i=r.startLevel;-1===i&&(i=0,this.bitrateTest=!0),this.level=r.nextLoadLevel=i,this.loadedmetadata=!1}t>0&&-1===e&&(p.logger.log("override startPosition with lastCurrentTime @"+t.toFixed(3)),e=t),this.state=y.State.IDLE,this.nextLoadPosition=this.startPosition=this.lastCurrentTime=e,this.tick()}else this.forceStartLoad=!0,this.state=y.State.STOPPED},r.prototype.stopLoad=function(){this.forceStartLoad=!1,t.prototype.stopLoad.call(this)},r.prototype.doTick=function(){switch(this.state){case y.State.BUFFER_FLUSHING:this.fragLoadError=0;break;case y.State.IDLE:this._doTickIdle();break;case y.State.WAITING_LEVEL:var e=this.levels[this.level];e&&e.details&&(this.state=y.State.IDLE);break;case y.State.FRAG_LOADING_WAITING_RETRY:var t=window.performance.now(),r=this.retryDate;(!r||t>=r||this.media&&this.media.seeking)&&(p.logger.log("mediaController: retryDate reached, switch back to IDLE state"),this.state=y.State.IDLE);break;case y.State.ERROR:case y.State.STOPPED:case y.State.FRAG_LOADING:case y.State.PARSING:case y.State.PARSED:case y.State.ENDED:}this._checkBuffer(),this._checkFragmentChanged()},r.prototype._doTickIdle=function(){var e=this.hls,t=e.config,r=this.media;if(void 0!==this.levelLastLoaded&&(r||!this.startFragRequested&&t.startFragPrefetch)){var i;i=this.loadedmetadata?r.currentTime:this.nextLoadPosition;var a=e.nextLoadLevel,o=this.levels[a];if(o){var l,u=o.bitrate;l=u?Math.max(8*t.maxBufferSize/u,t.maxBufferLength):t.maxBufferLength,l=Math.min(l,t.maxMaxBufferLength);var d=n.BufferHelper.bufferInfo(this.mediaBuffer?this.mediaBuffer:r,i,t.maxBufferHole),f=d.len;if(!(f>=l)){p.logger.trace("buffer length of "+f.toFixed(3)+" is below max of "+l.toFixed(3)+". checking for more payload ..."),this.level=e.nextLoadLevel=a;var c=o.details;if(!c||c.live&&this.levelLastLoaded!==a)this.state=y.State.WAITING_LEVEL;else{if(this._streamEnded(d,c)){var h={};return this.altAudio&&(h.type="video"),this.hls.trigger(s.default.BUFFER_EOS,h),void(this.state=y.State.ENDED)}this._fetchPayloadOrEos(i,d,c)}}}}},r.prototype._fetchPayloadOrEos=function(e,t,r){var i=this.fragPrevious,a=this.level,n=r.fragments,o=n.length;if(0!==o){var s,l=n[0].start,u=n[o-1].start+n[o-1].duration,d=t.end;if(r.initSegment&&!r.initSegment.data)s=r.initSegment;else if(r.live){var f=this.config.initialLiveManifestSize;if(o<f)return void p.logger.warn("Can not start playback of a level, reason: not enough fragments "+o+" < "+f);if(null===(s=this._ensureFragmentAtLivePoint(r,d,l,u,i,n,o)))return}else d<l&&(s=n[0]);s||(s=this._findFragment(l,i,o,n,d,u,r)),s&&(s.encrypted?(p.logger.log("Loading key for "+s.sn+" of ["+r.startSN+" ,"+r.endSN+"],level "+a),this._loadKey(s)):(p.logger.log("Loading "+s.sn+" of ["+r.startSN+" ,"+r.endSN+"],level "+a+", currentTime:"+e.toFixed(3)+",bufferEnd:"+d.toFixed(3)),this._loadFragment(s)))}},r.prototype._ensureFragmentAtLivePoint=function(e,t,r,i,n,o,s){var l,u=this.hls.config,d=this.media,f=void 0!==u.liveMaxLatencyDuration?u.liveMaxLatencyDuration:u.liveMaxLatencyDurationCount*e.targetduration;if(t<Math.max(r-u.maxFragLookUpTolerance,i-f)){var c=this.liveSyncPosition=this.computeLivePosition(r,e);p.logger.log("buffer end: "+t.toFixed(3)+" is located too far from the end of live sliding playlist, reset currentTime to : "+c.toFixed(3)),t=c,d&&d.readyState&&d.duration>c&&(d.currentTime=c),this.nextLoadPosition=c}if(e.PTSKnown&&t>i&&d&&d.readyState)return null;if(this.startFragRequested&&!e.PTSKnown){if(n)if(e.hasProgramDateTime)p.logger.log("live playlist, switching playlist, load frag with same PDT: "+n.programDateTime),l=v.findFragmentByPDT(o,n.endProgramDateTime,u.maxFragLookUpTolerance);else{var h=n.sn+1;if(h>=e.startSN&&h<=e.endSN){var g=o[h-e.startSN];n.cc===g.cc&&(l=g,p.logger.log("live playlist, switching playlist, load frag with next SN: "+l.sn))}l||(l=a.default.search(o,function(e){return n.cc-e.cc}))&&p.logger.log("live playlist, switching playlist, load frag with same CC: "+l.sn)}l||(l=o[Math.min(s-1,Math.round(s/2))],p.logger.log("live playlist, switching playlist, unknown, load middle frag : "+l.sn))}return l},r.prototype._findFragment=function(e,t,r,i,a,n,o){var s,l=this.hls.config;if(a<n){var u=a>n-l.maxFragLookUpTolerance?0:l.maxFragLookUpTolerance;s=v.findFragmentByPTS(t,i,a,u)}else s=i[r-1];if(s){var d=s.sn-o.startSN,f=t&&s.level===t.level,c=i[d-1],h=i[d+1];if(t&&s.sn===t.sn)if(f&&!s.backtracked)if(s.sn<o.endSN){var g=t.deltaPTS;g&&g>l.maxBufferHole&&t.dropped&&d?(s=c,p.logger.warn("SN just loaded, with large PTS gap between audio and video, maybe frag is not starting with a keyframe ? load previous one to try to overcome this")):(s=h,p.logger.log("SN just loaded, load next one: "+s.sn,s))}else s=null;else s.backtracked&&(h&&h.backtracked?(p.logger.warn("Already backtracked from fragment "+h.sn+", will not backtrack to fragment "+s.sn+". Loading fragment "+h.sn),s=h):(p.logger.warn("Loaded fragment with dropped frames, backtracking 1 segment to find a keyframe"),s.dropped=0,c?(s=c).backtracked=!0:d&&(s=null)))}return s},r.prototype._loadKey=function(e){this.state=y.State.KEY_LOADING,this.hls.trigger(s.default.KEY_LOADING,{frag:e})},r.prototype._loadFragment=function(t){var r=this.fragmentTracker.getState(t);this.fragCurrent=t,this.startFragRequested=!0,e.isFinite(t.sn)&&!t.bitrateTest&&(this.nextLoadPosition=t.start+t.duration),t.backtracked||r===l.FragmentState.NOT_LOADED||r===l.FragmentState.PARTIAL?(t.autoLevel=this.hls.autoLevelEnabled,t.bitrateTest=this.bitrateTest,this.hls.trigger(s.default.FRAG_LOADING,{frag:t}),this.demuxer||(this.demuxer=new o.default(this.hls,"main")),this.state=y.State.FRAG_LOADING):r===l.FragmentState.APPENDING&&this._reduceMaxBufferLength(t.duration)&&this.fragmentTracker.removeFragment(t)},Object.defineProperty(r.prototype,"state",{get:function(){return this._state},set:function(e){if(this.state!==e){var t=this.state;this._state=e,p.logger.log("main stream:"+t+"->"+e),this.hls.trigger(s.default.STREAM_STATE_TRANSITION,{previousState:t,nextState:e})}},enumerable:!0,configurable:!0}),r.prototype.getBufferedFrag=function(e){return this.fragmentTracker.getBufferedFrag(e,d.default.LevelType.MAIN)},Object.defineProperty(r.prototype,"currentLevel",{get:function(){var e=this.media;if(e){var t=this.getBufferedFrag(e.currentTime);if(t)return t.level}return-1},enumerable:!0,configurable:!0}),Object.defineProperty(r.prototype,"nextBufferedFrag",{get:function(){var e=this.media;return e?this.followingBufferedFrag(this.getBufferedFrag(e.currentTime)):null},enumerable:!0,configurable:!0}),r.prototype.followingBufferedFrag=function(e){return e?this.getBufferedFrag(e.endPTS+.5):null},Object.defineProperty(r.prototype,"nextLevel",{get:function(){var e=this.nextBufferedFrag;return e?e.level:-1},enumerable:!0,configurable:!0}),r.prototype._checkFragmentChanged=function(){var e,t,r=this.media;if(r&&r.readyState&&!1===r.seeking&&((t=r.currentTime)>this.lastCurrentTime&&(this.lastCurrentTime=t),n.BufferHelper.isBuffered(r,t)?e=this.getBufferedFrag(t):n.BufferHelper.isBuffered(r,t+.1)&&(e=this.getBufferedFrag(t+.1)),e)){var i=e;if(i!==this.fragPlaying){this.hls.trigger(s.default.FRAG_CHANGED,{frag:i});var a=i.level;this.fragPlaying&&this.fragPlaying.level===a||this.hls.trigger(s.default.LEVEL_SWITCHED,{level:a}),this.fragPlaying=i}}},r.prototype.immediateLevelSwitch=function(){if(p.logger.log("immediateLevelSwitch"),!this.immediateSwitch){this.immediateSwitch=!0;var t=this.media,r=void 0;t?(r=t.paused,t.pause()):r=!0,this.previouslyPaused=r}var i=this.fragCurrent;i&&i.loader&&i.loader.abort(),this.fragCurrent=null,this.flushMainBuffer(0,e.POSITIVE_INFINITY)},r.prototype.immediateLevelSwitchEnd=function(){var e=this.media;e&&e.buffered.length&&(this.immediateSwitch=!1,n.BufferHelper.isBuffered(e,e.currentTime)&&(e.currentTime-=1e-4),this.previouslyPaused||e.play())},r.prototype.nextLevelSwitch=function(){var t=this.media;if(t&&t.readyState){var r,i=void 0,a=void 0;if((r=this.getBufferedFrag(t.currentTime))&&r.startPTS>1&&this.flushMainBuffer(0,r.startPTS-1),t.paused)i=0;else{var n=this.hls.nextLoadLevel,o=this.levels[n],s=this.fragLastKbps;i=s&&this.fragCurrent?this.fragCurrent.duration*o.bitrate/(1e3*s)+1:0}if((a=this.getBufferedFrag(t.currentTime+i))&&(a=this.followingBufferedFrag(a))){var l=this.fragCurrent;l&&l.loader&&l.loader.abort(),this.fragCurrent=null,this.flushMainBuffer(a.maxStartPTS,e.POSITIVE_INFINITY)}}},r.prototype.flushMainBuffer=function(e,t){this.state=y.State.BUFFER_FLUSHING;var r={startOffset:e,endOffset:t};this.altAudio&&(r.type="video"),this.hls.trigger(s.default.BUFFER_FLUSHING,r)},r.prototype.onMediaAttached=function(e){var t=this.media=this.mediaBuffer=e.media;this.onvseeking=this.onMediaSeeking.bind(this),this.onvseeked=this.onMediaSeeked.bind(this),this.onvended=this.onMediaEnded.bind(this),t.addEventListener("seeking",this.onvseeking),t.addEventListener("seeked",this.onvseeked),t.addEventListener("ended",this.onvended);var r=this.config;this.levels&&r.autoStartLoad&&this.hls.startLoad(r.startPosition),this.gapController=new m.default(r,t,this.fragmentTracker,this.hls)},r.prototype.onMediaDetaching=function(){var e=this.media;e&&e.ended&&(p.logger.log("MSE detaching and video ended, reset startPosition"),this.startPosition=this.lastCurrentTime=0);var t=this.levels;t&&t.forEach(function(e){e.details&&e.details.fragments.forEach(function(e){e.backtracked=void 0})}),e&&(e.removeEventListener("seeking",this.onvseeking),e.removeEventListener("seeked",this.onvseeked),e.removeEventListener("ended",this.onvended),this.onvseeking=this.onvseeked=this.onvended=null),this.media=this.mediaBuffer=null,this.loadedmetadata=!1,this.stopLoad()},r.prototype.onMediaSeeked=function(){var t=this.media,r=t?t.currentTime:void 0;e.isFinite(r)&&p.logger.log("media seeked to "+r.toFixed(3)),this.tick()},r.prototype.onManifestLoading=function(){p.logger.log("trigger BUFFER_RESET"),this.hls.trigger(s.default.BUFFER_RESET),this.fragmentTracker.removeAllFragments(),this.stalled=!1,this.startPosition=this.lastCurrentTime=0},r.prototype.onManifestParsed=function(e){var t,r=!1,i=!1;e.levels.forEach(function(e){(t=e.audioCodec)&&(-1!==t.indexOf("mp4a.40.2")&&(r=!0),-1!==t.indexOf("mp4a.40.5")&&(i=!0))}),this.audioCodecSwitch=r&&i,this.audioCodecSwitch&&p.logger.log("both AAC/HE-AAC audio found in levels; declaring level codec as HE-AAC"),this.levels=e.levels,this.startFragRequested=!1;var a=this.config;(a.autoStartLoad||this.forceStartLoad)&&this.hls.startLoad(a.startPosition)},r.prototype.onLevelLoaded=function(t){var r=t.details,i=t.level,a=this.levels[this.levelLastLoaded],n=this.levels[i],o=r.totalduration,l=0;if(p.logger.log("level "+i+" loaded ["+r.startSN+","+r.endSN+"],duration:"+o),r.live){var u=n.details;u&&r.fragments.length>0?(f.mergeDetails(u,r),l=r.fragments[0].start,this.liveSyncPosition=this.computeLivePosition(l,u),r.PTSKnown&&e.isFinite(l)?p.logger.log("live playlist sliding:"+l.toFixed(3)):(p.logger.log("live playlist - outdated PTS, unknown sliding"),g.alignStream(this.fragPrevious,a,r))):(p.logger.log("live playlist - first load, unknown sliding"),r.PTSKnown=!1,g.alignStream(this.fragPrevious,a,r))}else r.PTSKnown=!1;if(n.details=r,this.levelLastLoaded=i,this.hls.trigger(s.default.LEVEL_UPDATED,{details:r,level:i}),!1===this.startFragRequested){if(-1===this.startPosition||-1===this.lastCurrentTime){var d=r.startTimeOffset;e.isFinite(d)?(d<0&&(p.logger.log("negative start time offset "+d+", count from end of last fragment"),d=l+o+d),p.logger.log("start time offset found in playlist, adjust startPosition to "+d),this.startPosition=d):r.live?(this.startPosition=this.computeLivePosition(l,r),p.logger.log("configure startPosition to "+this.startPosition)):this.startPosition=0,this.lastCurrentTime=this.startPosition}this.nextLoadPosition=this.startPosition}this.state===y.State.WAITING_LEVEL&&(this.state=y.State.IDLE),this.tick()},r.prototype.onKeyLoaded=function(){this.state===y.State.KEY_LOADING&&(this.state=y.State.IDLE,this.tick())},r.prototype.onFragLoaded=function(e){var t=this.fragCurrent,r=this.hls,i=this.levels,a=this.media,n=e.frag;if(this.state===y.State.FRAG_LOADING&&t&&"main"===n.type&&n.level===t.level&&n.sn===t.sn){var l=e.stats,u=i[t.level],d=u.details;if(this.bitrateTest=!1,this.stats=l,p.logger.log("Loaded "+t.sn+" of ["+d.startSN+" ,"+d.endSN+"],level "+t.level),n.bitrateTest&&r.nextLoadLevel)this.state=y.State.IDLE,this.startFragRequested=!1,l.tparsed=l.tbuffered=window.performance.now(),r.trigger(s.default.FRAG_BUFFERED,{stats:l,frag:t,id:"main"}),this.tick();else if("initSegment"===n.sn)this.state=y.State.IDLE,l.tparsed=l.tbuffered=window.performance.now(),d.initSegment.data=e.payload,r.trigger(s.default.FRAG_BUFFERED,{stats:l,frag:t,id:"main"}),this.tick();else{p.logger.log("Parsing "+t.sn+" of ["+d.startSN+" ,"+d.endSN+"],level "+t.level+", cc "+t.cc),this.state=y.State.PARSING,this.pendingBuffering=!0,this.appended=!1,n.bitrateTest&&(n.bitrateTest=!1,this.fragmentTracker.onFragLoaded({frag:n}));var f=!(a&&a.seeking)&&(d.PTSKnown||!d.live),c=d.initSegment?d.initSegment.data:[],h=this._getAudioCodec(u);(this.demuxer=this.demuxer||new o.default(this.hls,"main")).push(e.payload,c,h,u.videoCodec,t,d.totalduration,f)}}this.fragLoadError=0},r.prototype.onFragParsingInitSegment=function(e){var t=this.fragCurrent,r=e.frag;if(t&&"main"===e.id&&r.sn===t.sn&&r.level===t.level&&this.state===y.State.PARSING){var i=e.tracks,a=void 0,n=void 0;if(i.audio&&this.altAudio&&delete i.audio,n=i.audio){var o=this.levels[this.level].audioCodec,l=navigator.userAgent.toLowerCase();o&&this.audioCodecSwap&&(p.logger.log("swapping playlist audio codec"),o=-1!==o.indexOf("mp4a.40.5")?"mp4a.40.2":"mp4a.40.5"),this.audioCodecSwitch&&1!==n.metadata.channelCount&&-1===l.indexOf("firefox")&&(o="mp4a.40.5"),-1!==l.indexOf("android")&&"audio/mpeg"!==n.container&&(o="mp4a.40.2",p.logger.log("Android: force audio codec to "+o)),n.levelCodec=o,n.id=e.id}for(a in(n=i.video)&&(n.levelCodec=this.levels[this.level].videoCodec,n.id=e.id),this.hls.trigger(s.default.BUFFER_CODECS,i),i){n=i[a],p.logger.log("main track:"+a+",container:"+n.container+",codecs[level/parsed]=["+n.levelCodec+"/"+n.codec+"]");var u=n.initSegment;u&&(this.appended=!0,this.pendingBuffering=!0,this.hls.trigger(s.default.BUFFER_APPENDING,{type:a,data:u,parent:"main",content:"initSegment"}))}this.tick()}},r.prototype.onFragParsingData=function(t){var r=this,i=this.fragCurrent,a=t.frag;if(i&&"main"===t.id&&a.sn===i.sn&&a.level===i.level&&("audio"!==t.type||!this.altAudio)&&this.state===y.State.PARSING){var n=this.levels[this.level],o=i;if(e.isFinite(t.endPTS)||(t.endPTS=t.startPTS+i.duration,t.endDTS=t.startDTS+i.duration),!0===t.hasAudio&&o.addElementaryStream(u.default.ElementaryStreamTypes.AUDIO),!0===t.hasVideo&&o.addElementaryStream(u.default.ElementaryStreamTypes.VIDEO),p.logger.log("Parsed "+t.type+",PTS:["+t.startPTS.toFixed(3)+","+t.endPTS.toFixed(3)+"],DTS:["+t.startDTS.toFixed(3)+"/"+t.endDTS.toFixed(3)+"],nb:"+t.nb+",dropped:"+(t.dropped||0)),"video"===t.type)if(o.dropped=t.dropped,o.dropped)if(o.backtracked)p.logger.warn("Already backtracked on this fragment, appending with the gap",o.sn);else{var l=n.details;if(!l||o.sn!==l.startSN)return p.logger.warn("missing video frame(s), backtracking fragment",o.sn),this.fragmentTracker.removeFragment(o),o.backtracked=!0,this.nextLoadPosition=t.startPTS,this.state=y.State.IDLE,this.fragPrevious=o,void this.tick();p.logger.warn("missing video frame(s) on first frag, appending with gap",o.sn)}else o.backtracked=!1;var d=f.updateFragPTSDTS(n.details,o,t.startPTS,t.endPTS,t.startDTS,t.endDTS),c=this.hls;c.trigger(s.default.LEVEL_PTS_UPDATED,{details:n.details,level:this.level,drift:d,type:t.type,start:t.startPTS,end:t.endPTS}),[t.data1,t.data2].forEach(function(e){e&&e.length&&r.state===y.State.PARSING&&(r.appended=!0,r.pendingBuffering=!0,c.trigger(s.default.BUFFER_APPENDING,{type:t.type,data:e,parent:"main",content:"data"}))}),this.tick()}},r.prototype.onFragParsed=function(e){var t=this.fragCurrent,r=e.frag;t&&"main"===e.id&&r.sn===t.sn&&r.level===t.level&&this.state===y.State.PARSING&&(this.stats.tparsed=window.performance.now(),this.state=y.State.PARSED,this._checkAppendedParsed())},r.prototype.onAudioTrackSwitching=function(t){var r=!!t.url,i=t.id;if(!r){if(this.mediaBuffer!==this.media){p.logger.log("switching on main audio, use media.buffered to schedule main fragment loading"),this.mediaBuffer=this.media;var a=this.fragCurrent;a.loader&&(p.logger.log("switching to main audio track, cancel main fragment load"),a.loader.abort()),this.fragCurrent=null,this.fragPrevious=null,this.demuxer&&(this.demuxer.destroy(),this.demuxer=null),this.state=y.State.IDLE}var n=this.hls;n.trigger(s.default.BUFFER_FLUSHING,{startOffset:0,endOffset:e.POSITIVE_INFINITY,type:"audio"}),n.trigger(s.default.AUDIO_TRACK_SWITCHED,{id:i}),this.altAudio=!1}},r.prototype.onAudioTrackSwitched=function(e){var t=e.id,r=!!this.hls.audioTracks[t].url;if(r){var i=this.videoBuffer;i&&this.mediaBuffer!==i&&(p.logger.log("switching on alternate audio, use video.buffered to schedule main fragment loading"),this.mediaBuffer=i)}this.altAudio=r,this.tick()},r.prototype.onBufferCreated=function(e){var t,r,i=e.tracks,a=!1;for(var n in i){var o=i[n];"main"===o.id?(r=n,t=o,"video"===n&&(this.videoBuffer=i[n].buffer)):a=!0}a&&t?(p.logger.log("alternate track found, use "+r+".buffered to schedule main fragment loading"),this.mediaBuffer=t.buffer):this.mediaBuffer=this.media},r.prototype.onBufferAppended=function(e){if("main"===e.parent){var t=this.state;t!==y.State.PARSING&&t!==y.State.PARSED||(this.pendingBuffering=e.pending>0,this._checkAppendedParsed())}},r.prototype._checkAppendedParsed=function(){if(!(this.state!==y.State.PARSED||this.appended&&this.pendingBuffering)){var e=this.fragCurrent;if(e){var t=this.mediaBuffer?this.mediaBuffer:this.media;p.logger.log("main buffered : "+c.default.toString(t.buffered)),this.fragPrevious=e;var r=this.stats;r.tbuffered=window.performance.now(),this.fragLastKbps=Math.round(8*r.total/(r.tbuffered-r.tfirst)),this.hls.trigger(s.default.FRAG_BUFFERED,{stats:r,frag:e,id:"main"}),this.state=y.State.IDLE}this.tick()}},r.prototype.onError=function(t){var r=t.frag||this.fragCurrent;if(!r||"main"===r.type){var i=!!this.media&&n.BufferHelper.isBuffered(this.media,this.media.currentTime)&&n.BufferHelper.isBuffered(this.media,this.media.currentTime+.5);switch(t.details){case h.ErrorDetails.FRAG_LOAD_ERROR:case h.ErrorDetails.FRAG_LOAD_TIMEOUT:case h.ErrorDetails.KEY_LOAD_ERROR:case h.ErrorDetails.KEY_LOAD_TIMEOUT:if(!t.fatal)if(this.fragLoadError+1<=this.config.fragLoadingMaxRetry){var a=Math.min(Math.pow(2,this.fragLoadError)*this.config.fragLoadingRetryDelay,this.config.fragLoadingMaxRetryTimeout);p.logger.warn("mediaController: frag loading failed, retry in "+a+" ms"),this.retryDate=window.performance.now()+a,this.loadedmetadata||(this.startFragRequested=!1,this.nextLoadPosition=this.startPosition),this.fragLoadError++,this.state=y.State.FRAG_LOADING_WAITING_RETRY}else p.logger.error("mediaController: "+t.details+" reaches max retry, redispatch as fatal ..."),t.fatal=!0,this.state=y.State.ERROR;break;case h.ErrorDetails.LEVEL_LOAD_ERROR:case h.ErrorDetails.LEVEL_LOAD_TIMEOUT:this.state!==y.State.ERROR&&(t.fatal?(this.state=y.State.ERROR,p.logger.warn("streamController: "+t.details+",switch to "+this.state+" state ...")):t.levelRetry||this.state!==y.State.WAITING_LEVEL||(this.state=y.State.IDLE));break;case h.ErrorDetails.BUFFER_FULL_ERROR:"main"!==t.parent||this.state!==y.State.PARSING&&this.state!==y.State.PARSED||(i?(this._reduceMaxBufferLength(this.config.maxBufferLength),this.state=y.State.IDLE):(p.logger.warn("buffer full error also media.currentTime is not buffered, flush everything"),this.fragCurrent=null,this.flushMainBuffer(0,e.POSITIVE_INFINITY)))}}},r.prototype._reduceMaxBufferLength=function(e){var t=this.config;return t.maxMaxBufferLength>=e&&(t.maxMaxBufferLength/=2,p.logger.warn("main:reduce max buffer length to "+t.maxMaxBufferLength+"s"),!0)},r.prototype._checkBuffer=function(){var e=this.media;if(e&&0!==e.readyState){var t=(this.mediaBuffer?this.mediaBuffer:e).buffered;!this.loadedmetadata&&t.length?(this.loadedmetadata=!0,this._seekToStartPos()):this.immediateSwitch?this.immediateLevelSwitchEnd():this.gapController.poll(this.lastCurrentTime,t)}},r.prototype.onFragLoadEmergencyAborted=function(){this.state=y.State.IDLE,this.loadedmetadata||(this.startFragRequested=!1,this.nextLoadPosition=this.startPosition),this.tick()},r.prototype.onBufferFlushed=function(){var e=this.mediaBuffer?this.mediaBuffer:this.media;e&&this.fragmentTracker.detectEvictedFragments(u.default.ElementaryStreamTypes.VIDEO,e.buffered),this.state=y.State.IDLE,this.fragPrevious=null},r.prototype.swapAudioCodec=function(){this.audioCodecSwap=!this.audioCodecSwap},r.prototype.computeLivePosition=function(e,t){var r=void 0!==this.config.liveSyncDuration?this.config.liveSyncDuration:this.config.liveSyncDurationCount*t.targetduration;return e+Math.max(0,t.totalduration-r)},r.prototype._seekToStartPos=function(){var e=this.media,t=e.currentTime,r=e.seeking?t:this.startPosition;t!==r&&(p.logger.log("target start position not buffered, seek to buffered.start(0) "+r+" from current time "+t+" "),e.currentTime=r)},r.prototype._getAudioCodec=function(e){var t=this.config.defaultAudioCodec||e.audioCodec;return this.audioCodecSwap&&(p.logger.log("swapping playlist audio codec"),t&&(t=-1!==t.indexOf("mp4a.40.5")?"mp4a.40.2":"mp4a.40.5")),t},Object.defineProperty(r.prototype,"liveSyncPosition",{get:function(){return this._liveSyncPosition},set:function(e){this._liveSyncPosition=e},enumerable:!0,configurable:!0}),r}(y.default);t.default=_}).call(this,r(2).Number)},function(e,t,r){"use strict";(function(e){Object.defineProperty(t,"__esModule",{value:!0});var i=r(32),a=r(1),n=r(18),o=r(0),s=r(3),l=r(12),u=r(6),d=r(22),f=u.getSelfScope(),c=l.getMediaSource(),h=function(){function t(e,t){var r=this;this.hls=e,this.id=t;var l=this.observer=new d.Observer,u=e.config,h=function(t,i){(i=i||{}).frag=r.frag,i.id=r.id,e.trigger(t,i)};l.on(a.default.FRAG_DECRYPTED,h),l.on(a.default.FRAG_PARSING_INIT_SEGMENT,h),l.on(a.default.FRAG_PARSING_DATA,h),l.on(a.default.FRAG_PARSED,h),l.on(a.default.ERROR,h),l.on(a.default.FRAG_PARSING_METADATA,h),l.on(a.default.FRAG_PARSING_USERDATA,h),l.on(a.default.INIT_PTS_FOUND,h);var p={mp4:c.isTypeSupported("video/mp4"),mpeg:c.isTypeSupported("audio/mpeg"),mp3:c.isTypeSupported('audio/mp4; codecs="mp3"')},g=navigator.vendor;if(u.enableWorker&&"undefined"!=typeof Worker){o.logger.log("demuxing in webworker");var v=void 0;try{v=this.w=i(46),this.onwmsg=this.onWorkerMessage.bind(this),v.addEventListener("message",this.onwmsg),v.onerror=function(t){e.trigger(a.default.ERROR,{type:s.ErrorTypes.OTHER_ERROR,details:s.ErrorDetails.INTERNAL_EXCEPTION,fatal:!0,event:"demuxerWorker",err:{message:t.message+" ("+t.filename+":"+t.lineno+")"}})},v.postMessage({cmd:"init",typeSupported:p,vendor:g,id:t,config:JSON.stringify(u)})}catch(e){o.logger.warn("Error in worker:",e),o.logger.error("Error while initializing DemuxerWorker, fallback on DemuxerInline"),v&&f.URL.revokeObjectURL(v.objectURL),this.demuxer=new n.default(l,p,u,g),this.w=void 0}}else this.demuxer=new n.default(l,p,u,g)}return t.prototype.destroy=function(){var e=this.w;if(e)e.removeEventListener("message",this.onwmsg),e.terminate(),this.w=null;else{var t=this.demuxer;t&&(t.destroy(),this.demuxer=null)}var r=this.observer;r&&(r.removeAllListeners(),this.observer=null)},t.prototype.push=function(t,r,i,a,n,s,l,u){var d=this.w,f=e.isFinite(n.startPTS)?n.startPTS:n.start,c=n.decryptdata,h=this.frag,p=!(h&&n.cc===h.cc),g=!(h&&n.level===h.level),v=h&&n.sn===h.sn+1,m=!g&&v;if(p&&o.logger.log(this.id+":discontinuity detected"),g&&o.logger.log(this.id+":switch detected"),this.frag=n,d)d.postMessage({cmd:"demux",data:t,decryptdata:c,initSegment:r,audioCodec:i,videoCodec:a,timeOffset:f,discontinuity:p,trackSwitch:g,contiguous:m,duration:s,accurateTimeOffset:l,defaultInitPTS:u},t instanceof ArrayBuffer?[t]:[]);else{var y=this.demuxer;y&&y.push(t,c,r,i,a,f,p,g,m,s,l,u)}},t.prototype.onWorkerMessage=function(e){var t=e.data,r=this.hls;switch(t.event){case"init":f.URL.revokeObjectURL(this.w.objectURL);break;case a.default.FRAG_PARSING_DATA:t.data.data1=new Uint8Array(t.data1),t.data2&&(t.data.data2=new Uint8Array(t.data2));default:t.data=t.data||{},t.data.frag=this.frag,t.data.id=this.id,r.trigger(t.event,t.data)}},t}();t.default=h}).call(this,r(2).Number)},function(e,t,r){function i(e){var t={};function r(i){if(t[i])return t[i].exports;var a=t[i]={i:i,l:!1,exports:{}};return e[i].call(a.exports,a,a.exports,r),a.l=!0,a.exports}r.m=e,r.c=t,r.i=function(e){return e},r.d=function(e,t,i){r.o(e,t)||Object.defineProperty(e,t,{configurable:!1,enumerable:!0,get:i})},r.r=function(e){Object.defineProperty(e,"__esModule",{value:!0})},r.n=function(e){var t=e&&e.__esModule?function(){return e.default}:function(){return e};return r.d(t,"a",t),t},r.o=function(e,t){return Object.prototype.hasOwnProperty.call(e,t)},r.p="/",r.oe=function(e){throw console.error(e),e};var i=r(r.s=ENTRY_MODULE);return i.default||i}var a="[\\.|\\-|\\+|\\w|/|@]+",n="\\((/\\*.*?\\*/)?s?.*?("+a+").*?\\)";function o(e){return(e+"").replace(/[.?*+^$[\]\\(){}|-]/g,"\\$&")}function s(e){return!isNaN(1*e)}function l(e,t,i){var l={};l[i]=[];var u=t.toString(),d=u.match(/^function\s?\(\w+,\s*\w+,\s*(\w+)\)/);if(!d)return l;for(var f,c=d[1],h=new RegExp("(\\\\n|\\W)"+o(c)+n,"g");f=h.exec(u);)"dll-reference"!==f[3]&&l[i].push(f[3]);for(h=new RegExp("\\("+o(c)+'\\("(dll-reference\\s('+a+'))"\\)\\)'+n,"g");f=h.exec(u);)e[f[2]]||(l[i].push(f[1]),e[f[2]]=r(f[1]).m),l[f[2]]=l[f[2]]||[],l[f[2]].push(f[4]);for(var p=Object.keys(l),g=0;g<p.length;g++)for(var v=0;v<l[p[g]].length;v++)s(l[p[g]][v])&&(l[p[g]][v]=1*l[p[g]][v]);return l}function u(e){return Object.keys(e).reduce(function(t,r){return t||e[r].length>0},!1)}e.exports=function(e,t){t=t||{};var a={main:r.m},n=t.all?{main:Object.keys(a.main)}:function(e,t){for(var r={main:[t]},i={main:[]},a={main:{}};u(r);)for(var n=Object.keys(r),o=0;o<n.length;o++){var s=n[o],d=r[s].pop();if(a[s]=a[s]||{},!a[s][d]&&e[s][d]){a[s][d]=!0,i[s]=i[s]||[],i[s].push(d);for(var f=l(e,e[s][d],s),c=Object.keys(f),h=0;h<c.length;h++)r[c[h]]=r[c[h]]||[],r[c[h]]=r[c[h]].concat(f[c[h]])}}return i}(a,e),o="";Object.keys(n).filter(function(e){return"main"!==e}).forEach(function(e){for(var t=0;n[e][t];)t++;n[e].push(t),a[e][t]="(function(module, exports, __webpack_require__) { module.exports = __webpack_require__; })",o=o+"var "+e+" = ("+i.toString().replace("ENTRY_MODULE",JSON.stringify(t))+")({"+n[e].map(function(t){return JSON.stringify(t)+": "+a[e][t].toString()}).join(",")+"});\n"}),o=o+"new (("+i.toString().replace("ENTRY_MODULE",JSON.stringify(e))+")({"+n.main.map(function(e){return JSON.stringify(e)+": "+a.main[e].toString()}).join(",")+"}))(self);";var s=new window.Blob([o],{type:"text/javascript"});if(t.bare)return s;var d=(window.URL||window.webkitURL||window.mozURL||window.msURL).createObjectURL(s),f=new window.Worker(d);return f.objectURL=d,f}},function(e,t,r){"use strict";Object.defineProperty(t,"__esModule",{value:!0});var i=function(){function e(e,t){this.subtle=e,this.aesIV=t}return e.prototype.decrypt=function(e,t){return this.subtle.decrypt({name:"AES-CBC",iv:this.aesIV},t,e)},e}();t.default=i},function(e,t,r){"use strict";Object.defineProperty(t,"__esModule",{value:!0});var i=function(){function e(e,t){this.subtle=e,this.key=t}return e.prototype.expandKey=function(){return this.subtle.importKey("raw",this.key,{name:"AES-CBC"},!1,["encrypt","decrypt"])},e}();t.default=i},function(e,t,r){"use strict";function i(e){var t=e.byteLength,r=t&&new DataView(e).getUint8(t-1);return r?e.slice(0,t-r):e}Object.defineProperty(t,"__esModule",{value:!0}),t.removePadding=i;var a=function(){function e(){this.rcon=[0,1,2,4,8,16,32,64,128,27,54],this.subMix=[new Uint32Array(256),new Uint32Array(256),new Uint32Array(256),new Uint32Array(256)],this.invSubMix=[new Uint32Array(256),new Uint32Array(256),new Uint32Array(256),new Uint32Array(256)],this.sBox=new Uint32Array(256),this.invSBox=new Uint32Array(256),this.key=new Uint32Array(0),this.initTable()}return e.prototype.uint8ArrayToUint32Array_=function(e){for(var t=new DataView(e),r=new Uint32Array(4),i=0;i<4;i++)r[i]=t.getUint32(4*i);return r},e.prototype.initTable=function(){var e=this.sBox,t=this.invSBox,r=this.subMix,i=r[0],a=r[1],n=r[2],o=r[3],s=this.invSubMix,l=s[0],u=s[1],d=s[2],f=s[3],c=new Uint32Array(256),h=0,p=0,g=0;for(g=0;g<256;g++)c[g]=g<128?g<<1:g<<1^283;for(g=0;g<256;g++){var v=p^p<<1^p<<2^p<<3^p<<4;v=v>>>8^255&v^99,e[h]=v,t[v]=h;var m=c[h],y=c[m],_=c[y],E=257*c[v]^16843008*v;i[h]=E<<24|E>>>8,a[h]=E<<16|E>>>16,n[h]=E<<8|E>>>24,o[h]=E,E=16843009*_^65537*y^257*m^16843008*h,l[v]=E<<24|E>>>8,u[v]=E<<16|E>>>16,d[v]=E<<8|E>>>24,f[v]=E,h?(h=m^c[c[c[_^m]]],p^=c[c[p]]):h=p=1}},e.prototype.expandKey=function(e){for(var t=this.uint8ArrayToUint32Array_(e),r=!0,i=0;i<t.length&&r;)r=t[i]===this.key[i],i++;if(!r){this.key=t;var a=this.keySize=t.length;if(4!==a&&6!==a&&8!==a)throw new Error("Invalid aes key size="+a);var n,o,s,l,u=this.ksRows=4*(a+6+1),d=this.keySchedule=new Uint32Array(u),f=this.invKeySchedule=new Uint32Array(u),c=this.sBox,h=this.rcon,p=this.invSubMix,g=p[0],v=p[1],m=p[2],y=p[3];for(n=0;n<u;n++)n<a?s=d[n]=t[n]:(l=s,n%a==0?(l=c[(l=l<<8|l>>>24)>>>24]<<24|c[l>>>16&255]<<16|c[l>>>8&255]<<8|c[255&l],l^=h[n/a|0]<<24):a>6&&n%a==4&&(l=c[l>>>24]<<24|c[l>>>16&255]<<16|c[l>>>8&255]<<8|c[255&l]),d[n]=s=(d[n-a]^l)>>>0);for(o=0;o<u;o++)n=u-o,l=3&o?d[n]:d[n-4],f[o]=o<4||n<=4?l:g[c[l>>>24]]^v[c[l>>>16&255]]^m[c[l>>>8&255]]^y[c[255&l]],f[o]=f[o]>>>0}},e.prototype.networkToHostOrderSwap=function(e){return e<<24|(65280&e)<<8|(16711680&e)>>8|e>>>24},e.prototype.decrypt=function(e,t,r,a){for(var n,o,s,l,u,d,f,c,h,p,g,v,m,y,_=this.keySize+6,E=this.invKeySchedule,b=this.invSBox,S=this.invSubMix,T=S[0],A=S[1],R=S[2],L=S[3],D=this.uint8ArrayToUint32Array_(r),O=D[0],w=D[1],P=D[2],I=D[3],x=new Int32Array(e),F=new Int32Array(x.length),k=this.networkToHostOrderSwap;t<x.length;){for(h=k(x[t]),p=k(x[t+1]),g=k(x[t+2]),v=k(x[t+3]),u=h^E[0],d=v^E[1],f=g^E[2],c=p^E[3],m=4,y=1;y<_;y++)n=T[u>>>24]^A[d>>16&255]^R[f>>8&255]^L[255&c]^E[m],o=T[d>>>24]^A[f>>16&255]^R[c>>8&255]^L[255&u]^E[m+1],s=T[f>>>24]^A[c>>16&255]^R[u>>8&255]^L[255&d]^E[m+2],l=T[c>>>24]^A[u>>16&255]^R[d>>8&255]^L[255&f]^E[m+3],u=n,d=o,f=s,c=l,m+=4;n=b[u>>>24]<<24^b[d>>16&255]<<16^b[f>>8&255]<<8^b[255&c]^E[m],o=b[d>>>24]<<24^b[f>>16&255]<<16^b[c>>8&255]<<8^b[255&u]^E[m+1],s=b[f>>>24]<<24^b[c>>16&255]<<16^b[u>>8&255]<<8^b[255&d]^E[m+2],l=b[c>>>24]<<24^b[u>>16&255]<<16^b[d>>8&255]<<8^b[255&f]^E[m+3],m+=3,F[t]=k(n^O),F[t+1]=k(l^w),F[t+2]=k(s^P),F[t+3]=k(o^I),O=h,w=p,P=g,I=v,t+=4}return a?i(F.buffer):F.buffer},e.prototype.destroy=function(){this.key=void 0,this.keySize=void 0,this.ksRows=void 0,this.sBox=void 0,this.invSBox=void 0,this.subMix=void 0,this.invSubMix=void 0,this.keySchedule=void 0,this.invKeySchedule=void 0,this.rcon=void 0},e}();t.default=a},function(e,t,r){"use strict";(function(e){Object.defineProperty(t,"__esModule",{value:!0});var i=r(20),a=r(0),n=r(11),o=function(){function t(e,t,r){this.observer=e,this.config=r,this.remuxer=t}return t.prototype.resetInitSegment=function(e,t,r,i){this._audioTrack={container:"audio/adts",type:"audio",id:0,sequenceNumber:0,isAAC:!0,samples:[],len:0,manifestCodec:t,duration:i,inputTimeScale:9e4}},t.prototype.resetTimeStamp=function(){},t.probe=function(e){if(!e)return!1;for(var t=(n.default.getID3Data(e,0)||[]).length,r=e.length;t<r;t++)if(i.probe(e,t))return a.logger.log("ADTS sync word found !"),!0;return!1},t.prototype.append=function(t,r,o,s){for(var l=this._audioTrack,u=n.default.getID3Data(t,0)||[],d=n.default.getTimeStamp(u),f=e.isFinite(d)?90*d:9e4*r,c=0,h=f,p=t.length,g=u.length,v=[{pts:h,dts:h,data:u}];g<p-1;)if(i.isHeader(t,g)&&g+5<p){i.initTrackConfig(l,this.observer,t,g,l.manifestCodec);var m=i.appendFrame(l,t,g,f,c);if(!m){a.logger.log("Unable to parse AAC frame");break}g+=m.length,h=m.sample.pts,c++}else n.default.isHeader(t,g)?(u=n.default.getID3Data(t,g),v.push({pts:h,dts:h,data:u}),g+=u.length):g++;this.remuxer.remux(l,{samples:[]},{samples:v,inputTimeScale:9e4},{samples:[]},r,o,s)},t.prototype.destroy=function(){},t}();t.default=o}).call(this,r(2).Number)},function(e,t,r){"use strict";Object.defineProperty(t,"__esModule",{value:!0});var i=r(20),a=r(21),n=r(1),o=r(38),s=r(39),l=r(0),u=r(3),d={video:1,audio:2,id3:3,text:4},f=function(){function e(e,t,r,i){this.observer=e,this.config=r,this.typeSupported=i,this.remuxer=t,this.sampleAes=null}return e.prototype.setDecryptData=function(e){null!=e&&null!=e.key&&"SAMPLE-AES"===e.method?this.sampleAes=new s.default(this.observer,this.config,e,this.discardEPB):this.sampleAes=null},e.probe=function(t){var r=e._syncOffset(t);return!(r<0)&&(r&&l.logger.warn("MPEG2-TS detected but first sync word found @ offset "+r+", junk ahead ?"),!0)},e._syncOffset=function(e){for(var t=Math.min(1e3,e.length-564),r=0;r<t;){if(71===e[r]&&71===e[r+188]&&71===e[r+376])return r;r++}return-1},e.createTrack=function(e,t){return{container:"video"===e||"audio"===e?"video/mp2t":void 0,type:e,id:d[e],pid:-1,inputTimeScale:9e4,sequenceNumber:0,samples:[],len:0,dropped:"video"===e?0:void 0,isAAC:"audio"===e||void 0,duration:"audio"===e?t:void 0}},e.prototype.resetInitSegment=function(t,r,i,a){this.pmtParsed=!1,this._pmtId=-1,this._avcTrack=e.createTrack("video",a),this._audioTrack=e.createTrack("audio",a),this._id3Track=e.createTrack("id3",a),this._txtTrack=e.createTrack("text",a),this.aacOverFlow=null,this.aacLastPTS=null,this.avcSample=null,this.audioCodec=r,this.videoCodec=i,this._duration=a},e.prototype.resetTimeStamp=function(){},e.prototype.append=function(t,r,i,a){var o,s,d,f,c,h=t.length,p=!1;this.contiguous=i;var g=this.pmtParsed,v=this._avcTrack,m=this._audioTrack,y=this._id3Track,_=v.pid,E=m.pid,b=y.pid,S=this._pmtId,T=v.pesData,A=m.pesData,R=y.pesData,L=this._parsePAT,D=this._parsePMT,O=this._parsePES,w=this._parseAVCPES.bind(this),P=this._parseAACPES.bind(this),I=this._parseMPEGPES.bind(this),x=this._parseID3PES.bind(this),F=e._syncOffset(t);for(h-=(h+F)%188,o=F;o<h;o+=188)if(71===t[o]){if(s=!!(64&t[o+1]),d=((31&t[o+1])<<8)+t[o+2],(48&t[o+3])>>4>1){if((f=o+5+t[o+4])===o+188)continue}else f=o+4;switch(d){case _:s&&(T&&(c=O(T))&&void 0!==c.pts&&w(c,!1),T={data:[],size:0}),T&&(T.data.push(t.subarray(f,o+188)),T.size+=o+188-f);break;case E:s&&(A&&(c=O(A))&&void 0!==c.pts&&(m.isAAC?P(c):I(c)),A={data:[],size:0}),A&&(A.data.push(t.subarray(f,o+188)),A.size+=o+188-f);break;case b:s&&(R&&(c=O(R))&&void 0!==c.pts&&x(c),R={data:[],size:0}),R&&(R.data.push(t.subarray(f,o+188)),R.size+=o+188-f);break;case 0:s&&(f+=t[f]+1),S=this._pmtId=L(t,f);break;case S:s&&(f+=t[f]+1);var k=D(t,f,!0===this.typeSupported.mpeg||!0===this.typeSupported.mp3,null!=this.sampleAes);(_=k.avc)>0&&(v.pid=_),(E=k.audio)>0&&(m.pid=E,m.isAAC=k.isAAC),(b=k.id3)>0&&(y.pid=b),p&&!g&&(l.logger.log("reparse from beginning"),p=!1,o=F-188),g=this.pmtParsed=!0;break;case 17:case 8191:break;default:p=!0}}else this.observer.trigger(n.default.ERROR,{type:u.ErrorTypes.MEDIA_ERROR,details:u.ErrorDetails.FRAG_PARSING_ERROR,fatal:!1,reason:"TS packet did not start with 0x47"});T&&(c=O(T))&&void 0!==c.pts?(w(c,!0),v.pesData=null):v.pesData=T,A&&(c=O(A))&&void 0!==c.pts?(m.isAAC?P(c):I(c),m.pesData=null):(A&&A.size&&l.logger.log("last AAC PES packet truncated,might overlap between fragments"),m.pesData=A),R&&(c=O(R))&&void 0!==c.pts?(x(c),y.pesData=null):y.pesData=R,null==this.sampleAes?this.remuxer.remux(m,v,y,this._txtTrack,r,i,a):this.decryptAndRemux(m,v,y,this._txtTrack,r,i,a)},e.prototype.decryptAndRemux=function(e,t,r,i,a,n,o){if(e.samples&&e.isAAC){var s=this;this.sampleAes.decryptAacSamples(e.samples,0,function(){s.decryptAndRemuxAvc(e,t,r,i,a,n,o)})}else this.decryptAndRemuxAvc(e,t,r,i,a,n,o)},e.prototype.decryptAndRemuxAvc=function(e,t,r,i,a,n,o){if(t.samples){var s=this;this.sampleAes.decryptAvcSamples(t.samples,0,0,function(){s.remuxer.remux(e,t,r,i,a,n,o)})}else this.remuxer.remux(e,t,r,i,a,n,o)},e.prototype.destroy=function(){this._initPTS=this._initDTS=void 0,this._duration=0},e.prototype._parsePAT=function(e,t){return(31&e[t+10])<<8|e[t+11]},e.prototype._parsePMT=function(e,t,r,i){var a,n,o={audio:-1,avc:-1,id3:-1,isAAC:!0};for(a=t+3+((15&e[t+1])<<8|e[t+2])-4,t+=12+((15&e[t+10])<<8|e[t+11]);t<a;){switch(n=(31&e[t+1])<<8|e[t+2],e[t]){case 207:if(!i){l.logger.log("unkown stream type:"+e[t]);break}case 15:-1===o.audio&&(o.audio=n);break;case 21:-1===o.id3&&(o.id3=n);break;case 219:if(!i){l.logger.log("unkown stream type:"+e[t]);break}case 27:-1===o.avc&&(o.avc=n);break;case 3:case 4:r?-1===o.audio&&(o.audio=n,o.isAAC=!1):l.logger.log("MPEG audio found, not supported in this browser for now");break;case 36:l.logger.warn("HEVC stream type found, not supported for now");break;default:l.logger.log("unkown stream type:"+e[t])}t+=5+((15&e[t+3])<<8|e[t+4])}return o},e.prototype._parsePES=function(e){var t,r,i,a,n,o,s,u,d=0,f=e.data;if(!e||0===e.size)return null;for(;f[0].length<19&&f.length>1;){var c=new Uint8Array(f[0].length+f[1].length);c.set(f[0]),c.set(f[1],f[0].length),f[0]=c,f.splice(1,1)}if(1===((t=f[0])[0]<<16)+(t[1]<<8)+t[2]){if((i=(t[4]<<8)+t[5])&&i>e.size-6)return null;192&(r=t[7])&&((o=536870912*(14&t[9])+4194304*(255&t[10])+16384*(254&t[11])+128*(255&t[12])+(254&t[13])/2)>4294967295&&(o-=8589934592),64&r?((s=536870912*(14&t[14])+4194304*(255&t[15])+16384*(254&t[16])+128*(255&t[17])+(254&t[18])/2)>4294967295&&(s-=8589934592),o-s>54e5&&(l.logger.warn(Math.round((o-s)/9e4)+"s delta between PTS and DTS, align them"),o=s)):s=o),u=(a=t[8])+9,e.size-=u,n=new Uint8Array(e.size);for(var h=0,p=f.length;h<p;h++){var g=(t=f[h]).byteLength;if(u){if(u>g){u-=g;continue}t=t.subarray(u),g-=u,u=0}n.set(t,d),d+=g}return i&&(i-=a+3),{data:n,pts:o,dts:s,len:i}}return null},e.prototype.pushAccesUnit=function(e,t){if(e.units.length&&e.frame){var r=t.samples,i=r.length;!this.config.forceKeyFrameOnDiscontinuity||!0===e.key||t.sps&&(i||this.contiguous)?(e.id=i,r.push(e)):t.dropped++}e.debug.length&&l.logger.log(e.pts+"/"+e.dts+":"+e.debug)},e.prototype._parseAVCPES=function(e,t){var r,i,a,n=this,s=this._avcTrack,l=this._parseAVCNALu(e.data),u=this.avcSample,d=!1,f=this.pushAccesUnit.bind(this),c=function(e,t,r,i){return{key:e,pts:t,dts:r,units:[],debug:i}};e.data=null,u&&l.length&&!s.audFound&&(f(u,s),u=this.avcSample=c(!1,e.pts,e.dts,"")),l.forEach(function(t){switch(t.type){case 1:i=!0,u||(u=n.avcSample=c(!0,e.pts,e.dts,"")),u.frame=!0;var l=t.data;if(d&&l.length>4){var h=new o.default(l).readSliceType();2!==h&&4!==h&&7!==h&&9!==h||(u.key=!0)}break;case 5:i=!0,u||(u=n.avcSample=c(!0,e.pts,e.dts,"")),u.key=!0,u.frame=!0;break;case 6:i=!0,(r=new o.default(n.discardEPB(t.data))).readUByte();for(var p=0,g=0,v=!1,m=0;!v&&r.bytesAvailable>1;){p=0;do{p+=m=r.readUByte()}while(255===m);g=0;do{g+=m=r.readUByte()}while(255===m);if(4===p&&0!==r.bytesAvailable){if(v=!0,181===r.readUByte())if(49===r.readUShort())if(1195456820===r.readUInt())if(3===r.readUByte()){var y=r.readUByte(),_=31&y,E=[y,r.readUByte()];for(a=0;a<_;a++)E.push(r.readUByte()),E.push(r.readUByte()),E.push(r.readUByte());n._insertSampleInOrder(n._txtTrack.samples,{type:3,pts:e.pts,bytes:E})}}else if(g<r.bytesAvailable)for(a=0;a<g;a++)r.readUByte()}break;case 7:if(i=!0,d=!0,!s.sps){var b=(r=new o.default(t.data)).readSPS();s.width=b.width,s.height=b.height,s.pixelRatio=b.pixelRatio,s.sps=[t.data],s.duration=n._duration;var S=t.data.subarray(1,4),T="avc1.";for(a=0;a<3;a++){var A=S[a].toString(16);A.length<2&&(A="0"+A),T+=A}s.codec=T}break;case 8:i=!0,s.pps||(s.pps=[t.data]);break;case 9:i=!1,s.audFound=!0,u&&f(u,s),u=n.avcSample=c(!1,e.pts,e.dts,"");break;case 12:i=!1;break;default:i=!1,u&&(u.debug+="unknown NAL "+t.type+" ")}u&&i&&u.units.push(t)}),t&&u&&(f(u,s),this.avcSample=null)},e.prototype._insertSampleInOrder=function(e,t){var r=e.length;if(r>0){if(t.pts>=e[r-1].pts)e.push(t);else for(var i=r-1;i>=0;i--)if(t.pts<e[i].pts){e.splice(i,0,t);break}}else e.push(t)},e.prototype._getLastNalUnit=function(){var e,t=this.avcSample;if(!t||0===t.units.length){var r=this._avcTrack.samples;t=r[r.length-1]}if(t){var i=t.units;e=i[i.length-1]}return e},e.prototype._parseAVCNALu=function(e){var t,r,i,a,n=0,o=e.byteLength,s=this._avcTrack,l=s.naluState||0,u=l,d=[],f=-1;for(-1===l&&(f=0,a=31&e[0],l=0,n=1);n<o;)if(t=e[n++],l)if(1!==l)if(t)if(1===t){var c,h;if(f>=0)i={data:e.subarray(f,n-l-1),type:a},d.push(i);else if(c=this._getLastNalUnit())if(u&&n<=4-u&&c.state&&(c.data=c.data.subarray(0,c.data.byteLength-u)),(r=n-l-1)>0)(h=new Uint8Array(c.data.byteLength+r)).set(c.data,0),h.set(e.subarray(0,r),c.data.byteLength),c.data=h;n<o?(f=n,a=31&e[n],l=0):l=-1}else l=0;else l=3;else l=t?0:2;else l=t?0:1;(f>=0&&l>=0&&(i={data:e.subarray(f,o),type:a,state:l},d.push(i)),0===d.length)&&((c=this._getLastNalUnit())&&((h=new Uint8Array(c.data.byteLength+e.byteLength)).set(c.data,0),h.set(e,c.data.byteLength),c.data=h));return s.naluState=l,d},e.prototype.discardEPB=function(e){for(var t,r,i=e.byteLength,a=[],n=1;n<i-2;)0===e[n]&&0===e[n+1]&&3===e[n+2]?(a.push(n+2),n+=2):n++;if(0===a.length)return e;t=i-a.length,r=new Uint8Array(t);var o=0;for(n=0;n<t;o++,n++)o===a[0]&&(o++,a.shift()),r[n]=e[o];return r},e.prototype._parseAACPES=function(e){var t,r,a,o,s,d=this._audioTrack,f=e.data,c=e.pts,h=this.aacOverFlow,p=this.aacLastPTS;if(h){var g=new Uint8Array(h.byteLength+f.byteLength);g.set(h,0),g.set(f,h.byteLength),f=g}for(a=0,s=f.length;a<s-1&&!i.isHeader(f,a);a++);if(a){var v=void 0,m=void 0;if(a<s-1?(v="AAC PES did not start with ADTS header,offset:"+a,m=!1):(v="no ADTS header found in AAC PES",m=!0),l.logger.warn("parsing error:"+v),this.observer.trigger(n.default.ERROR,{type:u.ErrorTypes.MEDIA_ERROR,details:u.ErrorDetails.FRAG_PARSING_ERROR,fatal:m,reason:v}),m)return}if(i.initTrackConfig(d,this.observer,f,a,this.audioCodec),r=0,t=i.getFrameDuration(d.samplerate),h&&p){var y=p+t;Math.abs(y-c)>1&&(l.logger.log("AAC: align PTS for overlapping frames by "+Math.round((y-c)/90)),c=y)}for(;a<s;)if(i.isHeader(f,a)&&a+5<s){var _=i.appendFrame(d,f,a,c,r);if(!_)break;a+=_.length,o=_.sample.pts,r++}else a++;h=a<s?f.subarray(a,s):null,this.aacOverFlow=h,this.aacLastPTS=o},e.prototype._parseMPEGPES=function(e){for(var t=e.data,r=t.length,i=0,n=0,o=e.pts;n<r;)if(a.default.isHeader(t,n)){var s=a.default.appendFrame(this._audioTrack,t,n,o,i);if(!s)break;n+=s.length,i++}else n++},e.prototype._parseID3PES=function(e){this._id3Track.samples.push(e)},e}();t.default=f},function(e,t,r){"use strict";Object.defineProperty(t,"__esModule",{value:!0});var i=r(0),a=function(){function e(e){this.data=e,this.bytesAvailable=e.byteLength,this.word=0,this.bitsAvailable=0}return e.prototype.loadWord=function(){var e=this.data,t=this.bytesAvailable,r=e.byteLength-t,i=new Uint8Array(4),a=Math.min(4,t);if(0===a)throw new Error("no bytes available");i.set(e.subarray(r,r+a)),this.word=new DataView(i.buffer).getUint32(0),this.bitsAvailable=8*a,this.bytesAvailable-=a},e.prototype.skipBits=function(e){var t;this.bitsAvailable>e?(this.word<<=e,this.bitsAvailable-=e):(e-=this.bitsAvailable,e-=(t=e>>3)>>3,this.bytesAvailable-=t,this.loadWord(),this.word<<=e,this.bitsAvailable-=e)},e.prototype.readBits=function(e){var t=Math.min(this.bitsAvailable,e),r=this.word>>>32-t;return e>32&&i.logger.error("Cannot read more than 32 bits at a time"),this.bitsAvailable-=t,this.bitsAvailable>0?this.word<<=t:this.bytesAvailable>0&&this.loadWord(),(t=e-t)>0&&this.bitsAvailable?r<<t|this.readBits(t):r},e.prototype.skipLZ=function(){var e;for(e=0;e<this.bitsAvailable;++e)if(0!=(this.word&2147483648>>>e))return this.word<<=e,this.bitsAvailable-=e,e;return this.loadWord(),e+this.skipLZ()},e.prototype.skipUEG=function(){this.skipBits(1+this.skipLZ())},e.prototype.skipEG=function(){this.skipBits(1+this.skipLZ())},e.prototype.readUEG=function(){var e=this.skipLZ();return this.readBits(e+1)-1},e.prototype.readEG=function(){var e=this.readUEG();return 1&e?1+e>>>1:-1*(e>>>1)},e.prototype.readBoolean=function(){return 1===this.readBits(1)},e.prototype.readUByte=function(){return this.readBits(8)},e.prototype.readUShort=function(){return this.readBits(16)},e.prototype.readUInt=function(){return this.readBits(32)},e.prototype.skipScalingList=function(e){var t,r=8,i=8;for(t=0;t<e;t++)0!==i&&(i=(r+this.readEG()+256)%256),r=0===i?r:i},e.prototype.readSPS=function(){var e,t,r,i,a,n,o,s=0,l=0,u=0,d=0,f=this.readUByte.bind(this),c=this.readBits.bind(this),h=this.readUEG.bind(this),p=this.readBoolean.bind(this),g=this.skipBits.bind(this),v=this.skipEG.bind(this),m=this.skipUEG.bind(this),y=this.skipScalingList.bind(this);if(f(),e=f(),c(5),g(3),f(),m(),100===e||110===e||122===e||244===e||44===e||83===e||86===e||118===e||128===e){var _=h();if(3===_&&g(1),m(),m(),g(1),p())for(n=3!==_?8:12,o=0;o<n;o++)p()&&y(o<6?16:64)}m();var E=h();if(0===E)h();else if(1===E)for(g(1),v(),v(),t=h(),o=0;o<t;o++)v();m(),g(1),r=h(),i=h(),0===(a=c(1))&&g(1),g(1),p()&&(s=h(),l=h(),u=h(),d=h());var b=[1,1];if(p()&&p())switch(f()){case 1:b=[1,1];break;case 2:b=[12,11];break;case 3:b=[10,11];break;case 4:b=[16,11];break;case 5:b=[40,33];break;case 6:b=[24,11];break;case 7:b=[20,11];break;case 8:b=[32,11];break;case 9:b=[80,33];break;case 10:b=[18,11];break;case 11:b=[15,11];break;case 12:b=[64,33];break;case 13:b=[160,99];break;case 14:b=[4,3];break;case 15:b=[3,2];break;case 16:b=[2,1];break;case 255:b=[f()<<8|f(),f()<<8|f()]}return{width:Math.ceil(16*(r+1)-2*s-2*l),height:(2-a)*(i+1)*16-(a?2:4)*(u+d),pixelRatio:b}},e.prototype.readSliceType=function(){return this.readUByte(),this.readUEG(),this.readUEG()},e}();t.default=a},function(e,t,r){"use strict";Object.defineProperty(t,"__esModule",{value:!0});var i=r(19),a=function(){function e(e,t,r,a){this.decryptdata=r,this.discardEPB=a,this.decrypter=new i.default(e,t,{removePKCS7Padding:!1})}return e.prototype.decryptBuffer=function(e,t){this.decrypter.decrypt(e,this.decryptdata.key.buffer,this.decryptdata.iv.buffer,t)},e.prototype.decryptAacSample=function(e,t,r,i){var a=e[t].unit,n=a.subarray(16,a.length-a.length%16),o=n.buffer.slice(n.byteOffset,n.byteOffset+n.length),s=this;this.decryptBuffer(o,function(n){n=new Uint8Array(n),a.set(n,16),i||s.decryptAacSamples(e,t+1,r)})},e.prototype.decryptAacSamples=function(e,t,r){for(;;t++){if(t>=e.length)return void r();if(!(e[t].unit.length<32)){var i=this.decrypter.isSync();if(this.decryptAacSample(e,t,r,i),!i)return}}},e.prototype.getAvcEncryptedData=function(e){for(var t=16*Math.floor((e.length-48)/160)+16,r=new Int8Array(t),i=0,a=32;a<=e.length-16;a+=160,i+=16)r.set(e.subarray(a,a+16),i);return r},e.prototype.getAvcDecryptedUnit=function(e,t){t=new Uint8Array(t);for(var r=0,i=32;i<=e.length-16;i+=160,r+=16)e.set(t.subarray(r,r+16),i);return e},e.prototype.decryptAvcSample=function(e,t,r,i,a,n){var o=this.discardEPB(a.data),s=this.getAvcEncryptedData(o),l=this;this.decryptBuffer(s.buffer,function(s){a.data=l.getAvcDecryptedUnit(o,s),n||l.decryptAvcSamples(e,t,r+1,i)})},e.prototype.decryptAvcSamples=function(e,t,r,i){for(;;t++,r=0){if(t>=e.length)return void i();for(var a=e[t].units;!(r>=a.length);r++){var n=a[r];if(!(n.length<=48||1!==n.type&&5!==n.type)){var o=this.decrypter.isSync();if(this.decryptAvcSample(e,t,r,i,n,o),!o)return}}}},e}();t.default=a},function(e,t,r){"use strict";Object.defineProperty(t,"__esModule",{value:!0});var i=r(11),a=r(0),n=r(21),o=function(){function e(e,t,r){this.observer=e,this.config=r,this.remuxer=t}return e.prototype.resetInitSegment=function(e,t,r,i){this._audioTrack={container:"audio/mpeg",type:"audio",id:-1,sequenceNumber:0,isAAC:!1,samples:[],len:0,manifestCodec:t,duration:i,inputTimeScale:9e4}},e.prototype.resetTimeStamp=function(){},e.probe=function(e){var t,r,o=i.default.getID3Data(e,0);if(o&&void 0!==i.default.getTimeStamp(o))for(t=o.length,r=Math.min(e.length-1,t+100);t<r;t++)if(n.default.probe(e,t))return a.logger.log("MPEG Audio sync word found !"),!0;return!1},e.prototype.append=function(e,t,r,a){for(var o=i.default.getID3Data(e,0),s=i.default.getTimeStamp(o),l=s?90*s:9e4*t,u=o.length,d=e.length,f=0,c=0,h=this._audioTrack,p=[{pts:l,dts:l,data:o}];u<d;)if(n.default.isHeader(e,u)){var g=n.default.appendFrame(h,e,u,l,f);if(!g)break;u+=g.length,c=g.sample.pts,f++}else i.default.isHeader(e,u)?(o=i.default.getID3Data(e,u),p.push({pts:c,dts:c,data:o}),u+=o.length):u++;this.remuxer.remux(h,{samples:[]},{samples:p,inputTimeScale:9e4},{samples:[]},t,r,a)},e.prototype.destroy=function(){},e}();t.default=o},function(e,t,r){"use strict";Object.defineProperty(t,"__esModule",{value:!0});var i=r(42),a=r(43),n=r(1),o=r(3),s=r(0),l=function(){function e(e,t,r,i){this.observer=e,this.config=t,this.typeSupported=r;var a=navigator.userAgent;this.isSafari=i&&i.indexOf("Apple")>-1&&a&&!a.match("CriOS"),this.ISGenerated=!1}return e.prototype.destroy=function(){},e.prototype.resetTimeStamp=function(e){this._initPTS=this._initDTS=e},e.prototype.resetInitSegment=function(){this.ISGenerated=!1},e.prototype.remux=function(e,t,r,i,a,o,l){if(this.ISGenerated||this.generateIS(e,t,a),this.ISGenerated){var u=e.samples.length,d=t.samples.length,f=a,c=a;if(u&&d){var h=(e.samples[0].pts-t.samples[0].pts)/t.inputTimeScale;f+=Math.max(0,h),c+=Math.max(0,-h)}if(u){e.timescale||(s.logger.warn("regenerate InitSegment as audio detected"),this.generateIS(e,t,a));var p=this.remuxAudio(e,f,o,l);if(d){var g=void 0;p&&(g=p.endPTS-p.startPTS),t.timescale||(s.logger.warn("regenerate InitSegment as video detected"),this.generateIS(e,t,a)),this.remuxVideo(t,c,o,g,l)}}else if(d){var v=this.remuxVideo(t,c,o,0,l);v&&e.codec&&this.remuxEmptyAudio(e,f,o,v)}}r.samples.length&&this.remuxID3(r,a),i.samples.length&&this.remuxText(i,a),this.observer.trigger(n.default.FRAG_PARSED)},e.prototype.generateIS=function(e,t,r){var i,l,u=this.observer,d=e.samples,f=t.samples,c=this.typeSupported,h="audio/mp4",p={},g={tracks:p},v=void 0===this._initPTS;if(v&&(i=l=1/0),e.config&&d.length&&(e.timescale=e.samplerate,s.logger.log("audio sampling rate : "+e.samplerate),e.isAAC||(c.mpeg?(h="audio/mpeg",e.codec=""):c.mp3&&(e.codec="mp3")),p.audio={container:h,codec:e.codec,initSegment:!e.isAAC&&c.mpeg?new Uint8Array:a.default.initSegment([e]),metadata:{channelCount:e.channelCount}},v&&(i=l=d[0].pts-e.inputTimeScale*r)),t.sps&&t.pps&&f.length){var m=t.inputTimeScale;t.timescale=m,p.video={container:"video/mp4",codec:t.codec,initSegment:a.default.initSegment([t]),metadata:{width:t.width,height:t.height}},v&&(i=Math.min(i,f[0].pts-m*r),l=Math.min(l,f[0].dts-m*r),this.observer.trigger(n.default.INIT_PTS_FOUND,{initPTS:i}))}Object.keys(p).length?(u.trigger(n.default.FRAG_PARSING_INIT_SEGMENT,g),this.ISGenerated=!0,v&&(this._initPTS=i,this._initDTS=l)):u.trigger(n.default.ERROR,{type:o.ErrorTypes.MEDIA_ERROR,details:o.ErrorDetails.FRAG_PARSING_ERROR,fatal:!1,reason:"no audio/video samples found"})},e.prototype.remuxVideo=function(e,t,r,i,l){var u,d,f,c,h,p,g,v=8,m=e.timescale,y=e.samples,_=[],E=y.length,b=this._PTSNormalize,S=this._initPTS,T=this.nextAvcDts,A=this.isSafari;if(0!==E){A&&(r|=y.length&&T&&(l&&Math.abs(t-T/m)<.1||Math.abs(y[0].pts-T-S)<m/5)),r||(T=t*m),y.forEach(function(e){e.pts=b(e.pts-S,T),e.dts=b(e.dts-S,T)}),y.sort(function(e,t){var r=e.dts-t.dts,i=e.pts-t.pts;return r||i||e.id-t.id});var R=y.reduce(function(e,t){return Math.max(Math.min(e,t.pts-t.dts),-18e3)},0);if(R<0){s.logger.warn("PTS < DTS detected in video samples, shifting DTS by "+Math.round(R/90)+" ms to overcome this issue");for(var L=0;L<y.length;L++)y[L].dts+=R}var D=y[0];h=Math.max(D.dts,0),c=Math.max(D.pts,0);var O=Math.round((h-T)/90);r&&O&&(O>1?s.logger.log("AVC:"+O+" ms hole between fragments detected,filling it"):O<-1&&s.logger.log("AVC:"+-O+" ms overlapping between fragments detected"),h=T,y[0].dts=h,c=Math.max(c-O,T),y[0].pts=c,s.logger.log("Video/PTS/DTS adjusted: "+Math.round(c/90)+"/"+Math.round(h/90)+",delta:"+O+" ms")),D=y[y.length-1],g=Math.max(D.dts,0),p=Math.max(D.pts,0,g),A&&(u=Math.round((g-h)/(y.length-1)));var w=0,P=0;for(L=0;L<E;L++){for(var I=y[L],x=I.units,F=x.length,k=0,C=0;C<F;C++)k+=x[C].data.length;P+=k,w+=F,I.length=k,I.dts=A?h+L*u:Math.max(I.dts,h),I.pts=Math.max(I.pts,I.dts)}var M=P+4*w+8;try{d=new Uint8Array(M)}catch(e){return void this.observer.trigger(n.default.ERROR,{type:o.ErrorTypes.MUX_ERROR,details:o.ErrorDetails.REMUX_ALLOC_ERROR,fatal:!1,bytes:M,reason:"fail allocating video mdat "+M})}var N=new DataView(d.buffer);N.setUint32(0,M),d.set(a.default.types.mdat,4);for(L=0;L<E;L++){var U=y[L],B=U.units,G=0,j=void 0;for(C=0,F=B.length;C<F;C++){var H=B[C],K=H.data,V=H.data.byteLength;N.setUint32(v,V),v+=4,d.set(K,v),v+=V,G+=4+V}if(A)j=Math.max(0,u*Math.round((U.pts-U.dts)/u));else{if(L<E-1)u=y[L+1].dts-U.dts;else{var W=this.config,Y=U.dts-y[L>0?L-1:L].dts;if(W.stretchShortVideoTrack){var z=W.maxBufferHole,X=Math.floor(z*m),q=(i?c+i*m:this.nextAudioPts)-U.pts;q>X?((u=q-Y)<0&&(u=Y),s.logger.log("It is approximately "+q/90+" ms to the next segment; using duration "+u/90+" ms for the last video frame.")):u=Y}else u=Y}j=Math.round(U.pts-U.dts)}_.push({size:G,duration:u,cts:j,flags:{isLeading:0,isDependedOn:0,hasRedundancy:0,degradPrio:0,dependsOn:U.key?2:1,isNonSync:U.key?0:1}})}this.nextAvcDts=g+u;var Q=e.dropped;if(e.len=0,e.nbNalu=0,e.dropped=0,_.length&&navigator.userAgent.toLowerCase().indexOf("chrome")>-1){var Z=_[0].flags;Z.dependsOn=2,Z.isNonSync=0}e.samples=_,f=a.default.moof(e.sequenceNumber++,h,e),e.samples=[];var J={data1:f,data2:d,startPTS:c/m,endPTS:(p+u)/m,startDTS:h/m,endDTS:this.nextAvcDts/m,type:"video",hasAudio:!1,hasVideo:!0,nb:_.length,dropped:Q};return this.observer.trigger(n.default.FRAG_PARSING_DATA,J),J}},e.prototype.remuxAudio=function(e,t,r,l){var u,d,f,c,h,p,g,v=e.inputTimeScale,m=e.timescale,y=v/m,_=(e.isAAC?1024:1152)*y,E=this._PTSNormalize,b=this._initPTS,S=!e.isAAC&&this.typeSupported.mpeg,T=e.samples,A=[],R=this.nextAudioPts;if(r|=T.length&&R&&(l&&Math.abs(t-R/v)<.1||Math.abs(T[0].pts-R-b)<20*_),T.forEach(function(e){e.pts=e.dts=E(e.pts-b,t*v)}),0!==(T=T.filter(function(e){return e.pts>=0})).length){if(r||(R=l?t*v:T[0].pts),e.isAAC)for(var L=this.config.maxAudioFramesDrift,D=0,O=R;D<T.length;){var w,P=T[D];w=(U=P.pts)-O;var I=Math.abs(1e3*w/v);if(w<=-L*_)s.logger.warn("Dropping 1 audio frame @ "+(O/v).toFixed(3)+"s due to "+Math.round(I)+" ms overlap."),T.splice(D,1),e.len-=P.unit.length;else if(w>=L*_&&I<1e4&&O){var x=Math.round(w/_);s.logger.warn("Injecting "+x+" audio frame @ "+(O/v).toFixed(3)+"s due to "+Math.round(1e3*w/v)+" ms gap.");for(var F=0;F<x;F++){var k=Math.max(O,0);(f=i.default.getSilentFrame(e.manifestCodec||e.codec,e.channelCount))||(s.logger.log("Unable to get silent frame for given audio codec; duplicating last frame instead."),f=P.unit.subarray()),T.splice(D,0,{unit:f,pts:k,dts:k}),e.len+=f.length,O+=_,D++}P.pts=P.dts=O,O+=_,D++}else Math.abs(w),P.pts=P.dts=O,O+=_,D++}F=0;for(var C=T.length;F<C;F++){var M=T[F],N=M.unit,U=M.pts;if(void 0!==g)d.duration=Math.round((U-g)/y);else{var B=Math.round(1e3*(U-R)/v),G=0;if(r&&e.isAAC&&B){if(B>0&&B<1e4)G=Math.round((U-R)/_),s.logger.log(B+" ms hole between AAC samples detected,filling it"),G>0&&((f=i.default.getSilentFrame(e.manifestCodec||e.codec,e.channelCount))||(f=N.subarray()),e.len+=G*f.length);else if(B<-12){s.logger.log("drop overlapping AAC sample, expected/parsed/delta:"+(R/v).toFixed(3)+"s/"+(U/v).toFixed(3)+"s/"+-B+"ms"),e.len-=N.byteLength;continue}U=R}if(p=U,!(e.len>0))return;var j=S?e.len:e.len+8;u=S?0:8;try{c=new Uint8Array(j)}catch(e){return void this.observer.trigger(n.default.ERROR,{type:o.ErrorTypes.MUX_ERROR,details:o.ErrorDetails.REMUX_ALLOC_ERROR,fatal:!1,bytes:j,reason:"fail allocating audio mdat "+j})}S||(new DataView(c.buffer).setUint32(0,j),c.set(a.default.types.mdat,4));for(D=0;D<G;D++)(f=i.default.getSilentFrame(e.manifestCodec||e.codec,e.channelCount))||(s.logger.log("Unable to get silent frame for given audio codec; duplicating this frame instead."),f=N.subarray()),c.set(f,u),u+=f.byteLength,d={size:f.byteLength,cts:0,duration:1024,flags:{isLeading:0,isDependedOn:0,hasRedundancy:0,degradPrio:0,dependsOn:1}},A.push(d)}c.set(N,u);var H=N.byteLength;u+=H,d={size:H,cts:0,duration:0,flags:{isLeading:0,isDependedOn:0,hasRedundancy:0,degradPrio:0,dependsOn:1}},A.push(d),g=U}var K=0,V=A.length;if(V>=2&&(K=A[V-2].duration,d.duration=K),V){this.nextAudioPts=R=g+y*K,e.len=0,e.samples=A,h=S?new Uint8Array:a.default.moof(e.sequenceNumber++,p/y,e),e.samples=[];var W=p/v,Y=R/v,z={data1:h,data2:c,startPTS:W,endPTS:Y,startDTS:W,endDTS:Y,type:"audio",hasAudio:!0,hasVideo:!1,nb:V};return this.observer.trigger(n.default.FRAG_PARSING_DATA,z),z}return null}},e.prototype.remuxEmptyAudio=function(e,t,r,a){var n=e.inputTimeScale,o=n/(e.samplerate?e.samplerate:n),l=this.nextAudioPts,u=(void 0!==l?l:a.startDTS*n)+this._initDTS,d=a.endDTS*n+this._initDTS,f=1024*o,c=Math.ceil((d-u)/f),h=i.default.getSilentFrame(e.manifestCodec||e.codec,e.channelCount);if(s.logger.warn("remux empty Audio"),h){for(var p=[],g=0;g<c;g++){var v=u+g*f;p.push({unit:h,pts:v,dts:v}),e.len+=h.length}e.samples=p,this.remuxAudio(e,t,r)}else s.logger.trace("Unable to remuxEmptyAudio since we were unable to get a silent frame for given audio codec!")},e.prototype.remuxID3=function(e){var t,r=e.samples.length,i=e.inputTimeScale,a=this._initPTS,o=this._initDTS;if(r){for(var s=0;s<r;s++)(t=e.samples[s]).pts=(t.pts-a)/i,t.dts=(t.dts-o)/i;this.observer.trigger(n.default.FRAG_PARSING_METADATA,{samples:e.samples})}e.samples=[]},e.prototype.remuxText=function(e){e.samples.sort(function(e,t){return e.pts-t.pts});var t,r=e.samples.length,i=e.inputTimeScale,a=this._initPTS;if(r){for(var o=0;o<r;o++)(t=e.samples[o]).pts=(t.pts-a)/i;this.observer.trigger(n.default.FRAG_PARSING_USERDATA,{samples:e.samples})}e.samples=[]},e.prototype._PTSNormalize=function(e,t){var r;if(void 0===t)return e;for(r=t<e?-8589934592:8589934592;Math.abs(e-t)>4294967296;)e+=r;return e},e}();t.default=l},function(e,t,r){"use strict";Object.defineProperty(t,"__esModule",{value:!0});var i=function(){function e(){}return e.getSilentFrame=function(e,t){switch(e){case"mp4a.40.2":if(1===t)return new Uint8Array([0,200,0,128,35,128]);if(2===t)return new Uint8Array([33,0,73,144,2,25,0,35,128]);if(3===t)return new Uint8Array([0,200,0,128,32,132,1,38,64,8,100,0,142]);if(4===t)return new Uint8Array([0,200,0,128,32,132,1,38,64,8,100,0,128,44,128,8,2,56]);if(5===t)return new Uint8Array([0,200,0,128,32,132,1,38,64,8,100,0,130,48,4,153,0,33,144,2,56]);if(6===t)return new Uint8Array([0,200,0,128,32,132,1,38,64,8,100,0,130,48,4,153,0,33,144,2,0,178,0,32,8,224]);break;default:if(1===t)return new Uint8Array([1,64,34,128,163,78,230,128,186,8,0,0,0,28,6,241,193,10,90,90,90,90,90,90,90,90,90,90,90,90,90,90,90,90,90,90,90,90,90,90,90,90,90,90,90,90,90,90,90,90,90,90,90,90,90,90,90,90,94]);if(2===t)return new Uint8Array([1,64,34,128,163,94,230,128,186,8,0,0,0,0,149,0,6,241,161,10,90,90,90,90,90,90,90,90,90,90,90,90,90,90,90,90,90,90,90,90,90,90,90,90,90,90,90,90,90,90,90,90,90,90,90,90,90,90,94]);if(3===t)return new Uint8Array([1,64,34,128,163,94,230,128,186,8,0,0,0,0,149,0,6,241,161,10,90,90,90,90,90,90,90,90,90,90,90,90,90,90,90,90,90,90,90,90,90,90,90,90,90,90,90,90,90,90,90,90,90,90,90,90,90,90,94])}return null},e}();t.default=i},function(e,t,r){"use strict";Object.defineProperty(t,"__esModule",{value:!0});var i=Math.pow(2,32)-1,a=function(){function e(){}return e.init=function(){var t;for(t in e.types={avc1:[],avcC:[],btrt:[],dinf:[],dref:[],esds:[],ftyp:[],hdlr:[],mdat:[],mdhd:[],mdia:[],mfhd:[],minf:[],moof:[],moov:[],mp4a:[],".mp3":[],mvex:[],mvhd:[],pasp:[],sdtp:[],stbl:[],stco:[],stsc:[],stsd:[],stsz:[],stts:[],tfdt:[],tfhd:[],traf:[],trak:[],trun:[],trex:[],tkhd:[],vmhd:[],smhd:[]},e.types)e.types.hasOwnProperty(t)&&(e.types[t]=[t.charCodeAt(0),t.charCodeAt(1),t.charCodeAt(2),t.charCodeAt(3)]);var r=new Uint8Array([0,0,0,0,0,0,0,0,118,105,100,101,0,0,0,0,0,0,0,0,0,0,0,0,86,105,100,101,111,72,97,110,100,108,101,114,0]),i=new Uint8Array([0,0,0,0,0,0,0,0,115,111,117,110,0,0,0,0,0,0,0,0,0,0,0,0,83,111,117,110,100,72,97,110,100,108,101,114,0]);e.HDLR_TYPES={video:r,audio:i};var a=new Uint8Array([0,0,0,0,0,0,0,1,0,0,0,12,117,114,108,32,0,0,0,1]),n=new Uint8Array([0,0,0,0,0,0,0,0]);e.STTS=e.STSC=e.STCO=n,e.STSZ=new Uint8Array([0,0,0,0,0,0,0,0,0,0,0,0]),e.VMHD=new Uint8Array([0,0,0,1,0,0,0,0,0,0,0,0]),e.SMHD=new Uint8Array([0,0,0,0,0,0,0,0]),e.STSD=new Uint8Array([0,0,0,0,0,0,0,1]);var o=new Uint8Array([105,115,111,109]),s=new Uint8Array([97,118,99,49]),l=new Uint8Array([0,0,0,1]);e.FTYP=e.box(e.types.ftyp,o,l,o,s),e.DINF=e.box(e.types.dinf,e.box(e.types.dref,a))},e.box=function(e){for(var t,r=Array.prototype.slice.call(arguments,1),i=8,a=r.length,n=a;a--;)i+=r[a].byteLength;for((t=new Uint8Array(i))[0]=i>>24&255,t[1]=i>>16&255,t[2]=i>>8&255,t[3]=255&i,t.set(e,4),a=0,i=8;a<n;a++)t.set(r[a],i),i+=r[a].byteLength;return t},e.hdlr=function(t){return e.box(e.types.hdlr,e.HDLR_TYPES[t])},e.mdat=function(t){return e.box(e.types.mdat,t)},e.mdhd=function(t,r){r*=t;var a=Math.floor(r/(i+1)),n=Math.floor(r%(i+1));return e.box(e.types.mdhd,new Uint8Array([1,0,0,0,0,0,0,0,0,0,0,2,0,0,0,0,0,0,0,3,t>>24&255,t>>16&255,t>>8&255,255&t,a>>24,a>>16&255,a>>8&255,255&a,n>>24,n>>16&255,n>>8&255,255&n,85,196,0,0]))},e.mdia=function(t){return e.box(e.types.mdia,e.mdhd(t.timescale,t.duration),e.hdlr(t.type),e.minf(t))},e.mfhd=function(t){return e.box(e.types.mfhd,new Uint8Array([0,0,0,0,t>>24,t>>16&255,t>>8&255,255&t]))},e.minf=function(t){return"audio"===t.type?e.box(e.types.minf,e.box(e.types.smhd,e.SMHD),e.DINF,e.stbl(t)):e.box(e.types.minf,e.box(e.types.vmhd,e.VMHD),e.DINF,e.stbl(t))},e.moof=function(t,r,i){return e.box(e.types.moof,e.mfhd(t),e.traf(i,r))},e.moov=function(t){for(var r=t.length,i=[];r--;)i[r]=e.trak(t[r]);return e.box.apply(null,[e.types.moov,e.mvhd(t[0].timescale,t[0].duration)].concat(i).concat(e.mvex(t)))},e.mvex=function(t){for(var r=t.length,i=[];r--;)i[r]=e.trex(t[r]);return e.box.apply(null,[e.types.mvex].concat(i))},e.mvhd=function(t,r){r*=t;var a=Math.floor(r/(i+1)),n=Math.floor(r%(i+1)),o=new Uint8Array([1,0,0,0,0,0,0,0,0,0,0,2,0,0,0,0,0,0,0,3,t>>24&255,t>>16&255,t>>8&255,255&t,a>>24,a>>16&255,a>>8&255,255&a,n>>24,n>>16&255,n>>8&255,255&n,0,1,0,0,1,0,0,0,0,0,0,0,0,0,0,0,0,1,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1,0,0,0,0,0,0,0,0,0,0,0,0,0,0,64,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,255,255,255,255]);return e.box(e.types.mvhd,o)},e.sdtp=function(t){var r,i,a=t.samples||[],n=new Uint8Array(4+a.length);for(i=0;i<a.length;i++)r=a[i].flags,n[i+4]=r.dependsOn<<4|r.isDependedOn<<2|r.hasRedundancy;return e.box(e.types.sdtp,n)},e.stbl=function(t){return e.box(e.types.stbl,e.stsd(t),e.box(e.types.stts,e.STTS),e.box(e.types.stsc,e.STSC),e.box(e.types.stsz,e.STSZ),e.box(e.types.stco,e.STCO))},e.avc1=function(t){var r,i,a,n=[],o=[];for(r=0;r<t.sps.length;r++)a=(i=t.sps[r]).byteLength,n.push(a>>>8&255),n.push(255&a),n=n.concat(Array.prototype.slice.call(i));for(r=0;r<t.pps.length;r++)a=(i=t.pps[r]).byteLength,o.push(a>>>8&255),o.push(255&a),o=o.concat(Array.prototype.slice.call(i));var s=e.box(e.types.avcC,new Uint8Array([1,n[3],n[4],n[5],255,224|t.sps.length].concat(n).concat([t.pps.length]).concat(o))),l=t.width,u=t.height,d=t.pixelRatio[0],f=t.pixelRatio[1];return e.box(e.types.avc1,new Uint8Array([0,0,0,0,0,0,0,1,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,l>>8&255,255&l,u>>8&255,255&u,0,72,0,0,0,72,0,0,0,0,0,0,0,1,18,100,97,105,108,121,109,111,116,105,111,110,47,104,108,115,46,106,115,0,0,0,0,0,0,0,0,0,0,0,0,0,0,24,17,17]),s,e.box(e.types.btrt,new Uint8Array([0,28,156,128,0,45,198,192,0,45,198,192])),e.box(e.types.pasp,new Uint8Array([d>>24,d>>16&255,d>>8&255,255&d,f>>24,f>>16&255,f>>8&255,255&f])))},e.esds=function(e){var t=e.config.length;return new Uint8Array([0,0,0,0,3,23+t,0,1,0,4,15+t,64,21,0,0,0,0,0,0,0,0,0,0,0,5].concat([t]).concat(e.config).concat([6,1,2]))},e.mp4a=function(t){var r=t.samplerate;return e.box(e.types.mp4a,new Uint8Array([0,0,0,0,0,0,0,1,0,0,0,0,0,0,0,0,0,t.channelCount,0,16,0,0,0,0,r>>8&255,255&r,0,0]),e.box(e.types.esds,e.esds(t)))},e.mp3=function(t){var r=t.samplerate;return e.box(e.types[".mp3"],new Uint8Array([0,0,0,0,0,0,0,1,0,0,0,0,0,0,0,0,0,t.channelCount,0,16,0,0,0,0,r>>8&255,255&r,0,0]))},e.stsd=function(t){return"audio"===t.type?t.isAAC||"mp3"!==t.codec?e.box(e.types.stsd,e.STSD,e.mp4a(t)):e.box(e.types.stsd,e.STSD,e.mp3(t)):e.box(e.types.stsd,e.STSD,e.avc1(t))},e.tkhd=function(t){var r=t.id,a=t.duration*t.timescale,n=t.width,o=t.height,s=Math.floor(a/(i+1)),l=Math.floor(a%(i+1));return e.box(e.types.tkhd,new Uint8Array([1,0,0,7,0,0,0,0,0,0,0,2,0,0,0,0,0,0,0,3,r>>24&255,r>>16&255,r>>8&255,255&r,0,0,0,0,s>>24,s>>16&255,s>>8&255,255&s,l>>24,l>>16&255,l>>8&255,255&l,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1,0,0,0,0,0,0,0,0,0,0,0,0,0,0,64,0,0,0,n>>8&255,255&n,0,0,o>>8&255,255&o,0,0]))},e.traf=function(t,r){var a=e.sdtp(t),n=t.id,o=Math.floor(r/(i+1)),s=Math.floor(r%(i+1));return e.box(e.types.traf,e.box(e.types.tfhd,new Uint8Array([0,0,0,0,n>>24,n>>16&255,n>>8&255,255&n])),e.box(e.types.tfdt,new Uint8Array([1,0,0,0,o>>24,o>>16&255,o>>8&255,255&o,s>>24,s>>16&255,s>>8&255,255&s])),e.trun(t,a.length+16+20+8+16+8+8),a)},e.trak=function(t){return t.duration=t.duration||4294967295,e.box(e.types.trak,e.tkhd(t),e.mdia(t))},e.trex=function(t){var r=t.id;return e.box(e.types.trex,new Uint8Array([0,0,0,0,r>>24,r>>16&255,r>>8&255,255&r,0,0,0,1,0,0,0,0,0,0,0,0,0,1,0,1]))},e.trun=function(t,r){var i,a,n,o,s,l,u=t.samples||[],d=u.length,f=12+16*d,c=new Uint8Array(f);for(r+=8+f,c.set([0,0,15,1,d>>>24&255,d>>>16&255,d>>>8&255,255&d,r>>>24&255,r>>>16&255,r>>>8&255,255&r],0),i=0;i<d;i++)n=(a=u[i]).duration,o=a.size,s=a.flags,l=a.cts,c.set([n>>>24&255,n>>>16&255,n>>>8&255,255&n,o>>>24&255,o>>>16&255,o>>>8&255,255&o,s.isLeading<<2|s.dependsOn,s.isDependedOn<<6|s.hasRedundancy<<4|s.paddingValue<<1|s.isNonSync,61440&s.degradPrio,15&s.degradPrio,l>>>24&255,l>>>16&255,l>>>8&255,255&l],12+16*i);return e.box(e.types.trun,c)},e.initSegment=function(t){e.types||e.init();var r,i=e.moov(t);return(r=new Uint8Array(e.FTYP.byteLength+i.byteLength)).set(e.FTYP),r.set(i,e.FTYP.byteLength),r},e}();t.default=a},function(e,t,r){"use strict";Object.defineProperty(t,"__esModule",{value:!0});var i=r(1),a=function(){function e(e){this.observer=e}return e.prototype.destroy=function(){},e.prototype.resetTimeStamp=function(){},e.prototype.resetInitSegment=function(){},e.prototype.remux=function(e,t,r,a,n,o,s,l){var u=this.observer,d="";e&&(d+="audio"),t&&(d+="video"),u.trigger(i.default.FRAG_PARSING_DATA,{data1:l,startPTS:n,startDTS:n,type:d,hasAudio:!!e,hasVideo:!!t,nb:1,dropped:0}),u.trigger(i.default.FRAG_PARSED)},e}();t.default=a},function(e,t,r){"use strict";var i=Object.prototype.hasOwnProperty,a="~";function n(){}function o(e,t,r,i,n){if("function"!=typeof r)throw new TypeError("The listener must be a function");var o=new function(e,t,r){this.fn=e,this.context=t,this.once=r||!1}(r,i||e,n),s=a?a+t:t;return e._events[s]?e._events[s].fn?e._events[s]=[e._events[s],o]:e._events[s].push(o):(e._events[s]=o,e._eventsCount++),e}function s(e,t){0==--e._eventsCount?e._events=new n:delete e._events[t]}function l(){this._events=new n,this._eventsCount=0}Object.create&&(n.prototype=Object.create(null),(new n).__proto__||(a=!1)),l.prototype.eventNames=function(){var e,t,r=[];if(0===this._eventsCount)return r;for(t in e=this._events)i.call(e,t)&&r.push(a?t.slice(1):t);return Object.getOwnPropertySymbols?r.concat(Object.getOwnPropertySymbols(e)):r},l.prototype.listeners=function(e){var t=a?a+e:e,r=this._events[t];if(!r)return[];if(r.fn)return[r.fn];for(var i=0,n=r.length,o=new Array(n);i<n;i++)o[i]=r[i].fn;return o},l.prototype.listenerCount=function(e){var t=a?a+e:e,r=this._events[t];return r?r.fn?1:r.length:0},l.prototype.emit=function(e,t,r,i,n,o){var s=a?a+e:e;if(!this._events[s])return!1;var l,u,d=this._events[s],f=arguments.length;if(d.fn){switch(d.once&&this.removeListener(e,d.fn,void 0,!0),f){case 1:return d.fn.call(d.context),!0;case 2:return d.fn.call(d.context,t),!0;case 3:return d.fn.call(d.context,t,r),!0;case 4:return d.fn.call(d.context,t,r,i),!0;case 5:return d.fn.call(d.context,t,r,i,n),!0;case 6:return d.fn.call(d.context,t,r,i,n,o),!0}for(u=1,l=new Array(f-1);u<f;u++)l[u-1]=arguments[u];d.fn.apply(d.context,l)}else{var c,h=d.length;for(u=0;u<h;u++)switch(d[u].once&&this.removeListener(e,d[u].fn,void 0,!0),f){case 1:d[u].fn.call(d[u].context);break;case 2:d[u].fn.call(d[u].context,t);break;case 3:d[u].fn.call(d[u].context,t,r);break;case 4:d[u].fn.call(d[u].context,t,r,i);break;default:if(!l)for(c=1,l=new Array(f-1);c<f;c++)l[c-1]=arguments[c];d[u].fn.apply(d[u].context,l)}}return!0},l.prototype.on=function(e,t,r){return o(this,e,t,r,!1)},l.prototype.once=function(e,t,r){return o(this,e,t,r,!0)},l.prototype.removeListener=function(e,t,r,i){var n=a?a+e:e;if(!this._events[n])return this;if(!t)return s(this,n),this;var o=this._events[n];if(o.fn)o.fn!==t||i&&!o.once||r&&o.context!==r||s(this,n);else{for(var l=0,u=[],d=o.length;l<d;l++)(o[l].fn!==t||i&&!o[l].once||r&&o[l].context!==r)&&u.push(o[l]);u.length?this._events[n]=1===u.length?u[0]:u:s(this,n)}return this},l.prototype.removeAllListeners=function(e){var t;return e?(t=a?a+e:e,this._events[t]&&s(this,t)):(this._events=new n,this._eventsCount=0),this},l.prototype.off=l.prototype.removeListener,l.prototype.addListener=l.prototype.on,l.prefixed=a,l.EventEmitter=l,e.exports=l},function(e,t,r){"use strict";Object.defineProperty(t,"__esModule",{value:!0});var i=r(18),a=r(1),n=r(0),o=r(47);t.default=function(e){var t=new o.EventEmitter;t.trigger=function(e){for(var r=[],i=1;i<arguments.length;i++)r[i-1]=arguments[i];t.emit.apply(t,[e,e].concat(r))},t.off=function(e){for(var r=[],i=1;i<arguments.length;i++)r[i-1]=arguments[i];t.removeListener.apply(t,[e].concat(r))};var r=function(t,r){e.postMessage({event:t,data:r})};e.addEventListener("message",function(a){var o=a.data;switch(o.cmd){case"init":var s=JSON.parse(o.config);e.demuxer=new i.default(t,o.typeSupported,s,o.vendor),n.enableLogs(s.debug),r("init",null);break;case"demux":e.demuxer.push(o.data,o.decryptdata,o.initSegment,o.audioCodec,o.videoCodec,o.timeOffset,o.discontinuity,o.trackSwitch,o.contiguous,o.duration,o.accurateTimeOffset,o.defaultInitPTS)}}),t.on(a.default.FRAG_DECRYPTED,r),t.on(a.default.FRAG_PARSING_INIT_SEGMENT,r),t.on(a.default.FRAG_PARSED,r),t.on(a.default.ERROR,r),t.on(a.default.FRAG_PARSING_METADATA,r),t.on(a.default.FRAG_PARSING_USERDATA,r),t.on(a.default.INIT_PTS_FOUND,r),t.on(a.default.FRAG_PARSING_DATA,function(t,r){var i=[],a={event:t,data:r};r.data1&&(a.data1=r.data1.buffer,i.push(r.data1.buffer),delete r.data1),r.data2&&(a.data2=r.data2.buffer,i.push(r.data2.buffer),delete r.data2),e.postMessage(a,i)})}},function(e,t){function r(){this._events=this._events||{},this._maxListeners=this._maxListeners||void 0}function i(e){return"function"==typeof e}function a(e){return"object"==typeof e&&null!==e}function n(e){return void 0===e}e.exports=r,r.EventEmitter=r,r.prototype._events=void 0,r.prototype._maxListeners=void 0,r.defaultMaxListeners=10,r.prototype.setMaxListeners=function(e){if(!function(e){return"number"==typeof e}(e)||e<0||isNaN(e))throw TypeError("n must be a positive number");return this._maxListeners=e,this},r.prototype.emit=function(e){var t,r,o,s,l,u;if(this._events||(this._events={}),"error"===e&&(!this._events.error||a(this._events.error)&&!this._events.error.length)){if((t=arguments[1])instanceof Error)throw t;var d=new Error('Uncaught, unspecified "error" event. ('+t+")");throw d.context=t,d}if(n(r=this._events[e]))return!1;if(i(r))switch(arguments.length){case 1:r.call(this);break;case 2:r.call(this,arguments[1]);break;case 3:r.call(this,arguments[1],arguments[2]);break;default:s=Array.prototype.slice.call(arguments,1),r.apply(this,s)}else if(a(r))for(s=Array.prototype.slice.call(arguments,1),o=(u=r.slice()).length,l=0;l<o;l++)u[l].apply(this,s);return!0},r.prototype.addListener=function(e,t){var o;if(!i(t))throw TypeError("listener must be a function");return this._events||(this._events={}),this._events.newListener&&this.emit("newListener",e,i(t.listener)?t.listener:t),this._events[e]?a(this._events[e])?this._events[e].push(t):this._events[e]=[this._events[e],t]:this._events[e]=t,a(this._events[e])&&!this._events[e].warned&&(o=n(this._maxListeners)?r.defaultMaxListeners:this._maxListeners)&&o>0&&this._events[e].length>o&&(this._events[e].warned=!0,console.error("(node) warning: possible EventEmitter memory leak detected. %d listeners added. Use emitter.setMaxListeners() to increase limit.",this._events[e].length),"function"==typeof console.trace&&console.trace()),this},r.prototype.on=r.prototype.addListener,r.prototype.once=function(e,t){if(!i(t))throw TypeError("listener must be a function");var r=!1;function a(){this.removeListener(e,a),r||(r=!0,t.apply(this,arguments))}return a.listener=t,this.on(e,a),this},r.prototype.removeListener=function(e,t){var r,n,o,s;if(!i(t))throw TypeError("listener must be a function");if(!this._events||!this._events[e])return this;if(o=(r=this._events[e]).length,n=-1,r===t||i(r.listener)&&r.listener===t)delete this._events[e],this._events.removeListener&&this.emit("removeListener",e,t);else if(a(r)){for(s=o;s-- >0;)if(r[s]===t||r[s].listener&&r[s].listener===t){n=s;break}if(n<0)return this;1===r.length?(r.length=0,delete this._events[e]):r.splice(n,1),this._events.removeListener&&this.emit("removeListener",e,t)}return this},r.prototype.removeAllListeners=function(e){var t,r;if(!this._events)return this;if(!this._events.removeListener)return 0===arguments.length?this._events={}:this._events[e]&&delete this._events[e],this;if(0===arguments.length){for(t in this._events)"removeListener"!==t&&this.removeAllListeners(t);return this.removeAllListeners("removeListener"),this._events={},this}if(i(r=this._events[e]))this.removeListener(e,r);else if(r)for(;r.length;)this.removeListener(e,r[r.length-1]);return delete this._events[e],this},r.prototype.listeners=function(e){return this._events&&this._events[e]?i(this._events[e])?[this._events[e]]:this._events[e].slice():[]},r.prototype.listenerCount=function(e){if(this._events){var t=this._events[e];if(i(t))return 1;if(t)return t.length}return 0},r.listenerCount=function(e,t){return e.listenerCount(t)}},function(e,t,r){"use strict";Object.defineProperty(t,"__esModule",{value:!0});t.default={toString:function(e){for(var t="",r=e.length,i=0;i<r;i++)t+="["+e.start(i).toFixed(3)+","+e.end(i).toFixed(3)+"]";return t}}},function(e,t,r){"use strict";(function(e){Object.defineProperty(t,"__esModule",{value:!0});var i=r(10),a=r(0);function n(e,t){for(var r=null,i=0;i<e.length;i+=1){var a=e[i];if(a&&a.cc===t){r=a;break}}return r}function o(e,t,r){var i=!1;return t&&t.details&&r&&(r.endCC>r.startCC||e&&e.cc<r.startCC)&&(i=!0),i}function s(e,t){var r=e.fragments,i=t.fragments;if(i.length&&r.length){var o=n(r,i[0].cc);if(o&&(!o||o.startPTS))return o;a.logger.log("No frag in previous level to align on")}else a.logger.log("No fragments to align")}function l(e,t){t.fragments.forEach(function(t){if(t){var r=t.start+e;t.start=t.startPTS=r,t.endPTS=r+t.duration}}),t.PTSKnown=!0}function u(e,t,r){if(o(e,r,t)){var i=s(r.details,t);i&&(a.logger.log("Adjusting PTS using last level due to CC increase within current level"),l(i.start,t))}}function d(t,r){if(r&&r.fragments.length){if(!t.hasProgramDateTime||!r.hasProgramDateTime)return;var i=r.fragments[0].programDateTime,n=(t.fragments[0].programDateTime-i)/1e3+r.fragments[0].start;e.isFinite(n)&&(a.logger.log("adjusting PTS using programDateTime delta, sliding:"+n.toFixed(3)),l(n,t))}}t.findFirstFragWithCC=n,t.findFragWithCC=function(e,t){return i.default.search(e,function(e){return e.cc<t?1:e.cc>t?-1:0})},t.shouldAlignOnDiscontinuities=o,t.findDiscontinuousReferenceFrag=s,t.adjustPts=l,t.alignStream=function(e,t,r){u(e,r,t),!r.PTSKnown&&t&&d(r,t.details)},t.alignDiscontinuities=u,t.alignPDT=d}).call(this,r(2).Number)},function(e,t,r){"use strict";(function(e){Object.defineProperty(t,"__esModule",{value:!0});var i=r(10);function a(e,t,r){void 0===e&&(e=0),void 0===t&&(t=0);var i=Math.min(t,r.duration+(r.deltaPTS?r.deltaPTS:0));return r.start+r.duration-i<=e?1:r.start-i>e&&r.start?-1:0}function n(e,t,r){var i=1e3*Math.min(t,r.duration+(r.deltaPTS?r.deltaPTS:0));return r.endProgramDateTime-i>e}t.findFragmentByPDT=function(t,r,i){if(!Array.isArray(t)||!t.length||!e.isFinite(r))return null;if(r<t[0].programDateTime)return null;if(r>=t[t.length-1].endProgramDateTime)return null;i=i||0;for(var a=0;a<t.length;++a){var o=t[a];if(n(r,i,o))return o}return null},t.findFragmentByPTS=function(e,t,r,n){void 0===r&&(r=0),void 0===n&&(n=0);var o=e?t[e.sn-t[0].sn+1]:null;return o&&!a(r,n,o)?o:i.default.search(t,a.bind(null,r,n))},t.fragmentWithinToleranceTest=a,t.pdtWithinToleranceTest=n}).call(this,r(2).Number)},function(e,t,r){"use strict";Object.defineProperty(t,"__esModule",{value:!0});var i=r(8),a=r(3),n=r(1),o=r(0),s=function(){function e(e,t,r,i){this.config=e,this.media=t,this.fragmentTracker=r,this.hls=i,this.stallReported=!1}return e.prototype.poll=function(e,t){var r=this.config,a=this.media,n=a.currentTime,s=window.performance.now();if(n!==e)return this.stallReported&&(o.logger.warn("playback not stuck anymore @"+n+", after "+Math.round(s-this.stalled)+"ms"),this.stallReported=!1),this.stalled=null,void(this.nudgeRetry=0);if(!(a.ended||!a.buffered.length||a.readyState>2||a.seeking&&i.BufferHelper.isBuffered(a,n))){var l=s-this.stalled,u=i.BufferHelper.bufferInfo(a,n,r.maxBufferHole);this.stalled?(l>=1e3&&this._reportStall(u.len),this._tryFixBufferStall(u,l)):this.stalled=s}},e.prototype._tryFixBufferStall=function(e,t){var r=this.config,i=this.fragmentTracker,a=this.media.currentTime,n=i.getPartialFragment(a);n&&this._trySkipBufferHole(n),e.len>.5&&t>1e3*r.highBufferWatchdogPeriod&&(this.stalled=null,this._tryNudgeBuffer())},e.prototype._reportStall=function(e){var t=this.hls,r=this.media;this.stallReported||(this.stallReported=!0,o.logger.warn("Playback stalling at @"+r.currentTime+" due to low buffer"),t.trigger(n.default.ERROR,{type:a.ErrorTypes.MEDIA_ERROR,details:a.ErrorDetails.BUFFER_STALLED_ERROR,fatal:!1,buffer:e}))},e.prototype._trySkipBufferHole=function(e){for(var t=this.hls,r=this.media,i=r.currentTime,s=0,l=0;l<r.buffered.length;l++){var u=r.buffered.start(l);if(i>=s&&i<u)return r.currentTime=Math.max(u,r.currentTime+.1),o.logger.warn("skipping hole, adjusting currentTime from "+i+" to "+r.currentTime),this.stalled=null,void t.trigger(n.default.ERROR,{type:a.ErrorTypes.MEDIA_ERROR,details:a.ErrorDetails.BUFFER_SEEK_OVER_HOLE,fatal:!1,reason:"fragment loaded with buffer holes, seeking from "+i+" to "+r.currentTime,frag:e});s=r.buffered.end(l)}},e.prototype._tryNudgeBuffer=function(){var e=this.config,t=this.hls,r=this.media,i=r.currentTime,s=(this.nudgeRetry||0)+1;if(this.nudgeRetry=s,s<e.nudgeMaxRetry){var l=i+s*e.nudgeOffset;o.logger.log("adjust currentTime from "+i+" to "+l),r.currentTime=l,t.trigger(n.default.ERROR,{type:a.ErrorTypes.MEDIA_ERROR,details:a.ErrorDetails.BUFFER_NUDGE_ON_STALL,fatal:!1})}else o.logger.error("still stuck in high buffer @"+i+" after "+e.nudgeMaxRetry+", raise fatal error"),t.trigger(n.default.ERROR,{type:a.ErrorTypes.MEDIA_ERROR,details:a.ErrorDetails.BUFFER_STALLED_ERROR,fatal:!0})},e}();t.default=s},function(e,t,r){"use strict";(function(e){var i=this&&this.__extends||function(){var e=Object.setPrototypeOf||{__proto__:[]}instanceof Array&&function(e,t){e.__proto__=t}||function(e,t){for(var r in t)t.hasOwnProperty(r)&&(e[r]=t[r])};return function(t,r){function i(){this.constructor=t}e(t,r),t.prototype=null===r?Object.create(r):(i.prototype=r.prototype,new i)}}();Object.defineProperty(t,"__esModule",{value:!0});var a=r(53),n=r(9),o=r(8),s=r(0);t.State={STOPPED:"STOPPED",STARTING:"STARTING",IDLE:"IDLE",PAUSED:"PAUSED",KEY_LOADING:"KEY_LOADING",FRAG_LOADING:"FRAG_LOADING",FRAG_LOADING_WAITING_RETRY:"FRAG_LOADING_WAITING_RETRY",WAITING_TRACK:"WAITING_TRACK",PARSING:"PARSING",PARSED:"PARSED",BUFFER_FLUSHING:"BUFFER_FLUSHING",ENDED:"ENDED",ERROR:"ERROR",WAITING_INIT_PTS:"WAITING_INIT_PTS",WAITING_LEVEL:"WAITING_LEVEL"};var l=function(r){function a(){return null!==r&&r.apply(this,arguments)||this}return i(a,r),a.prototype.doTick=function(){},a.prototype.startLoad=function(){},a.prototype.stopLoad=function(){var e=this.fragCurrent;e&&(e.loader&&e.loader.abort(),this.fragmentTracker.removeFragment(e)),this.demuxer&&(this.demuxer.destroy(),this.demuxer=null),this.fragCurrent=null,this.fragPrevious=null,this.clearInterval(),this.clearNextTick(),this.state=t.State.STOPPED},a.prototype._streamEnded=function(e,t){var r=this.fragCurrent,i=this.fragmentTracker;if(!t.live&&r&&!r.backtracked&&r.sn===t.endSN&&!e.nextStart){var a=i.getState(r);return a===n.FragmentState.PARTIAL||a===n.FragmentState.OK}return!1},a.prototype.onMediaSeeking=function(){var r=this.config,i=this.media,a=this.mediaBuffer,n=this.state,l=i?i.currentTime:null,u=o.BufferHelper.bufferInfo(a||i,l,this.config.maxBufferHole);if(e.isFinite(l)&&s.logger.log("media seeking to "+l.toFixed(3)),n===t.State.FRAG_LOADING){var d=this.fragCurrent;if(0===u.len&&d){var f=r.maxFragLookUpTolerance,c=d.start-f,h=d.start+d.duration+f;l<c||l>h?(d.loader&&(s.logger.log("seeking outside of buffer while fragment load in progress, cancel fragment load"),d.loader.abort()),this.fragCurrent=null,this.fragPrevious=null,this.state=t.State.IDLE):s.logger.log("seeking outside of buffer but within currently loaded fragment range")}}else n===t.State.ENDED&&(0===u.len&&(this.fragPrevious=null,this.fragCurrent=null),this.state=t.State.IDLE);i&&(this.lastCurrentTime=l),this.loadedmetadata||(this.nextLoadPosition=this.startPosition=l),this.tick()},a.prototype.onMediaEnded=function(){this.startPosition=this.lastCurrentTime=0},a.prototype.onHandlerDestroying=function(){this.stopLoad(),r.prototype.onHandlerDestroying.call(this)},a.prototype.onHandlerDestroyed=function(){this.state=t.State.STOPPED,this.fragmentTracker=null},a}(a.default);t.default=l}).call(this,r(2).Number)},function(e,t,r){"use strict";var i=this&&this.__extends||function(){var e=Object.setPrototypeOf||{__proto__:[]}instanceof Array&&function(e,t){e.__proto__=t}||function(e,t){for(var r in t)t.hasOwnProperty(r)&&(e[r]=t[r])};return function(t,r){function i(){this.constructor=t}e(t,r),t.prototype=null===r?Object.create(r):(i.prototype=r.prototype,new i)}}();Object.defineProperty(t,"__esModule",{value:!0});var a=function(e){function t(t){for(var r=[],i=1;i<arguments.length;i++)r[i-1]=arguments[i];var a=e.apply(this,[t].concat(r))||this;return a._tickInterval=null,a._tickTimer=null,a._tickCallCount=0,a._boundTick=a.tick.bind(a),a}return i(t,e),t.prototype.onHandlerDestroying=function(){this.clearNextTick(),this.clearInterval()},t.prototype.hasInterval=function(){return!!this._tickInterval},t.prototype.hasNextTick=function(){return!!this._tickTimer},t.prototype.setInterval=function(e){return!this._tickInterval&&(this._tickInterval=setInterval(this._boundTick,e),!0)},t.prototype.clearInterval=function(){return!!this._tickInterval&&(clearInterval(this._tickInterval),this._tickInterval=null,!0)},t.prototype.clearNextTick=function(){return!!this._tickTimer&&(clearTimeout(this._tickTimer),this._tickTimer=null,!0)},t.prototype.tick=function(){this._tickCallCount++,1===this._tickCallCount&&(this.doTick(),this._tickCallCount>1&&(this.clearNextTick(),this._tickTimer=setTimeout(this._boundTick,0)),this._tickCallCount=0)},t.prototype.doTick=function(){},t}(r(4).default);t.default=a},function(e,t,r){"use strict";var i=this&&this.__extends||function(){var e=Object.setPrototypeOf||{__proto__:[]}instanceof Array&&function(e,t){e.__proto__=t}||function(e,t){for(var r in t)t.hasOwnProperty(r)&&(e[r]=t[r])};return function(t,r){function i(){this.constructor=t}e(t,r),t.prototype=null===r?Object.create(r):(i.prototype=r.prototype,new i)}}();Object.defineProperty(t,"__esModule",{value:!0});var a,n=r(1),o=r(4),s=r(0),l=r(3),u=r(17),d=r(23),f=(window.performance,function(e){function t(t){var r=e.call(this,t,n.default.MANIFEST_LOADED,n.default.LEVEL_LOADED,n.default.AUDIO_TRACK_SWITCHED,n.default.FRAG_LOADED,n.default.ERROR)||this;return r.canload=!1,r.currentLevelIndex=null,r.manualLevelIndex=-1,r.timer=null,a=/chrome|firefox/.test(navigator.userAgent.toLowerCase()),r}return i(t,e),t.prototype.onHandlerDestroying=function(){this.clearTimer(),this.manualLevelIndex=-1},t.prototype.clearTimer=function(){null!==this.timer&&(clearTimeout(this.timer),this.timer=null)},t.prototype.startLoad=function(){var e=this._levels;this.canload=!0,this.levelRetryCount=0,e&&e.forEach(function(e){e.loadError=0;var t=e.details;t&&t.live&&(e.details=void 0)}),null!==this.timer&&this.loadLevel()},t.prototype.stopLoad=function(){this.canload=!1},t.prototype.onManifestLoaded=function(e){var t,r=[],i=[],o={},f=null,c=!1,h=!1;if(e.levels.forEach(function(e){var t=e.attrs;e.loadError=0,e.fragmentError=!1,c=c||!!e.videoCodec,h=h||!!e.audioCodec,a&&e.audioCodec&&-1!==e.audioCodec.indexOf("mp4a.40.34")&&(e.audioCodec=void 0),(f=o[e.bitrate])?f.url.push(e.url):(e.url=[e.url],e.urlId=0,o[e.bitrate]=e,r.push(e)),t&&(t.AUDIO&&(h=!0,d.addGroupId(f||e,"audio",t.AUDIO)),t.SUBTITLES&&d.addGroupId(f||e,"text",t.SUBTITLES))}),c&&h&&(r=r.filter(function(e){return!!e.videoCodec})),r=r.filter(function(e){var t=e.audioCodec,r=e.videoCodec;return(!t||u.isCodecSupportedInMp4(t,"audio"))&&(!r||u.isCodecSupportedInMp4(r,"video"))}),e.audioTracks&&(i=e.audioTracks.filter(function(e){return!e.audioCodec||u.isCodecSupportedInMp4(e.audioCodec,"audio")})).forEach(function(e,t){e.id=t}),r.length>0){t=r[0].bitrate,r.sort(function(e,t){return e.bitrate-t.bitrate}),this._levels=r;for(var p=0;p<r.length;p++)if(r[p].bitrate===t){this._firstLevel=p,s.logger.log("manifest loaded,"+r.length+" level(s) found, first bitrate:"+t);break}this.hls.trigger(n.default.MANIFEST_PARSED,{levels:r,audioTracks:i,firstLevel:this._firstLevel,stats:e.stats,audio:h,video:c,altAudio:i.some(function(e){return!!e.url})})}else this.hls.trigger(n.default.ERROR,{type:l.ErrorTypes.MEDIA_ERROR,details:l.ErrorDetails.MANIFEST_INCOMPATIBLE_CODECS_ERROR,fatal:!0,url:this.hls.url,reason:"no level with compatible codecs found in manifest"})},Object.defineProperty(t.prototype,"levels",{get:function(){return this._levels},enumerable:!0,configurable:!0}),Object.defineProperty(t.prototype,"level",{get:function(){return this.currentLevelIndex},set:function(e){var t=this._levels;t&&(e=Math.min(e,t.length-1),this.currentLevelIndex===e&&t[e].details||this.setLevelInternal(e))},enumerable:!0,configurable:!0}),t.prototype.setLevelInternal=function(e){var t=this._levels,r=this.hls;if(e>=0&&e<t.length){if(this.clearTimer(),this.currentLevelIndex!==e){s.logger.log("switching to level "+e),this.currentLevelIndex=e;var i=t[e];i.level=e,r.trigger(n.default.LEVEL_SWITCHING,i)}var a=t[e],o=a.details;if(!o||o.live){var u=a.urlId;r.trigger(n.default.LEVEL_LOADING,{url:a.url[u],level:e,id:u})}}else r.trigger(n.default.ERROR,{type:l.ErrorTypes.OTHER_ERROR,details:l.ErrorDetails.LEVEL_SWITCH_ERROR,level:e,fatal:!1,reason:"invalid level idx"})},Object.defineProperty(t.prototype,"manualLevel",{get:function(){return this.manualLevelIndex},set:function(e){this.manualLevelIndex=e,void 0===this._startLevel&&(this._startLevel=e),-1!==e&&(this.level=e)},enumerable:!0,configurable:!0}),Object.defineProperty(t.prototype,"firstLevel",{get:function(){return this._firstLevel},set:function(e){this._firstLevel=e},enumerable:!0,configurable:!0}),Object.defineProperty(t.prototype,"startLevel",{get:function(){if(void 0===this._startLevel){var e=this.hls.config.startLevel;return void 0!==e?e:this._firstLevel}return this._startLevel},set:function(e){this._startLevel=e},enumerable:!0,configurable:!0}),t.prototype.onError=function(e){if(e.fatal)e.type===l.ErrorTypes.NETWORK_ERROR&&this.clearTimer();else{var t,r=!1,i=!1;switch(e.details){case l.ErrorDetails.FRAG_LOAD_ERROR:case l.ErrorDetails.FRAG_LOAD_TIMEOUT:case l.ErrorDetails.KEY_LOAD_ERROR:case l.ErrorDetails.KEY_LOAD_TIMEOUT:t=e.frag.level,i=!0;break;case l.ErrorDetails.LEVEL_LOAD_ERROR:case l.ErrorDetails.LEVEL_LOAD_TIMEOUT:t=e.context.level,r=!0;break;case l.ErrorDetails.REMUX_ALLOC_ERROR:t=e.level,r=!0}void 0!==t&&this.recoverLevel(e,t,r,i)}},t.prototype.recoverLevel=function(e,t,r,i){var a,n,o,l=this,u=this.hls.config,d=e.details,f=this._levels[t];if(f.loadError++,f.fragmentError=i,r){if(!(this.levelRetryCount+1<=u.levelLoadingMaxRetry))return s.logger.error("level controller, cannot recover from "+d+" error"),this.currentLevelIndex=null,this.clearTimer(),void(e.fatal=!0);n=Math.min(Math.pow(2,this.levelRetryCount)*u.levelLoadingRetryDelay,u.levelLoadingMaxRetryTimeout),this.timer=setTimeout(function(){return l.loadLevel()},n),e.levelRetry=!0,this.levelRetryCount++,s.logger.warn("level controller, "+d+", retry in "+n+" ms, current retry count is "+this.levelRetryCount)}(r||i)&&((a=f.url.length)>1&&f.loadError<a?(f.urlId=(f.urlId+1)%a,f.details=void 0,s.logger.warn("level controller, "+d+" for level "+t+": switching to redundant URL-id "+f.urlId)):-1===this.manualLevelIndex?(o=0===t?this._levels.length-1:t-1,s.logger.warn("level controller, "+d+": switch to "+o),this.hls.nextAutoLevel=this.currentLevelIndex=o):i&&(s.logger.warn("level controller, "+d+": reload a fragment"),this.currentLevelIndex=null))},t.prototype.onFragLoaded=function(e){var t=e.frag;if(void 0!==t&&"main"===t.type){var r=this._levels[t.level];void 0!==r&&(r.fragmentError=!1,r.loadError=0,this.levelRetryCount=0)}},t.prototype.onLevelLoaded=function(e){var t=this,r=e.level,i=e.details;if(r===this.currentLevelIndex){var a=this._levels[r];if(a.fragmentError||(a.loadError=0,this.levelRetryCount=0),i.live){var n=d.computeReloadInterval(a.details,i,e.stats.trequest);s.logger.log("live playlist, reload in "+Math.round(n)+" ms"),this.timer=setTimeout(function(){return t.loadLevel()},n)}else this.clearTimer()}},t.prototype.onAudioTrackSwitched=function(e){var t=this.hls.audioTracks[e.id].groupId,r=this.hls.levels[this.currentLevelIndex];if(r&&r.audioGroupIds){for(var i=-1,a=0;a<r.audioGroupIds.length;a++)if(r.audioGroupIds[a]===t){i=a;break}i!==r.urlId&&(r.urlId=i,this.startLoad())}},t.prototype.loadLevel=function(){if(s.logger.debug("call to loadLevel"),null!==this.currentLevelIndex&&this.canload){var e=this._levels[this.currentLevelIndex];if("object"==typeof e&&e.url.length>0){var t=this.currentLevelIndex,r=e.urlId,i=e.url[r];s.logger.log("Attempt loading level index "+t+" with URL-id "+r),this.hls.trigger(n.default.LEVEL_LOADING,{url:i,level:t,id:r})}}},Object.defineProperty(t.prototype,"nextLoadLevel",{get:function(){return-1!==this.manualLevelIndex?this.manualLevelIndex:this.hls.nextAutoLevel},set:function(e){this.level=e,-1===this.manualLevelIndex&&(this.hls.nextAutoLevel=e)},enumerable:!0,configurable:!0}),t}(o.default));t.default=f},function(e,t,r){"use strict";var i=this&&this.__extends||function(){var e=Object.setPrototypeOf||{__proto__:[]}instanceof Array&&function(e,t){e.__proto__=t}||function(e,t){for(var r in t)t.hasOwnProperty(r)&&(e[r]=t[r])};return function(t,r){function i(){this.constructor=t}e(t,r),t.prototype=null===r?Object.create(r):(i.prototype=r.prototype,new i)}}();Object.defineProperty(t,"__esModule",{value:!0});var a=r(1),n=r(4),o=r(11),s=r(56),l=function(e){function t(t){var r=e.call(this,t,a.default.MEDIA_ATTACHED,a.default.MEDIA_DETACHING,a.default.FRAG_PARSING_METADATA)||this;return r.id3Track=void 0,r.media=void 0,r}return i(t,e),t.prototype.destroy=function(){n.default.prototype.destroy.call(this)},t.prototype.onMediaAttached=function(e){this.media=e.media,this.media},t.prototype.onMediaDetaching=function(){s.clearCurrentCues(this.id3Track),this.id3Track=void 0,this.media=void 0},t.prototype.getID3Track=function(e){for(var t=0;t<e.length;t++){var r=e[t];if("metadata"===r.kind&&"id3"===r.label)return s.sendAddTrackEvent(r,this.media),r}return this.media.addTextTrack("metadata","id3")},t.prototype.onFragParsingMetadata=function(e){var t=e.frag,r=e.samples;this.id3Track||(this.id3Track=this.getID3Track(this.media.textTracks),this.id3Track.mode="hidden");for(var i=window.WebKitDataCue||window.VTTCue||window.TextTrackCue,a=0;a<r.length;a++){var n=o.default.getID3Frames(r[a].data);if(n){var s=r[a].pts,l=a<r.length-1?r[a+1].pts:t.endPTS;s===l&&(l+=1e-4);for(var u=0;u<n.length;u++){var d=n[u];if(!o.default.isTimeStampFrame(d)){var f=new i(s,l,"");f.value=d,this.id3Track.addCue(f)}}}}},t}(n.default);t.default=l},function(e,t,r){"use strict";Object.defineProperty(t,"__esModule",{value:!0}),t.sendAddTrackEvent=function(e,t){var r=null;try{r=new window.Event("addtrack")}catch(e){(r=document.createEvent("Event")).initEvent("addtrack",!1,!1)}r.track=e,t.dispatchEvent(r)},t.clearCurrentCues=function(e){if(e&&e.cues)for(;e.cues.length>0;)e.removeCue(e.cues[0])}},function(e,t,r){"use strict";Object.defineProperty(t,"__esModule",{value:!0});var i=r(12);t.isSupported=function(){var e=i.getMediaSource(),t=window.SourceBuffer||window.WebKitSourceBuffer,r=e&&"function"==typeof e.isTypeSupported&&e.isTypeSupported('video/mp4; codecs="avc1.42E01E,mp4a.40.2"'),a=!t||t.prototype&&"function"==typeof t.prototype.appendBuffer&&"function"==typeof t.prototype.remove;return!!r&&!!a}},function(e,t,r){"use strict";Object.defineProperty(t,"__esModule",{value:!0});var i=r(59),a=r(62),n=r(63),o=r(64),s=r(65),l=(r(5),r(5),r(5),r(5),r(5),r(5),r(5),r(66));t.hlsDefaultConfig={autoStartLoad:!0,startPosition:-1,defaultAudioCodec:void 0,debug:!1,capLevelOnFPSDrop:!1,capLevelToPlayerSize:!1,initialLiveManifestSize:1,maxBufferLength:30,maxBufferSize:6e7,maxBufferHole:.5,lowBufferWatchdogPeriod:.5,highBufferWatchdogPeriod:3,nudgeOffset:.1,nudgeMaxRetry:3,maxFragLookUpTolerance:.25,liveSyncDurationCount:3,liveMaxLatencyDurationCount:1/0,liveSyncDuration:void 0,liveMaxLatencyDuration:void 0,liveDurationInfinity:!1,liveBackBufferLength:1/0,maxMaxBufferLength:600,enableWorker:!0,enableSoftwareAES:!0,manifestLoadingTimeOut:1e4,manifestLoadingMaxRetry:1,manifestLoadingRetryDelay:1e3,manifestLoadingMaxRetryTimeout:64e3,startLevel:void 0,levelLoadingTimeOut:1e4,levelLoadingMaxRetry:4,levelLoadingRetryDelay:1e3,levelLoadingMaxRetryTimeout:64e3,fragLoadingTimeOut:2e4,fragLoadingMaxRetry:6,fragLoadingRetryDelay:1e3,fragLoadingMaxRetryTimeout:64e3,startFragPrefetch:!1,fpsDroppedMonitoringPeriod:5e3,fpsDroppedMonitoringThreshold:.2,appendErrorMaxRetry:3,loader:s.default,fLoader:void 0,pLoader:void 0,xhrSetup:void 0,licenseXhrSetup:void 0,abrController:i.default,bufferController:a.default,capLevelController:n.default,fpsController:o.default,stretchShortVideoTrack:!1,maxAudioFramesDrift:1,forceKeyFrameOnDiscontinuity:!0,abrEwmaFastLive:3,abrEwmaSlowLive:9,abrEwmaFastVoD:3,abrEwmaSlowVoD:9,abrEwmaDefaultEstimate:5e5,abrBandWidthFactor:.95,abrBandWidthUpFactor:.7,abrMaxWithRealBitrate:!1,maxStarvationDelay:4,maxLoadingDelay:4,minAutoBitrate:0,emeEnabled:!1,widevineLicenseUrl:void 0,requestMediaKeySystemAccessFunc:l.requestMediaKeySystemAccess}},function(e,t,r){"use strict";(function(e){var i=this&&this.__extends||function(){var e=Object.setPrototypeOf||{__proto__:[]}instanceof Array&&function(e,t){e.__proto__=t}||function(e,t){for(var r in t)t.hasOwnProperty(r)&&(e[r]=t[r])};return function(t,r){function i(){this.constructor=t}e(t,r),t.prototype=null===r?Object.create(r):(i.prototype=r.prototype,new i)}}();Object.defineProperty(t,"__esModule",{value:!0});var a=r(1),n=r(4),o=r(8),s=r(3),l=r(0),u=r(60),d=window.performance,f=function(t){function r(e){var r=t.call(this,e,a.default.FRAG_LOADING,a.default.FRAG_LOADED,a.default.FRAG_BUFFERED,a.default.ERROR)||this;return r.lastLoadedFragLevel=0,r._nextAutoLevel=-1,r.hls=e,r.timer=null,r._bwEstimator=null,r.onCheck=r._abandonRulesCheck.bind(r),r}return i(r,t),r.prototype.destroy=function(){this.clearTimer(),n.default.prototype.destroy.call(this)},r.prototype.onFragLoading=function(e){var t=e.frag;if("main"===t.type&&(this.timer||(this.fragCurrent=t,this.timer=setInterval(this.onCheck,100)),!this._bwEstimator)){var r=this.hls,i=r.config,a=t.level,n=void 0,o=void 0;r.levels[a].details.live?(n=i.abrEwmaFastLive,o=i.abrEwmaSlowLive):(n=i.abrEwmaFastVoD,o=i.abrEwmaSlowVoD),this._bwEstimator=new u.default(r,o,n,i.abrEwmaDefaultEstimate)}},r.prototype._abandonRulesCheck=function(){var e=this.hls,t=e.media,r=this.fragCurrent;if(r){var i=r.loader,n=e.minAutoLevel;if(!i||i.stats&&i.stats.aborted)return l.logger.warn("frag loader destroy or aborted, disarm abandonRules"),this.clearTimer(),void(this._nextAutoLevel=-1);var s=i.stats;if(t&&s&&(!t.paused&&0!==t.playbackRate||!t.readyState)&&r.autoLevel&&r.level){var u=d.now()-s.trequest,f=Math.abs(t.playbackRate);if(u>500*r.duration/f){var c=e.levels,h=Math.max(1,s.bw?s.bw/8:1e3*s.loaded/u),p=c[r.level],g=p.realBitrate?Math.max(p.realBitrate,p.bitrate):p.bitrate,v=s.total?s.total:Math.max(s.loaded,Math.round(r.duration*g/8)),m=t.currentTime,y=(v-s.loaded)/h,_=(o.BufferHelper.bufferInfo(t,m,e.config.maxBufferHole).end-m)/f;if(_<2*r.duration/f&&y>_){var E=void 0,b=void 0;for(b=r.level-1;b>n;b--){var S=c[b].realBitrate?Math.max(c[b].realBitrate,c[b].bitrate):c[b].bitrate;if((E=r.duration*S/(6.4*h))<_)break}E<y&&(l.logger.warn("loading too slow, abort fragment loading and switch to level "+b+":fragLoadedDelay["+b+"]<fragLoadedDelay["+(r.level-1)+"];bufferStarvationDelay:"+E.toFixed(1)+"<"+y.toFixed(1)+":"+_.toFixed(1)),e.nextLoadLevel=b,this._bwEstimator.sample(u,s.loaded),i.abort(),this.clearTimer(),e.trigger(a.default.FRAG_LOAD_EMERGENCY_ABORTED,{frag:r,stats:s}))}}}}},r.prototype.onFragLoaded=function(t){var r=t.frag;if("main"===r.type&&e.isFinite(r.sn)){if(this.clearTimer(),this.lastLoadedFragLevel=r.level,this._nextAutoLevel=-1,this.hls.config.abrMaxWithRealBitrate){var i=this.hls.levels[r.level],a=(i.loaded?i.loaded.bytes:0)+t.stats.loaded,n=(i.loaded?i.loaded.duration:0)+t.frag.duration;i.loaded={bytes:a,duration:n},i.realBitrate=Math.round(8*a/n)}if(t.frag.bitrateTest){var o=t.stats;o.tparsed=o.tbuffered=o.tload,this.onFragBuffered(t)}}},r.prototype.onFragBuffered=function(t){var r=t.stats,i=t.frag;if(!0!==r.aborted&&"main"===i.type&&e.isFinite(i.sn)&&(!i.bitrateTest||r.tload===r.tbuffered)){var a=r.tparsed-r.trequest;l.logger.log("latency/loading/parsing/append/kbps:"+Math.round(r.tfirst-r.trequest)+"/"+Math.round(r.tload-r.tfirst)+"/"+Math.round(r.tparsed-r.tload)+"/"+Math.round(r.tbuffered-r.tparsed)+"/"+Math.round(8*r.loaded/(r.tbuffered-r.trequest))),this._bwEstimator.sample(a,r.loaded),r.bwEstimate=this._bwEstimator.getEstimate(),i.bitrateTest?this.bitrateTestDelay=a/1e3:this.bitrateTestDelay=0}},r.prototype.onError=function(e){switch(e.details){case s.ErrorDetails.FRAG_LOAD_ERROR:case s.ErrorDetails.FRAG_LOAD_TIMEOUT:this.clearTimer()}},r.prototype.clearTimer=function(){clearInterval(this.timer),this.timer=null},Object.defineProperty(r.prototype,"nextAutoLevel",{get:function(){var e=this._nextAutoLevel,t=this._bwEstimator;if(!(-1===e||t&&t.canEstimate()))return e;var r=this._nextABRAutoLevel;return-1!==e&&(r=Math.min(e,r)),r},set:function(e){this._nextAutoLevel=e},enumerable:!0,configurable:!0}),Object.defineProperty(r.prototype,"_nextABRAutoLevel",{get:function(){var e=this.hls,t=e.maxAutoLevel,r=e.levels,i=e.config,a=e.minAutoLevel,n=e.media,s=this.lastLoadedFragLevel,u=this.fragCurrent?this.fragCurrent.duration:0,d=n?n.currentTime:0,f=n&&0!==n.playbackRate?Math.abs(n.playbackRate):1,c=this._bwEstimator?this._bwEstimator.getEstimate():i.abrEwmaDefaultEstimate,h=(o.BufferHelper.bufferInfo(n,d,i.maxBufferHole).end-d)/f,p=this._findBestLevel(s,u,c,a,t,h,i.abrBandWidthFactor,i.abrBandWidthUpFactor,r);if(p>=0)return p;l.logger.trace("rebuffering expected to happen, lets try to find a quality level minimizing the rebuffering");var g=u?Math.min(u,i.maxStarvationDelay):i.maxStarvationDelay,v=i.abrBandWidthFactor,m=i.abrBandWidthUpFactor;if(0===h){var y=this.bitrateTestDelay;if(y)g=(u?Math.min(u,i.maxLoadingDelay):i.maxLoadingDelay)-y,l.logger.trace("bitrate test took "+Math.round(1e3*y)+"ms, set first fragment max fetchDuration to "+Math.round(1e3*g)+" ms"),v=m=1}return p=this._findBestLevel(s,u,c,a,t,h+g,v,m,r),Math.max(p,0)},enumerable:!0,configurable:!0}),r.prototype._findBestLevel=function(e,t,r,i,a,n,o,s,u){for(var d=a;d>=i;d--){var f=u[d];if(f){var c=f.details,h=c?c.totalduration/c.fragments.length:t,p=!!c&&c.live,g=void 0;g=d<=e?o*r:s*r;var v=u[d].realBitrate?Math.max(u[d].realBitrate,u[d].bitrate):u[d].bitrate,m=v*h/g;if(l.logger.trace("level/adjustedbw/bitrate/avgDuration/maxFetchDuration/fetchDuration: "+d+"/"+Math.round(g)+"/"+v+"/"+h+"/"+n+"/"+m),g>v&&(!m||p&&!this.bitrateTestDelay||m<n))return d}}return-1},r}(n.default);t.default=f}).call(this,r(2).Number)},function(e,t,r){"use strict";Object.defineProperty(t,"__esModule",{value:!0});var i=r(61),a=function(){function e(e,t,r,a){this.hls=e,this.defaultEstimate_=a,this.minWeight_=.001,this.minDelayMs_=50,this.slow_=new i.default(t),this.fast_=new i.default(r)}return e.prototype.sample=function(e,t){var r=8e3*t/(e=Math.max(e,this.minDelayMs_)),i=e/1e3;this.fast_.sample(i,r),this.slow_.sample(i,r)},e.prototype.canEstimate=function(){var e=this.fast_;return e&&e.getTotalWeight()>=this.minWeight_},e.prototype.getEstimate=function(){return this.canEstimate()?Math.min(this.fast_.getEstimate(),this.slow_.getEstimate()):this.defaultEstimate_},e.prototype.destroy=function(){},e}();t.default=a},function(e,t,r){"use strict";Object.defineProperty(t,"__esModule",{value:!0});var i=function(){function e(e){this.alpha_=e?Math.exp(Math.log(.5)/e):0,this.estimate_=0,this.totalWeight_=0}return e.prototype.sample=function(e,t){var r=Math.pow(this.alpha_,e);this.estimate_=t*(1-r)+r*this.estimate_,this.totalWeight_+=e},e.prototype.getTotalWeight=function(){return this.totalWeight_},e.prototype.getEstimate=function(){if(this.alpha_){var e=1-Math.pow(this.alpha_,this.totalWeight_);return this.estimate_/e}return this.estimate_},e}();t.default=i},function(e,t,r){"use strict";(function(e){var i=this&&this.__extends||function(){var e=Object.setPrototypeOf||{__proto__:[]}instanceof Array&&function(e,t){e.__proto__=t}||function(e,t){for(var r in t)t.hasOwnProperty(r)&&(e[r]=t[r])};return function(t,r){function i(){this.constructor=t}e(t,r),t.prototype=null===r?Object.create(r):(i.prototype=r.prototype,new i)}}();Object.defineProperty(t,"__esModule",{value:!0});var a=r(1),n=r(4),o=r(0),s=r(3),l=r(12).getMediaSource(),u=function(t){function r(e){var r=t.call(this,e,a.default.MEDIA_ATTACHING,a.default.MEDIA_DETACHING,a.default.MANIFEST_PARSED,a.default.BUFFER_RESET,a.default.BUFFER_APPENDING,a.default.BUFFER_CODECS,a.default.BUFFER_EOS,a.default.BUFFER_FLUSHING,a.default.LEVEL_PTS_UPDATED,a.default.LEVEL_UPDATED)||this;return r._msDuration=null,r._levelDuration=null,r._levelTargetDuration=10,r._live=null,r._objectUrl=null,r.bufferCodecEventsExpected=0,r.onsbue=r.onSBUpdateEnd.bind(r),r.onsbe=r.onSBUpdateError.bind(r),r.pendingTracks={},r.tracks={},r}return i(r,t),r.prototype.destroy=function(){n.default.prototype.destroy.call(this)},r.prototype.onLevelPtsUpdated=function(e){var t=e.type,r=this.tracks.audio;if("audio"===t&&r&&"audio/mpeg"===r.container){var i=this.sourceBuffer.audio;if(Math.abs(i.timestampOffset-e.start)>.1){var a=i.updating;try{i.abort()}catch(e){o.logger.warn("can not abort audio buffer: "+e)}a?this.audioTimestampOffset=e.start:(o.logger.warn("change mpeg audio timestamp offset from "+i.timestampOffset+" to "+e.start),i.timestampOffset=e.start)}}},r.prototype.onManifestParsed=function(e){this.bufferCodecEventsExpected=e.altAudio?2:1,o.logger.log(this.bufferCodecEventsExpected+" bufferCodec event(s) expected")},r.prototype.onMediaAttaching=function(e){var t=this.media=e.media;if(t){var r=this.mediaSource=new l;this.onmso=this.onMediaSourceOpen.bind(this),this.onmse=this.onMediaSourceEnded.bind(this),this.onmsc=this.onMediaSourceClose.bind(this),r.addEventListener("sourceopen",this.onmso),r.addEventListener("sourceended",this.onmse),r.addEventListener("sourceclose",this.onmsc),t.src=window.URL.createObjectURL(r),this._objectUrl=t.src}},r.prototype.onMediaDetaching=function(){o.logger.log("media source detaching");var e=this.mediaSource;if(e){if("open"===e.readyState)try{e.endOfStream()}catch(e){o.logger.warn("onMediaDetaching:"+e.message+" while calling endOfStream")}e.removeEventListener("sourceopen",this.onmso),e.removeEventListener("sourceended",this.onmse),e.removeEventListener("sourceclose",this.onmsc),this.media&&(window.URL.revokeObjectURL(this._objectUrl),this.media.src===this._objectUrl?(this.media.removeAttribute("src"),this.media.load()):o.logger.warn("media.src was changed by a third party - skip cleanup")),this.mediaSource=null,this.media=null,this._objectUrl=null,this.pendingTracks={},this.tracks={},this.sourceBuffer={},this.flushRange=[],this.segments=[],this.appended=0}this.onmso=this.onmse=this.onmsc=null,this.hls.trigger(a.default.MEDIA_DETACHED)},r.prototype.onMediaSourceOpen=function(){o.logger.log("media source opened"),this.hls.trigger(a.default.MEDIA_ATTACHED,{media:this.media});var e=this.mediaSource;e&&e.removeEventListener("sourceopen",this.onmso),this.checkPendingTracks()},r.prototype.checkPendingTracks=function(){var e=this.bufferCodecEventsExpected,t=this.pendingTracks,r=Object.keys(t).length;(r&&!e||2===r)&&(this.createSourceBuffers(t),this.pendingTracks={},this.doAppending())},r.prototype.onMediaSourceClose=function(){o.logger.log("media source closed")},r.prototype.onMediaSourceEnded=function(){o.logger.log("media source ended")},r.prototype.onSBUpdateEnd=function(){if(this.audioTimestampOffset){var e=this.sourceBuffer.audio;o.logger.warn("change mpeg audio timestamp offset from "+e.timestampOffset+" to "+this.audioTimestampOffset),e.timestampOffset=this.audioTimestampOffset,delete this.audioTimestampOffset}this._needsFlush&&this.doFlush(),this._needsEos&&this.checkEos(),this.appending=!1;var t=this.parent,r=this.segments.reduce(function(e,r){return r.parent===t?e+1:e},0),i={},n=this.sourceBuffer;for(var s in n)i[s]=n[s].buffered;this.hls.trigger(a.default.BUFFER_APPENDED,{parent:t,pending:r,timeRanges:i}),this._needsFlush||this.doAppending(),this.updateMediaElementDuration(),0===r&&this.flushLiveBackBuffer()},r.prototype.onSBUpdateError=function(e){o.logger.error("sourceBuffer error:",e),this.hls.trigger(a.default.ERROR,{type:s.ErrorTypes.MEDIA_ERROR,details:s.ErrorDetails.BUFFER_APPENDING_ERROR,fatal:!1})},r.prototype.onBufferReset=function(){var e=this.sourceBuffer;for(var t in e){var r=e[t];try{this.mediaSource.removeSourceBuffer(r),r.removeEventListener("updateend",this.onsbue),r.removeEventListener("error",this.onsbe)}catch(e){}}this.sourceBuffer={},this.flushRange=[],this.segments=[],this.appended=0},r.prototype.onBufferCodecs=function(e){var t=this;if(!Object.keys(this.sourceBuffer).length){Object.keys(e).forEach(function(r){t.pendingTracks[r]=e[r]});var r=this.mediaSource;this.bufferCodecEventsExpected=Math.max(this.bufferCodecEventsExpected-1,0),r&&"open"===r.readyState&&this.checkPendingTracks()}},r.prototype.createSourceBuffers=function(e){var t=this.sourceBuffer,r=this.mediaSource;for(var i in e)if(!t[i]){var n=e[i],l=n.levelCodec||n.codec,u=n.container+";codecs="+l;o.logger.log("creating sourceBuffer("+u+")");try{var d=t[i]=r.addSourceBuffer(u);d.addEventListener("updateend",this.onsbue),d.addEventListener("error",this.onsbe),this.tracks[i]={codec:l,container:n.container},n.buffer=d}catch(e){o.logger.error("error while trying to add sourceBuffer:"+e.message),this.hls.trigger(a.default.ERROR,{type:s.ErrorTypes.MEDIA_ERROR,details:s.ErrorDetails.BUFFER_ADD_CODEC_ERROR,fatal:!1,err:e,mimeType:u})}}this.hls.trigger(a.default.BUFFER_CREATED,{tracks:e})},r.prototype.onBufferAppending=function(e){this._needsFlush||(this.segments?this.segments.push(e):this.segments=[e],this.doAppending())},r.prototype.onBufferAppendFail=function(e){o.logger.error("sourceBuffer error:",e.event),this.hls.trigger(a.default.ERROR,{type:s.ErrorTypes.MEDIA_ERROR,details:s.ErrorDetails.BUFFER_APPENDING_ERROR,fatal:!1})},r.prototype.onBufferEos=function(e){var t=this.sourceBuffer,r=e.type;for(var i in t)r&&i!==r||t[i].ended||(t[i].ended=!0,o.logger.log(i+" sourceBuffer now EOS"));this.checkEos()},r.prototype.checkEos=function(){var e=this.sourceBuffer,t=this.mediaSource;if(t&&"open"===t.readyState){for(var r in e){var i=e[r];if(!i.ended)return;if(i.updating)return void(this._needsEos=!0)}o.logger.log("all media data are available, signal endOfStream() to MediaSource and stop loading fragment");try{t.endOfStream()}catch(e){o.logger.warn("exception while calling mediaSource.endOfStream()")}this._needsEos=!1}else this._needsEos=!1},r.prototype.onBufferFlushing=function(e){this.flushRange.push({start:e.startOffset,end:e.endOffset,type:e.type}),this.flushBufferCounter=0,this.doFlush()},r.prototype.flushLiveBackBuffer=function(){if(this._live){var e=this.hls.config.liveBackBufferLength;if(isFinite(e)&&!(e<0))for(var t=this.media.currentTime,r=this.sourceBuffer,i=Object.keys(r),a=t-Math.max(e,this._levelTargetDuration),n=i.length-1;n>=0;n--){var o=i[n],s=r[o].buffered;s.length>0&&a>s.start(0)&&this.removeBufferRange(o,r[o],0,a)}}},r.prototype.onLevelUpdated=function(e){var t=e.details;t.fragments.length>0&&(this._levelDuration=t.totalduration+t.fragments[0].start,this._levelTargetDuration=t.averagetargetduration||t.targetduration||10,this._live=t.live,this.updateMediaElementDuration())},r.prototype.updateMediaElementDuration=function(){var t,r=this.hls.config;if(null!==this._levelDuration&&this.media&&this.mediaSource&&this.sourceBuffer&&0!==this.media.readyState&&"open"===this.mediaSource.readyState){for(var i in this.sourceBuffer)if(!0===this.sourceBuffer[i].updating)return;t=this.media.duration,null===this._msDuration&&(this._msDuration=this.mediaSource.duration),!0===this._live&&!0===r.liveDurationInfinity?(o.logger.log("Media Source duration is set to Infinity"),this._msDuration=this.mediaSource.duration=1/0):(this._levelDuration>this._msDuration&&this._levelDuration>t||!e.isFinite(t))&&(o.logger.log("Updating Media Source duration to "+this._levelDuration.toFixed(3)),this._msDuration=this.mediaSource.duration=this._levelDuration)}},r.prototype.doFlush=function(){for(;this.flushRange.length;){var e=this.flushRange[0];if(!this.flushBuffer(e.start,e.end,e.type))return void(this._needsFlush=!0);this.flushRange.shift(),this.flushBufferCounter=0}if(0===this.flushRange.length){this._needsFlush=!1;var t=0,r=this.sourceBuffer;try{for(var i in r)t+=r[i].buffered.length}catch(e){o.logger.error("error while accessing sourceBuffer.buffered")}this.appended=t,this.hls.trigger(a.default.BUFFER_FLUSHED)}},r.prototype.doAppending=function(){var e=this.hls,t=this.segments,r=this.sourceBuffer;if(Object.keys(r).length){if(this.media.error)return this.segments=[],void o.logger.error("trying to append although a media error occured, flush segment and abort");if(this.appending)return;if(t&&t.length){var i=t.shift();try{var n=r[i.type];n?n.updating?t.unshift(i):(n.ended=!1,this.parent=i.parent,n.appendBuffer(i.data),this.appendError=0,this.appended++,this.appending=!0):this.onSBUpdateEnd()}catch(r){o.logger.error("error while trying to append buffer:"+r.message),t.unshift(i);var l={type:s.ErrorTypes.MEDIA_ERROR,parent:i.parent};22!==r.code?(this.appendError?this.appendError++:this.appendError=1,l.details=s.ErrorDetails.BUFFER_APPEND_ERROR,this.appendError>e.config.appendErrorMaxRetry?(o.logger.log("fail "+e.config.appendErrorMaxRetry+" times to append segment in sourceBuffer"),this.segments=[],l.fatal=!0,e.trigger(a.default.ERROR,l)):(l.fatal=!1,e.trigger(a.default.ERROR,l))):(this.segments=[],l.details=s.ErrorDetails.BUFFER_FULL_ERROR,l.fatal=!1,e.trigger(a.default.ERROR,l))}}}},r.prototype.flushBuffer=function(e,t,r){var i,a=this.sourceBuffer;if(Object.keys(a).length){if(o.logger.log("flushBuffer,pos/start/end: "+this.media.currentTime.toFixed(3)+"/"+e+"/"+t),this.flushBufferCounter<this.appended){for(var n in a)if(!r||n===r){if((i=a[n]).ended=!1,i.updating)return o.logger.warn("cannot flush, sb updating in progress"),!1;if(this.removeBufferRange(n,i,e,t))return this.flushBufferCounter++,!1}}else o.logger.warn("abort flushing too many retries");o.logger.log("buffer flushed")}return!0},r.prototype.removeBufferRange=function(e,t,r,i){try{for(var a=0;a<t.buffered.length;a++){var n=t.buffered.start(a),s=t.buffered.end(a),l=Math.max(n,r),u=Math.min(s,i);if(Math.min(u,s)-l>.5)return o.logger.log("sb remove "+e+" ["+l+","+u+"], of ["+n+","+s+"], pos:"+this.media.currentTime),t.remove(l,u),!0}}catch(e){o.logger.warn("removeBufferRange failed",e)}return!1},r}(n.default);t.default=u}).call(this,r(2).Number)},function(e,t,r){"use strict";(function(e){var i=this&&this.__extends||function(){var e=Object.setPrototypeOf||{__proto__:[]}instanceof Array&&function(e,t){e.__proto__=t}||function(e,t){for(var r in t)t.hasOwnProperty(r)&&(e[r]=t[r])};return function(t,r){function i(){this.constructor=t}e(t,r),t.prototype=null===r?Object.create(r):(i.prototype=r.prototype,new i)}}();Object.defineProperty(t,"__esModule",{value:!0});var a=r(1),n=function(t){function r(r){var i=t.call(this,r,a.default.FPS_DROP_LEVEL_CAPPING,a.default.MEDIA_ATTACHING,a.default.MANIFEST_PARSED,a.default.BUFFER_CODECS,a.default.MEDIA_DETACHING)||this;return i.autoLevelCapping=e.POSITIVE_INFINITY,i.firstLevel=null,i.levels=[],i.media=null,i.restrictedLevels=[],i.timer=null,i}return i(r,t),r.prototype.destroy=function(){this.hls.config.capLevelToPlayerSize&&(this.media=null,this._stopCapping())},r.prototype.onFpsDropLevelCapping=function(e){r.isLevelAllowed(e.droppedLevel,this.restrictedLevels)&&this.restrictedLevels.push(e.droppedLevel)},r.prototype.onMediaAttaching=function(e){this.media=e.media instanceof window.HTMLVideoElement?e.media:null},r.prototype.onManifestParsed=function(e){var t=this.hls;this.restrictedLevels=[],this.levels=e.levels,this.firstLevel=e.firstLevel,t.config.capLevelToPlayerSize&&e.video&&this._startCapping()},r.prototype.onBufferCodecs=function(e){this.hls.config.capLevelToPlayerSize&&e.video&&this._startCapping()},r.prototype.onLevelsUpdated=function(e){this.levels=e.levels},r.prototype.onMediaDetaching=function(){this._stopCapping()},r.prototype.detectPlayerSize=function(){if(this.media){var e=this.levels?this.levels.length:0;if(e){var t=this.hls;t.autoLevelCapping=this.getMaxLevel(e-1),t.autoLevelCapping>this.autoLevelCapping&&t.streamController.nextLevelSwitch(),this.autoLevelCapping=t.autoLevelCapping}}},r.prototype.getMaxLevel=function(e){var t=this;if(!this.levels)return-1;var i=this.levels.filter(function(i,a){return r.isLevelAllowed(a,t.restrictedLevels)&&a<=e});return r.getMaxLevelByMediaSize(i,this.mediaWidth,this.mediaHeight)},r.prototype._startCapping=function(){this.timer||(this.autoLevelCapping=e.POSITIVE_INFINITY,this.hls.firstLevel=this.getMaxLevel(this.firstLevel),clearInterval(this.timer),this.timer=setInterval(this.detectPlayerSize.bind(this),1e3),this.detectPlayerSize())},r.prototype._stopCapping=function(){this.restrictedLevels=[],this.firstLevel=null,this.autoLevelCapping=e.POSITIVE_INFINITY,this.timer&&(this.timer=clearInterval(this.timer),this.timer=null)},Object.defineProperty(r.prototype,"mediaWidth",{get:function(){var e,t=this.media;return t&&(e=t.width||t.clientWidth||t.offsetWidth,e*=r.contentScaleFactor),e},enumerable:!0,configurable:!0}),Object.defineProperty(r.prototype,"mediaHeight",{get:function(){var e,t=this.media;return t&&(e=t.height||t.clientHeight||t.offsetHeight,e*=r.contentScaleFactor),e},enumerable:!0,configurable:!0}),Object.defineProperty(r,"contentScaleFactor",{get:function(){var e=1;try{e=window.devicePixelRatio}catch(e){}return e},enumerable:!0,configurable:!0}),r.isLevelAllowed=function(e,t){return void 0===t&&(t=[]),-1===t.indexOf(e)},r.getMaxLevelByMediaSize=function(e,t,r){if(!e||e&&!e.length)return-1;for(var i=function(e,t){return!t||(e.width!==t.width||e.height!==t.height)},a=e.length-1,n=0;n<e.length;n+=1){var o=e[n];if((o.width>=t||o.height>=r)&&i(o,e[n+1])){a=n;break}}return a},r}(r(4).default);t.default=n}).call(this,r(2).Number)},function(e,t,r){"use strict";var i=this&&this.__extends||function(){var e=Object.setPrototypeOf||{__proto__:[]}instanceof Array&&function(e,t){e.__proto__=t}||function(e,t){for(var r in t)t.hasOwnProperty(r)&&(e[r]=t[r])};return function(t,r){function i(){this.constructor=t}e(t,r),t.prototype=null===r?Object.create(r):(i.prototype=r.prototype,new i)}}();Object.defineProperty(t,"__esModule",{value:!0});var a=r(1),n=r(4),o=r(0),s=window.performance,l=function(e){function t(t){return e.call(this,t,a.default.MEDIA_ATTACHING)||this}return i(t,e),t.prototype.destroy=function(){this.timer&&clearInterval(this.timer),this.isVideoPlaybackQualityAvailable=!1},t.prototype.onMediaAttaching=function(e){var t=this.hls.config;t.capLevelOnFPSDrop&&("function"==typeof(this.video=e.media instanceof window.HTMLVideoElement?e.media:null).getVideoPlaybackQuality&&(this.isVideoPlaybackQualityAvailable=!0),clearInterval(this.timer),this.timer=setInterval(this.checkFPSInterval.bind(this),t.fpsDroppedMonitoringPeriod))},t.prototype.checkFPS=function(e,t,r){var i=s.now();if(t){if(this.lastTime){var n=i-this.lastTime,l=r-this.lastDroppedFrames,u=t-this.lastDecodedFrames,d=1e3*l/n,f=this.hls;if(f.trigger(a.default.FPS_DROP,{currentDropped:l,currentDecoded:u,totalDroppedFrames:r}),d>0&&l>f.config.fpsDroppedMonitoringThreshold*u){var c=f.currentLevel;o.logger.warn("drop FPS ratio greater than max allowed value for currentLevel: "+c),c>0&&(-1===f.autoLevelCapping||f.autoLevelCapping>=c)&&(c-=1,f.trigger(a.default.FPS_DROP_LEVEL_CAPPING,{level:c,droppedLevel:f.currentLevel}),f.autoLevelCapping=c,f.streamController.nextLevelSwitch())}}this.lastTime=i,this.lastDroppedFrames=r,this.lastDecodedFrames=t}},t.prototype.checkFPSInterval=function(){var e=this.video;if(e)if(this.isVideoPlaybackQualityAvailable){var t=e.getVideoPlaybackQuality();this.checkFPS(e,t.totalVideoFrames,t.droppedVideoFrames)}else this.checkFPS(e,e.webkitDecodedFrameCount,e.webkitDroppedFrameCount)},t}(n.default);t.default=l},function(e,t,r){"use strict";Object.defineProperty(t,"__esModule",{value:!0});var i=r(0),a=window.performance,n=window.XMLHttpRequest,o=function(){function e(e){e&&e.xhrSetup&&(this.xhrSetup=e.xhrSetup)}return e.prototype.destroy=function(){this.abort(),this.loader=null},e.prototype.abort=function(){var e=this.loader;e&&4!==e.readyState&&(this.stats.aborted=!0,e.abort()),window.clearTimeout(this.requestTimeout),this.requestTimeout=null,window.clearTimeout(this.retryTimeout),this.retryTimeout=null},e.prototype.load=function(e,t,r){this.context=e,this.config=t,this.callbacks=r,this.stats={trequest:a.now(),retry:0},this.retryDelay=t.retryDelay,this.loadInternal()},e.prototype.loadInternal=function(){var e,t=this.context;e=this.loader=new n;var r=this.stats;r.tfirst=0,r.loaded=0;var i=this.xhrSetup;try{if(i)try{i(e,t.url)}catch(r){e.open("GET",t.url,!0),i(e,t.url)}e.readyState||e.open("GET",t.url,!0)}catch(r){return void this.callbacks.onError({code:e.status,text:r.message},t,e)}t.rangeEnd&&e.setRequestHeader("Range","bytes="+t.rangeStart+"-"+(t.rangeEnd-1)),e.onreadystatechange=this.readystatechange.bind(this),e.onprogress=this.loadprogress.bind(this),e.responseType=t.responseType,this.requestTimeout=window.setTimeout(this.loadtimeout.bind(this),this.config.timeout),e.send()},e.prototype.readystatechange=function(e){var t=e.currentTarget,r=t.readyState,n=this.stats,o=this.context,s=this.config;if(!n.aborted&&r>=2)if(window.clearTimeout(this.requestTimeout),0===n.tfirst&&(n.tfirst=Math.max(a.now(),n.trequest)),4===r){var l=t.status;if(l>=200&&l<300){n.tload=Math.max(n.tfirst,a.now());var u=void 0,d=void 0;d="arraybuffer"===o.responseType?(u=t.response).byteLength:(u=t.responseText).length,n.loaded=n.total=d;var f={url:t.responseURL,data:u};this.callbacks.onSuccess(f,n,o,t)}else n.retry>=s.maxRetry||l>=400&&l<499?(i.logger.error(l+" while loading "+o.url),this.callbacks.onError({code:l,text:t.statusText},o,t)):(i.logger.warn(l+" while loading "+o.url+", retrying in "+this.retryDelay+"..."),this.destroy(),this.retryTimeout=window.setTimeout(this.loadInternal.bind(this),this.retryDelay),this.retryDelay=Math.min(2*this.retryDelay,s.maxRetryDelay),n.retry++)}else this.requestTimeout=window.setTimeout(this.loadtimeout.bind(this),s.timeout)},e.prototype.loadtimeout=function(){i.logger.warn("timeout while loading "+this.context.url),this.callbacks.onTimeout(this.stats,this.context,null)},e.prototype.loadprogress=function(e){var t=e.currentTarget,r=this.stats;r.loaded=e.loaded,e.lengthComputable&&(r.total=e.total);var i=this.callbacks.onProgress;i&&i(r,this.context,null,t)},e}();t.default=o},function(e,t,r){"use strict";Object.defineProperty(t,"__esModule",{value:!0});var i="undefined"!=typeof window&&window.navigator&&window.navigator.requestMediaKeySystemAccess?window.navigator.requestMediaKeySystemAccess.bind(window.navigator):null;t.requestMediaKeySystemAccess=i}]).default});
//# sourceMappingURL=hls.light.min.js.map